import React, { useState, useCallback } from 'react';




import './App.css';
import { Container, Typography, Button, TextField, Box, Alert, CircularProgress, Paper, List, ListItem, ListItemIcon, ListItemText, LinearProgress, Select, MenuItem, FormControl, InputLabel, Tabs, Tab, Table, TableHead, TableRow, TableCell, TableBody, TableContainer, IconButton, Modal, Checkbox, FormControlLabel, Dialog, DialogTitle, DialogContent, DialogActions, Chip, Divider, Avatar, Slider, Tooltip, Radio, Link } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import ReactMarkdown from 'react-markdown';
import { AuthProvider, useAuth } from "./AuthContext";
import Login from "./Login";
// Firebase-Imports entfernt - alle Firebase-Operationen gehen über das Backend
// import { db } from "./firebase";
// import { doc, getDoc, setDoc, deleteDoc } from "firebase/firestore";
import { useTranslation } from 'react-i18next';
import i18n, { changeLanguage, tWithCountry } from './i18n';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import QrCodeIcon from '@mui/icons-material/QrCode';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import SportsOutlinedIcon from '@mui/icons-material/SportsOutlined';
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DescriptionIcon from '@mui/icons-material/Description';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ShareIcon from '@mui/icons-material/Share';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import BackspaceIcon from '@mui/icons-material/Backspace';
import WarningIcon from '@mui/icons-material/Warning';
import ImageIcon from '@mui/icons-material/Image';
import CvTemplate from './templates/CvTemplate';
import { MotivationTemplateComponent, type MotivationTemplateData } from './utils/templateRenderer';
import CvSharePage from './components/CvSharePage';

import { config } from './config/env';
import { auth } from './firebase';
import { saveCvSettings, loadCvSettings, resetCvSettings, resetTemplateSettings, type CvSettings, type CvDesignSettings, defaultCvSettings } from './utils/cvSettings';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SaveIcon from '@mui/icons-material/Save';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import RestoreIcon from '@mui/icons-material/Restore';
import SettingsIcon from '@mui/icons-material/Settings';
import BrushIcon from '@mui/icons-material/Brush';
import RefreshIcon from '@mui/icons-material/Refresh';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PersonIcon from '@mui/icons-material/Person';
import Menu from '@mui/material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import ComputerIcon from '@mui/icons-material/Computer';
import LanguageIcon from '@mui/icons-material/Language';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import InfoIcon from '@mui/icons-material/Info';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import DataObjectIcon from '@mui/icons-material/DataObject';
import StorageIcon from '@mui/icons-material/Storage';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';


import ReactDOM from 'react-dom';

// Mock-Firebase-Funktionen für Entwicklung
const mockDb = {
  collection: () => ({
    doc: () => ({
      get: async () => ({ exists: false, data: () => null }),
      set: async () => {},
      delete: async () => {}
    })
  })
};

// Alle Firebase-Funktionen entfernt - Kommunikation läuft ausschließlich über Backend


// Funktion zur Erkennung der Browser-Sprache
const detectBrowserLanguage = (): string => {
  const browserLang = navigator.language || (navigator as any).userLanguage || 'de';
  const langCode = browserLang.split('-')[0].toLowerCase();
  
  // Unterstützte Sprachen: de, en, fr, it
  const supportedLanguages = ['de', 'en', 'fr', 'it'];
  
  // Wenn Browser-Sprache unterstützt wird, verwende sie, sonst 'de' als Fallback
  return supportedLanguages.includes(langCode) ? langCode : 'de';
};

function ProtectedApp() {
  const { t: tOriginal } = useTranslation();
  const { user, agbAccepted, agbLoading, acceptAgb, accountId, firstLogin, country: userCountry, createAccount, checkAccountStatus, checkAgbStatus, logout } = useAuth();
  
  // Wrapper für t-Funktion, der automatisch ß durch ss ersetzt für CH
  const t = (key: string, options?: any) => {
    const translation = tOriginal(key, options);
    // Stelle sicher, dass translation ein String ist
    const translationString = typeof translation === 'string' ? translation : String(translation);
    if (userCountry === 'CH') {
      return translationString.replace(/ß/g, 'ss');
    }
    return translationString;
  };
  // Initialisiere immer mit Browser-Sprache (kein localStorage)
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    const browserLang = detectBrowserLanguage();
    console.log('🚀 Initial Language (Browser):', browserLang);
    return browserLang;
  });
  
  // Zielsprache für Übersetzungen basierend auf jobDescriptionLanguage
  const [targetLanguage, setTargetLanguage] = useState('deutsch');
  const [isLoading, setIsLoading] = useState(false);
  
  // AGB-Modal State - wird nur gezeigt wenn AGBs explizit NICHT akzeptiert wurden (false, nicht null)
  const showAgbModal: boolean = !agbLoading && !!user && agbAccepted === false;
  
  // Onboarding Modal State - wird gezeigt wenn firstLogin nicht null ist
  const showOnboardingModal = !agbLoading && !!user && !!firstLogin;
  
  // Handler für AGB-Akzeptierung
  const handleAcceptAgb = async () => {
    if (!hasReadAgb) return;
    
    setIsAccepting(true);
    try {
      await acceptAgb();
    } catch (error) {
      console.error('Error accepting AGBs:', error);
      alert('Fehler beim Akzeptieren der AGBs. Bitte versuchen Sie es erneut.');
      setIsAccepting(false);
    }
  };
  
  // States für Onboarding Modal
  const [onboardingFirstName, setOnboardingFirstName] = useState('');
  const [onboardingLastName, setOnboardingLastName] = useState('');
  const [onboardingGender, setOnboardingGender] = useState('');
  const [onboardingCountry, setOnboardingCountry] = useState('');
  const [savingOnboarding, setSavingOnboarding] = useState(false);
  
  // State für AGB-Modal
  const [hasReadAgb, setHasReadAgb] = useState(false);
  const [isAccepting, setIsAccepting] = useState(false);
  
  // Handler für Onboarding
  const handleSaveOnboarding = async () => {
    if (!user) return;
    
    if (!onboardingFirstName || !onboardingLastName || !onboardingGender || !onboardingCountry) {
      alert('Bitte füllen Sie alle Felder aus.');
      return;
    }
    
    setSavingOnboarding(true);
    try {
      const idToken = await user.getIdToken();
      const response = await fetch(`${config.backend.baseUrl}/api/user/onboarding`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${idToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          firstName: onboardingFirstName,
          lastName: onboardingLastName,
          gender: onboardingGender,
          country: onboardingCountry
        })
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Fehler beim Speichern');
      }
      
      // Erfolgreich gespeichert - aktualisiere AGB-Status (firstLogin wird dadurch zurückgesetzt)
      await checkAgbStatus();
      console.log('✅ Onboarding-Daten erfolgreich gespeichert');
    } catch (error) {
      console.error('❌ Fehler beim Speichern der Onboarding-Daten:', error);
      alert('Fehler beim Speichern. Bitte versuchen Sie es erneut.');
    } finally {
      setSavingOnboarding(false);
    }
  };
  
  // Versionsinformationen
  const [showVersionInfo, setShowVersionInfo] = useState(false);
  const [backendVersionInfo, setBackendVersionInfo] = useState<any>(null);

  // State für Textfarben-Modal
  const [showTextColorPalette, setShowTextColorPalette] = useState(false);
  const [nameTextColor, setNameTextColor] = useState('#333333');
  const [leftColumnTextColor, setLeftColumnTextColor] = useState('#333333');
  const [rightColumnTextColor, setRightColumnTextColor] = useState('#333333');
  const [leftColumnTitleColor, setLeftColumnTitleColor] = useState('#333333');
  const [rightColumnTitleColor, setRightColumnTitleColor] = useState('#333333');
  
  // Temporäre State-Variablen für Textfarben (werden erst beim Schließen angewendet)
  const [tempNameTextColor, setTempNameTextColor] = useState('#333333');
  const [tempLeftColumnTextColor, setTempLeftColumnTextColor] = useState('#333333');
  const [tempRightColumnTextColor, setTempRightColumnTextColor] = useState('#333333');
  const [tempLeftColumnTitleColor, setTempLeftColumnTitleColor] = useState('#333333');
  const [tempRightColumnTitleColor, setTempRightColumnTitleColor] = useState('#333333');
  const [loadingVersionInfo, setLoadingVersionInfo] = useState(false);
  
  // Frontend Build-Informationen
  const frontendVersion = '1.0.0';
  const buildTime = process.env.REACT_APP_BUILD_TIME || new Date().toISOString();
  const buildDate = new Date(buildTime).toLocaleDateString('de-DE');
  const buildTimeFormatted = new Date(buildTime).toLocaleTimeString('de-DE');

  // Funktion zum Übersetzen von CV-Text-Labels basierend auf currentLanguage (UI-Sprache)
  const getTranslatedCvLabel = (label: string) => {
    // Konvertiere currentLanguage zu ausgeschriebenem Format für Translations-Lookup
    const languageMap: { [key: string]: string } = {
      'de': 'deutsch',
      'fr': 'französisch',
      'it': 'italienisch',
      'en': 'englisch'
    };
    const uiLanguage = languageMap[currentLanguage] || 'deutsch';
    
    const translations: { [key: string]: { [key: string]: string } } = {
      'Name:': {
        'deutsch': 'Name:',
        'englisch': 'Name:',
        'französisch': 'Nom:',
        'italienisch': 'Nome:'
      },
      'Adresse:': {
        'deutsch': 'Adresse:',
        'englisch': 'Address:',
        'französisch': 'Adresse:',
        'italienisch': 'Indirizzo:'
      },
      'PLZ:': {
        'deutsch': 'PLZ:',
        'englisch': 'Postal Code:',
        'französisch': 'Code postal:',
        'italienisch': 'CAP:'
      },
      'Stadt:': {
        'deutsch': 'Stadt:',
        'englisch': 'City:',
        'französisch': 'Ville:',
        'italienisch': 'Città:'
      },
      'Land:': {
        'deutsch': 'Land:',
        'englisch': 'Country:',
        'französisch': 'Pays:',
        'italienisch': 'Paese:'
      },
      'Verfügbar ab:': {
        'deutsch': 'Verfügbar ab:',
        'englisch': 'Available from:',
        'französisch': 'Disponible à partir de:',
        'italienisch': 'Disponibile da:'
      },
      'Telefon:': {
        'deutsch': 'Telefon:',
        'englisch': 'Phone:',
        'französisch': 'Téléphone:',
        'italienisch': 'Telefono:'
      },
      'Email:': {
        'deutsch': 'Email:',
        'englisch': 'Email:',
        'französisch': 'Email:',
        'italienisch': 'Email:'
      },
      'Geburtsjahr:': {
        'deutsch': 'Geburtsjahr:',
        'englisch': 'Birth Year:',
        'französisch': 'Année de naissance:',
        'italienisch': 'Anno di nascita:'
      },
      'Nationalität:': {
        'deutsch': 'Nationalität:',
        'englisch': 'Nationality:',
        'französisch': 'Nationalité:',
        'italienisch': 'Nazionalità:'
      },
      'Aufenthaltsbewilligung:': {
        'deutsch': 'Aufenthaltsbewilligung:',
        'englisch': 'Residence Permit:',
        'französisch': 'Permis de séjour:',
        'italienisch': 'Permesso di soggiorno:'
      },
      'Familienstand:': {
        'deutsch': 'Familienstand:',
        'englisch': 'Marital Status:',
        'französisch': 'État civil:',
        'italienisch': 'Stato civile:'
      },
      'Profil:': {
        'deutsch': 'Profil:',
        'englisch': 'Profile:',
        'französisch': 'Profil:',
        'italienisch': 'Profilo:'
      },
      'Profilbild:': {
        'deutsch': 'Profilbild:',
        'englisch': 'Profile Picture:',
        'französisch': 'Photo de profil:',
        'italienisch': 'Foto del profilo:'
      },
      'Signatur:': {
        'deutsch': 'Signatur:',
        'englisch': 'Signature:',
        'französisch': 'Signature:',
        'italienisch': 'Firma:'
      },
      'CV-Daten sind wahrheitsgetreu und aktuell.': {
        'deutsch': 'CV-Daten sind wahrheitsgetreu und aktuell.',
        'englisch': 'CV data is truthful and up-to-date.',
        'französisch': 'Les données du CV sont exactes et à jour.',
        'italienisch': 'I dati del CV sono veritieri e aggiornati.'
      },
      'CV-Daten': {
        'deutsch': 'CV-Daten',
        'englisch': 'CV Data',
        'französisch': 'Données CV',
        'italienisch': 'Dati CV'
      },
      'Bitte überprüfe deine CV-Daten genau und nimm nötige Änderungen direkt in dieser Maske vor.': {
        'deutsch': 'Bitte überprüfe deine CV-Daten genau und nimm nötige Änderungen direkt in dieser Maske vor.',
        'englisch': 'Please check your CV data carefully and make necessary changes directly in this form.',
        'französisch': 'Veuillez vérifier attentivement vos données CV et apporter les modifications nécessaires directement dans ce formulaire.',
        'italienisch': 'Si prega di controllare attentamente i dati del CV e apportare le modifiche necessarie direttamente in questo modulo.'
      },
      'CV-Daten bearbeiten': {
        'deutsch': 'CV-Daten bearbeiten',
        'englisch': 'Edit CV Data',
        'französisch': 'Modifier les données CV',
        'italienisch': 'Modifica dati CV'
      },
      'CV-Daten exportieren': {
        'deutsch': 'CV-Daten exportieren',
        'englisch': 'Export CV Data',
        'französisch': 'Exporter les données CV',
        'italienisch': 'Esporta dati CV'
      },
      'Stellenbeschreibung erfassen': {
        'deutsch': 'Stellenbeschreibung erfassen',
        'englisch': 'Enter Job Description',
        'französisch': 'Saisir la description du poste',
        'italienisch': 'Inserisci descrizione del lavoro'
      },
      'Neue Stellenbeschreibung erfassen': {
        'deutsch': 'Neue Stellenbeschreibung erfassen',
        'englisch': 'Enter New Job Description',
        'französisch': 'Saisir une nouvelle description du poste',
        'italienisch': 'Inserisci nuova descrizione del lavoro'
      },
      'Als neue Bewerbung speichern': {
        'deutsch': 'Als neue Bewerbung speichern',
        'englisch': 'Save as new application',
        'französisch': 'Enregistrer comme nouvelle candidature',
        'italienisch': 'Salva come nuova candidatura'
      },
      'Bewerbungen speichern': {
        'deutsch': 'Bewerbungen speichern',
        'englisch': 'Save applications',
        'französisch': 'Enregistrer les candidatures',
        'italienisch': 'Salva candidature'
      },
      'Meine Bewerbungen': {
        'deutsch': 'Meine Bewerbungen',
        'englisch': 'My Applications',
        'französisch': 'Mes candidatures',
        'italienisch': 'Le mie candidature'
      },
      'Meine CV Daten': {
        'deutsch': 'Meine CV Daten',
        'englisch': 'My CV Data',
        'französisch': 'Mes données CV',
        'italienisch': 'I miei dati CV'
      },
      'CV Name': {
        'deutsch': 'CV Name',
        'englisch': 'CV Name',
        'französisch': 'Nom du CV',
        'italienisch': 'Nome CV'
      },
      'Aktiv': {
        'deutsch': 'Aktiv',
        'englisch': 'Active',
        'französisch': 'Actif',
        'italienisch': 'Attivo'
      },
      'Letzte Änderung': {
        'deutsch': 'Letzte Änderung',
        'englisch': 'Last Modified',
        'französisch': 'Dernière modification',
        'italienisch': 'Ultima modifica'
      },
      'Keine CV Daten vorhanden': {
        'deutsch': 'Keine CV Daten vorhanden',
        'englisch': 'No CV data available',
        'französisch': 'Aucune donnée CV disponible',
        'italienisch': 'Nessun dato CV disponibile'
      },
      'Erstellt am': {
        'deutsch': 'Erstellt am',
        'englisch': 'Created on',
        'französisch': 'Créé le',
        'italienisch': 'Creato il'
      },
      'Sprache': {
        'deutsch': 'Sprache',
        'englisch': 'Language',
        'französisch': 'Langue',
        'italienisch': 'Lingua'
      },
      'Keine Bewerbungen vorhanden': {
        'deutsch': 'Keine Bewerbungen vorhanden',
        'englisch': 'No applications available',
        'französisch': 'Aucune candidature disponible',
        'italienisch': 'Nessuna candidatura disponibile'
      },
      'Laden': {
        'deutsch': 'Laden',
        'englisch': 'Load',
        'französisch': 'Charger',
        'italienisch': 'Carica'
      },
      'Firma': {
        'deutsch': 'Firma',
        'englisch': 'Company',
        'französisch': 'Entreprise',
        'italienisch': 'Azienda'
      },
      'Ausschreibedatum': {
        'deutsch': 'Ausschreibedatum',
        'englisch': 'Publish Date',
        'französisch': 'Date de publication',
        'italienisch': 'Data di pubblicazione'
      },
      'Kontaktdaten': {
        'deutsch': 'Kontaktdaten',
        'englisch': 'Contact Info',
        'französisch': 'Coordonnées',
        'italienisch': 'Dati di contatto'
      },
      'Branche': {
        'deutsch': 'Branche',
        'englisch': 'Industry',
        'französisch': 'Secteur',
        'italienisch': 'Settore'
      },
      'Rollentitel': {
        'deutsch': 'Rollentitel',
        'englisch': 'Role Title',
        'französisch': 'Titre du poste',
        'italienisch': 'Titolo del ruolo'
      },
      'Auslastung': {
        'deutsch': 'Auslastung',
        'englisch': 'Workload',
        'französisch': 'Charge de travail',
        'italienisch': 'Carico di lavoro'
      },
      'Schlüsselstichworte': {
        'deutsch': 'Schlüsselstichworte',
        'englisch': 'Keywords',
        'französisch': 'Mots-clés',
        'italienisch': 'Parole chiave'
      },
      'Job-Informationen': {
        'deutsch': 'Job-Informationen',
        'englisch': 'Job Information',
        'französisch': 'Informations sur le poste',
        'italienisch': 'Informazioni sul lavoro'
      },
      'Job-Informationen löschen': {
        'deutsch': 'Job-Informationen löschen',
        'englisch': 'Delete Job Information',
        'französisch': 'Supprimer les informations sur le poste',
        'italienisch': 'Elimina informazioni sul lavoro'
      },
      'Drag & Drop': {
        'deutsch': 'Ziehen & Ablegen',
        'englisch': 'Drag & Drop',
        'französisch': 'Glisser-déposer',
        'italienisch': 'Trascina e rilascia'
      },
      'Copy & Paste': {
        'deutsch': 'Kopieren & Einfügen',
        'englisch': 'Copy & Paste',
        'französisch': 'Copier-coller',
        'italienisch': 'Copia e incolla'
      },
      'Bitte Stellenbeschreibung eingeben. Copy&Paste oder URL Drag&Drop': {
        'deutsch': 'Bitte Stellenbeschreibung eingeben.\nCopy&Paste oder URL Drag&Drop',
        'englisch': 'Please enter job description.\nCopy&Paste or URL Drag&Drop',
        'französisch': 'Veuillez saisir la description du poste.\nCopier-coller ou glisser-déposer l\'URL',
        'italienisch': 'Si prega di inserire la descrizione del lavoro.\nCopia e incolla o trascina e rilascia l\'URL'
      },
      'Bewerbungsdetails': {
        'deutsch': 'Bewerbungsdetails',
        'englisch': 'Application Details',
        'französisch': 'Détails de la candidature',
        'italienisch': 'Dettagli della candidatura'
      },
      'Zur Stellenbeschreibung': {
        'deutsch': 'Zur Stellenbeschreibung',
        'englisch': 'Go to Job Description',
        'französisch': 'Aller à la description du poste',
        'italienisch': 'Vai alla descrizione del lavoro'
      },
      'Status': {
        'deutsch': 'Status',
        'englisch': 'Status',
        'französisch': 'Statut',
        'italienisch': 'Stato'
      },
      'PDF verfügbar zum Download': {
        'deutsch': 'PDF verfügbar zum Download',
        'englisch': 'PDF available for download',
        'französisch': 'PDF disponible au téléchargement',
        'italienisch': 'PDF disponibile per il download'
      },
      'CV': {
        'deutsch': 'CV',
        'englisch': 'CV',
        'französisch': 'CV',
        'italienisch': 'CV'
      },
      'Notizen': {
        'deutsch': 'Notizen',
        'englisch': 'Notes',
        'französisch': 'Notes',
        'italienisch': 'Note'
      },
      'Offen': {
        'deutsch': 'Offen',
        'englisch': 'Open',
        'französisch': 'Ouvert',
        'italienisch': 'Aperto'
      },
      'Vorstellungsgespräch': {
        'deutsch': 'Vorstellungsgespräch',
        'englisch': 'Interview',
        'französisch': 'Entretien',
        'italienisch': 'Colloquio'
      },
      'Geschlossen': {
        'deutsch': 'Geschlossen',
        'englisch': 'Closed',
        'französisch': 'Fermé',
        'italienisch': 'Chiuso'
      },
      'Geschlossene Bewerbungen anzeigen': {
        'deutsch': 'Geschlossene Bewerbungen anzeigen',
        'englisch': 'Show closed applications',
        'französisch': 'Afficher les candidatures fermées',
        'italienisch': 'Mostra candidature chiuse'
      },
      'Datumsfilter anzeigen': {
        'deutsch': 'Datumsfilter anzeigen',
        'englisch': 'Show date filters',
        'französisch': 'Afficher les filtres de date',
        'italienisch': 'Mostra filtri data'
      },
      'Datumsfilter verbergen': {
        'deutsch': 'Datumsfilter verbergen',
        'englisch': 'Hide date filters',
        'französisch': 'Masquer les filtres de date',
        'italienisch': 'Nascondi filtri data'
      },
      'Von': {
        'deutsch': 'Von',
        'englisch': 'From',
        'französisch': 'De',
        'italienisch': 'Da'
      },
      'Bis': {
        'deutsch': 'Bis',
        'englisch': 'To',
        'französisch': 'À',
        'italienisch': 'A'
      },
      'Logout': {
        'deutsch': 'Abmelden',
        'englisch': 'Logout',
        'französisch': 'Déconnexion',
        'italienisch': 'Disconnetti'
      },
      'Beenden': {
        'deutsch': 'Beenden',
        'englisch': 'Finish',
        'französisch': 'Terminer',
        'italienisch': 'Terminare'
      },
      'Speicherung nicht möglich: Vollständiger Name fehlt': {
        'deutsch': 'Speicherung nicht möglich: Vollständiger Name fehlt',
        'englisch': 'Cannot save: Full name is missing',
        'französisch': 'Sauvegarde impossible: Nom complet manquant',
        'italienisch': 'Impossibile salvare: Nome completo mancante'
      },
      'Ungespeicherte Änderungen': {
        'deutsch': 'Ungespeicherte Änderungen',
        'englisch': 'Unsaved Changes',
        'französisch': 'Modifications non enregistrées',
        'italienisch': 'Modifiche non salvate'
      },
      'Sie haben ungespeicherte Änderungen. Möchten Sie wirklich schließen ohne zu speichern?': {
        'deutsch': 'Sie haben ungespeicherte Änderungen. Möchten Sie wirklich schließen ohne zu speichern?',
        'englisch': 'You have unsaved changes. Do you really want to close without saving?',
        'französisch': 'Vous avez des modifications non enregistrées. Voulez-vous vraiment fermer sans enregistrer?',
        'italienisch': 'Hai modifiche non salvate. Vuoi davvero chiudere senza salvare?'
      },
      'Abbrechen': {
        'deutsch': 'Abbrechen',
        'englisch': 'Cancel',
        'französisch': 'Annuler',
        'italienisch': 'Annulla'
      },
      'Ohne Speichern schließen': {
        'deutsch': 'Ohne Speichern schließen',
        'englisch': 'Close without saving',
        'französisch': 'Fermer sans enregistrer',
        'italienisch': 'Chiudi senza salvare'
      },
      'Stellenbeschreibung eingeben': {
        'deutsch': 'Stellenbeschreibung eingeben',
        'englisch': 'Enter Job Description',
        'französisch': 'Saisir la description du poste',
        'italienisch': 'Inserisci descrizione del lavoro'
      },
      'Extrahiere Text von Webseite...': {
        'deutsch': 'Extrahiere Text von Webseite...',
        'englisch': 'Extracting text from website...',
        'französisch': 'Extraction du texte du site web...',
        'italienisch': 'Estrazione del testo dal sito web...'
      },
      'Fügen Sie hier die vollständige Stellenbeschreibung ein oder ziehen Sie einen Link hinein...': {
        'deutsch': 'Fügen Sie hier die vollständige Stellenbeschreibung ein oder ziehen Sie einen Link hinein...',
        'englisch': 'Paste the complete job description here or drag a link into it...',
        'französisch': 'Collez ici la description complète du poste ou faites glisser un lien...',
        'italienisch': 'Incolla qui la descrizione completa del lavoro o trascina un link...'
      },
      'Sprache Stellenbeschreibung': {
        'deutsch': 'Sprache Stellenbeschreibung',
        'englisch': 'Job Description Language',
        'französisch': 'Langue de la description du poste',
        'italienisch': 'Lingua della descrizione del lavoro'
      },
      'Passgenauigkeit prüfen': {
        'deutsch': 'Passgenauigkeit prüfen',
        'englisch': 'Check Match Score',
        'französisch': 'Vérifier la correspondance',
        'italienisch': 'Verifica corrispondenza'
      },
      'Passgenauigkeit:': {
        'deutsch': 'Passgenauigkeit:',
        'englisch': 'Match Score:',
        'französisch': 'Correspondance:',
        'italienisch': 'Corrispondenza:'
      },
      'Fehlende Skills/Erfahrungen:': {
        'deutsch': 'Fehlende Skills/Erfahrungen:',
        'englisch': 'Missing Skills/Experiences:',
        'französisch': 'Compétences/Expériences manquantes:',
        'italienisch': 'Competenze/Esperienze mancanti:'
      },
      'Ergänzt': {
        'deutsch': 'Ergänzt',
        'englisch': 'Added',
        'französisch': 'Ajouté',
        'italienisch': 'Aggiunto'
      },
      'CV optimieren': {
        'deutsch': 'CV optimieren',
        'englisch': 'Optimize CV',
        'französisch': 'Optimiser le CV',
        'italienisch': 'Ottimizza CV'
      },
      'CV anzeigen': {
        'deutsch': 'CV anzeigen',
        'englisch': 'Show CV',
        'französisch': 'Afficher le CV',
        'italienisch': 'Mostra CV'
      },
      'oder': {
        'deutsch': 'oder',
        'englisch': 'or',
        'französisch': 'ou',
        'italienisch': 'o'
      },
      'CV-Vorschau': {
        'deutsch': 'CV-Vorschau',
        'englisch': 'CV Preview',
        'französisch': 'Aperçu du CV',
        'italienisch': 'Anteprima CV'
      },
      'Motivationsschreiben-Vorschau': {
        'deutsch': 'Motivationsschreiben-Vorschau',
        'englisch': 'Cover Letter Preview',
        'französisch': 'Aperçu de la lettre de motivation',
        'italienisch': 'Anteprima lettera di motivazione'
      },
      'Vorschau': {
        'deutsch': 'Vorschau',
        'englisch': 'Preview',
        'französisch': 'Aperçu',
        'italienisch': 'Anteprima'
      },
      'Profilbild anzeigen': {
        'deutsch': 'Profilbild anzeigen',
        'englisch': 'Show Profile Picture',
        'französisch': 'Afficher la photo de profil',
        'italienisch': 'Mostra foto profilo'
      },
      'Kurzprofil anzeigen': {
        'deutsch': 'Kurzprofil anzeigen',
        'englisch': 'Show Short Profile',
        'französisch': 'Afficher le profil court',
        'italienisch': 'Mostra profilo breve'
      },
      'Kernkompetenzen anzeigen': {
        'deutsch': 'Kernkompetenzen anzeigen',
        'englisch': 'Show Core Competencies',
        'französisch': 'Afficher les compétences clés',
        'italienisch': 'Mostra competenze chiave'
      },
      'Zertifizierungen anzeigen': {
        'deutsch': 'Zertifizierungen anzeigen',
        'englisch': 'Show Certifications',
        'französisch': 'Afficher les certifications',
        'italienisch': 'Mostra certificazioni'
      },
      'IT-Skills anzeigen': {
        'deutsch': 'IT-Skills anzeigen',
        'englisch': 'Show IT Skills',
        'französisch': 'Afficher les compétences IT',
        'italienisch': 'Mostra competenze IT'
      },
      'Branchen anzeigen': {
        'deutsch': 'Branchen anzeigen',
        'englisch': 'Show Industries',
        'französisch': 'Afficher les secteurs',
        'italienisch': 'Mostra settori'
      },
      'Sprachen anzeigen': {
        'deutsch': 'Sprachen anzeigen',
        'englisch': 'Show Languages',
        'französisch': 'Afficher les langues',
        'italienisch': 'Mostra lingue'
      },
      'Hobbys anzeigen': {
        'deutsch': 'Hobbys anzeigen',
        'englisch': 'Show Hobbies',
        'französisch': 'Afficher les loisirs',
        'italienisch': 'Mostra hobby'
      },
      'Ausbildung anzeigen': {
        'deutsch': 'Ausbildung anzeigen',
        'englisch': 'Show Education',
        'französisch': 'Afficher la formation',
        'italienisch': 'Mostra formazione'
      },
      'Berufserfahrung anzeigen': {
        'deutsch': 'Berufserfahrung anzeigen',
        'englisch': 'Show Work Experience',
        'französisch': 'Afficher l\'expérience professionnelle',
        'italienisch': 'Mostra esperienza lavorativa'
      },
      'Weitere Berufserfahrungen anzeigen': {
        'deutsch': 'Weitere Berufserfahrungen anzeigen',
        'englisch': 'Show Additional Work Experience',
        'französisch': 'Afficher l\'expérience professionnelle supplémentaire',
        'italienisch': 'Mostra esperienza lavorativa aggiuntiva'
      },
      'Zusätzliche Infos anzeigen': {
        'deutsch': 'Zusätzliche Infos anzeigen',
        'englisch': 'Show Additional Information',
        'französisch': 'Afficher les informations supplémentaires',
        'italienisch': 'Mostra informazioni aggiuntive'
      },
      'Spaltenfarbe': {
        'deutsch': 'Spaltenfarbe',
        'englisch': 'Column Color',
        'französisch': 'Couleur de colonne',
        'italienisch': 'Colore colonna'
      },
      'Textfarben': {
        'deutsch': 'Textfarben',
        'englisch': 'Text Colors',
        'französisch': 'Couleurs du texte',
        'italienisch': 'Colori del testo'
      },
      'Reset Design': {
        'deutsch': 'Reset Design',
        'englisch': 'Reset Design',
        'französisch': 'Réinitialiser le design',
        'italienisch': 'Ripristina design'
      },
      'CV-Einstellungen': {
        'deutsch': 'CV-Einstellungen',
        'englisch': 'CV Settings',
        'französisch': 'Paramètres CV',
        'italienisch': 'Impostazioni CV'
      },
      'Sichtbarkeit': {
        'deutsch': 'Sichtbarkeit',
        'englisch': 'Visibility',
        'französisch': 'Visibilité',
        'italienisch': 'Visibilità'
      },
      'Design': {
        'deutsch': 'Design',
        'englisch': 'Design',
        'französisch': 'Design',
        'italienisch': 'Design'
      },
      'Hier kannst du dir deinen CV in 3 verschiedenen Designs anzeigen lassen. Wähle ein Design aus und lies die Texte sorgfältig durch. Wenn du etwas ändern willst, klicke auf das entsprechende Element. Die Einstellungen findest du links neben der CV-Vorschau. Willst du den CV herunterladen, klicke auf das Download Icon oben rechts.': {
        'deutsch': 'Hier kannst du dir deinen CV in 3 verschiedenen Designs anzeigen lassen. Wähle ein Design aus und lies die Texte sorgfältig durch. Wenn du etwas ändern willst, klicke auf das entsprechende Element. Die Einstellungen findest du links neben der CV-Vorschau. Willst du den CV herunterladen, klicke auf das Download Icon oben rechts.',
        'englisch': 'Here you can view your CV in 3 different designs. Choose a design and read through the texts carefully. If you want to change something, click on the corresponding element. You can find the settings on the left next to the CV preview. If you want to download the CV, click on the download icon in the top right.',
        'französisch': 'Ici vous pouvez voir votre CV dans 3 designs différents. Choisissez un design et lisez attentivement les textes. Si vous voulez changer quelque chose, cliquez sur l\'élément correspondant. Vous pouvez trouver les paramètres à gauche à côté de l\'aperçu du CV. Si vous voulez télécharger le CV, cliquez sur l\'icône de téléchargement en haut à droite.',
        'italienisch': 'Qui puoi visualizzare il tuo CV in 3 design diversi. Scegli un design e leggi attentamente i testi. Se vuoi cambiare qualcosa, clicca sull\'elemento corrispondente. Puoi trovare le impostazioni a sinistra accanto all\'anteprima del CV. Se vuoi scaricare il CV, clicca sull\'icona di download in alto a destra.'
      },
      'Modern': {
        'deutsch': 'Modern',
        'englisch': 'Modern',
        'französisch': 'Moderne',
        'italienisch': 'Moderno'
      },
      'Professional': {
        'deutsch': 'Professional',
        'englisch': 'Professional',
        'französisch': 'Professionnel',
        'italienisch': 'Professionale'
      },
      'Classic': {
        'deutsch': 'Classic',
        'englisch': 'Classic',
        'französisch': 'Classique',
        'italienisch': 'Classico'
      },
      'Profilbild im CV-Template anzeigen': {
        'deutsch': 'Profilbild im CV-Template anzeigen',
        'englisch': 'Show Profile Picture in CV Template',
        'französisch': 'Afficher la photo de profil dans le modèle CV',
        'italienisch': 'Mostra foto profilo nel template CV'
      },
      'Klicken und ziehen, um die Position zu ändern': {
        'deutsch': 'Klicken und ziehen, um die Position zu ändern',
        'englisch': 'Click and drag to change position',
        'französisch': 'Cliquer et faire glisser pour modifier la position',
        'italienisch': 'Fare clic e trascinare per modificare la posizione'
      },
      'Rundung:': {
        'deutsch': 'Rundung:',
        'englisch': 'Roundness:',
        'französisch': 'Arrondi:',
        'italienisch': 'Arrotondamento:'
      },
      'Eckig': {
        'deutsch': 'Eckig',
        'englisch': 'Square',
        'französisch': 'Carré',
        'italienisch': 'Quadrato'
      },
      'Rund': {
        'deutsch': 'Rund',
        'englisch': 'Round',
        'französisch': 'Rond',
        'italienisch': 'Rotondo'
      },
      'Rahmen': {
        'deutsch': 'Rahmen',
        'englisch': 'Border',
        'französisch': 'Bordure',
        'italienisch': 'Bordo'
      },
      'Rahmen um das Profilbild anzeigen': {
        'deutsch': 'Rahmen um das Profilbild anzeigen',
        'englisch': 'Show border around profile picture',
        'französisch': 'Afficher la bordure autour de la photo de profil',
        'italienisch': 'Mostra bordo attorno alla foto profilo'
      },
      'Rahmenfarbe': {
        'deutsch': 'Rahmenfarbe',
        'englisch': 'Border Color',
        'französisch': 'Couleur de bordure',
        'italienisch': 'Colore bordo'
      },
      'Rahmendicke:': {
        'deutsch': 'Rahmendicke:',
        'englisch': 'Border Thickness:',
        'französisch': 'Épaisseur de bordure:',
        'italienisch': 'Spessore bordo:'
      },
      'Breite:': {
        'deutsch': 'Breite:',
        'englisch': 'Width:',
        'französisch': 'Largeur:',
        'italienisch': 'Larghezza:'
      },
      'Profilbild-Größe': {
        'deutsch': 'Profilbild-Größe',
        'englisch': 'Profile Picture Size',
        'französisch': 'Taille de la photo de profil',
        'italienisch': 'Dimensione foto profilo'
      },
      'Profilbild-Ausrichtung': {
        'deutsch': 'Profilbild-Ausrichtung',
        'englisch': 'Profile Picture Alignment',
        'französisch': 'Alignement de la photo de profil',
        'italienisch': 'Allineamento foto profilo'
      },
      'Links': {
        'deutsch': 'Links',
        'englisch': 'Left',
        'französisch': 'Gauche',
        'italienisch': 'Sinistra'
      },
      'Mittig': {
        'deutsch': 'Mittig',
        'englisch': 'Center',
        'französisch': 'Centre',
        'italienisch': 'Centro'
      },
      'Rechts': {
        'deutsch': 'Rechts',
        'englisch': 'Right',
        'französisch': 'Droite',
        'italienisch': 'Destra'
      },
      'Schließen': {
        'deutsch': 'Schließen',
        'englisch': 'Close',
        'französisch': 'Fermer',
        'italienisch': 'Chiudi'
      },
      'Profil im CV-Template anzeigen': {
        'deutsch': 'Profil im CV-Template anzeigen',
        'englisch': 'Show Profile in CV Template',
        'französisch': 'Afficher le profil dans le modèle CV',
        'italienisch': 'Mostra profilo nel template CV'
      },
      'Bearbeiten Sie Ihr Profil:': {
        'deutsch': 'Bearbeiten Sie Ihr Profil:',
        'englisch': 'Edit your profile:',
        'französisch': 'Modifiez votre profil:',
        'italienisch': 'Modifica il tuo profilo:'
      },
      'Profil-Text': {
        'deutsch': 'Profil-Text',
        'englisch': 'Profile Text',
        'französisch': 'Texte du profil',
        'italienisch': 'Testo profilo'
      },
      'Beschreiben Sie sich selbst, Ihre Ziele und Ihre Stärken...': {
        'deutsch': 'Beschreiben Sie sich selbst, Ihre Ziele und Ihre Stärken...',
        'englisch': 'Describe yourself, your goals and your strengths...',
        'französisch': 'Décrivez-vous, vos objectifs et vos points forts...',
        'italienisch': 'Descrivi te stesso, i tuoi obiettivi e i tuoi punti di forza...'
      },
      'Kernkompetenzen im CV-Template anzeigen': {
        'deutsch': 'Kernkompetenzen im CV-Template anzeigen',
        'englisch': 'Show Core Competencies in CV Template',
        'französisch': 'Afficher les compétences clés dans le modèle CV',
        'italienisch': 'Mostra competenze chiave nel template CV'
      },
      'Hier sind alle optimierten Kernkompetenzen aus Ihren CV-Daten:': {
        'deutsch': 'Hier sind alle optimierten Kernkompetenzen aus Ihren CV-Daten:',
        'englisch': 'Here are all optimized core competencies from your CV data:',
        'französisch': 'Voici toutes les compétences clés optimisées de vos données CV:',
        'italienisch': 'Ecco tutte le competenze chiave ottimizzate dai tuoi dati CV:'
      },
      'Hinzufügen': {
        'deutsch': 'Hinzufügen',
        'englisch': 'Add',
        'französisch': 'Ajouter',
        'italienisch': 'Aggiungi'
      },
      'Kernkompetenz': {
        'deutsch': 'Kernkompetenz',
        'englisch': 'Core Competency',
        'französisch': 'Compétence clé',
        'italienisch': 'Competenza chiave'
      },
      'Aktionen': {
        'deutsch': 'Aktionen',
        'englisch': 'Actions',
        'französisch': 'Actions',
        'italienisch': 'Azioni'
      },
      'Keine Kernkompetenzen verfügbar': {
        'deutsch': 'Keine Kernkompetenzen verfügbar',
        'englisch': 'No core competencies available',
        'französisch': 'Aucune compétence clé disponible',
        'italienisch': 'Nessuna competenza chiave disponibile'
      },
      'Ausbildungen im CV-Template anzeigen': {
        'deutsch': 'Ausbildungen im CV-Template anzeigen',
        'englisch': 'Show Education in CV Template',
        'französisch': 'Afficher la formation dans le modèle CV',
        'italienisch': 'Mostra formazione nel template CV'
      },
      'Hier sind alle optimierten Ausbildungen aus Ihren CV-Daten:': {
        'deutsch': 'Hier sind alle optimierten Ausbildungen aus Ihren CV-Daten:',
        'englisch': 'Here is all optimized education from your CV data:',
        'französisch': 'Voici toutes les formations optimisées de vos données CV:',
        'italienisch': 'Ecco tutta la formazione ottimizzata dai tuoi dati CV:'
      },
      'Keine Ausbildungen verfügbar': {
        'deutsch': 'Keine Ausbildungen verfügbar',
        'englisch': 'No education available',
        'französisch': 'Aucune formation disponible',
        'italienisch': 'Nessuna formazione disponibile'
      },
      'Zertifizierungen im CV-Template anzeigen': {
        'deutsch': 'Zertifizierungen im CV-Template anzeigen',
        'englisch': 'Show Certifications in CV Template',
        'französisch': 'Afficher les certifications dans le modèle CV',
        'italienisch': 'Mostra certificazioni nel template CV'
      },
      'Hier sind alle optimierten Zertifizierungen aus Ihren CV-Daten:': {
        'deutsch': 'Hier sind alle optimierten Zertifizierungen aus Ihren CV-Daten:',
        'englisch': 'Here are all optimized certifications from your CV data:',
        'französisch': 'Voici toutes les certifications optimisées de vos données CV:',
        'italienisch': 'Ecco tutte le certificazioni ottimizzate dai tuoi dati CV:'
      },
      'Zertifizierung': {
        'deutsch': 'Zertifizierung',
        'englisch': 'Certification',
        'französisch': 'Certification',
        'italienisch': 'Certificazione'
      },
      'Keine Zertifizierungen verfügbar': {
        'deutsch': 'Keine Zertifizierungen verfügbar',
        'englisch': 'No certifications available',
        'französisch': 'Aucune certification disponible',
        'italienisch': 'Nessuna certificazione disponibile'
      },
      'IT-Skills im CV-Template anzeigen': {
        'deutsch': 'IT-Skills im CV-Template anzeigen',
        'englisch': 'Show IT Skills in CV Template',
        'französisch': 'Afficher les compétences IT dans le modèle CV',
        'italienisch': 'Mostra competenze IT nel template CV'
      },
      'Hier sind alle optimierten IT-Skills aus Ihren CV-Daten:': {
        'deutsch': 'Hier sind alle optimierten IT-Skills aus Ihren CV-Daten:',
        'englisch': 'Here are all optimized IT skills from your CV data:',
        'französisch': 'Voici toutes les compétences IT optimisées de vos données CV:',
        'italienisch': 'Ecco tutte le competenze IT ottimizzate dai tuoi dati CV:'
      },
      'IT-Skill': {
        'deutsch': 'IT-Skill',
        'englisch': 'IT Skill',
        'französisch': 'Compétence IT',
        'italienisch': 'Competenza IT'
      },
      'Keine IT-Skills verfügbar': {
        'deutsch': 'Keine IT-Skills verfügbar',
        'englisch': 'No IT skills available',
        'französisch': 'Aucune compétence IT disponible',
        'italienisch': 'Nessuna competenza IT disponibile'
      },
      'Branchen im CV-Template anzeigen': {
        'deutsch': 'Branchen im CV-Template anzeigen',
        'englisch': 'Show Industries in CV Template',
        'französisch': 'Afficher les secteurs dans le modèle CV',
        'italienisch': 'Mostra settori nel template CV'
      },
      'Hier sind alle optimierten Branchen aus Ihren CV-Daten:': {
        'deutsch': 'Hier sind alle optimierten Branchen aus Ihren CV-Daten:',
        'englisch': 'Here are all optimized industries from your CV data:',
        'französisch': 'Voici tous les secteurs optimisés de vos données CV:',
        'italienisch': 'Ecco tutti i settori ottimizzati dai tuoi dati CV:'
      },
      'Keine Branchen verfügbar': {
        'deutsch': 'Keine Branchen verfügbar',
        'englisch': 'No industries available',
        'französisch': 'Aucun secteur disponible',
        'italienisch': 'Nessun settore disponibile'
      },
      'Sprachen im CV-Template anzeigen': {
        'deutsch': 'Sprachen im CV-Template anzeigen',
        'englisch': 'Show Languages in CV Template',
        'französisch': 'Afficher les langues dans le modèle CV',
        'italienisch': 'Mostra lingue nel template CV'
      },
      'Hier sind alle optimierten Sprachen aus Ihren CV-Daten:': {
        'deutsch': 'Hier sind alle optimierten Sprachen aus Ihren CV-Daten:',
        'englisch': 'Here are all optimized languages from your CV data:',
        'französisch': 'Voici toutes les langues optimisées de vos données CV:',
        'italienisch': 'Ecco tutte le lingue ottimizzate dai tuoi dati CV:'
      },
      'Keine Sprachen verfügbar': {
        'deutsch': 'Keine Sprachen verfügbar',
        'englisch': 'No languages available',
        'französisch': 'Aucune langue disponible',
        'italienisch': 'Nessuna lingua disponibile'
      },
      'Hobbies im CV-Template anzeigen': {
        'deutsch': 'Hobbies im CV-Template anzeigen',
        'englisch': 'Show Hobbies in CV Template',
        'französisch': 'Afficher les loisirs dans le modèle CV',
        'italienisch': 'Mostra hobby nel template CV'
      },
      'Hier sind alle optimierten Hobbies aus Ihren CV-Daten:': {
        'deutsch': 'Hier sind alle optimierten Hobbies aus Ihren CV-Daten:',
        'englisch': 'Here are all optimized hobbies from your CV data:',
        'französisch': 'Voici tous les loisirs optimisés de vos données CV:',
        'italienisch': 'Ecco tutti gli hobby ottimizzati dai tuoi dati CV:'
      },
      'Keine Hobbies verfügbar': {
        'deutsch': 'Keine Hobbies verfügbar',
        'englisch': 'No hobbies available',
        'französisch': 'Aucun loisir disponible',
        'italienisch': 'Nessun hobby disponibile'
      },
      'Weitere Angaben im CV-Template anzeigen': {
        'deutsch': 'Weitere Angaben im CV-Template anzeigen',
        'englisch': 'Show Additional Information in CV Template',
        'französisch': 'Afficher les informations supplémentaires dans le modèle CV',
        'italienisch': 'Mostra informazioni aggiuntive nel template CV'
      },
      'Hier sind alle optimierten Weitere Angaben aus Ihren CV-Daten:': {
        'deutsch': 'Hier sind alle optimierten Weitere Angaben aus Ihren CV-Daten:',
        'englisch': 'Here is all optimized additional information from your CV data:',
        'französisch': 'Voici toutes les informations supplémentaires optimisées de vos données CV:',
        'italienisch': 'Ecco tutte le informazioni aggiuntive ottimizzate dai tuoi dati CV:'
      },
      'Info': {
        'deutsch': 'Info',
        'englisch': 'Info',
        'französisch': 'Info',
        'italienisch': 'Info'
      },
      'Keine Weitere Angaben verfügbar': {
        'deutsch': 'Keine Weitere Angaben verfügbar',
        'englisch': 'No additional information available',
        'französisch': 'Aucune information supplémentaire disponible',
        'italienisch': 'Nessuna informazione aggiuntiva disponibile'
      },
      'Berufserfahrungen im CV-Template anzeigen': {
        'deutsch': 'Berufserfahrungen im CV-Template anzeigen',
        'englisch': 'Show Work Experience in CV Template',
        'französisch': 'Afficher l\'expérience professionnelle dans le modèle CV',
        'italienisch': 'Mostra esperienza lavorativa nel template CV'
      },
      'Weitere Berufserfahrungen im CV-Template anzeigen': {
        'deutsch': 'Weitere Berufserfahrungen im CV-Template anzeigen',
        'englisch': 'Show Additional Work Experience in CV Template',
        'französisch': 'Afficher l\'expérience professionnelle supplémentaire dans le modèle CV',
        'italienisch': 'Mostra esperienza lavorativa aggiuntiva nel template CV'
      },
      'Bearbeiten Sie diese Berufserfahrung:': {
        'deutsch': 'Bearbeiten Sie diese Berufserfahrung:',
        'englisch': 'Edit this work experience:',
        'französisch': 'Modifiez cette expérience professionnelle:',
        'italienisch': 'Modifica questa esperienza lavorativa:'
      },
      'Hier sind alle optimierten Berufserfahrungen aus Ihren CV-Daten:': {
        'deutsch': 'Hier sind alle optimierten Berufserfahrungen aus Ihren CV-Daten:',
        'englisch': 'Here is all optimized work experience from your CV data:',
        'französisch': 'Voici toutes les expériences professionnelles optimisées de vos données CV:',
        'italienisch': 'Ecco tutta l\'esperienza lavorativa ottimizzata dai tuoi dati CV:'
      },
      'Unternehmen': {
        'deutsch': 'Unternehmen',
        'englisch': 'Company',
        'französisch': 'Entreprise',
        'italienisch': 'Azienda'
      },
      'Relevant': {
        'deutsch': 'Relevant',
        'englisch': 'Relevant',
        'französisch': 'Pertinent',
        'italienisch': 'Rilevante'
      },
      'Nicht relevant': {
        'deutsch': 'Nicht relevant',
        'englisch': 'Not relevant',
        'französisch': 'Non pertinent',
        'italienisch': 'Non rilevante'
      },
      'Mit Relevanz kannst du angeben, ob eine Berufserfahrung mit Beschreibung unter BERUFLICHER WERDEGANG oder mit minimalen Informationen unter WEITERE BERUFSERFAHRUNGEN aufgeführt werden soll.': {
        'deutsch': 'Mit Relevanz kannst du angeben, ob eine Berufserfahrung mit Beschreibung unter BERUFLICHER WERDEGANG oder mit minimalen Informationen unter WEITERE BERUFSERFAHRUNGEN aufgeführt werden soll.',
        'englisch': 'With relevance you can specify whether a work experience should be listed with description under PROFESSIONAL EXPERIENCE or with minimal information under ADDITIONAL WORK EXPERIENCE.',
        'französisch': 'Avec la pertinence, vous pouvez spécifier si une expérience professionnelle doit être répertoriée avec description sous PARCOURS PROFESSIONNEL ou avec des informations minimales sous AUTRES EXPÉRIENCES PROFESSIONNELLES.',
        'italienisch': 'Con la rilevanza puoi specificare se un\'esperienza lavorativa deve essere elencata con descrizione sotto ESPERIENZA PROFESSIONALE o con informazioni minime sotto ALTRE ESPERIENZE PROFESSIONALI.'
      },
      'Speichern': {
        'deutsch': 'Speichern',
        'englisch': 'Save',
        'französisch': 'Enregistrer',
        'italienisch': 'Salva'
      },
      'Zurück': {
        'deutsch': 'Zurück',
        'englisch': 'Back',
        'französisch': 'Retour',
        'italienisch': 'Indietro'
      },
      'Löschen': {
        'deutsch': 'Löschen',
        'englisch': 'Delete',
        'französisch': 'Supprimer',
        'italienisch': 'Elimina'
      },
      'Keine Berufserfahrungen verfügbar': {
        'deutsch': 'Keine Berufserfahrungen verfügbar',
        'englisch': 'No work experience available',
        'französisch': 'Aucune expérience professionnelle disponible',
        'italienisch': 'Nessuna esperienza lavorativa disponibile'
      },
      'Motivationsschreiben erstellen': {
        'deutsch': 'Motivationsschreiben erstellen',
        'englisch': 'Create Cover Letter',
        'französisch': 'Créer une lettre de motivation',
        'italienisch': 'Crea lettera di motivazione'
      },
      'Motivationsschreiben anzeigen': {
        'deutsch': 'Motivationsschreiben anzeigen',
        'englisch': 'Show Cover Letter',
        'französisch': 'Afficher la lettre de motivation',
        'italienisch': 'Mostra lettera di motivazione'
      },
      'Bitte lies das Motivationsschreiben gut durch. Willst du etwas ändern, klicke auf den entsprechenden Text. Willst du es herunter laden, klicke auf das Download Icon oben rechts.': {
        'deutsch': 'Bitte lies das Motivationsschreiben gut durch. Willst du etwas ändern, klicke auf den entsprechenden Text. Willst du es herunter laden, klicke auf das Download Icon oben rechts.',
        'englisch': 'Please read the cover letter carefully. If you want to change something, click on the corresponding text. If you want to download it, click on the download icon at the top right.',
        'französisch': 'Veuillez lire attentivement la lettre de motivation. Si vous souhaitez modifier quelque chose, cliquez sur le texte correspondant. Si vous souhaitez la télécharger, cliquez sur l\'icône de téléchargement en haut à droite.',
        'italienisch': 'Si prega di leggere attentamente la lettera di motivazione. Se vuoi modificare qualcosa, fai clic sul testo corrispondente. Se vuoi scaricarla, fai clic sull\'icona di download in alto a destra.'
      },
      'Hier kannst du dir deinen CV in 3 verschiedenen Designs anzeigen lassen. Wähle ein Design aus und lies die Texte sorgfältig durch. Wenn du etwas ändern willst, klicke auf das entsprechende Element. Willst du ein Design ändern, klick auf das Zahnrad Icon oben rechts. Willst du den CV herunterladen, klicke auf das Download Icon oben rechts.': {
        'deutsch': 'Hier kannst du dir deinen CV in 3 verschiedenen Designs anzeigen lassen. Wähle ein Design aus und lies die Texte sorgfältig durch. Wenn du etwas ändern willst, klicke auf das entsprechende Element. Willst du ein Design ändern, klick auf das Zahnrad Icon oben rechts. Willst du den CV herunterladen, klicke auf das Download Icon oben rechts.',
        'englisch': 'Here you can view your CV in 3 different designs. Select a design and read the texts carefully. If you want to change something, click on the corresponding element. If you want to change a design, click on the gear icon at the top right. If you want to download the CV, click on the download icon at the top right.',
        'französisch': 'Ici, vous pouvez afficher votre CV dans 3 designs différents. Sélectionnez un design et lisez attentivement les textes. Si vous souhaitez modifier quelque chose, cliquez sur l\'élément correspondant. Si vous souhaitez modifier un design, cliquez sur l\'icône d\'engrenage en haut à droite. Si vous souhaitez télécharger le CV, cliquez sur l\'icône de téléchargement en haut à droite.',
        'italienisch': 'Qui puoi visualizzare il tuo CV in 3 design diversi. Seleziona un design e leggi attentamente i testi. Se vuoi modificare qualcosa, fai clic sull\'elemento corrispondente. Se vuoi modificare un design, fai clic sull\'icona dell\'ingranaggio in alto a destra. Se vuoi scaricare il CV, fai clic sull\'icona di download in alto a destra.'
      },
      'Beschreibung wird extrahiert': {
        'deutsch': 'Beschreibung wird extrahiert',
        'englisch': 'Description being extracted',
        'französisch': 'Description en cours d\'extraction',
        'italienisch': 'Descrizione in estrazione'
      },
      'QR-Code wird geladen...': {
        'deutsch': 'QR-Code wird geladen...',
        'englisch': 'QR code loading...',
        'französisch': 'Chargement du code QR...',
        'italienisch': 'Caricamento del codice QR...'
      },
      'Der QR-Code ist 10 Minuten gültig. Das Foto wird automatisch als Profilbild übernommen.': {
        'deutsch': 'Der QR-Code ist 10 Minuten gültig. Das Foto wird automatisch als Profilbild übernommen.',
        'englisch': 'The QR code is valid for 10 minutes. The photo will be automatically used as profile picture.',
        'französisch': 'Le code QR est valable 10 minutes. La photo sera automatiquement utilisée comme photo de profil.',
        'italienisch': 'Il codice QR è valido per 10 minuti. La foto verrà automaticamente utilizzata come foto profilo.'
      },
      'CV Daten werden importiert...': {
        'deutsch': 'CV Daten werden importiert...',
        'englisch': 'CV data being imported...',
        'französisch': 'Importation des données CV...',
        'italienisch': 'Importazione dati CV...'
      },
      'CV wird verarbeitet...': {
        'deutsch': 'CV wird verarbeitet...',
        'englisch': 'CV being processed...',
        'französisch': 'CV en cours de traitement...',
        'italienisch': 'CV in elaborazione...'
      },
      'Kurzprofil': {
        'deutsch': 'Kurzprofil',
        'englisch': 'Short Profile',
        'französisch': 'Profil court',
        'italienisch': 'Profilo breve'
      },
      'Kernkompetenzen': {
        'deutsch': 'Kernkompetenzen',
        'englisch': 'Core Competencies',
        'französisch': 'Compétences clés',
        'italienisch': 'Competenze chiave'
      },
      'Relevante Kernkompetenzen': {
        'deutsch': 'Relevante Kernkompetenzen',
        'englisch': 'Relevant Core Competencies',
        'französisch': 'Compétences clés pertinentes',
        'italienisch': 'Competenze chiave rilevanti'
      },
      'Kernkompetenz aus gespeicherten Daten hinzufügen': {
        'deutsch': 'Kernkompetenz aus gespeicherten Daten hinzufügen',
        'englisch': 'Add Core Competency from Saved Data',
        'französisch': 'Ajouter une compétence clé à partir des données enregistrées',
        'italienisch': 'Aggiungi competenza chiave dai dati salvati'
      },
      'Beschreibung': {
        'deutsch': 'Beschreibung',
        'englisch': 'Description',
        'französisch': 'Description',
        'italienisch': 'Descrizione'
      },
      'Jahre': {
        'deutsch': 'Jahre',
        'englisch': 'Years',
        'französisch': 'Années',
        'italienisch': 'Anni'
      },
      'Branchenerfahrungen': {
        'deutsch': 'Branchenerfahrungen',
        'englisch': 'Industry Experience',
        'französisch': 'Expérience sectorielle',
        'italienisch': 'Esperienza settoriale'
      },
      'Position': {
        'deutsch': 'Position',
        'englisch': 'Position',
        'französisch': 'Poste',
        'italienisch': 'Posizione'
      },
      'Start': {
        'deutsch': 'Start',
        'englisch': 'Start',
        'französisch': 'Début',
        'italienisch': 'Inizio'
      },
      'Ende': {
        'deutsch': 'Ende',
        'englisch': 'End',
        'französisch': 'Fin',
        'italienisch': 'Fine'
      },
      'Ausbildung': {
        'deutsch': 'Ausbildung',
        'englisch': 'Education',
        'französisch': 'Formation',
        'italienisch': 'Formazione'
      },
      'Institution': {
        'deutsch': 'Institution',
        'englisch': 'Institution',
        'französisch': 'Institution',
        'italienisch': 'Istituzione'
      },
      'Abschluss': {
        'deutsch': 'Abschluss',
        'englisch': 'Degree',
        'französisch': 'Diplôme',
        'italienisch': 'Diploma'
      },
      'Zertifikate': {
        'deutsch': 'Zertifikate',
        'englisch': 'Certificates',
        'französisch': 'Certificats',
        'italienisch': 'Certificati'
      },
      'Zertifikat': {
        'deutsch': 'Zertifikat',
        'englisch': 'Certificate',
        'französisch': 'Certificat',
        'italienisch': 'Certificato'
      },
      'Jahr': {
        'deutsch': 'Jahr',
        'englisch': 'Year',
        'französisch': 'Année',
        'italienisch': 'Anno'
      },
      'Datum': {
        'deutsch': 'Datum',
        'englisch': 'Date',
        'französisch': 'Date',
        'italienisch': 'Data'
      },
      'Name': {
        'deutsch': 'Name',
        'englisch': 'Name',
        'französisch': 'Nom',
        'italienisch': 'Nome'
      },
      'Aussteller': {
        'deutsch': 'Aussteller',
        'englisch': 'Issuer',
        'französisch': 'Émetteur',
        'italienisch': 'Emittente'
      },
      'Sprachkenntnisse': {
        'deutsch': 'Sprachkenntnisse',
        'englisch': 'Language Skills',
        'französisch': 'Compétences linguistiques',
        'italienisch': 'Competenze linguistiche'
      },
      'Niveau': {
        'deutsch': 'Niveau',
        'englisch': 'Level',
        'französisch': 'Niveau',
        'italienisch': 'Livello'
      },
      'IT-Kenntnisse': {
        'deutsch': 'IT-Kenntnisse',
        'englisch': 'IT Skills',
        'französisch': 'Compétences IT',
        'italienisch': 'Competenze IT'
      },
      'Skill': {
        'deutsch': 'Skill',
        'englisch': 'Skill',
        'französisch': 'Compétence',
        'italienisch': 'Competenza'
      },
      'Weitere Angaben': {
        'deutsch': 'Weitere Angaben',
        'englisch': 'Additional Information',
        'französisch': 'Informations supplémentaires',
        'italienisch': 'Informazioni aggiuntive'
      },
      'Angabe': {
        'deutsch': 'Angabe',
        'englisch': 'Information',
        'französisch': 'Information',
        'italienisch': 'Informazione'
      },
      'Details': {
        'deutsch': 'Details',
        'englisch': 'Details',
        'französisch': 'Détails',
        'italienisch': 'Dettagli'
      },
      'Hobbys': {
        'deutsch': 'Hobbys',
        'englisch': 'Hobbies',
        'französisch': 'Loisirs',
        'italienisch': 'Hobby'
      },
      'Hobby': {
        'deutsch': 'Hobby',
        'englisch': 'Hobby',
        'französisch': 'Loisir',
        'italienisch': 'Hobby'
      },
      'Daten manuell befüllen': {
        'deutsch': 'Daten manuell befüllen',
        'englisch': 'Fill in data manually',
        'französisch': 'Remplir les données manuellement',
        'italienisch': 'Compila i dati manualmente'
      },
      'Stellenbeschreibung': {
        'deutsch': 'Stellenbeschreibung',
        'englisch': 'Job Description',
        'französisch': 'Description du poste',
        'italienisch': 'Descrizione del lavoro'
      },
      'Header': {
        'deutsch': 'Header',
        'englisch': 'Header',
        'französisch': 'En-tête',
        'italienisch': 'Intestazione'
      },
      'Spalte:': {
        'deutsch': 'Spalte:',
        'englisch': 'Column:',
        'französisch': 'Colonne:',
        'italienisch': 'Colonna:'
      },
      'Sichtbarkeit (0-100%):': {
        'deutsch': 'Sichtbarkeit (0-100%):',
        'englisch': 'Visibility (0-100%):',
        'französisch': 'Visibilité (0-100%) :',
        'italienisch': 'Visibilità (0-100%):'
      }
    };

    const translated = translations[label]?.[uiLanguage] || label;
    // Ersetze ß durch ss für Schweizer Benutzer
    if (userCountry === 'CH') {
      return translated.replace(/ß/g, 'ss');
    }
    return translated;
  };

  // Hilfsfunktionen für HEX/RGBA-Konvertierung
  const hexToRgba = (hex: string, alpha: number = 1): string => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!result) return `rgba(248, 246, 242, ${alpha})`;
    const r = parseInt(result[1], 16);
    const g = parseInt(result[2], 16);
    const b = parseInt(result[3], 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  const rgbaToHex = (rgba: string): string => {
    const matches = rgba.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
    if (!matches) return '#f8f6f2';
    const r = parseInt(matches[1]).toString(16).padStart(2, '0');
    const g = parseInt(matches[2]).toString(16).padStart(2, '0');
    const b = parseInt(matches[3]).toString(16).padStart(2, '0');
    return `#${r}${g}${b}`;
  };

  const getAlphaFromRgba = (rgba: string): number => {
    const matches = rgba.match(/rgba?\([\d\s,]+,\s*([\d.]+)\)/);
    return matches ? parseFloat(matches[1]) : 1;
  };

  // Funktion zum Übersetzen von Info-Nachrichten basierend auf currentLanguage (UI-Sprache)
  const getTranslatedInfoMessage = (messageKey: string) => {
    // Konvertiere currentLanguage zu ausgeschriebenem Format für Translations-Lookup
    const languageMap: { [key: string]: string } = {
      'de': 'deutsch',
      'fr': 'französisch',
      'it': 'italienisch',
      'en': 'englisch'
    };
    const uiLanguage = languageMap[currentLanguage] || 'deutsch';
    
    const translations: { [key: string]: { [key: string]: string } } = {
      'upload_cv': {
        'deutsch': 'Laden Sie zuerst Ihre CV hoch oder geben Sie Ihre Daten manuell ein. Hier ist wichtig, dass Ihre Daten möglichst viele Informationen enthalten. Schönschreibung ist nicht relevant.',
        'englisch': 'Please upload your CV first or enter your data manually. It is important that your data contains as much information as possible. Good writing style is not relevant.',
        'französisch': 'Veuillez d\'abord télécharger votre CV ou saisir vos données manuellement. Il est important que vos données contiennent autant d\'informations que possible. Le style d\'écriture n\'est pas pertinent.',
        'italienisch': 'Si prega di caricare prima il CV o inserire i dati manualmente. È importante che i tuoi dati contengano quante più informazioni possibili. Lo stile di scrittura non è rilevante.'
      },
      'open_cv_and_motivation': {
        'deutsch': 'Erfasse deine CV Daten, in dem du deinen aktuell CV hochlädst oder deine Daten manuell eingibst.',
        'englisch': 'Capture your CV data by uploading your current CV or entering your data manually.',
        'französisch': 'Saisissez vos données CV en téléchargeant votre CV actuel ou en saisissant vos données manuellement.',
        'italienisch': 'Cattura i tuoi dati CV caricando il tuo CV attuale o inserendo i tuoi dati manualmente.'
      },
      'open_cv_create_motivation': {
        'deutsch': 'Hier können Sie Ihren CV öffnen und das Motivationsschreiben erstellen. Weiter können Sie hier eine weitere CV Optimierung beginnen.',
        'englisch': 'Here you can open your CV and create your cover letter. You can also start another CV optimization here.',
        'französisch': 'Vous pouvez ouvrir votre CV et créer votre lettre de motivation ici. Vous pouvez également commencer une autre optimisation de CV ici.',
        'italienisch': 'Qui puoi aprire il tuo CV e creare la tua lettera di motivazione. Puoi anche iniziare un\'altra ottimizzazione del CV qui.'
      },
      'match_results': {
        'deutsch': 'Unten sehen Sie die berechnete Passgenauigkeit. Diese sollte mindestens 75% betragen. Weiter sehen Sie eine Liste mit fehlenden Erfahrungen und Schwächen, welche Ihre Daten im Vergleich mit der Stellenbeschreibung aufweisen. Sie können nun Ihre Daten ergänzen oder die CV-Optimierung starten.',
        'englisch': 'Below you can see the calculated match score. This should be at least 75%. You will also see a list of missing experiences and weaknesses that your data has compared to the job description. You can now supplement your data or start the CV optimization.',
        'französisch': 'Vous pouvez voir ci-dessous le score de correspondance calculé. Celui-ci devrait être d\'au moins 75%. Vous verrez également une liste des expériences manquantes et des faiblesses de vos données par rapport à la description du poste. Vous pouvez maintenant compléter vos données ou commencer l\'optimisation du CV.',
        'italienisch': 'Di seguito puoi vedere il punteggio di corrispondenza calcolato. Questo dovrebbe essere almeno del 75%. Vedrai anche un elenco di esperienze mancanti e debolezze che i tuoi dati hanno rispetto alla descrizione del lavoro. Ora puoi integrare i tuoi dati o iniziare l\'ottimizzazione del CV.'
      },
      'enter_job_description': {
        'deutsch': 'Geben Sie eine Stellenbeschreibung ein, um mit der CV-Optimierung zu beginnen.',
        'englisch': 'Enter a job description to start the CV optimization.',
        'französisch': 'Entrez une description de poste pour commencer l\'optimisation du CV.',
        'italienisch': 'Inserisci una descrizione del lavoro per iniziare l\'ottimizzazione del CV.'
      },
      'verify_data': {
        'deutsch': 'Bitte überprüfen Sie Ihre Daten. Sind alle Daten korrekt, bestätigen Sie bitte, dass diese wahrheitsgetreu und vollständig sind. Klicken Sie hierzu auch die Checkbox oberhalb Ihrer Daten.',
        'englisch': 'Please verify your data. If all data is correct, please confirm that it is truthful and complete. To do this, click the checkbox above your data.',
        'französisch': 'Veuillez vérifier vos données. Si toutes les données sont correctes, veuillez confirmer qu\'elles sont exactes et complètes. Pour ce faire, cliquez sur la case à cocher au-dessus de vos données.',
        'italienisch': 'Si prega di verificare i propri dati. Se tutti i dati sono corretti, si prega di confermare che sono veritieri e completi. Per farlo, fare clic sulla casella di controllo sopra i dati.'
      },
      'calculating_match': {
        'deutsch': 'Passgenauigkeit wird berechnet...',
        'englisch': 'Calculating match score...',
        'französisch': 'Calcul du score de correspondance...',
        'italienisch': 'Calcolo del punteggio di corrispondenza...'
      },
      'match_calculated': {
        'deutsch': 'Passgenauigkeit berechnet. Sie können nun Ihr CV optimieren oder ein Motivationsschreiben erstellen.',
        'englisch': 'Match score calculated. You can now optimize your CV or create a cover letter.',
        'französisch': 'Score de correspondance calculé. Vous pouvez maintenant optimiser votre CV ou créer une lettre de motivation.',
        'italienisch': 'Punteggio di corrispondenza calcolato. Ora puoi ottimizzare il tuo CV o creare una lettera di motivazione.'
      },
      'optimizing_cv': {
        'deutsch': 'CV wird optimiert...',
        'englisch': 'Optimizing CV...',
        'französisch': 'Optimisation du CV...',
        'italienisch': 'Ottimizzazione del CV...'
      },
      'optimized_cv_being_created': {
        'deutsch': 'Optimierter CV wird erstellt...',
        'englisch': 'Creating optimized CV...',
        'französisch': 'Création du CV optimisé...',
        'italienisch': 'Creazione del CV ottimizzato...'
      },
      'creating_motivation': {
        'deutsch': 'Motivationsschreiben wird erstellt...',
        'englisch': 'Creating cover letter...',
        'französisch': 'Création de la lettre de motivation...',
        'italienisch': 'Creazione della lettera di motivazione...'
      },
      'loading_cv_preview': {
        'deutsch': 'CV-Vorschau wird geladen...',
        'englisch': 'Loading CV preview...',
        'französisch': 'Chargement de l\'aperçu du CV...',
        'italienisch': 'Caricamento anteprima CV...'
      },
      'upload_cv_data_first': {
        'deutsch': 'Zuerst CV-Daten hochladen',
        'englisch': 'Upload CV data first',
        'französisch': 'Téléchargez d\'abord les données du CV',
        'italienisch': 'Carica prima i dati del CV'
      },
      'motivation_created': {
        'deutsch': 'Motivationsschreiben erstellt. Sie können es nun anzeigen oder bearbeiten.',
        'englisch': 'Cover letter created. You can now view or edit it.',
        'französisch': 'Lettre de motivation créée. Vous pouvez maintenant la visualiser ou la modifier.',
        'italienisch': 'Lettera di motivazione creata. Ora puoi visualizzarla o modificarla.'
      }
    };

    return translations[messageKey]?.[uiLanguage] || '';
  };
  
  // Funktion zum Abrufen der Benutzerrolle
  const fetchUserRole = async (user: any) => {
    if (!user) return;
    
    try {
      setLoadingUserRole(true);
      const idToken = await user.getIdToken();
      
      const response = await fetch(`${config.backend.fullApiUrl}/api/user-role`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${idToken}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        setUserRole(data.role || 'Normal');
        console.log('👤 Benutzerrolle geladen:', data.role);
      } else {
        console.warn('⚠️ Fehler beim Laden der Benutzerrolle, verwende Standard-Rolle');
        setUserRole('Normal');
      }
    } catch (error) {
      console.error('❌ Fehler beim Abrufen der Benutzerrolle:', error);
      setUserRole('Normal');
    } finally {
      setLoadingUserRole(false);
    }
  };
  
  // Debug: Logge Konfiguration beim Start
  React.useEffect(() => {
    config.logUrls();
    console.log('🔧 Frontend erfolgreich gestartet!');
    console.log('🌍 currentLanguage:', currentLanguage);
    
    // Stelle sicher, dass die Übersetzung aktiv ist
    changeLanguage(currentLanguage);
    console.log('✅ Übersetzung aktiviert für:', currentLanguage);
    
    // Aktualisiere targetLanguage für CV-Label-Übersetzungen
    const languageMap: { [key: string]: string } = {
      'de': 'deutsch',
      'fr': 'französisch',
      'it': 'italienisch',
      'en': 'englisch'
    };
    setTargetLanguage(languageMap[currentLanguage] || 'deutsch');
    
    // Checkbox "Daten sind wahheitsgetreu" bleibt standardmäßig auf false
    
    // Markiere App als geladen
    setHasLoaded(true);

  }, []);

  // Lade User-Warnungs-Präferenzen beim App-Start
  React.useEffect(() => {
    if (user) {
      loadUserWarningPreferences();
    }
  }, [user]);


  // Reagiere auf Änderungen von currentLanguage und aktiviere die Übersetzung
  React.useEffect(() => {
    console.log('🔄 currentLanguage geändert:', currentLanguage);
    changeLanguage(currentLanguage);
    
    // Aktualisiere auch targetLanguage
    const languageMap: { [key: string]: string } = {
      'de': 'deutsch',
      'fr': 'französisch',
      'it': 'italienisch',
      'en': 'englisch'
    };
    setTargetLanguage(languageMap[currentLanguage] || 'deutsch');
    console.log('✅ Übersetzung aktiviert und targetLanguage gesetzt:', currentLanguage);
  }, [currentLanguage]);

  // Lade Benutzerrolle wenn sich der Benutzer anmeldet
  React.useEffect(() => {
    if (user) {
      fetchUserRole(user);
      loadUserCvData(user);
      loadCvDesignSettings(user);
      // Sprache wird nicht mehr aus Firebase geladen - i18next verwendet localStorage
    } else {
      setUserRole('Normal');
      setLoadingUserRole(false);
    }
  }, [user]);

  // Funktion zum Laden der CV-Design-Einstellungen aus der cvDesign Collection
  const loadCvDesignSettings = async (user: any) => {
    try {
      const idToken = await user.getIdToken();
      const response = await fetch(`${config.backend.baseUrl}/api/get-cv-design`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${idToken}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        console.log('🎨 CV-Design-Einstellungen geladen:', data);
        
        // Prüfe ob ein Template in den Design-Settings vorhanden ist
        const templateFromDesign = data.designSettings?.selectedTemplate;
        
        if (!data.useDefaults && data.designSettings) {
          // Wende die geladenen Design-Einstellungen an
          console.log('🎨 Wende Design-Einstellungen an:', data.designSettings);
          applyCvDesignSettings(data.designSettings);
          // Stelle sicher, dass das Template gesetzt ist (applyCvDesignSettings setzt es bereits, aber zur Sicherheit nochmal)
          if (templateFromDesign) {
            setSelectedTemplateId(templateFromDesign);
            console.log('✅ Template aus Design-Settings gesetzt:', templateFromDesign);
          }
          // Warte kurz, damit State-Updates verarbeitet werden
          await new Promise(resolve => setTimeout(resolve, 50));
        } else if (templateFromDesign) {
          // Auch wenn useDefaults true ist, setze das Template falls vorhanden
          setSelectedTemplateId(templateFromDesign);
          console.log('✅ Template aus Design-Settings gesetzt (useDefaults):', templateFromDesign);
          // KEINE Standardwerte anwenden - nur Template setzen
          // Die Design-Einstellungen bleiben unverändert
        } else {
          // Kein Template in Design-Settings, nur Template setzen falls vorhanden
          if (templateFromDesign) {
            setSelectedTemplateId(templateFromDesign);
          }
          // KEINE Standardwerte anwenden - Design-Einstellungen bleiben unverändert
        }
      } else {
        console.log('ℹ️ Keine CV-Design-Einstellungen gefunden, Design-Einstellungen bleiben unverändert');
        // KEINE Standardwerte anwenden - Design-Einstellungen bleiben unverändert
      }
    } catch (error) {
      console.error('❌ Fehler beim Laden der CV-Design-Einstellungen:', error);
    }
  };

  // Funktion zum Speichern der CV-Design-Einstellungen in der cvDesign Collection
  const saveCvDesignSettings = async () => {
    if (!user) return;
    
    try {
      const idToken = await user.getIdToken();
      const designSettings = getCurrentCvDesignSettings();
      
      const response = await fetch(`${config.backend.baseUrl}/api/save-cv-design`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${idToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(designSettings)
      });

      if (response.ok) {
        console.log('✅ CV-Design-Einstellungen gespeichert');
      } else {
        console.error('❌ Fehler beim Speichern der CV-Design-Einstellungen');
      }
    } catch (error) {
      console.error('❌ Fehler beim Speichern der CV-Design-Einstellungen:', error);
    }
  };

  // Funktion zum Zurücksetzen der CV-Design-Einstellungen
  const resetCvDesignSettings = async () => {
    if (!user) return;
    
    try {
      const idToken = await user.getIdToken();
      
      const response = await fetch(`${config.backend.baseUrl}/api/reset-cv-design`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${idToken}`
        }
      });

      if (response.ok) {
        console.log('✅ CV-Design-Einstellungen zurückgesetzt');
        // Lade die Design-Einstellungen neu (verwendet dann Defaults)
        loadCvDesignSettings(user);
      } else {
        console.error('❌ Fehler beim Zurücksetzen der CV-Design-Einstellungen');
      }
    } catch (error) {
      console.error('❌ Fehler beim Zurücksetzen der CV-Design-Einstellungen:', error);
    }
  };

  // Funktion zum Laden der CV-Daten des Users
  // HINWEIS: Diese Funktion wurde deaktiviert - CV-Auswahl erfolgt über die Tabelle
  const loadUserCvData = async (user: any) => {
    // Funktion ist jetzt leer - CV-Daten werden über handleSelectCv geladen
    return;
    
    try {
      setIsLoadingFromFirebase(true); // Verhindere Speichern während des Ladens
      
      const idToken = await user.getIdToken();
      const response = await fetch(`${config.backend.userDataUrl}/${user.uid}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${idToken}`
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        console.log('✅ CV-Daten geladen (Checkbox-Status wird von fetchCv gesetzt)');
      } else {
        console.log('⚠️ Fehler beim Laden der CV-Daten');
      }
      
      // Setze nur die Initialisierung, nicht den Checkbox-Status
      setTimeout(() => {
        setHasInitialized(true);
        setIsLoadingFromFirebase(false); // Erlaube wieder Speichern
        console.log('🏁 CV-Daten-Initialisierung abgeschlossen');
      }, 100);
      
    } catch (error) {
      console.error('❌ Fehler beim Laden der CV-Daten:', error);
      // Bei Fehler: Setze nur die Initialisierung
      setTimeout(() => {
        setHasInitialized(true);
        setIsLoadingFromFirebase(false);
        console.log('⚠️ Fehler beim Laden, Initialisierung abgeschlossen');
      }, 100);
    }
  };

  // Hilfsfunktion um zu überprüfen, ob der Benutzer Admin ist
  const isAdmin = () => {
    return userRole === 'Admin';
  };

  // User Menu Handlers
  const handleUserMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setUserMenuAnchorEl(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setUserMenuAnchorEl(null);
  };

  // CV Settings Menu Handler
  const handleCvSettingsMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setCvSettingsMenuAnchorEl(event.currentTarget);
  };

  const handleCvSettingsMenuClose = () => {
    setCvSettingsMenuAnchorEl(null);
  };

  // Funktion zum Sammeln der aktuellen CV-Design-Einstellungen für die cvDesign Collection
  const getCurrentCvDesignSettings = () => {
    return {
      // Farben - speichere RGBA-Werte mit Alpha-Kanal
      leftColumnColor: hexToRgba(leftColumnColor, leftColumnAlpha),
      nameTextColor,
      leftColumnTextColor,
      rightColumnTextColor,
      leftColumnTitleColor,
      rightColumnTitleColor,
      
      // Sichtbarkeits-Einstellungen
      showCoreCompetenciesInCv,
      showCertificationsInCv,
      showItSkillsInCv,
      showIndustriesInCv,
      showLanguagesInCv,
      showHobbiesInCv,
      showEducationInCv,
      showWorkExperienceInCv,
      showProfileInCv,
      showAdditionalInfoInCv,
      showProfileImageInCv,
      
      // Profilbild-Einstellungen
      profileImageBorderRadius,
      profileImageSize,
      profileImageWidth,
      profileImagePosition,
      profileImageAlignment,
      profileImageBorder,
      profileImageBorderColor,
      profileImageBorderThickness,
      
      // Namensgröße
      nameFontSize,
      
      // Kontakt-Display-Mode
      contactDisplayMode,
      
      // Header-Box-Einstellungen - speichere RGBA-Werte mit Alpha-Kanal
      topBoxColor: hexToRgba(topBoxColor, topBoxAlpha),
      topBoxAlpha: topBoxAlpha, // Speichere Alpha-Wert separat für korrektes Laden
      topBoxImage,
      
      // Linke Spalte Bild
      leftColumnImage,
      
      // Template-Name
      templateName: selectedTemplateId === 'template1' ? getTranslatedCvLabel('Modern') : 
                   selectedTemplateId === 'template2' ? getTranslatedCvLabel('Professional') : getTranslatedCvLabel('Classic'),
      
      // Template-ID
      selectedTemplate: selectedTemplateId,
      
      // Metadaten
      lastUpdated: new Date().toISOString(),
      version: '2.0.0'
    };
  };

  // Funktion zum Anwenden der CV-Design-Einstellungen aus der cvDesign Collection
  const applyCvDesignSettings = (designSettings: any) => {
    // Lade die Standard-Template-Einstellungen für das aktuelle Template
    const templateId = designSettings.selectedTemplate || selectedTemplateId;
    const isProfessional = templateId === 'template2';
    
    // Farben anwenden (mit Template-spezifischen Defaults)
    // Konvertiere RGBA zurück zu HEX und extrahiere Alpha
    const leftColumnColorValue = designSettings.leftColumnColor || (isProfessional ? '#2e2e2e' : '#f8f6f2');
    if (leftColumnColorValue.startsWith('rgba')) {
      setLeftColumnColor(rgbaToHex(leftColumnColorValue));
      setLeftColumnAlpha(getAlphaFromRgba(leftColumnColorValue));
    } else {
      setLeftColumnColor(leftColumnColorValue);
      setLeftColumnAlpha(1);
    }
    
    const topBoxColorValue = designSettings.topBoxColor || (isProfessional ? '#2e2e2e' : '#f8f6f2');
    if (topBoxColorValue.startsWith('rgba')) {
      // RGBA-Wert: Extrahiere Farbe und verwende separaten Alpha-Wert falls vorhanden
      setTopBoxColor(rgbaToHex(topBoxColorValue));
      // Verwende IMMER den separaten topBoxAlpha, falls vorhanden (genauer als aus RGBA-String)
      if (designSettings.topBoxAlpha !== undefined) {
        setTopBoxAlpha(designSettings.topBoxAlpha);
      } else {
        // Fallback: Extrahiere Alpha aus RGBA-String
        setTopBoxAlpha(getAlphaFromRgba(topBoxColorValue));
      }
    } else {
      // HEX-Wert: Setze Farbe und verwende Alpha-Wert aus Design-Settings falls vorhanden
      setTopBoxColor(topBoxColorValue);
      // Wenn eine explizite Header-Farbe gesetzt wurde, prüfe ob Alpha-Wert in Design-Settings vorhanden ist
      if (designSettings.topBoxColor) {
        // Wenn topBoxAlpha explizit in Design-Settings vorhanden ist, verwende diesen
        // Ansonsten verwende 1 (sichtbar) wenn eine Farbe gesetzt wurde
        if (designSettings.topBoxAlpha !== undefined) {
          setTopBoxAlpha(designSettings.topBoxAlpha);
        } else {
          // Prüfe ob die Farbe aus RGBA kommt (könnte als HEX gespeichert worden sein)
          // Wenn ja, extrahiere Alpha, ansonsten verwende 1
          setTopBoxAlpha(1); // Header-Farbe ist gesetzt, standardmäßig sichtbar
        }
      } else {
        setTopBoxAlpha(0); // Default: 100% transparent
      }
    }
    setTopBoxImage(designSettings.topBoxImage || ''); // Header-Box-Bild aus Settings
    setLeftColumnImage(designSettings.leftColumnImage || ''); // Linke Spalte Bild aus Settings
    setNameTextColor(designSettings.nameTextColor || '#333333');
    setLeftColumnTextColor(designSettings.leftColumnTextColor || (isProfessional ? '#ffffff' : '#333333'));
    setRightColumnTextColor(designSettings.rightColumnTextColor || '#333333');
    setLeftColumnTitleColor(designSettings.leftColumnTitleColor || (isProfessional ? '#ffffff' : '#333333'));
    setRightColumnTitleColor(designSettings.rightColumnTitleColor || '#333333');
    
    // Temporäre Farben auch setzen
    setTempNameTextColor(designSettings.nameTextColor || '#333333');
    setTempLeftColumnTextColor(designSettings.leftColumnTextColor || (isProfessional ? '#ffffff' : '#333333'));
    setTempRightColumnTextColor(designSettings.rightColumnTextColor || '#333333');
    setTempLeftColumnTitleColor(designSettings.leftColumnTitleColor || (isProfessional ? '#ffffff' : '#333333'));
    setTempRightColumnTitleColor(designSettings.rightColumnTitleColor || '#333333');
    // setTempLeftColumnColor entfernt - wird direkt über leftColumnColor gesteuert
    
    // Sichtbarkeits-Einstellungen anwenden
    if (typeof designSettings.showCoreCompetenciesInCv === 'boolean') setShowCoreCompetenciesInCv(designSettings.showCoreCompetenciesInCv);
    if (typeof designSettings.showCertificationsInCv === 'boolean') setShowCertificationsInCv(designSettings.showCertificationsInCv);
    if (typeof designSettings.showItSkillsInCv === 'boolean') setShowItSkillsInCv(designSettings.showItSkillsInCv);
    if (typeof designSettings.showIndustriesInCv === 'boolean') setShowIndustriesInCv(designSettings.showIndustriesInCv);
    if (typeof designSettings.showLanguagesInCv === 'boolean') setShowLanguagesInCv(designSettings.showLanguagesInCv);
    if (typeof designSettings.showHobbiesInCv === 'boolean') setShowHobbiesInCv(designSettings.showHobbiesInCv);
    if (typeof designSettings.showEducationInCv === 'boolean') setShowEducationInCv(designSettings.showEducationInCv);
    if (typeof designSettings.showWorkExperienceInCv === 'boolean') setShowWorkExperienceInCv(designSettings.showWorkExperienceInCv);
    if (typeof designSettings.showProfileInCv === 'boolean') setShowProfileInCv(designSettings.showProfileInCv);
    if (typeof designSettings.showAdditionalInfoInCv === 'boolean') setShowAdditionalInfoInCv(designSettings.showAdditionalInfoInCv);
    if (typeof designSettings.showProfileImageInCv === 'boolean') setShowProfileImageInCv(designSettings.showProfileImageInCv);
    
    // Profilbild-Einstellungen anwenden (mit Template-spezifischen Defaults)
    setProfileImageBorderRadius(designSettings.profileImageBorderRadius !== undefined ? designSettings.profileImageBorderRadius : (isProfessional ? 0 : 50));
    setProfileImageSize(designSettings.profileImageSize || 'M');
    setProfileImageWidth(designSettings.profileImageWidth || 100);
    setProfileImagePosition(designSettings.profileImagePosition || { x: 50, y: 50 });
    setProfileImageAlignment(designSettings.profileImageAlignment || (isProfessional ? 'left' : 'center'));
    if (typeof designSettings.profileImageBorder === 'boolean') setProfileImageBorder(designSettings.profileImageBorder);
    if (designSettings.profileImageBorderColor) setProfileImageBorderColor(designSettings.profileImageBorderColor);
    if (designSettings.profileImageBorderThickness) setProfileImageBorderThickness(designSettings.profileImageBorderThickness);
    
    // Namensgröße anwenden
    setNameFontSize(designSettings.nameFontSize || 36);
    
    // Kontakt-Display-Mode anwenden
    setContactDisplayMode(designSettings.contactDisplayMode || 'text');
    
    // Template-ID anwenden
    if (designSettings.selectedTemplate) {
      setSelectedTemplateId(designSettings.selectedTemplate);
      console.log('✅ Template-ID gesetzt:', designSettings.selectedTemplate);
    }
    
    console.log('✅ CV-Design-Einstellungen angewendet:', designSettings);
    console.log('✅ Angewendete Werte - selectedTemplateId wird sein:', designSettings.selectedTemplate || selectedTemplateId);
    console.log('✅ Angewendete Werte - leftColumnColor wird sein:', leftColumnColorValue);
    console.log('✅ Angewendete Werte - topBoxColor wird sein:', topBoxColorValue);
    console.log('✅ Angewendete Werte - nameTextColor wird sein:', designSettings.nameTextColor || '#333333');
  };

  // Funktion zum Sammeln aller aktuellen CV-Settings für das aktuelle Template
  const getCurrentCvSettings = (): CvSettings => {
    const currentTemplateSettings: CvDesignSettings = {
      // Farben - konvertiere zu RGBA mit Alpha-Wert
      leftColumnColor: hexToRgba(leftColumnColor, leftColumnAlpha),
      nameTextColor,
      leftColumnTextColor,
      rightColumnTextColor,
      leftColumnTitleColor,
      rightColumnTitleColor,
      
      // Sichtbarkeits-Einstellungen
      showCoreCompetenciesInCv,
      showCertificationsInCv,
      showItSkillsInCv,
      showIndustriesInCv,
      showLanguagesInCv,
      showHobbiesInCv,
      showEducationInCv,
      showWorkExperienceInCv,
      showProfileInCv,
      showAdditionalInfoInCv,
      showProfileImageInCv,
      
      // Profilbild-Einstellungen
      profileImageBorderRadius,
      profileImageSize,
      profileImageWidth,
      profileImagePosition,
      profileImageAlignment,
      profileImageBorder,
      profileImageBorderColor,
      profileImageBorderThickness,
      
      // Namensgröße
      nameFontSize,
      
      // Kontakt-Display-Mode
      contactDisplayMode,
      
      // Header-Box-Einstellungen - konvertiere zu RGBA mit Alpha-Wert
      topBoxColor: hexToRgba(topBoxColor, topBoxAlpha),
      topBoxAlpha: topBoxAlpha, // Speichere Alpha-Wert separat für korrektes Laden
      topBoxImage,
      
      // Linke Spalte Bild
      leftColumnImage,
      
      // Template-Name
      templateName: selectedTemplateId === 'template1' ? getTranslatedCvLabel('Modern') : 
                   selectedTemplateId === 'template2' ? getTranslatedCvLabel('Professional') : getTranslatedCvLabel('Classic')
    };

    return {
      ...cvSettings,
      [selectedTemplateId]: currentTemplateSettings,
      selectedTemplate: selectedTemplateId,
      lastUpdated: new Date().toISOString(),
      version: '2.0.0'
    };
  };

  // Funktion zum Anwenden von CV-Settings für das aktuelle Template
  const applyCvSettings = (settings: CvSettings, preserveTemplate: boolean = false) => {
    // Wenn preserveTemplate true ist, überschreibe KEINE Design-Einstellungen
    // Die Design-Einstellungen wurden bereits von applyCvDesignSettings gesetzt
    // und sollen erhalten bleiben. Nur die CV-Settings-Struktur wird aktualisiert.
    if (preserveTemplate) {
      console.log('ℹ️ preserveTemplate=true: Design-Einstellungen werden nicht überschrieben');
      // Aktualisiere nur die CV-Settings-Struktur, ohne Design-Einstellungen zu ändern
      setCvSettings(settings);
      return;
    }
    
    // Aktuelles Template aus den Settings laden
    const templateToUse = settings.selectedTemplate;
    const currentTemplate = settings[templateToUse];
    
    // Farben anwenden - konvertiere RGBA zurück zu HEX und extrahiere Alpha
    const leftColColor = currentTemplate.leftColumnColor || '#f8f6f2';
    if (leftColColor.startsWith('rgba')) {
      setLeftColumnColor(rgbaToHex(leftColColor));
      setLeftColumnAlpha(getAlphaFromRgba(leftColColor));
    } else {
      setLeftColumnColor(leftColColor);
      setLeftColumnAlpha(1);
    }
    
    // Header-Farbe setzen
    const topBoxCol = currentTemplate.topBoxColor || '#f8f6f2';
    if (topBoxCol.startsWith('rgba')) {
      setTopBoxColor(rgbaToHex(topBoxCol));
      // Verwende IMMER den separaten topBoxAlpha, falls vorhanden (genauer als aus RGBA-String)
      if (currentTemplate.topBoxAlpha !== undefined) {
        setTopBoxAlpha(currentTemplate.topBoxAlpha);
      } else {
        // Fallback: Extrahiere Alpha aus RGBA-String
        setTopBoxAlpha(getAlphaFromRgba(topBoxCol));
      }
    } else {
      setTopBoxColor(topBoxCol);
      // Wenn topBoxAlpha explizit in Settings vorhanden ist, verwende diesen
      if (currentTemplate.topBoxAlpha !== undefined) {
        setTopBoxAlpha(currentTemplate.topBoxAlpha);
      } else {
        setTopBoxAlpha(0); // Default: 100% transparent
      }
    }
    
    // Header-Einstellungen setzen
    setTopBoxImage(currentTemplate.topBoxImage || ''); // Header-Box-Bild aus Settings
    setLeftColumnImage(currentTemplate.leftColumnImage || ''); // Linke Spalte Bild aus Settings
    // setTempLeftColumnColor entfernt - wird direkt über leftColumnColor gesteuert
    setNameTextColor(currentTemplate.nameTextColor);
    setLeftColumnTextColor(currentTemplate.leftColumnTextColor);
    setRightColumnTextColor(currentTemplate.rightColumnTextColor);
    setLeftColumnTitleColor(currentTemplate.leftColumnTitleColor);
    setRightColumnTitleColor(currentTemplate.rightColumnTitleColor);
    setTempNameTextColor(currentTemplate.nameTextColor);
    setTempLeftColumnTextColor(currentTemplate.leftColumnTextColor);
    setTempRightColumnTextColor(currentTemplate.rightColumnTextColor);
    setTempLeftColumnTitleColor(currentTemplate.leftColumnTitleColor);
    setTempRightColumnTitleColor(currentTemplate.rightColumnTitleColor);
    
    // Sichtbarkeits-Einstellungen anwenden
    setShowCoreCompetenciesInCv(currentTemplate.showCoreCompetenciesInCv);
    setShowCertificationsInCv(currentTemplate.showCertificationsInCv);
    setShowItSkillsInCv(currentTemplate.showItSkillsInCv);
    setShowIndustriesInCv(currentTemplate.showIndustriesInCv);
    setShowLanguagesInCv(currentTemplate.showLanguagesInCv);
    setShowHobbiesInCv(currentTemplate.showHobbiesInCv);
    setShowEducationInCv(currentTemplate.showEducationInCv);
    setShowWorkExperienceInCv(currentTemplate.showWorkExperienceInCv);
    setShowProfileInCv(currentTemplate.showProfileInCv);
    setShowAdditionalInfoInCv(currentTemplate.showAdditionalInfoInCv);
    setShowProfileImageInCv(currentTemplate.showProfileImageInCv);
    
    // Profilbild-Einstellungen anwenden
    setProfileImageBorderRadius(currentTemplate.profileImageBorderRadius);
    setProfileImageSize(currentTemplate.profileImageSize);
    setProfileImageWidth(currentTemplate.profileImageWidth);
    setProfileImagePosition(currentTemplate.profileImagePosition);
    setProfileImageAlignment(currentTemplate.profileImageAlignment);
    setProfileImageBorder(currentTemplate.profileImageBorder || false);
    setProfileImageBorderColor(currentTemplate.profileImageBorderColor || '#333333');
    setProfileImageBorderThickness(currentTemplate.profileImageBorderThickness || 2);
    
    // Namensgröße anwenden
    setNameFontSize(currentTemplate.nameFontSize);
    
    // Kontakt-Display-Mode anwenden
    setContactDisplayMode(currentTemplate.contactDisplayMode);
    
    // Template-Settings und ausgewähltes Template aktualisieren
    setCvSettings(settings);
    setSelectedTemplateId(settings.selectedTemplate);
  };

  // Handler für das Öffnen des CV-Templates mit Auto-Load der Settings
  // Funktion zum Erstellen einer Bewerbung beim Öffnen der CV-Preview
  // Optional: designSettings können übergeben werden, um sicherzustellen, dass die korrekten Einstellungen verwendet werden
  const createApplicationFromCvPreview = async (designSettingsOverride?: any) => {
    if (!user) return null;
    
    try {
      console.log('📝 Erstelle neue Bewerbung beim Öffnen der CV-Preview...');
      const token = await user.getIdToken();
      
      // Sammle alle CV-Preview-Daten (alle Daten, die in der CV-Preview angezeigt werden)
      // Übergebe die Design-Einstellungen direkt, damit sie verwendet werden, auch wenn State-Updates noch nicht verarbeitet wurden
      const cvPreviewData = getCvDataForTemplate(designSettingsOverride);
      
      // Debug: Zeige die Design-Settings, die gespeichert werden
      console.log('💾 Design-Settings die in Application gespeichert werden:', cvPreviewData.designSettings);
      console.log('💾 Design-Settings Keys:', cvPreviewData.designSettings ? Object.keys(cvPreviewData.designSettings) : 'keine');
      
      const response = await fetch(`${config.backend.baseUrl}/api/create-application-from-cv`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          cvName: fullName || 'CV',
          cvId: selectedCvId || null,
          jobInfo: extractedJobInfo || null,
          jobDescription: jobDescription || '',
          matchScore: matchScore || null,
          cvPreviewData: cvPreviewData // Alle CV-Preview-Daten mit speichern
        })
      });

      if (response.ok) {
        const result = await response.json();
        const applicationId = result.applicationId;
        setSelectedApplicationId(applicationId);
        setSelectedApplication(null); // Reset: Verhindere, dass alte Bewerbung überschrieben wird
        console.log('✅ Neue Bewerbung erstellt beim Öffnen der CV-Preview:', applicationId);
        
        // Aktualisiere die Anwendungsliste
        const token2 = await user.getIdToken();
        const verifyResponse = await fetch(`${config.backend.baseUrl}/api/get-job-descriptions`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token2}`,
            'Content-Type': 'application/json'
          }
        });
        
        if (verifyResponse.ok) {
          const data = await verifyResponse.json();
          setApplications(data.applications || []);
        }
        
        return applicationId;
      } else {
        const errorText = await response.text();
        console.error('❌ Fehler beim Erstellen der Bewerbung:', response.status, errorText);
        return null;
      }
    } catch (error) {
      console.error('❌ Fehler beim Erstellen der Bewerbung:', error);
      return null;
    }
  };

  // Gemeinsame Funktion zum Laden der Design-Einstellungen aus Firebase
  // Gibt die geladenen Design-Einstellungen zurück, damit sie direkt verwendet werden können
  const loadCvDesignSettingsForPreview = async (): Promise<any | null> => {
    // Lade CV-Design-Settings aus Firebase (inkl. zuletzt verwendetem Template, Header-Farbe, Grafiken, etc.)
    if (!user) return null;
    
    try {
      const idToken = await user.getIdToken();
      const response = await fetch(`${config.backend.baseUrl}/api/get-cv-design`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${idToken}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        console.log('🎨 CV-Design-Einstellungen geladen:', data);
        console.log('🎨 useDefaults:', data.useDefaults);
        
        // Die Design-Settings können direkt in data sein oder in data.designSettings
        // Prüfe beide Möglichkeiten
        const designSettings = data.designSettings || data;
        console.log('🎨 designSettings vorhanden:', !!designSettings);
        if (designSettings) {
          console.log('🎨 designSettings Keys:', Object.keys(designSettings));
          console.log('🎨 designSettings selectedTemplate:', designSettings.selectedTemplate);
          console.log('🎨 designSettings leftColumnColor:', designSettings.leftColumnColor);
          console.log('🎨 designSettings topBoxColor:', designSettings.topBoxColor);
        }
        
        // Prüfe ob ein Template in den Design-Settings vorhanden ist
        const templateFromDesign = designSettings?.selectedTemplate || designSettings?.selectedTemplateId;
        const templateId = templateFromDesign || selectedTemplateId || 'template1';
        const isProfessional = templateId === 'template2';
        
        // Wenn useDefaults nicht true ist und Design-Settings vorhanden sind
        if (!data.useDefaults && designSettings && (designSettings.selectedTemplate || designSettings.leftColumnColor || designSettings.nameTextColor)) {
          // Wende die geladenen Design-Einstellungen an
          console.log('🎨 Wende Design-Einstellungen an:', designSettings);
          applyCvDesignSettings(designSettings);
          // Stelle sicher, dass das Template gesetzt ist
          if (templateFromDesign) {
            setSelectedTemplateId(templateFromDesign);
            console.log('✅ Template aus Design-Settings gesetzt:', templateFromDesign);
          }
          
          // Erstelle vollständige, normalisierte Design-Einstellungen mit allen erforderlichen Feldern
          // Dies stellt sicher, dass auch nach App-Start alle Felder vorhanden sind
          const normalizedSettings = {
            // Template-Informationen
            selectedTemplate: templateId,
            selectedTemplateId: templateId,
            templateName: templateId === 'template1' ? getTranslatedCvLabel('Modern') : 
                         templateId === 'template2' ? getTranslatedCvLabel('Professional') : getTranslatedCvLabel('Classic'),
            
            // Farben - verwende geladene Werte oder Template-spezifische Defaults
            leftColumnColor: designSettings.leftColumnColor || (isProfessional ? 'rgba(46,46,46,1)' : 'rgba(248,246,242,1)'),
            nameTextColor: designSettings.nameTextColor || '#333333',
            leftColumnTextColor: designSettings.leftColumnTextColor || (isProfessional ? '#ffffff' : '#333333'),
            rightColumnTextColor: designSettings.rightColumnTextColor || '#333333',
            leftColumnTitleColor: designSettings.leftColumnTitleColor || (isProfessional ? '#ffffff' : '#333333'),
            rightColumnTitleColor: designSettings.rightColumnTitleColor || '#333333',
            
            // Header-Box-Einstellungen
            topBoxColor: designSettings.topBoxColor || (isProfessional ? 'rgba(46,46,46,1)' : 'rgba(248,246,242,1)'),
            topBoxAlpha: designSettings.topBoxAlpha !== undefined ? designSettings.topBoxAlpha : 0,
            topBoxImage: designSettings.topBoxImage || '',
            
            // Linke Spalte Bild
            leftColumnImage: designSettings.leftColumnImage || '',
            
            // Sichtbarkeits-Einstellungen - verwende geladene Werte oder Defaults (true)
            showCoreCompetenciesInCv: designSettings.showCoreCompetenciesInCv !== undefined ? designSettings.showCoreCompetenciesInCv : true,
            showCertificationsInCv: designSettings.showCertificationsInCv !== undefined ? designSettings.showCertificationsInCv : true,
            showItSkillsInCv: designSettings.showItSkillsInCv !== undefined ? designSettings.showItSkillsInCv : true,
            showIndustriesInCv: designSettings.showIndustriesInCv !== undefined ? designSettings.showIndustriesInCv : true,
            showLanguagesInCv: designSettings.showLanguagesInCv !== undefined ? designSettings.showLanguagesInCv : true,
            showHobbiesInCv: designSettings.showHobbiesInCv !== undefined ? designSettings.showHobbiesInCv : true,
            showEducationInCv: designSettings.showEducationInCv !== undefined ? designSettings.showEducationInCv : true,
            showWorkExperienceInCv: designSettings.showWorkExperienceInCv !== undefined ? designSettings.showWorkExperienceInCv : true,
            showProfileInCv: designSettings.showProfileInCv !== undefined ? designSettings.showProfileInCv : true,
            showAdditionalInfoInCv: designSettings.showAdditionalInfoInCv !== undefined ? designSettings.showAdditionalInfoInCv : true,
            showProfileImageInCv: designSettings.showProfileImageInCv !== undefined ? designSettings.showProfileImageInCv : true,
            
            // Profilbild-Einstellungen
            profileImageBorderRadius: designSettings.profileImageBorderRadius !== undefined ? designSettings.profileImageBorderRadius : (isProfessional ? 0 : 50),
            profileImageSize: designSettings.profileImageSize || 'M',
            profileImageWidth: designSettings.profileImageWidth || 100,
            profileImagePosition: designSettings.profileImagePosition || { x: 50, y: 50 },
            profileImageAlignment: designSettings.profileImageAlignment || (isProfessional ? 'left' : 'center'),
            profileImageBorder: designSettings.profileImageBorder !== undefined ? designSettings.profileImageBorder : false,
            profileImageBorderColor: designSettings.profileImageBorderColor || '#333333',
            profileImageBorderThickness: designSettings.profileImageBorderThickness || 2,
            
            // Namensgröße
            nameFontSize: designSettings.nameFontSize || 36,
            
            // Kontakt-Display-Mode
            contactDisplayMode: designSettings.contactDisplayMode || 'text',
            
            // Metadaten
            lastUpdated: designSettings.lastUpdated || new Date().toISOString(),
            version: designSettings.version || '2.0.0'
          };
          
          console.log('✅ Vollständige, normalisierte Design-Einstellungen erstellt:', normalizedSettings);
          console.log('✅ Normalisierte Settings Keys:', Object.keys(normalizedSettings));
          console.log('✅ Normalisierte Settings selectedTemplate:', normalizedSettings.selectedTemplate);
          console.log('✅ Normalisierte Settings leftColumnColor:', normalizedSettings.leftColumnColor);
          console.log('✅ Normalisierte Settings topBoxColor:', normalizedSettings.topBoxColor);
          return normalizedSettings;
        } else if (templateFromDesign) {
          // Auch wenn useDefaults true ist, setze das Template falls vorhanden
          setSelectedTemplateId(templateFromDesign);
          console.log('✅ Template aus Design-Settings gesetzt (useDefaults):', templateFromDesign);
          // Erstelle normalisierte Settings auch für useDefaults-Fall
          const normalizedSettings = {
            selectedTemplate: templateFromDesign,
            selectedTemplateId: templateFromDesign,
            templateName: templateFromDesign === 'template1' ? getTranslatedCvLabel('Modern') : 
                         templateFromDesign === 'template2' ? getTranslatedCvLabel('Professional') : getTranslatedCvLabel('Classic'),
            ...(designSettings || {})
          };
          return normalizedSettings;
        } else {
          // Kein Template in Design-Settings
          if (templateFromDesign) {
            setSelectedTemplateId(templateFromDesign);
          }
          return null;
        }
      } else {
        console.log('ℹ️ Keine CV-Design-Einstellungen gefunden');
        return null;
      }
    } catch (error) {
      console.error('❌ Fehler beim Laden der CV-Design-Einstellungen:', error);
      return null;
    }
  };

  // Funktion zum Laden der CV-Daten aus einer Application und Öffnen des CV-Preview Modals
  const handleOpenCvPreviewFromApplication = async (applicationId: string) => {
    if (!user || !applicationId) return;
    
    // Schließe das Modal, damit die Animation im Hauptfenster sichtbar ist
    setShowApplicationDetailsModal(false);
    
    // Starte Warte-Animation
    setLoadingCvPreview(true);
    
    try {
      // Lade CV-Preview-Daten aus der Application
      const idToken = await user.getIdToken();
      const response = await fetch(`${config.backend.baseUrl}/api/get-application-cv-preview-data/${applicationId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${idToken}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error('❌ Fehler beim Laden der CV-Daten:', errorData);
        setError('Fehler beim Laden der CV-Daten: ' + (errorData.error || 'Unbekannter Fehler'));
        return;
      }
      
      const data = await response.json();
      const cvPreviewData = data.cvPreviewData;
      
      if (!cvPreviewData) {
        setError('Keine CV-Daten in der Bewerbung gefunden');
        return;
      }
      
      // Setze selectedApplicationId
      setSelectedApplicationId(applicationId);
      
      // Lade CV-Daten in State-Variablen
      // WICHTIG: optimizedShortProfile hat Priorität über personalInfo.shortProfile (für Share-Link-Änderungen)
      if (cvPreviewData.optimizedShortProfile !== undefined) {
        setOptimizedShortProfile(cvPreviewData.optimizedShortProfile);
      } else if (cvPreviewData.personalInfo?.shortProfile !== undefined) {
        setOptimizedShortProfile(cvPreviewData.personalInfo.shortProfile);
      }
      
      if (cvPreviewData.personalInfo) {
        const pi = cvPreviewData.personalInfo;
        if (pi.fullName) setOptimizedFullName(pi.fullName);
        if (pi.email) setOptimizedEmail(pi.email);
        if (pi.phoneNumber) setOptimizedPhoneNumber(pi.phoneNumber);
        if (pi.address) setOptimizedAddress(pi.address);
        if (pi.postalCode) setOptimizedPostalCode(pi.postalCode);
        if (pi.city) setOptimizedCity(pi.city);
        if (pi.birthYear) setBirthYear(pi.birthYear);
        if (pi.nationality) setNationality(pi.nationality);
        if (pi.maritalStatus) setCivilStatus(pi.maritalStatus);
        if (pi.availableFrom) setAvailableFrom(pi.availableFrom);
      }
      
      // Lade IT-Skills
      if (cvPreviewData.relevantItSkills && Array.isArray(cvPreviewData.relevantItSkills)) {
        setRelevantItSkills(cvPreviewData.relevantItSkills);
      } else if (cvPreviewData.itSkills && Array.isArray(cvPreviewData.itSkills)) {
        setRelevantItSkills(cvPreviewData.itSkills);
      }
      
      // Lade Berufserfahrungen
      if (cvPreviewData.optimizedWorkExperiences && Array.isArray(cvPreviewData.optimizedWorkExperiences)) {
        // Setze optimizedWorkExperiences (wird vom Template verwendet)
        setOptimizedWorkExperiences(cvPreviewData.optimizedWorkExperiences);
        // Filtere relevante Berufserfahrungen (relevant: true)
        const relevant = cvPreviewData.optimizedWorkExperiences.filter((exp: any) => 
          exp.relevant === true || exp.relevant === 'true'
        );
        setRelevantWorkExperiences(relevant.length > 0 ? relevant : cvPreviewData.optimizedWorkExperiences);
      } else if (cvPreviewData.workExperience && Array.isArray(cvPreviewData.workExperience)) {
        // Wenn keine optimizedWorkExperiences, verwende workExperience
        setRelevantWorkExperiences(cvPreviewData.workExperience);
        // Setze auch optimizedWorkExperiences auf workExperience (mit relevant: true)
        const withRelevant = cvPreviewData.workExperience.map((exp: any) => ({
          ...exp,
          relevant: true
        }));
        setOptimizedWorkExperiences(withRelevant);
      }
      
      // Lade Ausbildungen
      if (cvPreviewData.relevantEducations && Array.isArray(cvPreviewData.relevantEducations)) {
        setRelevantEducations(cvPreviewData.relevantEducations);
      } else if (cvPreviewData.educations && Array.isArray(cvPreviewData.educations)) {
        setRelevantEducations(cvPreviewData.educations);
      }
      
      // Lade Zertifizierungen
      // WICHTIG: relevantCertifications hat Priorität (für Share-Link-Änderungen)
      if (cvPreviewData.relevantCertifications && Array.isArray(cvPreviewData.relevantCertifications)) {
        setRelevantCertifications(cvPreviewData.relevantCertifications);
      } else if (cvPreviewData.certifications && Array.isArray(cvPreviewData.certifications)) {
        setRelevantCertifications(cvPreviewData.certifications);
      }
      
      // Lade Sprachen
      if (cvPreviewData.relevantLanguages && Array.isArray(cvPreviewData.relevantLanguages)) {
        setRelevantLanguages(cvPreviewData.relevantLanguages);
      } else if (cvPreviewData.languages && Array.isArray(cvPreviewData.languages)) {
        setRelevantLanguages(cvPreviewData.languages);
      }
      
      // Lade Kernkompetenzen
      // WICHTIG: relevantCoreCompetencies hat Priorität (für Share-Link-Änderungen)
      if (cvPreviewData.relevantCoreCompetencies && Array.isArray(cvPreviewData.relevantCoreCompetencies)) {
        setRelevantCoreCompetencies(cvPreviewData.relevantCoreCompetencies);
      } else if (cvPreviewData.coreCompetencies && Array.isArray(cvPreviewData.coreCompetencies)) {
        setRelevantCoreCompetencies(cvPreviewData.coreCompetencies);
      }
      
      // Lade Branchen
      if (cvPreviewData.relevantIndustries && Array.isArray(cvPreviewData.relevantIndustries)) {
        setRelevantIndustries(cvPreviewData.relevantIndustries);
      } else if (cvPreviewData.industryExperiences && Array.isArray(cvPreviewData.industryExperiences)) {
        setRelevantIndustries(cvPreviewData.industryExperiences);
      }
      
      // Lade Hobbys
      if (cvPreviewData.relevantHobbies && Array.isArray(cvPreviewData.relevantHobbies)) {
        setRelevantHobbies(cvPreviewData.relevantHobbies);
      } else if (cvPreviewData.hobbies && Array.isArray(cvPreviewData.hobbies)) {
        setRelevantHobbies(cvPreviewData.hobbies);
      }
      
      // Lade weitere Informationen
      if (cvPreviewData.relevantAdditionalInfo && Array.isArray(cvPreviewData.relevantAdditionalInfo)) {
        setRelevantAdditionalInfo(cvPreviewData.relevantAdditionalInfo);
      } else if (cvPreviewData.additionalInfo && Array.isArray(cvPreviewData.additionalInfo)) {
        setRelevantAdditionalInfo(cvPreviewData.additionalInfo);
      }
      
      // Lade Profilbild und Signatur
      if (cvPreviewData.profileImage) {
        setProfileImage(cvPreviewData.profileImage);
      }
      if (cvPreviewData.signature) {
        setSignature(cvPreviewData.signature);
      }
      
      // Lade CV-Design-Settings aus Firebase (gemeinsame Funktion)
      await loadCvDesignSettingsForPreview();
      
      // Lade Design-Settings aus cvPreviewData NACH loadCvDesignSettings (überschreibt globale Settings)
      // Dies stellt sicher, dass die Design-Settings, die beim Erstellen der Application verwendet wurden, übernommen werden
      if (cvPreviewData.designSettings) {
        const designSettings = cvPreviewData.designSettings;
        // Verwende applyCvDesignSettings, um ALLE Design-Einstellungen zu laden
        // Dies stellt sicher, dass alle Felder (Farben, Sichtbarkeiten, Profilbild-Einstellungen, etc.) korrekt übernommen werden
        applyCvDesignSettings(designSettings);
        console.log('✅ CV-Design-Einstellungen aus Application geladen:', designSettings);
      }
      
      // Öffne CV-Preview Modal direkt (ohne Warnung)
      setShowTemplatePreviewDialog(true);
      setShowCvOptimierenButton(false);
      // NICHT hier setzen - wird erst beim Schließen der Preview gesetzt
      // setCvTemplateHasBeenOpened(true);
      
      console.log('✅ CV-Daten aus Application geladen und Preview geöffnet');
      
    } catch (error) {
      console.error('❌ Fehler beim Laden der CV-Daten aus Application:', error);
      setError('Fehler beim Laden der CV-Daten: ' + (error instanceof Error ? error.message : 'Unbekannter Fehler'));
    } finally {
      // Stoppe Warte-Animation
      setLoadingCvPreview(false);
    }
  };

  const handleOpenCvTemplate = async () => {
    // Verwende den gleichen Prozess wie beim Modal "Bewerbungen" (funktioniert korrekt)
    // 1. Lade CV-Design-Settings aus Firebase (gemeinsame Funktion)
    // Die Funktion wendet die Design-Settings bereits an, gibt sie aber auch zurück
    const loadedDesignSettings = await loadCvDesignSettingsForPreview();
    
    // Verwende die geladenen Settings direkt - sie sind bereits normalisiert von loadCvDesignSettingsForPreview
    // Normalisiere NUR wenn keine Settings geladen wurden (verwende dann aktuelle State-Werte)
    // WICHTIG: Verwende die geladenen Settings direkt, nicht normalizeDesignSettings, da dies die State-Werte verwenden könnte
    const normalizedDesignSettings = loadedDesignSettings || getCurrentCvDesignSettings();
    
    if (normalizedDesignSettings) {
      console.log('✅ Design-Einstellungen geladen und normalisiert:', normalizedDesignSettings);
      
      // 2. Wende die Design-Einstellungen explizit an (wie beim Modal Bewerbungen)
      // Dies stellt sicher, dass alle Felder (Farben, Sichtbarkeiten, Profilbild-Einstellungen, etc.) korrekt übernommen werden
      applyCvDesignSettings(normalizedDesignSettings);
      console.log('✅ CV-Design-Einstellungen explizit angewendet:', normalizedDesignSettings);
    }
    
    // Zeige Warnungs-Dialog vor dem Öffnen des Templates nur wenn nicht deaktiviert
    if (!dontShowTemplateWarning) {
      setShowCvTemplateWarningDialog(true);
    } else {
      try {
        // 3. Erstelle automatisch eine Bewerbung BEVOR die Preview geöffnet wird
        // selectedApplicationId wurde beim Start der Optimierung auf null gesetzt
        // Übergebe die normalisierten Design-Einstellungen direkt
        const applicationId = await createApplicationFromCvPreview(normalizedDesignSettings);
        
        if (!applicationId) {
          throw new Error('Fehler beim Erstellen der Application');
        }
        
        // 4. Lade Design-Settings aus der erstellten Application (wie beim Modal Bewerbungen)
        // Dies stellt sicher, dass die Design-Einstellungen korrekt angewendet werden
        if (!user) {
          throw new Error('Benutzer nicht angemeldet');
        }
        
        // Kurze Verzögerung, um sicherzustellen, dass die Application vollständig gespeichert wurde
        await new Promise(resolve => setTimeout(resolve, 100));
        
        const token = await user.getIdToken();
        const response = await fetch(`${config.backend.baseUrl}/api/get-application-cv-preview-data/${applicationId}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error('Fehler beim Laden der Application-Daten');
        }

        const data = await response.json();
        const cvPreviewData = data.cvPreviewData;

        if (!cvPreviewData || !cvPreviewData.designSettings) {
          throw new Error('Keine Design-Settings in cvPreviewData gefunden');
        }

        // Debug: Zeige die Design-Settings, die aus der Application geladen wurden
        console.log('📥 Design-Settings aus Application geladen:', cvPreviewData.designSettings);
        console.log('📥 Design-Settings Keys:', Object.keys(cvPreviewData.designSettings));
        console.log('📥 selectedTemplate:', cvPreviewData.designSettings.selectedTemplate);
        console.log('📥 leftColumnColor:', cvPreviewData.designSettings.leftColumnColor);
        console.log('📥 topBoxColor:', cvPreviewData.designSettings.topBoxColor);
        console.log('📥 nameTextColor:', cvPreviewData.designSettings.nameTextColor);

        // Wende die Design-Settings aus der Application an (überschreibt globale Settings)
        // Dies stellt sicher, dass die Design-Settings, die beim Erstellen der Application verwendet wurden, übernommen werden
        applyCvDesignSettings(cvPreviewData.designSettings);
        console.log('✅ CV-Design-Einstellungen aus Application geladen und angewendet:', cvPreviewData.designSettings);
        
        // 5. Warte, bis alle State-Updates verarbeitet wurden, bevor die Preview geöffnet wird
        // Verwende requestAnimationFrame, um sicherzustellen, dass React die State-Updates verarbeitet hat
        await new Promise(resolve => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              setTimeout(resolve, 100);
            });
          });
        });
        
        // 6. Öffne CV-Preview Modal NACH dem Laden der Design-Einstellungen (wie beim Modal Bewerbungen)
        // Die Design-Einstellungen wurden bereits explizit angewendet und die State-Updates wurden verarbeitet
        setShowTemplatePreviewDialog(true);
        setShowCvOptimierenButton(false);
        // NICHT hier setzen - wird erst beim Schließen der Preview gesetzt
        // setCvTemplateHasBeenOpened(true);
      } catch (error) {
        console.error('❌ Fehler beim Öffnen der CV-Preview:', error);
        setError('Fehler beim Öffnen der CV-Preview: ' + (error instanceof Error ? error.message : 'Unbekannter Fehler'));
      }
    }
  };

  // Handler für Reset Design
  const handleResetDesign = async () => {
    // Stelle den Template-Namen basierend auf selectedTemplateId fest
    const templateName = selectedTemplateId === 'template1' ? 'Modern' : 
                        selectedTemplateId === 'template2' ? 'Professional' : 'Minimal';
    
    // Hole die Standardwerte für das aktuelle Template
    const defaultTemplateSettings = defaultCvSettings[selectedTemplateId];
    
    // Wende die Standardwerte des aktuellen Templates an
    applyCvDesignSettings({
      ...defaultTemplateSettings,
      selectedTemplate: selectedTemplateId
    });
    
    // Lösche die Design-Einstellungen aus der cvDesign Collection
    if (user?.uid) {
      try {
        await resetCvDesignSettings();
        console.log('✅ CV-Design-Einstellungen erfolgreich auf Standardwerte zurückgesetzt für Template:', templateName);
      } catch (error) {
        console.error('Fehler beim Zurücksetzen der CV-Design-Einstellungen:', error);
      }
    }
    
    // Schließe das Menü
    handleCvSettingsMenuClose();
  };

  // Handler für Template-Wechsel
  const handleTemplateChange = async (templateId: 'template1' | 'template2' | 'template3') => {
    // KEINE Speicherung beim Tab-Wechsel - Speicherung erfolgt nur beim Schließen der Preview
    
    // Wechsle zum neuen Template
    setSelectedTemplateId(templateId);
    
    // Lade Settings für das neue Template
    if (user?.uid) {
      try {
        const savedSettings = await loadCvSettings(user.uid);
        const newSettings = {
          ...savedSettings,
          selectedTemplate: templateId
        };
        applyCvSettings(newSettings);
        
      } catch (error) {
        console.error('Fehler beim Laden der Template-Settings:', error);
        // Bei Fehler Standardwerte für das neue Template verwenden
        const newSettings = {
          ...defaultCvSettings,
          selectedTemplate: templateId
        };
        applyCvSettings(newSettings);
      }
    } else {
      // Wenn kein User eingeloggt ist, Standardwerte für das neue Template verwenden
      const newSettings = {
        ...defaultCvSettings,
        selectedTemplate: templateId
      };
      applyCvSettings(newSettings);
    }
  };

  // Handler für Template-spezifisches Reset
  const handleResetTemplate = async (templateId: 'template1' | 'template2' | 'template3') => {
    if (user?.uid) {
      try {
        await resetTemplateSettings(user.uid, templateId);
        // Lade die aktualisierten Settings
        const updatedSettings = await loadCvSettings(user.uid);
        applyCvSettings(updatedSettings);
      } catch (error) {
        console.error('Fehler beim Zurücksetzen des Templates:', error);
      }
    }
    handleCvSettingsMenuClose();
  };

  // Handler für Textfarben-Modal
  const handleOpenTextColorPalette = () => {
    setTempNameTextColor(nameTextColor);
    setTempLeftColumnTextColor(leftColumnTextColor);
    setTempRightColumnTextColor(rightColumnTextColor);
    setTempLeftColumnTitleColor(leftColumnTitleColor);
    setTempRightColumnTitleColor(rightColumnTitleColor);
    setShowTextColorPalette(true);
  };

  const handleCloseTextColorPalette = () => {
    setNameTextColor(tempNameTextColor);
    setLeftColumnTextColor(tempLeftColumnTextColor);
    setRightColumnTextColor(tempRightColumnTextColor);
    setLeftColumnTitleColor(tempLeftColumnTitleColor);
    setRightColumnTitleColor(tempRightColumnTitleColor);
    setShowTextColorPalette(false);
  };

  const handleTextColorSelect = useCallback((color: string, section: 'name' | 'left' | 'right' | 'leftTitle' | 'rightTitle') => {
    switch (section) {
      case 'name':
        setTempNameTextColor(color);
        break;
      case 'left':
        setTempLeftColumnTextColor(color);
        break;
      case 'right':
        setTempRightColumnTextColor(color);
        break;
      case 'leftTitle':
        setTempLeftColumnTitleColor(color);
        break;
      case 'rightTitle':
        setTempRightColumnTitleColor(color);
        break;
    }
  }, []);

  // Hilfsfunktion für Textfarben-Palette
  const renderTextColorPalette = (section: 'name' | 'left' | 'right' | 'leftTitle' | 'rightTitle', tempColor: string) => {
    // Für Titel-Sektionen: Schwarz-weiß Palette
    const titleColors = [
      '#000000', '#333333', '#666666', '#999999', '#CCCCCC', '#FFFFFF'
    ];
    
    // Für normale Text-Sektionen: Standard Palette
    const textColors = [
      '#333333', '#666666', '#999999', '#CCCCCC', '#E0E0E0', '#F5F5F5'
    ];
    
    const colors = (section === 'leftTitle' || section === 'rightTitle') ? titleColors : textColors;

    const handleColorPickerChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const colorValue = event.target.value;
      handleTextColorSelect(colorValue, section);
    };

    const getSectionTitle = () => {
      switch (section) {
        case 'name': return 'Name';
        case 'left': return 'Linke Spalte';
        case 'right': return 'Rechte Spalte';
        case 'leftTitle': return 'Titel Spalte Links';
        case 'rightTitle': return 'Titel Spalte Rechts';
        default: return '';
      }
    };

    return (
      <Box sx={{ p: 2 }}>
        <Typography variant="h6" sx={{ mb: 2, fontFamily: 'Times New Roman, serif' }}>
          {getSectionTitle()}
        </Typography>
        
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
          <Typography variant="body2" sx={{ fontFamily: 'Times New Roman, serif' }}>
            Farbpicker:
          </Typography>
          <input
            type="color"
            value={tempColor}
            onChange={handleColorPickerChange}
            style={{
              width: '40px',
              height: '40px',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          />
        </Box>
        
        {/* Farbpalette */}
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 1.5, p: 1 }}>
          {colors.map((color) => (
            <Box
              key={`${section}-${color}`}
              onClick={() => handleTextColorSelect(color, section)}
              sx={{
                width: 40,
                height: 40,
                backgroundColor: color,
                border: tempColor === color ? '3px solid #667eea' : '2px solid #ddd',
                borderRadius: 1,
                cursor: 'pointer',
                '&:hover': {
                  transform: 'scale(1.1)',
                  transition: 'transform 0.2s ease'
                }
              }}
            />
          ))}
        </Box>
      </Box>
    );
  };


  // Hilfsfunktion zum Öffnen des Motivationsschreiben-Dialogs
  const handleOpenMotivationDialog = () => {
    // Markiere, dass Dialog gerade geöffnet wird
    dialogJustOpenedRef.current = true;
    // Öffne Dialog - Initialisierung erfolgt im useEffect
    setShowMotivationDialog(true);
  };

  // Hilfsfunktion zum Schließen des Motivationsschreiben-Dialogs (mit Speichern)
  const handleCloseMotivationDialog = () => {
    // Speichere alle Änderungen
    setMotivationTitle(tempMotivationTitle);
    setMotivationGreeting(tempMotivationGreeting);
    setMotivationLetter(tempMotivationLetter);
    setMotivationSenderName(tempMotivationSenderName);
    setMotivationSenderAddress(tempMotivationSenderAddress);
    setMotivationSenderPostalCode(tempMotivationSenderPostalCode);
    setMotivationSenderCity(tempMotivationSenderCity);
    setMotivationRecipientCompany(tempMotivationRecipientCompany);
    setMotivationRecipientContactPerson(tempMotivationRecipientContactPerson);
    setMotivationRecipientAddress(tempMotivationRecipientAddress);
    setMotivationRecipientPostalCode(tempMotivationRecipientPostalCode);
    setMotivationRecipientCity(tempMotivationRecipientCity);
    setMotivationClosingText(tempMotivationClosingText);
    setMotivationDateLocation(tempMotivationDateLocation);
    setMotivationSignatureName(tempMotivationSignatureName);
    
    // Schließe Dialog
    setShowMotivationDialog(false);
    
    // Trigger Seitenberechnung im CV-Template
    window.dispatchEvent(new CustomEvent('modalClosed'));
  };

  const handleLogout = () => {
    handleUserMenuClose();
    logout();
  };

  // Funktion zum Neuladen der CV-Daten vom Backend
  async function reloadCvDataFromBackend() {
    if (!user) return;
    
    // Wenn ein CV ausgewählt ist, lade diesen CV neu
    if (selectedCvId) {
      await handleSelectCv(selectedCvId);
      return;
    }
    
    try {
      const idToken = await user.getIdToken();
      const response = await fetch(`${config.backend.userDataUrl}/${user.uid}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        }
      });

      if (response.ok) {
        const result = await response.json();
        const data = result.data || {};
        
        // Setze alle Daten aus der verschlüsselten Antwort
        setFullName(data?.fullName || "");
        setCompany(data?.company || "");
        setAddress(data?.address || "");
        setPostalCode(data?.postalCode || "");
        setCity(data?.city || "");
        setCountry(data?.country || "");
        setAvailableFrom(data?.availableFrom || "");
        setPhoneNumber(data?.phoneNumber || "");
        setEmail(data?.email || "");
        setBirthYear(data?.birthYear || "");
        setNationality(mapNationalityToSelectValue(data?.nationality || ""));
        setResidencePermit(data?.residencePermit || "");
        setCivilStatus(mapCivilStatusToSelectValue(data?.civilStatus || ""));
        setShortProfile(data?.shortProfile || "");
        setWorkExperience(data?.workExperience || "");
        setEducation(data?.education || "");
        setCertificates(data?.certificates || "");
        setLanguages(data?.languages || "");
        setItSkills(data?.itSkills || "");
        setAdditionalInfo(data?.additionalInfo || "");
        
        setWorkExperiences(data?.workExperiences || []);
        setEducations(data?.educations || []);
        setCertifications(data?.certifications || []);
        setIndustryExperiences(data?.industryExperiences || []);
        setLanguages(Array.isArray(data?.languages) ? data.languages : []);
        setCoreCompetencies(Array.isArray(data?.coreCompetencies) ? data.coreCompetencies : []);
        setItSkills(Array.isArray(data?.itSkills) ? data.itSkills : []);
        setHobbies(Array.isArray(data?.hobbies) ? data.hobbies : []);
        setAdditionalInfo(Array.isArray(data?.additionalInfo) ? data.additionalInfo : []);
        
        // Profilfoto
        if (data?.profileImage) {
          if (typeof data.profileImage === 'string') {
            setProfileImage(data.profileImage);
          } else if (data.profileImage.data) {
            setProfileImage(`data:${data.profileImage.type};base64,${data.profileImage.data}`);
          } else {
            setProfileImage(null);
          }
        } else {
          setProfileImage(null);
        }
        
        // Signatur
        if (data?.signature) {
          if (typeof data.signature === 'string') {
            setSignature(data.signature);
          } else if (data.signature.data) {
            setSignature(`data:${data.signature.type};base64,${data.signature.data}`);
          } else {
            setSignature(null);
          }
        } else {
          setSignature(null);
        }
      }
    } catch (error) {
      console.error('❌ Fehler beim Neuladen der CV-Daten:', error);
    }
  }

  // Funktion zum Laden der User-Präferenzen für Warnungs-Dialoge
  const loadUserWarningPreferences = async () => {
    if (!user) return;
    
    try {
      const idToken = await user.getIdToken();
      
      // Lade User-Präferenzen aus der users Collection
      const response = await fetch(`${config.backend.baseUrl}/api/get-user-preferences`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        }
      });

      if (response.ok) {
        const result = await response.json();
        const data = result.data || {};
        
        setDontShowImportWarning(data.dontShowImportWarning || false);
        setDontShowTemplateWarning(data.dontShowTemplateWarning || false);
        setDontShowMotivationWarning(data.dontShowMotivationWarning || false);
        
        console.log('✅ User-Warnungs-Präferenzen geladen:', {
          dontShowImportWarning: data.dontShowImportWarning || false,
          dontShowTemplateWarning: data.dontShowTemplateWarning || false,
          dontShowMotivationWarning: data.dontShowMotivationWarning || false
        });
      } else {
        console.log('ℹ️ Keine User-Präferenzen gefunden, verwende Standardwerte');
        setDontShowImportWarning(false);
        setDontShowTemplateWarning(false);
        setDontShowMotivationWarning(false);
      }
    } catch (error) {
      console.error('❌ Fehler beim Laden der User-Warnungs-Präferenzen:', error);
      // Bei Fehler Standardwerte verwenden
      setDontShowImportWarning(false);
      setDontShowTemplateWarning(false);
      setDontShowMotivationWarning(false);
    }
  };

  // Funktion zum Speichern der User-Präferenzen für Warnungs-Dialoge
  const saveUserWarningPreferences = async (importWarning: boolean, templateWarning: boolean, motivationWarning?: boolean) => {
    if (!user) return;
    
    try {
      const idToken = await user.getIdToken();
      
      // Verwende POST-Methode anstatt PATCH (umgeht CORS-Probleme)
      const response = await fetch(`${config.backend.baseUrl}/api/save-user-preferences`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({
          dontShowImportWarning: importWarning,
          dontShowTemplateWarning: templateWarning,
          dontShowMotivationWarning: motivationWarning || false
        })
      });

      if (response.ok) {
        console.log('✅ User-Warnungs-Präferenzen gespeichert:', {
          dontShowImportWarning: importWarning,
          dontShowTemplateWarning: templateWarning,
          dontShowMotivationWarning: motivationWarning || false
        });
      } else {
        console.error('❌ Fehler beim Speichern der User-Warnungs-Präferenzen');
      }
    } catch (error) {
      console.error('❌ Fehler beim Speichern der User-Warnungs-Präferenzen:', error);
    }
  };

  // Funktion zum Löschen aller CV-Daten (für neuen CV)
  const clearAllCvData = () => {
    console.log('🗑️ Lösche alle CV-Daten für neuen CV...');
    
    // Lösche alle persönlichen Daten
    setFullName('');
    setCompany('');
    setAddress('');
    setPostalCode('');
    setCity('');
    setCountry('');
    setAvailableFrom('');
    setPhoneNumber('');
    setEmail('');
    setBirthYear('');
    setNationality('');
    setResidencePermit('');
    setCivilStatus('');
    setDrivingLicense('');
    setShortProfile('');
    setWorkExperience('');
    setEducation('');
    setCertificates('');
    
    // Lösche alle Array-Daten
    setLanguages([]);
    setCoreCompetencies([]);
    setItSkills([]);
    setAdditionalInfo([]);
    setHobbies([]);
    setWorkExperiences([]);
    setEducations([]);
    setCertifications([]);
    setIndustryExperiences([]);
    
    // Lösche Bilder und Signaturen
    setProfileImage(null);
    setSignature(null);
    
    // Setze CV-Auswahl zurück
    setSelectedCvId(null);
    setCurrentCvName('');
    
    // Setze ungespeicherte Änderungen zurück
    setHasUnsavedChanges(false);
    
    console.log('✅ Alle CV-Daten gelöscht - bereit für neuen CV');
  };

  const handleCvDataMenu = async () => {
    handleUserMenuClose();
    
    // Speichere Passgenauigkeit vor dem Reload, falls vorhanden
    const savedMatchScore = matchScore;
    
    // Lade gespeicherte Daten vom Backend neu, um ungespeicherte Änderungen zu verwerfen
    // Dies kann die Passgenauigkeit löschen (durch handleSelectCv -> clearOptimizedAndMatchData)
    await reloadCvDataFromBackend();
    
    // Lade Passgenauigkeit aus der Application, falls vorhanden (NACH dem Reload!)
    // WICHTIG: Nur wenn die Application zum aktuellen CV gehört!
    let matchScoreToSet: number | null = null;
    
    if (selectedApplicationId && applications.length > 0 && selectedCvId) {
      const application = applications.find((app: any) => app.id === selectedApplicationId);
      // Prüfe ob Application zum aktuellen CV gehört
      if (application && application.cvId === selectedCvId && application.matchScore !== null && application.matchScore !== undefined) {
        matchScoreToSet = application.matchScore;
        console.log('✅ Passgenauigkeit aus Application geladen:', matchScoreToSet, 'CV ID:', selectedCvId);
      } else if (application && application.cvId !== selectedCvId) {
        console.log('⚠️ Application gehört zu anderem CV. Application CV ID:', application.cvId, 'Aktuelles CV ID:', selectedCvId);
      }
    }
    
    // Falls keine Application-Passgenauigkeit vorhanden, aber vorher berechnet wurde, wiederherstellen
    // NUR wenn das CV nicht gewechselt wurde (savedMatchScore ist nur gültig für das gleiche CV)
    if (matchScoreToSet === null && savedMatchScore !== null && savedMatchScore !== undefined) {
      matchScoreToSet = savedMatchScore;
      console.log('✅ Passgenauigkeit aus gespeichertem Wert wiederhergestellt:', matchScoreToSet);
    }
    
    // Setze die Passgenauigkeit, falls vorhanden
    if (matchScoreToSet !== null) {
      setMatchScore(matchScoreToSet);
    } else {
      console.log('⚠️ Keine Passgenauigkeit gefunden oder CV wurde gewechselt');
    }
    
    // Öffne CV-Daten Modal mit "Persönliche Informationen" Tab
    setShowCvDataModal(true);
    setTabIndex(0); // Setze Modal auf Tab "Persönliche Informationen"
    setCvDataEditMode(true); // Markiere, dass CV-Daten-Bearbeitung aktiviert wurde
    setHasUnsavedChanges(false); // Beim Öffnen keine ungespeicherten Änderungen
    
    console.log('📝 CV-Daten Modal geöffnet - keine automatische Speicherung');
    
    // Zeige "Passgenauigkeit prüfen" Button wieder an, verstecke andere Buttons
    setShowPassgenauigkeitButton(true);
    setShowCvOptimierenButton(false); // CV optimieren Button verstecken bis Passgenauigkeit berechnet
    setCvTemplateHasBeenOpened(false); // Reset: Template wurde noch nicht geöffnet
    
    // KEINE Speicherung beim Öffnen des Modals!
    // Speicherung erfolgt nur beim expliziten Klick auf das Speicher-Icon
  };

  const handleCloseCvDataModal = () => {
    // Prüfe ob es ungespeicherte Änderungen gibt
    if (hasUnsavedChanges) {
      setShowUnsavedChangesDialog(true);
      return;
    }
    
    // Schließe Modal
    setShowCvDataModal(false);
    
    // Wenn keine CV-Daten vorhanden sind, zeige Tab "CV Daten" (Index 1)
    if (!hasData()) {
      setCvTabIndex(1);
    } else if (cvTabIndex < 1) {
      // Wenn CV-Daten vorhanden sind und Tab kleiner als 1, setze auf Tab "Bewerbungen" (Index 0)
      setCvTabIndex(0);
    }
  };
  
  const confirmCloseCvDataModal = () => {
    setShowUnsavedChangesDialog(false);
    setShowCvDataModal(false);
    setHasUnsavedChanges(false);
    
    // Wenn keine CV-Daten vorhanden sind, zeige Tab "CV Daten" (Index 1)
    if (!hasData()) {
      setCvTabIndex(1);
    } else if (cvTabIndex < 1) {
      // Wenn CV-Daten vorhanden sind und Tab kleiner als 1, setze auf Tab "Bewerbungen" (Index 0)
      setCvTabIndex(0);
    }
  };

  const handleCvDataAnpassen = async () => {
    // Speichere Passgenauigkeit vor dem Reload, falls vorhanden
    const savedMatchScore = matchScore;
    
    // Lade gespeicherte Daten vom Backend neu, um ungespeicherte Änderungen zu verwerfen
    // Dies kann die Passgenauigkeit löschen (durch handleSelectCv -> clearOptimizedAndMatchData)
    await reloadCvDataFromBackend();
    
    // Lade Passgenauigkeit aus der Application, falls vorhanden (NACH dem Reload!)
    // WICHTIG: Nur wenn die Application zum aktuellen CV gehört!
    let matchScoreToSet: number | null = null;
    
    if (selectedApplicationId && applications.length > 0 && selectedCvId) {
      const application = applications.find((app: any) => app.id === selectedApplicationId);
      // Prüfe ob Application zum aktuellen CV gehört
      if (application && application.cvId === selectedCvId && application.matchScore !== null && application.matchScore !== undefined) {
        matchScoreToSet = application.matchScore;
        console.log('✅ Passgenauigkeit aus Application geladen:', matchScoreToSet, 'CV ID:', selectedCvId);
      } else if (application && application.cvId !== selectedCvId) {
        console.log('⚠️ Application gehört zu anderem CV. Application CV ID:', application.cvId, 'Aktuelles CV ID:', selectedCvId);
      }
    }
    
    // Falls keine Application-Passgenauigkeit vorhanden, aber vorher berechnet wurde, wiederherstellen
    // NUR wenn das CV nicht gewechselt wurde (savedMatchScore ist nur gültig für das gleiche CV)
    if (matchScoreToSet === null && savedMatchScore !== null && savedMatchScore !== undefined) {
      matchScoreToSet = savedMatchScore;
      console.log('✅ Passgenauigkeit aus gespeichertem Wert wiederhergestellt:', matchScoreToSet);
    }
    
    // Setze die Passgenauigkeit, falls vorhanden
    if (matchScoreToSet !== null) {
      setMatchScore(matchScoreToSet);
    } else {
      console.log('⚠️ Keine Passgenauigkeit gefunden oder CV wurde gewechselt');
    }
    
    // Öffne CV-Daten Modal mit "Persönliche Informationen" Tab
    setShowCvDataModal(true);
    setTabIndex(0); // Setze Modal auf Tab "Persönliche Informationen"
    setCvDataEditMode(true); // Markiere, dass CV-Daten-Bearbeitung aktiviert wurde
    setHasUnsavedChanges(false); // Beim Öffnen keine ungespeicherten Änderungen
    
    // Setze Checkbox auf false (nur lokal, KEINE Speicherung)
    console.log('📝 Checkbox auf false gesetzt beim Klick auf "CV-Daten anpassen" (nur lokal, nicht gespeichert)');
    
    // Zeige "Passgenauigkeit prüfen" Button wieder an, verstecke andere Buttons
    setShowPassgenauigkeitButton(true);
    setShowCvOptimierenButton(false); // CV optimieren Button verstecken bis Passgenauigkeit berechnet
    setCvTemplateHasBeenOpened(false); // Reset: Template wurde noch nicht geöffnet
    
    // KEINE Speicherung beim Öffnen des Modals!
    // Speicherung erfolgt nur beim expliziten Klick auf das Speicher-Icon
  };



  // Funktion zum Laden der Backend-Versionsinfo
  const loadBackendVersionInfo = async () => {
    if (backendVersionInfo) return; // Bereits geladen
    
    setLoadingVersionInfo(true);
    try {
      const response = await fetch(`${config.backend.fullApiUrl}/api/version-info`);
      if (response.ok) {
        const data = await response.json();
        setBackendVersionInfo(data);
        console.log('📋 Backend-Versionsinfo geladen:', data);
      } else {
        console.error('❌ Fehler beim Laden der Backend-Versionsinfo:', response.status);
      }
    } catch (error) {
      console.error('❌ Fehler beim Laden der Backend-Versionsinfo:', error);
    } finally {
      setLoadingVersionInfo(false);
    }
  };







  // Funktion zum Generieren des Textes für mitgelieferte Daten
  const getMitgelieferteDatenText = () => {
    // Analysiere den aktuellen Prompt und zeige nur die relevanten Daten
    const currentPrompt = editingPromptText || '';
    let dataText = '';
    
    // Prüfe welche Platzhalter im Prompt verwendet werden
    if (currentPrompt.includes('{cvText}')) {
      // Zeige alle CV-Daten ohne Label
      if (fullName) dataText += `${fullName}\n`;
      if (address) dataText += `${address}\n`;
      if (city) dataText += `${city}\n`;
      if (shortProfile) dataText += `${shortProfile}\n`;
      
      if (workExperiences && workExperiences.length > 0) {
        workExperiences.forEach((exp: any) => {
          dataText += `${exp.position} bei ${exp.company} (${exp.startDate} - ${exp.endDate})\n`;
          if (exp.description) dataText += `${exp.description}\n`;
        });
      }
      
      if (educations && educations.length > 0) {
        educations.forEach((edu: any) => {
          dataText += `${edu.degree} an ${edu.institution} (${edu.startDate} - ${edu.endDate})\n`;
        });
      }
      
      if (itSkills && itSkills.length > 0) {
        itSkills.forEach((skill: any) => {
          dataText += `${skill.skill} (${skill.level})\n`;
        });
      }
      
      if (languages && languages.length > 0) {
        languages.forEach((lang: any) => {
          dataText += `${lang.language} (${lang.level})\n`;
        });
      }
      
      if (certifications && certifications.length > 0) {
        certifications.forEach((cert: any) => {
          dataText += `${cert.name} - ${cert.issuer} (${cert.date})\n`;
        });
      }
      
      if (hobbies && hobbies.length > 0) {
        hobbies.forEach((hobby: any) => {
          dataText += `${hobby.hobby}: ${hobby.description}\n`;
        });
      }
      
      if (additionalInfo && additionalInfo.length > 0) {
        additionalInfo.forEach((info: any) => {
          dataText += `${info.info}: ${info.details}\n`;
        });
      }
      
      if (coreCompetencies && coreCompetencies.length > 0) {
        coreCompetencies.forEach((comp: any) => {
          dataText += `${comp.competency}\n`;
        });
      }
      
      if (industryExperiences && industryExperiences.length > 0) {
        industryExperiences.forEach((exp: any) => {
          dataText += `${exp.industry} (${exp.years} Jahre)\n`;
        });
      }
    }
    
    if (currentPrompt.includes('{jobDescription}')) {
      // Zeige Stellenbeschreibung nur wenn es nicht IT-Skills-Optimierung ist
      if (jobDescription && !currentPrompt.includes('{itSkillData}')) {
        dataText += jobDescription;
      }
    }
    
    if (currentPrompt.includes('{itSkillData}')) {
      if (itSkills && itSkills.length > 0) {
        itSkills.forEach((skill: any) => {
          dataText += `${skill.skill || 'Kein Skill'}: ${skill.level || 'Kein Level'}\n`;
        });
      } else {
        dataText += 'Keine IT-Skills im CV gefunden';
      }
    }
    
    if (currentPrompt.includes('{coreCompetencyData}')) {
      if (coreCompetencies && coreCompetencies.length > 0) {
        coreCompetencies.forEach((comp: any) => {
          dataText += `${comp.competency || 'Keine Kompetenz'}\n`;
        });
      } else {
        dataText += 'Keine Kernkompetenzen im CV gefunden';
      }
    }
    
    if (currentPrompt.includes('{educationData}')) {
      if (educations && educations.length > 0) {
        educations.forEach((edu: any) => {
          dataText += `${edu.degree || 'Kein Abschluss'} an ${edu.institution || 'Keine Institution'} (${edu.startDate || 'Kein Start'} - ${edu.endDate || 'Kein Ende'})\n`;
        });
      } else {
        dataText += 'Keine Ausbildungen im CV gefunden';
      }
    }
    
    if (currentPrompt.includes('{workExperienceData}')) {
      if (workExperiences && workExperiences.length > 0) {
        workExperiences.forEach((exp: any) => {
          dataText += `${exp.position || 'Keine Position'} bei ${exp.company || 'Keine Firma'} (${exp.startDate || 'Kein Start'} - ${exp.endDate || 'Kein Ende'})\n${exp.description || 'Keine Beschreibung'}\n`;
        });
      } else {
        dataText += 'Keine Arbeitserfahrungen im CV gefunden';
      }
    }
    
    if (currentPrompt.includes('{industryData}')) {
      if (industryExperiences && industryExperiences.length > 0) {
        industryExperiences.forEach((exp: any) => {
          dataText += `${exp.industry || 'Keine Branche'} (${exp.years || 'Keine Jahre'} Jahre)\n`;
        });
      } else {
        dataText += 'Keine Branchen-Erfahrungen im CV gefunden';
      }
    }
    
    if (currentPrompt.includes('{languageData}')) {
      if (languages && languages.length > 0) {
        languages.forEach((lang: any) => {
          dataText += `${lang.language || 'Keine Sprache'}: ${lang.level || 'Kein Level'}\n`;
        });
      }
    }
    
    if (currentPrompt.includes('{hobbyData}')) {
      if (hobbies && hobbies.length > 0) {
        hobbies.forEach((hobby: any) => {
          dataText += `${hobby.hobby || 'Kein Hobby'}: ${hobby.description || 'Keine Beschreibung'}\n`;
        });
      } else {
        // Fallback für leere Hobby-Daten
        dataText += 'Keine Hobbydaten verfügbar\n';
      }
    }
    

    
    if (currentPrompt.includes('{workExperienceData}')) {
      if (workExperiences && workExperiences.length > 0) {
        workExperiences.forEach((exp: any) => {
          dataText += `${exp.position || 'Keine Position'} bei ${exp.company || 'Keine Firma'} (${exp.startDate || ''} - ${exp.endDate || 'Heute'})\n`;
          if (exp.description) dataText += `${exp.description}\n`;
        });
      }
    }
    
    if (currentPrompt.includes('{certificationData}')) {
      if (certifications && certifications.length > 0) {
        certifications.forEach((cert: any) => {
          dataText += `${cert.name || 'Kein Name'} - ${cert.issuer || 'Kein Aussteller'} (${cert.date || 'Kein Datum'})\n`;
        });
      }
    }
    
    if (currentPrompt.includes('{additionalInfoData}')) {
      if (additionalInfo && additionalInfo.length > 0) {
        additionalInfo.forEach((info: any) => {
          dataText += `${info.info || 'Keine Info'}: ${info.details || 'Keine Details'}\n`;
        });
      }
    }
    
    if (currentPrompt.includes('{industryExperienceData}')) {
      if (industryExperiences && industryExperiences.length > 0) {
        industryExperiences.forEach((exp: any) => {
          dataText += `${exp.industry || 'Keine Branche'} (${exp.years || '0'} Jahre): ${exp.description || 'Keine Beschreibung'}\n`;
        });
      }
    }
    
    return dataText || 'Keine Daten verfügbar';
  };

  // Funktion zum Laden der Prompts von Firebase
  const loadPromptsFromFirebase = async () => {
    try {
      if (!user) {
        console.log('⚠️ Kein User - verwende Default-Prompts');
        return;
      }

      const idToken = await user.getIdToken();
      const response = await fetch(`${config.backend.baseUrl}/api/prompts`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${idToken}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        console.log('✅ Prompts von Firebase geladen:', data);

        // Prompts aus Firebase-Daten erstellen - ALLE Prompts laden
        const firebasePrompts: Array<{type: string; text: string; originalText: string; chatGptVersion?: string; usage?: string; temperature?: string; maxTokens?: string; systemRole?: string}> = [];

        // Alle Prompts aus Firebase laden (nicht nur bekannte)
        if (data.prompts) {
          Object.keys(data.prompts).forEach(promptType => {
            firebasePrompts.push({
              type: promptType,
              text: data.prompts[promptType],
              originalText: data.prompts[promptType],
              chatGptVersion: data.versions?.[promptType] || 'gpt-4o',
              usage: data.usages?.[promptType] || data.types?.[promptType] || 'Optimierung',
              temperature: data.temperatures?.[promptType] || '0.0',
              maxTokens: data.maxTokens?.[promptType] || '8000',
              systemRole: data.systemRoles?.[promptType] || 'Du bist ein Experte für CV-Optimierung.'
            });
          });
        }

        if (firebasePrompts.length > 0) {
          setPrompts(firebasePrompts);
          console.log('✅ Alle Prompts erfolgreich geladen:', firebasePrompts.length);
        } else {
          console.log('⚠️ Keine Prompts in Firebase gefunden');
          setPrompts([]);
        }
      } else {
        console.log('⚠️ Fehler beim Laden der Prompts');
        setPrompts([]);
      }
    } catch (error) {
      console.error('❌ Fehler beim Laden der Prompts:', error);
      setPrompts([]);
    }
  };

  // State für die Prompts
  const [prompts, setPrompts] = useState<Array<{type: string; text: string; originalText: string; chatGptVersion?: string; usage?: string; temperature?: string; maxTokens?: string; systemRole?: string}>>([]);

  // Funktion zum Sortieren der Prompts (zweistufig: 1. nach Usage, 2. nach Type)
  const sortPrompts = (promptsToSort: Array<{type: string; text: string; originalText: string; chatGptVersion?: string; usage?: string; temperature?: string; maxTokens?: string; systemRole?: string}>) => {
    return promptsToSort.sort((a, b) => {
      // Primäre Sortierung: Nach Usage (Verwendung)
      const usageA = a.usage || 'Optimierung';
      const usageB = b.usage || 'Optimierung';
      const usageComparison = usageA.localeCompare(usageB);
      
      // Wenn Usage gleich ist, sekundäre Sortierung nach Type
      if (usageComparison === 0) {
        return a.type.localeCompare(b.type);
      }
      
      return usageComparison;
    });
  };

  const [cvFile, setCvFile] = useState<File | null>(null);
  const [jobDescription, setJobDescription] = useState('');
  const [jobDescriptionLanguage, setJobDescriptionLanguage] = useState<string>('DE');
  const [languageDetected, setLanguageDetected] = useState<boolean>(false);
  const [applications, setApplications] = useState<any[]>([]);
  const [selectedApplicationId, setSelectedApplicationId] = useState<string | null>(null);
  const [userCvs, setUserCvs] = useState<any[]>([]);
  const [selectedCvId, setSelectedCvId] = useState<string | null>(null);
  const [currentCvName, setCurrentCvName] = useState<string>('');
  const [showDeleteCvDialog, setShowDeleteCvDialog] = useState<boolean>(false);
  const [userBasic, setUserBasic] = useState<{ fullName: string; email: string }>({ fullName: '', email: '' });
  const [loadingApplications, setLoadingApplications] = useState<boolean>(false);
  const [showApplicationDetailsModal, setShowApplicationDetailsModal] = useState<boolean>(false);
  const [selectedApplication, setSelectedApplication] = useState<any>(null);
  const [editableNotes, setEditableNotes] = useState<string>('');
  const [editableCompany, setEditableCompany] = useState<string>('');
  const [editableIndustry, setEditableIndustry] = useState<string>('');
  const [editableRoleTitle, setEditableRoleTitle] = useState<string>('');
  const [shareLinkEmail, setShareLinkEmail] = useState<string>('');
  const [generatingShareLink, setGeneratingShareLink] = useState<boolean>(false);
  const [shareLinkUrl, setShareLinkUrl] = useState<string | null>(null);
  const [showShareLinkDialog, setShowShareLinkDialog] = useState<boolean>(false);

  // Funktion zum Generieren eines Share-Links
  const generateShareLink = async (applicationId: string, email?: string) => {
    if (!user) return;
    
    try {
      setGeneratingShareLink(true);
      const token = await user.getIdToken();
      
      const response = await fetch(`${config.backend.baseUrl}/api/generate-cv-share-link`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          applicationId: applicationId,
          email: email || null
        })
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Fehler beim Generieren des Share-Links');
      }
      
      const result = await response.json();
      setShareLinkUrl(result.shareUrl);
      setShowShareLinkDialog(true);
      
      if (email && result.emailSent) {
        alert('Share-Link wurde per E-Mail versendet!');
      }
    } catch (error: any) {
      console.error('Fehler beim Generieren des Share-Links:', error);
      alert('Fehler beim Generieren des Share-Links: ' + (error.message || 'Unbekannter Fehler'));
    } finally {
      setGeneratingShareLink(false);
    }
  };
  
  const copyShareLinkToClipboard = () => {
    if (shareLinkUrl) {
      navigator.clipboard.writeText(shareLinkUrl);
      // Kein Popup mehr - nur stilles Kopieren
    }
  };
  
  // Funktion zum Speichern der Notizen, Firma, Branche, Rollentitel und CV-Preview-Daten
  const saveApplicationData = async () => {
    if (!selectedApplication || !user) return;
    
    try {
      const token = await user.getIdToken();
      
      // Speichere Notizen
      const notesResponse = await fetch(`${config.backend.baseUrl}/api/update-application-notes`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          applicationId: selectedApplication.id,
          notes: editableNotes
        })
      });

      // Speichere Firma
      const companyResponse = await fetch(`${config.backend.baseUrl}/api/update-application-company`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          applicationId: selectedApplication.id,
          company: editableCompany
        })
      });

      // Speichere Branche
      const industryResponse = await fetch(`${config.backend.baseUrl}/api/update-application-industry`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          applicationId: selectedApplication.id,
          industry: editableIndustry
        })
      });

      // Speichere Rollentitel
      const roleTitleResponse = await fetch(`${config.backend.baseUrl}/api/update-application-role-title`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          applicationId: selectedApplication.id,
          roleTitle: editableRoleTitle
        })
      });

      // Sammle alle CV-Preview-Daten (alle Daten, die in der CV-Preview angezeigt werden)
      const cvPreviewData = getCvDataForTemplate();
      
      // Speichere CV-Preview-Daten
      // Verwende selectedApplicationId wenn vorhanden, sonst selectedApplication.id
      const targetApplicationId = selectedApplicationId || selectedApplication?.id;
      if (!targetApplicationId) {
        console.warn('⚠️ Keine Application ID zum Speichern der CV-Preview-Daten gefunden');
        return;
      }
      
      const cvPreviewResponse = await fetch(`${config.backend.baseUrl}/api/save-application-cv-preview-data`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          applicationId: targetApplicationId,
          cvPreviewData: cvPreviewData
        })
      });

      if (notesResponse.ok && companyResponse.ok && industryResponse.ok && roleTitleResponse.ok && cvPreviewResponse.ok) {
        // Update local state
        setSelectedApplication((prev: any) => ({ 
          ...prev, 
          notes: editableNotes,
          company: editableCompany,
          industry: editableIndustry,
          roleTitle: editableRoleTitle
        }));
        setApplications((prev: any[]) => 
          prev.map(app => 
            app.id === selectedApplication.id 
              ? { ...app, notes: editableNotes, company: editableCompany, industry: editableIndustry, roleTitle: editableRoleTitle }
              : app
          )
        );
        console.log('✅ Notizen, Firma, Branche, Rollentitel und CV-Preview-Daten gespeichert');
      } else {
        console.error('❌ Fehler beim Speichern der Daten');
        if (!cvPreviewResponse.ok) {
          const errorData = await cvPreviewResponse.json().catch(() => ({}));
          console.error('❌ CV-Preview-Daten Fehler:', errorData);
        }
      }
    } catch (error) {
      console.error('❌ Fehler beim Speichern der Daten:', error);
    }
  };
  const [showClosedApplications, setShowClosedApplications] = useState<boolean>(false);
  const [showDateFilters, setShowDateFilters] = useState<boolean>(false);
  const [applicationDateFrom, setApplicationDateFrom] = useState<string>('');
  const [applicationDateTo, setApplicationDateTo] = useState<string>('');
  const [extractedJobInfo, setExtractedJobInfo] = useState<{
    company?: string;
    publishDate?: string;
    contactInfo?: string;
    industry?: string;
    roleTitle?: string;
    tasks?: string;
    requirements?: string;
    applicationDetails?: string;
    workload?: string;
    keywords?: string[];
  } | null>(null);
  const [extractingJobInfo, setExtractingJobInfo] = useState<boolean>(false);
  
  
  // Lade Applications beim App-Start
  React.useEffect(() => {
    const loadApplications = async () => {
      if (!user) return;
      
      setLoadingApplications(true);
      // Deaktiviere Motivationsschreiben-Icon beim Laden der Applications
      setCvTemplateHasBeenOpened(false);
      
      try {
        const idToken = await user.getIdToken();
        const response = await fetch(`${config.backend.baseUrl}/api/get-job-descriptions`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${idToken}`
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          setApplications(data.applications || []);
          console.log('✅ Applications geladen:', data.count);
        }
      } catch (error) {
        console.error('❌ Fehler beim Laden der Applications:', error);
      } finally {
        setLoadingApplications(false);
      }
    };
    
    loadApplications();
  }, [user]);

  // Lade CV-Daten beim App-Start
  React.useEffect(() => {
    const loadUserCvs = async () => {
      if (!user) {
        setCvDataLoaded(true); // Wenn kein User, markiere als geladen (keine Daten zu laden)
        return;
      }
      
      try {
        const idToken = await user.getIdToken();
        const response = await fetch(`${config.backend.baseUrl}/api/get-user-cvs`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${idToken}`
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          setUserCvs(data.userCvs || []);
          
          // Wähle automatisch das gespeicherte CV, Standard-CV oder den neuesten CV aus
          if (data.userCvs && data.userCvs.length > 0 && !selectedCvId) {
            // 1. Versuche selectedCvId aus localStorage zu laden
            const savedCvId = localStorage.getItem('selectedCvId');
            let cvToSelect = null;
            
            if (savedCvId) {
              // Prüfe, ob das gespeicherte CV noch existiert
              cvToSelect = data.userCvs.find((cv: any) => cv.cvId === savedCvId);
              if (cvToSelect) {
                console.log('✅ Lade gespeichertes CV aus localStorage:', savedCvId);
              }
            }
            
            // 2. Falls nicht gefunden, verwende Standard-CV
            if (!cvToSelect) {
              cvToSelect = data.userCvs.find((cv: any) => cv.isDefault);
              if (cvToSelect) {
                console.log('✅ Lade Standard-CV:', cvToSelect.cvId);
              }
            }
            
            // 3. Falls kein Standard-CV, verwende den neuesten CV
            if (!cvToSelect) {
              cvToSelect = data.userCvs[0];
              if (cvToSelect) {
                console.log('✅ Lade neuesten CV:', cvToSelect.cvId);
              }
            }
            
            if (cvToSelect && cvToSelect.cvId) {
              // Lade CV, aber setze es nur als Standard, wenn es noch nicht als Standard gesetzt ist
              const shouldSetAsDefault = !cvToSelect.isDefault && savedCvId === cvToSelect.cvId;
              await handleSelectCv(cvToSelect.cvId, false, shouldSetAsDefault);
            }
          }
        }
        // Markiere als geladen, auch wenn die Antwort nicht ok war
        setCvDataLoaded(true);
      } catch (error) {
        console.error('❌ Fehler beim Laden der CV-Daten:', error);
        // Markiere als geladen, auch bei Fehler (damit die Prüfung nicht ewig wartet)
        setCvDataLoaded(true);
      }
    };
    
    setCvDataLoaded(false); // Zurücksetzen beim Neuladen
    loadUserCvs();
  }, [user]);


  // Lade Basisdaten (fullName, email) beim App-Start
  React.useEffect(() => {
    const loadUserBasic = async () => {
      if (!user) return;
      try {
        const idToken = await user.getIdToken();
        const response = await fetch(`${config.backend.baseUrl}/api/get-user-basic`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${idToken}`
          }
        });
        if (response.ok) {
          const data = await response.json();
          setUserBasic({ fullName: data.fullName || '', email: data.email || '' });
        }
      } catch (e) {
        // ignore
      }
    };
    loadUserBasic();
  }, [user]);
  
  // Setze Zielsprache basierend auf jobDescriptionLanguage
  React.useEffect(() => {
    const languageMap: { [key: string]: string } = {
      'de': 'deutsch',
      'DE': 'deutsch',
      'fr': 'französisch',
      'FR': 'französisch',
      'it': 'italienisch',
      'IT': 'italienisch',
      'en': 'englisch',
      'EN': 'englisch'
    };
    
    const newTargetLanguage = languageMap[jobDescriptionLanguage] || 'deutsch';
    setTargetLanguage(newTargetLanguage);
  }, [jobDescriptionLanguage]);
  const [detectingLanguage, setDetectingLanguage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  // originalCvText wurde entfernt - nicht mehr benötigt
  const [fullName, setFullName] = useState('');
  const [company, setCompany] = useState('');
  const [address, setAddress] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [city, setCity] = useState('');
  const [country, setCountry] = useState('');
  const [availableFrom, setAvailableFrom] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [birthYear, setBirthYear] = useState('');
  const [nationality, setNationality] = useState('');
  const [residencePermit, setResidencePermit] = useState('');
  const [civilStatus, setCivilStatus] = useState('');
  const [drivingLicense, setDrivingLicense] = useState('');
  const [shortProfile, setShortProfile] = useState('');
  const [workExperience, setWorkExperience] = useState('');
  const [education, setEducation] = useState('');
  const [certificates, setCertificates] = useState('');
  const [languages, setLanguages] = useState<Array<{language: string; level: string}>>([]);
  const [coreCompetencies, setCoreCompetencies] = useState<Array<{competency: string}>>([]);
  const [itSkills, setItSkills] = useState<Array<{skill: string; level: string}>>([]);
  const [additionalInfo, setAdditionalInfo] = useState<Array<{info: string; details: string}>>([]);
  const [hobbies, setHobbies] = useState<Array<{hobby: string; description: string}>>([]);
  const [optimizedImages, setOptimizedImages] = useState<Array<{id: number; name: string; description: string; image: string; optimizationInstructions?: string; isOriginal?: boolean; isOptimized?: boolean; isMask?: boolean}>>([]);
  const [showImageOptimizer, setShowImageOptimizer] = useState(false);
  const [workExperiences, setWorkExperiences] = useState<Array<{company: string; position: string; startDate: string; endDate: string; description: string}>>([]);
  const [educations, setEducations] = useState<Array<{institution: string; degree: string; startDate: string; endDate: string}>>([]);
  const [certifications, setCertifications] = useState<Array<{name: string; issuer: string; date: string}>>([]);
  const [industryExperiences, setIndustryExperiences] = useState<Array<{industry: string; years: string}>>([]);
  const [profileImage, setProfileImage] = useState<string | null>(null);
  const [showQrCodeDialog, setShowQrCodeDialog] = useState(false);
  
  
  const [qrCodeData, setQrCodeData] = useState<string | null>(null);
  const [qrSessionId, setQrSessionId] = useState<string | null>(null);
  

  const [qrExpiresAt, setQrExpiresAt] = useState<string | null>(null);
  const [isGeneratingQr, setIsGeneratingQr] = useState(false);
  const [signature, setSignature] = useState<string | null>(null);
  const [originalCvMarkdown, setOriginalCvMarkdown] = useState<string | null>(null);
  const [extracting, setExtracting] = useState(false);
  const [extractingJobUrl, setExtractingJobUrl] = useState(false); // State für URL-Extraktion
  
  // State für Import-Fortschrittsanzeige
  const [importProgress, setImportProgress] = useState<{[key: string]: 'pending' | 'running' | 'completed' | 'failed'}>({});
  
  // Funktion zum Abrufen des passenden Icons für jedes Thema
  const getTopicIcon = (topicName: string, status: string) => {
    // Blau-violettes Farbschema für abgeschlossene Tasks (wie CV Hochladen Button)
    const iconColor = status === 'completed' ? '#667eea' : 'grey.400';
    const isAnimated = status !== 'completed';
    
    const iconSx = {
      fontSize: 24, 
      color: iconColor,
      ...(isAnimated && {
        animation: 'pulse 2s ease-in-out infinite',
        '@keyframes pulse': {
          '0%': {
            opacity: 0.4,
            transform: 'scale(1)',
          },
          '50%': {
            opacity: 0.8,
            transform: 'scale(1.05)',
          },
          '100%': {
            opacity: 0.4,
            transform: 'scale(1)',
          },
        },
      }),
    };
    
    switch (topicName) {
      case 'Text extrahieren':
        return <DescriptionOutlinedIcon sx={iconSx} />;
      case 'Persönliche Informationen':
        return <PersonIcon sx={iconSx} />;
      case 'Kernkompetenzen':
        return <StarOutlineIcon sx={iconSx} />;
      case 'Branchen':
        return <BusinessCenterOutlinedIcon sx={iconSx} />;
      case 'Hobbies':
        return <SportsOutlinedIcon sx={iconSx} />;
      case 'IT-Skills':
        return <ComputerOutlinedIcon sx={iconSx} />;
      case 'Sprachen':
        return <LanguageOutlinedIcon sx={iconSx} />;
      case 'Ausbildung':
        return <SchoolOutlinedIcon sx={iconSx} />;
      case 'Zertifizierungen':
        return <WorkspacePremiumOutlinedIcon sx={iconSx} />;
      case 'Berufserfahrung':
        return <WorkOutlineIcon sx={iconSx} />;
      case 'Weitere Angaben':
        return <InfoOutlinedIcon sx={iconSx} />;
      default:
        return <DescriptionOutlinedIcon sx={iconSx} />;
    }
  };

  // Funktion zum Abrufen des passenden Icons für Optimierungs-Fortschritt
  const getOptimizationIcon = (taskName: string, status: string) => {
    // Blau-violettes Farbschema für abgeschlossene Tasks (wie CV Hochladen Button)
    const iconColor = status === 'completed' ? '#667eea' : 'grey.400';
    const isAnimated = status !== 'completed';
    
    const iconSx = {
      fontSize: 24, 
      color: iconColor,
      ...(isAnimated && {
        animation: 'pulse 2s ease-in-out infinite',
        '@keyframes pulse': {
          '0%': {
            opacity: 0.4,
            transform: 'scale(1)',
          },
          '50%': {
            opacity: 0.8,
            transform: 'scale(1.05)',
          },
          '100%': {
            opacity: 0.4,
            transform: 'scale(1)',
          },
        },
      }),
    };
    
    switch (taskName) {
      case 'Kurzprofil':
        return <PersonIcon sx={iconSx} />;
      case 'Arbeitserfahrung':
        return <WorkOutlineIcon sx={iconSx} />;
      case 'Kernkompetenzen':
        return <StarOutlineIcon sx={iconSx} />;
      case 'Branchen':
        return <BusinessCenterOutlinedIcon sx={iconSx} />;
      case 'Hobbies':
        return <SportsOutlinedIcon sx={iconSx} />;
      case 'Hobbys':
        return <SportsOutlinedIcon sx={iconSx} />;
      case 'IT-Skills':
        return <ComputerOutlinedIcon sx={iconSx} />;
      case 'Sprachen':
        return <LanguageOutlinedIcon sx={iconSx} />;
      case 'Ausbildung':
        return <SchoolOutlinedIcon sx={iconSx} />;
      case 'Zertifizierungen':
        return <WorkspacePremiumOutlinedIcon sx={iconSx} />;
      case 'Zertifikate':
        return <WorkspacePremiumOutlinedIcon sx={iconSx} />;
      case 'Weitere Informationen':
        return <InfoOutlinedIcon sx={iconSx} />;
      case 'Weitere Angaben':
        return <InfoOutlinedIcon sx={iconSx} />;
      default:
        return <DescriptionOutlinedIcon sx={iconSx} />;
    }
  };
  const [matchScore, setMatchScore] = useState<number | null>(null);
  const [missingSkills, setMissingSkills] = useState<string[]>([]);
  const [hiddenMissingSkills, setHiddenMissingSkills] = useState<Set<number>>(new Set());
  
  const [weaknesses, setWeaknesses] = useState<string[]>([]);
  const [hiddenWeaknesses, setHiddenWeaknesses] = useState<Set<number>>(new Set());
  
  // Hilfsfunktion zum Zurücksetzen aller Match-Daten
  const resetMatchData = () => {
    setMissingSkills([]);
    setWeaknesses([]);
    setHiddenMissingSkills(new Set());
    setHiddenWeaknesses(new Set());
  };

  // Funktion zum Löschen/Leeren von Passgenauigkeiten, optimierten CV-Daten und Motivationsschreiben
  const clearOptimizedAndMatchData = (preserveMatchScore: boolean = false) => {
    // Passgenauigkeit zurücksetzen (nur wenn nicht explizit erhalten werden soll)
    if (!preserveMatchScore) {
      setMatchScore(null);
    }
    resetMatchData();
    
    // Motivationsschreiben löschen
    setMotivationLetter(null);
    
    // Optimierte CV-Daten löschen
    setOptimizedShortProfile('');
    setOptimizedWorkExperiences([]);
    
    // Relevante Daten löschen
    setRelevantWorkExperiences([]);
    setRelevantItSkills([]);
    setRelevantCertifications([]);
    setRelevantCoreCompetencies([]);
    setRelevantIndustries([]);
    setRelevantHobbies([]);
    setRelevantAdditionalInfo([]);
    setRelevantEducations([]);
    setRelevantLanguages([]);
    
    // Optimierte persönliche Angaben löschen
    setOptimizedFullName('');
    setOptimizedCompany('');
    setOptimizedAddress('');
    setOptimizedPostalCode('');
    setOptimizedCity('');
    setOptimizedPhoneNumber('');
    setOptimizedEmail('');
    setOptimizedBirthYear('');
    setOptimizedNationality('');
    setOptimizedResidencePermit('');
    setOptimizedCivilStatus('');
    
    console.log('✅ Passgenauigkeiten, optimierte CV-Daten und Motivationsschreiben gelöscht');
  };
  
  // Handler für das Verstecken von fehlenden Skills
  const handleHideMissingSkill = (index: number) => {
    setHiddenMissingSkills(prev => {
      const newSet = new Set(prev);
      newSet.add(index);
      return newSet;
    });
  };
  
  // Handler für das Verstecken von Schwächen
  const handleHideWeakness = (index: number) => {
    setHiddenWeaknesses(prev => {
      const newSet = new Set(prev);
      newSet.add(index);
      return newSet;
    });
  };
  
  const [checkingMatch, setCheckingMatch] = useState(false);
  const [checkingMatchInModal, setCheckingMatchInModal] = useState(false);
  const [improvedCvText, setImprovedCvText] = useState<string | null>(null);
  const [optimizing, setOptimizing] = useState(false);
  const [optimizationProgress, setOptimizationProgress] = useState<{[key: string]: 'pending' | 'running' | 'completed' | 'failed'}>({});
  const [motivationLetter, setMotivationLetter] = useState<string | null>(null);
  const [motivationTitle, setMotivationTitle] = useState<string>('');
  const [showMotivationBorder, setShowMotivationBorder] = useState<boolean>(false);
  const [showCvBorder, setShowCvBorder] = useState<boolean>(false);
  const [showFrames, setShowFrames] = useState<boolean>(false);
  const [forceShowCvData, setForceShowCvData] = useState<boolean>(false);
  
  // Kombinierte Funktion für beide Rahmen-Typen
  const toggleAllBorders = () => {
    setShowCvBorder(!showCvBorder);
    setShowFrames(!showFrames);
  };

  const [motivationGreeting, setMotivationGreeting] = useState<string>('');
  const [motivationRecipientInfo, setMotivationRecipientInfo] = useState<any>(null);
  
  // States für editierbare Motivationsschreiben-Felder
  const [motivationSenderName, setMotivationSenderName] = useState<string>('');
  const [motivationSenderAddress, setMotivationSenderAddress] = useState<string>('');
  const [motivationSenderPostalCode, setMotivationSenderPostalCode] = useState<string>('');
  const [motivationSenderCity, setMotivationSenderCity] = useState<string>('');
  const [motivationRecipientCompany, setMotivationRecipientCompany] = useState<string>('');
  const [motivationRecipientContactPerson, setMotivationRecipientContactPerson] = useState<string>('');
  const [motivationRecipientAddress, setMotivationRecipientAddress] = useState<string>('');
  const [motivationRecipientPostalCode, setMotivationRecipientPostalCode] = useState<string>('');
  const [motivationRecipientCity, setMotivationRecipientCity] = useState<string>('');
  const [motivationClosingText, setMotivationClosingText] = useState<string>(() => {
    const defaultClosing = 'Mit freundlichen Grüßen';
    // Initialisierung wird im useEffect basierend auf userCountry angepasst
    return defaultClosing;
  });
  const [motivationDateLocation, setMotivationDateLocation] = useState<string>('');
  const [motivationSignatureName, setMotivationSignatureName] = useState<string>('');
  const [creatingMotivation, setCreatingMotivation] = useState(false);
  const [loadingCvPreview, setLoadingCvPreview] = useState(false);
  const [downloadingPdf, setDownloadingPdf] = useState(false);
  const [downloadingMotivationPdf, setDownloadingMotivationPdf] = useState(false);
  
  // Passe die Grussformel an die erkannte Sprache der Stellenausschreibung an,
  // sofern keine AI-Anrede geliefert wurde oder der Nutzer sie nicht manuell gesetzt hat
  React.useEffect(() => {
    const languageToGreeting: Record<string, string> = {
      'DE': 'Sehr geehrte Damen und Herren,',
      'EN': 'Dear Hiring Team,',
      'FR': 'Madame, Monsieur,',
      'IT': 'Gentili Signore e Signori,'
    };
    const mapped = languageToGreeting[jobDescriptionLanguage] || languageToGreeting['DE'];
    // Nur setzen, wenn aktuell leer oder nur Whitespace
    if (!motivationGreeting || motivationGreeting.trim().length === 0) {
      setMotivationGreeting(mapped);
    }
  }, [jobDescriptionLanguage]);

  // Passe die Abschluss-Grussformel an die erkannte Sprache an,
  // sofern sie leer ist oder dem Standard entspricht (nicht manuell gesetzt)
  React.useEffect(() => {
    const languageToClosing: Record<string, string> = {
      'DE': 'Mit freundlichen Grüßen',
      'EN': 'Kind regards',
      'FR': 'Cordialement',
      'IT': 'Cordiali saluti'
    };
    let mapped = languageToClosing[jobDescriptionLanguage] || languageToClosing['DE'];
    // Ersetze ß durch ss für Schweizer Benutzer
    if (userCountry === 'CH') {
      mapped = mapped.replace(/ß/g, 'ss');
    }
    const current = (motivationClosingText || '').trim();
    const knownClosings = Object.values(languageToClosing);
    // Auch bekannte Grußformeln für Vergleich anpassen, wenn CH
    const adjustedCurrent = userCountry === 'CH' ? current.replace(/ß/g, 'ss') : current;
    const adjustedKnownClosings = userCountry === 'CH' 
      ? knownClosings.map(c => c.replace(/ß/g, 'ss'))
      : knownClosings;
    if (current.length === 0 || adjustedKnownClosings.includes(adjustedCurrent)) {
      setMotivationClosingText(mapped);
    }
  }, [jobDescriptionLanguage, userCountry]);

  // Temporäre States für Motivationsschreiben-Bearbeitung (werden erst beim Schließen gespeichert)
  const [tempMotivationTitle, setTempMotivationTitle] = useState<string>('');
  const [tempMotivationGreeting, setTempMotivationGreeting] = useState<string>('');
  const [tempMotivationLetter, setTempMotivationLetter] = useState<string>('');
  const [tempMotivationSenderName, setTempMotivationSenderName] = useState<string>('');
  const [tempMotivationSenderAddress, setTempMotivationSenderAddress] = useState<string>('');
  const [tempMotivationSenderPostalCode, setTempMotivationSenderPostalCode] = useState<string>('');
  const [tempMotivationSenderCity, setTempMotivationSenderCity] = useState<string>('');
  const [tempMotivationRecipientCompany, setTempMotivationRecipientCompany] = useState<string>('');
  const [tempMotivationRecipientContactPerson, setTempMotivationRecipientContactPerson] = useState<string>('');
  const [tempMotivationRecipientAddress, setTempMotivationRecipientAddress] = useState<string>('');
  const [tempMotivationRecipientPostalCode, setTempMotivationRecipientPostalCode] = useState<string>('');
  const [tempMotivationRecipientCity, setTempMotivationRecipientCity] = useState<string>('');
  const [tempMotivationClosingText, setTempMotivationClosingText] = useState<string>('');
  const [tempMotivationDateLocation, setTempMotivationDateLocation] = useState<string>('');
  const [tempMotivationSignatureName, setTempMotivationSignatureName] = useState<string>('');

  const [tabIndex, setTabIndex] = useState(0);
  const [mainTabIndex, setMainTabIndex] = useState(0);
  const [cvTabIndex, setCvTabIndex] = useState(0);
  const [bewerbungenSubTabIndex, setBewerbungenSubTabIndex] = useState(0); // Sub-Tabs für Bewerbungen
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };
  const handleMainTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setMainTabIndex(newValue);
  };
  const handleCvTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setCvTabIndex(newValue);
  };

  const toggleSection = (section: keyof typeof minimizedSections) => {
    setMinimizedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };


  const [hasLoaded, setHasLoaded] = useState(false);
  const [tabSelectionExecuted, setTabSelectionExecuted] = useState(false);
  const [cvDataLoaded, setCvDataLoaded] = useState(false);
  const [showCvImportWarningDialog, setShowCvImportWarningDialog] = useState(false);
  const [showCvTemplateWarningDialog, setShowCvTemplateWarningDialog] = useState(false);
  const [showMotivationWarningDialog, setShowMotivationWarningDialog] = useState(false);
  const [dontShowImportWarning, setDontShowImportWarning] = useState(false);
  const [dontShowTemplateWarning, setDontShowTemplateWarning] = useState(false);
  const [dontShowMotivationWarning, setDontShowMotivationWarning] = useState(false);
  const [newWorkExperience, setNewWorkExperience] = useState({ company: '', position: '', startDate: '', endDate: '', description: '' });
  const [showNewWorkExperienceForm, setShowNewWorkExperienceForm] = useState(false);
  const [newEducation, setNewEducation] = useState({ institution: '', degree: '', startDate: '', endDate: '' });
  const [showNewEducationForm, setShowNewEducationForm] = useState(false);


  const handleCoreCompetencyChange = (index: number, text: string) => {
    const updatedCompetencies = [...coreCompetencies];
    if (updatedCompetencies[index]) {
      updatedCompetencies[index] = { competency: text };
      setCoreCompetencies(updatedCompetencies);
 // Setze Checkbox auf false bei manuellen Änderungen
      setHasUnsavedChanges(true); // Markiere als ungespeichert
    }
  };

  const handleCoreCompetenciesTitleChange = (title: string) => {
    setCurrentCoreCompetenciesTitle(title);
  };

  const handleCertificationsTitleChange = (title: string) => {
    setCurrentCertificationsTitle(title);
  };

  const handleItSkillsTitleChange = (title: string) => {
    setCurrentItSkillsTitle(title);
  };

  const handleIndustriesTitleChange = (title: string) => {
    setCurrentIndustriesTitle(title);
  };

  const handleLanguagesTitleChange = (title: string) => {
    setCurrentLanguagesTitle(title);
  };

  const handleHobbiesTitleChange = (title: string) => {
    setCurrentHobbiesTitle(title);
  };

  const handleEducationTitleChange = (title: string) => {
    setCurrentEducationTitle(title);
  };

  const handleWorkExperienceTitleChange = (title: string) => {
    setCurrentWorkExperienceTitle(title);
  };

  const handleProfileTitleChange = (title: string) => {
    setCurrentProfileTitle(title);
  };


  const handleCoreCompetencyAdd = () => {
    setCoreCompetencies([...coreCompetencies, { competency: '' }]);
 // Setze Checkbox auf false bei manuellen Änderungen
    console.log('➕ Neue Kernkompetenz hinzugefügt');
  };

  const handleCoreCompetencyRemove = (index: number) => {
    if (coreCompetencies.length > 1) {
      const updatedCompetencies = coreCompetencies.filter((_, i) => i !== index);
      setCoreCompetencies(updatedCompetencies);
 // Setze Checkbox auf false bei manuellen Änderungen
      console.log(`🗑️ Kernkompetenz ${index} entfernt`);
    }
  };

  
  // State für minimierte/maximierte Tabs
  const [minimizedSections, setMinimizedSections] = useState({
    industryExperiences: false,
    workExperience: false,
    education: false,
    certifications: false,
    languages: false,
    coreCompetencies: false,
    itSkills: false,
    additionalInfo: false,
    hobbies: false
  });
  
  // State für das Ausblenden des Stellenbeschreibung-Textfelds
  const [hideJobDescription, setHideJobDescription] = useState(false);
  
  // State für Info-Nachrichten
  const [infoMessage, setInfoMessage] = useState(getTranslatedInfoMessage('upload_cv'));
  
  // Funktion zum Aktualisieren der Info-Nachricht basierend auf dem Zustand
  const updateInfoMessage = () => {
    if (hasOptimizedCvData() && cvTemplateHasBeenOpened && motivationLetter) {
      setInfoMessage(getTranslatedInfoMessage('open_cv_and_motivation'));
    } else if (hasOptimizedCvData() && cvTemplateHasBeenOpened && !motivationLetter) {
      setInfoMessage(getTranslatedInfoMessage('open_cv_create_motivation'));
    } else if (hasOptimizedCvData() && !cvTemplateHasBeenOpened) {
      setInfoMessage(''); // Kein Info-Text während CV-Optimierung läuft und Template noch nicht geöffnet wurde
    } else if (hasData() && jobDescription.trim() && matchScore !== null && !optimizedShortProfile.trim()) {
      setInfoMessage(getTranslatedInfoMessage('match_results'));
    } else if (hasData() && jobDescription.trim()) {
      setInfoMessage(getTranslatedInfoMessage('enter_job_description'));
    } else if (hasData()) {
      setInfoMessage(getTranslatedInfoMessage('enter_job_description'));
    } else {
      setInfoMessage(getTranslatedInfoMessage('upload_cv'));
    }
  };

  // Update Info-Nachricht wenn sich die Sprache ändert
  React.useEffect(() => {
    updateInfoMessage();
  }, [targetLanguage]);
  
  
  // State für Template-System (verknüpft mit dem neuen Template-System)
  const [selectedTemplate, setSelectedTemplate] = useState('modern');

  const [showTemplatePreviewDialog, setShowTemplatePreviewDialog] = useState(false);
  const [showMotivationDialog, setShowMotivationDialog] = useState(false);
  const [showEditableMotivation, setShowEditableMotivation] = useState(false);
  const [cvTemplateHasBeenOpened, setCvTemplateHasBeenOpened] = useState(false);
  const openMotivationAfterWarningRef = React.useRef(false);
  
  // Referenz zum Tracken ob Dialog gerade geöffnet wurde
  const dialogJustOpenedRef = React.useRef(false);

  // Initialisiere temporäre States nur beim ersten Öffnen des Modals
  React.useEffect(() => {
    if (showMotivationDialog && dialogJustOpenedRef.current) {
      setTempMotivationTitle(motivationTitle);
      setTempMotivationGreeting(motivationGreeting);
      setTempMotivationLetter(motivationLetter || '');
      setTempMotivationSenderName(motivationSenderName);
      setTempMotivationSenderAddress(motivationSenderAddress);
      setTempMotivationSenderPostalCode(motivationSenderPostalCode);
      setTempMotivationSenderCity(motivationSenderCity);
      setTempMotivationRecipientCompany(motivationRecipientCompany);
      setTempMotivationRecipientContactPerson(motivationRecipientContactPerson);
      setTempMotivationRecipientAddress(motivationRecipientAddress);
      setTempMotivationRecipientPostalCode(motivationRecipientPostalCode);
      setTempMotivationRecipientCity(motivationRecipientCity);
      setTempMotivationClosingText(motivationClosingText);
      setTempMotivationDateLocation(motivationDateLocation);
      setTempMotivationSignatureName(motivationSignatureName);
      dialogJustOpenedRef.current = false;
    }
  }, [showMotivationDialog, motivationTitle, motivationGreeting, motivationLetter, motivationSenderName, 
      motivationSenderAddress, motivationSenderPostalCode, motivationSenderCity, motivationRecipientCompany,
      motivationRecipientContactPerson, motivationRecipientAddress, motivationRecipientPostalCode,
      motivationRecipientCity, motivationClosingText, motivationDateLocation, motivationSignatureName]);
  
  // Template-Switcher States
  const [selectedTemplateId, setSelectedTemplateId] = useState<'template1' | 'template2' | 'template3'>('template1');
  const [cvSettings, setCvSettings] = useState<CvSettings>(defaultCvSettings);
  
  // Template-Mapping für das alte System
  const getTemplateStyle = (templateId: 'template1' | 'template2' | 'template3'): 'modern' | 'professional' | 'classic' => {
    switch (templateId) {
      case 'template1': return 'modern';
      case 'template2': return 'professional';
      case 'template3': return 'classic';
      default: return 'modern';
    }
  };



  
  // State für CV-Daten-Bearbeitungsmodus - verfolgt ob "CV-Daten bearbeiten" geklickt wurde
  const [cvDataEditMode, setCvDataEditMode] = useState(false);
  
  // State für das Ausblenden der Upload-Buttons - versteckt sie nach Klick auf "Daten manuell befüllen"
  const [hideUploadButtons, setHideUploadButtons] = useState(false);
  
  // State für das Ausblenden der Buttons nach Klick auf "Neue Stellenbeschreibung erfassen"
  const [hideOptimizedButtons, setHideOptimizedButtons] = useState(false);
  
  // State für das Ausblenden der optimierten CV-Daten - standardmäßig minimiert
  const [hideOptimizedCvData, setHideOptimizedCvData] = useState(true);
  
  // State für das Ausblenden der Prompt-Daten - standardmäßig minimiert
  const [hidePromptData, setHidePromptData] = useState(true);
  
  // State für Benutzerrollen
  const [userRole, setUserRole] = useState<string>('Normal'); // 'Normal' oder 'Admin'
  const [loadingUserRole, setLoadingUserRole] = useState(true);
  
  // User Dropdown Menu State
  const [userMenuAnchorEl, setUserMenuAnchorEl] = useState<null | HTMLElement>(null);
  const isUserMenuOpen = Boolean(userMenuAnchorEl);
  
  // State für CV-Template Settings Menu
  const [cvSettingsMenuAnchorEl, setCvSettingsMenuAnchorEl] = useState<null | HTMLElement>(null);
  const isCvSettingsMenuOpen = Boolean(cvSettingsMenuAnchorEl);
  
  // State für Farben
  const [leftColumnColor, setLeftColumnColor] = useState('#f8f6f2');
  const [leftColumnAlpha, setLeftColumnAlpha] = useState(1); // Alpha-Wert für linke Spalte (0-1)
  const [topBoxColor, setTopBoxColor] = useState('#f8f6f2'); // Initial gleiche Farbe wie linke Spalte
  const [topBoxAlpha, setTopBoxAlpha] = useState(0); // Alpha-Wert für Header-Box (0-1), default 0 (100% transparent)
  
  // State für Color-Picker-Modal
  const [openColorPickerModal, setOpenColorPickerModal] = useState(false);
  const [currentColorPicker, setCurrentColorPicker] = useState<'header' | 'column' | 'name' | 'leftTitle' | 'leftText' | 'rightTitle' | 'rightText' | null>(null);
  const [tempColor, setTempColor] = useState('#000000');
  const [tempAlpha, setTempAlpha] = useState(1);
  
  // State für Header-Box-Bild
  const [topBoxImage, setTopBoxImage] = useState<string>(''); // Bild für Header-Box (Base64)
  
  // State für linke Spalte Bild
  const [leftColumnImage, setLeftColumnImage] = useState<string>(''); // Bild für linke Spalte (Base64)
  
  // State für Grafik-Upload-Modal
  const [showImageUploadModal, setShowImageUploadModal] = useState(false);
  const [imageTypeToUpload, setImageTypeToUpload] = useState<'header' | 'column' | null>(null);

  // Debug-Log für Admin-Bereiche
  // Debug Admin-Bereiche entfernt für bessere Performance
  
  // State für die Option, das Foto im CV anzuzeigen oder nicht
  const [showPhotoInCv, setShowPhotoInCv] = useState(true);
  
  // Keine Default-Prompts - nur Firebase-Prompts verwenden
 
  
        // States für das Prompt-Editor Modal
  const [promptEditorOpen, setPromptEditorOpen] = useState(false);
  const [editingPromptIndex, setEditingPromptIndex] = useState<number | null>(null);
  const [editingPromptText, setEditingPromptText] = useState('');
  const [editingPromptVersion, setEditingPromptVersion] = useState<string>('gpt-4o');
  const [editingPromptUsage, setEditingPromptUsage] = useState<string>('Optimierung');
  const [editingPromptTemperature, setEditingPromptTemperature] = useState<string>('0.0');
  const [editingPromptMaxTokens, setEditingPromptMaxTokens] = useState<string>('8000');
  const [editingPromptName, setEditingPromptName] = useState<string>('');
  const [originalPromptName, setOriginalPromptName] = useState<string>(''); // Speichert den ursprünglichen Namen
  
  // State für Prompt-Testing
  const [testResult, setTestResult] = useState<string>('');
  const [isTesting, setIsTesting] = useState(false);
  const [showMitgelieferteDaten, setShowMitgelieferteDaten] = useState(false);
  const [showVerwendeteDatensets, setShowVerwendeteDatensets] = useState(false);
  const [editingPromptSystemRole, setEditingPromptSystemRole] = useState<string>('Du bist ein Experte für CV-Optimierung.');


  // Verfügbare ChatGPT-Versionen mit Informationen
  const chatGptVersions = [
    {
      value: 'gpt-4o',
      label: 'GPT-4o',
      description: 'Neueste und leistungsfähigste Version',
      speed: 'Schnell',
      quality: 'Sehr hoch',
      speedColor: '#4caf50',
      qualityColor: '#2196f3',
      details: 'Multimodal, sehr schnell, beste Qualität'
    },
    {
      value: 'gpt-4o-mini',
      label: 'GPT-4o Mini',
      description: 'Kompakte Version von GPT-4o',
      speed: 'Sehr schnell',
      quality: 'Hoch',
      speedColor: '#4caf50',
      qualityColor: '#4caf50',
      details: 'Schneller als GPT-4o, etwas geringere Qualität'
    },
    {
      value: 'gpt-4-turbo',
      label: 'GPT-4 Turbo',
      description: 'Optimierte Version von GPT-4',
      speed: 'Mittel',
      quality: 'Sehr hoch',
      speedColor: '#ff9800',
      qualityColor: '#2196f3',
      details: 'Gute Qualität, moderate Geschwindigkeit'
    },
    {
      value: 'gpt-3.5-turbo',
      label: 'GPT-3.5 Turbo',
      description: 'Schnelle und kostengünstige Version',
      speed: 'Sehr schnell',
      quality: 'Mittel',
      speedColor: '#4caf50',
      qualityColor: '#ff9800',
      details: 'Sehr schnell, moderate Qualität, günstig'
    },
    {
      value: 'gpt-4',
      label: 'GPT-4',
      description: 'Klassische GPT-4 Version',
      speed: 'Langsam',
      quality: 'Sehr hoch',
      speedColor: '#f44336',
      qualityColor: '#2196f3',
      details: 'Beste Qualität, aber langsam und teuer'
    },
    {
      value: 'gpt-image-1',
      label: 'GPT-Image-1',
      description: 'Neueste Bildgenerierung und -bearbeitung',
      speed: 'Mittel',
      quality: 'Sehr hoch',
      speedColor: '#ff9800',
      qualityColor: '#2196f3',
      details: 'Spezialisiert für Bildbearbeitung und -generierung'
    },
    {
      value: 'dall-e-2',
      label: 'DALL-E 2',
      description: 'Bewährtes Modell für Bildbearbeitung',
      speed: 'Mittel',
      quality: 'Hoch',
      speedColor: '#ff9800',
      qualityColor: '#4caf50',
      details: 'Stabil und zuverlässig für Foto-Optimierung und Hintergrund-Ersetzung'
    },
    {
      value: 'dall-e-3',
      label: 'DALL-E 3',
      description: 'Neuestes Modell für erweiterte Bildbearbeitung',
      speed: 'Langsam',
      quality: 'Sehr hoch',
      speedColor: '#f44336',
      qualityColor: '#2196f3',
      details: 'Erweiterte Bearbeitungsfähigkeiten mit besserer Masken-Unterstützung'
    }
  ];

    
    // State für die CV-Daten Checkbox
  
  // State für die Sichtbarkeit der CV-Bereiche im Template
  const [showCoreCompetenciesInCv, setShowCoreCompetenciesInCv] = useState(true);
  const [showCertificationsInCv, setShowCertificationsInCv] = useState(true);
  const [showItSkillsInCv, setShowItSkillsInCv] = useState(true);
  const [showIndustriesInCv, setShowIndustriesInCv] = useState(true);
  const [showLanguagesInCv, setShowLanguagesInCv] = useState(true);
  const [showHobbiesInCv, setShowHobbiesInCv] = useState(true);
  const [showEducationInCv, setShowEducationInCv] = useState(true);
  const [showWorkExperienceInCv, setShowWorkExperienceInCv] = useState(true);
  const [showAdditionalWorkExperienceInCv, setShowAdditionalWorkExperienceInCv] = useState(true);
  const [showProfileInCv, setShowProfileInCv] = useState(true);
  const [showAdditionalInfoInCv, setShowAdditionalInfoInCv] = useState(true);
  const [showProfileImageInCv, setShowProfileImageInCv] = useState(true);
  const [profileImageBorderRadius, setProfileImageBorderRadius] = useState(50); // 0 = eckig, 50 = rund
  const [profileImageSize, setProfileImageSize] = useState('M'); // S, M, L
  const [profileImageWidth, setProfileImageWidth] = useState(100); // 50-100% der ursprünglichen Breite
  const [profileImageAlignment, setProfileImageAlignment] = useState('center'); // left, center, right
  const [profileImagePosition, setProfileImagePosition] = useState({ x: 50, y: 50 }); // Position des Bildes im Rahmen (0-100%)
  const [profileImageBorder, setProfileImageBorder] = useState(false); // Rahmen um das Profilbild
  const [profileImageBorderColor, setProfileImageBorderColor] = useState('#333333'); // Farbe des Rahmens
  const [profileImageBorderThickness, setProfileImageBorderThickness] = useState(2); // Dicke des Rahmens
  
  // Temporäre State-Variablen für das Profilbild-Modal
  const [tempProfileImageBorder, setTempProfileImageBorder] = useState(false);
  const [tempProfileImageBorderColor, setTempProfileImageBorderColor] = useState('#333333');
  const [tempProfileImageBorderThickness, setTempProfileImageBorderThickness] = useState(2);
  const [nameFontSize, setNameFontSize] = useState(36); // Schriftgröße für den Namen (wird automatisch überschrieben)
  const [contactDisplayMode, setContactDisplayMode] = useState<'text' | 'icon'>('text'); // Kontakt-Anzeigemodus
  
  // Design-Einstellungen werden nur beim Schließen der CV-Preview gespeichert
  // (nicht automatisch bei jeder Änderung)
  
  // Handler für Namensgröße-Änderung (wird automatisch überschrieben)
  const handleNameFontSizeChange = (newFontSize: number) => {
    setNameFontSize(newFontSize);
    // Automatische Berechnung überschreibt manuelle Einstellungen
  };

  // Handler für Kontakt-Display-Mode-Änderung
  const handleContactDisplayModeChange = (mode: 'text' | 'icon') => {
    setContactDisplayMode(mode);
  };
  
  // Funktion zur Berechnung der Profilbild-Größe
  const getProfileImageSize = (size: string) => {
    switch (size) {
      case 'S': return '180px';
      case 'M': return '245px';
      case 'L': return '300px';
      default: return '245px';
    }
  };
  
  // State für das Kernkompetenzen-Modal
  const [showCoreCompetenciesModal, setShowCoreCompetenciesModal] = useState(false);
  
  // State für den aktuellen Titel aus dem CV-Template
  const [currentCoreCompetenciesTitle, setCurrentCoreCompetenciesTitle] = useState('Kernkompetenzen');
  
  // State für das Auswahl-Modal der verfügbaren Kernkompetenzen
  const [showAvailableCoreCompetenciesModal, setShowAvailableCoreCompetenciesModal] = useState(false);
  
  // State für das Zertifizierungen-Modal
  const [showCertificationsModal, setShowCertificationsModal] = useState(false);
  
  // State für den aktuellen Zertifizierungen-Titel aus dem CV-Template
  const [currentCertificationsTitle, setCurrentCertificationsTitle] = useState('Zertifizierungen');
  
  // State für das Auswahl-Modal der verfügbaren Zertifizierungen
  const [showAvailableCertificationsModal, setShowAvailableCertificationsModal] = useState(false);
  
  // State für das CV-Daten Modal
  const [showCvDataModal, setShowCvDataModal] = useState(false);
  const [showAddCvModal, setShowAddCvModal] = useState(false);
  const [newCvName, setNewCvName] = useState<string>('');
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showUnsavedChangesDialog, setShowUnsavedChangesDialog] = useState(false);
  const [cvModalManuallyClosed, setCvModalManuallyClosed] = useState(false);
  const [openCvModalFromPassgenauigkeit, setOpenCvModalFromPassgenauigkeit] = useState(false);

  // Funktion zum Öffnen des CV-Daten-Modals mit dem richtigen Tab
  // skipReload: wenn true, wird das Neuladen aus dem Backend übersprungen
  const openCvDataModal = async (fromPassgenauigkeit: boolean = false, skipReload: boolean = false) => {
    // Speichere Passgenauigkeit vor dem Reload, falls vorhanden
    const savedMatchScore = matchScore;
    
    // Lade gespeicherte Daten vom Backend neu, um ungespeicherte Änderungen zu verwerfen
    // Dies kann die Passgenauigkeit löschen (durch handleSelectCv -> clearOptimizedAndMatchData)
    if (!skipReload) {
      await reloadCvDataFromBackend();
    }
    
    // Lade Passgenauigkeit aus der Application, falls vorhanden (NACH dem Reload!)
    // Prüfe zuerst in der Application, dann im gespeicherten Wert
    // WICHTIG: Nur wenn die Application zum aktuellen CV gehört!
    let matchScoreToSet: number | null = null;
    
    if (selectedApplicationId && applications.length > 0 && selectedCvId) {
      const application = applications.find((app: any) => app.id === selectedApplicationId);
      // Prüfe ob Application zum aktuellen CV gehört
      if (application && application.cvId === selectedCvId && application.matchScore !== null && application.matchScore !== undefined) {
        matchScoreToSet = application.matchScore;
        console.log('✅ Passgenauigkeit aus Application gefunden:', matchScoreToSet, 'Application ID:', selectedApplicationId, 'CV ID:', selectedCvId);
      } else if (application && application.cvId !== selectedCvId) {
        console.log('⚠️ Application gehört zu anderem CV. Application CV ID:', application.cvId, 'Aktuelles CV ID:', selectedCvId);
      }
    }
    
    // Falls keine Application-Passgenauigkeit vorhanden, aber vorher berechnet wurde, verwende den gespeicherten Wert
    if (matchScoreToSet === null && savedMatchScore !== null && savedMatchScore !== undefined) {
      matchScoreToSet = savedMatchScore;
      console.log('✅ Passgenauigkeit aus gespeichertem Wert wiederhergestellt:', matchScoreToSet);
    }
    
    // Setze die Passgenauigkeit, falls vorhanden
    if (matchScoreToSet !== null) {
      setMatchScore(matchScoreToSet);
      console.log('✅ Passgenauigkeit gesetzt:', matchScoreToSet);
    } else {
      console.log('⚠️ Keine Passgenauigkeit gefunden. selectedApplicationId:', selectedApplicationId, 'savedMatchScore:', savedMatchScore, 'applications.length:', applications.length);
    }
    
    // Öffne CV-Daten Modal
    setShowCvDataModal(true);
    setCvDataEditMode(true);
    setHasUnsavedChanges(false);
    
    // Setze den richtigen Tab basierend auf der Quelle
    if (fromPassgenauigkeit) {
      setTabIndex(1); // Tab "Berufserfahrung" nach Passgenauigkeit
    } else {
      setTabIndex(0); // Tab "Persönliche Informationen" für normalen Klick
    }
    
  };

  // Öffne CV-Upload-Modal automatisch wenn keine CV-Daten vorhanden sind
  React.useEffect(() => {
    if (user && userCvs.length === 0 && !showAddCvModal && !cvModalManuallyClosed) {
      // Kleine Verzögerung, damit die App vollständig geladen ist
      const timer = setTimeout(() => {
        setShowAddCvModal(true);
        console.log('🎯 CV-Upload-Modal automatisch geöffnet - keine CV-Daten vorhanden');
      }, 1000);
      
      return () => clearTimeout(timer);
    }
  }, [user, userCvs.length, showAddCvModal, cvModalManuallyClosed]);
  
  // State für collapsed sections im Modal
  const [showHobbiesCollapsed, setShowHobbiesCollapsed] = useState(false);
  const [showItSkillsCollapsed, setShowItSkillsCollapsed] = useState(false);
  const [showLanguagesCollapsed, setShowLanguagesCollapsed] = useState(false);
  const [showCertificationsCollapsed, setShowCertificationsCollapsed] = useState(false);
  const [showCoreCompetenciesCollapsed, setShowCoreCompetenciesCollapsed] = useState(false);
  const [showAdditionalInfoCollapsed, setShowAdditionalInfoCollapsed] = useState(false);
  const [showEducationCollapsed, setShowEducationCollapsed] = useState(false);
  const [showIndustryExperiencesCollapsed, setShowIndustryExperiencesCollapsed] = useState(false);
  const [showWorkExperiencesCollapsed, setShowWorkExperiencesCollapsed] = useState(false);
  
  // State für das IT-Skills-Modal
  const [showItSkillsModal, setShowItSkillsModal] = useState(false);
  const [currentItSkillsTitle, setCurrentItSkillsTitle] = useState('Informatik');
  
  // State für das Auswahl-Modal der verfügbaren IT-Skills
  const [showAvailableItSkillsModal, setShowAvailableItSkillsModal] = useState(false);
  
  // State für das Branchen-Modal
  const [showIndustriesModal, setShowIndustriesModal] = useState(false);
  const [currentIndustriesTitle, setCurrentIndustriesTitle] = useState('Branchen');
  
  // State für das Auswahl-Modal der verfügbaren Branchen
  const [showAvailableIndustriesModal, setShowAvailableIndustriesModal] = useState(false);
  
  // State für das Sprachen-Modal
  const [showLanguagesModal, setShowLanguagesModal] = useState(false);
  const [currentLanguagesTitle, setCurrentLanguagesTitle] = useState('Sprachen');
  
  // State für das Auswahl-Modal der verfügbaren Sprachen
  const [showAvailableLanguagesModal, setShowAvailableLanguagesModal] = useState(false);
  
  // State für das Hobbies-Modal
  const [showHobbiesModal, setShowHobbiesModal] = useState(false);
  const [currentHobbiesTitle, setCurrentHobbiesTitle] = useState('Hobbies');
  
  // State für das Auswahl-Modal der verfügbaren Hobbys
  const [showAvailableHobbiesModal, setShowAvailableHobbiesModal] = useState(false);
  
  // State für das Weitere-Angaben-Modal
  const [showAdditionalInfoModal, setShowAdditionalInfoModal] = useState(false);
  const [currentAdditionalInfoTitle, setCurrentAdditionalInfoTitle] = useState('Weitere Angaben');
  
  // State für das Auswahl-Modal der verfügbaren Weiteren Angaben
  const [showAvailableAdditionalInfoModal, setShowAvailableAdditionalInfoModal] = useState(false);
  
  // State für das Ausbildung-Modal
  const [showEducationModal, setShowEducationModal] = useState(false);
  const [currentEducationTitle, setCurrentEducationTitle] = useState('Ausbildung');
  
  // State für das Berufserfahrungen-Modal
  const [showWorkExperienceModal, setShowWorkExperienceModal] = useState(false);
  const [currentWorkExperienceTitle, setCurrentWorkExperienceTitle] = useState('Beruflicher Werdegang');
  const [selectedWorkExperience, setSelectedWorkExperience] = useState<{
    position?: string;
    company?: string;
    startDate?: string;
    endDate?: string;
    description?: string;
    responsibilities?: string[];
    relevant?: boolean | string;
  } | null>(null);
  const [originalWorkExperience, setOriginalWorkExperience] = useState<{
    position?: string;
    company?: string;
    startDate?: string;
    endDate?: string;
    description?: string;
    responsibilities?: string[];
    relevant?: boolean | string;
  } | null>(null);
  const [isNonRelevantWorkExperience, setIsNonRelevantWorkExperience] = useState(false);
  
  // State für das Profil-Modal
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [currentProfileTitle, setCurrentProfileTitle] = useState('Profil');
  
  // State für das Profilbild-Modal
  const [showProfileImageModal, setShowProfileImageModal] = useState(false);
  
  // State für die übersetzte "Jahre"-Bezeichnung
  const [translatedYears, setTranslatedYears] = useState('Jahre');
  
  // Event Listener für das Kernkompetenzen-Modal
  React.useEffect(() => {
    const handleOpenCoreCompetenciesModal = (event: any) => {
      // Übernehme den aktuellen Titel aus dem Template
      if (event.detail && event.detail.title) {
        setCurrentCoreCompetenciesTitle(event.detail.title);
      }
      setShowCoreCompetenciesModal(true);
    };
    
    window.addEventListener('openCoreCompetenciesModal', handleOpenCoreCompetenciesModal);
    
    return () => {
      window.removeEventListener('openCoreCompetenciesModal', handleOpenCoreCompetenciesModal);
    };
  }, []);

  // Event Listener für Titel-Änderungen im Modal
  React.useEffect(() => {
    const handleTitleChange = () => {
      // Sende den geänderten Titel an das Template
      const event = new CustomEvent('updateCoreCompetenciesTitle', {
        detail: { title: currentCoreCompetenciesTitle }
      });
      window.dispatchEvent(event);
    };
    
    // Trigger bei Änderungen des Titels
    handleTitleChange();
  }, [currentCoreCompetenciesTitle]);

  // Event Listener für das Zertifizierungen-Modal
  React.useEffect(() => {
    const handleOpenCertificationsModal = (event: any) => {
      // Übernehme den aktuellen Titel aus dem Template
      if (event.detail && event.detail.title) {
        setCurrentCertificationsTitle(event.detail.title);
      }
      setShowCertificationsModal(true);
    };
    
    window.addEventListener('openCertificationsModal', handleOpenCertificationsModal);
    
    return () => {
      window.removeEventListener('openCertificationsModal', handleOpenCertificationsModal);
    };
  }, []);

  // Event Listener für Zertifizierungen-Titel-Änderungen im Modal
  React.useEffect(() => {
    const handleTitleChange = () => {
      // Sende den geänderten Titel an das Template
      const event = new CustomEvent('updateCertificationsTitle', {
        detail: { title: currentCertificationsTitle }
      });
      window.dispatchEvent(event);
    };
    
    // Trigger bei Änderungen des Titels
    handleTitleChange();
  }, [currentCertificationsTitle]);

  // Funktion zum Filtern der verfügbaren (nicht ausgewählten) Kernkompetenzen
  const getAvailableCoreCompetencies = () => {
    if (!coreCompetencies || coreCompetencies.length === 0) {
      return [];
    }
    
    // Filtere alle Kernkompetenzen, die noch nicht in relevantCoreCompetencies sind
    return coreCompetencies.filter(comp => {
      // Prüfe, ob diese Kompetenz bereits in relevantCoreCompetencies ist
      const isAlreadySelected = relevantCoreCompetencies.some(relComp => 
        relComp.competency === comp.competency
      );
      return !isAlreadySelected;
    });
  };

  // Funktion zum Filtern der verfügbaren (nicht ausgewählten) Zertifizierungen
  const getAvailableCertifications = () => {
    if (!certifications || certifications.length === 0) {
      return [];
    }
    
    // Filtere alle Zertifizierungen, die noch nicht in relevantCertifications sind
    return certifications.filter(cert => {
      // Prüfe, ob diese Zertifizierung bereits in relevantCertifications ist (nur nach Zertifizierungs-Name)
      const isAlreadySelected = relevantCertifications.some(relCert => 
        relCert.name === cert.name
      );
      return !isAlreadySelected;
    });
  };

  // Funktion zum Filtern der verfügbaren (nicht ausgewählten) IT-Skills
  const getAvailableItSkills = () => {
    if (!itSkills || itSkills.length === 0) {
      return [];
    }
    
    // Filtere alle IT-Skills, die noch nicht in relevantItSkills sind
    return itSkills.filter(skill => {
      // Prüfe, ob dieser Skill bereits in relevantItSkills ist (nur nach Skill-Name)
      const isAlreadySelected = relevantItSkills.some(relSkill => 
        relSkill.skill === skill.skill
      );
      return !isAlreadySelected;
    });
  };

  // Funktion zum Filtern der verfügbaren (nicht ausgewählten) Hobbys
  const getAvailableHobbies = () => {
    if (!hobbies || hobbies.length === 0) {
      return [];
    }
    
    // Filtere alle Hobbys, die noch nicht in relevantHobbies sind
    return hobbies.filter(hobby => {
      // Prüfe, ob dieses Hobby bereits in relevantHobbies ist (nur nach Hobby-Name)
      const isAlreadySelected = relevantHobbies.some(relHobby => 
        relHobby.hobby === hobby.hobby
      );
      return !isAlreadySelected;
    });
  };

  // Funktion zum Filtern der verfügbaren (nicht ausgewählten) Weiteren Angaben
  const getAvailableAdditionalInfo = () => {
    if (!additionalInfo || additionalInfo.length === 0) {
      return [];
    }
    
    // Filtere alle Weiteren Angaben, die noch nicht in relevantAdditionalInfo sind
    return additionalInfo.filter(info => {
      // Prüfe, ob diese Information bereits in relevantAdditionalInfo ist (nur nach Info-Titel)
      const isAlreadySelected = relevantAdditionalInfo.some(relInfo => 
        relInfo.info === info.info
      );
      return !isAlreadySelected;
    });
  };

  // Funktion zum Filtern der verfügbaren (nicht ausgewählten) Sprachen
  const getAvailableLanguages = () => {
    if (!languages || languages.length === 0) {
      return [];
    }
    
    // Filtere alle Sprachen, die noch nicht in relevantLanguages sind
    return languages.filter(lang => {
      // Prüfe, ob diese Sprache bereits in relevantLanguages ist (nur nach Sprachen-Name)
      const isAlreadySelected = relevantLanguages.some(relLang => 
        relLang.language === lang.language
      );
      return !isAlreadySelected;
    });
  };

  // Funktion zum Filtern der verfügbaren (nicht ausgewählten) Branchen
  const getAvailableIndustries = () => {
    if (!industryExperiences || industryExperiences.length === 0) {
      return [];
    }
    
    // Filtere alle Branchen, die noch nicht in relevantIndustries sind
    return industryExperiences.filter(industry => {
      // Prüfe, ob diese Branche bereits in relevantIndustries ist (nur nach Branchen-Name)
      const isAlreadySelected = relevantIndustries.some(relIndustry => 
        relIndustry.industry === industry.industry
      );
      return !isAlreadySelected;
    });
  };

  // Event Listener für IT-Skills-Modal
  React.useEffect(() => {
    const handleOpenItSkillsModal = (event: any) => {
      if (event.detail && event.detail.title) {
        setCurrentItSkillsTitle(event.detail.title);
      }
      setShowItSkillsModal(true);
    };
    
    window.addEventListener('openItSkillsModal', handleOpenItSkillsModal);
    
    return () => {
      window.removeEventListener('openItSkillsModal', handleOpenItSkillsModal);
    };
  }, []);

  // Event Listener für Branchen-Modal
  React.useEffect(() => {
    const handleOpenIndustriesModal = (event: any) => {
      if (event.detail && event.detail.title) {
        setCurrentIndustriesTitle(event.detail.title);
      }
      setShowIndustriesModal(true);
    };
    
    window.addEventListener('openIndustriesModal', handleOpenIndustriesModal);
    
    return () => {
      window.removeEventListener('openIndustriesModal', handleOpenIndustriesModal);
    };
  }, []);

  // Event Listener für Sprachen-Modal
  React.useEffect(() => {
    const handleOpenLanguagesModal = (event: any) => {
      if (event.detail && event.detail.title) {
        setCurrentLanguagesTitle(event.detail.title);
      }
      setShowLanguagesModal(true);
    };
    
    window.addEventListener('openLanguagesModal', handleOpenLanguagesModal);
    
    return () => {
      window.removeEventListener('openLanguagesModal', handleOpenLanguagesModal);
    };
  }, []);

  // Event Listener für Hobbies-Modal
  React.useEffect(() => {
    const handleOpenHobbiesModal = (event: any) => {
      if (event.detail && event.detail.title) {
        setCurrentHobbiesTitle(event.detail.title);
      }
      setShowHobbiesModal(true);
    };
    
    window.addEventListener('openHobbiesModal', handleOpenHobbiesModal);
    
    return () => {
      window.removeEventListener('openHobbiesModal', handleOpenHobbiesModal);
    };
  }, []);

  // Event Listener für das Weitere-Angaben-Modal
  React.useEffect(() => {
    const handleOpenAdditionalInfoModal = (event: any) => {
      if (event.detail && event.detail.title) {
        setCurrentAdditionalInfoTitle(event.detail.title);
      }
      setShowAdditionalInfoModal(true);
    };
    
    window.addEventListener('openAdditionalInfoModal', handleOpenAdditionalInfoModal);
    
    return () => {
      window.removeEventListener('openAdditionalInfoModal', handleOpenAdditionalInfoModal);
    };
  }, []);

  // Event Listener für das Ausbildung-Modal
  React.useEffect(() => {
    const handleOpenEducationModal = (event: any) => {
      if (event.detail && event.detail.title) {
        setCurrentEducationTitle(event.detail.title);
      }
      setShowEducationModal(true);
    };
    
    window.addEventListener('openEducationModal', handleOpenEducationModal);
    
    return () => {
      window.removeEventListener('openEducationModal', handleOpenEducationModal);
    };
  }, []);

  // Event Listener für das Berufserfahrungen-Modal
  React.useEffect(() => {
    const handleOpenWorkExperienceModal = (event: any) => {
      if (event.detail && event.detail.workExperience) {
        setSelectedWorkExperience(event.detail.workExperience);
        setOriginalWorkExperience(event.detail.workExperience);
        setIsNonRelevantWorkExperience(event.detail.isNonRelevant || false);
        
        // Verwende den vom CV-Template übergebenen Titel, falls vorhanden
        if (event.detail.title) {
          setCurrentWorkExperienceTitle(event.detail.title);
        } else {
          // Fallback: Setze den Titel basierend auf der Relevanz der Berufserfahrung
          if (event.detail.isNonRelevant) {
            // Für nicht-relevante Berufserfahrungen: "Weitere Berufserfahrungen"
            setCurrentWorkExperienceTitle('Weitere Berufserfahrungen');
          } else {
            // Für relevante Berufserfahrungen: "Beruflicher Werdegang"
            setCurrentWorkExperienceTitle('Beruflicher Werdegang');
          }
        }
      }
      setShowWorkExperienceModal(true);
    };
    
    window.addEventListener('openWorkExperienceModal', handleOpenWorkExperienceModal);
    
    return () => {
      window.removeEventListener('openWorkExperienceModal', handleOpenWorkExperienceModal);
    };
  }, []);

  // Event Listener für das Profil-Modal
  React.useEffect(() => {
    const handleOpenProfileModal = (event: any) => {
      if (event.detail && event.detail.title) {
        setCurrentProfileTitle(event.detail.title);
      }
      // Initialisiere temporäre Werte beim Öffnen des Modals
      initializeProfileModal();
      setShowProfileModal(true);
    };
    
    window.addEventListener('openProfileModal', handleOpenProfileModal);
    
    return () => {
      window.removeEventListener('openProfileModal', handleOpenProfileModal);
    };
  }, []);

  // Event Listener für das Profilbild-Modal
  React.useEffect(() => {
    const handleOpenProfileImageModal = (event: any) => {
      // Setze temporäre Werte beim Öffnen des Modals
      setTempProfileImageBorder(profileImageBorder);
      setTempProfileImageBorderColor(profileImageBorderColor);
      setTempProfileImageBorderThickness(profileImageBorderThickness);
      setShowProfileImageModal(true);
    };
    
    window.addEventListener('openProfileImageModal', handleOpenProfileImageModal);
    
    return () => {
      window.removeEventListener('openProfileImageModal', handleOpenProfileImageModal);
    };
  }, [profileImageBorder, profileImageBorderColor, profileImageBorderThickness]);

  // Handler für das Schließen des Profilbild-Modals
  const handleCloseProfileImageModal = () => {
    // Übernehme die temporären Werte beim Schließen
    setProfileImageBorder(tempProfileImageBorder);
    setProfileImageBorderColor(tempProfileImageBorderColor);
    setProfileImageBorderThickness(tempProfileImageBorderThickness);
    setShowProfileImageModal(false);
  };

  // Event Listener für Textfarben-Modal
  React.useEffect(() => {
    const handleOpenTextColorPalette = () => {
      setShowTextColorPalette(true);
    };
    
    window.addEventListener('openTextColorPalette', handleOpenTextColorPalette);
    
    return () => {
      window.removeEventListener('openTextColorPalette', handleOpenTextColorPalette);
    };
  }, []);

  // Globaler Keyboard Event Listener für CTRL+V ins Stellenbeschreibung-Textfeld
  React.useEffect(() => {
    const handleGlobalPaste = async (e: KeyboardEvent) => {
      // Prüfe ob CTRL+V (oder CMD+V auf Mac) gedrückt wurde
      const isCtrlV = (e.ctrlKey || e.metaKey) && e.key === 'v';
      
      if (!isCtrlV) return;
      
      // Prüfe ob Stellenbeschreibung-Textfeld sichtbar ist
      const isJobDescriptionVisible = !hideJobDescription && !extracting;
      
      // Prüfe ob Textfeld leer ist
      const isJobDescriptionEmpty = !jobDescription || !jobDescription.trim();
      
      // Nur wenn sichtbar und leer
      if (isJobDescriptionVisible && isJobDescriptionEmpty) {
        try {
          // Lese Text aus Zwischenablage
          const clipboardText = await navigator.clipboard.readText();
          
          if (clipboardText && clipboardText.trim()) {
            // Reset language detection (wie in handleJobDescriptionChange)
            setLanguageDetected(false);
            
            // Füge Text ins Textfeld ein
            setJobDescription(clipboardText);
            console.log('📋 Text aus Zwischenablage eingefügt');
            
            // Automatische Spracherkennung nach Copy/Paste
            if (clipboardText.trim().length > 10) {
              console.log('🔍 Starte Spracherkennung nach Copy/Paste...');
              await detectJobDescriptionLanguage(clipboardText.trim());
            }
            
            // Optional: Fokussiere das Textfeld
            // Das Textfeld wird automatisch durch den Wert-Update fokussiert
          }
        } catch (error) {
          console.error('❌ Fehler beim Lesen der Zwischenablage:', error);
        }
      }
    };
    
    // Füge Event Listener hinzu
    window.addEventListener('keydown', handleGlobalPaste);
    
    return () => {
      window.removeEventListener('keydown', handleGlobalPaste);
    };
  }, [hideJobDescription, extracting, jobDescription]);

  // Event Listener für Titel-Änderungen im Modal
  React.useEffect(() => {
    const handleTitleChange = () => {
      const event = new CustomEvent('updateItSkillsTitle', {
        detail: { title: currentItSkillsTitle }
      });
      window.dispatchEvent(event);
    };
    handleTitleChange();
  }, [currentItSkillsTitle]);

  React.useEffect(() => {
    const handleTitleChange = () => {
      const event = new CustomEvent('updateIndustriesTitle', {
        detail: { title: currentIndustriesTitle }
      });
      window.dispatchEvent(event);
    };
    handleTitleChange();
  }, [currentIndustriesTitle]);

  React.useEffect(() => {
    const handleTitleChange = () => {
      const event = new CustomEvent('updateLanguagesTitle', {
        detail: { title: currentLanguagesTitle }
      });
      window.dispatchEvent(event);
    };
    handleTitleChange();
  }, [currentLanguagesTitle]);

  React.useEffect(() => {
    const handleTitleChange = () => {
      const event = new CustomEvent('updateHobbiesTitle', {
        detail: { title: currentHobbiesTitle }
      });
      window.dispatchEvent(event);
    };
    handleTitleChange();
  }, [currentHobbiesTitle]);

  React.useEffect(() => {
    const handleTitleChange = () => {
      const event = new CustomEvent('updateEducationTitle', {
        detail: { title: currentEducationTitle }
      });
      window.dispatchEvent(event);
    };
    handleTitleChange();
  }, [currentEducationTitle]);

  // Event Listener für Berufserfahrungen-Titel-Änderungen
  React.useEffect(() => {
    const handleTitleChange = () => {
      // Nur ausführen, wenn das Modal geöffnet ist
      if (!showWorkExperienceModal) {
        return;
      }
      
      if (isNonRelevantWorkExperience) {
        // Für nicht-relevante Berufserfahrungen: "Weitere Berufserfahrungen" Titel aktualisieren
        const event = new CustomEvent('updateAdditionalWorkExperienceTitle', {
          detail: { title: currentWorkExperienceTitle }
        });
        window.dispatchEvent(event);
      } else {
        // Für relevante Berufserfahrungen: "Beruflicher Werdegang" Titel aktualisieren
        const event = new CustomEvent('updateWorkExperienceTitle', {
          detail: { title: currentWorkExperienceTitle }
        });
        window.dispatchEvent(event);
      }
    };
    handleTitleChange();
  }, [currentWorkExperienceTitle, isNonRelevantWorkExperience, showWorkExperienceModal]);

  React.useEffect(() => {
    const handleTitleChange = () => {
      const event = new CustomEvent('updateProfileTitle', {
        detail: { title: currentProfileTitle }
      });
      window.dispatchEvent(event);
    };
    handleTitleChange();
  }, [currentProfileTitle]);

  React.useEffect(() => {
    const handleTitleChange = () => {
      const event = new CustomEvent('updateAdditionalInfoTitle', {
        detail: { title: currentAdditionalInfoTitle }
      });
      window.dispatchEvent(event);
    };
    handleTitleChange();
  }, [currentAdditionalInfoTitle]);

  // Aktualisiere den Titel wenn sich die Zielsprache ändert
  React.useEffect(() => {
    const getTranslatedTitle = (key: string) => {
      if (targetLanguage === 'englisch') {
        switch (key) {
          case 'KERNKOMPETENZEN': return 'Core Competencies';
          case 'ZERTIFIZIERUNG': return 'Certifications';
          case 'INFORMATIK': return 'IT Skills';
          case 'BRANCHEN': return 'Industries';
          case 'SPRACHEN': return 'Languages';
          case 'HOBBYS': return 'Hobbies';
          case 'AUSBILDUNG': return 'Education';
          case 'BERUFLICHER WERDEGANG': return 'Work Experience';
          case 'PROFIL': return 'Profile';
          default: return key;
        }
      } else {
        switch (key) {
          case 'KERNKOMPETENZEN': return 'Kernkompetenzen';
          case 'ZERTIFIZIERUNG': return 'Zertifizierungen';
          case 'INFORMATIK': return 'Informatik';
          case 'BRANCHEN': return 'Branchen';
          case 'SPRACHEN': return 'Sprachen';
          case 'HOBBYS': return 'Hobbies';
          case 'AUSBILDUNG': return 'Ausbildung';
          case 'BERUFLICHER WERDEGANG': return 'Beruflicher Werdegang';
          case 'PROFIL': return 'Profil';
          default: return key;
        }
      }
    };

    // Übersetzungsfunktion für "Jahre"
    const getTranslatedYears = () => {
      return targetLanguage === 'englisch' ? 'Years' : 'Jahre';
    };
    
    setCurrentCoreCompetenciesTitle(getTranslatedTitle('KERNKOMPETENZEN'));
    setCurrentCertificationsTitle(getTranslatedTitle('ZERTIFIZIERUNG'));
    setCurrentItSkillsTitle(getTranslatedTitle('INFORMATIK'));
    setCurrentIndustriesTitle(getTranslatedTitle('BRANCHEN'));
    setCurrentLanguagesTitle(getTranslatedTitle('SPRACHEN'));
    setCurrentHobbiesTitle(getTranslatedTitle('HOBBYS'));
    setCurrentEducationTitle(getTranslatedTitle('AUSBILDUNG'));
    setCurrentWorkExperienceTitle(getTranslatedTitle('BERUFLICHER WERDEGANG'));
    setCurrentProfileTitle(getTranslatedTitle('PROFIL'));
    setTranslatedYears(getTranslatedYears());
  }, [targetLanguage]);
  
  
  // Funktion zum Konvertieren von File zu Base64
  const convertFileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const result = reader.result as string;
        // Entferne den Data URL Prefix (z.B. "data:application/pdf;base64,")
        const base64 = result.split(',')[1];
        resolve(base64);
      };
      reader.onerror = error => reject(error);
    });
  };
  
  // Vereinfachte Checkbox-Logik: Firebase wird nur bei Checkbox-Klick aktualisiert
  const [hasInitialized, setHasInitialized] = React.useState(false);
  const [isLoadingFromFirebase, setIsLoadingFromFirebase] = React.useState(false);
  
  
  // State für das Ausblenden der Match-Ergebnisse
  const [hideMatchResults, setHideMatchResults] = useState(false);
  
  // Separate State-Variablen für Button-Sichtbarkeit
  const [showPassgenauigkeitButton, setShowPassgenauigkeitButton] = useState(true);
  const [showCvOptimierenButton, setShowCvOptimierenButton] = useState(true);
  
  // Handler zum Hinzufügen einer neuen Ausbildung
  const handleAddEducation = () => {
    setEducations(prev => [{ institution: '', degree: '', startDate: '', endDate: '' }, ...prev]);
    setHasUnsavedChanges(true);
  };

  // Handler zum Ändern der neuen Ausbildung
  const handleNewEducationChange = useCallback((field: string, value: string) => {
    setNewEducation(prev => ({ ...prev, [field]: value }));
  }, []);

  // Handler zum Hinzufügen der neuen Ausbildung
  const handleAddNewEducation = () => {
    setEducations(prev => [newEducation, ...prev]);
    setNewEducation({ institution: '', degree: '', startDate: '', endDate: '' });
    setShowNewEducationForm(false);
  };

  // Handler zum Löschen einer Ausbildung
  const handleDeleteEducation = (idx: number) => {
    setEducations(prev => prev.filter((_, i) => i !== idx));
    setHasUnsavedChanges(true);
  };

  // Handler zum Editieren einer Ausbildung
  const handleEducationChange = useCallback((idx: number, field: string, value: string) => {
    setEducations(prev => {
      const newEducations = [...prev];
      newEducations[idx] = { ...newEducations[idx], [field]: value };
      return newEducations;
    });
    setHasUnsavedChanges(true);
  }, []);

  // Handler zum Hinzufügen einer neuen Zertifizierung
  const handleAddCertification = () => {
    setCertifications(prev => [{ name: '', issuer: '', date: '' }, ...prev]);
    setHasUnsavedChanges(true);
  };

  // Handler zum Löschen einer Zertifizierung
  const handleDeleteCertification = (idx: number) => {
    setCertifications(prev => prev.filter((_, i) => i !== idx));
    setHasUnsavedChanges(true);
  };

  // Handler zum Editieren einer Zertifizierung
  const handleCertificationChange = useCallback((idx: number, field: string, value: string) => {
    setCertifications(prev => {
      const newCertifications = [...prev];
      newCertifications[idx] = { ...newCertifications[idx], [field]: value };
      return newCertifications;
    });
    setHasUnsavedChanges(true);
  }, []);

  // Handler zum Editieren eines Hobbys
  const handleHobbyChange = useCallback((idx: number, field: string, value: string) => {
    setHobbies(prev => {
      const newHobbies = [...prev];
      newHobbies[idx] = { ...newHobbies[idx], [field]: value };
      return newHobbies;
    });
    setHasUnsavedChanges(true);
  }, []);


  // Sprachwechsel-Handler
  const handleLanguageChange = (language: string) => {
    setCurrentLanguage(language);
    changeLanguage(language);
  };

  // Globaler Keyboard Event Listener für Enter-Taste → Passgenauigkeit prüfen
  React.useEffect(() => {
    const handleGlobalEnter = (e: KeyboardEvent) => {
      // Prüfe ob Enter gedrückt wurde (ohne Shift)
      if (e.key !== 'Enter' || e.shiftKey) return;
      
      // Prüfe ob gerade ein Textfeld/Textarea fokussiert ist (außer Stellenbeschreibung)
      // Damit Enter in anderen Feldern normal funktioniert
      const activeElement = document.activeElement;
      const isInputFocused = activeElement && (
        activeElement.tagName === 'INPUT' || 
        activeElement.tagName === 'TEXTAREA' ||
        activeElement.getAttribute('contenteditable') === 'true'
      );
      
      // Wenn ein anderes Input-Element fokussiert ist, nicht abfangen
      // (Stellenbeschreibung-Textfeld hat eigenen onKeyDown Handler)
      if (isInputFocused) return;
      
      // Prüfe ob Stellenbeschreibung-Textfeld sichtbar ist
      const isJobDescriptionVisible = !hideJobDescription && !extracting;
      
      // Prüfe ob Button aktiviert ist (nicht disabled)
      const isButtonEnabled = !checkingMatch && hasData() && 
                              jobDescription && jobDescription.trim();
      
      // Nur wenn alles passt: Passgenauigkeit prüfen
      if (isJobDescriptionVisible && isButtonEnabled && !checkingMatch && !optimizing) {
        e.preventDefault();
        console.log('⌨️ Enter gedrückt - starte Passgenauigkeitsprüfung');
        handleCheckMatchScore();
      }
    };
    
      // Füge Event Listener hinzu
    window.addEventListener('keydown', handleGlobalEnter);
    
    return () => {
      window.removeEventListener('keydown', handleGlobalEnter);
    };
  }, [hideJobDescription, extracting, 
      checkingMatch, optimizing, jobDescription]);

  // Überwache Änderungen im CV-Daten Modal
  React.useEffect(() => {
    if (!showCvDataModal) {
      // Setze hasUnsavedChanges zurück, wenn Modal geschlossen wird
      setHasUnsavedChanges(false);
      return;
    }

    const handleInput = () => {
      setHasUnsavedChanges(true);
    };

    // Lausche auf Input-Events im gesamten Dokument während Modal offen ist
    document.addEventListener('input', handleInput);
    document.addEventListener('change', handleInput);

    return () => {
      document.removeEventListener('input', handleInput);
      document.removeEventListener('change', handleInput);
    };
  }, [showCvDataModal]);

  // Funktion zum Löschen des aktuellen CVs
  const handleDeleteCv = async () => {
    if (!user || !selectedCvId) return;
    
    try {
      const idToken = await user.getIdToken();
      const response = await fetch(`${config.backend.baseUrl}/api/delete-cv/${selectedCvId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${idToken}`
        }
      });
      
      if (response.ok) {
        console.log('✅ CV erfolgreich gelöscht:', selectedCvId);
        
        // Bereinige localStorage, wenn das gelöschte CV das aktuelle war
        const savedCvId = localStorage.getItem('selectedCvId');
        if (savedCvId === selectedCvId) {
          localStorage.removeItem('selectedCvId');
        }
        
        // Schließe Dialog und Modal
        setShowDeleteCvDialog(false);
        setShowCvDataModal(false);
        
        // Lade CV-Liste neu
        const cvListResponse = await fetch(`${config.backend.baseUrl}/api/get-user-cvs`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${idToken}`
          }
        });
        
        if (cvListResponse.ok) {
          const cvListData = await cvListResponse.json();
          setUserCvs(cvListData.userCvs || []);
          
          // Wähle automatisch den ersten verfügbaren CV aus
          if (cvListData.userCvs && cvListData.userCvs.length > 0) {
            const defaultCv = cvListData.userCvs.find((cv: any) => cv.isDefault);
            const cvToSelect = defaultCv || cvListData.userCvs[0];
            if (cvToSelect && cvToSelect.cvId) {
              await handleSelectCv(cvToSelect.cvId);
            }
          } else {
            // Keine CVs mehr vorhanden
            setSelectedCvId(null);
            setCurrentCvName('');
            // Bereinige localStorage
            localStorage.removeItem('selectedCvId');
          }
        }
      } else {
        const errorData = await response.json();
        console.error('❌ Fehler beim Löschen:', errorData.error);
        setError('Fehler beim Löschen: ' + errorData.error);
      }
    } catch (error) {
      console.error('❌ Fehler beim Löschen des CVs:', error);
      setError('Fehler beim Löschen des CVs');
    }
  };

  // Funktion zum Export der CV-Daten als CSV
  const exportCvDataAsCsv = () => {
    if (!selectedCvId) {
      console.error('Kein CV ausgewählt');
      return;
    }
    
    // CSV-Header und Daten erstellen
    const csvRows = [];
    
    // Persönliche Informationen
    csvRows.push(['Kategorie', 'Feld', 'Wert']);
    csvRows.push(['Persönliche Daten', 'Name', fullName || '']);
    csvRows.push(['Persönliche Daten', 'Firma', company || '']);
    csvRows.push(['Persönliche Daten', 'Email', email || '']);
    csvRows.push(['Persönliche Daten', 'Telefon', phoneNumber || '']);
    csvRows.push(['Persönliche Daten', 'Adresse', address || '']);
    csvRows.push(['Persönliche Daten', 'PLZ', postalCode || '']);
    csvRows.push(['Persönliche Daten', 'Stadt', city || '']);
    csvRows.push(['Persönliche Daten', 'Land', country || '']);
    csvRows.push(['Persönliche Daten', 'Verfügbar ab', availableFrom || '']);
    csvRows.push(['Persönliche Daten', 'Geburtsjahr', birthYear || '']);
    csvRows.push(['Persönliche Daten', 'Nationalität', nationality || '']);
    csvRows.push(['Persönliche Daten', 'Aufenthaltsbewilligung', residencePermit || '']);
    csvRows.push(['Persönliche Daten', 'Familienstand', civilStatus || '']);
    csvRows.push(['', '', '']); // Leerzeile
    
    // Kurzprofil
    csvRows.push(['Kurzprofil', 'Text', shortProfile || '']);
    csvRows.push(['', '', '']); // Leerzeile
    
    // Berufserfahrung
    workExperiences.forEach((exp, index) => {
      csvRows.push([`Berufserfahrung ${index + 1}`, 'Position', exp.position || '']);
      csvRows.push([`Berufserfahrung ${index + 1}`, 'Firma', exp.company || '']);
      csvRows.push([`Berufserfahrung ${index + 1}`, 'Von', exp.startDate || '']);
      csvRows.push([`Berufserfahrung ${index + 1}`, 'Bis', exp.endDate || '']);
      csvRows.push([`Berufserfahrung ${index + 1}`, 'Beschreibung', exp.description || '']);
      csvRows.push(['', '', '']); // Leerzeile
    });
    
    // Ausbildung
    educations.forEach((edu, index) => {
      csvRows.push([`Ausbildung ${index + 1}`, 'Titel', edu.degree || '']);
      csvRows.push([`Ausbildung ${index + 1}`, 'Institution', edu.institution || '']);
      csvRows.push([`Ausbildung ${index + 1}`, 'Von', edu.startDate || '']);
      csvRows.push([`Ausbildung ${index + 1}`, 'Bis', edu.endDate || '']);
      csvRows.push(['', '', '']); // Leerzeile
    });
    
    // Zertifizierungen
    certifications.forEach((cert, index) => {
      csvRows.push([`Zertifizierung ${index + 1}`, 'Name', cert.name || '']);
      csvRows.push([`Zertifizierung ${index + 1}`, 'Aussteller', cert.issuer || '']);
      csvRows.push([`Zertifizierung ${index + 1}`, 'Datum', cert.date || '']);
      csvRows.push(['', '', '']); // Leerzeile
    });
    
    // Kernkompetenzen
    csvRows.push(['Kernkompetenzen', 'Liste', coreCompetencies.join(', ')]);
    csvRows.push(['', '', '']); // Leerzeile
    
    // IT-Skills
    csvRows.push(['IT-Skills', 'Liste', itSkills.join(', ')]);
    csvRows.push(['', '', '']); // Leerzeile
    
    // Sprachen
    languages.forEach((lang, index) => {
      csvRows.push([`Sprache ${index + 1}`, 'Sprache', lang.language || '']);
      csvRows.push([`Sprache ${index + 1}`, 'Level', lang.level || '']);
      csvRows.push(['', '', '']); // Leerzeile
    });
    
    // Hobbys
    csvRows.push(['Hobbys', 'Liste', hobbies.join(', ')]);
    csvRows.push(['', '', '']); // Leerzeile
    
    // Branchenerfahrungen
    industryExperiences.forEach((ind, index) => {
      csvRows.push([`Branchenerfahrung ${index + 1}`, 'Branche', ind.industry || '']);
      csvRows.push([`Branchenerfahrung ${index + 1}`, 'Jahre', ind.years || '']);
      csvRows.push(['', '', '']); // Leerzeile
    });
    
    // Weitere Angaben
    additionalInfo.forEach((info, index) => {
      csvRows.push([`Weitere Angaben ${index + 1}`, 'Text', info || '']);
    });
    
    // CSV-String erstellen
    const csvContent = csvRows
      .map(row => row.map(cell => `"${cell.toString().replace(/"/g, '""')}"`).join(','))
      .join('\n');
    
    // BOM für UTF-8 hinzufügen (für korrekte Umlaute in Excel)
    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
    
    // Download auslösen
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', `${currentCvName || 'CV-Daten'}_${new Date().toISOString().split('T')[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
    console.log('✅ CV-Daten als CSV exportiert');
  };

  // Funktion zum Laden eines spezifischen CVs
  const handleSelectCv = async (cvId: string, openModal: boolean = false, setAsDefault: boolean = true) => {
    if (!user || !cvId) {
      console.error('❌ handleSelectCv: Kein User oder keine cvId', { user: !!user, cvId });
      return;
    }
    
    // Prüfe ob CV gewechselt wird (nicht nur erstmalige Auswahl)
    const previousCvId = selectedCvId;
    const isCvChanged = previousCvId !== null && previousCvId !== cvId;
    
    // Wenn CV gewechselt wird, lösche Passgenauigkeit und optimierte Daten
    // (da sie sich auf das vorherige CV beziehen)
    if (isCvChanged) {
      console.log('🔄 CV gewechselt:', previousCvId, '->', cvId, '- Lösche Passgenauigkeit und optimierte Daten');
      clearOptimizedAndMatchData();
      setSelectedApplicationId(null); // Application bezieht sich auch auf das vorherige CV
      setCvTemplateHasBeenOpened(false); // Deaktiviere Motivationsschreiben-Icon
    }
    
    try {
      setSelectedCvId(cvId);
      // Speichere selectedCvId im localStorage
      localStorage.setItem('selectedCvId', cvId);
      
      setIsLoading(true);
      
      const idToken = await user.getIdToken();
      
      // Setze CV als Standard-CV im Backend (nur wenn setAsDefault true ist)
      if (setAsDefault) {
        try {
          await fetch(`${config.backend.baseUrl}/api/set-default-cv/${cvId}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${idToken}`
            }
          });
          console.log('✅ CV als Standard gesetzt:', cvId);
        } catch (error) {
          console.error('❌ Fehler beim Setzen des Standard-CVs:', error);
          // Weiter machen, auch wenn das Setzen als Standard fehlschlägt
        }
      }
      const response = await fetch(`${config.backend.baseUrl}/api/get-encrypted-data/${cvId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        }
      });

      if (response.ok) {
        const result = await response.json();
        const data = result.data || {};
        
        // Setze alle Daten aus der verschlüsselten Antwort
        setFullName(data?.fullName || "");
        setCompany(data?.company || "");
        setAddress(data?.address || "");
        setPostalCode(data?.postalCode || "");
        setCity(data?.city || "");
        setCountry(data?.country || "");
        setAvailableFrom(data?.availableFrom || "");
        setPhoneNumber(data?.phoneNumber || "");
        setEmail(data?.email || "");
        setBirthYear(data?.birthYear || "");
        setNationality(mapNationalityToSelectValue(data?.nationality || ""));
        setResidencePermit(data?.residencePermit || "");
        setCivilStatus(mapCivilStatusToSelectValue(data?.civilStatus || ""));
        setShortProfile(data?.shortProfile || "");
        
        // Arrays
        setWorkExperiences(data?.workExperiences || []);
        setEducations(data?.educations || []);
        setCertifications(data?.certifications || []);
        setIndustryExperiences(data?.industryExperiences || []);
        setLanguages(Array.isArray(data?.languages) ? data.languages : []);
        setCoreCompetencies(Array.isArray(data?.coreCompetencies) ? data.coreCompetencies : []);
        setItSkills(Array.isArray(data?.itSkills) ? data.itSkills : []);
        setHobbies(Array.isArray(data?.hobbies) ? data.hobbies : []);
        setAdditionalInfo(Array.isArray(data?.additionalInfo) ? data.additionalInfo : []);
        
        // Profilfoto
        if (data?.profileImage) {
          if (typeof data.profileImage === 'string') {
            setProfileImage(data.profileImage);
          } else if (data.profileImage.data) {
            setProfileImage(`data:${data.profileImage.type};base64,${data.profileImage.data}`);
          }
        } else {
          setProfileImage(null);
        }
        
        // Signatur
        if (data?.signature) {
          if (typeof data.signature === 'string') {
            setSignature(data.signature);
          } else if (data.signature.data) {
            setSignature(`data:${data.signature.type};base64,${data.signature.data}`);
          }
        } else {
          setSignature(null);
        }
        
        setIsLoading(false);
        
        // Setze CV-Namen
        setCurrentCvName(result.cvName || '');
        
        // Öffne Modal wenn gewünscht
        if (openModal) {
          // skipReload=true verhindert, dass direkt danach erneut mit alter selectedCvId geladen wird
          await openCvDataModal(false, true); // false = normaler Klick, true = skipReload
        }
      } else {
        console.error('❌ Fehler beim Laden der CV-Daten:', response.statusText);
        setIsLoading(false);
      }
    } catch (error) {
      console.error('❌ Fehler beim Laden des CVs:', error);
      setIsLoading(false);
    }
  };

  // HINWEIS: Der alte fetchCv useEffect wurde entfernt
  // CV-Auswahl erfolgt jetzt über die Tabelle mit Radio Buttons
  // Die automatische Auswahl des Standard-/neuesten CVs passiert in der loadUserCvs Funktion

  // Automatische Tab-Auswahl nur beim ersten Laden der App
  React.useEffect(() => {
    // Warte bis alle Daten geladen sind: App geladen, User vorhanden, CV-Daten geladen
    if (hasLoaded && user && cvDataLoaded && !tabSelectionExecuted) {
      const hasDataResult = hasData();
      console.log('🔍 Tab-Auswahl Debug (nur beim App-Start):', {
        hasLoaded,
        cvDataLoaded,
        hasDataResult,
        fullName,
        company,
        workExperiencesLength: workExperiences?.length || 0,
        educationsLength: educations?.length || 0,
        languagesLength: languages?.length || 0,
        userCvsLength: userCvs?.length || 0
      });
      
      if (hasDataResult) {
        // CV-Daten vorhanden → "Bewerbungen" Tab (Index 0 = "Start")
        setCvTabIndex(0);
        console.log('✅ CV-Daten vorhanden - zeige "Bewerbungen" Tab (Index 0)');
      } else {
        // Keine CV-Daten → "CV Daten" Tab (Index 1)
        setCvTabIndex(1);
        console.log('ℹ️ Keine CV-Daten - zeige "CV Daten" Tab (Index 1)');
      }
      
      // Markiere Tab-Auswahl als ausgeführt
      setTabSelectionExecuted(true);
    }
  }, [hasLoaded, user, cvDataLoaded, userCvs, tabSelectionExecuted]); // Warte auf cvDataLoaded

  // DEAKTIVIERT: Automatisches Speichern von CV-Daten
  // CV-Daten werden jetzt nur noch gespeichert, wenn die Checkbox "Daten sind wahrheitsgetreu" auf true gesetzt wird
  // React.useEffect(() => {
  //   if (!user || !hasLoaded) return; // Warte bis Daten geladen sind
  //   
  //   // Nur speichern wenn tatsächlich Daten vorhanden sind
  //   const hasData = fullName || company || address || postalCode || city || phoneNumber || email || birthYear || nationality || residencePermit || civilStatus || shortProfile || workExperience || education || certificates || 
  //                  (Array.isArray(languages) && languages.length > 0) || 
  //                  (Array.isArray(coreCompetencies) && coreCompetencies.length > 0) || 
  //                  (Array.isArray(itSkills) && itSkills.length > 0) || 
  //                  (Array.isArray(hobbies) && hobbies.length > 0) || 
  //                  (Array.isArray(additionalInfo) && additionalInfo.length > 0) ||
  //                  (Array.isArray(workExperiences) && workExperiences.length > 0) || 
  //                  (Array.isArray(educations) && educations.length > 0) || 
  //                  (Array.isArray(certifications) && certifications.length > 0) || 
  //                  (Array.isArray(industryExperiences) && industryExperiences.length > 0) ||
  //                  profileImage || signature;
  //   
  //   if (hasData) {
  //     // Verwende Backend-Endpoint für automatische Klassifizierung und Verschlüsselung
  //     const saveData = async () => {
  //       try {
  //         // Echten Firebase ID Token für Backend-Authentication verwenden
  //         const idToken = await user.getIdToken();
  //         const response = await fetch(`${config.backend.saveDataUrl}`, {
  //           method: 'POST',
  //           headers: {
  //             'Content-Type': 'application/json',
  //             'Authorization': `Bearer ${idToken}`
  //           },
  //           body: JSON.stringify({
  //             uid: user.uid,
  //             data: {
  //               fullName,
  //               company,
  //               address,
  //               postalCode,
  //               city,
  //               country,
  //               availableFrom,
  //               phoneNumber,
  //               email,
  //               birthYear,
  //               nationality,
  //               residencePermit,
  //               civilStatus,
  //               shortProfile,
  //               workExperience,
  //               education,
  //               certificates,
  //               languages,
  //               coreCompetencies,
  //               itSkills,
  //               hobbies,
  //               additionalInfo,
  //               workExperiences,
  //               educations,
  //               certifications,
  //               industryExperiences,
  //               profileImage,
  //               signature,
  //             }
  //           })
  //         });

  //         if (response.ok) {
  //           const result = await response.json();
  //           console.log('🔒 Daten erfolgreich klassifiziert und verschlüsselt gespeichert:', result.classification);
  //         } else {
  //           console.error('Fehler beim Speichern verschlüsselter Daten');
  //         }
  //       } catch (error) {
  //         console.error('Fehler beim Speichern verschlüsselter Daten:', error);
  //       }
  //     };

  //     saveData();
  //   }
  // }, [fullName, address, phoneNumber, email, birthYear, nationality, residencePermit, civilStatus, shortProfile, workExperience, education, certificates, languages, itSkills, additionalInfo, workExperiences, educations, certifications, industryExperiences, coreCompetencies, profileImage, signature, country, availableFrom, user, hasLoaded]);

  // Debug useEffect für Profilbild-Status
  // Profilbild Debug-Log entfernt für bessere Performance

  // Funktion zum Upload von Original-Dokumenten


  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setCvFile(file);
      
      // Setze Checkbox "Daten sind wahrheitsgetreu" auf false beim CV-Upload
      
      // Prüfe Dateityp
      const fileExt = file.name.split('.').pop()?.toLowerCase();
      if (!fileExt || !['docx', 'doc', 'pdf', 'txt'].includes(fileExt)) {
        setError('Nur Word-Dateien (.docx, .doc), PDF-Dateien (.pdf) und Text-Dateien (.txt) werden unterstützt.');
        return;
      }
      
      // Prüfe Dateigröße (max 10MB)
      if (file.size > 10 * 1024 * 1024) {
        setError('Datei ist zu groß. Maximale Größe: 10MB.');
        return;
      }
      
      // Sende Original-Dokument direkt an Backend
      uploadOriginalDocument(file);
    }
  };





  // Hilfsfunktionen für Text-Extraktion
  const extractNameFromText = (text: string): string => {
    // Suche nach Namen am Anfang des Texts
    const lines = text.split('\n').map(line => line.trim()).filter(line => line.length > 0);
    for (const line of lines.slice(0, 5)) {
      // Suche nach Namen mit Großbuchstaben
      const nameMatch = line.match(/^([A-ZÄÖÜ][a-zäöüß]+(?:\s+[A-ZÄÖÜ][a-zäöüß]+)+)/);
      if (nameMatch) {
        return nameMatch[1];
      }
    }
    return '';
  };

  const extractProfileFromText = (text: string): string => {
    // Suche nach Profil/Über mich Abschnitt
    const profileMatch = text.match(/(?:profil|über mich|about|summary)[:\s]*([^\n]+)/i);
    if (profileMatch) {
      return profileMatch[1].trim();
    }
    return '';
  };

  const extractWorkExperienceFromText = (text: string): Array<{position: string, company: string, startDate: string, endDate: string, description: string}> => {
    const experiences = [];
    const lines = text.split('\n');
    
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].toLowerCase();
      if (line.includes('arbeit') || line.includes('beruf') || line.includes('experience') || line.includes('position')) {
        // Versuche die nächsten Zeilen als Arbeitserfahrung zu parsen
        if (i + 1 < lines.length) {
          const nextLine = lines[i + 1];
          const positionMatch = nextLine.match(/([^,]+)/);
          if (positionMatch) {
            experiences.push({
              position: positionMatch[1].trim(),
              company: 'Unternehmen',
              startDate: '2020',
              endDate: '2023',
              description: getTranslatedCvLabel('Beschreibung wird extrahiert')
            });
          }
        }
      }
    }
    
    return experiences;
  };

  const extractEducationFromText = (text: string): Array<{degree: string, institution: string, startDate: string, endDate: string}> => {
    const education = [];
    const lines = text.split('\n');
    
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].toLowerCase();
      if (line.includes('bildung') || line.includes('education') || line.includes('studium') || line.includes('ausbildung')) {
        if (i + 1 < lines.length) {
          const nextLine = lines[i + 1];
          const degreeMatch = nextLine.match(/([^,]+)/);
          if (degreeMatch) {
            education.push({
              degree: degreeMatch[1].trim(),
              institution: 'Institution',
              startDate: '2015',
              endDate: '2019'
            });
          }
        }
      }
    }
    
    return education;
  };

  const extractSkillsFromText = (text: string): Array<{skill: string, level: string}> => {
    const skills = [];
    const lines = text.split('\n');
    
    for (const line of lines) {
      const skillMatch = line.match(/(?:javascript|python|java|react|node|sql|html|css|typescript|angular|vue|php|ruby|go|rust|swift|kotlin|scala|r|matlab|excel|word|powerpoint|photoshop|illustrator|figma|sketch|git|docker|kubernetes|aws|azure|gcp|linux|windows|mac|agile|scrum|kanban|jira|confluence|slack|teams|zoom|microsoft office|adobe|autocad|solidworks|blender|unity|unreal|tableau|power bi|salesforce|hubspot|wordpress|shopify|magento|woocommerce|drupal|joomla|laravel|django|flask|express|spring|hibernate|jpa|mybatis|mongodb|postgresql|mysql|oracle|redis|elasticsearch|kafka|rabbitmq|nginx|apache|tomcat|jetty|wildfly|docker|kubernetes|openshift|rancher|terraform|ansible|chef|puppet|jenkins|gitlab|github|bitbucket|circleci|travis|teamcity|sonarqube|junit|testng|selenium|cypress|jest|mocha|chai|pytest|unittest|mockito|powermock|wiremock|rest assured|postman|soapui|jmeter|gatling|k6|locust|prometheus|grafana|elk|splunk|datadog|newrelic|appdynamics|wireshark|fiddler|charles|burp|nmap|metasploit|wireshark|tcpdump|netstat|ss|lsof|strace|ltrace|gdb|valgrind|perf|htop|iotop|nethogs|iftop|tcpflow|ngrep|tshark|tcpflow|ngrep|tshark)/i);
      if (skillMatch) {
        skills.push({
          skill: skillMatch[1],
          level: 'Fortgeschritten'
        });
      }
    }
    
    return skills;
  };

  // QR-Code für Foto-Upload generieren
  const generatePhotoQrCode = async () => {
    if (!user) {
      setError('Kein User angemeldet');
      return;
    }
    
    setIsGeneratingQr(true);
    setError(null);
    
    try {
      // QR-Code-Generierung gestartet
      const idToken = await user.getIdToken();
      console.log('🔐 ID Token erhalten');
      
      const requestUrl = `${config.backend.baseUrl}/api/generate-photo-qr`;
      console.log('🌐 Request URL:', requestUrl);
      
      const response = await fetch(requestUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        }
      });
      
      console.log('📥 Response Status:', response.status, response.statusText);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ Response Error:', errorText);
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }
      
      const data = await response.json();
      console.log('📦 Response Data:', data);
      
      if (data.success && data.qrCode) {
        console.log('✅ QR-Code erhalten, Länge:', data.qrCode.length);
        setQrCodeData(data.qrCode);
        setQrSessionId(data.sessionId);
        setQrExpiresAt(data.expiresAt);
        setShowQrCodeDialog(true);
        console.log('✅ QR-Code Dialog geöffnet');
      } else {
        console.error('❌ Kein QR-Code in Response:', data);
        throw new Error('QR-Code konnte nicht generiert werden');
      }
      
    } catch (error) {
      console.error('❌ Fehler beim Generieren des QR-Codes:', error);
      setError('Fehler beim Generieren des QR-Codes: ' + (error as Error).message);
    } finally {
      setIsGeneratingQr(false);
    }
  };

  // QR-Code Session Status prüfen
  const checkQrSessionStatus = async () => {
    if (!qrSessionId || !user) return;
    
    try {
      const idToken = await user.getIdToken();
      
      // Prüfe ob das Foto hochgeladen wurde
      const response = await fetch(`${config.backend.userDataUrl}/${user.uid}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        }
      });
      
      if (response.ok) {
        const result = await response.json();
        const data = result.data || {};
        
        // Prüfe ob ein neues Foto hochgeladen wurde - unterstützt beide Formate
        if (data?.profileImage) {
          if (typeof data.profileImage === 'string') {
            // Direkter Base64-String (aus verschlüsselten Daten)
            setProfileImage(data.profileImage);
            setShowQrCodeDialog(false);
            console.log('✅ Neues Profilfoto über QR-Code empfangen (verschlüsselt)');
          } else if (data.profileImage.data) {
            // Strukturiertes Format mit data und type
            setProfileImage(`data:${data.profileImage.type};base64,${data.profileImage.data}`);
            setShowQrCodeDialog(false);
            console.log('✅ Neues Profilfoto über QR-Code empfangen (strukturiert)');
          }
        }
      }
      
    } catch (error) {
      console.error('❌ Fehler beim Prüfen des QR-Session-Status:', error);
    }
  };

  // Polling für QR-Code Status
  React.useEffect(() => {
    if (showQrCodeDialog && qrSessionId) {
      const interval = setInterval(checkQrSessionStatus, 2000); // Alle 2 Sekunden prüfen
      return () => clearInterval(interval);
    }
  }, [showQrCodeDialog, qrSessionId, user]);

  // Funktion um Account-Status zu überprüfen und bei Bedarf zu erstellen
  const ensureAccountExists = async (): Promise<boolean> => {
    if (accountId) {
      console.log('✅ Account bereits vorhanden:', accountId);
      return true;
    }
    
    console.log('🔄 Kein Account gefunden, versuche Account zu erstellen...');
    try {
      const existingAccountId = await checkAccountStatus();
      
      if (existingAccountId) {
        console.log('✅ Account nach Status-Check gefunden:', existingAccountId);
        return true;
      }
      
      // Versuche Account zu erstellen
      const newAccountId = await createAccount();
      
      if (newAccountId) {
        console.log('✅ Account erstellt und gefunden:', newAccountId);
        return true;
      }
      
      console.error('❌ Account konnte nicht erstellt oder gefunden werden');
      return false;
    } catch (error) {
      console.error('❌ Fehler beim Account-Setup:', error);
      return false;
    }
  };

  const uploadOriginalDocument = async (file: File) => {
    // Prüfe ob User einen Account hat, falls nicht, versuche einen zu erstellen
    const hasAccount = await ensureAccountExists();
    if (!hasAccount) {
      setError('Bitte warten Sie, bis Ihr Account erstellt wurde, und versuchen Sie es erneut.');
      return;
    }
    
    console.log('✅ Account gefunden für CV-Upload:', accountId);
    
    // Schließe das CV-Upload-Modal während des Uploads und markiere als manuell geschlossen
    setShowAddCvModal(false);
    setCvModalManuallyClosed(true);
    
    // Reset alle Daten
    // originalCvText wurde entfernt
    setFullName('');
    setCompany('');
    setAddress('');
    setPostalCode('');
    setCity('');
    setCountry('');
    setAvailableFrom('');
    setPhoneNumber('');
    setEmail('');
    setBirthYear('');
    setNationality('');
    setResidencePermit('');
    setCivilStatus('');
    setShortProfile('');
    setWorkExperience('');
    setEducation('');
    setCertificates('');
    setLanguages([]);
    setCoreCompetencies([]);
    setItSkills([]);
    setHobbies([]);
    setAdditionalInfo([]);
    setProfileImage(null);
    setSignature(null);
    setOptimizedImages([]);
    setShowImageOptimizer(false);
    setOriginalCvMarkdown(null);
    setError(null);
    setExtracting(true);
    
    // Generiere Session-ID für SSE
    const sessionId = `upload_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    
    // Initialisiere Import-Fortschrittsanzeige (ähnlich wie CV-Optimierung)
    setImportProgress({
      'Text extrahieren': 'pending',
      'Persönliche Informationen': 'pending',
      'Kernkompetenzen': 'pending',
      'Branchen': 'pending',
      'Hobbies': 'pending',
      'IT-Skills': 'pending',
      'Sprachen': 'pending',
      'Ausbildung': 'pending',
      'Zertifizierungen': 'pending',
      'Berufserfahrung': 'pending',
      'Weitere Angaben': 'pending'
    });
    
    // Starte SSE-Verbindung für Fortschrittsupdates
    const eventSource = new EventSource(`${config.backend.baseUrl}/api/upload-progress/${sessionId}`);
    
    eventSource.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log('📡 SSE-Update erhalten:', data);
        
        if (data.type === 'progress') {
          // Update Fortschrittsanzeige basierend auf Backend-Updates
          setImportProgress(prev => {
            const updated = { ...prev };
            
            // Mappe Backend-Schritte zu Frontend-Schritten (jeder Prompt einzeln)
            switch (data.step) {
              case 'text_extraction':
                if (data.status === 'running') {
                  updated['Text extrahieren'] = 'running';
                } else if (data.status === 'completed') {
                  updated['Text extrahieren'] = 'completed';
                }
                break;
              case 'main_prompt':
                if (data.status === 'running') {
                  updated['Persönliche Informationen'] = 'running';
                } else if (data.status === 'completed') {
                  updated['Persönliche Informationen'] = 'completed';
                }
                break;
              case 'core_competencies':
                if (data.status === 'running') {
                  updated['Kernkompetenzen'] = 'running';
                } else if (data.status === 'completed') {
                  updated['Kernkompetenzen'] = 'completed';
                }
                break;
              case 'branches':
                if (data.status === 'running') {
                  updated['Branchen'] = 'running';
                } else if (data.status === 'completed') {
                  updated['Branchen'] = 'completed';
                }
                break;
              case 'hobbies':
                if (data.status === 'running') {
                  updated['Hobbies'] = 'running';
                } else if (data.status === 'completed') {
                  updated['Hobbies'] = 'completed';
                }
                break;
              case 'it_skills':
                if (data.status === 'running') {
                  updated['IT-Skills'] = 'running';
                } else if (data.status === 'completed') {
                  updated['IT-Skills'] = 'completed';
                }
                break;
              case 'languages':
                if (data.status === 'running') {
                  updated['Sprachen'] = 'running';
                } else if (data.status === 'completed') {
                  updated['Sprachen'] = 'completed';
                }
                break;
              case 'education':
                if (data.status === 'running') {
                  updated['Ausbildung'] = 'running';
                } else if (data.status === 'completed') {
                  updated['Ausbildung'] = 'completed';
                }
                break;
              case 'certificates':
                if (data.status === 'running') {
                  updated['Zertifizierungen'] = 'running';
                } else if (data.status === 'completed') {
                  updated['Zertifizierungen'] = 'completed';
                }
                break;
              case 'work_experience':
                if (data.status === 'running') {
                  updated['Berufserfahrung'] = 'running';
                } else if (data.status === 'completed') {
                  updated['Berufserfahrung'] = 'completed';
                }
                break;
              case 'additional_info':
                if (data.status === 'running') {
                  updated['Weitere Angaben'] = 'running';
                } else if (data.status === 'completed') {
                  updated['Weitere Angaben'] = 'completed';
                }
                break;
              case 'photo_extraction':
                // Foto-Extraktion wird nicht in der Fortschrittsanzeige angezeigt
                break;
              case 'data_saving':
                // Daten speichern wird nicht in der Fortschrittsanzeige angezeigt
                break;
            }
            
            return updated;
          });
        }
      } catch (error) {
        console.error('❌ Fehler beim Parsen der SSE-Daten:', error);
      }
    };
    
    eventSource.onerror = (error) => {
      console.error('❌ SSE-Verbindungsfehler:', error);
    };
    
    // Variablen für die neue CV-ID und -Name (im gesamten Scope verfügbar)
    let importedCvId: string | null = null;
    let importedCvName: string | null = null;
    
    try {
      console.log('📤 Sende Original-Dokument an Backend:', {
        fileName: file.name,
        fileSize: file.size,
        fileType: file.type
      });
      
      // Konvertiere File zu Base64 und sende als JSON
      // Beachte: Wir können den FullName hier noch nicht verwenden, da er erst aus der Backend-Antwort kommt
      // Wir verwenden einen Platzhalter, der später durch den FullName ersetzt wird
      const fileData = await convertFileToBase64(file);
      const requestData = {
        fileData: fileData,
        fileName: file.name,
        fileType: file.type,
        jobDescription: jobDescription || getTranslatedCvLabel('CV wird verarbeitet...'),
        sessionId: sessionId,
        cvName: newCvName || '__USE_FULLNAME__', // Platzhalter, der später durch FullName ersetzt wird
        language: currentLanguage
      };
      
      // User-Authentifizierung für Backend-Request
      if (!user) {
        throw new Error('Kein User angemeldet');
      }
      
      const idToken = await user.getIdToken();
      
      const response = await fetch(config.backend.extractCvUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify(requestData),
      });
      
      console.log('📥 Backend-Antwort erhalten:', response.status, response.statusText);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ Backend-Fehler:', errorText);
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }
      
      const data = await response.json();
      
      console.log('✅ Original-Dokument erfolgreich verarbeitet!');
      console.log('📋 Neue CV-ID aus Backend-Response:', data.cvId);
      console.log('📋 Neuer CV-Name aus Backend-Response:', data.cvName);
      
      // Speichere die cvId und cvName für spätere Verwendung
      importedCvId = data.cvId;
      importedCvName = data.cvName;
      
      // SSE-Updates übernehmen die Fortschrittsanzeige
      
      // Verarbeite die AI-extrahierten Daten
      // originalCvText wurde entfernt - nicht mehr benötigt
      
      // Verwende die Daten direkt aus der Backend-Antwort
      const extractedData = data;
      
      // Persönliche Informationen aus der AI-extrahierten Backend-Antwort setzen
      // AI-extrahierten Daten verarbeitet
      
      if (extractedData.fullName && extractedData.fullName !== 'CV Upload' && extractedData.fullName !== 'Unbekannt') {
        setFullName(extractedData.fullName);
        console.log('✅ Echten Namen gesetzt:', extractedData.fullName);
      }
      
      
      if (extractedData.email) {
        setEmail(extractedData.email);
        console.log('✅ E-Mail gesetzt:', extractedData.email);
      }
      
      if (extractedData.phoneNumber) {
        setPhoneNumber(extractedData.phoneNumber);
        console.log('✅ Telefonnummer gesetzt:', extractedData.phoneNumber);
      }
      
      if (extractedData.address) {
        setAddress(extractedData.address);
        console.log('✅ Adresse gesetzt:', extractedData.address);
      } else {
        console.log('❌ Keine Adresse in AI-Antwort gefunden');
      }
      
      if (extractedData.postalCode) {
        setPostalCode(extractedData.postalCode);
        console.log('✅ PLZ gesetzt:', extractedData.postalCode);
      }
      
      if (extractedData.city) {
        setCity(extractedData.city);
        console.log('✅ Stadt gesetzt:', extractedData.city);
      }
      
      if (extractedData.country) {
        setCountry(extractedData.country);
        console.log('✅ Land gesetzt:', extractedData.country);
      }
      
      if (extractedData.company) {
        setCompany(extractedData.company);
        console.log('✅ Firma gesetzt:', extractedData.company);
      }
      
      if (extractedData.birthYear) {
        setBirthYear(extractedData.birthYear);
        console.log('✅ Geburtsjahr gesetzt:', extractedData.birthYear);
      }
      
      if (extractedData.availableFrom) {
        setAvailableFrom(extractedData.availableFrom);
        console.log('✅ Verfügbar ab gesetzt:', extractedData.availableFrom);
      }
      
      if (extractedData.nationality) {
        const mappedNationality = mapNationalityToSelectValue(extractedData.nationality);
        setNationality(mappedNationality);
        console.log('✅ Nationalität gesetzt:', extractedData.nationality, '->', mappedNationality);
      }
      
      if (extractedData.residencePermit) {
        setResidencePermit(extractedData.residencePermit);
        console.log('✅ Aufenthaltserlaubnis gesetzt:', extractedData.residencePermit);
      }
      
      if (extractedData.civilStatus) {
        const mappedCivilStatus = mapCivilStatusToSelectValue(extractedData.civilStatus);
        setCivilStatus(mappedCivilStatus);
        console.log('✅ Familienstand gesetzt:', extractedData.civilStatus, '->', mappedCivilStatus);
      }
      
      if (extractedData.shortProfile && extractedData.shortProfile !== getTranslatedCvLabel('CV wird verarbeitet...')) {
        setShortProfile(extractedData.shortProfile);
        console.log('✅ Echtes Profil gesetzt:', extractedData.shortProfile);
      }
      
      // Berufserfahrung und Ausbildung
      if (extractedData.workExperiences && extractedData.workExperiences.length > 0) {
        setWorkExperiences(extractedData.workExperiences);
        console.log('✅ Berufserfahrungen gesetzt:', extractedData.workExperiences.length);
      }
      
      
      if (extractedData.educations && extractedData.educations.length > 0) {
        setEducations(extractedData.educations);
        console.log('✅ Ausbildung gesetzt:', extractedData.educations.length);
      }
      
      
      if (extractedData.certifications && extractedData.certifications.length > 0) {
        setCertifications(extractedData.certifications);
        console.log('✅ Zertifizierungen gesetzt:', extractedData.certifications.length);
      } else {
        console.log('❌ Keine Zertifizierungen in AI-Antwort gefunden');
      }
      
      
      if (extractedData.industryExperiences && extractedData.industryExperiences.length > 0) {
        setIndustryExperiences(extractedData.industryExperiences);
        console.log('✅ Branchenerfahrungen gesetzt:', extractedData.industryExperiences.length);
      } else {
        console.log('❌ Keine Branchenerfahrungen in AI-Antwort gefunden');
      }
      
      // IT-Skills, Sprachen und Kompetenzen
      if (extractedData.itSkills && extractedData.itSkills.length > 0) {
        setItSkills(extractedData.itSkills);
        console.log('✅ IT-Skills gesetzt:', extractedData.itSkills.length);
      }
      
      
      if (extractedData.languages && extractedData.languages.length > 0) {
        setLanguages(extractedData.languages);
        console.log('✅ Sprachen gesetzt:', extractedData.languages.length);
      }
      
      
      if (extractedData.coreCompetencies && extractedData.coreCompetencies.length > 0) {
        setCoreCompetencies(extractedData.coreCompetencies);
        console.log('✅ Kernkompetenzen gesetzt:', extractedData.coreCompetencies.length);
      }
      
      if (extractedData.hobbies && extractedData.hobbies.length > 0) {
        setHobbies(extractedData.hobbies);
        console.log('✅ Hobbys erfolgreich gesetzt:', extractedData.hobbies.length);
      }
      
      
      if (extractedData.additionalInfo && extractedData.additionalInfo.length > 0) {
        setAdditionalInfo(extractedData.additionalInfo);
        console.log('✅ Zusätzliche Informationen gesetzt:', extractedData.additionalInfo.length);
      }
      
      // Foto-Verarbeitung - unterstützt beide Formate
      if (data.profileImage) {
        if (typeof data.profileImage === 'string') {
          // Direkter Base64-String
          setProfileImage(data.profileImage);
          console.log('✅ Profilfoto gesetzt (direkter String)');
        } else if (data.profileImage.data) {
          // Strukturiertes Format mit data und type
          setProfileImage(`data:${data.profileImage.type};base64,${data.profileImage.data}`);
          console.log('✅ Profilfoto gesetzt:', data.profileImage.size, 'Bytes');
        } else {
          console.log('📸 Kein Profilfoto in der Antwort gefunden');
        }
      } else {
        console.log('📸 Kein Profilfoto in der Antwort gefunden');
      }
      

      // Speichere die Daten über das Backend in Firebase
      if (data.savedToFirebase) {
        console.log('✅ CV-Daten wurden über das Backend in Firebase gespeichert');
      }
      
      // Zeige Erfolgsmeldung für AI-Extraktion
      if (data.extractionMethod === 'AI-GPT4' || data.extractionMethod === 'Fallback-Extraktion') {
        console.log('🤖 Persönliche-Informationen-Extraktion erfolgreich abgeschlossen');
        setError(null); // Lösche eventuelle Fehler
        
        // Maximiere alle CV-Sektionen nach der Extraktion
        setMinimizedSections({
          industryExperiences: false,
          workExperience: false,
          education: false,
          certifications: false,
          languages: false,
          coreCompetencies: false,
          itSkills: false,
          additionalInfo: false,
          hobbies: false
        });
        
        console.log('✅ Alle CV-Sektionen wurden maximiert');
        
        // Aktiviere den neu importierten CV und öffne das Modal
        // Die Daten sind BEREITS im State geladen - wir laden sie NICHT nochmal vom Backend!
        if (importedCvId && importedCvName) {
          // Wenn kein expliziter CV-Name angegeben wurde und ein FullName vorhanden ist, verwende den FullName
          let finalCvName = importedCvName;
          // Prüfe ob der Platzhalter verwendet wurde oder ob der Default-Name gesetzt wurde
          const isPlaceholder = importedCvName === '__USE_FULLNAME__';
          const isDefaultName = !newCvName && importedCvName.startsWith('CV vom ');
          
          if ((isPlaceholder || isDefaultName) && extractedData.fullName && extractedData.fullName !== 'CV Upload' && extractedData.fullName !== 'Unbekannt') {
            // Der Platzhalter oder Default-Name wurde verwendet, aktualisiere mit FullName
            finalCvName = extractedData.fullName;
            // Aktualisiere den CV-Namen im Backend
            try {
              const updateResponse = await fetch(`${config.backend.baseUrl}/api/update-cv-name/${importedCvId}`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${idToken}`
                },
                body: JSON.stringify({ cvName: finalCvName })
              });
              if (updateResponse.ok) {
                console.log('✅ CV-Name aktualisiert zu FullName:', finalCvName);
                // Aktualisiere auch in der userCvs Liste
                setUserCvs((prev: any[]) => 
                  prev.map((cv: any) => 
                    cv.cvId === importedCvId ? { ...cv, cvName: finalCvName } : cv
                  )
                );
              } else {
                const errorData = await updateResponse.json().catch(() => ({}));
                console.error('❌ Fehler beim Aktualisieren des CV-Namens:', errorData);
              }
            } catch (error) {
              console.error('❌ Fehler beim Aktualisieren des CV-Namens:', error);
            }
          }
          // Setze selectedCvId und CV-Name
          setSelectedCvId(importedCvId);
          setCurrentCvName(finalCvName);
          console.log('✅ Neuer CV aktiviert:', importedCvId, '(', finalCvName, ')');
          
          // Öffne das Modal mit den bereits geladenen Daten
          setShowCvDataModal(true);
          setTabIndex(0); // Setze Modal auf Tab "Persönliche Informationen" nach CV-Import
          setCvDataEditMode(true);
          setHasUnsavedChanges(false);
          console.log('✅ CV-Daten Modal geöffnet mit importierten Daten');
          
          // Zeige Warnung über AI-Genauigkeit nur wenn nicht deaktiviert
          if (!dontShowImportWarning) {
            setShowCvImportWarningDialog(true);
          }
        }
        
        // Alle Schritte abgeschlossen
        
        // SSE-Verbindung schließen
        eventSource.close();
      }
      
    } catch (err: any) {
      console.error('❌ Fehler beim Upload des Original-Dokuments:', err);
      setError('Fehler beim Verarbeiten des Dokuments: ' + (err.message || 'Unbekannter Fehler'));
      
      // Setze alle laufenden Schritte auf fehlgeschlagen
      setImportProgress(prev => {
        const updated = { ...prev };
        Object.keys(updated).forEach(key => {
          if (updated[key] === 'running') {
            updated[key] = 'failed';
          }
        });
        return updated;
      });
      
      // SSE-Verbindung schließen
      eventSource.close();
    } finally {
      setTimeout(async () => {
        setExtracting(false);
        // Setze Import-Fortschrittsanzeige zurück
        setImportProgress({});
        // Setze Checkbox "Daten sind wahrheitsgetreu" auf false nach CV-Import
        
        // Lade CV-Liste neu nach erfolgreichem Upload (für die Tabelle)
        if (user) {
          try {
            const idToken = await user.getIdToken();
            const response = await fetch(`${config.backend.baseUrl}/api/get-user-cvs`, {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${idToken}`
              }
            });
            
            if (response.ok) {
              const data = await response.json();
              setUserCvs(data.userCvs || []);
              console.log('✅ CV-Liste aktualisiert, Anzahl CVs:', data.userCvs?.length || 0);
            }
          } catch (error) {
            console.error('❌ Fehler beim Aktualisieren der CV-Liste:', error);
          }
        }
        
        // KEINE automatische Tab-Umschaltung nach CV-Upload
        // Der User bleibt auf dem aktuellen Tab
        console.log('ℹ️ CV-Upload abgeschlossen - Tab bleibt unverändert');
        
        // Modal wurde bereits im try-Block geöffnet mit den korrekten Daten
        // KEIN reloadCvDataFromBackend() hier - das würde die neuen Daten überschreiben!
      }, 1000); // Kurze Verzögerung, damit der Benutzer "100% Complete" sieht
    }
  };

  // AI-gestützte Extraktion persönlicher Angaben (verwendet lokale Extraktion)
  const extractPersonalInfoWithAI = async (text: string): Promise<{ fullName: string; company: string; address: string; postalCode: string; city: string; phoneNumber: string; email: string; birthYear: string; nationality: string; residencePermit: string; civilStatus: string }> => {
    try {
      // Verwende lokale Extraktion als Fallback
      return extractPersonalInfo(text);
    } catch (error) {
      console.error('Extraktion fehlgeschlagen:', error);
      throw error;
    }
  };

  // Funktion zur Extraktion persönlicher Angaben (Fallback)
     const extractPersonalInfo = (text: string): { fullName: string; company: string; address: string; postalCode: string; city: string; phoneNumber: string; email: string; birthYear: string; nationality: string; residencePermit: string; civilStatus: string } => {
         // Sicherheitscheck für Text
         if (!text || typeof text !== 'string') {
           return { fullName: '', company: '', address: '', postalCode: '', city: '', phoneNumber: '', email: '', birthYear: '', nationality: '', residencePermit: '', civilStatus: '' };
         }
         
         const lines = text.split('\n').map(line => line.trim()).filter(line => line.length > 0);
     let fullName = '';
     let company = '';
     let address = '';
     let postalCode = '';
     let city = '';
     let phoneNumber = '';
    let email = '';
    let birthYear = '';
    let nationality = '';
    let residencePermit = '';
    let civilStatus = '';

    // Vollständiger Name (meist am Anfang, 2-3 Wörter, erste Zeile oder nach "Name:")
    const namePatterns = [
      /^([A-ZÄÖÜ][a-zäöüß]+(\s+[A-ZÄÖÜ][a-zäöüß]+){1,2})\s*$/m,
      /Name[:\s]+([A-ZÄÖÜ][a-zäöüß]+(\s+[A-ZÄÖÜ][a-zäöüß]+){1,2})/i,
      /^([A-ZÄÖÜ][a-zäöüß]+(\s+[A-ZÄÖÜ][a-zäöüß]+){1,2})/,
      /Vorname[:\s]+([A-ZÄÖÜ][a-zäöüß]+)\s+Nachname[:\s]+([A-ZÄÖÜ][a-zäöüß]+)/i
    ];
    
    let nameFound = false;
    for (let i = 0; i < namePatterns.length; i++) {
      const pattern = namePatterns[i];
      const match = text.match(pattern);
      if (match && !nameFound) {
        if (i === 3) {
          // Spezieller Fall für "Vorname: X Nachname: Y"
          fullName = `${match[1]} ${match[2]}`;
        } else {
          fullName = match[1] || match[0];
        }
        
        // Validierung: Name sollte nicht zu lang sein (max 50 Zeichen)
        if (fullName.length > 50) {
          // Versuche nur die ersten 2-3 Wörter zu nehmen
          const words = fullName.split(/\s+/).slice(0, 3);
          fullName = words.join(' ');
        }
        
                 nameFound = true;
         break;
       }
     }
     
     // Firma extrahieren
     const companyPatterns = [
       /Firma[:\s]+([A-ZÄÖÜ][a-zäöüß\s&\.]+)/gi,
       /Company[:\s]+([A-ZÄÖÜ][a-zäöüß\s&\.]+)/gi,
       /Unternehmen[:\s]+([A-ZÄÖÜ][a-zäöüß\s&\.]+)/gi,
       /Employer[:\s]+([A-ZÄÖÜ][a-zäöüß\s&\.]+)/gi,
       /Arbeitgeber[:\s]+([A-ZÄÖÜ][a-zäöüß\s&\.]+)/gi
     ];
     
     for (const pattern of companyPatterns) {
       const match = text.match(pattern);
       if (match && match[1]) {
         company = match[1].trim();
         break;
       }
     }
    
    // E-Mail-Adresse
    const emailPattern = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
    const emails = text.match(emailPattern);
    if (emails && emails.length > 0) {
      email = emails[0];
    }
    
    // Telefonnummer (verschiedene Formate)
    const phonePatterns = [
      /(\+?[0-9\s\-\(\)]{10,})/g,
      /Tel[:\s]+([0-9\s\-\(\)\+]+)/gi,
      /Telefon[:\s]+([0-9\s\-\(\)\+]+)/gi,
      /Phone[:\s]+([0-9\s\-\(\)\+]+)/gi
    ];
    
    let phoneFound = false;
    for (const pattern of phonePatterns) {
      const matches = text.match(pattern);
      if (matches && !phoneFound) {
        const phone = matches[1] || matches[0];
        if (phone.replace(/[\s\-\(\)]/g, '').length >= 10) {
          phoneNumber = phone.trim();
          phoneFound = true;
          break;
        }
      }
    }
    
    // Adresse (mehrzeilige Adressen)
    const addressPatterns = [
      /Adresse[:\s]+([^\n]+(?:\n[^\n]+){0,3})/gi,
      /Address[:\s]+([^\n]+(?:\n[^\n]+){0,3})/gi,
      /^([A-ZÄÖÜ][a-zäöüß\s]+(?:straße|strasse|weg|platz|allee|gasse)\s+[0-9a-zA-Z\s]+(?:\n[0-9]{4,5}\s+[A-ZÄÖÜ][a-zäöüß\s]+)?)/gm
    ];
    
    let addressFound = false;
    for (const pattern of addressPatterns) {
      const matches = text.match(pattern);
      if (matches && !addressFound) {
        const addressMatch = matches[1] || matches[0];
                 if (addressMatch.length > 10) {
           address = addressMatch.trim();
           
           // Extrahiere Postleitzahl und Ort aus der Adresse
           const postalCodeMatch = addressMatch.match(/([0-9]{4,5})\s+([A-ZÄÖÜ][a-zäöüß\s]+)/);
           if (postalCodeMatch) {
             postalCode = postalCodeMatch[1];
             city = postalCodeMatch[2].trim();
           }
           
           addressFound = true;
           break;
         }
      }
    }
    
    // Separate Extraktion von Postleitzahl und Ort - NEUE, EINFACHERE LOGIK
    if (!postalCode || !city) {
      // 1. Zuerst nach expliziten Labels suchen
      const explicitPostalCodeMatch = text.match(/PLZ[:\s]+([0-9]{4,5})/i);
      if (explicitPostalCodeMatch && !postalCode) {
        postalCode = explicitPostalCodeMatch[1];
      }
      
      const explicitPostalCodeMatch2 = text.match(/Postleitzahl[:\s]+([0-9]{4,5})/i);
      if (explicitPostalCodeMatch2 && !postalCode) {
        postalCode = explicitPostalCodeMatch2[1];
      }
      
      const explicitPostalCodeMatch3 = text.match(/Postal[:\s]+([0-9]{4,5})/i);
      if (explicitPostalCodeMatch3 && !postalCode) {
        postalCode = explicitPostalCodeMatch3[1];
      }
      
      // 2. Nach expliziten Stadt-Labels suchen (präziser)
      const explicitCityMatch = text.match(/Ort[:\s]+([A-ZÄÖÜ][a-zäöüß\s]+?)(?:\n|$)/i);
      if (explicitCityMatch && !city) {
        const extractedCity = explicitCityMatch[1].trim();
        // Validierung: Stadt sollte nicht zu lang sein und keine Zahlen enthalten
        if (extractedCity.length > 2 && extractedCity.length < 50 && !/\d/.test(extractedCity)) {
          city = extractedCity;
        }
      }
      
      const explicitCityMatch2 = text.match(/Stadt[:\s]+([A-ZÄÖÜ][a-zäöüß\s]+?)(?:\n|$)/i);
      if (explicitCityMatch2 && !city) {
        const extractedCity = explicitCityMatch2[1].trim();
        if (extractedCity.length > 2 && extractedCity.length < 50 && !/\d/.test(extractedCity)) {
          city = extractedCity;
        }
      }
      
      const explicitCityMatch3 = text.match(/City[:\s]+([A-ZÄÖÜ][a-zäöüß\s]+?)(?:\n|$)/i);
      if (explicitCityMatch3 && !city) {
        const extractedCity = explicitCityMatch3[1].trim();
        if (extractedCity.length > 2 && extractedCity.length < 50 && !/\d/.test(extractedCity)) {
          city = extractedCity;
        }
      }
      
      // 3. Nur wenn noch nicht gefunden: Nach Schweizer Postleitzahl-Format suchen
      if (!postalCode || !city) {
        // Schweizer Postleitzahl: 4-stellig, gefolgt von Stadt
        const swissPostalPattern = /\b([0-9]{4})\s+([A-ZÄÖÜ][a-zäöüß\s]+)\b/g;
        let match;
        
        while ((match = swissPostalPattern.exec(text)) !== null) {
          const potentialPostalCode = match[1];
          const potentialCity = match[2].trim();
          
          // Validierung: Postleitzahl sollte zwischen 1000-9999 sein (Schweizer Format)
          const postalNum = parseInt(potentialPostalCode);
          if (postalNum >= 1000 && postalNum <= 9999) {
            // Zusätzliche Validierung für Stadt
            if (potentialCity.length > 2 && potentialCity.length < 50 && !/\d/.test(potentialCity)) {
              // Zusätzliche Sicherheit: Prüfe Kontext
              const context = match[0];
              const beforeContext = text.substring(Math.max(0, match.index - 20), match.index);
              const afterContext = text.substring(match.index + match[0].length, match.index + match[0].length + 20);
              
              // Ignoriere wenn es Teil eines anderen Kontexts ist
              const fullContext = (beforeContext + context + afterContext).toLowerCase();
              if (!fullContext.includes('nationalität') && 
                  !fullContext.includes('geboren') && 
                  !fullContext.includes('birth') && 
                  !fullContext.includes('jahr') && 
                  !fullContext.includes('year') &&
                  !fullContext.includes('telefon') &&
                  !fullContext.includes('phone') &&
                  !fullContext.includes('email') &&
                  !fullContext.includes('e-mail')) {
                
                if (!postalCode) {
                  postalCode = potentialPostalCode;
                }
                if (!city) {
                  city = potentialCity;
                }
                break; // Erste gültige Kombination verwenden
              }
            }
          }
        }
      }
      
      // 4. Zusätzliche Stadt-Extraktion: Bekannte Schweizer Städte
      if (!city) {
        const swissCities = [
          'Zürich', 'Genf', 'Basel', 'Bern', 'Lausanne', 'Winterthur', 'St. Gallen', 'Luzern', 'Lugano', 'Biel',
          'Thun', 'Köniz', 'La Chaux-de-Fonds', 'Fribourg', 'Schaffhausen', 'Chur', 'Neuchâtel', 'Vernier', 'Uster', 'Sion',
          'Zug', 'Yverdon-les-Bains', 'Rapperswil-Jona', 'Dübendorf', 'Montreux', 'Frauenfeld', 'Wädenswil', 'Aarau', 'Herisau', 'Kreuzlingen',
          'Baden', 'Bulle', 'Meyrin', 'Carouge', 'Wettingen', 'Allschwil', 'Reinach', 'Riehen', 'Vevey', 'Nyon'
        ];
        
        for (const swissCity of swissCities) {
          const cityPattern = new RegExp(`\\b${swissCity}\\b`, 'i');
          const cityMatch = text.match(cityPattern);
          if (cityMatch) {
            // Prüfe Kontext: Stadt sollte nicht Teil eines anderen Textes sein
            const matchIndex = cityMatch.index!;
            const beforeContext = text.substring(Math.max(0, matchIndex - 30), matchIndex);
            const afterContext = text.substring(matchIndex + swissCity.length, matchIndex + swissCity.length + 30);
            const fullContext = (beforeContext + afterContext).toLowerCase();
            
            // Ignoriere wenn es Teil eines Labels oder anderen Kontexts ist
            if (!fullContext.includes('nationalität') && 
                !fullContext.includes('geboren') && 
                !fullContext.includes('birth') && 
                !fullContext.includes('telefon') && 
                !fullContext.includes('phone') &&
                !fullContext.includes('email') &&
                !fullContext.includes('e-mail') &&
                !fullContext.includes('firma') &&
                !fullContext.includes('company')) {
              city = swissCity;
              break;
            }
          }
        }
      }
    }
    
         // Geburtsdatum
     const birthPatterns = [
       /Geboren[:\s]+([0-9]{1,2}[\.\/\-][0-9]{1,2}[\.\/\-][0-9]{2,4})/gi,
       /Geburtsdatum[:\s]+([0-9]{1,2}[\.\/\-][0-9]{1,2}[\.\/\-][0-9]{2,4})/gi,
       /Birth[:\s]+([0-9]{1,2}[\.\/\-][0-9]{1,2}[\.\/\-][0-9]{2,4})/gi,
       /Born[:\s]+([0-9]{1,2}[\.\/\-][0-9]{1,2}[\.\/\-][0-9]{2,4})/gi,
       /([0-9]{1,2}[\.\/\-][0-9]{1,2}[\.\/\-][0-9]{2,4})/g
     ];
     
     let birthFound = false;
     for (const pattern of birthPatterns) {
       const matches = text.match(pattern);
       if (matches && !birthFound) {
         const birth = matches[1] || matches[0];
         // Prüfe ob es ein realistisches Datum ist (nicht zu alt oder zu jung)
         const yearMatch = birth.match(/\b(19|20)\d{2}\b/);
         if (yearMatch) {
           birthYear = yearMatch[0];
         } else {
           birthYear = birth;
         }
         birthFound = true;
         break;
       }
     }
    
         // Nationalität
     const nationalityPatterns = [
       /Nationalität[:\s]+([A-ZÄÖÜ][a-zäöüß]+)/gi,
       /Nationality[:\s]+([A-ZÄÖÜ][a-zäöüß]+)/gi,
       /Staatsangehörigkeit[:\s]+([A-ZÄÖÜ][a-zäöüß]+)/gi
     ];
     
     for (const pattern of nationalityPatterns) {
       const match = text.match(pattern);
       if (match && match[1]) {
         const nationalityMatch = match[1].toLowerCase();
         // Mapping von erkannten Texten zu Dropdown-Werten
               if (nationalityMatch.includes('schweiz') || nationalityMatch.includes('suisse') || nationalityMatch.includes('svizzero') || nationalityMatch.includes('ch')) {
        nationality = 'CH';
         } else if (nationalityMatch.includes('deutsch') || nationalityMatch.includes('allemand') || nationalityMatch.includes('tedesco')) {
           nationality = 'DE';
         } else if (nationalityMatch.includes('österreich') || nationalityMatch.includes('autrichien') || nationalityMatch.includes('austriaco')) {
           nationality = 'AT';
         } else if (nationalityMatch.includes('französ') || nationalityMatch.includes('français') || nationalityMatch.includes('francese')) {
           nationality = 'FR';
         } else if (nationalityMatch.includes('italien') || nationalityMatch.includes('italien') || nationalityMatch.includes('italiano')) {
           nationality = 'IT';
         } else if (nationalityMatch.includes('spanisch') || nationalityMatch.includes('espagnol') || nationalityMatch.includes('spagnolo')) {
           nationality = 'ES';
         } else if (nationalityMatch.includes('britisch') || nationalityMatch.includes('britannique') || nationalityMatch.includes('britannico')) {
           nationality = 'GB';
         } else if (nationalityMatch.includes('amerikanisch') || nationalityMatch.includes('américain') || nationalityMatch.includes('americano')) {
           nationality = 'US';
         } else if (nationalityMatch.includes('kanadisch') || nationalityMatch.includes('canadien') || nationalityMatch.includes('canadese')) {
           nationality = 'CA';
         } else if (nationalityMatch.includes('australisch') || nationalityMatch.includes('australien') || nationalityMatch.includes('australiano')) {
           nationality = 'AU';
         } else if (nationalityMatch.includes('japanisch') || nationalityMatch.includes('japonais') || nationalityMatch.includes('giapponese')) {
           nationality = 'JP';
         } else if (nationalityMatch.includes('chinesisch') || nationalityMatch.includes('chinois') || nationalityMatch.includes('cinese')) {
           nationality = 'CN';
         } else if (nationalityMatch.includes('indisch') || nationalityMatch.includes('indien') || nationalityMatch.includes('indiano')) {
           nationality = 'IN';
         } else if (nationalityMatch.includes('brasilianisch') || nationalityMatch.includes('brésilien') || nationalityMatch.includes('brasiliano')) {
           nationality = 'BR';
         } else if (nationalityMatch.includes('argentinisch') || nationalityMatch.includes('argentin') || nationalityMatch.includes('argentino')) {
           nationality = 'AR';
         } else if (nationalityMatch.includes('mexikanisch') || nationalityMatch.includes('mexicain') || nationalityMatch.includes('messicano')) {
           nationality = 'MX';
         } else if (nationalityMatch.includes('russisch') || nationalityMatch.includes('russe') || nationalityMatch.includes('russo')) {
           nationality = 'RU';
         } else if (nationalityMatch.includes('türkisch') || nationalityMatch.includes('turc') || nationalityMatch.includes('turco')) {
           nationality = 'TR';
         } else if (nationalityMatch.includes('marokkanisch') || nationalityMatch.includes('marocain') || nationalityMatch.includes('marocchino')) {
           nationality = 'MA';
         } else if (nationalityMatch.includes('ägyptisch') || nationalityMatch.includes('égyptien') || nationalityMatch.includes('egiziano')) {
           nationality = 'EG';
         } else if (nationalityMatch.includes('südafrikanisch') || nationalityMatch.includes('sud-africain') || nationalityMatch.includes('sudafricano')) {
           nationality = 'ZA';
         } else if (nationalityMatch.includes('nigerianisch') || nationalityMatch.includes('nigerian') || nationalityMatch.includes('nigeriano')) {
           nationality = 'NG';
         } else if (nationalityMatch.includes('kenianisch') || nationalityMatch.includes('kényan') || nationalityMatch.includes('kenyano')) {
           nationality = 'KE';
         } else {
           nationality = 'andere';
         }
         break;
       }
     }
    
    // Aufenthaltsbewilligung
    const permitPatterns = [
      /Aufenthaltsbewilligung[:\s]+([A-Z])/gi,
      /Permit[:\s]+([A-Z])/gi,
      /Bewilligung[:\s]+([A-Z])/gi
    ];
    
         for (const pattern of permitPatterns) {
       const match = text.match(pattern);
       if (match && match[1]) {
         residencePermit = match[1];
        break;
      }
    }
    
         // Zivilstand
     const civilPatterns = [
       /Zivilstand[:\s]+([A-ZÄÖÜ][a-zäöüß]+)/gi,
       /Civil[:\s]+([A-ZÄÖÜ][a-zäöüß]+)/gi,
       /Familienstand[:\s]+([A-ZÄÖÜ][a-zäöüß]+)/gi
     ];
     
     for (const pattern of civilPatterns) {
       const match = text.match(pattern);
       if (match && match[1]) {
         const civilMatch = match[1].toLowerCase();
         // Mapping von erkannten Texten zu Dropdown-Werten
         if (civilMatch.includes('ledig') || civilMatch.includes('single') || civilMatch.includes('célibataire') || civilMatch.includes('celibe')) {
           civilStatus = 'ledig';
         } else if (civilMatch.includes('verheiratet') || civilMatch.includes('married') || civilMatch.includes('marié') || civilMatch.includes('sposato')) {
           civilStatus = 'verheiratet';
         } else if (civilMatch.includes('geschieden') || civilMatch.includes('divorced') || civilMatch.includes('divorcé') || civilMatch.includes('divorziato')) {
           civilStatus = 'geschieden';
         } else if (civilMatch.includes('verwitwet') || civilMatch.includes('widowed') || civilMatch.includes('veuf') || civilMatch.includes('vedovo')) {
           civilStatus = 'verwitwet';
         } else if (civilMatch.includes('partnerschaft') || civilMatch.includes('partnership') || civilMatch.includes('partenaire') || civilMatch.includes('unione')) {
           civilStatus = 'eingetragene-partnerschaft';
         }
         break;
       }
     }
    
         // Postleitzahl-zu-Ort-Mapping: Wenn Postleitzahl gefunden wurde, aber kein Ort
         if (postalCode && !city) {
           // Kein Mapping mehr, city bleibt leer
         }
    
         return { fullName, company, address, postalCode, city, phoneNumber, email, birthYear, nationality, residencePermit, civilStatus };
  };

  // AI-gestützte Extraktion Kurzprofil
  const extractShortProfileWithAI = async (text: string): Promise<string> => {
    try {
      const backendApi = config.backend.fullApiUrl;
      if (!backendApi) {
        throw new Error(t('error.backend.api'));
      }
      // User-Authentifizierung für Backend-Request
      if (!user) {
        throw new Error('Kein User angemeldet');
      }
      
      const idToken = await user.getIdToken();
      
      const response = await fetch(config.backend.fullApiUrl + '/api/extract-short-profile', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({ text: text }),
      });
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      const data = await response.json();
      return data.shortProfile || '';
    } catch (error) {
      console.error('AI-Extraktion Kurzprofil fehlgeschlagen:', error);
      throw error;
    }
  };

  // Funktion zum Löschen aller CV-Daten
  const handleClearAllData = async () => {
    try {
      if (!user) return;
      
      // Alle States zurücksetzen
      setFullName('');
      setCompany('');
      setAddress('');
      setPostalCode('');
      setCity('');
      setCountry('');
      setAvailableFrom('');
      setPhoneNumber('');
      setEmail('');
      setBirthYear('');
      setNationality('');
      setResidencePermit('');
      setCivilStatus('');
      setShortProfile('');
      setWorkExperience('');
      setEducation('');
      setCertificates('');
      setLanguages([]);
      setCoreCompetencies([]);
      setItSkills([]);
      setAdditionalInfo([]);
      setOriginalCvMarkdown(null);
      setError(null);
      setMatchScore(null);
      resetMatchData();
      setImprovedCvText(null);
      setMotivationLetter(null);
      setWorkExperiences([]);
      setEducations([]);
      setCertifications([]);
      setIndustryExperiences([]);
      setHobbies([]);
      setProfileImage(null);
      setSignature(null);
      setOptimizedImages([]);
      setShowImageOptimizer(false);
 // Checkbox-Status zurücksetzen
      
      // Daten aus verschlüsselten Backend-Endpoints löschen
      try {
        // Echten Firebase ID Token für Backend-Authentication verwenden
        const idToken = await user.getIdToken();
        const response = await fetch(`${config.backend.deleteDataUrl}/${user.uid}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
          }
        });

        if (response.ok) {
          console.log('🔒 Daten erfolgreich aus verschlüsselten Backend-Endpoints gelöscht');
        } else {
          console.error('Fehler beim Löschen verschlüsselter Daten');
        }
      } catch (error) {
        console.error('Fehler beim Löschen verschlüsselter Daten:', error);
      }
      
      // Warte kurz, damit alle State-Updates verarbeitet werden können
      // Dann setze den Tab-Index auf 0 (erster Tab im Hauptfenster)
      await new Promise(resolve => setTimeout(resolve, 100));
      setMainTabIndex(0);
      
      console.log('✅ Alle Daten gelöscht und Tab 0 gesetzt');
      
    } catch (err: any) {
      console.error('Fehler beim Löschen der Daten:', err);
      setError(t('error.clear.data') + (err.message || ''));
    }
  };

  const handleDownloadOriginalCvPdf = () => {
    // CV-Daten werden nur noch strukturiert gespeichert
    console.log('Original CV Text Download deaktiviert - Text wird nicht gespeichert');
    return;
  };

  // Funktion zum Neuberechnen der Passgenauigkeit aus dem Modal
  const handleRecalculateMatchScoreFromModal = async () => {
    // Speichere zuerst CV-Daten
    await saveAllCvDataToFirebase();
    
    // Starte Neuberechnung mit Modal-spezifischer Warte-Animation
    setError(null);
    setMatchScore(null);
    resetMatchData();
    setCheckingMatchInModal(true);
    setCheckingMatch(false); // Stelle sicher, dass die normale Warte-Animation nicht angezeigt wird
    setHideJobDescription(true); // Verstecke das Stellenbeschreibung-Textfeld
    setHideMatchResults(false); // Zeige Match-Ergebnisse an
    setInfoMessage(getTranslatedInfoMessage('calculating_match'));
    
    // Rufe die normale Funktion auf
    await handleCheckMatchScoreInternal();
    
    // Setze Modal-Warte-Animation zurück
    setCheckingMatchInModal(false);
  };
  
  // Interne Funktion für die Passgenauigkeits-Berechnung (ohne setCheckingMatch)
  const handleCheckMatchScoreInternal = async () => {
    if (!jobDescription.trim()) {
      setError('Stellenbeschreibung ist erforderlich.');
      setCheckingMatch(false);
      setCheckingMatchInModal(false);
      return;
    }

    // Spracherkennung der Stellenbeschreibung beim Klick auf "Passgenauigkeit prüfen"
    if (jobDescription.trim().length > 10) {
      console.log('🔍 Starte Spracherkennung der Stellenbeschreibung...');
      await detectJobDescriptionLanguage(jobDescription.trim());
    }



    // Prüfe ob User-Daten vorhanden sind
    if (!user) {
      setError('Benutzer nicht angemeldet.');
      setCheckingMatch(false);
      setCheckingMatchInModal(false);
      return;
    }

    try {
      // Verwende alle Daten aus den bereits geladenen Tabellendaten
      const personalInfo = getPersonalInfoForMotivation();
      
      // Hole ID Token für API-Aufruf
      const idToken = await user.getIdToken();
      
      // Erstelle strukturierte CV-Daten für den Vergleich
      const cvData = {
        personalInfo: {
          fullName: personalInfo.fullName || '',
          address: personalInfo.address || '',
          postalCode: personalInfo.postalCode || '',
          city: personalInfo.city || '',
          country: personalInfo.country || '',
          availableFrom: personalInfo.availableFrom || '',
          phoneNumber: personalInfo.phoneNumber || '',
          email: personalInfo.email || '',
          birthYear: birthYear || '',
          nationality: nationality || '',
          residencePermit: residencePermit || '',
          civilStatus: civilStatus || '',
          shortProfile: shortProfile || ''
        },
        workExperience: workExperiences || [],
        education: educations || [],
        certifications: certifications || [],
        languages: languages || [],
        itSkills: itSkills || [],
        coreCompetencies: coreCompetencies || [],
        industryExperiences: industryExperiences || [],
        hobbies: hobbies || [],
        additionalInfo: additionalInfo || []
      };

      // 🔍 DEBUG: Prüfe Zertifizierungen-Struktur beim Export
      console.log('🔍 DEBUG Zertifizierungen Count:', certifications?.length || 0);
      if (certifications && certifications.length > 0) {
        console.log('🔍 DEBUG Erste Zertifizierung:', certifications[0]);
        console.log('🔍 DEBUG Zertifizierungen Feldnamen:', Object.keys(certifications[0]));
      }

      // Erstelle CV-Text aus strukturierten Daten für die Passgenauigkeit
      const createCvTextFromData = (data: any) => {
        let cvText = '';
        
        // Persönliche Informationen
        if (data.personalInfo?.fullName) cvText += `${getTranslatedCvLabel('Name:')} ${data.personalInfo.fullName}\n`;
        if (data.personalInfo?.address) cvText += `${getTranslatedCvLabel('Adresse:')} ${data.personalInfo.address}\n`;
        if (data.personalInfo?.postalCode) cvText += `${getTranslatedCvLabel('PLZ:')} ${data.personalInfo.postalCode}\n`;
        if (data.personalInfo?.city) cvText += `${getTranslatedCvLabel('Stadt:')} ${data.personalInfo.city}\n`;
        if (data.personalInfo?.country) cvText += `${getTranslatedCvLabel('Land:')} ${data.personalInfo.country}\n`;
        if (data.personalInfo?.availableFrom) cvText += `${getTranslatedCvLabel('Verfügbar ab:')} ${data.personalInfo.availableFrom}\n`;
        if (data.personalInfo?.phoneNumber) cvText += `${getTranslatedCvLabel('Telefon:')} ${data.personalInfo.phoneNumber}\n`;
        if (data.personalInfo?.email) cvText += `${getTranslatedCvLabel('Email:')} ${data.personalInfo.email}\n`;
        if (data.personalInfo?.birthYear) cvText += `${getTranslatedCvLabel('Geburtsjahr:')} ${data.personalInfo.birthYear}\n`;
        if (data.personalInfo?.nationality) cvText += `${getTranslatedCvLabel('Nationalität:')} ${data.personalInfo.nationality}\n`;
        if (data.personalInfo?.residencePermit) cvText += `${getTranslatedCvLabel('Aufenthaltsbewilligung:')} ${data.personalInfo.residencePermit}\n`;
        if (data.personalInfo?.civilStatus) cvText += `${getTranslatedCvLabel('Familienstand:')} ${data.personalInfo.civilStatus}\n`;
        if (data.personalInfo?.shortProfile) cvText += `${getTranslatedCvLabel('Profil:')} ${data.personalInfo.shortProfile}\n`;
        
        // Arbeitserfahrung
        if (data.workExperience && data.workExperience.length > 0) {
          cvText += '\nArbeitserfahrung:\n';
          data.workExperience.forEach((exp: any) => {
            cvText += `${exp.position} bei ${exp.company} (${exp.startDate} - ${exp.endDate})\n`;
            if (exp.description) cvText += `${exp.description}\n`;
          });
        }
        
        // Ausbildung
        if (data.education && data.education.length > 0) {
          cvText += '\nAusbildung:\n';
          data.education.forEach((edu: any) => {
            cvText += `${edu.degree} an ${edu.institution} (${edu.startDate} - ${edu.endDate})\n`;
          });
        }
        
        // Zertifikate
        if (data.certifications && data.certifications.length > 0) {
          cvText += '\nZertifikate:\n';
          data.certifications.forEach((cert: any) => {
            cvText += `${cert.certification} - ${cert.issuer} (${cert.date})\n`;
          });
        }
        
        // IT-Skills
        if (data.itSkills && data.itSkills.length > 0) {
          cvText += '\nIT-Skills:\n';
          data.itSkills.forEach((skill: any) => {
            cvText += `${skill.skill} (${skill.level})\n`;
          });
        }
        
        // Sprachen
        if (data.languages && data.languages.length > 0) {
          cvText += '\nSprachen:\n';
          data.languages.forEach((lang: any) => {
            cvText += `${lang.language} (${lang.level})\n`;
          });
        }
        
        // Hobbys
        if (data.hobbies && data.hobbies.length > 0) {
          cvText += '\nHobbys:\n';
          data.hobbies.forEach((hobby: any) => {
            cvText += `${hobby.hobby}: ${hobby.description}\n`;
          });
        }
        
        // Zusätzliche Informationen
        if (data.additionalInfo && data.additionalInfo.length > 0) {
          cvText += '\nZusätzliche Informationen:\n';
          data.additionalInfo.forEach((info: any) => {
            cvText += `${info.info}: ${info.details}\n`;
          });
        }
        
        // Kernkompetenzen
        if (data.coreCompetencies && data.coreCompetencies.length > 0) {
          cvText += '\nKernkompetenzen:\n';
          data.coreCompetencies.forEach((comp: any) => {
            cvText += `${comp.competency}\n`;
          });
        }
        
        // Branchenerfahrungen
        if (data.industryExperiences && data.industryExperiences.length > 0) {
          cvText += '\nBranchenerfahrungen:\n';
          data.industryExperiences.forEach((exp: any) => {
            cvText += `${exp.industry} (${exp.years} Jahre)\n`;
          });
        }
        
        return cvText;
      };

      const cvText = createCvTextFromData(cvData);
      
      // CV-Daten für Passgenauigkeit gesendet
      
      // Verwende bereits erstellten ID Token
      const matchResponse = await fetch(config.backend.optimizeCvJsonUrl, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({
          cvData: cvData,
          cvText: cvText,
          jobDescription: jobDescription,
          optimizeType: 'match',
          targetLanguage: targetLanguage,
          browserLanguage: { 'de': 'deutsch', 'en': 'englisch', 'fr': 'französisch', 'it': 'italienisch' }[currentLanguage] || 'deutsch'
        }),
      });
      
      if (!matchResponse.ok) throw new Error(t('error.match.score'));
      const data = await matchResponse.json();
      // Backend Response erhalten
      
      setMatchScore(typeof data.matchScore === 'number' ? data.matchScore : null);
      
      // Vereinfachte Logik für fehlende Skills
      if (Array.isArray(data.missingSkills)) {
        setMissingSkills(data.missingSkills);
      } else if (data.missingSkills && typeof data.missingSkills === 'object') {
        setMissingSkills(Object.values(data.missingSkills));
      } else {
        setMissingSkills([]);
      }
      
      // Verarbeite Weaknesses
      if (Array.isArray(data.weaknesses)) {
        setWeaknesses(data.weaknesses);
      } else if (data.weaknesses && typeof data.weaknesses === 'object') {
        setWeaknesses(Object.values(data.weaknesses));
      } else {
        setWeaknesses([]);
      }
      
      // Stelle sicher, dass Match-Ergebnisse angezeigt werden
      setHideMatchResults(false);
      
      // Zeige "CV optimieren" Button nach erfolgreicher Passgenauigkeit-Berechnung
      setShowCvOptimierenButton(true);
      
      // Öffne das Modal nach erfolgreicher Berechnung (nur wenn nicht bereits geöffnet)
      if (!showCvDataModal) {
        await openCvDataModal(true); // true = von Passgenauigkeit
      }
      
      // Match-Ergebnisse verarbeitet
    } catch (err: any) {
      setError(t('error.match.score.unknown') + (err.message || ''));
    } finally {
      setCheckingMatch(false);
      setCheckingMatchInModal(false);
      setInfoMessage(getTranslatedInfoMessage('match_calculated'));
    }
  };
  
  // Öffentliche Funktion für die Passgenauigkeits-Berechnung (mit setCheckingMatch)
  const handleCheckMatchScore = async () => {
    // Wenn bereits eine Passgenauigkeit vorhanden ist, einfach das Modal öffnen
    if (matchScore !== null) {
      console.log('✅ Passgenauigkeit bereits vorhanden:', matchScore, '- Öffne Modal ohne Neuberechnung');
      if (!showCvDataModal) {
        await openCvDataModal(true); // true = von Passgenauigkeit
      }
      return;
    }
    
    // Wenn keine Passgenauigkeit vorhanden, neu berechnen
    setError(null);
    setMatchScore(null);
    resetMatchData();
    setCheckingMatch(true);
    setCheckingMatchInModal(false); // Stelle sicher, dass Modal-Animation nicht angezeigt wird
    setHideJobDescription(true); // Verstecke das Stellenbeschreibung-Textfeld
    setHideMatchResults(false); // Zeige Match-Ergebnisse an
    setInfoMessage(getTranslatedInfoMessage('calculating_match'));
    
    // Rufe die interne Funktion auf
    await handleCheckMatchScoreInternal();
  };

  // Separate Optimierungsfunktionen für jeden Bereich
  
  // Hobby-Optimierung
  const handleHobbyOptimization = async (promptText: string, promptVersion: string, temperature: string, maxTokens: string) => {
    console.log('🎯 Starte Hobby-Optimierung...');
    
    try {
      setError(null);
      setOptimizing(true);
      
      // Prüfe ob User-Daten vorhanden sind
      if (!user) {
        setError('Benutzer nicht angemeldet.');
        setOptimizing(false);
        return;
      }

      // Verwende alle Daten aus den bereits geladenen Tabellendaten
      const personalInfo = getPersonalInfoForMotivation();

      // Hobby-Daten verarbeitet

      // Für Hobby-Optimierung: Bereite nur Hobby-spezifische Daten vor
      const hobbyData = {
        hobbies: hobbies || []
      };

      // Erstelle Hobby-spezifischen Text
      let hobbyText = '';
      if (hobbies && hobbies.length > 0) {
        hobbyText = 'Hobbys:\n' + hobbies.map(hobby => 
          `${hobby.hobby || 'Unbekannt'}: ${hobby.description || 'Keine Beschreibung'}`
        ).join('\n');
      } else {
        hobbyText = 'Keine Hobbys im CV gefunden';
      }

      console.log('🎯 Hobby-Daten für Backend:', hobbyData);
      console.log('🎯 Hobby-Text für Backend:', hobbyText);

      // Hole ID Token für Backend-Authentifizierung
      const idToken = await user.getIdToken();

              // Sende Request an Backend für Hobby-Optimierung
        const optimizeResponse = await fetch(config.backend.optimizeCvJsonUrl, {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
          },
          body: JSON.stringify({
            cvData: hobbyData, // Nur Hobby-Daten
            cvText: hobbyText, // Nur Hobby-Text
            jobDescription: jobDescription,
            optimizeType: 'hobbies',
            targetLanguage: targetLanguage,
            // Test-spezifische Parameter
            testPrompt: promptText,
            chatGptVersion: promptVersion,
            temperature: temperature,
            maxTokens: maxTokens
          }),
        });
      
      if (!optimizeResponse.ok) throw new Error(t('error.optimize.cv'));
      const data = await optimizeResponse.json();
      
      // Backend-Antwort für Hobbys verarbeitet
      
      // Setze die relevanten Hobbys
      if (data.relevantHobbies) {
        let hobbiesArray;
        
        // Prüfe ob relevantHobbies ein String ist (JSON) oder bereits ein Array
        if (typeof data.relevantHobbies === 'string') {
          try {
            // Entferne Markdown-Code-Block-Formatierung falls vorhanden
            let cleanJsonString = data.relevantHobbies;
            if (cleanJsonString.includes('```json')) {
              cleanJsonString = cleanJsonString.replace(/```json\n?/g, '').replace(/```\n?/g, '');
              console.log('🔧 Markdown-Code-Block entfernt, bereinigter String:', cleanJsonString);
            }
            
            // Parse den bereinigten JSON-String zu einem Array
            hobbiesArray = JSON.parse(cleanJsonString);
            console.log('✅ JSON-String erfolgreich geparst zu Array:', hobbiesArray);
          } catch (parseError) {
            console.error('❌ Fehler beim Parsen des JSON-Strings:', parseError);
            setTestResult('Fehler beim Parsen der Hobby-Daten');
            return;
          }
        } else if (Array.isArray(data.relevantHobbies)) {
          // relevantHobbies ist bereits ein Array
          hobbiesArray = data.relevantHobbies;
          console.log('✅ relevantHobbies ist bereits ein Array:', hobbiesArray);
        } else {
          console.log('⚠️ relevantHobbies ist weder String noch Array:', typeof data.relevantHobbies);
          setTestResult('Unerwartetes Datenformat für Hobbys');
          return;
        }
        
        // Prüfe ob das geparste Array gültig ist
        if (hobbiesArray && Array.isArray(hobbiesArray) && hobbiesArray.length > 0) {
          // Setze die Hobbys im lokalen State
          setRelevantHobbies(hobbiesArray);
          console.log('✅ Relevante Hobbys gesetzt:', hobbiesArray.length, 'Hobbys');
          
          // Zeige nur die relevanten Hobbys im Test-Modal an
          setTestResult(JSON.stringify(hobbiesArray, null, 2));
        } else {
          console.log('⚠️ Geparste Hobbys sind leer oder ungültig:', hobbiesArray);
          setTestResult('Keine Hobbys gefunden');
        }
      } else {
        // Keine relevantHobbies vorhanden
        console.log('⚠️ Keine relevantHobbies in der Backend-Antwort gefunden');
        setTestResult('Keine Hobbys gefunden');
      }
      
      console.log('✅ Hobby-Optimierung erfolgreich abgeschlossen');
      
    } catch (err: any) {
      setError(t('error.optimize.cv.unknown') + (err.message || ''));
    } finally {
      setOptimizing(false);
    }
  };

  // IT-Skills-Optimierung
  const handleItSkillsOptimization = async (promptText: string, promptVersion: string, temperature: string, maxTokens: string) => {
    console.log('🎯 Starte IT-Skills-Optimierung...');
    
    try {
      setError(null);
      setOptimizing(true);
      
      // Prüfe ob User-Daten vorhanden sind
      if (!user) {
        setError('Benutzer nicht angemeldet.');
        setOptimizing(false);
        return;
      }

      // Für IT-Skills-Optimierung: Bereite nur IT-Skills-spezifische Daten vor
      const itSkillsData = {
        itSkills: itSkills || []
      };

      // Erstelle IT-Skills-spezifischen Text
      let itSkillsText = '';
      if (itSkills && itSkills.length > 0) {
        itSkillsText = 'IT-Skills:\n' + itSkills.map(skill => 
          `${skill.skill || 'Unbekannt'} (${skill.level || 'Kein Level'})`
        ).join('\n');
      } else {
        itSkillsText = 'Keine IT-Skills im CV gefunden';
      }

      console.log('🎯 IT-Skills-Daten für Backend:', itSkillsData);
      console.log('🎯 IT-Skills-Text für Backend:', itSkillsText);
      const createCvTextFromData = (data: any) => {
        let cvText = '';
        if (data.personalInfo?.fullName) cvText += `${getTranslatedCvLabel('Name:')} ${data.personalInfo.fullName}\n`;
        if (data.personalInfo?.address) cvText += `${getTranslatedCvLabel('Adresse:')} ${data.personalInfo.address}\n`;
        if (data.personalInfo?.postalCode) cvText += `${getTranslatedCvLabel('PLZ:')} ${data.personalInfo.postalCode}\n`;
        if (data.personalInfo?.city) cvText += `${getTranslatedCvLabel('Stadt:')} ${data.personalInfo.city}\n`;
        if (data.personalInfo?.country) cvText += `${getTranslatedCvLabel('Land:')} ${data.personalInfo.country}\n`;
        if (data.personalInfo?.availableFrom) cvText += `${getTranslatedCvLabel('Verfügbar ab:')} ${data.personalInfo.availableFrom}\n`;
        if (data.personalInfo?.phoneNumber) cvText += `${getTranslatedCvLabel('Telefon:')} ${data.personalInfo.phoneNumber}\n`;
        if (data.personalInfo?.email) cvText += `${getTranslatedCvLabel('Email:')} ${data.personalInfo.email}\n`;
        if (data.personalInfo?.birthYear) cvText += `${getTranslatedCvLabel('Geburtsjahr:')} ${data.personalInfo.birthYear}\n`;
        if (data.personalInfo?.nationality) cvText += `${getTranslatedCvLabel('Nationalität:')} ${data.personalInfo.nationality}\n`;
        if (data.personalInfo?.residencePermit) cvText += `${getTranslatedCvLabel('Aufenthaltsbewilligung:')} ${data.personalInfo.residencePermit}\n`;
        if (data.personalInfo?.civilStatus) cvText += `${getTranslatedCvLabel('Familienstand:')} ${data.personalInfo.civilStatus}\n`;
        if (data.personalInfo?.shortProfile) cvText += `${getTranslatedCvLabel('Profil:')} ${data.personalInfo.shortProfile}\n`;
        if (data.workExperience && data.workExperience.length > 0) {
          cvText += '\nArbeitserfahrung:\n';
          data.workExperience.forEach((exp: any) => {
            cvText += `${exp.position} bei ${exp.company} (${exp.startDate} - ${exp.endDate})\n`;
            cvText += `${exp.description}\n`;
          });
        }
        if (data.education && data.education.length > 0) {
          cvText += '\nAusbildung:\n';
          data.education.forEach((edu: any) => {
            cvText += `${edu.degree} an ${edu.institution} (${edu.startDate} - ${edu.endDate})\n`;
          });
        }
        if (data.itSkills && data.itSkills.length > 0) {
          cvText += '\nIT-Skills:\n';
          data.itSkills.forEach((skill: any) => {
            cvText += `${skill.skill} (${skill.level})\n`;
          });
        }
        if (data.languages && data.languages.length > 0) {
          cvText += '\nSprachen:\n';
          data.languages.forEach((lang: any) => {
            cvText += `${lang.language} (${lang.level})\n`;
          });
        }
        if (data.certifications && data.certifications.length > 0) {
          cvText += '\nZertifikate:\n';
          data.certifications.forEach((cert: any) => {
            cvText += `${cert.certification} - ${cert.issuer} (${cert.date})\n`;
          });
        }
        if (data.hobbies && data.hobbies.length > 0) {
          cvText += '\nHobbys:\n';
          data.hobbies.forEach((hobby: any) => {
            cvText += `${hobby.hobby}: ${hobby.description}\n`;
          });
        }
        if (data.additionalInfo && data.additionalInfo.length > 0) {
          cvText += '\nZusätzliche Informationen:\n';
          data.additionalInfo.forEach((info: any) => {
            cvText += `${info.info}: ${info.details}\n`;
          });
        }
        if (data.coreCompetencies && data.coreCompetencies.length > 0) {
          cvText += '\nKernkompetenzen:\n';
          data.coreCompetencies.forEach((comp: any) => {
            cvText += `${comp.competency}\n`;
          });
        }
        if (data.industryExperiences && data.industryExperiences.length > 0) {
          cvText += '\nBranchenerfahrungen:\n';
          data.industryExperiences.forEach((exp: any) => {
            cvText += `${exp.industry} (${exp.years} Jahre)\n`;
          });
        }
        return cvText;
      };

      // Hole ID Token für Backend-Authentifizierung
      const idToken = await user.getIdToken();

      // Sende Request an Backend für IT-Skills-Optimierung
      const optimizeResponse = await fetch(config.backend.optimizeCvJsonUrl, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({
          cvData: itSkillsData, // Nur IT-Skills-Daten
          cvText: itSkillsText, // Nur IT-Skills-Text
          jobDescription: jobDescription,
          optimizeType: 'itSkills',
          targetLanguage: targetLanguage,
          // Test-spezifische Parameter
          testPrompt: promptText,
          chatGptVersion: promptVersion,
          temperature: temperature,
          maxTokens: maxTokens
        }),
      });
      
      if (!optimizeResponse.ok) throw new Error(t('error.optimize.cv'));
      const data = await optimizeResponse.json();
      
      // Backend-Antwort für IT-Skills verarbeitet
      
      // Setze die relevanten IT-Skills
      if (data.relevantItSkills) {
        let itSkillsArray;
        
        // Prüfe ob relevantItSkills ein String ist (JSON) oder bereits ein Array
        if (typeof data.relevantItSkills === 'string') {
          try {
            // Entferne Markdown-Code-Block-Formatierung falls vorhanden
            let cleanJsonString = data.relevantItSkills;
            if (cleanJsonString.includes('```json')) {
              cleanJsonString = cleanJsonString.replace(/```json\n?/g, '').replace(/```\n?/g, '');
              console.log('🔧 Markdown-Code-Block entfernt, bereinigter String:', cleanJsonString);
            }
            
            // Parse den bereinigten JSON-String zu einem Array
            itSkillsArray = JSON.parse(cleanJsonString);
            console.log('✅ JSON-String erfolgreich geparst zu Array:', itSkillsArray);
          } catch (parseError) {
            console.error('❌ Fehler beim Parsen des JSON-Strings:', parseError);
            setTestResult('Fehler beim Parsen der IT-Skills-Daten');
            return;
          }
        } else if (Array.isArray(data.relevantItSkills)) {
          // relevantItSkills ist bereits ein Array
          itSkillsArray = data.relevantItSkills;
          console.log('✅ relevantItSkills ist bereits ein Array:', itSkillsArray);
        } else {
          console.log('⚠️ relevantItSkills ist weder String noch Array:', typeof data.relevantItSkills);
          setTestResult('Unerwartetes Datenformat für IT-Skills');
          return;
        }
        
        // Prüfe ob das geparste Array gültig ist
        if (itSkillsArray && Array.isArray(itSkillsArray) && itSkillsArray.length > 0) {
          // Setze die IT-Skills im lokalen State
          setRelevantItSkills(itSkillsArray);
          console.log('✅ Relevante IT-Skills gesetzt:', itSkillsArray.length, 'Skills');
          
          // Zeige nur die relevanten IT-Skills im Test-Modal an
          setTestResult(JSON.stringify(itSkillsArray, null, 2));
        } else {
          console.log('⚠️ Geparste IT-Skills sind leer oder ungültig:', itSkillsArray);
          setTestResult('Keine IT-Skills gefunden');
        }
      } else {
        // Keine relevantItSkills vorhanden
        console.log('⚠️ Keine relevantItSkills in der Backend-Antwort gefunden');
        setTestResult('Keine IT-Skills gefunden');
      }
      
      console.log('✅ IT-Skills-Optimierung erfolgreich abgeschlossen');
      
    } catch (err: any) {
      setError(t('error.optimize.cv.unknown') + (err.message || ''));
    } finally {
      setOptimizing(false);
    }
  };

  // Kernkompetenzen-Optimierung
  const handleCoreCompetenciesOptimization = async (promptText: string, promptVersion: string, temperature: string, maxTokens: string) => {
    console.log('🎯 Starte Kernkompetenzen-Optimierung...');
    
    try {
      setError(null);
      setOptimizing(true);
      
      // Prüfe ob User-Daten vorhanden sind
      if (!user) {
        setError('Benutzer nicht angemeldet.');
        setOptimizing(false);
        return;
      }

      // Verwende alle Daten aus den bereits geladenen Tabellendaten
      const personalInfo = getPersonalInfoForMotivation();
      
      // Erstelle CV-Text aus strukturierten Daten für die Optimierung
      const createCvTextFromData = (data: any) => {
        let cvText = '';
        if (data.personalInfo?.fullName) cvText += `${getTranslatedCvLabel('Name:')} ${data.personalInfo.fullName}\n`;
        if (data.personalInfo?.address) cvText += `${getTranslatedCvLabel('Adresse:')} ${data.personalInfo.address}\n`;
        if (data.personalInfo?.postalCode) cvText += `${getTranslatedCvLabel('PLZ:')} ${data.personalInfo.postalCode}\n`;
        if (data.personalInfo?.city) cvText += `${getTranslatedCvLabel('Stadt:')} ${data.personalInfo.city}\n`;
        if (data.personalInfo?.country) cvText += `${getTranslatedCvLabel('Land:')} ${data.personalInfo.country}\n`;
        if (data.personalInfo?.availableFrom) cvText += `${getTranslatedCvLabel('Verfügbar ab:')} ${data.personalInfo.availableFrom}\n`;
        if (data.personalInfo?.phoneNumber) cvText += `${getTranslatedCvLabel('Telefon:')} ${data.personalInfo.phoneNumber}\n`;
        if (data.personalInfo?.email) cvText += `${getTranslatedCvLabel('Email:')} ${data.personalInfo.email}\n`;
        if (data.personalInfo?.birthYear) cvText += `${getTranslatedCvLabel('Geburtsjahr:')} ${data.personalInfo.birthYear}\n`;
        if (data.personalInfo?.nationality) cvText += `${getTranslatedCvLabel('Nationalität:')} ${data.personalInfo.nationality}\n`;
        if (data.personalInfo?.residencePermit) cvText += `${getTranslatedCvLabel('Aufenthaltsbewilligung:')} ${data.personalInfo.residencePermit}\n`;
        if (data.personalInfo?.civilStatus) cvText += `${getTranslatedCvLabel('Familienstand:')} ${data.personalInfo.civilStatus}\n`;
        if (data.personalInfo?.shortProfile) cvText += `${getTranslatedCvLabel('Profil:')} ${data.personalInfo.shortProfile}\n`;
        if (data.workExperience && data.workExperience.length > 0) {
          cvText += '\nArbeitserfahrung:\n';
          data.workExperience.forEach((exp: any) => {
            cvText += `${exp.position} bei ${exp.company} (${exp.startDate} - ${exp.endDate})\n`;
            cvText += `${exp.description}\n`;
          });
        }
        if (data.education && data.education.length > 0) {
          cvText += '\nAusbildung:\n';
          data.education.forEach((edu: any) => {
            cvText += `${edu.degree} an ${edu.institution} (${edu.startDate} - ${edu.endDate})\n`;
          });
        }
        if (data.itSkills && data.itSkills.length > 0) {
          cvText += '\nIT-Skills:\n';
          data.itSkills.forEach((skill: any) => {
            cvText += `${skill.skill} (${skill.level})\n`;
          });
        }
        if (data.languages && data.languages.length > 0) {
          cvText += '\nSprachen:\n';
          data.languages.forEach((lang: any) => {
            cvText += `${lang.language} (${lang.level})\n`;
          });
        }
        if (data.certifications && data.certifications.length > 0) {
          cvText += '\nZertifikate:\n';
          data.certifications.forEach((cert: any) => {
            cvText += `${cert.certification} - ${cert.issuer} (${cert.date})\n`;
          });
        }
        if (data.hobbies && data.hobbies.length > 0) {
          cvText += '\nHobbys:\n';
          data.hobbies.forEach((hobby: any) => {
            cvText += `${hobby.hobby}: ${hobby.description}\n`;
          });
        }
        if (data.additionalInfo && data.additionalInfo.length > 0) {
          cvText += '\nZusätzliche Informationen:\n';
          data.additionalInfo.forEach((info: any) => {
            cvText += `${info.info}: ${info.details}\n`;
          });
        }
        if (data.coreCompetencies && data.coreCompetencies.length > 0) {
          cvText += '\nKernkompetenzen:\n';
          data.coreCompetencies.forEach((comp: any) => {
            cvText += `${comp.competency}\n`;
          });
        }
        if (data.industryExperiences && data.industryExperiences.length > 0) {
          cvText += '\nBranchenerfahrungen:\n';
          data.industryExperiences.forEach((exp: any) => {
            cvText += `${exp.industry} (${exp.years} Jahre)\n`;
          });
        }
        return cvText;
      };

      // Erstelle strukturierte CV-Daten aus den bereits geladenen Tabellendaten
      const cvData = {
        personalInfo: {
          fullName: personalInfo.fullName || '',
          address: personalInfo.address || '',
          postalCode: personalInfo.postalCode || '',
          city: personalInfo.city || '',
          country: personalInfo.country || '',
          availableFrom: personalInfo.availableFrom || '',
          phoneNumber: personalInfo.phoneNumber || '',
          email: personalInfo.email || '',
          birthYear: birthYear || '',
          nationality: nationality || '',
          residencePermit: residencePermit || '',
          civilStatus: civilStatus || '',
          shortProfile: shortProfile || ''
        },
        workExperience: workExperiences || [],
        education: educations || [],
        certifications: certifications || [],
        languages: languages || [],
        itSkills: itSkills || [],
        coreCompetencies: coreCompetencies || [],
        industryExperiences: industryExperiences || [],
        hobbies: hobbies || [],
        additionalInfo: additionalInfo || []
      };

      // Für Kernkompetenzen-Optimierung: Bereite nur Kernkompetenzen-spezifische Daten vor
      const coreCompetenciesData = {
        coreCompetencies: coreCompetencies || []
      };

      // Erstelle Kernkompetenzen-spezifischen Text
      let coreCompetenciesText = '';
      if (coreCompetencies && coreCompetencies.length > 0) {
        coreCompetenciesText = coreCompetencies.map(comp => 
          `${comp.competency || 'Keine Kompetenz'}`
        ).join('\n');
      } else {
        coreCompetenciesText = 'Keine Kernkompetenzen im CV gefunden';
      }

      console.log('🎯 Kernkompetenzen-Daten für Backend:', coreCompetenciesData);
      console.log('🎯 Kernkompetenzen-Text für Backend:', coreCompetenciesText);

      // Hole ID Token für Backend-Authentifizierung
      const idToken = await user.getIdToken();

      // Sende Request an Backend für Kernkompetenzen-Optimierung
      const optimizeResponse = await fetch(config.backend.optimizeCvJsonUrl, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({
          cvData: coreCompetenciesData, // Nur Kernkompetenzen-Daten
          cvText: coreCompetenciesText, // Nur Kernkompetenzen-Text
          jobDescription: jobDescription,
          optimizeType: 'coreCompetencies',
          targetLanguage: targetLanguage,
          // Test-spezifische Parameter
          testPrompt: promptText,
          chatGptVersion: promptVersion,
          temperature: temperature,
          maxTokens: maxTokens
        }),
      });
      
      if (!optimizeResponse.ok) throw new Error(t('error.optimize.cv'));
      const data = await optimizeResponse.json();
      
      // Backend-Antwort für Kernkompetenzen verarbeitet
      
      // Setze die relevanten Kernkompetenzen
      if (data.relevantCoreCompetencies) {
        let coreCompetenciesArray;
        
        // Prüfe ob relevantCoreCompetencies ein String ist (JSON) oder bereits ein Array
        if (typeof data.relevantCoreCompetencies === 'string') {
            // Entferne Markdown-Code-Block-Formatierung falls vorhanden
            let cleanJsonString = data.relevantCoreCompetencies;
            if (cleanJsonString.includes('```json')) {
              cleanJsonString = cleanJsonString.replace(/```json\n?/g, '').replace(/```\n?/g, '');
              console.log('🔧 Markdown-Code-Block entfernt, bereinigter String:', cleanJsonString);
            }
          
          try {
            // JSON-String verarbeitet
            
            // Parse den bereinigten JSON-String zu einem Array
            coreCompetenciesArray = JSON.parse(cleanJsonString);
            console.log('✅ JSON-String erfolgreich geparst zu Array:', coreCompetenciesArray);
          } catch (parseError) {
            console.error('❌ Fehler beim Parsen des JSON-Strings:', parseError);
            console.error('❌ Problematischer JSON-String:', cleanJsonString);
            console.error('❌ JSON-String Länge:', cleanJsonString.length);
            const errorMessage = parseError instanceof Error ? parseError.message : 'Unbekannter Fehler';
            setTestResult(`Fehler beim Parsen der Kernkompetenzen-Daten: ${errorMessage}`);
            return;
          }
        } else if (Array.isArray(data.relevantCoreCompetencies)) {
          // relevantCoreCompetencies ist bereits ein Array
          coreCompetenciesArray = data.relevantCoreCompetencies;
          console.log('✅ relevantCoreCompetencies ist bereits ein Array:', coreCompetenciesArray);
        } else {
          console.log('⚠️ relevantCoreCompetencies ist weder String noch Array:', typeof data.relevantCoreCompetencies);
          setTestResult('Unerwartetes Datenformat für Kernkompetenzen');
          return;
        }
        
        // Prüfe ob das geparste Array gültig ist
        if (coreCompetenciesArray && Array.isArray(coreCompetenciesArray) && coreCompetenciesArray.length > 0) {
          // Setze die Kernkompetenzen im lokalen State
          setRelevantCoreCompetencies(coreCompetenciesArray);
          console.log('✅ Relevante Kernkompetenzen gesetzt:', coreCompetenciesArray.length, 'Kompetenzen');
          
          // Zeige nur die relevanten Kernkompetenzen im Test-Modal an
          setTestResult(JSON.stringify(coreCompetenciesArray, null, 2));
        } else {
          console.log('⚠️ Geparste Kernkompetenzen sind leer oder ungültig:', coreCompetenciesArray);
          setTestResult('Keine Kernkompetenzen gefunden');
        }
      } else {
        // Keine relevantCoreCompetencies vorhanden
        console.log('⚠️ Keine relevantCoreCompetencies in der Backend-Antwort gefunden');
        setTestResult('Keine Kernkompetenzen gefunden');
      }
      
      console.log('✅ Kernkompetenzen-Optimierung erfolgreich abgeschlossen');
      
    } catch (err: any) {
      setError(t('error.optimize.cv.unknown') + (err.message || ''));
    } finally {
      setOptimizing(false);
    }
  };

  // Sprach-Optimierung
  const handleLanguageOptimization = async (promptText: string, promptVersion: string, temperature: string, maxTokens: string) => {
    console.log('🌍 Starte Sprach-Optimierung...');
    
    try {
      setError(null);
      setOptimizing(true);
      
      // Prüfe ob User-Daten vorhanden sind
      if (!user) {
        setError('Benutzer nicht angemeldet.');
        setOptimizing(false);
        return;
      }

      // Für Sprach-Optimierung: Bereite nur Sprach-spezifische Daten vor
      const languageData = {
        languages: languages || []
      };

      // Erstelle Sprach-spezifischen Text
      let languageText = '';
      if (languages && languages.length > 0) {
        languageText = languages.map(lang => 
          `${lang.language || 'Keine Sprache'} (${lang.level || 'Kein Niveau'})`
        ).join('\n');
      } else {
        languageText = 'Keine Sprachen im CV gefunden';
      }

      console.log('🌍 Sprach-Daten für Backend:', languageData);
      console.log('🌍 Sprach-Text für Backend:', languageText);

      // Hole ID Token für Backend-Authentifizierung
      const idToken = await user.getIdToken();

      // Sende Request an Backend für Sprach-Optimierung
      const optimizeResponse = await fetch(config.backend.optimizeCvJsonUrl, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({
          cvData: languageData, // Nur Sprach-Daten
          cvText: languageText, // Nur Sprach-Text
          jobDescription: jobDescription,
          optimizeType: 'languages',
          targetLanguage: targetLanguage,
          // Test-spezifische Parameter
          testPrompt: promptText,
          chatGptVersion: promptVersion,
          temperature: temperature,
          maxTokens: maxTokens
        }),
      });
      
      if (!optimizeResponse.ok) throw new Error(t('error.optimize.cv'));
      const data = await optimizeResponse.json();
      
      // Backend-Antwort für Sprachen verarbeitet
      
      // Setze die relevanten Sprachen - genauso wie bei der Ausbildung
      if (data.relevantLanguages) {
        let languageArray;
        
        // Prüfe ob relevantLanguages ein String ist (JSON) oder bereits ein Array
        if (typeof data.relevantLanguages === 'string') {
          try {
            // Entferne Markdown-Code-Block-Formatierung falls vorhanden
            let cleanJsonString = data.relevantLanguages;
            if (cleanJsonString.includes('```json')) {
              cleanJsonString = cleanJsonString.replace(/```json\n?/g, '').replace(/```\n?/g, '');
              console.log('🔧 Markdown-Code-Block entfernt, bereinigter String:', cleanJsonString);
            }
            
            // Parse den bereinigten JSON-String zu einem Array
            languageArray = JSON.parse(cleanJsonString);
            console.log('✅ JSON-String erfolgreich geparst zu Array:', languageArray);
          } catch (parseError) {
            console.error('❌ Fehler beim Parsen des JSON-Strings:', parseError);
            setTestResult('Fehler beim Parsen der Sprach-Daten');
            return;
          }
        } else if (Array.isArray(data.relevantLanguages)) {
          // relevantLanguages ist bereits ein Array
          languageArray = data.relevantLanguages;
          console.log('✅ relevantLanguages ist bereits ein Array:', languageArray);
        } else {
          console.log('⚠️ relevantLanguages ist weder String noch Array:', typeof data.relevantLanguages);
          setTestResult('Unerwartetes Datenformat für Sprachen');
          return;
        }
        
        // Prüfe ob das geparste Array gültig ist
        if (languageArray && Array.isArray(languageArray) && languageArray.length > 0) {
          // Setze die Sprachen im lokalen State
          setRelevantLanguages(languageArray);
          console.log('✅ Relevante Sprachen erfolgreich gesetzt:', languageArray.length, 'Sprachen');
          
          // Zeige nur die effektiven Sprach-Daten ohne zusätzlichen Text
          setTestResult(JSON.stringify(languageArray, null, 2));
        } else {
          console.log('⚠️ Keine gültigen Sprach-Daten gefunden');
          setTestResult('Keine relevanten Sprachen gefunden');
        }
      } else {
        console.log('⚠️ Keine relevantLanguages in der Backend-Antwort');
        setTestResult('Keine Sprach-Daten vom Backend erhalten');
      }
      
      console.log('✅ Sprach-Optimierung erfolgreich abgeschlossen');
      
    } catch (err: any) {
      console.error('❌ Fehler bei Sprach-Optimierung:', err);
      setError(t('error.optimize.cv.unknown') + (err.message || ''));
      setTestResult(`Fehler: ${err.message || 'Unbekannter Fehler'}`);
    } finally {
      setOptimizing(false);
    }
  };

  // Hauptfunktion für vollständige CV-Optimierung (alle Bereiche)
  const handleOptimizeCv = async (testMode = false, testPromptType = '', testPromptText = '', testPromptVersion = '', testTemperature = '', testMaxTokens = '') => {
    // Wenn bereits optimierte CV-Daten vorhanden sind und nicht im Test-Modus, öffne die CV Preview
    if (hasOptimizedCvData() && !testMode) {
      await handleOpenCvTemplate();
      return;
    }

    setError(null);
    setImprovedCvText(null);
    setOptimizing(true);
    setHideMatchResults(true); // Verstecke Match-Ergebnisse
    setInfoMessage(getTranslatedInfoMessage('optimizing_cv'));
    resetMatchData(); // Lösche alle Match-Daten
    setRelevantItSkills([]); // Lösche relevante IT-Kenntnisse
    setRelevantEducations([]); // Lösche relevante Ausbildungen
    setRelevantLanguages([]); // Lösche relevante Sprachen
    setRelevantIndustries([]); // Lösche relevante Branchen
    setRelevantHobbies([]); // Lösche relevante Hobbys
    setRelevantCoreCompetencies([]); // Lösche relevante Kernkompetenzen
    
    
    if (!jobDescription.trim()) {
      setError('Stellenbeschreibung ist erforderlich.');
      setOptimizing(false);
      return;
    }

    // Prüfe ob User-Daten vorhanden sind
    if (!user) {
      setError('Benutzer nicht angemeldet.');
      setOptimizing(false);
      return;
    }

    try {
      // Verwende alle Daten aus den bereits geladenen Tabellendaten
      const personalInfo = getPersonalInfoForMotivation();
      
      // Erstelle CV-Text aus strukturierten Daten für die Optimierung
      const createCvTextFromData = (data: any) => {
        let cvText = '';
        if (data.personalInfo?.fullName) cvText += `${getTranslatedCvLabel('Name:')} ${data.personalInfo.fullName}\n`;
        if (data.personalInfo?.address) cvText += `${getTranslatedCvLabel('Adresse:')} ${data.personalInfo.address}\n`;
        if (data.personalInfo?.postalCode) cvText += `${getTranslatedCvLabel('PLZ:')} ${data.personalInfo.postalCode}\n`;
        if (data.personalInfo?.city) cvText += `${getTranslatedCvLabel('Stadt:')} ${data.personalInfo.city}\n`;
        if (data.personalInfo?.country) cvText += `${getTranslatedCvLabel('Land:')} ${data.personalInfo.country}\n`;
        if (data.personalInfo?.availableFrom) cvText += `${getTranslatedCvLabel('Verfügbar ab:')} ${data.personalInfo.availableFrom}\n`;
        if (data.personalInfo?.phoneNumber) cvText += `${getTranslatedCvLabel('Telefon:')} ${data.personalInfo.phoneNumber}\n`;
        if (data.personalInfo?.email) cvText += `${getTranslatedCvLabel('Email:')} ${data.personalInfo.email}\n`;
        if (data.personalInfo?.birthYear) cvText += `${getTranslatedCvLabel('Geburtsjahr:')} ${data.personalInfo.birthYear}\n`;
        if (data.personalInfo?.nationality) cvText += `${getTranslatedCvLabel('Nationalität:')} ${data.personalInfo.nationality}\n`;
        if (data.personalInfo?.residencePermit) cvText += `${getTranslatedCvLabel('Aufenthaltsbewilligung:')} ${data.personalInfo.residencePermit}\n`;
        if (data.personalInfo?.civilStatus) cvText += `${getTranslatedCvLabel('Familienstand:')} ${data.personalInfo.civilStatus}\n`;
        if (data.personalInfo?.shortProfile) cvText += `${getTranslatedCvLabel('Profil:')} ${data.personalInfo.shortProfile}\n`;
        if (data.workExperience && data.workExperience.length > 0) {
          cvText += '\nArbeitserfahrung:\n';
          data.workExperience.forEach((exp: any) => {
            cvText += `${exp.position} bei ${exp.company} (${exp.startDate} - ${exp.endDate})\n`;
            cvText += `${exp.description}\n`;
          });
        }
        if (data.education && data.education.length > 0) {
          cvText += '\nAusbildung:\n';
          data.education.forEach((edu: any) => {
            cvText += `${edu.degree} an ${edu.institution} (${edu.startDate} - ${edu.endDate})\n`;
          });
        }
        if (data.itSkills && data.itSkills.length > 0) {
          cvText += '\nIT-Skills:\n';
          data.itSkills.forEach((skill: any) => {
            cvText += `${skill.skill} (${skill.level})\n`;
          });
        }
        if (data.languages && data.languages.length > 0) {
          cvText += '\nSprachen:\n';
          data.languages.forEach((lang: any) => {
            cvText += `${lang.language} (${lang.level})\n`;
          });
        }
        if (data.certifications && data.certifications.length > 0) {
          cvText += '\nZertifikate:\n';
          data.certifications.forEach((cert: any) => {
            cvText += `${cert.certification} - ${cert.issuer} (${cert.date})\n`;
          });
        }
        if (data.hobbies && data.hobbies.length > 0) {
          cvText += '\nHobbys:\n';
          data.hobbies.forEach((hobby: any) => {
            cvText += `${hobby.hobby}: ${hobby.description}\n`;
          });
        }
        if (data.additionalInfo && data.additionalInfo.length > 0) {
          cvText += '\nZusätzliche Informationen:\n';
          data.additionalInfo.forEach((info: any) => {
            cvText += `${info.info}: ${info.details}\n`;
          });
        }
        if (data.coreCompetencies && data.coreCompetencies.length > 0) {
          cvText += '\nKernkompetenzen:\n';
          data.coreCompetencies.forEach((comp: any) => {
            cvText += `${comp.competency}\n`;
          });
        }
        if (data.industryExperiences && data.industryExperiences.length > 0) {
          cvText += '\nBranchenerfahrungen:\n';
          data.industryExperiences.forEach((exp: any) => {
            cvText += `${exp.industry} (${exp.years} Jahre)\n`;
          });
        }
        return cvText;
      };

      // Erstelle strukturierte CV-Daten aus den bereits geladenen Tabellendaten
      const cvData = {
        personalInfo: {
          fullName: personalInfo.fullName || '',
          address: personalInfo.address || '',
          postalCode: personalInfo.postalCode || '',
          city: personalInfo.city || '',
          country: personalInfo.country || '',
          availableFrom: personalInfo.availableFrom || '',
          phoneNumber: personalInfo.phoneNumber || '',
          email: personalInfo.email || '',
          birthYear: birthYear || '',
          nationality: nationality || '',
          residencePermit: residencePermit || '',
          civilStatus: civilStatus || '',
          shortProfile: shortProfile || ''
        },
        workExperience: workExperiences || [],
        education: educations || [],
        certifications: certifications || [],
        languages: languages || [],
        itSkills: itSkills || [],
        coreCompetencies: coreCompetencies || [],
        industryExperiences: industryExperiences || [],
        hobbies: hobbies || [],
        additionalInfo: additionalInfo || []
      };

      // Erstelle auch den CV-Text für das Backend
      const cvText = createCvTextFromData(cvData);

      // Hole ID Token für Backend-Authentifizierung
      const idToken = await user.getIdToken();

      // Konvertiere browserLanguage in ausgeschriebene Form
      const browserLanguageMap: { [key: string]: string } = {
        'de': 'deutsch',
        'en': 'englisch',
        'fr': 'französisch',
        'it': 'italienisch'
      };
      const browserLanguageWritten = browserLanguageMap[currentLanguage] || 'deutsch';
      
      // Verwende bereits erstellten ID Token
      const normalizedTestType = (testPromptType || '').toString().toLowerCase();
      const isMotivationTest = normalizedTestType === 'motivation' || normalizedTestType.includes('motiv');
      const requestBody = testMode ? {
        cvData: cvData,
        cvText: cvText,
        jobDescription: jobDescription,
        optimizeType: isMotivationTest ? 'motivation' : (testPromptType || 'cv'),
        targetLanguage: targetLanguage,
        browserLanguage: browserLanguageWritten,
        ...(isMotivationTest ? { generateSeparateFields: true } : {}),
        // Test-spezifische Parameter
        testPrompt: testPromptText,
        chatGptVersion: testPromptVersion,
        temperature: testTemperature,
        maxTokens: testMaxTokens
      } : {
        cvData: cvData,
        cvText: cvText,
        jobDescription: jobDescription,
        optimizeType: 'cv',
        targetLanguage: targetLanguage,
        browserLanguage: browserLanguageWritten
      };

      const optimizeResponse = await fetch(config.backend.optimizeCvJsonUrl, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify(requestBody),
      });
      
      if (!optimizeResponse.ok) throw new Error(t('error.optimize.cv'));
      const data = await optimizeResponse.json();
      setImprovedCvText(typeof data.optimizedCvText === 'string' ? data.optimizedCvText : null);
      
      // Setze das optimierte Kurzprofil
      console.log('📥 Backend Response Data:', data);
      console.log('📥 optimizedShortProfile:', data.optimizedShortProfile);
      console.log('📥 optimizedWorkExperiences:', data.optimizedWorkExperiences);
      
      if (data.optimizedShortProfile && typeof data.optimizedShortProfile === 'string') {
        console.log('✅ Setze optimiertes Kurzprofil:', data.optimizedShortProfile.substring(0, 100) + '...');
        setOptimizedShortProfile(data.optimizedShortProfile);
      } else {
        console.log('❌ Kein optimiertes Kurzprofil in Response');
        // Kein Fallback: Setze auf leeren String
        setOptimizedShortProfile('');
      }
      
      // AI-basierte Auswahl der besten Arbeitserfahrungen
      if (data.optimizedWorkExperiences && Array.isArray(data.optimizedWorkExperiences)) {
        console.log('✅ Setze optimierte Arbeitserfahrungen:', data.optimizedWorkExperiences.length, 'Erfahrungen');
        // Aktualisiere die Arbeitserfahrungen mit den AI-optimierten
        const updatedWorkExperiences = data.optimizedWorkExperiences.map((exp: any, index: number) => ({
          position: exp.position || '',
          company: exp.company || '',
          startDate: exp.startDate || '',
          endDate: exp.endDate || '',
          description: exp.description || '',
          relevant: exp.relevant || true
        }));
        
        // Fülle bis zu 3 Arbeitserfahrungen auf
        while (updatedWorkExperiences.length < 3) {
          updatedWorkExperiences.push({
            position: '',
            company: '',
            startDate: '',
            endDate: '',
            description: '',
            relevant: true
          });
        }
        
        setOptimizedWorkExperiences(updatedWorkExperiences);
        setRelevantWorkExperiences(updatedWorkExperiences);
        console.log('✅ Optimierte Berufserfahrungen gesetzt:', updatedWorkExperiences.length, 'Erfahrungen');
      }
      
      // Setze die relevanten IT-Kenntnisse
      if (data.relevantItSkills && Array.isArray(data.relevantItSkills)) {
        setRelevantItSkills(data.relevantItSkills);
        console.log('✅ Relevante IT-Skills gesetzt:', data.relevantItSkills.length, 'Skills');
      }
      
      // Setze NUR die AI-optimierten Ausbildungen vom Backend
      if (data.relevantEducations && Array.isArray(data.relevantEducations)) {
        setRelevantEducations(data.relevantEducations);
        console.log('✅ AI-optimierte Ausbildungen gesetzt:', data.relevantEducations.length, 'Ausbildungen');
      } else {
        setRelevantEducations([]);
        console.log('❌ Keine AI-optimierten Ausbildungen vom Backend');
      }
      
      // Setze die relevanten Zertifizierungen
      if (data.relevantCertifications && Array.isArray(data.relevantCertifications)) {
        setRelevantCertifications(data.relevantCertifications);
        console.log('✅ Relevante Zertifizierungen gesetzt:', data.relevantCertifications.length, 'Zertifizierungen');
      }
      
      // Setze NUR die AI-optimierten Kernkompetenzen vom Backend
      if (data.relevantCoreCompetencies && Array.isArray(data.relevantCoreCompetencies)) {
        setRelevantCoreCompetencies(data.relevantCoreCompetencies);
        console.log('✅ AI-optimierte Kernkompetenzen gesetzt:', data.relevantCoreCompetencies.length, 'Kompetenzen');
      } else {
        setRelevantCoreCompetencies([]);
        console.log('❌ Keine AI-optimierten Kernkompetenzen vom Backend');
      }
      
      // Setze die relevanten Branchen
      if (data.relevantIndustries && Array.isArray(data.relevantIndustries)) {
        setRelevantIndustries(data.relevantIndustries);
        console.log('✅ Relevante Branchen gesetzt:', data.relevantIndustries.length, 'Branchen');
      }
      
      // Setze die relevanten Hobbys
      // relevantHobbies verarbeitet
      if (data.relevantHobbies && Array.isArray(data.relevantHobbies)) {
        setRelevantHobbies(data.relevantHobbies);
        console.log('✅ Relevante Hobbys gesetzt:', data.relevantHobbies.length, 'Hobbys');
        console.log('✅ Relevante Hobbys Details:', data.relevantHobbies);
      } else {
        console.log('❌ Keine relevanten Hobbys in Response gefunden');
      }
      
      // Setze die relevanten weiteren Informationen
      if (data.relevantAdditionalInfo && Array.isArray(data.relevantAdditionalInfo)) {
        setRelevantAdditionalInfo(data.relevantAdditionalInfo);
        console.log('✅ Relevante weitere Informationen gesetzt:', data.relevantAdditionalInfo.length, 'Informationen');
      }
      
      // Setze NUR die AI-optimierten Sprachen vom Backend
      if (data.relevantLanguages && Array.isArray(data.relevantLanguages)) {
        setRelevantLanguages(data.relevantLanguages);
        console.log('✅ AI-optimierte Sprachen gesetzt:', data.relevantLanguages.length, 'Sprachen');
      } else {
        setRelevantLanguages([]);
        console.log('❌ Keine AI-optimierten Sprachen vom Backend');
      }
      
      // Im Test-Modus: Zeige Ergebnisse im Modal an
      if (testMode) {
        console.log('🧪 Test-Modus: Zeige Ergebnisse im Modal');
        
        // Spezielle Behandlung für Match-Score
        if (testPromptType === 'match') {
          const matchResult = {
            matchScore: data.matchScore || 0,
            missingSkills: data.missingSkills || [],
            weaknesses: data.weaknesses || []
          };
          setTestResult(JSON.stringify(matchResult, null, 2));
        } else {
          const result = data.optimizedCvText || data.result || 'Kein Ergebnis verfügbar';
          setTestResult(result);
        }
        
        // Fülle die entsprechenden Tabellen basierend auf dem Prompt-Typ
        if (data.parsedResult && Array.isArray(data.parsedResult)) {
          console.log('🔧 Fülle Tabellen mit Test-Ergebnissen:', testPromptType);
          
          switch (testPromptType) {
            case 'Hobbys-Optimierung':
              setRelevantHobbies(data.parsedResult);
              break;
            case 'IT-Skills':
              setRelevantItSkills(data.parsedResult);
              break;
            case 'Kernkompetenzen':
              setRelevantCoreCompetencies(data.parsedResult);
              break;
            case 'Zertifizierungen':
              setRelevantCertifications(data.parsedResult);
              break;
            case 'Relevante Ausbildungen':
              setRelevantEducations(data.parsedResult);
              break;
            case 'Relevante Sprachen':
              setRelevantLanguages(data.parsedResult);
              break;
            case 'Branchen-Optimierung':
              setRelevantIndustries(data.parsedResult);
              break;
          }
        }
      } else {
        // Normaler Modus: Öffne automatisch die Template Preview
        if (data.optimizedCvText) {
          await handleOpenCvTemplate();
          console.log('🎯 Template Preview automatisch geöffnet - optimierte Daten verfügbar');
        }
      }
    } catch (err: any) {
      setError(t('error.optimize.cv.unknown') + (err.message || ''));
    } finally {
      setOptimizing(false);
    }
  };

  // Prüfe ob bereits optimierte CV-Daten vorhanden sind
  const hasOptimizedCvData = () => {
    return optimizedShortProfile || 
           (optimizedWorkExperiences && optimizedWorkExperiences.length > 0) ||
           improvedCvText;
  };

  // Neue parallele CV-Optimierung für bessere Performance
  const handleOptimizeCvParallel = async () => {
    setError(null);
    setImprovedCvText(null);
    setOptimizing(true);
    setHideMatchResults(true);
    resetMatchData();
    setRelevantItSkills([]);
    setRelevantEducations([]);
    setRelevantLanguages([]);
    setRelevantIndustries([]);
    setRelevantHobbies([]);
    setRelevantCoreCompetencies([]);
    setCvTemplateHasBeenOpened(false); // Reset: Template wurde noch nicht geöffnet
    setSelectedApplicationId(null); // Reset: Neue Bewerbung soll erstellt werden
    setSelectedApplication(null); // Reset: Verhindere, dass alte Bewerbung überschrieben wird
    
    if (!jobDescription.trim()) {
      setError('Stellenbeschreibung ist erforderlich.');
      setOptimizing(false);
      return;
    }

    if (!user) {
      setError('Benutzer nicht angemeldet.');
      setOptimizing(false);
      return;
    }

    // KEINE Speicherung vor der Optimierung - Design wird beim Öffnen der Preview aus Firebase geladen
    // Design-Einstellungen werden nur beim Schließen der Preview gespeichert

    try {
      const personalInfo = getPersonalInfoForMotivation();
      
      // Erstelle strukturierte CV-Daten
      const cvData = {
        personalInfo: {
          fullName: personalInfo.fullName || '',
          address: personalInfo.address || '',
          postalCode: personalInfo.postalCode || '',
          city: personalInfo.city || '',
          country: personalInfo.country || '',
          availableFrom: personalInfo.availableFrom || '',
          phoneNumber: personalInfo.phoneNumber || '',
          email: personalInfo.email || '',
          birthYear: birthYear || '',
          nationality: nationality || '',
          residencePermit: residencePermit || '',
          civilStatus: civilStatus || '',
          shortProfile: shortProfile || ''
        },
        workExperience: workExperiences || [],
        education: educations || [],
        certifications: certifications || [],
        languages: languages || [],
        itSkills: itSkills || [],
        coreCompetencies: coreCompetencies || [],
        industryExperiences: industryExperiences || [],
        hobbies: hobbies || [],
        additionalInfo: additionalInfo || []
      };

      // Hole ID Token für Backend-Authentifizierung
      const idToken = await user.getIdToken();

      // Definiere alle Optimierungsaufgaben
      const optimizationTasks = [
        { 
          name: 'Kurzprofil', 
          type: 'shortProfile',
          setter: setOptimizedShortProfile,
          getter: () => optimizedShortProfile
        },
        { 
          name: 'Arbeitserfahrung', 
          type: 'workExperience',
          setter: (data: any) => {
            if (data && Array.isArray(data)) {
              const updatedWorkExperiences = data.map((exp: any, index: number) => ({
                ...exp,
                id: index + 1,
                relevant: exp.relevant || 'true'
              }));
              setOptimizedWorkExperiences(updatedWorkExperiences);
            }
          },
          getter: () => optimizedWorkExperiences
        },
        { 
          name: 'Ausbildung', 
          type: 'education',
          setter: (data: any) => {
            // Ausbildung wird als relevante Ausbildung gesetzt
            if (data && Array.isArray(data)) {
              setRelevantEducations(data);
            } else if (data && typeof data === 'object') {
              // Falls es ein einzelnes Objekt ist, in Array umwandeln
              setRelevantEducations([data]);
            } else {
              console.warn('Ausbildungs-Daten sind nicht im erwarteten Format:', data);
              setRelevantEducations([]);
            }
          },
          getter: () => relevantEducations
        },
        { 
          name: 'IT-Skills', 
          type: 'itSkills',
          setter: (data: any) => {
            // IT-Skills werden als relevante IT-Skills gesetzt
            if (data && Array.isArray(data)) {
              setRelevantItSkills(data);
            } else if (data && typeof data === 'object') {
              // Falls es ein einzelnes Objekt ist, in Array umwandeln
              setRelevantItSkills([data]);
            } else {
              console.warn('IT-Skills-Daten sind nicht im erwarteten Format:', data);
              setRelevantItSkills([]);
            }
          },
          getter: () => relevantItSkills
        },
        { 
          name: 'Sprachen', 
          type: 'languages',
          setter: (data: any) => {
            // Sprachen werden als relevante Sprachen gesetzt
            if (data && Array.isArray(data)) {
              setRelevantLanguages(data);
            } else if (data && typeof data === 'object') {
              // Falls es ein einzelnes Objekt ist, in Array umwandeln
              setRelevantLanguages([data]);
            } else {
              console.warn('Sprachen-Daten sind nicht im erwarteten Format:', data);
              setRelevantLanguages([]);
            }
          },
          getter: () => relevantLanguages
        },
        { 
          name: 'Kernkompetenzen',
          type: 'coreCompetencies',
          setter: (data: any) => {
            // Kernkompetenzen werden als relevante Kernkompetenzen gesetzt
            if (data && Array.isArray(data)) {
              setRelevantCoreCompetencies(data);
            } else if (data && typeof data === 'object') {
              // Falls es ein einzelnes Objekt ist, in Array umwandeln
              setRelevantCoreCompetencies([data]);
            } else {
              console.warn('Kernkompetenzen-Daten sind nicht im erwarteten Format:', data);
              setRelevantCoreCompetencies([]);
            }
          },
          getter: () => relevantCoreCompetencies
        },
        { 
          name: 'Branchen', 
          type: 'industry',
          setter: (data: any) => {
            // Branchen werden als relevante Branchen gesetzt
            if (data && Array.isArray(data)) {
              setRelevantIndustries(data);
            } else if (data && typeof data === 'object') {
              // Falls es ein einzelnes Objekt ist, in Array umwandeln
              setRelevantIndustries([data]);
            } else {
              console.warn('Branchen-Daten sind nicht im erwarteten Format:', data);
              setRelevantIndustries([]);
            }
          },
          getter: () => relevantIndustries
        },
        { 
          name: 'Hobbys', 
          type: 'hobbies',
          setter: (data: any) => {
            // Hobbys werden als relevante Hobbys gesetzt
            if (data && Array.isArray(data)) {
              setRelevantHobbies(data);
            } else if (data && typeof data === 'object') {
              // Falls es ein einzelnes Objekt ist, in Array umwandeln
              setRelevantHobbies([data]);
            } else {
              console.warn('Hobbys-Daten sind nicht im erwarteten Format:', data);
              setRelevantHobbies([]);
            }
          },
          getter: () => relevantHobbies
        },
        { 
          name: 'Zertifikate', 
          type: 'certifications',
          setter: (data: any) => {
            // Zertifikate werden als relevante Zertifikate gesetzt
            if (data && Array.isArray(data)) {
              setRelevantCertifications(data);
            }
          },
          getter: () => relevantCertifications
        },
        { 
          name: 'Weitere Angaben', 
          type: 'additionalInfo',
          setter: (data: any) => {
            // Weitere Angaben werden als relevante weitere Angaben gesetzt
            if (data && Array.isArray(data)) {
              setRelevantAdditionalInfo(data);
            } else if (data && typeof data === 'object') {
              // Falls es ein einzelnes Objekt ist, in Array umwandeln
              setRelevantAdditionalInfo([data]);
            } else {
              console.warn('Weitere Angaben-Daten sind nicht im erwarteten Format:', data);
              setRelevantAdditionalInfo([]);
            }
          },
          getter: () => relevantAdditionalInfo
        }
      ];

      console.log('🚀 Starte parallele CV-Optimierung...');
      console.log(`📊 ${optimizationTasks.length} Optimierungsaufgaben werden parallel ausgeführt`);

      // Initialisiere Progress-Tracking
      const initialProgress: {[key: string]: 'pending' | 'running' | 'completed' | 'failed'} = {};
      optimizationTasks.forEach(task => {
        initialProgress[task.name] = 'pending';
      });
      setOptimizationProgress(initialProgress);

      // Starte alle Optimierungen parallel
      const optimizationPromises = optimizationTasks.map(async (task, index) => {
        try {
          console.log(`🔄 Starte ${task.name}-Optimierung (${index + 1}/${optimizationTasks.length})`);
          
          // Setze Status auf "running"
          setOptimizationProgress(prev => ({
            ...prev,
            [task.name]: 'running'
          }));
          
          const requestBody = {
            cvData: cvData,
            jobDescription: jobDescription,
            optimizeType: task.type,
            targetLanguage: targetLanguage,
            // Parameter aus Firebase für alle Optimierungen
            promptText: '', // Wird vom Backend aus Firebase geladen
            promptVersion: '', // Wird vom Backend aus Firebase geladen
            temperature: '', // Wird vom Backend aus Firebase geladen
            maxTokens: '' // Wird vom Backend aus Firebase geladen
          };

          const response = await fetch(config.backend.optimizeCvJsonUrl, {
            method: 'POST',
            headers: { 
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${idToken}`
            },
            body: JSON.stringify(requestBody),
          });

          if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
          }

          const data = await response.json();
          console.log(`✅ ${task.name}-Optimierung erfolgreich abgeschlossen`);
          
          // Setze Status auf "completed"
          setOptimizationProgress(prev => ({
            ...prev,
            [task.name]: 'completed'
          }));
          
          // Setze die optimierten Daten
          if (task.setter) {
            // Extrahiere die richtigen Daten basierend auf dem Optimierungstyp
            let optimizedData = null;
            
            // Versuche zuerst optimizedData, dann die spezifischen Felder
            if (data.optimizedData && Array.isArray(data.optimizedData)) {
              optimizedData = data.optimizedData;
            } else {
              // Fallback: Extrahiere aus den spezifischen Feldern der Backend-Response
              switch (task.type) {
                case 'shortProfile':
                  optimizedData = data.optimizedShortProfile;
                  break;
                case 'workExperience':
                  optimizedData = data.optimizedWorkExperiences;
                  break;
                case 'education':
                  optimizedData = data.relevantEducations;
                  break;
                case 'itSkills':
                  optimizedData = data.relevantItSkills;
                  break;
                case 'languages':
                  optimizedData = data.relevantLanguages;
                  break;
                case 'coreCompetencies':
                  optimizedData = data.relevantCoreCompetencies;
                  break;
                case 'industry':
                  optimizedData = data.relevantIndustries;
                  break;
                case 'hobbies':
                  optimizedData = data.relevantHobbies;
                  break;
                case 'certifications':
                  optimizedData = data.relevantCertifications;
                  break;
                case 'additionalInfo':
                  optimizedData = data.relevantAdditionalInfo;
                  break;
                default:
                  // Als letzter Fallback: das gesamte data-Objekt
                  optimizedData = data;
              }
            }
            
            // Backend Response für ${task.name} verarbeitet
            
            task.setter(optimizedData);
          }

          return { 
            success: true, 
            task: task.name, 
            data: data,
            index: index 
          };
        } catch (error) {
          console.error(`❌ ${task.name}-Optimierung fehlgeschlagen:`, error);
          
          // Setze Status auf "failed"
          setOptimizationProgress(prev => ({
            ...prev,
            [task.name]: 'failed'
          }));
          
          return { 
            success: false, 
            task: task.name, 
            error: error instanceof Error ? error.message : 'Unbekannter Fehler',
            index: index 
          };
        }
      });

      // Warte auf alle Optimierungen
      console.log('⏳ Warte auf alle parallelen Optimierungen...');
      const results = await Promise.allSettled(optimizationPromises);

      // Analysiere Ergebnisse
      const successful = results.filter(result => 
        result.status === 'fulfilled' && result.value.success
      ).length;
      
      const failed = results.filter(result => 
        result.status === 'rejected' || 
        (result.status === 'fulfilled' && !result.value.success)
      ).length;

      console.log(`📈 Optimierung abgeschlossen: ${successful} erfolgreich, ${failed} fehlgeschlagen`);

      // Zeige Fehler an, falls welche aufgetreten sind
      if (failed > 0) {
        const failedTasks = results
          .filter(result => result.status === 'rejected' || 
            (result.status === 'fulfilled' && !result.value.success))
          .map(result => {
            if (result.status === 'fulfilled') {
              return result.value.task;
            }
            return 'Unbekannte Aufgabe';
          });
        
        console.warn(`⚠️ Folgende Optimierungen sind fehlgeschlagen: ${failedTasks.join(', ')}`);
        setError(`Optimierung teilweise erfolgreich: ${successful}/${optimizationTasks.length} Bereiche optimiert. Fehlgeschlagen: ${failedTasks.join(', ')}`);
      } else {
        console.log('🎉 Alle Optimierungen erfolgreich abgeschlossen!');
      }

      // Erstelle einen kombinierten CV-Text aus allen optimierten Daten
      let combinedCvText = '';
      
      // Füge optimiertes Kurzprofil hinzu
      if (optimizedShortProfile) {
        combinedCvText += `Profil:\n${optimizedShortProfile}\n\n`;
      }

      // Füge optimierte Arbeitserfahrungen hinzu
      if (optimizedWorkExperiences && optimizedWorkExperiences.length > 0) {
        combinedCvText += `Berufserfahrung:\n`;
        optimizedWorkExperiences.forEach((exp: any) => {
          combinedCvText += `${exp.position} bei ${exp.company} (${exp.startDate} - ${exp.endDate})\n`;
          combinedCvText += `${exp.description}\n\n`;
        });
      }

      // Füge andere optimierte Bereiche hinzu
      if (relevantEducations && relevantEducations.length > 0) {
        combinedCvText += `Ausbildung:\n`;
        relevantEducations.forEach((edu: any) => {
          combinedCvText += `${edu.degree} an ${edu.institution}\n`;
        });
        combinedCvText += '\n';
      }

      if (relevantItSkills && relevantItSkills.length > 0) {
        combinedCvText += `IT-Skills:\n`;
        relevantItSkills.forEach((skill: any) => {
          combinedCvText += `${skill.skill} (${skill.level})\n`;
        });
        combinedCvText += '\n';
      }

      if (relevantLanguages && relevantLanguages.length > 0) {
        combinedCvText += `Sprachen:\n`;
        relevantLanguages.forEach((lang: any) => {
          combinedCvText += `${lang.language} (${lang.level})\n`;
        });
        combinedCvText += '\n';
      }

      if (relevantCoreCompetencies && relevantCoreCompetencies.length > 0) {
        combinedCvText += `Kernkompetenzen:\n`;
        relevantCoreCompetencies.forEach((comp: any) => {
          combinedCvText += `${comp.competency}\n`;
        });
        combinedCvText += '\n';
      }

      if (relevantIndustries && relevantIndustries.length > 0) {
        combinedCvText += `Branchenerfahrung:\n`;
        relevantIndustries.forEach((industry: any) => {
          combinedCvText += `${industry.industry} (${industry.years} Jahre)\n`;
        });
        combinedCvText += '\n';
      }

      if (relevantHobbies && relevantHobbies.length > 0) {
        combinedCvText += `Hobbys:\n`;
        relevantHobbies.forEach((hobby: any) => {
          combinedCvText += `${hobby.hobby}: ${hobby.description}\n`;
        });
        combinedCvText += '\n';
      }

      if (relevantCertifications && relevantCertifications.length > 0) {
        combinedCvText += `Zertifikate:\n`;
        relevantCertifications.forEach((cert: any) => {
          combinedCvText += `${cert.certification} - ${cert.issuer}\n`;
        });
      }

      // Setze den kombinierten CV-Text
      setImprovedCvText(combinedCvText);

      // Öffne automatisch die CV Preview, wenn mindestens eine Optimierung erfolgreich war
      if (successful > 0) {
        // Verstecke "CV optimieren" Button nach erfolgreicher Optimierung
        setShowCvOptimierenButton(false);
        
        // Öffne die Preview direkt - keine Zeitverzögerung nötig
        console.log('🎯 Öffne CV Preview nach Optimierung...');
        await handleOpenCvTemplate();
        console.log('🎯 Template Preview automatisch geöffnet - optimierte Daten verfügbar');
      }

    } catch (err: any) {
      console.error('❌ Fehler bei paralleler CV-Optimierung:', err);
      setError(t('error.optimize.cv.unknown') + (err.message || ''));
    } finally {
      setOptimizing(false);
    }
  };

  const handleOptimizeImage = async () => {
    if (!profileImage) {
      setError('Bitte laden Sie zuerst ein Profilbild hoch.');
      return;
    }
    setOptimizingImage(true);
    setError(null);
    
    // Benachrichtigung anzeigen
    setError('🤖 DALL-E optimiert Ihr Foto... Bitte warten Sie.');
    
    // Bild komprimieren, um die Größe zu reduzieren
    const compressImage = (base64String: string, maxWidth = 1024, quality = 0.6): Promise<string> => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        
        img.onload = () => {
          try {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            
            if (!ctx) {
              reject(new Error('Canvas 2D Context nicht verfügbar'));
              return;
            }
            
            // Berechne neue Dimensionen
            const ratio = Math.min(maxWidth / img.width, maxWidth / img.height);
            const newWidth = Math.round(img.width * ratio);
            const newHeight = Math.round(img.height * ratio);
            
            canvas.width = newWidth;
            canvas.height = newHeight;
            
            // Zeichne komprimiertes Bild
            ctx.drawImage(img, 0, 0, newWidth, newHeight);
            
            // Konvertiere zu Base64 mit reduzierter Qualität
            const compressedBase64 = canvas.toDataURL('image/jpeg', quality);
            resolve(compressedBase64);
          } catch (error) {
            reject(new Error('Fehler bei der Bildkomprimierung: ' + error));
          }
        };
        
        img.onerror = () => {
          reject(new Error('Fehler beim Laden des Bildes'));
        };
        
        // Entferne data:image/...;base64, Prefix falls vorhanden
        const cleanBase64 = base64String.replace(/^data:image\/[a-z]+;base64,/, '');
        img.src = `data:image/jpeg;base64,${cleanBase64}`;
      });
    };
    
    // Verwende das ursprüngliche Bild ohne Komprimierung
    const compressedImage = profileImage;
    console.log('📸 Verwende ursprüngliches Bild ohne Komprimierung:', profileImage.length, 'Bytes');
    
    try {
      console.log('🤖 Sende DALL-E Optimierung Request...');
      
      if (!user) {
        throw new Error('Benutzer nicht angemeldet');
      }
      
      const idToken = await user.getIdToken();
      const response = await fetch(`${config.backend.baseUrl}/api/optimize-photo-dalle`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({ 
          imageData: compressedImage,
          prompt: 'Replace only the background with a professional office environment. Keep the person completely unchanged - preserve exact facial features, skin tone, clothing, and proportions. Do not alter the person or composition. Only change the background to a blurred modern office scene.'
        }),
      });
      
      console.log('📡 Response Status:', response.status);
      console.log('📡 Response OK:', response.ok);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ Response Error:', errorText);
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }
      
      const data = await response.json();
      console.log('🤖 DALL-E Response:', data);
      
      if (data.success && data.optimizedImage) {
        console.log('✅ DALL-E Optimierung erfolgreich');
        
        // Erstelle Array mit Original, Maske und optimiertem Bild für Auswahl
        const imageOptions = [
          {
            id: 1,
            image: profileImage,
            name: 'Ursprüngliches Bild',
            description: 'Ihr ursprünglich hochgeladenes Foto',
            isOriginal: true,
            isOptimized: false
          },
          {
            id: 2,
            image: data.maskImage,
            name: 'Erkannte Person (Maske)',
            description: 'KI-basierte Personenerkennung mit grünem Hintergrund',
            isOriginal: false,
            isOptimized: false,
            isMask: true
          },
          {
            id: 3,
            image: data.optimizedImage,
            name: 'Optimiertes Bild',
            description: 'Mit DALL-E optimiertes Foto',
            isOriginal: false,
            isOptimized: true
          }
        ];
        
        setOptimizedImages(imageOptions);
        setShowImageOptimizer(true);
        setError('✅ Foto-Optimierung abgeschlossen! Wählen Sie Ihr bevorzugtes Bild aus.');
        
        // Nach 5 Sekunden die Erfolgsmeldung löschen
        setTimeout(() => setError(null), 5000);
      } else {
        console.error('❌ Keine optimierten Bilddaten in Response:', data);
        throw new Error('Kein optimiertes Bild von DALL-E erhalten');
      }
    } catch (err: any) {
      console.error('❌ DALL-E Optimierung Fehler:', err);
      setError('Fehler bei der DALL-E Optimierung: ' + (err.message || ''));
    } finally {
      setOptimizingImage(false);
    }
  };

  const handleSelectOptimizedImage = (selectedImage: string) => {
    setProfileImage(selectedImage);
    setShowImageOptimizer(false);
    setError('✅ Bild ausgewählt!');
    // Nach 3 Sekunden die Erfolgsmeldung löschen
    setTimeout(() => setError(null), 3000);
  };

  const handleCreateMotivation = async () => {
    // Wenn bereits ein Motivationsschreiben existiert: erst Warnungs-Pop-up zeigen (wenn Flag false), dann öffnen
    if (motivationLetter) {
      if (!dontShowMotivationWarning) {
        setShowMotivationWarningDialog(true);
      } else {
        handleOpenMotivationDialog();
      }
      return;
    }

    // Starte Erstellung sofort; Pop-up erst nach Warte-Animation
    createMotivationLetter();
  };

  // Funktion zum tatsächlichen Erstellen des Motivationsschreibens
  const createMotivationLetter = async () => {
    setError(null);
    setMotivationLetter(null);
    setCreatingMotivation(true);
    setHideMatchResults(true); // Verstecke Match-Ergebnisse
    setInfoMessage(getTranslatedInfoMessage('creating_motivation'));
    resetMatchData(); // Lösche alle Match-Daten
    setRelevantItSkills([]); // Lösche relevante IT-Kenntnisse
    
    if (!jobDescription.trim()) {
      setError('Stellenbeschreibung ist erforderlich.');
      setCreatingMotivation(false);
      return;
    }

    // Prüfe ob User-Daten vorhanden sind
    if (!user) {
      setError('Benutzer nicht angemeldet.');
      setCreatingMotivation(false);
      return;
    }

    try {
      // Lade aktuelle User-Daten aus verschlüsselten Backend-Endpoints
      const idToken = await user.getIdToken();
      let userData: any = {};
      
      try {
        const response = await fetch(`${config.backend.userDataUrl}/${user.uid}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
          }
        });

        if (response.ok) {
          const result = await response.json();
          userData = result.data || {};
        }
        // Wenn keine CV-Daten gefunden werden, verwende leere Standarddaten
      } catch (fetchError) {
        console.log('Keine CV-Daten gefunden, verwende Standarddaten für Motivationsschreiben');
        userData = {};
      }
      
      // Erstelle strukturierte CV-Daten für das Motivationsschreiben - basierend auf optimierten Daten
      const cvData = {
        personalInfo: {
          fullName: optimizedFullName || userData?.fullName || '',
          shortProfile: optimizedShortProfile || '',
          nationality: userData?.nationality || '',
          residencePermit: userData?.residencePermit || ''
        },
        workExperience: optimizedWorkExperiences || [],
        education: userData?.educations || [],
        certifications: userData?.certifications || [],
        languages: userData?.languagesExtracted || [],
        itSkills: userData?.itSkillsExtracted || [],
        hobbiesExtracted: userData?.hobbiesExtracted || [],
        additionalInfoExtracted: userData?.additionalInfoExtracted || []
      };

      // Verwende bereits erstellten ID Token
      const motivationResponse = await fetch(config.backend.optimizeCvJsonUrl, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({
          cvData: cvData,
          jobDescription: jobDescription,
          optimizeType: 'motivation', // Wichtig: Sagt dem Backend, dass es ein Motivationsschreiben erstellen soll
          generateSeparateFields: true, // Neue Option: Generiere separate Felder für Titel, Anrede und Text
          targetLanguage: targetLanguage
        }),
      });
      if (!motivationResponse.ok) throw new Error(t('error.motivation.letter'));
      const data = await motivationResponse.json();
      
      // Extrahiere die vier separaten AI-generierten Felder (inkl. Empfänger)
      if (data.motivationTitle || data.motivationGreeting || data.motivationText || data.recipientInfo) {
        // Setze die AI-generierten Felder
        if (data.recipientInfo) {
          setMotivationRecipientInfo(data.recipientInfo);
        }
        if (data.motivationTitle) {
          setMotivationTitle(data.motivationTitle);
        }
        if (data.motivationGreeting) {
          setMotivationGreeting(data.motivationGreeting);
        }
        if (data.motivationText) {
          setMotivationLetter(data.motivationText);
        }
        // Dialog wird nach Warte-Animation geöffnet (in finally-Block)
        console.log('🎯 Motivationsschreiben erstellt (separate Felder)');
      } else if (data.motivationLetter) {
        // Fallback für alte API-Format
        const motivationText = typeof data.motivationLetter === 'string' ? data.motivationLetter : '';
        setMotivationLetter(motivationText);
        // Dialog wird nach Warte-Animation geöffnet (in finally-Block)
        console.log('🎯 Motivationsschreiben erstellt (Fallback)');
      }
    } catch (err: any) {
      setError(t('error.motivation.letter.unknown') + (err.message || ''));
    } finally {
      setCreatingMotivation(false);
      setInfoMessage(getTranslatedInfoMessage('motivation_created'));
      
      // Zeige Pop-up nach Warte-Animation, wenn Flag noch false ist
      if (!dontShowMotivationWarning) {
        setShowMotivationWarningDialog(true);
      } else {
        // Öffne direkt, wenn Warnung deaktiviert
        if (motivationLetter) {
          handleOpenMotivationDialog();
        }
      }
    }
  };

  // Handler für Color-Picker-Modal
  const handleColorPickerClick = (type: 'header' | 'column' | 'name' | 'leftTitle' | 'leftText' | 'rightTitle' | 'rightText') => {
    setCurrentColorPicker(type);
    if (type === 'header') {
      setTempColor(topBoxColor);
      setTempAlpha(topBoxAlpha);
    } else if (type === 'column') {
      setTempColor(leftColumnColor);
      setTempAlpha(leftColumnAlpha);
    } else if (type === 'name') {
      setTempColor(nameTextColor);
      setTempAlpha(1); // Textfarben haben keine Transparenz
    } else if (type === 'leftTitle') {
      setTempColor(leftColumnTitleColor);
      setTempAlpha(1);
    } else if (type === 'leftText') {
      setTempColor(leftColumnTextColor);
      setTempAlpha(1);
    } else if (type === 'rightTitle') {
      setTempColor(rightColumnTitleColor);
      setTempAlpha(1);
    } else if (type === 'rightText') {
      setTempColor(rightColumnTextColor);
      setTempAlpha(1);
    }
    setOpenColorPickerModal(true);
  };

  const handleColorChange = (color: string, alpha: number) => {
    setTempColor(color);
    setTempAlpha(alpha);
  };

  const handleApplyColor = async () => {
    if (currentColorPicker === 'header') {
      setTopBoxColor(tempColor);
      setTopBoxAlpha(tempAlpha);
    } else if (currentColorPicker === 'column') {
      setLeftColumnColor(tempColor);
      setLeftColumnAlpha(tempAlpha);
    } else if (currentColorPicker === 'name') {
      setNameTextColor(tempColor);
    } else if (currentColorPicker === 'leftTitle') {
      setLeftColumnTitleColor(tempColor);
    } else if (currentColorPicker === 'leftText') {
      setLeftColumnTextColor(tempColor);
    } else if (currentColorPicker === 'rightTitle') {
      setRightColumnTitleColor(tempColor);
    } else if (currentColorPicker === 'rightText') {
      setRightColumnTextColor(tempColor);
    }
    setOpenColorPickerModal(false);
    
    // Speichere CV-Settings in Firebase
    if (user?.uid) {
      try {
        const currentSettings = getCurrentCvSettings();
        await saveCvSettings(user.uid, currentSettings);
        console.log('✅ CV-Settings erfolgreich gespeichert (Farbe und Transparenz)');
      } catch (error) {
        console.error('❌ Fehler beim Speichern der CV-Settings:', error);
      }
    }
  };

  const handleCancelColor = () => {
    setOpenColorPickerModal(false);
  };

  // Funktion zum Erstellen einer PDF mit jsPDF + html2canvas
  const handleDownloadCvPdf = async () => {
    try {
      console.log('🖨️ Starte PDF-Generierung mit ATS-Kompatibilität');
      
      // PDF-Export ändert keine CV-Daten, daher Checkbox-Status nicht ändern
      
      // Finde das CV-Template
      const cvTemplate = document.querySelector('.cv-template') || document.querySelector('[data-testid="cv-template"]');
      if (!cvTemplate) {
        throw new Error('CV-Template nicht gefunden');
      }

      // Zeige Ladeindikator
      setDownloadingPdf(true);
      
      // 1. VISUELLES DESIGN: Erstelle ein Canvas vom gesamten CV
      const canvas = await html2canvas(cvTemplate as HTMLElement, {
        allowTaint: true,
        useCORS: true,
        scrollX: 0,
        scrollY: 0,
        width: cvTemplate.scrollWidth,
        height: cvTemplate.scrollHeight,
        scale: 2.5, // Höhere Auflösung für bessere Qualität
        backgroundColor: '#ffffff',
        logging: false,
        // Spezielle Einstellungen für Profilbilder
        imageTimeout: 15000, // Längere Timeout für Bilder
        removeContainer: false, // Behalte Container für bessere Kontrolle
        foreignObjectRendering: false, // Deaktiviert Foreign Object Rendering für bessere Kompatibilität
        // CSS-spezifische Einstellungen für bessere Bildqualität
        onclone: (clonedDoc) => {
          // Erzwinge quadratischen Slot mit Top-Crop (wie im Template)
          const images = clonedDoc.querySelectorAll('img[alt="Profilbild"]');
          images.forEach((img: any) => {
            const container = img.parentElement;
            if (!container) return;

            // Ermittele Slot-Größe (breite = slotBreite, höhe = slotBreite -> Quadrat)
            const originalElement = document.querySelector('.cv-template img[alt="Profilbild"]');
            const originalContainer = originalElement?.parentElement as HTMLElement | null;
            const slotWidth = (originalContainer?.offsetWidth || container.offsetWidth || 200);

            // Container als quadratisches Cropping-Fenster konfigurieren
            container.style.width = `${slotWidth}px`;
            container.style.height = `${slotWidth}px`;
            container.style.aspectRatio = 'auto';
            container.style.overflow = 'hidden';
            container.style.position = 'relative';
            container.style.display = 'block';

            // Bild so platzieren, dass unten abgeschnitten werden darf (top-aligned)
            img.style.width = '100%';
            img.style.height = 'auto'; // Höhe ergibt sich aus Seitenverhältnis
            img.style.objectFit = 'cover';
            img.style.objectPosition = 'center top'; // oben ausrichten, unten darf abgeschnitten werden
            img.style.position = 'absolute';
            img.style.top = '0';
            img.style.left = '0';
          });
        }
      });

      console.log('✅ Canvas erstellt:', {
        width: canvas.width,
        height: canvas.height
      });

      // 2. PDF ERSTELLEN: Konvertiere zu PDF mit optimierter Kompression
      const imgData = canvas.toDataURL('image/jpeg', 0.85); // 85% Qualität - guter Kompromiss
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
        compress: true // PDF-Kompression für kleinere Dateigröße
      });
      
      const imgWidth = 210; // A4 Breite in mm
      const pageHeight = 297; // A4 Höhe in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;

      let position = 0;
      let pageCount = 1;

      // 2a. PROFILBILD-LAYER FÜR ATS (ZUERST - HINTER DEM CANVAS)
      if (profileImage && (showPhotoInCv || showProfileImageInCv)) {
        try {
          console.log('📸 Füge Profilbild als separaten Layer hinzu (hinter Canvas)...');
          
          // Berechne Profilbild-Position und Größe basierend auf CV-Template-Einstellungen
          // Standard-Position im Template ist links oben (kann je nach Template variieren)
          const profileImageXPos = 15; // mm von links
          const profileImageYPos = 20; // mm von oben
          
          // Bildgröße basierend auf profileImageSize-Einstellung (Quadratischer Slot)
          let imageWidth = 35; // mm (Standard für 'M')
          if (profileImageSize === 'S') {
            imageWidth = 25;
          } else if (profileImageSize === 'L') {
            imageWidth = 45;
          }
          
          // Wende profileImageWidth-Prozentsatz an
          imageWidth = imageWidth * (profileImageWidth / 100);
          
          // Lade das Bild asynchron um die Originalmaße zu erhalten
          await new Promise<void>((resolve) => {
            const img = new Image();
            img.onload = () => {
              // Cropping wie CSS object-fit: cover; object-position: center top im quadratischen Slot
              const containerSize = imageWidth; // Quadrat in mm

              // Offscreen-Canvas in Pixeln vorbereiten (Qualität erhöhen)
              const scalePx = 4; // Render-Faktor
              const targetPx = containerSize * (96 / 25.4) * scalePx; // mm -> px (@96dpi) * scale
              const off = document.createElement('canvas');
              off.width = Math.round(targetPx);
              off.height = Math.round(targetPx);
              const ctx = off.getContext('2d');
              if (!ctx) { resolve(); return; }

              // Quelle berechnen (object-fit: cover mit top alignment)
              const imgAR = img.naturalWidth > 0 ? img.naturalWidth / img.naturalHeight : 1;
              const boxAR = 1; // Quadrat
              let srcW: number, srcH: number, srcX: number, srcY: number;
              if (imgAR > boxAR) {
                // Bild breiter als Box -> beschneide links/rechts
                srcH = img.naturalHeight;
                srcW = srcH * boxAR;
                srcX = Math.floor((img.naturalWidth - srcW) / 2);
                srcY = 0; // top aligned
              } else {
                // Bild höher als Box -> beschneide oben/unten (unten stärker, top aligned)
                srcW = img.naturalWidth;
                srcH = srcW / boxAR;
                srcX = 0;
                srcY = 0; // top aligned (unten abgeschnitten)
              }

              ctx.imageSmoothingQuality = 'high';
              ctx.drawImage(img, srcX, srcY, srcW, srcH, 0, 0, off.width, off.height);

              // Füge das gecroppte Quadrat als Bild ein
              const dataUrl = off.toDataURL('image/jpeg', 0.92);
              pdf.addImage(dataUrl, 'JPEG', profileImageXPos, profileImageYPos, containerSize, containerSize, undefined, 'FAST');
              
              console.log(`✅ Profilbild als separater Layer hinzugefügt (Quadrat: ${containerSize}x${containerSize}mm, via offscreen crop)`);
              resolve();
            };
            img.onerror = () => {
              console.error('⚠️ Fehler beim Laden des Profilbilds');
              resolve(); // Fahre trotzdem fort
            };
            img.src = profileImage;
          });
        } catch (imageError) {
          console.error('⚠️ Fehler beim Hinzufügen des Profilbild-Layers:', imageError);
          // Fehler beim Profilbild sollte die PDF-Generierung nicht stoppen
        }
      }

      // Füge erste Seite mit Canvas-Bild hinzu (ÜBER dem Profilbild)
      pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      // Füge weitere Seiten hinzu falls nötig
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
        pageCount++;
      }

      console.log(`✅ PDF-Bild erstellt mit ${pageCount} Seiten`);

      // 3. UNSICHTBARER TEXT-LAYER FÜR ATS-KOMPATIBILITÄT
      // Gehe zurück zur ersten Seite
      pdf.setPage(1);
      
      // Text-Einstellungen: Unsichtbar für Menschen, aber lesbar für ATS
      // Verwende normale Schriftgröße für korrekte Umlaute-Codierung
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(8); // Größer für korrekte Umlaute-Codierung (wird außerhalb des sichtbaren Bereichs platziert)
      pdf.setTextColor(255, 255, 255); // Weiß = unsichtbar auf weißem Hintergrund
      
      // CV-Text-Daten für ATS extrahieren und einfügen
      console.log('📝 Füge unsichtbaren Text-Layer für ATS hinzu...');
      
      const atsTextData: string[] = [];
      
      // Persönliche Daten (EXAKT wie in getCvDataForTemplate - mit optimierten Versionen)
      const nameToUse = optimizedFullName || fullName;
      const emailToUse = optimizedEmail || email;
      const phoneToUse = optimizedPhoneNumber || phoneNumber;
      const addressToUse = optimizedAddress || address;
      const postalCodeToUse = optimizedPostalCode || postalCode;
      const cityToUse = optimizedCity || city;
      
      if (nameToUse) atsTextData.push(`NAME: ${nameToUse}`);
      if (company) atsTextData.push(`FIRMA: ${company}`);
      if (addressToUse) atsTextData.push(`ADRESSE: ${addressToUse}`);
      if (postalCodeToUse || cityToUse) {
        const location = [postalCodeToUse, cityToUse].filter(Boolean).join(' ');
        if (location) atsTextData.push(`ORT: ${location}`);
      }
      if (country) atsTextData.push(`LAND: ${country}`);
      if (emailToUse) atsTextData.push(`EMAIL: ${emailToUse}`);
      if (phoneToUse) atsTextData.push(`TELEFON: ${phoneToUse}`);
      if (birthYear) atsTextData.push(`GEBURTSJAHR: ${birthYear}`);
      if (nationality) atsTextData.push(`NATIONALITÄT: ${nationality}`);
      if (residencePermit) atsTextData.push(`AUFENTHALTSBEWILLIGUNG: ${residencePermit}`);
      if (civilStatus) atsTextData.push(`FAMILIENSTAND: ${civilStatus}`);
      if (drivingLicense) atsTextData.push(`FÜHRERSCHEIN: ${drivingLicense}`);
      if (availableFrom) atsTextData.push(`VERFÜGBAR AB: ${availableFrom}`);
      atsTextData.push('');
      
      // Kurzprofil (EXAKT wie in getCvDataForTemplate - nur optimizedShortProfile)
      if (optimizedShortProfile && optimizedShortProfile.trim() && showProfileInCv) {
        atsTextData.push('KURZPROFIL:');
        // Teile lange Texte in mehrere Zeilen auf (max 100 Zeichen pro Zeile für bessere ATS-Lesbarkeit)
        const profileLines = optimizedShortProfile.match(/.{1,100}(\s|$)/g) || [optimizedShortProfile];
        profileLines.forEach(line => atsTextData.push(line.trim()));
        atsTextData.push('');
      }
      
      // Berufserfahrung - Relevante (EXAKT wie im CV-Template - mit relevant-Filter!)
      // Das CV-Template filtert optimizedWorkExperiences nach relevant === true
      const relevantWorkExp = optimizedWorkExperiences ? 
        optimizedWorkExperiences.filter((work: any) => work.relevant === true || work.relevant === 'true') : 
        (workExperiences || []);
      
      if (relevantWorkExp.length > 0) {
        atsTextData.push('BERUFLICHER WERDEGANG:');
        relevantWorkExp.forEach(exp => {
          atsTextData.push(`${exp.position} bei ${exp.company}`);
          atsTextData.push(`${exp.startDate} - ${exp.endDate}`);
          if (exp.description) {
            // Teile lange Beschreibungen auf
            const descLines = exp.description.match(/.{1,100}(\s|$)/g) || [exp.description];
            descLines.forEach(line => atsTextData.push(line.trim()));
          }
          atsTextData.push('');
        });
      }
      
      // Weitere Berufserfahrungen - Nicht-relevante (wenn im CV-Template angezeigt)
      const nonRelevantWorkExp = optimizedWorkExperiences ? 
        optimizedWorkExperiences.filter((work: any) => work.relevant !== true && work.relevant !== 'true') : 
        [];
      
      if (nonRelevantWorkExp.length > 0 && showAdditionalWorkExperienceInCv) {
        atsTextData.push('WEITERE BERUFSERFAHRUNGEN:');
        nonRelevantWorkExp.forEach(exp => {
          // Bei weiteren Berufserfahrungen werden oft nur Firma, Position und Zeitraum angezeigt
          atsTextData.push(`${exp.position} bei ${exp.company} (${exp.startDate} - ${exp.endDate})`);
          atsTextData.push('');
        });
      }
      
      // Ausbildung (EXAKT wie in getCvDataForTemplate - nur relevantEducations)
      if (relevantEducations && relevantEducations.length > 0) {
        atsTextData.push('AUSBILDUNG:');
        relevantEducations.forEach(edu => {
          atsTextData.push(`${edu.degree} - ${edu.institution}`);
          atsTextData.push(`${edu.startDate} - ${edu.endDate}`);
          atsTextData.push('');
        });
      }
      
      // Kernkompetenzen (EXAKT wie in getCvDataForTemplate - nur relevantCoreCompetencies)
      if (relevantCoreCompetencies && relevantCoreCompetencies.length > 0 && showCoreCompetenciesInCv) {
        atsTextData.push('KERNKOMPETENZEN:');
        relevantCoreCompetencies.forEach(c => atsTextData.push(c.competency));
        atsTextData.push('');
      }
      
      // IT-Skills (EXAKT wie in getCvDataForTemplate - nur relevantItSkills)
      if (relevantItSkills && relevantItSkills.length > 0 && showItSkillsInCv) {
        atsTextData.push('IT-SKILLS:');
        relevantItSkills.forEach(s => atsTextData.push(`${s.skill}: ${s.level}`));
        atsTextData.push('');
      }
      
      // Sprachen (EXAKT wie in getCvDataForTemplate - nur relevantLanguages)
      if (relevantLanguages && relevantLanguages.length > 0 && showLanguagesInCv) {
        atsTextData.push('SPRACHEN:');
        relevantLanguages.forEach(l => atsTextData.push(`${l.language}: ${l.level}`));
        atsTextData.push('');
      }
      
      // Branchen (EXAKT wie in getCvDataForTemplate - nur relevantIndustries)
      if (relevantIndustries && relevantIndustries.length > 0 && showIndustriesInCv) {
        atsTextData.push('BRANCHEN:');
        relevantIndustries.forEach(i => atsTextData.push(`${i.industry} (${i.years} Jahre)`));
        atsTextData.push('');
      }
      
      // Zertifizierungen (EXAKT wie in getCvDataForTemplate - nur relevantCertifications)
      if (relevantCertifications && relevantCertifications.length > 0 && showCertificationsInCv) {
        atsTextData.push('ZERTIFIZIERUNGEN:');
        relevantCertifications.forEach(cert => {
          atsTextData.push(`${cert.name} - ${cert.issuer} (${cert.date})`);
        });
        atsTextData.push('');
      }
      
      // Hobbies (EXAKT wie in getCvDataForTemplate - nur relevantHobbies)
      if (relevantHobbies && relevantHobbies.length > 0 && showHobbiesInCv) {
        atsTextData.push('HOBBIES:');
        relevantHobbies.forEach(h => {
          atsTextData.push(`${h.hobby}${h.description ? ': ' + h.description : ''}`);
        });
        atsTextData.push('');
      }
      
      // Weitere Angaben (EXAKT wie in getCvDataForTemplate - nur relevantAdditionalInfo)
      if (relevantAdditionalInfo && relevantAdditionalInfo.length > 0 && showAdditionalInfoInCv) {
        atsTextData.push('WEITERE ANGABEN:');
        relevantAdditionalInfo.forEach(item => {
          if (item.details) {
            atsTextData.push(`${item.info}:`);
            // Teile lange Details auf
            const detailLines = item.details.match(/.{1,100}(\s|$)/g) || [item.details];
            detailLines.forEach(line => atsTextData.push(line.trim()));
          } else {
            atsTextData.push(item.info);
          }
        });
      }
      
      // Füge den unsichtbaren Text zum PDF hinzu
      // Position WEIT außerhalb des druckbaren A4-Bereichs (210mm x 297mm)
      // Dadurch bleibt der Text im PDF-Layer, ist aber niemals sichtbar oder druckbar
      let yPos = 400; // Weit unterhalb der A4-Seite
      const xPos = 300; // Weit rechts außerhalb des A4-Bereichs
      const lineHeight = 4; // Größerer Zeilenabstand da Schrift größer ist
      let currentPage = 1;
      
      atsTextData.forEach(line => {
        // Wechsel zur nächsten Seite wenn nötig (wenn zu viele Zeilen)
        if (yPos > 800) {
          currentPage++;
          if (currentPage <= pageCount) {
            pdf.setPage(currentPage);
          } else {
            pdf.addPage();
            pageCount++;
          }
          yPos = 400; // Wieder weit außerhalb starten
        }
        
        // Text an Position einfügen - Umlaute werden bei Schriftgröße 8 korrekt codiert
        try {
          pdf.text(line, xPos, yPos, { maxWidth: 200, align: 'left' });
        } catch (e) {
          // Fallback falls Text-Codierung fehlschlägt
          console.warn('⚠️ Text-Codierung übersprungen für:', line.substring(0, 30));
        }
        yPos += lineHeight;
      });
      
      console.log(`✅ ATS Text-Layer hinzugefügt (${atsTextData.length} Zeilen)`);

      // Lade PDF herunter
      const fileName = `CV_${fullName || 'CV'}_${new Date().toISOString().split('T')[0]}.pdf`;
      pdf.save(fileName);
      
      console.log('✅ PDF erfolgreich heruntergeladen:', fileName);
      console.log('📊 PDF-Info: Visuell identisch, ATS-lesbar mit Text-Layer + Profilbild-Layer');
      
      // Speichere CV-Design-Settings (Header-Farbe, Grafiken, etc.) vor dem Schließen
      if (user) {
        try {
          await saveCvDesignSettings();
          console.log('✅ CV-Design-Settings beim Schließen gespeichert');
        } catch (error) {
          console.error('❌ Fehler beim Speichern der CV-Design-Settings:', error);
        }
      }
      
      // Schließe CV-Preview Modal nach erfolgreichem Download
      setShowTemplatePreviewDialog(false);
      // Zeige "CV optimieren" Button nach dem Schließen des CV-Templates
      setShowCvOptimierenButton(true);
      // Trigger Seitenberechnung im CV-Template
      window.dispatchEvent(new CustomEvent('modalClosed'));
      
    } catch (err: any) {
      console.error('❌ PDF-Generierung Fehler:', err);
      setError('Fehler bei der PDF-Generierung: ' + err.message);
    } finally {
      setDownloadingPdf(false);
    }
  };

  // Funktion zum Speichern des PDFs in Firebase Storage
  const savePdfToFirebase = async (pdf: any, fileName: string, applicationId?: string) => {
    try {
      const targetApplicationId = applicationId || selectedApplicationId;
      
      // Prüfe ob eine aktive Bewerbung vorhanden ist
      if (!targetApplicationId) {
        console.log('ℹ️ Keine aktive Bewerbung - PDF wird nur lokal gespeichert');
        return;
      }

      console.log('💾 Speichere PDF in Firebase Storage für Bewerbung:', targetApplicationId);
      
      // Konvertiere PDF zu Base64
      const pdfOutput = pdf.output('datauristring');
      const base64Data = pdfOutput.split(',')[1]; // Entferne "data:application/pdf;base64," Prefix
      
      // Sende PDF an Backend
      const token = await user?.getIdToken();
      const response = await fetch(`${config.backend.baseUrl}/api/save-application-pdf`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          applicationId: targetApplicationId,
          pdfData: base64Data,
          fileName: fileName
        })
      });

          if (response.ok) {
            const result = await response.json();
            console.log('✅ PDF erfolgreich in Firebase Storage gespeichert:', result.pdfUrl);
            
            // Aktualisiere die Anwendungsliste um die PDF-URL anzuzeigen
            setApplications(prev => prev.map(app => 
              app.id === targetApplicationId 
                ? { ...app, pdfUrl: result.pdfUrl, pdfFileName: result.fileName }
                : app
            ));
          } else {
            console.error('❌ Fehler beim Speichern des PDFs in Firebase:', response.statusText);
          }
    } catch (error) {
      console.error('❌ Fehler beim Speichern des PDFs in Firebase:', error);
    }
  };

  // Funktion zum Erstellen einer PDF mit jsPDF + html2canvas für Motivationsschreiben
  const handleDownloadMotivationPdf = async () => {
    if (!motivationLetter) return;
    
    try {
      console.log('🖨️ Starte PDF-Generierung für Motivationsschreiben mit jsPDF + html2canvas');
      
      // Finde das Motivationsschreiben-Template
      const motivationTemplate = document.querySelector('.motivation-template') || document.querySelector('[data-testid="motivation-template"]');
      if (!motivationTemplate) {
        throw new Error('Motivationsschreiben-Template nicht gefunden');
      }

      // Zeige Ladeindikator
      setDownloadingMotivationPdf(true);
      
      // Erstelle ein Canvas vom gesamten Motivationsschreiben (einfache Konfiguration wie CV)
      const canvas = await html2canvas(motivationTemplate as HTMLElement, {
        allowTaint: true,
        useCORS: true,
        scrollX: 0,
        scrollY: 0,
        width: motivationTemplate.scrollWidth,
        height: motivationTemplate.scrollHeight,
        scale: 2,
        backgroundColor: '#ffffff',
        logging: false
      });

      console.log('✅ Canvas erstellt:', {
        width: canvas.width,
        height: canvas.height
      });

      // Konvertiere zu PDF mit optimierter Kompression (gleiche Methode wie CV)
      const imgData = canvas.toDataURL('image/jpeg', 0.9); // 90% Qualität für kleinere Dateigröße
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
        compress: true // PDF-Kompression für kleinere Dateigröße
      });
      
      const imgWidth = 210; // A4 Breite in mm
      const pageHeight = 297; // A4 Höhe in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;

      let position = 0;
      let pageCount = 1;

      // Füge das Bild zur PDF hinzu (gleiche Methode wie CV)
      pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      // Füge weitere Seiten hinzu, falls nötig
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pageCount++;
        pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      // Speichere die PDF
      const fileName = `Motivationsschreiben_${new Date().toISOString().split('T')[0]}.pdf`;
      pdf.save(fileName);
      
      console.log('✅ Motivationsschreiben PDF erfolgreich erstellt');
      
    } catch (err: any) {
      console.error('❌ Fehler bei PDF-Generierung für Motivationsschreiben:', err);
      setError('Fehler bei PDF-Generierung: ' + (err?.message || 'Unbekannter Fehler'));
    } finally {
      setDownloadingMotivationPdf(false);
    }
  };

  const handleMotivationTextChange = (newText: string) => {
    setMotivationLetter(newText);
  };





  // Funktion zum Leeren der Stellenbeschreibung und abgeleiteten Felder
  const handleClearJobDescription = () => {
    setJobDescription('');
    setMatchScore(null);
    setImprovedCvText(null);
    setMotivationLetter(null);
    setShowMotivationDialog(false);
    setExtractedJobInfo(null);
    setHideMatchResults(false);
    setRelevantItSkills([]);
    setRelevantCertifications([]);
    setRelevantCoreCompetencies([]);
    setRelevantAdditionalInfo([]);
    console.log('Stellenbeschreibung und abgeleitete Felder geleert');
  };

  // Funktion zum Verarbeiten der Stellenbeschreibung mit automatischer Leerzeile
  const handleJobDescriptionChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    
    // Reset language detection when job description changes
    setLanguageDetected(false);
    
    // Prüfe, ob der Text über Copy/Paste eingefügt wurde (mehr als 1 Zeichen auf einmal)
    const isPaste = value.length > jobDescription.length + 1;
    
    if (isPaste) {
      // Füge eine zusätzliche Leerzeile am Ende hinzu, falls nicht bereits vorhanden
      const trimmedValue = value.trim();
      const newValue = trimmedValue.endsWith('\n\n') ? trimmedValue : trimmedValue + '\n\n';
      setJobDescription(newValue);
      
      // Extrahiere strukturierte Job-Informationen bei Copy/Paste
      if (trimmedValue.length > 100) {
        try {
          setExtractingJobInfo(true);
          console.log('🔍 Extrahiere Job-Informationen aus eingefügtem Text...');
          const response = await fetch(`${config.backend.baseUrl}/api/extract-job-info`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ text: trimmedValue })
          });
          
          if (response.ok) {
            const data = await response.json();
            if (data.jobInfo && Object.keys(data.jobInfo).length > 0) {
              setExtractedJobInfo(data.jobInfo);
              console.log('✅ Job-Informationen aus Text extrahiert:', data.jobInfo);
            }
          }
        } catch (error) {
          console.error('❌ Fehler bei Job-Info-Extraktion:', error);
        } finally {
          setExtractingJobInfo(false);
        }
      }
      
      // Spracherkennung wird nicht mehr automatisch ausgelöst
      // Sie wird jetzt beim Klick auf "Passgenauigkeit prüfen" ausgelöst
    } else {
      // Normale Eingabe - keine Änderung
      setJobDescription(value);
    }
  };

  // Funktion zum Extrahieren von Text aus URL
  const extractTextFromUrl = async (url: string) => {
    console.log('🌐 Extrahiere Text aus URL:', url);
    setExtractingJobUrl(true);
    setExtractingJobInfo(true);
    
    try {
      const response = await fetch(`${config.backend.fullApiUrl}/api/extract-job-url`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ url })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      if (data.text && data.text.trim()) {
        // Reset language detection
        setLanguageDetected(false);
        
        // Setze den extrahierten Text
        const trimmedText = data.text.trim();
        const newValue = trimmedText.endsWith('\n\n') ? trimmedText : trimmedText + '\n\n';
        setJobDescription(newValue);
        
        // Setze strukturierte Job-Informationen
        if (data.jobInfo) {
          console.log('📊 Empfangene Job-Informationen:', data.jobInfo);
          console.log('🏢 Firma:', data.jobInfo.company);
          console.log('📋 Rollentitel:', data.jobInfo.roleTitle);
          console.log('🏭 Branche:', data.jobInfo.industry);
          setExtractedJobInfo(data.jobInfo);
          console.log('✅ Strukturierte Job-Informationen gesetzt');
        } else {
          console.log('⚠️ Keine jobInfo in Response');
          setExtractingJobInfo(false);
        }
        
        console.log('✅ Text erfolgreich extrahiert:', data.text.substring(0, 100) + '...');
        
        // Automatische Spracherkennung nach URL-Extraktion
        if (trimmedText.length > 10) {
          console.log('🔍 Starte Spracherkennung nach URL-Extraktion...');
          await detectJobDescriptionLanguage(trimmedText);
        }
      } else {
        throw new Error('Kein Text gefunden');
      }
    } catch (error) {
      console.error('❌ Fehler beim Extrahieren:', error);
      setError(`Fehler beim Extrahieren der Stellenbeschreibung: ${error instanceof Error ? error.message : 'Unbekannter Fehler'}`);
    } finally {
      setExtractingJobUrl(false);
      setExtractingJobInfo(false);
    }
  };

  // Funktion für automatische Spracherkennung der Stellenbeschreibung
  const detectJobDescriptionLanguage = async (text: string) => {
    if (text.length < 10) return; // Zu kurz für zuverlässige Erkennung
    
    // Spracherkennung gestartet
    setDetectingLanguage(true);
    
    try {
      const requestBody = { text: text.substring(0, 500) };
      console.log('📤 Sende Request an:', `${config.backend.fullApiUrl}/api/detect-language`);
      console.log('📤 Request Body:', requestBody);
      
      const response = await fetch(`${config.backend.fullApiUrl}/api/detect-language`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody)
      });

      console.log('📥 Response Status:', response.status);
      
      if (response.ok) {
        const data = await response.json();
        console.log('📥 Response Data:', data);
        
        if (data.success && data.language) {
          // Konvertiere Sprachcode zu unseren Dropdown-Werten
          const languageMap: { [key: string]: string } = {
            'de': 'DE',
            'en': 'EN', 
            'fr': 'FR',
            'it': 'IT'
          };
          const detectedLanguage = languageMap[data.language.toLowerCase()] || 'DE';
          console.log('✅ Erkannte Sprache:', data.language, '->', detectedLanguage);
          setJobDescriptionLanguage(detectedLanguage);
          setLanguageDetected(true);
        } else {
          console.error('❌ Keine Sprache in Response gefunden:', data);
        }
      } else {
        const errorData = await response.json();
        console.error('❌ Response Error:', errorData);
      }
    } catch (error) {
      console.error('❌ Fehler bei der Spracherkennung:', error);
    } finally {
      setDetectingLanguage(false);
    }
  };

  // Separate State für AI-optimierte Arbeitserfahrungen (werden nicht gespeichert)
  const [optimizedWorkExperiences, setOptimizedWorkExperiences] = useState<Array<{ company: string; position: string; startDate: string; endDate: string; description: string; relevant?: boolean | string }>>([]);
  const [optimizedShortProfile, setOptimizedShortProfile] = useState<string>('');
  
  // Aktualisiere Info-Nachricht bei Zustandsänderungen - Optimiert für Performance
  React.useEffect(() => {
    if (!extracting && !optimizing && !creatingMotivation && !checkingMatch) {
      updateInfoMessage();
    }
  }, [jobDescription, matchScore, optimizedShortProfile, motivationLetter, extracting, optimizing, creatingMotivation, checkingMatch, cvTemplateHasBeenOpened]);
  
  // useEffect um das Profil-Modal beim Öffnen zu initialisieren
  React.useEffect(() => {
    if (showProfileModal) {
      // Initialisiere die temporären Werte beim Öffnen des Modals
      const currentProfile = optimizedShortProfile || shortProfile || '';
      console.log('🔧 Modal geöffnet - Initialisiere Profil:', {
        optimizedShortProfile,
        shortProfile,
        currentProfile
      });
      setTempOptimizedShortProfile(currentProfile);
    }
  }, [showProfileModal]); // Nur showProfileModal als Dependency
  
  // State für optimierte persönliche Angaben
  const [optimizedFullName, setOptimizedFullName] = useState<string>('');
  const [optimizedCompany, setOptimizedCompany] = useState<string>('');
  const [optimizedAddress, setOptimizedAddress] = useState<string>('');
  const [optimizedPostalCode, setOptimizedPostalCode] = useState<string>('');
  const [optimizedCity, setOptimizedCity] = useState<string>('');
  const [optimizedPhoneNumber, setOptimizedPhoneNumber] = useState<string>('');
  const [optimizedEmail, setOptimizedEmail] = useState<string>('');
  const [optimizedBirthYear, setOptimizedBirthYear] = useState<string>('');
  const [optimizedNationality, setOptimizedNationality] = useState<string>('');
  const [optimizedResidencePermit, setOptimizedResidencePermit] = useState<string>('');
  const [optimizedCivilStatus, setOptimizedCivilStatus] = useState<string>('');
  const [relevantItSkills, setRelevantItSkills] = useState<Array<{ skill: string; level: string; relevance?: string }>>([]);
  const [relevantCertifications, setRelevantCertifications] = useState<Array<{ name: string; issuer: string; date: string }>>([]);
  const [relevantCoreCompetencies, setRelevantCoreCompetencies] = useState<Array<{ competency: string }>>([]);
  const [relevantIndustries, setRelevantIndustries] = useState<Array<{ industry: string; years: string }>>([]);
  const [relevantHobbies, setRelevantHobbies] = useState<Array<{ hobby: string; description: string }>>([]);
  const [relevantAdditionalInfo, setRelevantAdditionalInfo] = useState<Array<{ info: string; details: string }>>([]);
  const [relevantEducations, setRelevantEducations] = useState<Array<{ institution: string; degree: string; startDate: string; endDate: string }>>([]);
  const [relevantWorkExperiences, setRelevantWorkExperiences] = useState<Array<{ position: string; company: string; startDate: string; endDate: string; description: string }>>([]);
  const [relevantLanguages, setRelevantLanguages] = useState<Array<{ language: string; level: string }>>([]);
  const [showItSkillSelector, setShowItSkillSelector] = useState(false);
  const [showCertificationSelector, setShowCertificationSelector] = useState(false);
  const [showCoreCompetencySelector, setShowCoreCompetencySelector] = useState(false);
  const [showAdditionalInfoSelector, setShowAdditionalInfoSelector] = useState(false);
  const [showEducationSelector, setShowEducationSelector] = useState(false);
  const [showIndustrySelector, setShowIndustrySelector] = useState(false);
  const [showHobbySelector, setShowHobbySelector] = useState(false);
  const [showLanguageSelector, setShowLanguageSelector] = useState(false);

  // Handler zum Löschen einer relevanten IT-Kenntnis
  const handleDeleteRelevantItSkill = (index: number) => {
    setRelevantItSkills(prev => prev.filter((_, i) => i !== index));
  };

  // Handler zum Löschen einer relevanten Zertifizierung
  const handleDeleteRelevantCertification = (index: number) => {
    setRelevantCertifications(prev => prev.filter((_, i) => i !== index));
  };

  // Handler zum Löschen einer relevanten Kernkompetenz
  const handleDeleteRelevantCoreCompetency = (index: number) => {
    setRelevantCoreCompetencies(prev => prev.filter((_, i) => i !== index));
  };

  // Handler zum Löschen einer relevanten Branche
  const handleDeleteRelevantIndustry = (index: number) => {
    setRelevantIndustries(prev => prev.filter((_, i) => i !== index));
  };

  // Handler zum Löschen eines relevanten Hobbys
  const handleDeleteRelevantHobby = (index: number) => {
    setRelevantHobbies(prev => prev.filter((_, i) => i !== index));
  };

  // Handler zum Löschen einer relevanten weiteren Information
  const handleDeleteRelevantAdditionalInfo = (index: number) => {
    setRelevantAdditionalInfo(prev => prev.filter((_, i) => i !== index));
  };

  // Handler zum Löschen einer relevanten Ausbildung
  const handleDeleteRelevantEducation = (index: number) => {
    setRelevantEducations(prev => prev.filter((_, i) => i !== index));
  };

  // Handler zum Löschen einer relevanten Arbeitserfahrung
  const handleDeleteRelevantWorkExperience = (index: number) => {
    setRelevantWorkExperiences(prev => prev.filter((_, i) => i !== index));
  };

  // Handler zum Löschen einer relevanten Sprache
  const handleDeleteRelevantLanguage = (index: number) => {
    setRelevantLanguages(prev => prev.filter((_, i) => i !== index));
  };

  // Handler zum Editieren einer relevanten Kernkompetenz
  const handleRelevantCoreCompetencyChange = (index: number, value: string) => {
    setRelevantCoreCompetencies(prev => prev.map((comp, i) => i === index ? { competency: value } : comp));
  };

  // Handler zum Editieren einer relevanten weiteren Information
  const handleRelevantAdditionalInfoChange = (index: number, field: 'info' | 'details', value: string) => {
    setRelevantAdditionalInfo(prev => prev.map((info, i) => i === index ? { ...info, [field]: value } : info));
  };

  // Handler zum Hinzufügen eines IT-Skills aus den gespeicherten Daten
  const handleAddItSkillFromStored = (skill: { skill: string; level: string }) => {
    // Prüfe ob der Skill bereits in der relevanten Liste ist
    const isAlreadyInList = relevantItSkills.some(
      relevantSkill => relevantSkill.skill === skill.skill && relevantSkill.level === skill.level
    );
    
    if (!isAlreadyInList) {
      setRelevantItSkills(prev => [{ 
        skill: skill.skill, 
        level: skill.level
      }, ...prev]);
    }
  };

  // Handler zum Hinzufügen einer Zertifizierung aus den gespeicherten Daten
  const handleAddCertificationFromStored = (certification: { name: string; issuer: string; date: string }) => {
    // Prüfe ob die Zertifizierung bereits in der relevanten Liste ist
    const isAlreadyInList = relevantCertifications.some(
      relevantCert => relevantCert.name === certification.name && relevantCert.issuer === certification.issuer
    );
    
    if (!isAlreadyInList) {
      setRelevantCertifications(prev => [{ 
        name: certification.name, 
        issuer: certification.issuer,
        date: certification.date
      }, ...prev]);
    }
  };

  // Handler zum Hinzufügen einer Kernkompetenz aus den gespeicherten Daten
  const handleAddCoreCompetencyFromStored = (competency: { competency: string }) => {
    // Prüfe ob die Kernkompetenz bereits in der relevanten Liste ist
    const isAlreadyInList = relevantCoreCompetencies.some(
      relevantComp => relevantComp.competency === competency.competency
    );
    
    if (!isAlreadyInList) {
      setRelevantCoreCompetencies(prev => [{ competency: competency.competency }, ...prev]);
    }
  };

  // Handler zum Hinzufügen einer Ausbildung aus den gespeicherten Daten
  const handleAddEducationFromStored = (education: { institution: string; degree: string; startDate: string; endDate: string }) => {
    // Prüfe ob die Ausbildung bereits in der relevanten Liste ist
    const isAlreadyInList = relevantEducations.some(
      relevantEdu => relevantEdu.institution === education.institution && relevantEdu.degree === education.degree
    );
    
    if (!isAlreadyInList) {
      setRelevantEducations(prev => [{ 
        institution: education.institution, 
        degree: education.degree,
        startDate: education.startDate,
        endDate: education.endDate
      }, ...prev]);
    }
  };

  // Handler für Profilbild Upload
  const handleProfileImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      // Prüfe Dateigröße (max 10MB)
      if (file.size > 10 * 1024 * 1024) {
        alert('Datei zu groß. Maximale Größe: 10MB');
        return;
      }
      
      // Prüfe Dateityp
      if (!file.type.startsWith('image/')) {
        alert('Bitte wählen Sie eine Bilddatei aus.');
        return;
      }
      
      const reader = new FileReader();
      reader.onload = (e) => {
        setProfileImage(e.target?.result as string);
        setHasUnsavedChanges(true);
      };
      reader.onerror = (error) => {
        console.error('❌ Fehler beim Lesen der Datei:', error);
        alert('Fehler beim Lesen der Datei. Bitte versuchen Sie es erneut.');
      };
      reader.readAsDataURL(file);
    }
  };

  // Handler zum Entfernen des Profilbilds
  const handleRemoveProfileImage = () => {
    setProfileImage(null);
    setHasUnsavedChanges(true);
  };

  // Handler für Signatur Upload
  const handleSignatureUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setSignature(e.target?.result as string);
        setHasUnsavedChanges(true);
      };
      reader.readAsDataURL(file);
    }
  };

  // Handler zum Entfernen der Signatur
  const handleRemoveSignature = () => {
    setSignature(null);
    setHasUnsavedChanges(true);
  };

  // Handler zum Hinzufügen einer Branche aus den gespeicherten Daten
  const handleAddIndustryFromStored = (industry: { industry: string; years: string }) => {
    // Prüfe ob die Branche bereits in der relevanten Liste ist
    const isAlreadyInList = relevantIndustries.some(
      relevantIndustry => relevantIndustry.industry === industry.industry
    );
    
    if (!isAlreadyInList) {
      setRelevantIndustries(prev => [{ 
        industry: industry.industry, 
        years: industry.years
      }, ...prev]);
    }
  };

  // Handler zum Hinzufügen eines Hobbys aus den gespeicherten Daten
  const handleAddHobbyFromStored = (hobby: { hobby: string; description: string }) => {
    // Prüfe ob das Hobby bereits in der relevanten Liste ist
    const isAlreadyInList = relevantHobbies.some(
      relevantHobby => relevantHobby.hobby === hobby.hobby
    );
    
    if (!isAlreadyInList) {
      setRelevantHobbies(prev => [{ 
        hobby: hobby.hobby, 
        description: hobby.description
      }, ...prev]);
    }
  };

  // Handler zum Hinzufügen einer weiteren Information aus den gespeicherten Daten
  const handleAddAdditionalInfoFromStored = (additionalInfo: { info: string; details: string }) => {
    // Prüfe ob die weitere Information bereits in der relevanten Liste ist
    const isAlreadyInList = relevantAdditionalInfo.some(
      relevantInfo => relevantInfo.info === additionalInfo.info && relevantInfo.details === additionalInfo.details
    );
    
    if (!isAlreadyInList) {
      setRelevantAdditionalInfo(prev => [{ info: additionalInfo.info, details: additionalInfo.details }, ...prev]);
    }
  };

  // Handler zum Hinzufügen einer Sprache aus den gespeicherten Daten
  const handleAddLanguageFromStored = (language: { language: string; level: string }) => {
    // Prüfe ob die Sprache bereits in der relevanten Liste ist
    const isAlreadyInList = relevantLanguages.some(
      relevantLang => relevantLang.language === language.language && relevantLang.level === language.level
    );
    
    if (!isAlreadyInList) {
      setRelevantLanguages(prev => [{ 
        language: language.language, 
        level: language.level
      }, ...prev]);
    }
  };

  // Handler zum Editieren einer Arbeitserfahrung (CV-Daten)
  const handleWorkExperienceChange = (idx: number, field: string, value: string) => {
    // Aktualisiere beide Arrays synchron: relevante Arbeitserfahrungen UND optimierte Arbeitserfahrungen
    const updateFunction = (prev: any[]) => prev.map((exp, i) => i === idx ? { ...exp, [field]: value } : exp);
    setRelevantWorkExperiences(updateFunction);
    setOptimizedWorkExperiences(updateFunction);
    setHasUnsavedChanges(true);
  };

  // Handler zum Editieren einer Arbeitserfahrung (nur CV-Daten) - Optimiert mit useCallback
  const handleCvWorkExperienceChange = useCallback((idx: number, field: 'company' | 'position' | 'startDate' | 'endDate' | 'description', value: string) => {
    setWorkExperiences(prev => {
      const newExperiences = [...prev];
      newExperiences[idx] = { ...newExperiences[idx], [field]: value };
      return newExperiences;
    });
    
    setHasUnsavedChanges(true);
  }, []);


  // Handler zum manuellen Editieren der Original CV-Arbeitserfahrungen
  const handleOriginalWorkExperienceChange = (idx: number, field: string, value: string) => {
    // Aktualisiere die Original-Arbeitserfahrungen (CV-Daten)
    setWorkExperiences(prev => prev.map((exp, i) => i === idx ? { ...exp, [field]: value } : exp));
  };

  // Synchronisiere relevantWorkExperiences mit optimizedWorkExperiences
  const syncWorkExperiences = (updatedRelevantWorkExperiences: any[]) => {
    setRelevantWorkExperiences(updatedRelevantWorkExperiences);
    setOptimizedWorkExperiences(updatedRelevantWorkExperiences);
  };

  // Handler zum Editieren einer optimierten Arbeitserfahrung (nicht gespeichert)
  const handleOptimizedWorkExperienceChange = (idx: number, field: string, value: string) => {
    // Aktualisiere nur die optimierten Arbeitserfahrungen (nicht gespeichert)
    setOptimizedWorkExperiences(prev => prev.map((exp, i) => i === idx ? { ...exp, [field]: value } : exp));
  };

  // Handler zum Hinzufügen einer neuen Arbeitserfahrung
  const handleAddWorkExperience = () => {
    setWorkExperiences(prev => [
      { company: '', position: '', startDate: '', endDate: '', description: '' },
      ...prev
    ]);
    setHasUnsavedChanges(true);
  };

  // Handler zum Löschen einer Arbeitserfahrung
  const handleDeleteWorkExperience = (idx: number) => {
    setWorkExperiences(prev => prev.filter((_, i) => i !== idx));
    setHasUnsavedChanges(true);
  };

  const handleNewWorkExperienceChange = useCallback((field: string, value: string) => {
    setNewWorkExperience(prev => ({ ...prev, [field]: value }));
  }, []);
  const handleAddNewWorkExperience = async () => {
    if (!newWorkExperience.company && !newWorkExperience.position && !newWorkExperience.startDate && !newWorkExperience.endDate && !newWorkExperience.description) return;
    
    // Füge neue Berufserfahrung zum State hinzu
    const updatedWorkExperiences = [
      { ...newWorkExperience },
      ...workExperiences
    ];
    setWorkExperiences(updatedWorkExperiences);
    
    // Speichere automatisch in Firebase
    if (user) {
      try {
        const idToken = await user.getIdToken();
        
        // Sammle alle CV-Daten mit der neuen Berufserfahrung
        const cvData = {
          fullName,
          company,
          address,
          postalCode,
          city,
          country,
          availableFrom,
          phoneNumber,
          email,
          birthYear,
          nationality,
          residencePermit,
          civilStatus,
          shortProfile,
          optimizedShortProfile,
          workExperiences: updatedWorkExperiences,
          optimizedWorkExperiences,
          relevantWorkExperiences,
          education,
          coreCompetencies,
          relevantCoreCompetencies,
          certifications,
          relevantCertifications,
          itSkills,
          relevantItSkills,
          languages,
          hobbies,
          additionalInfo,
          industryExperiences,
          profileImage,
          signature
        };
        
        const response = await fetch(`${config.backend.saveDataUrl}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
          },
          body: JSON.stringify({
            uid: user.uid,
            data: cvData
          })
        });
        
        if (response.ok) {
          const result = await response.json();
          console.log('✅ Neue Berufserfahrung in Firebase gespeichert');
          console.log('📊 Backend Response:', result);
        } else {
          const errorText = await response.text();
          console.error('❌ Fehler beim Speichern der neuen Berufserfahrung:', response.status, errorText);
        }
      } catch (error) {
        console.error('❌ Fehler beim Speichern der neuen Berufserfahrung:', error);
      }
    }
    
    // Formular zurücksetzen
    setNewWorkExperience({ company: '', position: '', startDate: '', endDate: '', description: '' });
    setShowNewWorkExperienceForm(false);
  };

  // Automatisches Speichern der Arbeitserfahrungen bei Änderung
  // Wird jetzt über den verschlüsselten Backend-Endpoint gehandhabt

  const handleAddLanguage = () => {
    setLanguages(prev => [{ language: '', level: '' }, ...prev]);
  };

  const handleDeleteLanguage = (idx: number) => {
    setLanguages(prev => prev.filter((_, i) => i !== idx));
  };

  const handleLanguageTableChange = useCallback((idx: number, field: 'language' | 'level', value: string) => {
    setLanguages(prev => {
      const newLanguages = [...prev];
      newLanguages[idx] = { ...newLanguages[idx], [field]: value };
      return newLanguages;
    });
  }, []);

  const handleAddCoreCompetency = () => {
    setCoreCompetencies(prev => [{ competency: '' }, ...prev]);
    setHasUnsavedChanges(true);
  };


  const handleDeleteCoreCompetency = (idx: number) => {
    setCoreCompetencies(prev => prev.filter((_, i) => i !== idx));
    setHasUnsavedChanges(true);
  };

  const handleCoreCompetencyTableChange = useCallback((idx: number, field: 'competency', value: string) => {
    setCoreCompetencies(prev => {
      const newCompetencies = [...prev];
      newCompetencies[idx] = { ...newCompetencies[idx], [field]: value };
      return newCompetencies;
    });
  }, []);

  const [optimizingImage, setOptimizingImage] = useState(false);


  const handleAddItSkill = () => {
    setItSkills(prev => [{ skill: '', level: '' }, ...prev]);
  };

  const handleDeleteItSkill = (idx: number) => {
    setItSkills(prev => prev.filter((_, i) => i !== idx));
  };

  const handleItSkillsChange = useCallback((idx: number, field: 'skill' | 'level', value: string) => {
    setItSkills(prev => {
      const newSkills = [...prev];
      newSkills[idx] = { ...newSkills[idx], [field]: value };
      return newSkills;
    });
  }, []);

  const handleAddHobby = () => {
    setHobbies(prev => [{ hobby: '', description: '' }, ...prev]);
  };

  const handleRemoveHobby = (idx: number) => {
    setHobbies(prev => prev.filter((_, i) => i !== idx));
  };

  const handleHobbyTableChange = useCallback((idx: number, field: 'hobby' | 'description', value: string) => {
    setHobbies(prev => {
      const newHobbies = [...prev];
      newHobbies[idx] = { ...newHobbies[idx], [field]: value };
      return newHobbies;
    });
  }, []);

  const handleAddAdditionalInfo = () => {
    setAdditionalInfo(prev => [{ info: '', details: '' }, ...prev]);
  };

  const handleDeleteAdditionalInfo = (idx: number) => {
    setAdditionalInfo(prev => prev.filter((_, i) => i !== idx));
  };

  const handleAdditionalInfoChange = useCallback((idx: number, field: 'info' | 'details', value: string) => {
    setAdditionalInfo(prev => {
      const newInfo = [...prev];
      newInfo[idx] = { ...newInfo[idx], [field]: value };
      return newInfo;
    });
  }, []);

  // Handler für Branchenerfahrungen
  const handleIndustryExperienceChange = useCallback((idx: number, field: 'industry' | 'years', value: string) => {
    setIndustryExperiences(prev => {
      const newExperiences = [...prev];
      newExperiences[idx] = { ...newExperiences[idx], [field]: value };
      return newExperiences;
    });
 // Setze Checkbox auf false bei manuellen Änderungen
    console.log(`📝 Branchenerfahrung ${idx} ${field} geändert:`, value);
  }, []);


  const handleAddIndustryExperience = () => {
    setIndustryExperiences(prev => [{ industry: '', years: '' }, ...prev]);
  };

  const handleDeleteIndustryExperience = (idx: number) => {
    setIndustryExperiences(prev => prev.filter((_, i) => i !== idx));
  };





  // Sprachen, Kernkompetenzen, IT-Skills, Weitere Angaben und Profilbild automatisch speichern
  // Wird jetzt über den verschlüsselten Backend-Endpoint gehandhabt

  // Funktion zum Generieren von Initialen
  const getInitials = (name: string): string => {
    if (!name || !name.trim()) return '';
    const parts = name.trim().split(' ');
    if (parts.length === 1) {
      return parts[0].charAt(0).toUpperCase();
    }
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  };

  // Funktion zum Generieren einer konsistenten Farbe aus einem String
  const getColorFromString = (str: string): string => {
    if (!str || !str.trim()) return '#667eea'; // Fallback-Farbe
    
    // Hash-Funktion: Summiere die Zeichencodes
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    // Generiere HSL-Farbwerte mit guter Sättigung und Helligkeit
    const hue = Math.abs(hash) % 360;
    const saturation = 60 + (Math.abs(hash) % 20); // 60-80%
    const lightness = 45 + (Math.abs(hash) % 15); // 45-60%
    
    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  };

  // Funktion zum Prüfen, ob Daten vorhanden sind
  const hasData = () => {
    const hasBasicData = !!(
      fullName ||
      company ||
      address ||
      postalCode ||
      city ||
      country ||
      availableFrom ||
      phoneNumber ||
      email ||
      birthYear ||
      nationality ||
      residencePermit ||
      civilStatus ||
      shortProfile ||
      workExperience ||
      education ||
      certificates ||
      profileImage ||
      signature
    );
    
    const hasArrayData = !!(
      (Array.isArray(workExperiences) && workExperiences.length > 0) ||
      (Array.isArray(educations) && educations.length > 0) ||
      (Array.isArray(certifications) && certifications.length > 0) ||
      (Array.isArray(industryExperiences) && industryExperiences.length > 0) ||
      (Array.isArray(languages) && languages.length > 0) ||
      (Array.isArray(coreCompetencies) && coreCompetencies.length > 0) ||
      (Array.isArray(itSkills) && itSkills.length > 0) ||
      (Array.isArray(hobbies) && hobbies.length > 0) ||
      (Array.isArray(additionalInfo) && additionalInfo.length > 0)
    );
    
    // Prüfe auch ob CVs in der userCvs Liste vorhanden sind
    const hasCvData = !!(userCvs && userCvs.length > 0);
    
    const result = hasBasicData || hasArrayData || hasCvData;
    
    return result;
  };

  // Funktion zum Zurücksetzen der Checkbox wenn CV-Daten geändert werden

  // Mapping-Funktion für AI-extrahierten Nationalität-Text zu Select-Werten
  const mapNationalityToSelectValue = (nationalityText: string): string => {
    if (!nationalityText) return '';
    
    const nationalityMap: { [key: string]: string } = {
      'schweiz': 'CH',
      'schweizer': 'CH',
      'deutschland': 'DE',
      'deutscher': 'DE',
      'deutsche': 'DE',
      'österreich': 'AT',
      'österreicher': 'AT',
      'österreicherin': 'AT',
      'frankreich': 'FR',
      'franzose': 'FR',
      'französin': 'FR',
      'italien': 'IT',
      'italiener': 'IT',
      'italienerin': 'IT',
      'spanien': 'ES',
      'spanier': 'ES',
      'spanierin': 'ES',
      'portugal': 'PT',
      'portugiese': 'PT',
      'portugiesin': 'PT',
      'niederlande': 'NL',
      'niederländer': 'NL',
      'niederländerin': 'NL',
      'belgien': 'BE',
      'belgier': 'BE',
      'belgierin': 'BE',
      'luxemburg': 'LU',
      'luxemburger': 'LU',
      'dänemark': 'DK',
      'däne': 'DK',
      'dänin': 'DK',
      'schweden': 'SE',
      'schwede': 'SE',
      'schwedin': 'SE',
      'norwegen': 'NO',
      'norweger': 'NO',
      'norwegerin': 'NO',
      'finnland': 'FI',
      'finne': 'FI',
      'finnin': 'FI',
      'island': 'IS',
      'isländer': 'IS',
      'isländerin': 'IS',
      'großbritannien': 'GB',
      'brite': 'GB',
      'britin': 'GB',
      'irland': 'IE',
      'ire': 'IE',
      'irin': 'IE',
      'polen': 'PL',
      'pole': 'PL',
      'polin': 'PL',
      'tschechien': 'CZ',
      'tscheche': 'CZ',
      'tschechin': 'CZ',
      'slowakei': 'SK',
      'slowake': 'SK',
      'slowakin': 'SK',
      'ungarn': 'HU',
      'ungar': 'HU',
      'ungarin': 'HU',
      'rumänien': 'RO',
      'rumäne': 'RO',
      'rumänin': 'RO',
      'bulgarien': 'BG',
      'bulgare': 'BG',
      'bulgarin': 'BG',
      'kroatien': 'HR',
      'kroate': 'HR',
      'kroatin': 'HR',
      'slowenien': 'SI',
      'slowene': 'SI',
      'slowenin': 'SI',
      'serbien': 'RS',
      'serbe': 'RS',
      'serbin': 'RS',
      'bosnien-herzegowina': 'BA',
      'bosnier': 'BA',
      'bosnierin': 'BA',
      'montenegro': 'ME',
      'montenegriner': 'ME',
      'montenegrinerin': 'ME',
      'nordmazedonien': 'MK',
      'mazedonier': 'MK',
      'mazedonierin': 'MK',
      'albanien': 'AL',
      'albaner': 'AL',
      'albanerin': 'AL',
      'griechenland': 'GR',
      'grieche': 'GR',
      'griechin': 'GR',
      'zypern': 'CY',
      'zypriot': 'CY',
      'zypriotin': 'CY',
      'malta': 'MT',
      'malteser': 'MT',
      'malteserin': 'MT',
      'estland': 'EE',
      'este': 'EE',
      'estin': 'EE',
      'lettland': 'LV',
      'lette': 'LV',
      'lettin': 'LV',
      'litauen': 'LT',
      'litauer': 'LT',
      'litauerin': 'LT',
      'usa': 'US',
      'amerikaner': 'US',
      'amerikanerin': 'US',
      'kanada': 'CA',
      'kanadier': 'CA',
      'kanadierin': 'CA',
      'australien': 'AU',
      'australier': 'AU',
      'australierin': 'AU',
      'neuseeland': 'NZ',
      'neuseeländer': 'NZ',
      'neuseeländerin': 'NZ',
      'japan': 'JP',
      'japaner': 'JP',
      'japanerin': 'JP',
      'südkorea': 'KR',
      'koreaner': 'KR',
      'koreanerin': 'KR',
      'china': 'CN',
      'chinese': 'CN',
      'chinesin': 'CN',
      'indien': 'IN',
      'inder': 'IN',
      'inderin': 'IN',
      'pakistan': 'PK',
      'pakistani': 'PK',
      'pakistanerin': 'PK',
      'bangladesch': 'BD',
      'bangladescher': 'BD',
      'bangladescherin': 'BD',
      'sri lanka': 'LK',
      'sri lanker': 'LK',
      'sri lankerin': 'LK',
      'nepal': 'NP',
      'nepalese': 'NP',
      'nepalesin': 'NP',
      'bhutan': 'BT',
      'bhutaneser': 'BT',
      'bhutaneserin': 'BT',
      'malediven': 'MV',
      'malediver': 'MV',
      'malediverin': 'MV',
      'afghanistan': 'AF',
      'afghane': 'AF',
      'afghanin': 'AF',
      'iran': 'IR',
      'iraner': 'IR',
      'iranerin': 'IR',
      'irak': 'IQ',
      'iraker': 'IQ',
      'irakerin': 'IQ',
      'kuwait': 'KW',
      'kuwaiter': 'KW',
      'kuwaiterin': 'KW',
      'bahrain': 'BH',
      'bahrainer': 'BH',
      'bahrainerin': 'BH',
      'katar': 'QA',
      'katarer': 'QA',
      'katarerin': 'QA'
    };
    
    const normalizedText = nationalityText.toLowerCase().trim();
    
    // Direkte Übereinstimmung
    if (nationalityMap[normalizedText]) {
      return nationalityMap[normalizedText];
    }
    
    // Teilübereinstimmung
    for (const [key, value] of Object.entries(nationalityMap)) {
      if (normalizedText.includes(key) || key.includes(normalizedText)) {
        return value;
      }
    }
    
    // Wenn keine Übereinstimmung gefunden wird, gib einen leeren String zurück
    // damit nur gültige Ländercodes angezeigt werden
    return '';
  };

  // Mapping-Funktion für AI-extrahierten Familienstand-Text zu Select-Werten
  const mapCivilStatusToSelectValue = (civilStatusText: string): string => {
    if (!civilStatusText) return '';
    
    const civilStatusMap: { [key: string]: string } = {
      'ledig': 'ledig',
      'single': 'ledig',
      'unverheiratet': 'ledig',
      'verheiratet': 'verheiratet',
      'married': 'verheiratet',
      'ehelich': 'verheiratet',
      'geschieden': 'geschieden',
      'divorced': 'geschieden',
      'getrennt': 'geschieden',
      'verwitwet': 'verwitwet',
      'widowed': 'verwitwet',
      'eingetragene partnerschaft': 'eingetragene-partnerschaft',
      'registered partnership': 'eingetragene-partnerschaft',
      'partnerschaft': 'eingetragene-partnerschaft'
    };
    
    const normalizedText = civilStatusText.toLowerCase().trim();
    
    // Direkte Übereinstimmung
    if (civilStatusMap[normalizedText]) {
      return civilStatusMap[normalizedText];
    }
    
    // Teilübereinstimmung
    for (const [key, value] of Object.entries(civilStatusMap)) {
      if (normalizedText.includes(key) || key.includes(normalizedText)) {
        return value;
      }
    }
    
    // Wenn keine Übereinstimmung gefunden wird, gib den ursprünglichen Text zurück
    return civilStatusText;
  };

  // Temporäre States für modale Fenster - werden erst beim Schließen übernommen
  const [tempOptimizedShortProfile, setTempOptimizedShortProfile] = useState('');
  
  // Optimierter Handler für Profil-Text-Änderungen
  const handleProfileTextChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setTempOptimizedShortProfile(e.target.value);
  }, []);
  
  // Optimierte TextField-Komponente entfernt - verursachte Fokus-Probleme

  // Funktion zum Übernehmen der temporären Werte beim Schließen des Profil-Modals
  const applyProfileChanges = () => {
    setOptimizedShortProfile(tempOptimizedShortProfile);
    // Profil-Änderungen sind manuelle Änderungen, daher Checkbox auf false setzen
  };
  
  // Funktion zum Verwerfen der temporären Änderungen (ESC oder X-Button)
  const discardProfileChanges = () => {
    // Setze temporären State zurück auf ursprüngliche Werte
    setTempOptimizedShortProfile(optimizedShortProfile || shortProfile || '');
  };

  // Funktion zum Initialisieren der temporären Werte beim Öffnen des Profil-Modals
  // Wird jetzt automatisch durch useEffect beim Öffnen des Modals aufgerufen
  const initializeProfileModal = () => {
    // Diese Funktion wird jetzt durch den useEffect ersetzt
    // Behalten für Kompatibilität, aber die eigentliche Initialisierung
    // passiert automatisch beim Öffnen des Modals
  };

  // Wrapper-Funktion für CV-Daten-Änderungen (nur für nicht-modale Felder)
  const handleCvDataChange = useCallback((setter: (value: string) => void, value: string) => {
    setter(value);
    // Markiere als ungespeicherte Änderungen
    setHasUnsavedChanges(true);
    // Änderungen werden über hasUnsavedChanges getrackt
  }, []);

  // Funktion zum Speichern aller CV-Daten nach Firebase
  const saveAllCvDataToFirebase = async () => {
    if (!user) return;
    
    // Sicherheitsprüfung: Verhindere Speicherung wenn fullName leer ist
    if (!fullName || fullName.trim() === '') {
      console.warn('⚠️ Speicherung verhindert: fullName ist leer');
      alert(getTranslatedCvLabel('Speicherung nicht möglich: Vollständiger Name fehlt'));
      return;
    }
    
    try {
      const idToken = await user.getIdToken();
      
      // Sammle alle CV-Daten
      const cvData = {
        fullName,
        company,
        address,
        postalCode,
        city,
        country,
        availableFrom,
        phoneNumber,
        email,
        birthYear,
        nationality,
        residencePermit,
        civilStatus,
        shortProfile,
        optimizedShortProfile,
        workExperiences,
        optimizedWorkExperiences,
        relevantWorkExperiences,
        educations,
        coreCompetencies,
        relevantCoreCompetencies,
        certifications,
        relevantCertifications,
        itSkills,
        relevantItSkills,
        languages,
        hobbies,
        additionalInfo,
        industryExperiences,
        profileImage,
        signature
        // Sprache wird jetzt separat in der users Collection gespeichert
      };
      
      const response = await fetch(`${config.backend.saveDataUrl}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({
          uid: user.uid,
          data: cvData,
          cvId: selectedCvId,
          cvName: currentCvName
        })
      });
      
      if (response.ok) {
        const result = await response.json();
        
        // Aktualisiere CV-Liste, damit der neue CV-Name angezeigt wird
        if (user) {
          try {
            const idToken = await user.getIdToken();
            const cvListResponse = await fetch(`${config.backend.baseUrl}/api/get-user-cvs`, {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${idToken}`
              }
            });
            
            if (cvListResponse.ok) {
              const cvListData = await cvListResponse.json();
              setUserCvs(cvListData.userCvs || []);
            }
          } catch (error) {
            // Fehler beim Aktualisieren der Liste ignorieren
          }
        }
      } else {
        const errorText = await response.text();
        console.error('❌ Fehler beim Speichern der CV-Daten:', response.status, errorText);
      }
    } catch (error) {
      console.error('❌ Fehler beim Speichern der CV-Daten:', error);
    }
  };

  // Spezielle Funktion für das "Vollständiger Name" Feld - Performance-optimiert
  const handleFullNameChange = useCallback((value: string) => {
    setFullName(value);
    setHasUnsavedChanges(true);
    // Checkbox wird nur bei spezifischen Aktionen gesetzt
  }, []);


  // Handler für Prompt-Änderungen
  const handlePromptChange = (index: number, value: string) => {
    setPrompts(prev => prev.map((prompt, i) => 
      i === index ? { ...prompt, text: value } : prompt
    ));
  };

  // Handler für Prompt-Speichern
  const handleSavePrompt = async (index: number) => {
    try {
      if (!user) return;
      
      const idToken = await user.getIdToken();
      const response = await fetch(`${config.backend.baseUrl}/api/prompts`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({
          promptType: prompts[index].type,
          promptText: prompts[index].text,
          usage: prompts[index].usage
        })
      });

      if (response.ok) {
        console.log('✅ Prompt gespeichert:', prompts[index].type);
      } else {
        console.error('❌ Fehler beim Speichern des Prompts');
      }
    } catch (error) {
      console.error('❌ Fehler beim Speichern des Prompts:', error);
    }
  };

  // Handler für Prompt-Zurücksetzen
  const handleResetPrompt = (index: number) => {
    setPrompts(prev => prev.map((prompt, i) => 
      i === index ? { ...prompt, text: prompt.originalText } : prompt
    ));
  };





  // Handler für Prompt-Editor Modal
  const handleClosePromptEditor = () => {
    setPromptEditorOpen(false);
    setEditingPromptIndex(null);
    setEditingPromptText('');
    setEditingPromptVersion('gpt-4o');
    setEditingPromptUsage('Optimierung');
    setEditingPromptTemperature('0.0');
    setEditingPromptMaxTokens('8000');
    setEditingPromptSystemRole('Du bist ein Experte für CV-Optimierung.');
    setEditingPromptName('');
    setOriginalPromptName(''); // Reset auch den ursprünglichen Namen
    setTestResult('');
  };

  // Handler für Prompt im Modal speichern
  const handleSavePromptInModal = async () => {
    console.log('🔧 handleSavePromptInModal aufgerufen');
    console.log('🔧 originalPromptName:', originalPromptName);
    console.log('🔧 editingPromptText:', editingPromptText);
    console.log('🔧 editingPromptName:', editingPromptName);
    
    if (!originalPromptName) {
      console.error('❌ originalPromptName ist nicht gesetzt');
      return;
    }
    
    try {
      if (!user) {
        console.error('❌ Kein User gefunden');
        return;
      }
      
      console.log('🔧 User gefunden:', user.uid);
      
      const idToken = await user.getIdToken();
      console.log('🔧 ID Token erhalten');
      
      // Sichere Identifikation des ursprünglichen Prompts über den ursprünglichen Namen
      const originalPrompt = prompts.find(p => p.type === originalPromptName);
      if (!originalPrompt) {
        console.error('❌ Ursprünglicher Prompt nicht gefunden für Namen:', originalPromptName);
        alert('Fehler: Ursprünglicher Prompt nicht gefunden');
        return;
      }
      
      const nameChanged = editingPromptName !== originalPromptName;
      
      console.log('🔧 Name geändert:', nameChanged);
      console.log('🔧 Original Name:', originalPrompt.type);
      console.log('🔧 Neuer Name:', editingPromptName);
      
      if (nameChanged) {
        // Prompt umbenennen: Altes löschen, neues erstellen
        console.log('🔄 Prompt wird umbenannt...');
        
        // 1. Neuen Prompt erstellen
        const createResponse = await fetch(`${config.backend.baseUrl}/api/prompts`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
          },
          body: JSON.stringify({
            promptType: editingPromptName,
            promptText: editingPromptText,
            chatGptVersion: editingPromptVersion,
            temperature: editingPromptTemperature,
            maxTokens: editingPromptMaxTokens,
            usage: editingPromptUsage
          })
        });
        
        if (createResponse.ok) {
          console.log('✅ Neuer Prompt erstellt');
          
          // 2. Alten Prompt löschen (nur wenn er existiert)
          try {
            const deleteResponse = await fetch(`${config.backend.baseUrl}/api/delete-prompt/${originalPromptName}`, {
              method: 'DELETE',
              headers: {
                'Authorization': `Bearer ${idToken}`,
                'Content-Type': 'application/json'
              }
            });
            
            if (deleteResponse.ok) {
              console.log('✅ Alter Prompt gelöscht');
            } else {
              const errorData = await deleteResponse.json();
              if (errorData.error && errorData.error.includes('existiert nicht')) {
                console.log('⚠️ Alter Prompt existierte nicht, überspringe Löschung');
              } else {
                console.error('❌ Fehler beim Löschen des alten Prompts:', errorData);
                // Trotzdem fortfahren, da der neue Prompt bereits erstellt wurde
              }
            }
          } catch (deleteError) {
            console.error('❌ Fehler beim Löschen des alten Prompts:', deleteError);
            // Trotzdem fortfahren, da der neue Prompt bereits erstellt wurde
          }
          
          // Local state aktualisieren
          setPrompts(prev => prev.map((prompt) => 
            prompt.type === originalPromptName ? { 
              ...prompt, 
              type: editingPromptName,
              text: editingPromptText, 
              chatGptVersion: editingPromptVersion, 
              usage: editingPromptUsage,
              temperature: editingPromptTemperature,
              maxTokens: editingPromptMaxTokens
            } : prompt
          ));
          
          // Prompt-Liste neu laden, damit Änderungen in der Tabelle sichtbar sind
          console.log('🔄 Lade Prompt-Liste neu nach Umbenennung...');
          await loadPromptsFromFirebase();
          console.log('✅ Prompt-Liste nach Umbenennung aktualisiert');
          
          // Modal schließen
          setPromptEditorOpen(false);
          setEditingPromptIndex(null);
          setEditingPromptText('');
          setEditingPromptVersion('gpt-4o');
          setEditingPromptTemperature('0.0');
          setEditingPromptMaxTokens('8000');
          setEditingPromptUsage('Optimierung');
          setEditingPromptSystemRole('Du bist ein Experte für CV-Optimierung.');
          setEditingPromptName('');
          setOriginalPromptName('');
          
          // Prompt erfolgreich umbenannt
        } else {
          const errorData = await createResponse.json();
          console.error('❌ Fehler beim Erstellen des neuen Prompts:', errorData);
          alert(`Fehler beim Erstellen des neuen Prompts: ${errorData.error}`);
        }
      } else {
        // Nur Inhalt aktualisieren (keine Umbenennung)
        console.log('🔄 Prompt-Inhalt wird aktualisiert...');
        
        const requestBody = {
          promptType: originalPromptName, // Verwende den ursprünglichen Namen
          promptText: editingPromptText,
          chatGptVersion: editingPromptVersion,
          usage: editingPromptUsage,
          temperature: editingPromptTemperature,
          maxTokens: editingPromptMaxTokens,
          systemRole: editingPromptSystemRole
        };
        
        console.log('🔧 Request Body:', requestBody);
        console.log('🔧 Backend URL:', `${config.backend.baseUrl}/api/prompts`);
        
        const response = await fetch(`${config.backend.baseUrl}/api/prompts`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
          },
          body: JSON.stringify(requestBody)
        });

        console.log('🔧 Response Status:', response.status);
        console.log('🔧 Response OK:', response.ok);

        if (response.ok) {
          const responseData = await response.json();
          console.log('✅ Prompt gespeichert:', originalPrompt.type, responseData);
          
          // Local state aktualisieren
          console.log('🔧 Aktualisiere Local State...');
          setPrompts(prev => prev.map((prompt) => 
            prompt.type === originalPromptName ? { 
              ...prompt, 
              text: editingPromptText, 
              chatGptVersion: editingPromptVersion, 
              usage: editingPromptUsage,
              temperature: editingPromptTemperature,
              maxTokens: editingPromptMaxTokens
            } : prompt
          ));
          console.log('✅ Local State aktualisiert');
          
          // Prompt-Liste neu laden, damit Änderungen in der Tabelle sichtbar sind
          console.log('🔄 Lade Prompt-Liste neu nach Speichern...');
          await loadPromptsFromFirebase();
          console.log('✅ Prompt-Liste nach Speichern aktualisiert');
          
          // Modal schließen
          setPromptEditorOpen(false);
          setEditingPromptIndex(null);
          setEditingPromptText('');
          setEditingPromptVersion('gpt-4o');
          setEditingPromptTemperature('0.0');
          setEditingPromptMaxTokens('8000');
          setEditingPromptUsage('Optimierung');
          setEditingPromptSystemRole('Du bist ein Experte für CV-Optimierung.');
          setEditingPromptName('');
          setOriginalPromptName('');
          
          // Prompt erfolgreich gespeichert
        } else {
          const errorText = await response.text();
          console.error('❌ Fehler beim Speichern des Prompts:', response.status, errorText);
          alert(`Fehler beim Speichern: ${response.status} - ${errorText}`);
        }
      }
    } catch (error) {
      console.error('❌ Fehler beim Speichern des Prompts:', error);
      const errorMessage = error instanceof Error ? error.message : 'Unbekannter Fehler';
      alert(`Fehler beim Speichern: ${errorMessage}`);
    }
  };

  // Handler für Prompt im Modal zurücksetzen
  const handleResetPromptInModal = () => {
    if (!originalPromptName) return;
    const originalPrompt = prompts.find(p => p.type === originalPromptName);
    if (!originalPrompt) return;
    
    setEditingPromptText(originalPrompt.originalText || originalPrompt.text);
    setEditingPromptVersion(originalPrompt.chatGptVersion || 'gpt-4o');
    setEditingPromptTemperature(originalPrompt.temperature || '0.0');
    setEditingPromptMaxTokens(originalPrompt.maxTokens || '8000');
    setEditingPromptSystemRole(originalPrompt.systemRole || 'Du bist ein Experte für CV-Optimierung.');
    setEditingPromptName(originalPrompt.type);
  };

  // Handler zum Ändern des Prompt-Namens
  const handlePromptNameChange = (newName: string) => {
    setEditingPromptName(newName);
  };

  // Handler zum Aktualisieren der Prompts aus Firebase
  const handleRefreshPrompts = async () => {
    try {
      console.log('🔄 Aktualisiere Prompts aus Firebase...');
      await loadPromptsFromFirebase();
              // Prompts erfolgreich aus Firebase aktualisiert
    } catch (error) {
      console.error('❌ Fehler beim Aktualisieren der Prompts:', error);
      alert('Fehler beim Aktualisieren der Prompts');
    }
  };

  // Handler zum Löschen eines Prompts
  const handleDeletePrompt = async () => {
    if (!originalPromptName || !user) return;
    
    // Verwende den ursprünglichen Namen für die Löschung
    const promptToDelete = prompts.find(p => p.type === originalPromptName);
    if (!promptToDelete) {
      console.error('❌ Prompt zum Löschen nicht gefunden');
      return;
    }
    
    const confirmed = window.confirm(`Möchten Sie den Prompt "${promptToDelete.type}" wirklich löschen?`);
    
    if (!confirmed) return;
    
    try {
      const idToken = await user.getIdToken();
      const response = await fetch(`${config.backend.baseUrl}/api/delete-prompt/${promptToDelete.type}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${idToken}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        console.log('✅ Prompt erfolgreich gelöscht:', promptToDelete.type);
        
        // Entferne den Prompt aus der lokalen Liste
        setPrompts(prev => prev.filter(prompt => prompt.type !== originalPromptName));
        
        // Schließe das Modal
        setEditingPromptIndex(null);
        setEditingPromptText('');
        setEditingPromptVersion('gpt-4o');
        setEditingPromptTemperature('0.0');
        setEditingPromptMaxTokens('8000');
        setEditingPromptUsage('Optimierung');
        setEditingPromptSystemRole('Du bist ein Experte für CV-Optimierung.');
        setEditingPromptName('');
        setOriginalPromptName(''); // Reset auch den ursprünglichen Namen
        setPromptEditorOpen(false);
        
        // Zeige Erfolgsmeldung
        // Prompt erfolgreich gelöscht
      } else {
        const errorData = await response.json();
        console.error('❌ Fehler beim Löschen des Prompts:', errorData);
        alert(`Fehler beim Löschen: ${errorData.error}`);
      }
    } catch (error) {
      console.error('❌ Fehler beim Löschen des Prompts:', error);
      alert('Fehler beim Löschen des Prompts');
    }
  };

  // Handler für expandierte Test-Bereiche


    // Handler für Zertifizierungen
  const handleCertificationOptimization = async (promptText: string, promptVersion: string, temperature: string, maxTokens: string) => {
    console.log('🏆 Starte Zertifizierungs-Optimierung...');
    
    try {
      setError(null);
      setOptimizing(true);
      
      // Prüfe ob User-Daten vorhanden sind
      if (!user) {
        setError('Benutzer nicht angemeldet.');
        setOptimizing(false);
        return;
      }

      // Für Zertifizierungs-Optimierung: Bereite nur Zertifizierungs-spezifische Daten vor
      const certificationData = {
        certifications: certifications || []
      };

      // Erstelle Zertifizierungs-spezifischen Text
      let certificationText = '';
      if (certifications && certifications.length > 0) {
        certificationText = certifications.map(cert => 
          `${cert.name || 'Kein Name'} - ${cert.issuer || 'Kein Aussteller'} (${cert.date || 'Kein Datum'})`
        ).join('\n');
      } else {
        certificationText = 'Keine Zertifizierungen im CV gefunden';
      }

      console.log('🏆 Zertifizierungs-Daten für Backend:', certificationData);
      console.log('🏆 Zertifizierungs-Text für Backend:', certificationText);

      // Hole ID Token für Backend-Authentifizierung
      const idToken = await user.getIdToken();

      // Sende Request an Backend für Zertifizierungs-Optimierung
      const optimizeResponse = await fetch(config.backend.optimizeCvJsonUrl, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({
          cvData: certificationData, // Nur Zertifizierungs-Daten
          cvText: certificationText, // Nur Zertifizierungs-Text
          jobDescription: jobDescription,
          optimizeType: 'certifications',
          targetLanguage: targetLanguage,
          // Test-spezifische Parameter
          testPrompt: promptText,
          chatGptVersion: promptVersion,
          temperature: temperature,
          maxTokens: maxTokens
        }),
      });
      
      if (!optimizeResponse.ok) throw new Error(t('error.optimize.cv'));
      const data = await optimizeResponse.json();
      
      // Backend-Antwort für Zertifizierungen verarbeitet
      
      // Setze die relevanten Zertifizierungen
      if (data.relevantCertifications) {
        let certificationArray;
        
        // Prüfe ob relevantCertifications ein String ist (JSON) oder bereits ein Array
        if (typeof data.relevantCertifications === 'string') {
          try {
            // Entferne Markdown-Code-Block-Formatierung falls vorhanden
            let cleanJsonString = data.relevantCertifications;
            if (cleanJsonString.includes('```json')) {
              cleanJsonString = cleanJsonString.replace(/```json\n?/g, '').replace(/```\n?/g, '');
              console.log('🔧 Markdown-Code-Block entfernt, bereinigter String:', cleanJsonString);
            }
            
            // Parse den bereinigten JSON-String zu einem Array
            certificationArray = JSON.parse(cleanJsonString);
            console.log('✅ JSON-String erfolgreich geparst zu Array:', certificationArray);
          } catch (parseError) {
            console.error('❌ Fehler beim Parsen des JSON-Strings:', parseError);
            setTestResult('Fehler beim Parsen der Zertifizierungs-Daten');
            return;
          }
        } else if (Array.isArray(data.relevantCertifications)) {
          // relevantCertifications ist bereits ein Array
          certificationArray = data.relevantCertifications;
          console.log('✅ relevantCertifications ist bereits ein Array:', certificationArray);
        } else {
          console.log('⚠️ relevantCertifications ist weder String noch Array:', typeof data.relevantCertifications);
          setTestResult('Unerwartetes Datenformat für Zertifizierungen');
          return;
        }
        
        // Prüfe ob das geparste Array gültig ist
        if (certificationArray && Array.isArray(certificationArray) && certificationArray.length > 0) {
          // Setze die Zertifizierungen im lokalen State
          setRelevantCertifications(certificationArray);
          console.log('✅ Relevante Zertifizierungen gesetzt:', certificationArray.length, 'Zertifizierungen');
          
          // Zeige nur die relevanten Zertifizierungen im Test-Modal an
          setTestResult(JSON.stringify(certificationArray, null, 2));
        } else {
          console.log('⚠️ Geparste Zertifizierungen sind leer oder ungültig:', certificationArray);
          setTestResult('Keine Zertifizierungen gefunden');
        }
      } else {
        // Keine relevantCertifications vorhanden
        console.log('⚠️ Keine relevantCertifications in der Backend-Antwort gefunden');
        setTestResult('Keine Zertifizierungen gefunden');
      }
      
      console.log('✅ Zertifizierungs-Optimierung erfolgreich abgeschlossen');
      
    } catch (err: any) {
      setError(t('error.optimize.cv.unknown') + (err.message || ''));
    } finally {
      setOptimizing(false);
    }
  };

  // Handler für Ausbildungen
  const handleEducationOptimization = async (promptText: string, promptVersion: string, temperature: string, maxTokens: string) => {
    console.log('🎓 Starte Ausbildungs-Optimierung...');
    
    try {
      setError(null);
      setOptimizing(true);
      
      // Prüfe ob User-Daten vorhanden sind
      if (!user) {
        setError('Benutzer nicht angemeldet.');
        setOptimizing(false);
        return;
      }

      // Für Ausbildungs-Optimierung: Bereite nur Ausbildungs-spezifische Daten vor
      const educationData = {
        education: educations || []
      };

      // Erstelle Ausbildungs-spezifischen Text
      let educationText = '';
      if (educations && educations.length > 0) {
        educationText = educations.map(edu => 
          `${edu.degree || 'Kein Abschluss'} an ${edu.institution || 'Keine Institution'} (${edu.startDate || 'Kein Start'} - ${edu.endDate || 'Kein Ende'})`
        ).join('\n');
      } else {
        educationText = 'Keine Ausbildungen im CV gefunden';
      }

      console.log('🎓 Ausbildungs-Daten für Backend:', educationData);
      console.log('🎓 Ausbildungs-Text für Backend:', educationText);

      // Hole ID Token für Backend-Authentifizierung
      const idToken = await user.getIdToken();

      // Sende Request an Backend für Ausbildungs-Optimierung
      const optimizeResponse = await fetch(config.backend.optimizeCvJsonUrl, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({
          cvData: educationData, // Nur Ausbildungs-Daten
          cvText: educationText, // Nur Ausbildungs-Text
          jobDescription: jobDescription,
          optimizeType: 'education',
          targetLanguage: targetLanguage,
          // Test-spezifische Parameter
          testPrompt: promptText,
          chatGptVersion: promptVersion,
          temperature: temperature,
          maxTokens: maxTokens
        }),
      });
      
      if (!optimizeResponse.ok) throw new Error(t('error.optimize.cv'));
      const data = await optimizeResponse.json();
      
      // Backend-Antwort für Ausbildungen verarbeitet
      
      // Setze die relevanten Ausbildungen
      if (data.relevantEducations) {
        let educationArray;
        
        // Prüfe ob relevantEducations ein String ist (JSON) oder bereits ein Array
        if (typeof data.relevantEducations === 'string') {
          try {
            // Entferne Markdown-Code-Block-Formatierung falls vorhanden
            let cleanJsonString = data.relevantEducations;
            if (cleanJsonString.includes('```json')) {
              cleanJsonString = cleanJsonString.replace(/```json\n?/g, '').replace(/```\n?/g, '');
              console.log('🔧 Markdown-Code-Block entfernt, bereinigter String:', cleanJsonString);
            }
            
            // Parse den bereinigten JSON-String zu einem Array
            educationArray = JSON.parse(cleanJsonString);
            console.log('✅ JSON-String erfolgreich geparst zu Array:', educationArray);
          } catch (parseError) {
            console.error('❌ Fehler beim Parsen des JSON-Strings:', parseError);
            setTestResult('Fehler beim Parsen der Ausbildungs-Daten');
            return;
          }
        } else if (Array.isArray(data.relevantEducations)) {
          // relevantEducations ist bereits ein Array
          educationArray = data.relevantEducations;
          console.log('✅ relevantEducations ist bereits ein Array:', educationArray);
        } else {
          console.log('⚠️ relevantEducations ist weder String noch Array:', typeof data.relevantEducations);
          setTestResult('Unerwartetes Datenformat für Ausbildungen');
          return;
        }
        
        // Prüfe ob das geparste Array gültig ist
        if (educationArray && Array.isArray(educationArray) && educationArray.length > 0) {
          // Setze die Ausbildungen im lokalen State
          setRelevantEducations(educationArray);
          console.log('✅ Relevante Ausbildungen gesetzt:', educationArray.length, 'Ausbildungen');
          
          // Zeige nur die relevanten Ausbildungen im Test-Modal an
          setTestResult(JSON.stringify(educationArray, null, 2));
        } else {
          console.log('⚠️ Geparste Ausbildungen sind leer oder ungültig:', educationArray);
          setTestResult('Keine Ausbildungen gefunden');
        }
      } else {
        // Keine relevantEducations vorhanden
        console.log('⚠️ Keine relevantEducations in der Backend-Antwort gefunden');
        setTestResult('Keine Ausbildungen gefunden');
      }
      
      console.log('✅ Ausbildungs-Optimierung erfolgreich abgeschlossen');
      
    } catch (err: any) {
      setError(t('error.optimize.cv.unknown') + (err.message || ''));
    } finally {
      setOptimizing(false);
    }
  };

  // Handler für Arbeitserfahrungen
  const handleWorkExperienceOptimization = async (promptText: string, promptVersion: string, temperature: string, maxTokens: string) => {
    console.log('💼 Starte Arbeitserfahrungs-Optimierung...');
    
    try {
      setError(null);
      setOptimizing(true);
      
      // Prüfe ob User-Daten vorhanden sind
      if (!user) {
        setError('Benutzer nicht angemeldet.');
        setOptimizing(false);
        return;
      }

      // Für Arbeitserfahrungs-Optimierung: Bereite nur Arbeitserfahrungs-spezifische Daten vor
      const workExperienceData = {
        workExperience: workExperiences || []
      };

      // Erstelle Arbeitserfahrungs-spezifischen Text
      let workExperienceText = '';
      if (workExperiences && workExperiences.length > 0) {
        workExperienceText = workExperiences.map(exp => 
          `${exp.position || 'Keine Position'} bei ${exp.company || 'Keine Firma'} (${exp.startDate || 'Kein Start'} - ${exp.endDate || 'Kein Ende'})\n${exp.description || 'Keine Beschreibung'}`
        ).join('\n\n');
      } else {
        workExperienceText = 'Keine Arbeitserfahrungen im CV gefunden';
      }

      console.log('💼 Arbeitserfahrungs-Daten für Backend:', workExperienceData);
      console.log('💼 Arbeitserfahrungs-Text für Backend:', workExperienceText);

      // Hole ID Token für Backend-Authentifizierung
      const idToken = await user.getIdToken();

      // Sende Request an Backend für Arbeitserfahrungs-Optimierung
      const optimizeResponse = await fetch(config.backend.optimizeCvJsonUrl, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({
          cvData: workExperienceData, // Nur Arbeitserfahrungs-Daten
          cvText: workExperienceText, // Nur Arbeitserfahrungs-Text
          jobDescription: jobDescription,
          optimizeType: 'workExperience',
          targetLanguage: targetLanguage,
          // Test-spezifische Parameter
          testPrompt: promptText,
          chatGptVersion: promptVersion,
          temperature: temperature,
          maxTokens: maxTokens
        }),
      });
      
      if (!optimizeResponse.ok) throw new Error(t('error.optimize.cv'));
      const data = await optimizeResponse.json();
      
      // Backend-Antwort für Arbeitserfahrungen verarbeitet
      // relevantWorkExperience verarbeitet
      
      // Setze die relevanten Arbeitserfahrungen
      if (data.relevantWorkExperience) {
        let workExperienceArray;
        
        // Prüfe ob relevantWorkExperience ein String ist (JSON) oder bereits ein Array
        if (typeof data.relevantWorkExperience === 'string') {
          try {
            // Entferne Markdown-Code-Block-Formatierung falls vorhanden
            let cleanJsonString = data.relevantWorkExperience;
            if (cleanJsonString.includes('```json')) {
              cleanJsonString = cleanJsonString.replace(/```json\n?/g, '').replace(/```\n?/g, '');
              console.log('🔧 Markdown-Code-Block entfernt, bereinigter String:', cleanJsonString);
            }
            
            // Parse den bereinigten JSON-String zu einem Array
            workExperienceArray = JSON.parse(cleanJsonString);
            console.log('✅ JSON-String erfolgreich geparst zu Array:', workExperienceArray);
          } catch (parseError) {
            console.error('❌ Fehler beim Parsen des JSON-Strings:', parseError);
            setTestResult('Fehler beim Parsen der Arbeitserfahrungs-Daten');
            return;
          }
        } else if (Array.isArray(data.relevantWorkExperience)) {
          // relevantWorkExperience ist bereits ein Array
          workExperienceArray = data.relevantWorkExperience;
          console.log('✅ relevantWorkExperience ist bereits ein Array:', workExperienceArray);
        } else {
          console.log('⚠️ relevantWorkExperience ist weder String noch Array:', typeof data.relevantWorkExperience);
          setTestResult('Unerwartetes Datenformat für Arbeitserfahrungen');
          return;
        }
        
        // Prüfe ob das geparste Array gültig ist
        if (workExperienceArray && Array.isArray(workExperienceArray) && workExperienceArray.length > 0) {
          // Setze die Arbeitserfahrungen im lokalen State
          setRelevantWorkExperiences(workExperienceArray);
          console.log('✅ Relevante Arbeitserfahrungen gesetzt:', workExperienceArray.length, 'Erfahrungen');
          
          // Zeige nur die relevanten Arbeitserfahrungen im Test-Modal an
          setTestResult(JSON.stringify(workExperienceArray, null, 2));
        } else {
          console.log('⚠️ Geparste Arbeitserfahrungen sind leer oder ungültig:', workExperienceArray);
          setTestResult('Keine Arbeitserfahrungen gefunden');
        }
      } else {
        // Keine relevantWorkExperience vorhanden
        console.log('⚠️ Keine relevantWorkExperience in der Backend-Antwort gefunden');
        setTestResult('Keine Arbeitserfahrungen gefunden');
      }
      
      console.log('✅ Arbeitserfahrungs-Optimierung erfolgreich abgeschlossen');
      
    } catch (err: any) {
      setError(t('error.optimize.cv.unknown') + (err.message || ''));
    } finally {
      setOptimizing(false);
    }
  };

  // Handler für Kurzprofil
  const handleShortProfileOptimization = async (promptText: string, promptVersion: string, temperature: string, maxTokens: string) => {
    console.log('👤 Starte Kurzprofil-Optimierung...');
    
    try {
      setError(null);
      setOptimizing(true);
      
      // Prüfe ob User-Daten vorhanden sind
      if (!user) {
        setError('Benutzer nicht angemeldet.');
        setOptimizing(false);
        return;
      }

      // Für Kurzprofil-Optimierung: Bereite alle CV-Daten vor (wie bereits implementiert)
      const personalInfo = getPersonalInfoForMotivation();
      
      // Erstelle CV-Text aus strukturierten Daten für die Optimierung (wie bereits implementiert)
      const createCvTextFromData = (data: any) => {
        let cvText = '';
        if (data.personalInfo?.fullName) cvText += `${getTranslatedCvLabel('Name:')} ${data.personalInfo.fullName}\n`;
        if (data.personalInfo?.address) cvText += `${getTranslatedCvLabel('Adresse:')} ${data.personalInfo.address}\n`;
        if (data.personalInfo?.postalCode) cvText += `${getTranslatedCvLabel('PLZ:')} ${data.personalInfo.postalCode}\n`;
        if (data.personalInfo?.city) cvText += `${getTranslatedCvLabel('Stadt:')} ${data.personalInfo.city}\n`;
        if (data.personalInfo?.country) cvText += `${getTranslatedCvLabel('Land:')} ${data.personalInfo.country}\n`;
        if (data.personalInfo?.availableFrom) cvText += `${getTranslatedCvLabel('Verfügbar ab:')} ${data.personalInfo.availableFrom}\n`;
        if (data.personalInfo?.phoneNumber) cvText += `${getTranslatedCvLabel('Telefon:')} ${data.personalInfo.phoneNumber}\n`;
        if (data.personalInfo?.email) cvText += `${getTranslatedCvLabel('Email:')} ${data.personalInfo.email}\n`;
        if (data.personalInfo?.birthYear) cvText += `${getTranslatedCvLabel('Geburtsjahr:')} ${data.personalInfo.birthYear}\n`;
        if (data.personalInfo?.nationality) cvText += `${getTranslatedCvLabel('Nationalität:')} ${data.personalInfo.nationality}\n`;
        if (data.personalInfo?.residencePermit) cvText += `${getTranslatedCvLabel('Aufenthaltsbewilligung:')} ${data.personalInfo.residencePermit}\n`;
        if (data.personalInfo?.civilStatus) cvText += `${getTranslatedCvLabel('Familienstand:')} ${data.personalInfo.civilStatus}\n`;
        if (data.personalInfo?.shortProfile) cvText += `${getTranslatedCvLabel('Profil:')} ${data.personalInfo.shortProfile}\n`;
        if (data.workExperience && data.workExperience.length > 0) {
          cvText += '\nArbeitserfahrung:\n';
          data.workExperience.forEach((exp: any) => {
            cvText += `${exp.position} bei ${exp.company} (${exp.startDate} - ${exp.endDate})\n`;
            cvText += `${exp.description}\n`;
          });
        }
        if (data.education && data.education.length > 0) {
          cvText += '\nAusbildung:\n';
          data.education.forEach((edu: any) => {
            cvText += `${edu.degree} an ${edu.institution} (${edu.startDate} - ${edu.endDate})\n`;
          });
        }
        if (data.itSkills && data.itSkills.length > 0) {
          cvText += '\nIT-Skills:\n';
          data.itSkills.forEach((skill: any) => {
            cvText += `${skill.skill} (${skill.level})\n`;
          });
        }
        if (data.languages && data.languages.length > 0) {
          cvText += '\nSprachen:\n';
          data.languages.forEach((lang: any) => {
            cvText += `${lang.language} (${lang.level})\n`;
          });
        }
        if (data.certifications && data.certifications.length > 0) {
          cvText += '\nZertifikate:\n';
          data.certifications.forEach((cert: any) => {
            cvText += `${cert.certification} - ${cert.issuer} (${cert.date})\n`;
          });
        }
        if (data.hobbies && data.hobbies.length > 0) {
          cvText += '\nHobbys:\n';
          data.hobbies.forEach((hobby: any) => {
            cvText += `${hobby.hobby}: ${hobby.description}\n`;
          });
        }
        if (data.additionalInfo && data.additionalInfo.length > 0) {
          cvText += '\nZusätzliche Informationen:\n';
          data.additionalInfo.forEach((info: any) => {
            cvText += `${info.info}: ${info.details}\n`;
          });
        }
        if (data.coreCompetencies && data.coreCompetencies.length > 0) {
          cvText += '\nKernkompetenzen:\n';
          data.coreCompetencies.forEach((comp: any) => {
            cvText += `${comp.competency}\n`;
          });
        }
        if (data.industryExperiences && data.industryExperiences.length > 0) {
          cvText += '\nBranchenerfahrungen:\n';
          data.industryExperiences.forEach((exp: any) => {
            cvText += `${exp.industry} (${exp.years} Jahre)\n`;
          });
        }
        return cvText;
      };

      // Erstelle strukturierte CV-Daten aus den bereits geladenen Tabellendaten
      const cvData = {
        personalInfo: {
          fullName: personalInfo.fullName || '',
          address: personalInfo.address || '',
          postalCode: personalInfo.postalCode || '',
          city: personalInfo.city || '',
          country: personalInfo.country || '',
          availableFrom: personalInfo.availableFrom || '',
          phoneNumber: personalInfo.phoneNumber || '',
          email: personalInfo.email || '',
          birthYear: birthYear || '',
          nationality: nationality || '',
          residencePermit: residencePermit || '',
          civilStatus: civilStatus || '',
          shortProfile: shortProfile || ''
        },
        workExperience: workExperiences || [],
        education: educations || [],
        certifications: certifications || [],
        languages: languages || [],
        itSkills: itSkills || [],
        coreCompetencies: coreCompetencies || [],
        industryExperiences: industryExperiences || [],
        hobbies: hobbies || [],
        additionalInfo: additionalInfo || []
      };

      // Erstelle den kompletten CV-Text (wie bereits implementiert)
      const cvText = createCvTextFromData(cvData);
      
      console.log('👤 CV-Daten für Backend:', cvData);
      console.log('👤 CV-Text für Backend:', cvText.substring(0, 200) + '...');

      // Hole ID Token für Backend-Authentifizierung
      const idToken = await user.getIdToken();

      // Sende Request an Backend für Kurzprofil-Optimierung
      const optimizeResponse = await fetch(config.backend.optimizeCvJsonUrl, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({
          cvData: cvData, // Alle CV-Daten (wie bereits implementiert)
          cvText: cvText, // Kompletter CV-Text (wie bereits implementiert)
          jobDescription: jobDescription,
          optimizeType: 'shortProfile',
          targetLanguage: targetLanguage
          // Backend holt Parameter (promptText, promptVersion, temperature, maxTokens) direkt aus Firebase
        }),
      });
      
      if (!optimizeResponse.ok) throw new Error(t('error.optimize.cv'));
      const data = await optimizeResponse.json();
      
      // Backend-Antwort für Kurzprofil verarbeitet
      
      // Setze das optimierte Kurzprofil
      if (data.optimizedShortProfile) {
        setOptimizedShortProfile(data.optimizedShortProfile);
        console.log('✅ Optimiertes Kurzprofil gesetzt:', data.optimizedShortProfile.substring(0, 100) + '...');
        
        // Zeige das optimierte Kurzprofil im Test-Modal an
        setTestResult(data.optimizedShortProfile);
      } else {
        console.log('❌ Kein optimiertes Kurzprofil in Response');
        setTestResult('Kein optimiertes Kurzprofil gefunden');
      }
      
      console.log('✅ Kurzprofil-Optimierung erfolgreich abgeschlossen');
      
    } catch (err: any) {
      setError(t('error.optimize.cv.unknown') + (err.message || ''));
    } finally {
      setOptimizing(false);
    }
  };

  // Handler für Branchen
  const handleIndustryOptimization = async (promptText: string, promptVersion: string, temperature: string, maxTokens: string) => {
    console.log('🏢 Starte Branchen-Optimierung...');
    
    try {
      setError(null);
      setOptimizing(true);
      
      // Prüfe ob User-Daten vorhanden sind
      if (!user) {
        setError('Benutzer nicht angemeldet.');
        setOptimizing(false);
        return;
      }

      // Für Branchen-Optimierung: Bereite nur Branchen-spezifische Daten vor
      const industryData = {
        industryExperiences: industryExperiences || []
      };

      // Erstelle Branchen-spezifischen Text
      let industryText = '';
      if (industryExperiences && industryExperiences.length > 0) {
        industryText = industryExperiences.map(exp => 
          `${exp.industry || 'Keine Branche'} (${exp.years || 'Keine Jahre'} Jahre)`
        ).join('\n');
      } else {
        industryText = 'Keine Branchen-Erfahrungen im CV gefunden';
      }

      console.log('🏢 Branchen-Daten für Backend:', industryData);
      console.log('🏢 Branchen-Text für Backend:', industryText);

      // Hole ID Token für Backend-Authentifizierung
      const idToken = await user.getIdToken();

      // Sende Request an Backend für Branchen-Optimierung
      const optimizeResponse = await fetch(config.backend.optimizeCvJsonUrl, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({
          cvData: industryData, // Nur Branchen-Daten
          cvText: industryText, // Nur Branchen-Text
          jobDescription: jobDescription,
          optimizeType: 'industry',
          targetLanguage: targetLanguage,
          // Test-spezifische Parameter
          testPrompt: promptText,
          chatGptVersion: promptVersion,
          temperature: temperature,
          maxTokens: maxTokens
        }),
      });
      
      if (!optimizeResponse.ok) throw new Error(t('error.optimize.cv'));
      const data = await optimizeResponse.json();
      
      // Backend-Antwort für Branchen verarbeitet
      
      // Setze die relevanten Branchen
      if (data.relevantIndustries) {
        let industryArray;
        
        // Prüfe ob relevantIndustries ein String ist (JSON) oder bereits ein Array
        if (typeof data.relevantIndustries === 'string') {
          try {
            // Entferne Markdown-Code-Block-Formatierung falls vorhanden
            let cleanJsonString = data.relevantIndustries;
            if (cleanJsonString.includes('```json')) {
              cleanJsonString = cleanJsonString.replace(/```json\n?/g, '').replace(/```\n?/g, '');
              console.log('🔧 Markdown-Code-Block entfernt, bereinigter String:', cleanJsonString);
            }
            
            // Parse den bereinigten JSON-String zu einem Array
            industryArray = JSON.parse(cleanJsonString);
            console.log('✅ JSON-String erfolgreich geparst zu Array:', industryArray);
          } catch (parseError) {
            console.error('❌ Fehler beim Parsen des JSON-Strings:', parseError);
            setTestResult('Fehler beim Parsen der Branchen-Daten');
            return;
          }
        } else if (Array.isArray(data.relevantIndustries)) {
          // relevantIndustries ist bereits ein Array
          industryArray = data.relevantIndustries;
          console.log('✅ relevantIndustries ist bereits ein Array:', industryArray);
        } else {
          console.log('⚠️ relevantIndustries ist weder String noch Array:', typeof data.relevantIndustries);
          setTestResult('Unerwartetes Datenformat für Branchen');
          return;
        }
        
        // Prüfe ob das geparste Array gültig ist
        if (industryArray && Array.isArray(industryArray) && industryArray.length > 0) {
          // Setze die Branchen im lokalen State
          setRelevantIndustries(industryArray);
          console.log('✅ Relevante Branchen gesetzt:', industryArray.length, 'Branchen');
          
          // Zeige nur die relevanten Branchen im Test-Modal an
          setTestResult(JSON.stringify(industryArray, null, 2));
        } else {
          console.log('⚠️ Geparste Branchen sind leer oder ungültig:', industryArray);
          setTestResult('Keine Branchen gefunden');
        }
      } else {
        // Keine relevantIndustries vorhanden
        console.log('⚠️ Keine relevantIndustries in der Backend-Antwort gefunden');
        setTestResult('Keine Branchen gefunden');
      }
      
      console.log('✅ Branchen-Optimierung erfolgreich abgeschlossen');
      
    } catch (err: any) {
      setError(t('error.optimize.cv.unknown') + (err.message || ''));
    } finally {
      setOptimizing(false);
    }
  };

  // Handler für weitere Informationen
  const handleAdditionalInfoOptimization = async (promptText: string, promptVersion: string, temperature: string, maxTokens: string) => {
    console.log('ℹ️ Starte Weitere-Angaben-Optimierung...');
    
    try {
      setError(null);
      setOptimizing(true);
      
      // Prüfe ob User-Daten vorhanden sind
      if (!user) {
        setError('Benutzer nicht angemeldet.');
        setOptimizing(false);
        return;
      }

      // Für Weitere-Angaben-Optimierung: Bereite nur Weitere-Angaben-spezifische Daten vor
      const additionalInfoData = {
        additionalInfo: additionalInfo || []
      };

      // Erstelle Weitere-Angaben-spezifischen Text
      let additionalInfoText = '';
      if (additionalInfo && additionalInfo.length > 0) {
        additionalInfoText = additionalInfo.map(info => {
          // Verwende nur Details wenn sie vorhanden und nicht leer sind
          if (info.details && info.details.trim() !== '' && info.details !== 'Keine Details') {
            return `${info.info || 'Keine Info'}: ${info.details}`;
          } else {
            // Nur die Info ohne Details verwenden
            return info.info || 'Keine Info';
          }
        }).join('\n');
      } else {
        additionalInfoText = 'Keine weiteren Angaben im CV gefunden';
      }

      console.log('ℹ️ Weitere-Angaben-Daten für Backend:', additionalInfoData);
      console.log('ℹ️ Weitere-Angaben-Text für Backend:', additionalInfoText);

      // Hole ID Token für Backend-Authentifizierung
      const idToken = await user.getIdToken();

      // Sende Request an Backend für Weitere-Angaben-Optimierung
      const optimizeResponse = await fetch(config.backend.optimizeCvJsonUrl, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({
          cvData: additionalInfoData, // Nur Weitere-Angaben-Daten
          cvText: additionalInfoText, // Nur Weitere-Angaben-Text
          jobDescription: jobDescription,
          optimizeType: 'additionalInfo',
          targetLanguage: targetLanguage,
          // Test-spezifische Parameter
          testPrompt: promptText,
          chatGptVersion: promptVersion,
          temperature: temperature,
          maxTokens: maxTokens
        }),
      });
      
      if (!optimizeResponse.ok) throw new Error(t('error.optimize.cv'));
      const data = await optimizeResponse.json();
      
      // Backend-Antwort für weitere Angaben verarbeitet
      
      // Setze die relevanten Weitere-Angaben
      if (data.relevantAdditionalInfo) {
        let additionalInfoArray;
        
        // Prüfe ob relevantAdditionalInfo ein String ist (JSON) oder bereits ein Array
        if (typeof data.relevantAdditionalInfo === 'string') {
          try {
            // Entferne Markdown-Code-Block-Formatierung falls vorhanden
            let cleanJsonString = data.relevantAdditionalInfo;
            if (cleanJsonString.includes('```json')) {
              cleanJsonString = cleanJsonString.replace(/```json\n?/g, '').replace(/```\n?/g, '');
              console.log('🔧 Markdown-Code-Block entfernt, bereinigter String:', cleanJsonString);
            }
            
            // Parse den bereinigten JSON-String zu einem Array
            additionalInfoArray = JSON.parse(cleanJsonString);
            console.log('✅ JSON-String erfolgreich geparst zu Array:', additionalInfoArray);
          } catch (parseError) {
            console.error('❌ Fehler beim Parsen des JSON-Strings:', parseError);
            setTestResult('Fehler beim Parsen der Weitere-Angaben-Daten');
            return;
          }
        } else if (Array.isArray(data.relevantAdditionalInfo)) {
          // relevantAdditionalInfo ist bereits ein Array
          additionalInfoArray = data.relevantAdditionalInfo;
          console.log('✅ relevantAdditionalInfo ist bereits ein Array:', additionalInfoArray);
        } else {
          console.log('⚠️ relevantAdditionalInfo ist weder String noch Array:', typeof data.relevantAdditionalInfo);
          setTestResult('Unerwartetes Datenformat für Weitere-Angaben');
          return;
        }
        
        // Prüfe ob das geparste Array gültig ist
        if (additionalInfoArray && Array.isArray(additionalInfoArray) && additionalInfoArray.length > 0) {
          // Setze die Weitere-Angaben im lokalen State
          setRelevantAdditionalInfo(additionalInfoArray);
          console.log('✅ Relevante Weitere-Angaben gesetzt:', additionalInfoArray.length, 'Einträge');
          
          // Zeige nur die relevanten Weitere-Angaben im Test-Modal an
          setTestResult(JSON.stringify(additionalInfoArray, null, 2));
        } else {
          console.log('⚠️ Geparste Weitere-Angaben sind leer oder ungültig:', additionalInfoArray);
          setTestResult('Keine Weitere-Angaben gefunden');
        }
      } else {
        // Keine relevantAdditionalInfo vorhanden
        console.log('⚠️ Keine relevantAdditionalInfo in der Backend-Antwort gefunden');
        setTestResult('Keine Weitere-Angaben gefunden');
      }
      
      console.log('✅ Weitere-Angaben-Optimierung erfolgreich abgeschlossen');
      
    } catch (err: any) {
      setError(t('error.optimize.cv.unknown') + (err.message || ''));
    } finally {
      setOptimizing(false);
    }
  };

  // Handler für Motivationsschreiben
  const handleMotivationLetterOptimization = async (promptText: string, promptVersion: string, temperature: string, maxTokens: string) => {
    console.log('✍️ Führe Motivationsschreiben-Optimierung durch...');
    await handleOptimizeCv(true, 'motivationLetter', promptText, promptVersion, temperature, maxTokens);
  };

  // Handler für Passgenauigkeit
  const handleMatchingOptimization = async (promptText: string, promptVersion: string, temperature: string, maxTokens: string) => {
    console.log('🎯 Führe Passgenauigkeit-Analyse durch...');

    await handleOptimizeCv(true, 'match', promptText, promptVersion, temperature, maxTokens);
  };

  // Handler für Spracherkennung
  const handleLanguageDetection = async (promptText: string, promptVersion: string, temperature: string, maxTokens: string) => {
    console.log('🔍 Führe Spracherkennung durch...');
    
    try {
      // Verwende den aktuellen Job-Description-Text für die Spracherkennung
      const textToAnalyze = jobDescription || 'Kein Text zur Analyse verfügbar';
      
      const user = auth.currentUser;
      if (!user) {
        throw new Error('Benutzer nicht angemeldet');
      }
      
      const idToken = await user.getIdToken();
      
      // Rufe den Spracherkennungs-Endpoint auf
      const response = await fetch(`${config.backend.baseUrl}/api/detect-language`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({
          text: textToAnalyze,
          prompt: promptText,
          version: promptVersion,
          temperature: temperature,
          maxTokens: maxTokens
        })
      });
      
      if (response.ok) {
        const result = await response.json();
        console.log('✅ Spracherkennung erfolgreich:', result);
        
        // Zeige das Ergebnis im Test-Modal an
        setTestResult(JSON.stringify(result, null, 2));
      } else {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
    } catch (error) {
      console.error('❌ Fehler bei der Spracherkennung:', error);
      setTestResult(`Fehler: ${error instanceof Error ? error.message : 'Unbekannter Fehler'}`);
    }
  };

  // Handler für einzelne Prompt-Tests - VERWENDET PRODUKTIVEN HANDLER
  const handleTestSinglePrompt = async (promptText: string, promptType: string, promptVersion: string, temperature: string, maxTokens: string) => {
    console.log('🧪 Teste einzelnen Prompt (verwende produktiven Handler):', promptType);
    
    try {
      setIsTesting(true);
      setTestResult('');
      
      // SCHRITT 1: Prompt zuerst in Firebase speichern
      console.log('💾 Speichere Prompt zuerst in Firebase...');
      const user = auth.currentUser;
      if (!user) {
        throw new Error('Benutzer nicht angemeldet');
      }
      
      const idToken = await user.getIdToken();
      
      // Speichere den aktuellen Prompt
      const savePromptResponse = await fetch(`${config.backend.baseUrl}/api/prompts`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({
          promptType: promptType,
          promptText: promptText,
          chatGptVersion: promptVersion,
          usage: editingPromptUsage, // Verwende die aktuelle usage statt hartcodierter 'Optimierung'
          temperature: temperature,
          maxTokens: maxTokens,
          systemRole: editingPromptSystemRole
        })
      });
      
      if (!savePromptResponse.ok) {
        throw new Error(`Fehler beim Speichern des Prompts: ${savePromptResponse.statusText}`);
      }
      
      console.log('✅ Prompt erfolgreich in Firebase gespeichert');
      
      // SCHRITT 1.5: Prompt-Liste neu laden, damit Änderungen in der Tabelle sichtbar sind
      console.log('🔄 Lade Prompt-Liste neu...');
      await loadPromptsFromFirebase();
      console.log('✅ Prompt-Liste aktualisiert');
      
      // SCHRITT 2: Rufe die entsprechende spezifische Optimierungsfunktion auf
      console.log('🚀 Rufe spezifische Optimierungsfunktion auf...');
      console.log('🔍 Prompt-Typ für Switch:', JSON.stringify(promptType));
      console.log('🔍 Prompt-Typ Länge:', promptType?.length);
      console.log('🔍 Prompt-Typ Vergleich mit "Hobbys-Optimierung":', promptType === 'Hobbys-Optimierung');
      console.log('🔍 Prompt-Typ Vergleich mit "Weitere-Angaben":', promptType === 'Weitere-Angaben');
      console.log('🔍 Prompt-Typ Zeichen-für-Zeichen:', Array.from(promptType || '').map(c => c.charCodeAt(0)));
      
      switch (promptType) {
        case 'Hobbys':
          await handleHobbyOptimization(promptText, promptVersion, temperature, maxTokens);
          break;
          
        case 'IT-Skills':
          await handleItSkillsOptimization(promptText, promptVersion, temperature, maxTokens);
          break;
          
        case 'Kernkompetenzen':
          await handleCoreCompetenciesOptimization(promptText, promptVersion, temperature, maxTokens);
          break;
          
        case 'Zertifizierungen':
          await handleCertificationOptimization(promptText, promptVersion, temperature, maxTokens);
          break;
          
        case 'Ausbildung':
          console.log('🎓 Ausführung: Ausbildungs-Optimierung gefunden!');
          await handleEducationOptimization(promptText, promptVersion, temperature, maxTokens);
          break;
          
        case 'Arbeitserfahrungen':
        case 'Berufserfahrung':
          console.log('💼 Ausführung: Berufserfahrung-Optimierung gefunden!');
          await handleWorkExperienceOptimization(promptText, promptVersion, temperature, maxTokens);
          break;
          
        case 'Relevante Sprachen':
        case 'Sprachen':
          await handleLanguageOptimization(promptText, promptVersion, temperature, maxTokens);
          break;
          
                 case 'Branchen':
           await handleIndustryOptimization(promptText, promptVersion, temperature, maxTokens);
           break;
          
        case 'Weitere Informationen':
        case 'Weitere-Angaben-Extraktion':
        case 'Weitere-Angaben':
          console.log('ℹ️ Ausführung: Weitere-Angaben-Optimierung gefunden!');
          await handleAdditionalInfoOptimization(promptText, promptVersion, temperature, maxTokens);
          break;
          
        case 'Motivationsschreiben':
          await handleMotivationLetterOptimization(promptText, promptVersion, temperature, maxTokens);
          break;
          
        case 'Passgenauigkeit':
          await handleMatchingOptimization(promptText, promptVersion, temperature, maxTokens);
          break;
          
        case 'Spracherkennung':
          await handleLanguageDetection(promptText, promptVersion, temperature, maxTokens);
          break;
          
        case 'Kurzprofil':
          console.log('👤 Ausführung: Kurzprofil-Optimierung gefunden!');
          await handleShortProfileOptimization(promptText, promptVersion, temperature, maxTokens);
          break;
          
        default:
          console.log('⚠️ Unbekannter Prompt-Typ, verwende allgemeinen Handler');
          await handleOptimizeCv(true, promptType, promptText, promptVersion, temperature, maxTokens);
      }
      
      console.log('✅ Prompt-Test erfolgreich abgeschlossen');
      
    } catch (error) {
      console.error('❌ Fehler beim Prompt-Test:', error);
      const errorMessage = error instanceof Error ? error.message : 'Unbekannter Fehler';
      setTestResult(`Fehler: ${errorMessage}`);
    } finally {
      setIsTesting(false);
    }
  };








  // Hilfsfunktion zum Normalisieren der Design-Einstellungen
  // Stellt sicher, dass alle erforderlichen Felder vorhanden sind
  const normalizeDesignSettings = (designSettings: any): any => {
    if (!designSettings) {
      return getCurrentCvDesignSettings();
    }
    
    // Wenn die Design-Einstellungen vollständig sind (haben selectedTemplate und templateName),
    // verwende sie direkt ohne State-Werte zu verwenden
    // Dies ist wichtig, wenn die State-Werte nach App-Start noch nicht aktualisiert wurden
    if (designSettings.selectedTemplate && designSettings.templateName) {
      // Design-Einstellungen sind vollständig normalisiert, verwende sie direkt
      return designSettings;
    }
    
    // Wenn die Design-Einstellungen nicht vollständig sind, ergänze fehlende Felder
    // WICHTIG: Verwende die übergebenen Settings als Basis, nicht die State-Werte
    // Nur für fehlende Felder verwende State-Werte als Fallback
    const currentSettings = getCurrentCvDesignSettings();
    
    // Bestimme Template-ID aus den übergebenen Settings oder State
    const templateId = designSettings.selectedTemplate || designSettings.selectedTemplateId || currentSettings.selectedTemplate || 'template1';
    const isProfessional = templateId === 'template2';
    
    // Erstelle normalisierte Settings mit übergebenen Settings als Basis
    return {
      // Verwende übergebene Settings als Basis
      ...designSettings,
      // Ergänze nur fehlende Felder mit Template-spezifischen Defaults oder State-Werten
      selectedTemplate: designSettings.selectedTemplate || designSettings.selectedTemplateId || templateId,
      selectedTemplateId: designSettings.selectedTemplateId || designSettings.selectedTemplate || templateId,
      templateName: designSettings.templateName || (templateId === 'template1' ? getTranslatedCvLabel('Modern') : 
                   templateId === 'template2' ? getTranslatedCvLabel('Professional') : getTranslatedCvLabel('Classic')),
      // Ergänze nur fehlende Farben mit Template-spezifischen Defaults
      leftColumnColor: designSettings.leftColumnColor || (isProfessional ? 'rgba(46,46,46,1)' : 'rgba(248,246,242,1)'),
      topBoxColor: designSettings.topBoxColor || (isProfessional ? 'rgba(46,46,46,1)' : 'rgba(248,246,242,1)'),
      nameTextColor: designSettings.nameTextColor || '#333333',
      leftColumnTextColor: designSettings.leftColumnTextColor || (isProfessional ? '#ffffff' : '#333333'),
      rightColumnTextColor: designSettings.rightColumnTextColor || '#333333',
      leftColumnTitleColor: designSettings.leftColumnTitleColor || (isProfessional ? '#ffffff' : '#333333'),
      rightColumnTitleColor: designSettings.rightColumnTitleColor || '#333333',
      // Ergänze nur fehlende andere Felder mit State-Werten als Fallback
      topBoxAlpha: designSettings.topBoxAlpha !== undefined ? designSettings.topBoxAlpha : (currentSettings.topBoxAlpha !== undefined ? currentSettings.topBoxAlpha : 0),
      topBoxImage: designSettings.topBoxImage || currentSettings.topBoxImage || '',
      leftColumnImage: designSettings.leftColumnImage || currentSettings.leftColumnImage || '',
      showCoreCompetenciesInCv: designSettings.showCoreCompetenciesInCv !== undefined ? designSettings.showCoreCompetenciesInCv : (currentSettings.showCoreCompetenciesInCv !== undefined ? currentSettings.showCoreCompetenciesInCv : true),
      showCertificationsInCv: designSettings.showCertificationsInCv !== undefined ? designSettings.showCertificationsInCv : (currentSettings.showCertificationsInCv !== undefined ? currentSettings.showCertificationsInCv : true),
      showItSkillsInCv: designSettings.showItSkillsInCv !== undefined ? designSettings.showItSkillsInCv : (currentSettings.showItSkillsInCv !== undefined ? currentSettings.showItSkillsInCv : true),
      showIndustriesInCv: designSettings.showIndustriesInCv !== undefined ? designSettings.showIndustriesInCv : (currentSettings.showIndustriesInCv !== undefined ? currentSettings.showIndustriesInCv : true),
      showLanguagesInCv: designSettings.showLanguagesInCv !== undefined ? designSettings.showLanguagesInCv : (currentSettings.showLanguagesInCv !== undefined ? currentSettings.showLanguagesInCv : true),
      showHobbiesInCv: designSettings.showHobbiesInCv !== undefined ? designSettings.showHobbiesInCv : (currentSettings.showHobbiesInCv !== undefined ? currentSettings.showHobbiesInCv : true),
      showEducationInCv: designSettings.showEducationInCv !== undefined ? designSettings.showEducationInCv : (currentSettings.showEducationInCv !== undefined ? currentSettings.showEducationInCv : true),
      showWorkExperienceInCv: designSettings.showWorkExperienceInCv !== undefined ? designSettings.showWorkExperienceInCv : (currentSettings.showWorkExperienceInCv !== undefined ? currentSettings.showWorkExperienceInCv : true),
      showProfileInCv: designSettings.showProfileInCv !== undefined ? designSettings.showProfileInCv : (currentSettings.showProfileInCv !== undefined ? currentSettings.showProfileInCv : true),
      showAdditionalInfoInCv: designSettings.showAdditionalInfoInCv !== undefined ? designSettings.showAdditionalInfoInCv : (currentSettings.showAdditionalInfoInCv !== undefined ? currentSettings.showAdditionalInfoInCv : true),
      showProfileImageInCv: designSettings.showProfileImageInCv !== undefined ? designSettings.showProfileImageInCv : (currentSettings.showProfileImageInCv !== undefined ? currentSettings.showProfileImageInCv : true),
      profileImageBorderRadius: designSettings.profileImageBorderRadius !== undefined ? designSettings.profileImageBorderRadius : (currentSettings.profileImageBorderRadius !== undefined ? currentSettings.profileImageBorderRadius : (isProfessional ? 0 : 50)),
      profileImageSize: designSettings.profileImageSize || currentSettings.profileImageSize || 'M',
      profileImageWidth: designSettings.profileImageWidth || currentSettings.profileImageWidth || 100,
      profileImagePosition: designSettings.profileImagePosition || currentSettings.profileImagePosition || { x: 50, y: 50 },
      profileImageAlignment: designSettings.profileImageAlignment || currentSettings.profileImageAlignment || (isProfessional ? 'left' : 'center'),
      profileImageBorder: designSettings.profileImageBorder !== undefined ? designSettings.profileImageBorder : (currentSettings.profileImageBorder !== undefined ? currentSettings.profileImageBorder : false),
      profileImageBorderColor: designSettings.profileImageBorderColor || currentSettings.profileImageBorderColor || '#333333',
      profileImageBorderThickness: designSettings.profileImageBorderThickness || currentSettings.profileImageBorderThickness || 2,
      nameFontSize: designSettings.nameFontSize || currentSettings.nameFontSize || 36,
      contactDisplayMode: designSettings.contactDisplayMode || currentSettings.contactDisplayMode || 'text',
    };
  };

  // CV-Daten für Template vorbereiten
  // Optional: designSettings können übergeben werden, um die State-Variablen zu überschreiben
  const getCvDataForTemplate = (designSettingsOverride?: any) => {
    // Normalisiere die Design-Einstellungen, damit alle erforderlichen Felder vorhanden sind
    const designSettings = normalizeDesignSettings(designSettingsOverride);
    
    return {
      personalInfo: {
        fullName: optimizedFullName || fullName,
        shortProfile: optimizedShortProfile || '', // Verwende ausschließlich optimiertes Kurzprofil - keine Fallbacks
        email: optimizedEmail || email,
        phoneNumber: optimizedPhoneNumber || phoneNumber,
        address: optimizedAddress || address,
        postalCode: optimizedPostalCode || postalCode,
        city: optimizedCity || city,
        location: `${optimizedAddress || address}, ${optimizedPostalCode || postalCode} ${optimizedCity || city}`,
        birthYear: birthYear, // Jahrgang für CV Classic Template
        nationality: nationality, // Nationalität für CV Classic Template
        maritalStatus: civilStatus, // Zivilstand für CV Classic Template
        availableFrom: availableFrom // Verfügbar ab für CV Classic Template
      },
      // Verwende ausschließlich relevante IT-Skills - keine Fallbacks
      itSkills: relevantItSkills || [],
      relevantItSkills: relevantItSkills || [],
      workExperience: (relevantWorkExperiences && relevantWorkExperiences.length > 0) 
        ? relevantWorkExperiences.map(exp => ({
            position: exp.position,
            company: exp.company,
            startDate: exp.startDate,
            endDate: exp.endDate,
            description: exp.description
          }))
        : workExperiences.map(exp => ({
            position: exp.position,
            company: exp.company,
            startDate: exp.startDate,
            endDate: exp.endDate,
            description: exp.description
          })), // Verwende relevante Arbeitserfahrungen falls verfügbar, sonst ursprüngliche
      // Verwende ausschließlich relevante Ausbildungen - keine Fallbacks
      educations: (relevantEducations || []).map(edu => ({
        degree: edu.degree,
        institution: edu.institution,
        startDate: edu.startDate,
        endDate: edu.endDate
      })),
      // Verwende relevante Ausbildungen für das Template
      relevantEducations: (relevantEducations || []).map(edu => ({
        degree: edu.degree,
        institution: edu.institution,
        startDate: edu.startDate,
        endDate: edu.endDate
      })),
      // Verwende relevante Zertifizierungen falls verfügbar, sonst normale Zertifizierungen
      // Verwende ausschließlich relevante Zertifikate - keine Fallbacks
      certifications: relevantCertifications || [],
      // Relevante Zertifizierungen als separates Feld (für CV-Share-Funktionalität)
      relevantCertifications: relevantCertifications || [],
      // Verwende ausschließlich relevante Sprachen - keine Fallbacks
      languages: (relevantLanguages || []).map(lang => ({
        language: lang.language,
        level: lang.level
      })),
      relevantLanguages: (relevantLanguages || []).map(lang => ({
        language: lang.language,
        level: lang.level
      })),
      // Verwende ausschließlich relevante Kernkompetenzen - keine Fallbacks
      coreCompetencies: (relevantCoreCompetencies || []).map(comp => ({
        competency: comp.competency
      })),
      // Relevante Kernkompetenzen als separates Feld (für CV-Share-Funktionalität)
      relevantCoreCompetencies: relevantCoreCompetencies || [],
      // Verwende ausschließlich relevante Branchen - keine Fallbacks
      industryExperiences: (relevantIndustries || []).map(exp => ({
        industry: exp.industry,
        years: exp.years
      })),
      // Verwende relevante Branchen für das Template
      relevantIndustries: (relevantIndustries || []).map(exp => ({
        industry: exp.industry,
        years: exp.years
      })),
      // Verwende ausschließlich relevante Hobbys - keine Fallbacks
      hobbies: relevantHobbies || [],
      // Verwende relevante Hobbys für das Template
      relevantHobbies: relevantHobbies || [],
      // Verwende ausschließlich relevante weitere Informationen - keine Fallbacks
      additionalInfo: relevantAdditionalInfo || [],
      // Verwende relevante weitere Informationen für das Template
      relevantAdditionalInfo: relevantAdditionalInfo || [],
      // Optimierte weitere Informationen für Classic Template
      additionalInfoOptimized: relevantAdditionalInfo || [],
      // Optimierte Berufserfahrungen für das Template (mit relevant-Feld)
      optimizedWorkExperiences: optimizedWorkExperiences || [],
      // Optimiertes Kurzprofil als separates Feld (für CV-Share-Funktionalität)
      optimizedShortProfile: optimizedShortProfile || '',
      profileImage,
      signature,
      // Design-Settings - verwende übergebene Einstellungen oder aktuelle State-Werte
      designSettings: designSettings
    };
  };

  // Persönliche Daten für Motivationsschreiben-Template vorbereiten
  const getPersonalInfoForMotivation = () => {
    return {
      fullName: optimizedFullName || fullName || '',
      address: optimizedAddress || address || '',
      postalCode: optimizedPostalCode || postalCode || '',
      city: optimizedCity || city || '',
      country: country || '',
      availableFrom: availableFrom || '',
      phoneNumber: optimizedPhoneNumber || phoneNumber || '',
      email: optimizedEmail || email || ''
    };
  };

  // Prompts beim Start laden
  React.useEffect(() => {
    if (user) {
      loadPromptsFromFirebase();
    } else {
     // Keine Fallback-Prompts - nur Firebase-Prompts verwenden
     setPrompts([]);
    }
  }, [user]);

  // Ladeanimation anzeigen, bis Daten geladen sind
  if (isLoading) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Container maxWidth="md" sx={{ mt: 4, mb: 4, flex: 1 }}>
          <Box sx={{ p: 3 }}>
            <Box sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center', 
              justifyContent: 'center', 
              minHeight: '400px',
              textAlign: 'center'
            }}>
              <CircularProgress size={60} thickness={4} sx={{ color: '#667eea' }} />
            </Box>
          </Box>
        </Container>
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Kombiniertes Modal für AGB und Onboarding */}
      <Dialog 
        open={showAgbModal || showOnboardingModal} 
        onClose={() => {}}
        maxWidth="md"
        fullWidth
        disableEscapeKeyDown
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          fontWeight: 700
        }}>
          {showOnboardingModal ? t('onboarding.title') : t('agb.title')}
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            {/* Onboarding-Bereich */}
            {showOnboardingModal && (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Box sx={{ height: 12 }} />
                <TextField
                  label={t('onboarding.firstName')}
                  value={onboardingFirstName}
                  onChange={(e) => setOnboardingFirstName(e.target.value)}
                  fullWidth
                  required
                />
                <TextField
                  label={t('onboarding.lastName')}
                  value={onboardingLastName}
                  onChange={(e) => setOnboardingLastName(e.target.value)}
                  fullWidth
                  required
                />
                <FormControl fullWidth required>
                  <InputLabel>{t('onboarding.gender')}</InputLabel>
                  <Select
                    value={onboardingGender}
                    onChange={(e) => setOnboardingGender(e.target.value)}
                    label={t('onboarding.gender')}
                  >
                    <MenuItem value="männlich">{t('onboarding.gender.male')}</MenuItem>
                    <MenuItem value="weiblich">{t('onboarding.gender.female')}</MenuItem>
                    <MenuItem value="divers">{t('onboarding.gender.diverse')}</MenuItem>
                    <MenuItem value="keine-angabe">{t('onboarding.gender.unspecified')}</MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth required>
                  <InputLabel>{t('onboarding.country')}</InputLabel>
                  <Select
                    value={onboardingCountry}
                    onChange={(e) => setOnboardingCountry(e.target.value)}
                    label={t('onboarding.country')}
                  >
                    <MenuItem value="CH">{t('onboarding.country.ch')}</MenuItem>
                    <MenuItem value="DE">{t('onboarding.country.de')}</MenuItem>
                    <MenuItem value="AT">{t('onboarding.country.at')}</MenuItem>
                    <MenuItem value="FR">{t('onboarding.country.fr')}</MenuItem>
                    <MenuItem value="IT">{t('onboarding.country.it')}</MenuItem>
                  </Select>
                </FormControl>
                
                {/* AGB Checkbox - direkt unter Land */}
                {showAgbModal && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={hasReadAgb}
                        onChange={(e) => setHasReadAgb(e.target.checked)}
                        sx={{
                          color: '#667eea',
                          '&.Mui-checked': { color: '#667eea' }
                        }}
                        disabled={isAccepting}
                      />
                    }
                    label={
                      <Typography variant="body2">
                        {t('agb.confirmation.before')}{' '}
                        <Link 
                          href="https://xlr-8-web.web.app/agb" 
                          target="_blank" 
                          rel="noopener noreferrer"
                          onClick={(e) => e.stopPropagation()}
                          sx={{ 
                            color: '#667eea',
                            fontWeight: 600,
                            textDecoration: 'underline',
                            '&:hover': { color: '#764ba2' }
                          }}
                        >
                          {t('agb.confirmation.link')}
                        </Link>
                        {' '}{t('agb.confirmation.after')}
                      </Typography>
                    }
                  />
                )}
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3, justifyContent: 'space-between' }}>
          <Button
            onClick={async () => {
              await logout();
            }}
            variant="text"
            disableRipple
            disableElevation
            disableFocusRipple
            disabled={isAccepting || savingOnboarding}
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 6,
              minWidth: 'auto',
              border: 'none !important',
              borderWidth: '0 !important',
              borderStyle: 'none !important',
              outline: 'none !important',
              outlineWidth: '0 !important',
              outlineStyle: 'none !important',
              boxShadow: 'none !important',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: 'transparent !important',
                border: 'none !important',
                borderWidth: '0 !important',
                borderStyle: 'none !important',
                outline: 'none !important',
                outlineWidth: '0 !important',
                outlineStyle: 'none !important',
                boxShadow: 'none !important',
                transform: 'none',
              },
              '&:focus': {
                border: 'none !important',
                borderWidth: '0 !important',
                borderStyle: 'none !important',
                outline: 'none !important',
                outlineWidth: '0 !important',
                outlineStyle: 'none !important',
                boxShadow: 'none !important',
              },
              '&:focus-visible': {
                border: 'none !important',
                borderWidth: '0 !important',
                borderStyle: 'none !important',
                outline: 'none !important',
                outlineWidth: '0 !important',
                outlineStyle: 'none !important',
                boxShadow: 'none !important',
              },
              '&.Mui-disabled': {
                border: 'none !important',
                borderWidth: '0 !important',
                borderStyle: 'none !important',
                outline: 'none !important',
                outlineWidth: '0 !important',
              },
              '& .MuiButton-root': {
                border: 'none !important',
                borderWidth: '0 !important',
              },
            }}
          >
            {t('common.cancel')}
          </Button>
          
          <Button
            onClick={async () => {
              // Zuerst AGB akzeptieren, dann Onboarding speichern
              if (showAgbModal) {
                await handleAcceptAgb();
              }
              if (showOnboardingModal) {
                await handleSaveOnboarding();
              }
            }}
            variant="outlined"
            disabled={
              (showOnboardingModal && (savingOnboarding || !onboardingFirstName || !onboardingLastName || !onboardingGender || !onboardingCountry)) ||
              (showAgbModal && !hasReadAgb) ||
              isAccepting
            }
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 6,
              borderWidth: 2,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
            startIcon={(isAccepting || savingOnboarding) ? <CircularProgress size={20} color="inherit" /> : undefined}
          >
            {(isAccepting || savingOnboarding) ? t('onboarding.saving') : t('onboarding.save')}
          </Button>
        </DialogActions>
      </Dialog>
      
      {/* Zeige Loading-Screen während AGB-Prüfung oder wenn Status noch nicht geladen */}
      {(agbLoading || (!agbLoading && agbAccepted === null && user)) && (
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '100vh' 
        }}>
          <CircularProgress />
        </Box>
      )}
      
      {/* Hauptinhalt - nur anzeigen wenn AGBs explizit akzeptiert wurden */}
      {!agbLoading && agbAccepted === true && (
        <>
          {/* Info-Icon für Versionsinformationen - weiter links */}
          <Box sx={{ 
            position: 'fixed', 
            top: 20, 
            right: 80, 
            zIndex: 1000 
          }}>
            {isAdmin() && (
            <IconButton
              onClick={() => {
                setShowVersionInfo(true);
                loadBackendVersionInfo(); // Lade Backend-Versionsinfo beim Öffnen
              }}
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(0, 0, 0, 0.1)',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 1)',
                  transform: 'scale(1.1)'
                },
                transition: 'all 0.2s ease'
              }}
            >
              <InfoOutlinedIcon sx={{ color: '#3b82f6' }} />
            </IconButton>
            )}
          </Box>

          {/* User-Menü-Icon - an der alten Info-Icon Position */}
          <Box sx={{ 
            position: 'fixed', 
            top: 20, 
            right: 20, 
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}>
            {/* CV-Name Dropdown links vom User-Icon */}
            {userCvs && userCvs.length > 0 && (
              <FormControl 
                size="small" 
                sx={{ 
                  minWidth: 200,
                  maxWidth: 300,
                  backgroundColor: 'rgba(255, 255, 255, 0.9)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: 2,
                  '& .MuiOutlinedInput-root': {
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    borderRadius: 2,
                    fontSize: '0.875rem',
                    fontWeight: 600,
                    color: '#424242',
                    '&:hover': {
                      borderColor: 'rgba(102, 126, 234, 0.5)',
                    },
                    '&.Mui-focused': {
                      borderColor: '#667eea',
                      backgroundColor: 'rgba(255, 255, 255, 1)',
                    },
                    '& fieldset': {
                      border: 'none',
                    }
                  },
                  '& .MuiSelect-select': {
                    py: 0.5,
                    px: 1.5,
                  }
                }}
              >
                <Select
                  value={selectedCvId || ''}
                  onChange={(e) => {
                    const newCvId = e.target.value as string;
                    if (newCvId && newCvId !== selectedCvId) {
                      handleSelectCv(newCvId, false);
                    }
                  }}
                  displayEmpty
                  sx={{
                    '& .MuiSelect-icon': {
                      color: '#424242',
                    }
                  }}
                >
                  {userCvs.map((cv: any) => (
                    <MenuItem key={cv.cvId} value={cv.cvId}>
                      <Typography 
                        sx={{ 
                          fontSize: '0.875rem',
                          fontWeight: 600,
                          color: '#424242',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          maxWidth: '250px'
                        }}
                      >
                        {cv.cvName || 'Unbenannt'}
                      </Typography>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
            <IconButton
              onClick={handleUserMenuClick}
              sx={{ 
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(0, 0, 0, 0.1)',
                color: '#424242',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 1)',
                  transform: 'scale(1.1)'
                },
                transition: 'all 0.2s ease'
              }}
            >
              <PersonIcon />
            </IconButton>
          </Box>

          {/* User-Menü */}
          <Menu
              anchorEl={userMenuAnchorEl}
              open={isUserMenuOpen}
              onClose={handleUserMenuClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              {/* E-Mail-Adresse des angemeldeten Benutzers */}
              {auth.currentUser?.email && (
                <MenuItem disabled sx={{ 
                  color: 'text.secondary',
                  fontSize: '0.875rem',
                  cursor: 'default',
                  '&:hover': { backgroundColor: 'transparent' }
                }}>
                  {auth.currentUser.email}
                </MenuItem>
              )}
              <MenuItem onClick={handleUserMenuClose}>
                <ListItemIcon>
                  <LanguageOutlinedIcon fontSize="small" />
                </ListItemIcon>
            <FormControl size="small" sx={{ minWidth: 120 }}>
              <Select
                value={currentLanguage}
                    onChange={(e) => {
                      const newLang = e.target.value as string;
                      setCurrentLanguage(newLang);
                      changeLanguage(newLang);
                      
                      // Aktualisiere auch targetLanguage für CV-Label-Übersetzungen
                      const languageMap: { [key: string]: string } = {
                        'de': 'deutsch',
                        'fr': 'französisch',
                        'it': 'italienisch',
                        'en': 'englisch'
                      };
                      setTargetLanguage(languageMap[newLang] || 'deutsch');
                      
                      console.log('✅ Sprache geändert:', newLang, '(temporär - nach Refresh wird Browser-Sprache geladen)');
                    }}
                    displayEmpty
                    variant="standard"
                    sx={{ 
                      '&:before': { borderBottom: 'none' },
                      '&:after': { borderBottom: 'none' },
                      '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' }
                    }}
              >
                <MenuItem value="de">Deutsch</MenuItem>
                <MenuItem value="fr">Français</MenuItem>
                <MenuItem value="it">Italiano</MenuItem>
                <MenuItem value="en">English</MenuItem>
              </Select>
            </FormControl>
              </MenuItem>
              
              <Divider />
              
              <MenuItem onClick={handleLogout}>
                <ListItemIcon>
                  <LogoutIcon fontSize="small" />
                </ListItemIcon>
              {getTranslatedCvLabel('Logout')}
              </MenuItem>
            </Menu>

          <Container maxWidth="md" sx={{ mt: 4, mb: 4, flex: 1, display: 'flex', flexDirection: 'column' }}>
            <Paper sx={{ p: 3, flex: 1, display: 'flex', flexDirection: 'column' }}>
        {/* Import-Fortschrittsanzeige mit Icons im Kreis um die Warte-Animation */}
        {extracting && (
          <Box sx={{ 
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            my: 10,
            minHeight: '360px'
          }}>
            <Box sx={{ 
              position: 'relative', 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center',
              minHeight: '136px'
            }}>
              {/* Zentrale Warte-Animation */}
              <CircularProgress size={54} sx={{ color: '#667eea' }} />
            
            {/* Icons im Kreis um die Animation */}
            {Object.keys(importProgress).length > 0 && (
              <>
                {Object.entries(importProgress).map(([taskName, status], index) => {
                  const totalIcons = Object.keys(importProgress).length;
                  const angle = (360 / totalIcons) * index;
                  const radius = 50; // Abstand vom Zentrum
                  const x = Math.cos((angle - 90) * Math.PI / 180) * radius;
                  const y = Math.sin((angle - 90) * Math.PI / 180) * radius;
                  
                  return (
                    <Box
                      key={`icon-${taskName}`}
                      title={taskName}
                      sx={{
                        position: 'absolute',
                        left: `calc(50% + ${x}px)`,
                        top: `calc(50% + ${y}px)`,
                        transform: 'translate(-50%, -50%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'help'
                      }}
                    >
                      {getTopicIcon(taskName, status)}
                    </Box>
                  );
                })}
              </>
            )}
            </Box>
            
            {/* Label unterhalb der Warte-Animation */}
            <Typography 
              variant="body2" 
              sx={{ 
                color: '#666',
                fontSize: '0.98rem',
                fontWeight: 500,
                textAlign: 'center',
                mt: 3
              }}
            >
              {getTranslatedCvLabel('CV Daten werden importiert...')}
            </Typography>
          </Box>
        )}
        
        {/* Warte-Animationen */}
        
            {/* Warte-Animation für Passgenauigkeit (nur wenn nicht im Modal) */}
            {checkingMatch && !checkingMatchInModal && (
              <Box sx={{ 
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center', 
                alignItems: 'center', 
                my: 10,
                minHeight: '360px'
              }}>
                <Box sx={{ 
                  position: 'relative', 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center',
                  minHeight: '136px'
                }}>
                  {/* Zentrale Warte-Animation */}
                  <CircularProgress size={54} sx={{ color: '#667eea' }} />
                  
                  {/* Passgenauigkeit-Icon in der Mitte */}
                  <Box
                    sx={{
                      position: 'absolute',
                      left: '50%',
                      top: '50%',
                      transform: 'translate(-50%, -50%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <AssessmentOutlinedIcon sx={{ fontSize: 27, color: '#667eea' }} />
                  </Box>
                </Box>
                
                {/* Label unterhalb der Passgenauigkeit Warte-Animation */}
                <Typography 
                  variant="body2" 
                  sx={{ 
                    color: '#666',
                    fontSize: '0.98rem',
                    fontWeight: 500,
                    textAlign: 'center',
                    mt: 3
                  }}
                >
                  {getTranslatedInfoMessage('calculating_match')}
                </Typography>
              </Box>
            )}
            
            
            {/* Progress-Anzeige für parallele Optimierung - Icons im Kreis */}
            {optimizing && Object.keys(optimizationProgress).length > 0 && (
              <Box sx={{ 
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                my: 10,
                minHeight: '360px'
              }}>
                {/* Icons im Kreis um eine zentrale Warte-Animation */}
                <Box sx={{ 
                  position: 'relative', 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center', 
                  minHeight: '136px'
                }}>
                  {/* Zentrale Warte-Animation */}
                  <CircularProgress size={54} sx={{ color: '#667eea' }} />
                  
                  {/* Icons im Kreis um die Animation */}
                  {Object.entries(optimizationProgress).map(([taskName, status], index) => {
                    const totalIcons = Object.keys(optimizationProgress).length;
                    const angle = (360 / totalIcons) * index;
                    const radius = 56; // Abstand vom Zentrum (20% kleiner als 70)
                    const x = Math.cos((angle - 90) * Math.PI / 180) * radius;
                    const y = Math.sin((angle - 90) * Math.PI / 180) * radius;
                    
                    return (
                      <Box
                        key={`opt-icon-${taskName}`}
                        title={taskName}
                        sx={{
                          position: 'absolute',
                          left: `calc(50% + ${x}px)`,
                          top: `calc(50% + ${y}px)`,
                          transform: 'translate(-50%, -50%) scale(1.12)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'help'
                        }}
                      >
                        {getOptimizationIcon(taskName, status)}
                      </Box>
                    );
                  })}
                </Box>
                
                {/* Label unterhalb der Warte-Animation */}
                <Typography 
                  variant="body2" 
                  sx={{ 
                    color: '#666',
                    fontSize: '0.98rem',
                    fontWeight: 500,
                    textAlign: 'center',
                    mt: 3
                  }}
                >
                  {getTranslatedInfoMessage('optimized_cv_being_created')}
                </Typography>
              </Box>
            )}
            
            {/* Optimierter CV Template-Anzeige */}
            {improvedCvText && (
              <Box sx={{ mb: 3 }}>

                

                




                {/* IT-Skill Selector Dialog */}
                <Dialog 
                  open={showItSkillSelector} 
                  onClose={() => setShowItSkillSelector(false)}
                  maxWidth="sm"
                >
                  <DialogTitle sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    borderBottom: 'none',
                    width: '100%',
                    maxWidth: '100%'
                  }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)', width: '100%', maxWidth: '100%' }}>
                        IT-Skill aus gespeicherten Daten hinzufügen
                      </Typography>
                      <IconButton onClick={() => setShowItSkillSelector(false)} sx={{ color: 'white' }}>
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  </DialogTitle>
                  <DialogContent sx={{ p: 3 }}>
                    <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
                      Wählen Sie einen IT-Skill aus Ihren gespeicherten Daten aus, um ihn zur relevanten Liste hinzuzufügen:
                    </Typography>
                    <Box sx={{ maxHeight: 400, overflow: 'auto' }}>
                            {itSkills && itSkills.length > 0 ? (
        itSkills
          .map((skill, index) => {
                          const isAlreadyInList = relevantItSkills.some(
                            relevantSkill => relevantSkill.skill === skill.skill && relevantSkill.level === skill.level
                          );
                          
                          return (
                            <Box
                              key={index}
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                p: 2,
                                mb: 1,
                                border: '1px solid #e2e8f0',
                                borderRadius: 2,
                                backgroundColor: isAlreadyInList ? '#f1f5f9' : 'white',
                                opacity: isAlreadyInList ? 0.6 : 1,
                                '&:hover': {
                                  backgroundColor: isAlreadyInList ? '#f1f5f9' : '#f8fafc',
                                  borderColor: '#cbd5e1'
                                }
                              }}
                            >
                              <Box>
                                <Typography variant="body1" sx={{ fontWeight: 600, color: '#1e293b' }}>
                                  {skill.skill || 'N/A'}
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#64748b' }}>
                                  Niveau: {skill.level || 'N/A'}
                                </Typography>
                              </Box>
                              <Button
                                variant="outlined"
                                size="small"
                                disabled={isAlreadyInList}
                                onClick={() => {
                                  handleAddItSkillFromStored(skill);
                                  setShowItSkillSelector(false);
                                }}
                                sx={{
                                  borderColor: '#10b981',
                                  color: '#10b981',
                                  '&:hover': {
                                    borderColor: '#059669',
                                    backgroundColor: '#f0fdf4'
                                  },
                                  '&:disabled': {
                                    borderColor: '#d1d5db',
                                    color: '#9ca3af'
                                  }
                                }}
                              >
                                {isAlreadyInList ? 'Bereits hinzugefügt' : 'Hinzufügen'}
                              </Button>
                            </Box>
                          );
                        })
                      ) : (
                        <Box sx={{ 
                          textAlign: 'center', 
                          py: 4,
                          color: '#94a3b8', 
                          fontStyle: 'italic'
                        }}>
                          Keine IT-Skills in gespeicherten Daten verfügbar
                        </Box>
                      )}
                    </Box>
                  </DialogContent>
                </Dialog>

                {/* Core Competency Selector Dialog */}
                <Dialog 
                  open={showCoreCompetencySelector} 
                  onClose={() => setShowCoreCompetencySelector(false)}
                  maxWidth="sm"
                >
                  <DialogTitle sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    borderBottom: 'none',
                    width: '100%',
                    maxWidth: '100%'
                  }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)', width: '100%', maxWidth: '100%' }}>
                        {getTranslatedCvLabel('Kernkompetenz aus gespeicherten Daten hinzufügen')}
                      </Typography>
                      <IconButton onClick={() => setShowCoreCompetencySelector(false)} sx={{ color: 'white' }}>
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  </DialogTitle>
                  <DialogContent sx={{ p: 3 }}>
                    <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
                      Wählen Sie eine Kernkompetenz aus Ihren gespeicherten Daten aus, um sie zur relevanten Liste hinzuzufügen:
                    </Typography>
                    <Box sx={{ maxHeight: 400, overflow: 'auto' }}>
                            {coreCompetencies && coreCompetencies.length > 0 ? (
        coreCompetencies
          .map((competency, index) => {
                          const isAlreadyInList = relevantCoreCompetencies.some(
                            relevantComp => relevantComp.competency === competency.competency
                          );
                          
                          return (
                            <Box
                              key={index}
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                p: 2,
                                mb: 1,
                                border: '1px solid #e2e8f0',
                                borderRadius: 2,
                                backgroundColor: isAlreadyInList ? '#f1f5f9' : 'white',
                                opacity: isAlreadyInList ? 0.6 : 1,
                                '&:hover': {
                                  backgroundColor: isAlreadyInList ? '#f1f5f9' : '#f8fafc',
                                  borderColor: '#cbd5e1'
                                }
                              }}
                            >
                              <Box>
                                <Typography variant="body1" sx={{ fontWeight: 600, color: '#1e293b' }}>
                                  {competency.competency || 'N/A'}
                                </Typography>
                              </Box>
                              <Button
                                variant="outlined"
                                size="small"
                                disabled={isAlreadyInList}
                                onClick={() => {
                                  handleAddCoreCompetencyFromStored(competency);
                                  setShowCoreCompetencySelector(false);
                                }}
                                sx={{
                                  borderColor: '#10b981',
                                  color: '#10b981',
                                  '&:hover': {
                                    borderColor: '#059669',
                                    backgroundColor: '#f0fdf4'
                                  },
                                  '&:disabled': {
                                    borderColor: '#d1d5db',
                                    color: '#9ca3af'
                                  }
                                }}
                              >
                                {isAlreadyInList ? 'Bereits hinzugefügt' : 'Hinzufügen'}
                              </Button>
                            </Box>
                          );
                        })
                      ) : (
                        <Box sx={{ 
                          textAlign: 'center', 
                          py: 4,
                          color: '#94a3b8', 
                          fontStyle: 'italic'
                        }}>
                          Keine Kernkompetenzen in gespeicherten Daten verfügbar
                        </Box>
                      )}
                    </Box>
                  </DialogContent>
                </Dialog>

                {/* Certification Selector Dialog */}
                <Dialog 
                  open={showCertificationSelector} 
                  onClose={() => setShowCertificationSelector(false)}
                  maxWidth="sm"
                >
                  <DialogTitle sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    borderBottom: 'none',
                    width: '100%',
                    maxWidth: '100%'
                  }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)', width: '100%', maxWidth: '100%' }}>
                        Zertifizierung aus gespeicherten Daten hinzufügen
                      </Typography>
                      <IconButton onClick={() => setShowCertificationSelector(false)} sx={{ color: 'white' }}>
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  </DialogTitle>
                  <DialogContent sx={{ p: 3 }}>
                    <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
                      Wählen Sie eine Zertifizierung aus Ihren gespeicherten Daten aus, um sie zur relevanten Liste hinzuzufügen:
                    </Typography>
                    <Box sx={{ maxHeight: 400, overflow: 'auto' }}>
                      {certifications && certifications.length > 0 ? (
                        certifications
                          .map((certification: { name: string; issuer: string; date: string }, index: number) => {
                          const isAlreadyInList = relevantCertifications.some(
                            relevantCert => relevantCert.name === certification.name && relevantCert.issuer === certification.issuer
                          );
                          
                          return (
                            <Box
                              key={index}
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                p: 2,
                                mb: 1,
                                border: '1px solid #e2e8f0',
                                borderRadius: 2,
                                backgroundColor: isAlreadyInList ? '#f1f5f9' : 'white',
                                opacity: isAlreadyInList ? 0.6 : 1,
                                '&:hover': {
                                  backgroundColor: isAlreadyInList ? '#f1f5f9' : '#f8fafc',
                                  borderColor: '#cbd5e1'
                                }
                              }}
                            >
                              <Box sx={{ flex: 1, mr: 2 }}>
                                <Typography variant="body1" sx={{ fontWeight: 600, color: '#1e293b', mb: 1 }}>
                                  {certification.name || 'N/A'}
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#64748b', fontSize: '0.85rem', mb: 0.5 }}>
                                  Aussteller: {certification.issuer || 'N/A'}
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#64748b', fontSize: '0.85rem' }}>
                                  Datum: {certification.date || 'N/A'}
                                </Typography>
                              </Box>
                              <Button
                                variant="outlined"
                                size="small"
                                disabled={isAlreadyInList}
                                onClick={() => {
                                  handleAddCertificationFromStored(certification);
                                  setShowCertificationSelector(false);
                                }}
                                sx={{
                                  borderColor: '#10b981',
                                  color: '#10b981',
                                  '&:hover': {
                                    borderColor: '#059669',
                                    backgroundColor: '#f0fdf4'
                                  },
                                  '&:disabled': {
                                    borderColor: '#d1d5db',
                                    color: '#9ca3af'
                                  }
                                }}
                              >
                                {isAlreadyInList ? 'Bereits hinzugefügt' : 'Hinzufügen'}
                              </Button>
                            </Box>
                          );
                        })
                      ) : (
                        <Box sx={{ 
                          textAlign: 'center', 
                          py: 4,
                          color: '#94a3b8', 
                          fontStyle: 'italic'
                        }}>
                          Keine Zertifizierungen in gespeicherten Daten verfügbar
                        </Box>
                      )}
                    </Box>
                  </DialogContent>
                </Dialog>

                {/* Additional Info Selector Dialog */}
                <Dialog 
                  open={showAdditionalInfoSelector} 
                  onClose={() => setShowAdditionalInfoSelector(false)}
                  maxWidth="sm"
                >
                  <DialogTitle sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    borderBottom: 'none',
                    width: '100%',
                    maxWidth: '100%'
                  }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)', width: '100%', maxWidth: '100%' }}>
                        Weitere Information aus gespeicherten Daten hinzufügen
                      </Typography>
                      <IconButton onClick={() => setShowAdditionalInfoSelector(false)} sx={{ color: 'white' }}>
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  </DialogTitle>
                  <DialogContent sx={{ p: 3 }}>
                    <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
                      Wählen Sie eine weitere Information aus Ihren gespeicherten Daten aus, um sie zur relevanten Liste hinzuzufügen:
                    </Typography>
                    <Box sx={{ maxHeight: 400, overflow: 'auto' }}>
                            {additionalInfo && additionalInfo.length > 0 ? (
        additionalInfo
          .map((info, index) => {
                          const isAlreadyInList = relevantAdditionalInfo.some(
                            relevantInfo => relevantInfo.info === info.info && relevantInfo.details === info.details
                          );
                          
                          return (
                            <Box
                              key={index}
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                p: 2,
                                mb: 1,
                                border: '1px solid #e2e8f0',
                                borderRadius: 2,
                                backgroundColor: isAlreadyInList ? '#f1f5f9' : 'white',
                                opacity: isAlreadyInList ? 0.6 : 1,
                                '&:hover': {
                                  backgroundColor: isAlreadyInList ? '#f1f5f9' : '#f8fafc',
                                  borderColor: '#cbd5e1'
                                }
                              }}
                            >
                              <Box sx={{ flex: 1, mr: 2 }}>
                                <Typography variant="body1" sx={{ fontWeight: 600, color: '#1e293b', mb: 1 }}>
                                  {info.info || 'N/A'}
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#64748b', fontSize: '0.85rem' }}>
                                  {info.details || 'N/A'}
                                </Typography>
                              </Box>
                              <Button
                                variant="outlined"
                                size="small"
                                disabled={isAlreadyInList}
                                onClick={() => {
                                  handleAddAdditionalInfoFromStored(info);
                                  setShowAdditionalInfoSelector(false);
                                }}
                                sx={{
                                  borderColor: '#10b981',
                                  color: '#10b981',
                                  '&:hover': {
                                    borderColor: '#059669',
                                    backgroundColor: '#f0fdf4'
                                  },
                                  '&:disabled': {
                                    borderColor: '#d1d5db',
                                    color: '#9ca3af'
                                  }
                                }}
                              >
                                {isAlreadyInList ? 'Bereits hinzugefügt' : 'Hinzufügen'}
                              </Button>
                            </Box>
                          );
                        })
                      ) : (
                        <Box sx={{ 
                          textAlign: 'center', 
                          py: 4,
                          color: '#94a3b8', 
                          fontStyle: 'italic'
                        }}>
                          Keine weiteren Informationen in gespeicherten Daten verfügbar
                        </Box>
                      )}
                    </Box>
                  </DialogContent>
                </Dialog>

                {/* Education Selector Dialog */}
                <Dialog 
                  open={showEducationSelector} 
                  onClose={() => setShowEducationSelector(false)}
                  maxWidth="sm"
                >
                  <DialogTitle sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    borderBottom: 'none',
                    width: '100%',
                    maxWidth: '100%'
                  }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)', width: '100%', maxWidth: '100%' }}>
                        Ausbildung aus gespeicherten Daten hinzufügen
                      </Typography>
                      <IconButton onClick={() => setShowEducationSelector(false)} sx={{ color: 'white' }}>
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  </DialogTitle>
                  <DialogContent sx={{ p: 3 }}>
                    <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
                      Wählen Sie eine Ausbildung aus Ihren gespeicherten Daten aus, um sie zur relevanten Liste hinzuzufügen:
                    </Typography>
                    <Box sx={{ maxHeight: 400, overflow: 'auto' }}>
                      {educations && educations.length > 0 ? (
                        educations.map((education, index) => {
                          const isAlreadyInList = relevantEducations.some(
                            relevantEdu => relevantEdu.institution === education.institution && relevantEdu.degree === education.degree
                          );
                          
                          return (
                            <Box
                              key={index}
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                p: 2,
                                mb: 1,
                                border: '1px solid #e2e8f0',
                                borderRadius: 2,
                                backgroundColor: isAlreadyInList ? '#f1f5f9' : 'white',
                                opacity: isAlreadyInList ? 0.6 : 1,
                                '&:hover': {
                                  backgroundColor: isAlreadyInList ? '#f1f5f9' : '#f8fafc',
                                  borderColor: '#cbd5e1'
                                }
                              }}
                            >
                              <Box>
                                <Typography variant="body1" sx={{ fontWeight: 600, color: '#1e293b' }}>
                                  {education.degree || 'N/A'}
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#64748b' }}>
                                  {education.institution || 'N/A'}
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#94a3b8', fontSize: '0.875rem' }}>
                                  {education.startDate} - {education.endDate}
                                </Typography>
                              </Box>
                              <Button
                                variant="outlined"
                                size="small"
                                disabled={isAlreadyInList}
                                onClick={() => {
                                  handleAddEducationFromStored(education);
                                  setShowEducationSelector(false);
                                }}
                                sx={{
                                  borderColor: '#10b981',
                                  color: '#10b981',
                                  '&:hover': {
                                    borderColor: '#059669',
                                    backgroundColor: '#f0fdf4'
                                  },
                                  '&:disabled': {
                                    borderColor: '#d1d5db',
                                    color: '#9ca3af'
                                  }
                                }}
                              >
                                {isAlreadyInList ? 'Bereits hinzugefügt' : 'Hinzufügen'}
                              </Button>
                            </Box>
                          );
                        })
                      ) : (
                        <Box sx={{ 
                          textAlign: 'center', 
                          py: 4,
                          color: '#94a3b8', 
                          fontStyle: 'italic'
                        }}>
                          Keine Ausbildungen in gespeicherten Daten verfügbar
                        </Box>
                      )}
                    </Box>
                  </DialogContent>
                </Dialog>

                {/* Industry Selector Dialog */}
                <Dialog 
                  open={showIndustrySelector} 
                  onClose={() => setShowIndustrySelector(false)}
                  maxWidth="sm"
                >
                  <DialogTitle sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    borderBottom: 'none',
                    width: '100%',
                    maxWidth: '100%'
                  }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)', width: '100%', maxWidth: '100%' }}>
                        Branche aus gespeicherten Daten hinzufügen
                      </Typography>
                      <IconButton onClick={() => setShowIndustrySelector(false)} sx={{ color: 'white' }}>
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  </DialogTitle>
                  <DialogContent sx={{ p: 3 }}>
                    <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
                      Wählen Sie eine Branche aus Ihren gespeicherten Daten aus, um sie zur relevanten Liste hinzuzufügen:
                    </Typography>
                    <Box sx={{ maxHeight: 400, overflow: 'auto' }}>
                      {industryExperiences && industryExperiences.length > 0 ? (
                        industryExperiences.map((industry, index) => {
                          const isAlreadyInList = relevantIndustries.some(
                            relevantIndustry => relevantIndustry.industry === industry.industry
                          );
                          
                          return (
                            <Box
                              key={index}
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                p: 2,
                                mb: 1,
                                border: '1px solid #e2e8f0',
                                borderRadius: 2,
                                backgroundColor: isAlreadyInList ? '#f1f5f9' : 'white',
                                opacity: isAlreadyInList ? 0.6 : 1,
                                '&:hover': {
                                  backgroundColor: isAlreadyInList ? '#f1f5f9' : '#f8fafc',
                                  borderColor: '#cbd5e1'
                                }
                              }}
                            >
                              <Box>
                                <Typography variant="body1" sx={{ fontWeight: 600, color: '#1e293b' }}>
                                  {industry.industry || 'N/A'}
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#64748b' }}>
                                  {industry.years} {translatedYears} Erfahrung
                                </Typography>
                              </Box>
                              <Button
                                variant="outlined"
                                size="small"
                                disabled={isAlreadyInList}
                                onClick={() => {
                                  handleAddIndustryFromStored(industry);
                                  setShowIndustrySelector(false);
                                }}
                                sx={{
                                  borderColor: '#10b981',
                                  color: '#10b981',
                                  '&:hover': {
                                    borderColor: '#059669',
                                    backgroundColor: '#f0fdf4'
                                  },
                                  '&:disabled': {
                                    borderColor: '#d1d5db',
                                    color: '#9ca3af'
                                  }
                                }}
                              >
                                {isAlreadyInList ? 'Bereits hinzugefügt' : 'Hinzufügen'}
                              </Button>
                            </Box>
                          );
                        })
                      ) : (
                        <Box sx={{ 
                          textAlign: 'center', 
                          py: 4,
                          color: '#94a3b8', 
                          fontStyle: 'italic'
                        }}>
                          Keine Branchen in gespeicherten Daten verfügbar
                        </Box>
                      )}
                    </Box>
                  </DialogContent>
                </Dialog>

                {/* Hobby Selector Dialog */}
                <Dialog 
                  open={showHobbySelector} 
                  onClose={() => setShowHobbySelector(false)}
                  maxWidth="sm"
                >
                  <DialogTitle sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    borderBottom: 'none',
                    width: '100%',
                    maxWidth: '100%'
                  }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)', width: '100%', maxWidth: '100%' }}>
                        Hobby aus gespeicherten Daten hinzufügen
                      </Typography>
                      <IconButton onClick={() => setShowHobbySelector(false)} sx={{ color: 'white' }}>
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  </DialogTitle>
                  <DialogContent sx={{ p: 3 }}>
                    <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
                      Wählen Sie ein Hobby aus Ihren gespeicherten Daten aus, um es zur relevanten Liste hinzuzufügen:
                    </Typography>
                    <Box sx={{ maxHeight: 400, overflow: 'auto' }}>
                            {hobbies && hobbies.length > 0 ? (
        hobbies.map((hobby, index) => {
                          const isAlreadyInList = relevantHobbies.some(
                            relevantHobby => relevantHobby.hobby === hobby.hobby
                          );
                          
                          return (
                            <Box
                              key={index}
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                p: 2,
                                mb: 1,
                                border: '1px solid #e2e8f0',
                                borderRadius: 2,
                                backgroundColor: isAlreadyInList ? '#f1f5f9' : 'white',
                                opacity: isAlreadyInList ? 0.6 : 1,
                                '&:hover': {
                                  backgroundColor: isAlreadyInList ? '#f1f5f9' : '#f8fafc',
                                  borderColor: '#cbd5e1'
                                }
                              }}
                            >
                              <Box>
                                <Typography variant="body1" sx={{ fontWeight: 600, color: '#1e293b' }}>
                                  {hobby.hobby || 'N/A'}
                                </Typography>
                                {hobby.description && (
                                  <Typography variant="body2" sx={{ color: '#64748b' }}>
                                    {hobby.description}
                                  </Typography>
                                )}
                              </Box>
                              <Button
                                variant="outlined"
                                size="small"
                                disabled={isAlreadyInList}
                                onClick={() => {
                                  handleAddHobbyFromStored(hobby);
                                  setShowHobbySelector(false);
                                }}
                                sx={{
                                  borderColor: '#10b981',
                                  color: '#10b981',
                                  '&:hover': {
                                    borderColor: '#059669',
                                    backgroundColor: '#f0fdf4'
                                  },
                                  '&:disabled': {
                                    borderColor: '#d1d5db',
                                    color: '#9ca3af'
                                  }
                                }}
                              >
                                {isAlreadyInList ? 'Bereits hinzugefügt' : 'Hinzufügen'}
                              </Button>
                            </Box>
                          );
                        })
                      ) : (
                        <Box sx={{ 
                          textAlign: 'center', 
                          py: 4,
                          color: '#94a3b8', 
                          fontStyle: 'italic'
                        }}>
                          Keine Hobbys in gespeicherten Daten verfügbar
                        </Box>
                      )}
                    </Box>
                  </DialogContent>
                </Dialog>

                {/* Language Selector Dialog */}
                <Dialog 
                  open={showLanguageSelector} 
                  onClose={() => setShowLanguageSelector(false)}
                  maxWidth="sm"
                >
                  <DialogTitle sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    borderBottom: 'none',
                    width: '100%',
                    maxWidth: '100%'
                  }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)', width: '100%', maxWidth: '100%' }}>
                        Sprache aus gespeicherten Daten hinzufügen
                      </Typography>
                      <IconButton onClick={() => setShowLanguageSelector(false)} sx={{ color: 'white' }}>
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  </DialogTitle>
                  <DialogContent sx={{ p: 3 }}>
                    <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
                      Wählen Sie eine Sprache aus Ihren gespeicherten Daten aus, um sie zur relevanten Liste hinzuzufügen:
                    </Typography>
                    <Box sx={{ maxHeight: 400, overflow: 'auto' }}>
                            {languages && languages.length > 0 ? (
        languages.map((language, index) => {
                          const isAlreadyInList = relevantLanguages.some(
                            relevantLang => relevantLang.language === language.language && relevantLang.level === language.level
                          );
                          
                          return (
                            <Box
                              key={index}
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                p: 2,
                                mb: 1,
                                border: '1px solid #e2e8f0',
                                borderRadius: 2,
                                backgroundColor: isAlreadyInList ? '#f1f5f9' : 'white',
                                opacity: isAlreadyInList ? 0.6 : 1,
                                '&:hover': {
                                  backgroundColor: isAlreadyInList ? '#f1f5f9' : '#f8fafc',
                                  borderColor: '#cbd5e1'
                                }
                              }}
                            >
                              <Box>
                                <Typography variant="body1" sx={{ fontWeight: 600, color: '#1e293b' }}>
                                  {language.language || 'N/A'}
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#64748b' }}>
                                  Niveau: {language.level || 'N/A'}
                                </Typography>
                              </Box>
                              <Button
                                variant="outlined"
                                size="small"
                                disabled={isAlreadyInList}
                                onClick={() => {
                                  handleAddLanguageFromStored(language);
                                  setShowLanguageSelector(false);
                                }}
                                sx={{
                                  borderColor: '#10b981',
                                  color: '#10b981',
                                  '&:hover': {
                                    borderColor: '#059669',
                                    backgroundColor: '#f0fdf4'
                                  },
                                  '&:disabled': {
                                    borderColor: '#d1d5db',
                                    color: '#9ca3af'
                                  }
                                }}
                              >
                                {isAlreadyInList ? 'Bereits hinzugefügt' : 'Hinzufügen'}
                              </Button>
                            </Box>
                          );
                        })
                      ) : (
                        <Box sx={{ 
                          textAlign: 'center', 
                          py: 4,
                          color: '#94a3b8', 
                          fontStyle: 'italic'
                        }}>
                          Keine Sprachen in gespeicherten Daten verfügbar
                        </Box>
                      )}
                    </Box>
                  </DialogContent>
                </Dialog>
              </Box>
            )}

            {/* Motivationsschreiben wird jetzt in einem Dialog angezeigt */}
        
        {/* Warte-Animation für CV-Preview */}
        {loadingCvPreview && (
            <Box sx={{ 
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              my: 10,
              minHeight: '360px'
            }}>
              <Box sx={{ 
                position: 'relative', 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                minHeight: '136px'
              }}>
                {/* Zentrale Warte-Animation */}
                <CircularProgress size={54} sx={{ color: '#667eea' }} />
                
                {/* CV-Icon in der Mitte */}
                <Box
                  sx={{
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <DescriptionOutlinedIcon sx={{ fontSize: 27, color: '#667eea' }} />
                </Box>
              </Box>
              
              {/* Label unterhalb der Warte-Animation */}
              <Typography 
                variant="body2" 
                sx={{ 
                  color: '#666',
                  fontSize: '0.98rem',
                  fontWeight: 500,
                  textAlign: 'center',
                  mt: 3
                }}
              >
                {getTranslatedInfoMessage('loading_cv_preview')}
              </Typography>
            </Box>
        )}
        
        {/* Warte-Animation für Motivationsschreiben */}
        {creatingMotivation && (
            <Box sx={{ 
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              my: 10,
              minHeight: '360px'
            }}>
              <Box sx={{ 
                position: 'relative', 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                minHeight: '136px'
              }}>
                {/* Zentrale Warte-Animation */}
                <CircularProgress size={54} sx={{ color: '#667eea' }} />
                
                {/* Motivationsschreiben-Icon in der Mitte */}
                <Box
                  sx={{
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <MailOutlineIcon sx={{ fontSize: 27, color: '#667eea' }} />
                </Box>
              </Box>
              
              {/* Label unterhalb der Warte-Animation */}
              <Typography 
                variant="body2" 
                sx={{ 
                  color: '#666',
                  fontSize: '0.98rem',
                  fontWeight: 500,
                  textAlign: 'center',
                  mt: 3
                }}
              >
                {getTranslatedInfoMessage('creating_motivation')}
              </Typography>
            </Box>
        )}
        
        {/* CV-Daten Tabs - versteckt während Warte-Animationen */}
        {!extracting && !checkingMatch && !optimizing && !creatingMotivation && !loadingCvPreview && (
          <Box id="cv-data-section" sx={{ mb: 3 }}>
              <>
                <Tabs value={cvTabIndex} onChange={handleCvTabChange} variant="scrollable" scrollButtons="auto" sx={{ mb: 2 }}>
                  <Tab label={t('cv.tab.start')} />
                  <Tab label={t('cv.tab.data')} />
                </Tabs>
          
          {cvTabIndex === 1 && (
            <Box sx={{ mt: 3 }}>

              
              
            </Box>
          )}

          {cvTabIndex === 1 && (
            <Box sx={{ mt: 3 }}>
              {/* Info-Textbox für Tab 0 */}
              <Box sx={{ mb: 3 }}>
                <Alert 
                  severity="info" 
                  sx={{ 
                    borderRadius: 2,
                    backgroundColor: '#f0f7ff',
                    border: '1px solid #b3d9ff',
                    '& .MuiAlert-icon': {
                      color: '#1976d2'
                    }
                  }}
                >
                  <Typography variant="body2" sx={{ color: '#1976d2', fontWeight: 500 }}>
                    {currentLanguage === 'de' ? 'Mit einem Klick auf "Hinzufügen" kannst CV Daten aufnehmen. Du kannst mehr als nur ein Daten-Set aufnehmen. Welche Daten für Bewerbungen verwendet werden, kannst du in der Tabelle in der Spalte "Aktiv" angeben. Willst du eine neue Bewerbung starten, dann wechsle in den Tab "Bewerbungen".' :
                     currentLanguage === 'en' ? 'With a click on "Add" you can capture CV data. You can capture more than just one data set. Which data is used for applications, you can specify in the table in the "Active" column. If you want to start a new application, switch to the "Applications" tab.' :
                     currentLanguage === 'fr' ? 'Avec un clic sur "Ajouter", vous pouvez capturer les données CV. Vous pouvez capturer plus d\'un ensemble de données. Quelles données sont utilisées pour les candidatures, vous pouvez le spécifier dans le tableau dans la colonne "Actif". Si vous voulez commencer une nouvelle candidature, passez à l\'onglet "Candidatures".' :
                     'Con un clic su "Aggiungi" puoi acquisire i dati CV. Puoi acquisire più di un set di dati. Quali dati vengono utilizzati per le candidature, puoi specificarlo nella tabella nella colonna "Attivo". Se vuoi iniziare una nuova candidatura, passa alla scheda "Candidature".'}
                  </Typography>
                </Alert>
              </Box>
              {/* Tabelle: Meine CV Daten */}
              <Box 
                sx={{ 
                  border: 'none',
                  borderRadius: 3,
                  bgcolor: 'white',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  overflow: 'hidden',
                  mb: 3
                }}
              >
                <Box 
                  sx={{ 
                    p: 3, 
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white'
                  }}
                  onDragOver={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                  onDrop={async (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    // Prüfe ob Dateien gedroppt wurden
                    const files = e.dataTransfer.files;
                    if (files && files.length > 0) {
                      const file = files[0];
                      
                      // Prüfe Dateityp
                      const fileExt = file.name.split('.').pop()?.toLowerCase();
                      if (!fileExt || !['docx', 'doc', 'pdf', 'txt'].includes(fileExt)) {
                        setError('Nur Word-Dateien (.docx, .doc), PDF-Dateien (.pdf) und Text-Dateien (.txt) werden unterstützt.');
                        return;
                      }
                      
                      // Prüfe Dateigröße (max 10MB)
                      if (file.size > 10 * 1024 * 1024) {
                        setError('Datei ist zu groß. Maximale Größe: 10MB.');
                        return;
                      }
                      
                      // Starte CV-Import-Prozess
                      console.log('📄 Datei per Drag & Drop auf Header empfangen:', file.name);
                      setCvFile(file);
                      uploadOriginalDocument(file);
                    }
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <StorageIcon sx={{ fontSize: 28 }} />
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                        {getTranslatedCvLabel('Meine CV Daten')}
                      </Typography>
                    </Box>
                    <Button
                      variant="contained"
                      startIcon={<AddIcon />}
                      onClick={() => setShowAddCvModal(true)}
                      sx={{ 
                        bgcolor: 'rgba(255,255,255,0.2)',
                        border: '1px solid rgba(255,255,255,0.3)',
                        color: 'white',
                        fontWeight: 600,
                        fontSize: '0.75rem',
                        textTransform: 'uppercase',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        '&:hover': {
                          bgcolor: 'rgba(255,255,255,0.3)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 8px rgba(0,0,0,0.15)'
                        }
                      }}
                    >
                      {getTranslatedCvLabel('Hinzufügen')}
                    </Button>
                  </Box>
                </Box>
                
                <TableContainer sx={{ maxHeight: '550px', overflow: 'auto' }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600, color: '#374151', width: '50px', backgroundColor: '#f8fafc', position: 'sticky', top: 0, zIndex: 1 }}>
                          {getTranslatedCvLabel('Aktiv')}
                        </TableCell>
                        <TableCell sx={{ fontWeight: 600, color: '#374151', backgroundColor: '#f8fafc', position: 'sticky', top: 0, zIndex: 1 }}>
                          {getTranslatedCvLabel('CV Name')}
                        </TableCell>
                        <TableCell sx={{ fontWeight: 600, color: '#374151', backgroundColor: '#f8fafc', position: 'sticky', top: 0, zIndex: 1 }}>
                          {getTranslatedCvLabel('Erstellungsdatum')}
                        </TableCell>
                        <TableCell sx={{ fontWeight: 600, color: '#374151', backgroundColor: '#f8fafc', position: 'sticky', top: 0, zIndex: 1 }}>
                          {getTranslatedCvLabel('E-Mail')}
                        </TableCell>
                        <TableCell sx={{ fontWeight: 600, color: '#374151', width: '80px', backgroundColor: '#f8fafc', position: 'sticky', top: 0, zIndex: 1, textAlign: 'center' }}>
                          Aktion
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {userCvs.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={5} sx={{ textAlign: 'center', py: 4, color: '#6b7280' }}>
                            {getTranslatedCvLabel('Keine CV Daten vorhanden')}
                          </TableCell>
                        </TableRow>
                      ) : (
                        userCvs.map((cv, index) => (
                          <TableRow 
                            key={cv.cvId || index} 
                            sx={{ 
                              '&:hover': { bgcolor: '#f8fafc', cursor: 'pointer' },
                              bgcolor: selectedCvId === cv.cvId ? '#f0f9ff' : 'transparent'
                            }}
                            onClick={() => handleSelectCv(cv.cvId, false)}
                          >
                            <TableCell onClick={(e) => e.stopPropagation()}>
                              <Radio
                                checked={selectedCvId === cv.cvId}
                                onChange={() => handleSelectCv(cv.cvId, false)}
                                value={cv.cvId}
                                name="selected-cv"
                                sx={{
                                  color: '#667eea',
                                  '&.Mui-checked': {
                                    color: '#667eea',
                                  },
                                }}
                              />
                            </TableCell>
                            <TableCell sx={{ fontWeight: 500 }}>
                              {cv.cvName || `CV ${index + 1}`}
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2" sx={{ color: '#64748b', fontSize: '0.85rem' }}>
                                {cv.createdAt?.seconds 
                                  ? new Date(cv.createdAt.seconds * 1000).toLocaleDateString(currentLanguage, {
                                      year: 'numeric',
                                      month: 'short',
                                      day: 'numeric'
                                    })
                                  : cv.timestamp 
                                    ? new Date(cv.timestamp).toLocaleDateString(currentLanguage, {
                                        year: 'numeric',
                                        month: 'short',
                                        day: 'numeric'
                                      })
                                    : '-'}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              {cv.email || '-'}
                            </TableCell>
                            <TableCell sx={{ textAlign: 'center' }}>
                              <IconButton
                                size="small"
                                onClick={async (e) => {
                                  e.stopPropagation();
                                  if (!cv.cvId) {
                                    console.error('❌ Keine cvId gefunden für CV:', cv);
                                    return;
                                  }
                                  
                                  // Lösche Passgenauigkeit beim Klick auf das Zahnrad-Icon
                                  clearOptimizedAndMatchData();
                                  
                                  await handleSelectCv(cv.cvId, true);
                                }}
                                sx={{
                                  color: '#667eea',
                                  '&:hover': {
                                    backgroundColor: 'rgba(102, 126, 234, 0.1)',
                                    color: '#5a67d8'
                                  }
                                }}
                                title="CV-Daten bearbeiten"
                              >
                                <SettingsIcon fontSize="small" />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>

              
            </Box>
          )}
          
          {cvTabIndex === 0 && (
            <Box sx={{ mt: 3 }}>
              {/* Sub-Tabs für Bewerbungen - Nur für Admin sichtbar */}
              {isAdmin() && (
                <Tabs 
                  value={bewerbungenSubTabIndex} 
                  onChange={(e, newValue) => {
                    setBewerbungenSubTabIndex(newValue);
                    // Beim Wechsel zum Tab "Stellenbeschreibung" optimierte CV-Daten zurücksetzen
                    if (newValue === 1) {
                      clearOptimizedAndMatchData();
                      setCvTemplateHasBeenOpened(false);
                    }
                  }} 
                  variant="scrollable" 
                  scrollButtons="auto" 
                  sx={{ 
                    mb: 3,
                    borderBottom: 1,
                    borderColor: 'divider'
                  }}
                >
                  <Tab label={t('cv.subtab.applications')} />
                  <Tab label={t('cv.subtab.job.description')} />
                </Tabs>
              )}
              
              {/* Sub-Tab Content: Bewerbungen */}
              {bewerbungenSubTabIndex === 0 && (
              <Box>
              {/* Info-Textbox für Tab 1 */}
              <Box sx={{ mb: 3 }}>
                <Alert 
                  severity="info" 
                  sx={{ 
                    borderRadius: 2,
                    backgroundColor: '#f0f7ff',
                    border: '1px solid #b3d9ff',
                    '& .MuiAlert-icon': {
                      color: '#1976d2'
                    }
                  }}
                >
                  <Typography variant="body2" sx={{ color: '#1976d2', fontWeight: 500 }}>
                    {currentLanguage === 'de' ? 'Mit Klick auf "Hinzufügen" kannst du hier eine neue Bewerbung starten. In der Tabelle siehst du alle erstellten Bewerbungen. Mit Klick auf das Minimierungs-Icon kannst du Filter für die Tabelle einblenden.' :
                     currentLanguage === 'en' ? 'With a click on "Add" you can start a new application here. In the table you can see all created applications. With a click on the minimize icon you can show filters for the table.' :
                     currentLanguage === 'fr' ? 'Avec un clic sur "Ajouter", vous pouvez commencer une nouvelle candidature ici. Dans le tableau, vous pouvez voir toutes les candidatures créées. Avec un clic sur l\'icône de minimisation, vous pouvez afficher les filtres pour le tableau.' :
                     'Con un clic su "Aggiungi" puoi iniziare una nuova candidatura qui. Nella tabella puoi vedere tutte le candidature create. Con un clic sull\'icona di minimizzazione puoi mostrare i filtri per la tabella.'}
                  </Typography>
                </Alert>
              </Box>
              
              
              
              {/* Tabelle: Meine Bewerbungen */}
              <Box 
                sx={{ 
                  border: 'none',
                  borderRadius: 3,
                  bgcolor: 'white',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  overflow: 'hidden',
                  mb: 3
                }}
              >
                <Box 
                  sx={{ 
                    p: 3, 
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white'
                  }}
                  onDragOver={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                  onDrop={async (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    // Versuche URL aus verschiedenen Quellen zu extrahieren
                    let url = '';
                    
                    // 1. Aus text/uri-list (Standard für Links)
                    if (e.dataTransfer.types.includes('text/uri-list')) {
                      url = e.dataTransfer.getData('text/uri-list').split('\n')[0];
                    }
                    // 2. Aus text/plain (falls als Text gezogen)
                    else if (e.dataTransfer.types.includes('text/plain')) {
                      const text = e.dataTransfer.getData('text/plain').trim();
                      // Prüfe ob es eine URL ist
                      if (text.startsWith('http://') || text.startsWith('https://')) {
                        url = text;
                      }
                    }
                    
                    if (url && (url.startsWith('http://') || url.startsWith('https://'))) {
                      console.log('🔗 URL per Drag & Drop auf Header empfangen:', url);
                      // Wechsle zum Tab "Stellenbeschreibung"
                      setCvTabIndex(0);
                      setBewerbungenSubTabIndex(1);
                      clearOptimizedAndMatchData(); // Setze optimierte CV-Daten zurück
                      setCvTemplateHasBeenOpened(false); // Deaktiviere Motivationsschreiben-Icon
                      extractTextFromUrl(url);
                    } else {
                      console.log('⚠️ Keine gültige URL gefunden im Drop Event auf Header');
                      // Versuche trotzdem, den Text normal einzufügen
                      const text = e.dataTransfer.getData('text/plain');
                      if (text && text.trim()) {
                        // Wechsle zum Tab "Stellenbeschreibung"
                        setCvTabIndex(0);
                        setBewerbungenSubTabIndex(1);
                        clearOptimizedAndMatchData(); // Setze optimierte CV-Daten zurück
                        setCvTemplateHasBeenOpened(false); // Deaktiviere Motivationsschreiben-Icon
                        const trimmedText = text.trim();
                        setJobDescription(trimmedText.endsWith('\n\n') ? trimmedText : trimmedText + '\n\n');
                        // Extrahiere strukturierte Job-Informationen auch bei Drag&Drop von Text
                        if (trimmedText.length > 100) {
                          try {
                            setExtractingJobInfo(true);
                            console.log('🔍 Extrahiere Job-Informationen aus Drag&Drop-Text (Header)...');
                            const response = await fetch(`${config.backend.fullApiUrl}/api/extract-job-info`, {
                              method: 'POST',
                              headers: {
                                'Content-Type': 'application/json'
                              },
                              body: JSON.stringify({ text: trimmedText })
                            });
                            if (response.ok) {
                              const data = await response.json();
                              if (data.jobInfo && Object.keys(data.jobInfo).length > 0) {
                                setExtractedJobInfo(data.jobInfo);
                                console.log('✅ Job-Informationen aus Drag&Drop (Header) extrahiert:', data.jobInfo);
                              }
                            }
                          } catch (error) {
                            console.error('❌ Fehler bei Job-Info-Extraktion (Drag&Drop Header):', error);
                          } finally {
                            setExtractingJobInfo(false);
                          }
                        }
                      }
                    }
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <BusinessCenterOutlinedIcon sx={{ fontSize: 28 }} />
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                        {getTranslatedCvLabel('Meine Bewerbungen')}
                      </Typography>
                    </Box>
                    
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <IconButton
                        onClick={() => setShowDateFilters(!showDateFilters)}
                        sx={{
                          color: 'white',
                          '&:hover': {
                            bgcolor: 'rgba(255,255,255,0.1)'
                          }
                        }}
                        title={showDateFilters ? getTranslatedCvLabel('Datumsfilter verbergen') : getTranslatedCvLabel('Datumsfilter anzeigen')}
                      >
                        {showDateFilters ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                      </IconButton>
                      <Tooltip 
                        title={(!userCvs || userCvs.length === 0) ? getTranslatedInfoMessage('upload_cv_data_first') : ''}
                        arrow
                      >
                        <span>
                          <Button 
                            variant="contained" 
                            startIcon={<AddIcon />} 
                            onClick={() => {
                              // Lösche Passgenauigkeiten, optimierte CV-Daten und Motivationsschreiben
                              clearOptimizedAndMatchData();
                              // Deaktiviere Motivationsschreiben-Icon
                              setCvTemplateHasBeenOpened(false);
                              // Wechsle zum Sub-Tab "Stellenbeschreibung"
                              setCvTabIndex(0);
                              setBewerbungenSubTabIndex(1);
                            }}
                            disabled={!userCvs || userCvs.length === 0}
                            sx={{
                              bgcolor: 'rgba(255,255,255,0.2)',
                              border: '1px solid rgba(255,255,255,0.3)',
                              color: 'white',
                              fontWeight: 600,
                              fontSize: '0.75rem',
                              textTransform: 'uppercase',
                              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                              '&:hover': {
                                bgcolor: 'rgba(255,255,255,0.3)',
                                transform: 'translateY(-1px)',
                                boxShadow: '0 4px 8px rgba(0,0,0,0.15)'
                              },
                              '&:disabled': {
                                opacity: 0.5,
                                bgcolor: 'rgba(255,255,255,0.1)',
                                cursor: 'not-allowed'
                              }
                            }}
                          >
                            {getTranslatedCvLabel('Hinzufügen')}
                          </Button>
                        </span>
                      </Tooltip>
                    </Box>
                  </Box>
                </Box>
                
                {/* Datums-Filter und Checkbox */}
                {showDateFilters && (
                <Box sx={{ p: 2, bgcolor: '#f8fafc', borderBottom: '1px solid #e2e8f0', display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={showClosedApplications}
                        onChange={(e) => setShowClosedApplications(e.target.checked)}
                        disableRipple
                        disableFocusRipple
                        sx={{
                          '&:hover': { backgroundColor: 'transparent' },
                          '& .MuiTouchRipple-root': { display: 'none' },
                          color: '#667eea',
                          '&.Mui-checked': {
                            color: '#667eea',
                          },
                        }}
                      />
                    }
                    label={
                      <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 500 }}>
                        {getTranslatedCvLabel('Geschlossene Bewerbungen anzeigen')}
                      </Typography>
                    }
                  />
                  <TextField
                    label={getTranslatedCvLabel('Von')}
                    type="date"
                    value={applicationDateFrom}
                    onChange={(e) => setApplicationDateFrom(e.target.value)}
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{ 
                      width: '200px',
                      '& .MuiOutlinedInput-root': {
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#667eea'
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#667eea'
                        }
                      }
                    }}
                  />
                  <TextField
                    label={getTranslatedCvLabel('Bis')}
                    type="date"
                    value={applicationDateTo}
                    onChange={(e) => setApplicationDateTo(e.target.value)}
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{ 
                      width: '200px',
                      '& .MuiOutlinedInput-root': {
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#667eea'
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#667eea'
                        }
                      }
                    }}
                  />
                  {(applicationDateFrom || applicationDateTo) && (
                    <Button
                      size="small"
                      onClick={() => {
                        setApplicationDateFrom('');
                        setApplicationDateTo('');
                      }}
                      sx={{
                        color: '#64748b',
                        textTransform: 'none',
                        '&:hover': {
                          bgcolor: 'rgba(0,0,0,0.04)'
                        }
                      }}
                    >
                      Filter zurücksetzen
                    </Button>
                  )}
                </Box>
                )}
                
                {applications.filter(app => {
                  // Status-Filter
                  if (!showClosedApplications && app.status === 'Geschlossen') return false;
                  
                  // Datums-Filter
                  if (applicationDateFrom || applicationDateTo) {
                    const appDate = app.createdAt?.seconds 
                      ? new Date(app.createdAt.seconds * 1000)
                      : app.timestamp 
                        ? new Date(app.timestamp)
                        : null;
                    
                    if (!appDate) return false;
                    
                    if (applicationDateFrom) {
                      const fromDate = new Date(applicationDateFrom);
                      fromDate.setHours(0, 0, 0, 0);
                      if (appDate < fromDate) return false;
                    }
                    
                    if (applicationDateTo) {
                      const toDate = new Date(applicationDateTo);
                      toDate.setHours(23, 59, 59, 999);
                      if (appDate > toDate) return false;
                    }
                  }
                  
                  return true;
                }).length > 0 ? (
                  <TableContainer sx={{ maxHeight: '550px', overflow: 'auto' }}>
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.8rem', backgroundColor: '#f8fafc', position: 'sticky', top: 0, zIndex: 1 }}>
                            {getTranslatedCvLabel('Erstellt am')}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.8rem', backgroundColor: '#f8fafc', position: 'sticky', top: 0, zIndex: 1, width: '80px' }}>
                            Name
                          </TableCell>
                          <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.8rem', backgroundColor: '#f8fafc', position: 'sticky', top: 0, zIndex: 1 }}>
                            {getTranslatedCvLabel('Rollentitel')}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.8rem', backgroundColor: '#f8fafc', position: 'sticky', top: 0, zIndex: 1 }}>
                            {getTranslatedCvLabel('Firma')}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.8rem', backgroundColor: '#f8fafc', position: 'sticky', top: 0, zIndex: 1 }}>
                            {getTranslatedCvLabel('Status')}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {applications
                          .filter(app => {
                            // Status-Filter
                            if (!showClosedApplications && app.status === 'Geschlossen') return false;
                            
                            // Datums-Filter
                            if (applicationDateFrom || applicationDateTo) {
                              const appDate = app.createdAt?.seconds 
                                ? new Date(app.createdAt.seconds * 1000)
                                : app.timestamp 
                                  ? new Date(app.timestamp)
                                  : null;
                              
                              if (!appDate) return false;
                              
                              if (applicationDateFrom) {
                                const fromDate = new Date(applicationDateFrom);
                                fromDate.setHours(0, 0, 0, 0);
                                if (appDate < fromDate) return false;
                              }
                              
                              if (applicationDateTo) {
                                const toDate = new Date(applicationDateTo);
                                toDate.setHours(23, 59, 59, 999);
                                if (appDate > toDate) return false;
                              }
                            }
                            
                            return true;
                          })
                          .map((app) => (
                          <TableRow 
                            key={app.id} 
                            hover 
                            onClick={() => {
                              setSelectedApplication(app);
                              setEditableNotes(app.notes || '');
                              setEditableCompany(app.company || '');
                              setEditableIndustry(app.industry || '');
                              setEditableRoleTitle(app.roleTitle || '');
                              setShowApplicationDetailsModal(true);
                            }}
                            sx={{ 
                              '&:hover': { backgroundColor: '#f8fafc', cursor: 'pointer' },
                              transition: 'all 0.2s ease'
                            }}
                          >
                            <TableCell>
                              <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 500, fontSize: '0.85rem' }}>
                                {app.createdAt?.seconds 
                                  ? new Date(app.createdAt.seconds * 1000).toLocaleDateString(currentLanguage, {
                                      year: 'numeric',
                                      month: 'short',
                                      day: 'numeric'
                                    })
                                  : app.timestamp 
                                    ? new Date(app.timestamp).toLocaleDateString(currentLanguage, {
                                        year: 'numeric',
                                        month: 'short',
                                        day: 'numeric'
                                      })
                                    : '-'
                                }
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Avatar 
                                sx={{ 
                                  bgcolor: getColorFromString(app.fullName || app.cvName || fullName || ''), 
                                  width: 40, 
                                  height: 40,
                                  fontSize: '0.9rem',
                                  fontWeight: 600,
                                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                }}
                              >
                                {getInitials(app.fullName || app.cvName || fullName)}
                              </Avatar>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2" sx={{ color: '#1e293b', fontWeight: 600, fontSize: '0.9rem' }}>
                                {app.roleTitle || app.position || '-'}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2" sx={{ color: '#1e293b', fontWeight: 500, fontSize: '0.85rem' }}>
                                {app.company || '-'}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Chip 
                                label={getTranslatedCvLabel(app.status || 'Offen')}
                                size="small"
                                sx={{ 
                                  bgcolor: app.status === 'Vorstellungsgespräch' ? '#f59e0b' : 
                                           app.status === 'Geschlossen' ? '#6b7280' : '#3b82f6',
                                  color: 'white',
                                  fontWeight: 600,
                                  fontSize: '0.75rem'
                                }}
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <Box sx={{ p: 4, textAlign: 'center' }}>
                    <Typography variant="body2" sx={{ color: '#94a3b8', fontStyle: 'italic', fontSize: '0.9rem' }}>
                      {getTranslatedCvLabel('Keine Bewerbungen vorhanden')}
                    </Typography>
                  </Box>
                )}
              </Box>
              </Box>
              )}
              
              {/* Sub-Tab Content: Stellenbeschreibung */}
              {bewerbungenSubTabIndex === 1 && (
              <Box>
                {/* Info-Textbox für Stellenbeschreibung */}
                <Box sx={{ mb: 3 }}>
                  <Alert 
                    severity="info" 
                    sx={{ 
                      borderRadius: 2,
                      backgroundColor: '#f0f7ff',
                      border: '1px solid #b3d9ff',
                      '& .MuiAlert-icon': {
                        color: '#1976d2'
                      }
                    }}
                  >
                    <Typography variant="body2" sx={{ color: '#1976d2', fontWeight: 500 }}>
                      {currentLanguage === 'de' ? 'Bitte gib hier die Stellenbeschreibung ein, für die du einen CV optimieren willst. Hierzu kannst du den Text der Stellenbeschreibung in das untenstehende Textfeld kopieren oder einfach die URL der Webseite in das Textfeld ziehen.' :
                       currentLanguage === 'en' ? 'Please enter the job description here for which you want to optimize a CV. You can copy the job description text into the text field below or simply drag the website URL into the text field.' :
                       currentLanguage === 'fr' ? 'Veuillez saisir ici la description du poste pour lequel vous souhaitez optimiser un CV. Vous pouvez copier le texte de la description du poste dans le champ de texte ci-dessous ou simplement faire glisser l\'URL du site web dans le champ de texte.' :
                       'Si prega di inserire qui la descrizione del lavoro per cui si desidera ottimizzare un CV. Puoi copiare il testo della descrizione del lavoro nel campo di testo sottostante o semplicemente trascinare l\'URL del sito web nel campo di testo.'}
                    </Typography>
                  </Alert>
                </Box>
                
                {/* Stellenbeschreibung Textfeld */}
                {(!jobDescription || !jobDescription.trim()) && (
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mb: 3 }}>
                    {/* Stellenbeschreibung Textfeld */}
                    <Box sx={{ position: 'relative', display: 'flex', flexDirection: 'column', height: '350px' }}>
                      {/* Text-Hinweis für Drag&Drop/Copy&Paste */}
                      {(!jobDescription || !jobDescription.trim()) && !extractingJobUrl && (
                        <Box sx={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          pointerEvents: 'none',
                          zIndex: 1
                        }}>
                          <Typography variant="body1" sx={{ 
                            color: '#64748b', 
                            fontWeight: 500, 
                            fontSize: '1rem',
                            textAlign: 'center',
                            whiteSpace: 'pre-line'
                          }}>
                            {getTranslatedCvLabel('Bitte Stellenbeschreibung eingeben. Copy&Paste oder URL Drag&Drop')}
                          </Typography>
                        </Box>
                      )}
                      <TextField 
                      value={jobDescription} 
                      onChange={handleJobDescriptionChange}
                      onKeyDown={(e) => {
                        // Enter: Passgenauigkeit prüfen (ohne Eingabe zu erlauben)
                        if (e.key === 'Enter' && !e.shiftKey) {
                          const isButtonEnabled = !checkingMatch && hasData() && jobDescription && jobDescription.trim();
                          if (isButtonEnabled && !checkingMatch && !optimizing) {
                            e.preventDefault();
                            handleCheckMatchScore();
                            return;
                          }
                        }
                        // Erlaube nur Paste-Shortcuts und Navigations-Tasten, blockiere sonst Keyboard-Eingaben
                        const isPasteCombo = ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'v') || (e.shiftKey && e.key === 'Insert');
                        const navKeys = ['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End','PageUp','PageDown','Tab'];
                        if (isPasteCombo || navKeys.includes(e.key)) {
                          return;
                        }
                        // Blockiere alle anderen Tasten (inkl. Backspace/Delete)
                        e.preventDefault();
                      }}
                      onBeforeInput={(e: any) => {
                        // Erlaube Einfügen per Paste/Drop; blockiere sonstige Tastatureingaben
                        const inputType = e?.inputType || '';
                        if (inputType === 'insertFromPaste' || inputType === 'insertFromDrop') {
                          return;
                        }
                        e.preventDefault();
                      }}
                      onPaste={async (e) => {
                        // Explizites Handling für Paste per Maus/Shortcut
                        const text = e.clipboardData.getData('text/plain');
                        if (text && text.trim()) {
                          e.preventDefault();
                          const trimmed = text.trim();
                          const withBreak = trimmed.endsWith('\n\n') ? trimmed : trimmed + '\n\n';
                          setJobDescription(withBreak);
                          if (trimmed.length > 100) {
                            try {
                              setExtractingJobInfo(true);
                              console.log('🔍 Extrahiere Job-Informationen aus Paste-Text...');
                              const response = await fetch(`${config.backend.baseUrl}/api/extract-job-info`, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ text: trimmed })
                              });
                              if (response.ok) {
                                const data = await response.json();
                                if (data.jobInfo && Object.keys(data.jobInfo).length > 0) {
                                  setExtractedJobInfo(data.jobInfo);
                                  console.log('✅ Job-Informationen aus Paste extrahiert:', data.jobInfo);
                                }
                              }
                            } catch (err) {
                              console.error('❌ Fehler bei Job-Info-Extraktion (Paste):', err);
                            } finally {
                              setExtractingJobInfo(false);
                            }
                          }
                        }
                      }}
                      onDragOver={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      onDrop={async (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        
                        // Versuche URL aus verschiedenen Quellen zu extrahieren
                        let url = '';
                        
                        // 1. Aus text/uri-list (Standard für Links)
                        if (e.dataTransfer.types.includes('text/uri-list')) {
                          url = e.dataTransfer.getData('text/uri-list').split('\n')[0];
                        }
                        // 2. Aus text/plain (falls als Text gezogen)
                        else if (e.dataTransfer.types.includes('text/plain')) {
                          const text = e.dataTransfer.getData('text/plain').trim();
                          // Prüfe ob es eine URL ist
                          if (text.startsWith('http://') || text.startsWith('https://')) {
                            url = text;
                          }
                        }
                        
                        if (url && (url.startsWith('http://') || url.startsWith('https://'))) {
                          console.log('🔗 URL per Drag & Drop empfangen:', url);
                          extractTextFromUrl(url);
                        } else {
                          console.log('⚠️ Keine gültige URL gefunden im Drop Event');
                          // Versuche trotzdem, den Text normal einzufügen
                          const text = e.dataTransfer.getData('text/plain');
                          if (text && text.trim()) {
                            const trimmedText = text.trim();
                            setJobDescription(trimmedText.endsWith('\n\n') ? trimmedText : trimmedText + '\n\n');
                            // Extrahiere strukturierte Job-Informationen auch bei Drag&Drop von Text
                            if (trimmedText.length > 100) {
                              try {
                                setExtractingJobInfo(true);
                                console.log('🔍 Extrahiere Job-Informationen aus Drag&Drop-Text...');
                                const response = await fetch(`${config.backend.baseUrl}/api/extract-job-info`, {
                                  method: 'POST',
                                  headers: {
                                    'Content-Type': 'application/json'
                                  },
                                  body: JSON.stringify({ text: trimmedText })
                                });
                                if (response.ok) {
                                  const data = await response.json();
                                  if (data.jobInfo && Object.keys(data.jobInfo).length > 0) {
                                    setExtractedJobInfo(data.jobInfo);
                                    console.log('✅ Job-Informationen aus Drag&Drop extrahiert:', data.jobInfo);
                                  }
                                }
                              } catch (error) {
                                console.error('❌ Fehler bei Job-Info-Extraktion (Drag&Drop):', error);
                              } finally {
                                setExtractingJobInfo(false);
                              }
                            }
                          }
                        }
                      }}
                      disabled={extractingJobUrl}
                      fullWidth 
                      multiline 
                      placeholder=""
                      InputProps={{
                        endAdornment: extractingJobUrl ? (
                          <Box sx={{ 
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 2
                          }}>
                            <CircularProgress size={60} thickness={4} sx={{ color: '#667eea' }} />
                            <Typography variant="body2" sx={{ color: '#667eea', fontWeight: 500 }}>
                              {getTranslatedCvLabel("Extrahiere Text von Webseite...")}
                            </Typography>
                          </Box>
                        ) : null
                      }}
                      sx={{
                        height: '100%',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 3,
                          height: '100%',
                          alignItems: 'flex-start',
                          position: 'relative',
                          overflow: 'hidden',
                          border: '2px dashed #cbd5e1',
                          '&:hover': {
                            borderColor: '#667eea',
                            borderStyle: 'dashed'
                          }
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                          border: 'none'
                        },
                        '& .MuiOutlinedInput-input': {
                          height: '100% !important',
                          overflow: 'hidden !important',
                          textAlign: 'center',
                          scrollbarWidth: 'none',
                          msOverflowStyle: 'none',
                          '&::-webkit-scrollbar': {
                            display: 'none'
                          }
                        },
                        '& .MuiOutlinedInput-input:placeholder-shown': {
                          textAlign: 'center'
                        },
                        '& .MuiOutlinedInput-root.Mui-focused': {
                          borderColor: '#667eea',
                          borderWidth: '2px',
                          borderStyle: 'dashed'
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                          color: '#667eea'
                        },
                        // Verstecke das Label während der Extraktion
                        '& .MuiInputLabel-root': extractingJobUrl ? {
                          display: 'none'
                        } : {},
                        // Zentriere den Platzhalter-Text horizontal und vertikal
                        '& .MuiOutlinedInput-input::placeholder': {
                          textAlign: 'center',
                          lineHeight: '350px',
                          opacity: 1
                        },
                        '& .MuiOutlinedInput-input:not(:placeholder-shown)': {
                          textAlign: 'left',
                          lineHeight: 'normal'
                        }
                      }}
                    />
                    </Box>
                  </Box>
                )}
                
                {/* Job-Informationen unter der Textbox */}
                {jobDescription && jobDescription.trim() && (
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mb: 3 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', height: '350px' }}>
                      <Paper 
                      sx={{ 
                        p: 3,
                        borderRadius: 3,
                        border: (extractedJobInfo || extractingJobInfo) ? '2px solid #e2e8f0' : '2px solid #e0e0e0',
                        boxShadow: (extractedJobInfo || extractingJobInfo) ? '0 2px 8px rgba(0,0,0,0.05)' : 'none',
                        bgcolor: (extractedJobInfo || extractingJobInfo) ? '#f8fafc' : '#f5f5f5',
                        opacity: (extractedJobInfo || extractingJobInfo) ? 1 : 0.5,
                        display: 'flex',
                        flexDirection: 'column',
                        transition: 'all 0.3s ease',
                        pointerEvents: (extractedJobInfo || extractingJobInfo) ? 'auto' : 'none',
                        height: '100%',
                        overflow: 'auto',
                        position: 'relative'
                      }}
                    >
                      {!extractingJobInfo && (
                        <Box sx={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'space-between', 
                          mb: 2,
                          position: 'relative'
                        }}>
                          <Typography variant="h6" sx={{ fontWeight: 700, color: extractedJobInfo ? '#1e293b' : '#9e9e9e', fontSize: '1rem', mb: 0 }}>
                            {getTranslatedCvLabel('Job-Informationen')}
                          </Typography>
                        </Box>
                      )}
                      
                      {/* Container für beide Icons mit Rahmen */}
                      {!extractingJobInfo && (
                        <Box
                          sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 3,
                            bgcolor: 'white',
                            border: '2px solid #e2e8f0',
                            borderRadius: '47px',
                            p: 1,
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                            zIndex: 2
                          }}
                        >
                          {/* Delete-Icon links */}
                          <Tooltip title={getTranslatedCvLabel('Job-Informationen löschen')}>
                            <span>
                              <IconButton
                                aria-label={getTranslatedCvLabel('Löschen')}
                                onClick={handleClearJobDescription}
                                disabled={!extractedJobInfo}
                                size="small"
                                sx={{ 
                                  color: extractedJobInfo ? '#64748b' : '#bdbdbd',
                                  p: 0.5
                                }}
                              >
                                <DeleteIcon sx={{ fontSize: 32 }} />
                              </IconButton>
                            </span>
                          </Tooltip>
                          
                          {/* Passgenauigkeit-Icon rechts */}
                          <Tooltip title={getTranslatedCvLabel('Passgenauigkeit prüfen')}>
                            <span>
                              <IconButton
                                aria-label={getTranslatedCvLabel('Passgenauigkeit prüfen')}
                                onClick={handleCheckMatchScore}
                                disabled={checkingMatch || !hasData() || !jobDescription || !jobDescription.trim()}
                                size="small"
                                sx={{ 
                                  color: (!checkingMatch && hasData() && jobDescription && jobDescription.trim()) ? '#667eea' : '#bdbdbd',
                                  bgcolor: 'transparent',
                                  p: 0.5,
                                  '&:hover .pg-circle': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 6px 16px rgba(102,126,234,0.35)'
                                  }
                                }}
                              >
                              <Box
                                className="pg-circle"
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  width: 72,
                                  height: 72,
                                  borderRadius: '50%',
                                  background: (!checkingMatch && hasData() && jobDescription && jobDescription.trim())
                                    ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                                    : 'linear-gradient(135deg, #e5e7eb 0%, #e5e7eb 100%)',
                                  boxShadow: (!checkingMatch && hasData() && jobDescription && jobDescription.trim())
                                    ? '0 4px 12px rgba(102,126,234,0.25)'
                                    : 'none',
                                  transition: 'all 0.15s ease',
                                  // Puls-Animation nur wenn nur dieses Icon aktiv ist (Motivationsschreiben muss inaktiv sein)
                                  animation: (!checkingMatch && hasData() && jobDescription && jobDescription.trim() && 
                                             matchScore === null && (!hasOptimizedCvData() || !cvTemplateHasBeenOpened) &&
                                             !(hasOptimizedCvData() && cvTemplateHasBeenOpened))
                                    ? 'pulseGentle 2s ease-in-out infinite'
                                    : 'none'
                                }}
                              >
                                <AssessmentOutlinedIcon sx={{ fontSize: 44, color: 'white' }} />
                              </Box>
                            </IconButton>
                            </span>
                          </Tooltip>

                          {/* CV-Optimierung-Icon */}
                          <Tooltip title={getTranslatedCvLabel('CV optimieren')}>
                            <span>
                              <IconButton
                                aria-label={getTranslatedCvLabel('CV optimieren')}
                                onClick={() => {
                                  if (!optimizing) {
                                    if (hasOptimizedCvData()) {
                                      handleOpenCvTemplate();
                                    } else {
                                      handleOptimizeCvParallel();
                                    }
                                  }
                                }}
                                disabled={optimizing || checkingMatch || !hasData() || !jobDescription || !jobDescription.trim() || matchScore === null}
                                size="small"
                                sx={{ 
                                  color: (!optimizing && !checkingMatch && hasData() && jobDescription && jobDescription.trim() && matchScore !== null) ? '#667eea' : '#bdbdbd',
                                  bgcolor: 'transparent',
                                  p: 0.5,
                                  '&:hover .cv-opt-circle': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 6px 16px rgba(102,126,234,0.35)'
                                  }
                                }}
                              >
                              <Box
                                className="cv-opt-circle"
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  width: 72,
                                  height: 72,
                                  borderRadius: '50%',
                                  background: (!optimizing && !checkingMatch && hasData() && jobDescription && jobDescription.trim() && matchScore !== null)
                                    ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                                    : 'linear-gradient(135deg, #e5e7eb 0%, #e5e7eb 100%)',
                                  boxShadow: (!optimizing && !checkingMatch && hasData() && jobDescription && jobDescription.trim() && matchScore !== null)
                                    ? '0 4px 12px rgba(102,126,234,0.25)'
                                    : 'none',
                                  transition: 'all 0.15s ease',
                                  // Puls-Animation nur wenn CV-Optimierung aktiv ist und Motivationsschreiben inaktiv
                                  animation: (!optimizing && !checkingMatch && hasData() && jobDescription && jobDescription.trim() && matchScore !== null &&
                                             !(hasOptimizedCvData() && cvTemplateHasBeenOpened))
                                    ? 'pulseGentle 2s ease-in-out infinite'
                                    : 'none'
                                }}
                              >
                                <DescriptionIcon sx={{ fontSize: 44, color: 'white' }} />
                              </Box>
                            </IconButton>
                            </span>
                          </Tooltip>

                          {/* Motivationsschreiben-Icon */}
                          <Tooltip title={getTranslatedCvLabel('Motivationsschreiben erstellen')}>
                            <span>
                              <IconButton
                                aria-label={getTranslatedCvLabel('Motivationsschreiben erstellen')}
                                onClick={handleCreateMotivation}
                                disabled={creatingMotivation || !cvTemplateHasBeenOpened}
                                size="small"
                                sx={{ 
                                  color: (!creatingMotivation && cvTemplateHasBeenOpened) ? '#667eea' : '#bdbdbd',
                                  bgcolor: 'transparent',
                                  p: 0.5,
                                  '&:hover .motivation-circle': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 6px 16px rgba(102,126,234,0.35)'
                                  }
                                }}
                              >
                              <Box
                                className="motivation-circle"
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  width: 72,
                                  height: 72,
                                  borderRadius: '50%',
                                  background: (!creatingMotivation && cvTemplateHasBeenOpened)
                                    ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                                    : 'linear-gradient(135deg, #e5e7eb 0%, #e5e7eb 100%)',
                                  boxShadow: (!creatingMotivation && cvTemplateHasBeenOpened)
                                    ? '0 4px 12px rgba(102,126,234,0.25)'
                                    : 'none',
                                  transition: 'all 0.15s ease',
                                  // Puls-Animation wenn Motivationsschreiben aktiv ist (nur wenn Preview geschlossen wurde)
                                  animation: (!creatingMotivation && cvTemplateHasBeenOpened)
                                    ? 'pulseGentle 2s ease-in-out infinite'
                                    : 'none'
                                }}
                              >
                                <MailOutlineIcon sx={{ fontSize: 44, color: 'white' }} />
                              </Box>
                            </IconButton>
                            </span>
                          </Tooltip>
                        </Box>
                      )}
                      
                      {extractingJobInfo ? (
                        <Box sx={{ 
                          flex: 1, 
                          display: 'flex', 
                          flexDirection: 'column', 
                          alignItems: 'center', 
                          justifyContent: 'center',
                          gap: 2,
                          opacity: 1
                        }}>
                          <CircularProgress size={60} thickness={4} sx={{ color: '#667eea' }} />
                          <Typography variant="body2" sx={{ color: '#667eea', fontWeight: 500 }}>
                            {getTranslatedCvLabel("Extrahiere Job-Informationen...")}
                          </Typography>
                        </Box>
                      ) : extractedJobInfo ? (
                        <>
                        {extractedJobInfo.roleTitle && (
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="caption" sx={{ 
                              fontWeight: 700, 
                              color: '#64748b', 
                              fontSize: '0.7rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block'
                            }}>
                              {getTranslatedCvLabel('Rollentitel')}
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#1e293b', fontWeight: 600 }}>
                              {extractedJobInfo.roleTitle}
                            </Typography>
                          </Box>
                        )}
                        
                        {(extractedJobInfo.company || extractedJobInfo.industry) && (
                          <Box sx={{ mb: 2, display: 'flex', gap: 3 }}>
                            {extractedJobInfo.company && (
                              <Box sx={{ flex: 1 }}>
                                <Typography variant="caption" sx={{ 
                                  fontWeight: 700, 
                                  color: '#64748b', 
                                  fontSize: '0.7rem',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.5px',
                                  display: 'block'
                                }}>
                                  {getTranslatedCvLabel('Firma')}
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#1e293b', fontWeight: 500 }}>
                                  {extractedJobInfo.company}
                                </Typography>
                              </Box>
                            )}
                            {extractedJobInfo.industry && (
                              <Box sx={{ flex: 1 }}>
                                <Typography variant="caption" sx={{ 
                                  fontWeight: 700, 
                                  color: '#64748b', 
                                  fontSize: '0.7rem',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.5px',
                                  display: 'block'
                                }}>
                                  {getTranslatedCvLabel('Branche')}
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#1e293b', fontWeight: 500 }}>
                                  {extractedJobInfo.industry}
                                </Typography>
                              </Box>
                            )}
                          </Box>
                        )}
                        
                        {extractedJobInfo.workload && (
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="caption" sx={{ 
                              fontWeight: 700, 
                              color: '#64748b', 
                              fontSize: '0.7rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block'
                            }}>
                              {getTranslatedCvLabel('Auslastung')}
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#1e293b', fontWeight: 500 }}>
                              {extractedJobInfo.workload}
                            </Typography>
                          </Box>
                        )}
                        
                        {extractedJobInfo.publishDate && (
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="caption" sx={{ 
                              fontWeight: 700, 
                              color: '#64748b', 
                              fontSize: '0.7rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block'
                            }}>
                              {getTranslatedCvLabel('Ausschreibedatum')}
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#1e293b', fontWeight: 500 }}>
                              {extractedJobInfo.publishDate}
                            </Typography>
                          </Box>
                        )}
                        
                        {extractedJobInfo.contactInfo && (
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="caption" sx={{ 
                              fontWeight: 700, 
                              color: '#64748b', 
                              fontSize: '0.7rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block'
                            }}>
                              {getTranslatedCvLabel('Kontaktdaten')}
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#1e293b', fontWeight: 500, fontSize: '0.85rem' }}>
                              {extractedJobInfo.contactInfo}
                            </Typography>
                          </Box>
                        )}

                        {extractedJobInfo.tasks && (
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="caption" sx={{ 
                              fontWeight: 700, 
                              color: '#64748b', 
                              fontSize: '0.7rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block'
                            }}>
                              {getTranslatedCvLabel('Aufgaben')}
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#1e293b', fontWeight: 400, whiteSpace: 'pre-wrap' }}>
                              {extractedJobInfo.tasks}
                            </Typography>
                          </Box>
                        )}

                        {extractedJobInfo.requirements && (
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="caption" sx={{ 
                              fontWeight: 700, 
                              color: '#64748b', 
                              fontSize: '0.7rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block'
                            }}>
                              {getTranslatedCvLabel('Anforderungen')}
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#1e293b', fontWeight: 400, whiteSpace: 'pre-wrap' }}>
                              {extractedJobInfo.requirements}
                            </Typography>
                          </Box>
                        )}

                        {extractedJobInfo.applicationDetails && (
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="caption" sx={{ 
                              fontWeight: 700, 
                              color: '#64748b', 
                              fontSize: '0.7rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block'
                            }}>
                              {getTranslatedCvLabel('Bewerbungsdetails')}
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#1e293b', fontWeight: 400, whiteSpace: 'pre-wrap' }}>
                              {extractedJobInfo.applicationDetails}
                            </Typography>
                          </Box>
                        )}
                        
                        {extractedJobInfo.keywords && extractedJobInfo.keywords.length > 0 && (
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="caption" sx={{ 
                              fontWeight: 700, 
                              color: '#64748b', 
                              fontSize: '0.7rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block',
                              mb: 1
                            }}>
                              {getTranslatedCvLabel('Schlüsselstichworte')}
                            </Typography>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                              {extractedJobInfo.keywords.map((keyword, idx) => (
                                <Chip 
                                  key={idx}
                                  label={keyword}
                                  size="small"
                                  sx={{ 
                                    bgcolor: '#667eea',
                                    color: 'white',
                                    fontSize: '0.7rem',
                                    fontWeight: 600,
                                    height: '24px'
                                  }}
                                />
                              ))}
                            </Box>
                          </Box>
                        )}

                        {/* Sprachauswahl Dropdown für Stellenbeschreibung */}
                        <Box sx={{ mt: 1 }}>
                          <Typography variant="caption" sx={{ 
                            fontWeight: 700, 
                            color: '#64748b', 
                            fontSize: '0.7rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                            display: 'block',
                            mb: 1
                          }}>
                            {getTranslatedCvLabel('Sprache Stellenbeschreibung')}
                          </Typography>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                            <FormControl size="small" sx={{ minWidth: 200 }}>
                              <Select
                                value={jobDescriptionLanguage}
                                onChange={(e) => setJobDescriptionLanguage(e.target.value)}
                                disabled={detectingLanguage}
                                displayEmpty
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: 2
                                  }
                                }}
                              >
                                <MenuItem value="DE">DE</MenuItem>
                                <MenuItem value="EN">EN</MenuItem>
                                <MenuItem value="FR">FR</MenuItem>
                                <MenuItem value="IT">IT</MenuItem>
                              </Select>
                            </FormControl>
                            {detectingLanguage && (
                              <CircularProgress size={16} />
                            )}
                          </Box>
                        </Box>
                        </>
                      ) : (
                        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <Typography variant="body2" sx={{ color: '#9e9e9e', textAlign: 'center', fontStyle: 'italic' }}>
                            {/* Text entfernt */}
                          </Typography>
                        </Box>
                      )}
                    </Paper>
                  </Box>
                </Box>
                )}
                
                {/* Zurück Button rechts ausgerichtet */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mb: 3 }}>
                  {/* Zurück Button */}
                  <Button
                    variant="outlined"
                    onClick={() => {
                      // Setze Stellenbeschreibung zurück
                      setJobDescription('');
                      // Zeige Stellenbeschreibung Textfeld an
                      setHideJobDescription(false);
                      // Zeige "Passgenauigkeit berechnen" Button an
                      setShowPassgenauigkeitButton(true);
                      // Verstecke CV-Optimieren Button
                      setShowCvOptimierenButton(false);
                      
                      // Lösche Passgenauigkeit
                      setMatchScore(null);
                      setMissingSkills([]);
                      setWeaknesses([]);
                      
                      // Lösche optimierte CV-Daten
                      setImprovedCvText(null);
                      setOptimizedShortProfile('');
                      setOptimizedWorkExperiences([]);
                      setMotivationLetter(null);
                      
                      // Lösche Job-Informationen
                      setExtractedJobInfo(null);
                      
                      // Wechsle zum "Start" Tab und Sub-Tab "Bewerbungen"
                      setCvTabIndex(0);
                      setBewerbungenSubTabIndex(0);
                      
                      // Deaktiviere Motivationsschreiben-Icon
                      setCvTemplateHasBeenOpened(false);
                      
                      // Leere nur die optimierten Ergebnisse, behalte Original-CV-Daten
                    }}
                    sx={{
                      px: 3,
                      py: 1.5,
                      borderRadius: 6,
                      borderColor: '#667eea',
                      color: '#757575',
                      fontWeight: 600,
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        borderColor: '#764ba2',
                        backgroundColor: '#f5f5f5',
                        transform: 'translateY(-1px)',
                      },
                    }}
                  >
                    {t('button.back.to.applications')}
                  </Button>
                </Box>
              </Box>
              )}
              
            </Box>
          )}
              </>
          </Box>
        )}
        
        {/* CV-Daten Modal */}
        <Dialog 
          open={showCvDataModal} 
          onClose={handleCloseCvDataModal}
          maxWidth="lg"
          fullWidth
          PaperProps={{
            sx: {
              maxHeight: '90vh',
              height: '90vh',
              margin: '20px'
            }
          }}
        >
          <DialogTitle>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                <Typography variant="h6">
                  {getTranslatedCvLabel('CV-Daten')}
                </Typography>
                <TextField
                  value={currentCvName}
                  onChange={(e) => {
                    setCurrentCvName(e.target.value);
                    setHasUnsavedChanges(true);
                  }}
                  placeholder="CV Name"
                  size="small"
                  sx={{
                    minWidth: '150px',
                    width: 'fit-content',
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: 'white',
                      width: 'fit-content',
                      '& .MuiOutlinedInput-input': {
                        width: currentCvName ? `${Math.max(150, currentCvName.length * 8.5 + 60)}px` : '150px',
                        minWidth: '150px',
                        transition: 'width 0.2s ease',
                      },
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                        width: '100%',
                      },
                      '&:hover fieldset': {
                        borderColor: '#667eea',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#667eea',
                      }
                    }
                  }}
                />
              </Box>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Tooltip 
                  title="CV löschen"
                  arrow
                >
                  <span>
                    <IconButton 
                      size="small"
                      onClick={() => setShowDeleteCvDialog(true)}
                      disabled={!selectedCvId}
                      sx={{
                        color: '#94a3b8',
                        transition: 'all 0.2s ease',
                        borderRadius: '50%',
                        '&:hover': {
                          color: '#ef4444',
                          bgcolor: '#fef2f2',
                          transform: 'scale(1.1)',
                          borderRadius: '50%'
                        }
                      }}
                    >
                    <DeleteIcon />
                  </IconButton>
                  </span>
                </Tooltip>
                <Tooltip 
                  title="CV-Daten als CSV exportieren"
                  arrow
                >
                  <IconButton 
                    size="small"
                    onClick={exportCvDataAsCsv}
                    disabled={!selectedCvId}
                    sx={{
                      color: '#94a3b8',
                      transition: 'all 0.2s ease',
                      borderRadius: '50%',
                      '&:hover': {
                        color: '#667eea',
                        bgcolor: '#f0f4ff',
                        transform: 'scale(1.1)',
                        borderRadius: '50%'
                      }
                    }}
                  >
                    <DownloadIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip 
                  title={hasUnsavedChanges ? getTranslatedCvLabel('Daten speichern') : getTranslatedCvLabel('Keine Änderungen zum Speichern')}
                  arrow
                >
                  <span>
                    <IconButton 
                      onClick={async () => {
                        if (user) {
                          try {
                            // Speichere alle CV-Daten nach Firebase
                            await saveAllCvDataToFirebase();
                            
                            // Lade die gespeicherten Daten neu, um sicherzustellen dass sie für die nächste Berechnung verfügbar sind
                            await reloadCvDataFromBackend();
                            
                            // Setze ungespeicherte Änderungen zurück
                            setHasUnsavedChanges(false);
                            
                            // Zeige Erfolgs-Feedback
                            setError('✅ Daten gespeichert!');
                            setTimeout(() => setError(null), 2000);
                            
                            console.log('✅ CV-Daten erfolgreich in Firebase gespeichert und neu geladen');
                            
                            // Schließe das Modal nach dem Speichern
                            setShowCvDataModal(false);
                          } catch (error) {
                            console.error('❌ Fehler beim Speichern der CV-Daten:', error);
                            setError('❌ Fehler beim Speichern der Daten');
                            setTimeout(() => setError(null), 3000);
                          }
                        }
                      }}
                      disabled={!hasUnsavedChanges}
                      size="small"
                      sx={{
                        color: hasUnsavedChanges ? 'primary.main' : 'action.disabled',
                        transition: 'all 0.2s ease',
                        borderRadius: '50%',
                        '&:hover': {
                          bgcolor: hasUnsavedChanges ? 'rgba(102, 126, 234, 0.1)' : 'transparent',
                          borderRadius: '50%',
                          transform: hasUnsavedChanges ? 'scale(1.1)' : 'none'
                        }
                      }}
                    >
                      <SaveOutlinedIcon />
                    </IconButton>
                  </span>
                </Tooltip>
                <IconButton onClick={handleCloseCvDataModal}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent sx={{ p: 3, overflow: 'hidden' }}>
            {/* Allgemeine Info-Box für CV-Daten - wird nur gezeigt, wenn Passgenauigkeits-Bereich nicht sichtbar ist und keine Neuberechnung läuft */}
            {!((matchScore !== null || missingSkills.length > 0 || weaknesses.length > 0 || checkingMatchInModal) && !optimizing) && (
              <Box sx={{ mb: 2 }}>
                <Alert 
                  severity="info" 
                  sx={{ 
                    borderRadius: 2,
                    backgroundColor: '#e3f2fd',
                    border: '1px solid #90caf9',
                    '& .MuiAlert-icon': {
                      color: '#1976d2'
                    }
                  }}
                >
                  <Typography variant="body2" sx={{ color: '#1565c0', fontWeight: 500 }}>
                    {getTranslatedCvLabel('Bitte überprüfe deine CV-Daten genau und nimm nötige Änderungen direkt in dieser Maske vor.')}
                  </Typography>
                </Alert>
              </Box>
            )}
            
            {/* Info-Textbox oberhalb - nur wenn Passgenauigkeit vorhanden oder während Neuberechnung */}
            {(matchScore !== null || missingSkills.length > 0 || weaknesses.length > 0 || checkingMatchInModal) && !optimizing && (
              <Box sx={{ mb: 2 }}>
                <Alert 
                  severity="info" 
                  sx={{ 
                    borderRadius: 2,
                    backgroundColor: '#f0f7ff',
                    border: '1px solid #b3d9ff',
                    '& .MuiAlert-icon': {
                      color: '#1976d2'
                    }
                  }}
                >
                  <Typography variant="body2" sx={{ color: '#1976d2', fontWeight: 500 }}>
                    {currentLanguage === 'de' ? 'Hier siehst du die berechnete Passgenauigkeit. Diese sollte mindestens 75% betragen. Weiter findest du eine Liste mit fehlenden Erfahrungen und Schwächen, welche deine CV Daten im Vergleich mit der Stellenbeschreibung aufweisen. Du kannst nun deine CV Daten ergänzen, um die Passgenauigkeit zu erhöhen. Bleibe hier aber wahrheitsgetreu. Hast du eine Ergänzung vorgenommen, kannst du den Punkt mit der Checkbox bestätigen. Dies kann dir helfen die Übersicht nicht zu verlieren.' :
                     currentLanguage === 'en' ? 'Here you can see the calculated match score. This should be at least 75%. You will also find a list of missing experiences and weaknesses that your CV data has compared to the job description. You can now supplement your CV data to increase the match score. However, remain truthful. If you have made a supplement, you can confirm the point with the checkbox. This can help you not lose track.' :
                     currentLanguage === 'fr' ? 'Ici vous pouvez voir le score de correspondance calculé. Celui-ci devrait être d\'au moins 75%. Vous trouverez également une liste des expériences manquantes et des faiblesses que vos données CV ont par rapport à la description du poste. Vous pouvez maintenant compléter vos données CV pour augmenter le score de correspondance. Cependant, restez véridique. Si vous avez fait un complément, vous pouvez confirmer le point avec la case à cocher. Cela peut vous aider à ne pas perdre le fil.' :
                     'Qui puoi vedere il punteggio di corrispondenza calcolato. Questo dovrebbe essere almeno del 75%. Troverai anche un elenco di esperienze mancanti e debolezze che i tuoi dati CV hanno rispetto alla descrizione del lavoro. Ora puoi integrare i tuoi dati CV per aumentare il punteggio di corrispondenza. Tuttavia, rimani veritiero. Se hai fatto un\'integrazione, puoi confermare il punto con la casella di controllo. Questo può aiutarti a non perdere il filo.'}
                  </Typography>
                </Alert>
              </Box>
            )}
            
            {/* Flex Container für Sidebar (links) und Inhalt (rechts) */}
            <Box sx={{ display: 'flex', gap: 3, minHeight: 'calc(100vh - 280px)' }}>
              {/* Linke Sidebar: Passgenauigkeit (sticky) */}
              {(matchScore !== null || missingSkills.length > 0 || weaknesses.length > 0 || checkingMatchInModal) && !optimizing && (
                <Box sx={{ 
                  width: '320px', 
                  flexShrink: 0,
                  position: 'sticky',
                  top: 0,
                  alignSelf: 'flex-start',
                  height: 'fit-content'
                }}>
                  <Paper sx={{ p: 3, background: '#f8f9fa', border: '1px solid #dee2e6', minHeight: 'calc(100vh - 365px)', maxHeight: 'calc(100vh - 365px)', display: 'flex', flexDirection: 'column', position: 'relative' }}>
                    {/* Refresh-Icon in der linken oberen Ecke */}
                    <IconButton
                      onClick={handleRecalculateMatchScoreFromModal}
                      disabled={!hasUnsavedChanges || checkingMatchInModal || !jobDescription || !jobDescription.trim()}
                      sx={{
                        position: 'absolute',
                        top: 8,
                        left: 8,
                        zIndex: 10,
                        color: (!hasUnsavedChanges || checkingMatchInModal) ? '#999' : '#667eea',
                        '&:hover': {
                          backgroundColor: 'rgba(102, 126, 234, 0.1)',
                        },
                        '&.Mui-disabled': {
                          color: '#999',
                        }
                      }}
                      title="Passgenauigkeit neu berechnen"
                    >
                      <RefreshIcon />
                    </IconButton>
                    
                    {/* Ringe Container */}
                    {(matchScore !== null || checkingMatchInModal) && (
                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3, flexShrink: 0 }}>
                        <Box sx={{ position: 'relative', display: 'flex', width: '100%', height: '240px', justifyContent: 'center', alignItems: 'center', transform: 'translateX(13px)' }}>
                          {/* Grauer Hintergrund-Ring */}
                          <CircularProgress
                            variant={checkingMatchInModal ? "indeterminate" : "determinate"}
                            value={checkingMatchInModal ? undefined : 100}
                            size={240}
                            thickness={2}
                            sx={{
                              color: '#e0e0e0',
                              position: 'absolute',
                              top: 0,
                              left: 0,
                            }}
                          />
                          {/* Farbiger Fortschritts-Ring oder Warte-Animation */}
                          {checkingMatchInModal ? (
                            <CircularProgress
                              variant="indeterminate"
                              size={240}
                              thickness={2}
                              sx={{
                                color: '#667eea',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                              }}
                            />
                          ) : (
                            matchScore !== null && (
                              <CircularProgress
                                variant="determinate"
                                value={matchScore}
                                size={240}
                                thickness={2}
                                sx={{
                                  color: matchScore < 75 ? '#ef4444' : '#667eea', // Rot unter 75%, sonst violett
                                  position: 'absolute',
                                  top: 0,
                                  left: 0,
                                }}
                              />
                            )
                          )}
                          <Box
                            sx={{
                              top: 0,
                              left: 0,
                              bottom: 0,
                              right: 0,
                              position: 'absolute',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            {(checkingMatchInModal || matchScore !== null) && (
                              <Typography
                                variant="h5"
                                component="div"
                                sx={{ 
                                  fontWeight: 'normal',
                                  color: '#000000',
                                  m: 0,
                                  fontSize: '5rem',
                                  transform: 'translateX(-2px)'
                                }}
                              >
                                {checkingMatchInModal ? '..%' : `${Math.round(matchScore!)}%`}
                              </Typography>
                            )}
                          </Box>
                        </Box>
                        {/* Check-Icon unten rechts von den Ringen, oberhalb des Labels "Ergänzt" */}
                        <Box sx={{ position: 'relative', width: '100%', display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                          <Tooltip title={getTranslatedCvLabel('Passgenauigkeit akzeptieren')}>
                            <IconButton
                              onClick={async () => {
                                await saveAllCvDataToFirebase();
                                handleCloseCvDataModal();
                              }}
                              sx={{
                                color: matchScore !== null && matchScore < 75 ? '#ef4444' : '#667eea',
                                '&:hover': {
                                  backgroundColor: matchScore !== null && matchScore < 75 ? 'rgba(239, 68, 68, 0.1)' : 'rgba(102, 126, 234, 0.1)',
                                }
                              }}
                            >
                              <CheckCircleIcon sx={{ fontSize: 32 }} />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </Box>
                    )}

                    {/* Liste Container */}
                    {(missingSkills.length > 0 || weaknesses.length > 0 || checkingMatchInModal) && (
                      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1, flexShrink: 0 }}>
                          <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#000000' }}>
                            {getTranslatedCvLabel('Fehlende Skills/Erfahrungen:')}
                          </Typography>
                          <Typography variant="body2" sx={{ fontSize: '0.875rem', fontWeight: 'bold', color: '#000000' }}>
                            {getTranslatedCvLabel('Ergänzt')}
                          </Typography>
                        </Box>
                        <List 
                          dense
                          sx={{
                            flex: 1,
                            overflowY: 'auto',
                            pb: 1,
                            pr: 1.5,
                            minHeight: 0,
                            '&::-webkit-scrollbar': {
                              width: '8px',
                            },
                            '&::-webkit-scrollbar-track': {
                              backgroundColor: '#f1f1f1',
                              borderRadius: '4px',
                              marginRight: '4px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                              backgroundColor: '#9e9e9e',
                              borderRadius: '4px',
                              '&:hover': {
                                backgroundColor: '#757575',
                              },
                            },
                          }}
                        >
                          {missingSkills.map((skill, index) => (
                            !hiddenMissingSkills.has(index) && (
                              <ListItem key={index} sx={{ 
                                py: 0.5, 
                                pl: 2, 
                                border: '1px solid #e0e0e0',
                                borderRadius: 1,
                                mb: 1,
                                backgroundColor: 'white',
                                display: 'flex',
                                alignItems: 'center',
                                '&:hover': {
                                  backgroundColor: '#f5f5f5',
                                }
                              }}>
                                <ListItemText 
                                  primary={skill}
                                  primaryTypographyProps={{ 
                                    fontSize: '0.875rem',
                                    sx: { wordBreak: 'break-word' }
                                  }}
                                  sx={{ flex: 1 }}
                                />
                                <Checkbox
                                  checked={false}
                                  onChange={() => handleHideMissingSkill(index)}
                                  size="small"
                                  disableRipple
                                  disableFocusRipple
                                  sx={{ 
                                    '&:hover': { backgroundColor: 'transparent' },
                                    '& .MuiTouchRipple-root': { display: 'none' },
                                    color: '#667eea',
                                    marginLeft: 'auto',
                                    mr: -2,
                                    '&.Mui-checked': {
                                      color: '#667eea',
                                    },
                                  }}
                                />
                              </ListItem>
                            )
                          ))}
                          {weaknesses.map((weakness, index) => (
                            !hiddenWeaknesses.has(index) && (
                              <ListItem key={`weakness-${index}`} sx={{ 
                                py: 0.5, 
                                pl: 2, 
                                border: '1px solid #e0e0e0',
                                borderRadius: 1,
                                mb: 1,
                                backgroundColor: 'white',
                                display: 'flex',
                                alignItems: 'center',
                                '&:hover': {
                                  backgroundColor: '#f5f5f5',
                                }
                              }}>
                                <ListItemText 
                                  primary={weakness}
                                  primaryTypographyProps={{ 
                                    fontSize: '0.875rem',
                                    sx: { wordBreak: 'break-word' }
                                  }}
                                  sx={{ flex: 1 }}
                                />
                                <Checkbox
                                  checked={false}
                                  onChange={() => handleHideWeakness(index)}
                                  size="small"
                                  disableRipple
                                  disableFocusRipple
                                  sx={{ 
                                    '&:hover': { backgroundColor: 'transparent' },
                                    '& .MuiTouchRipple-root': { display: 'none' },
                                    color: '#667eea',
                                    marginLeft: 'auto',
                                    mr: -2,
                                    '&.Mui-checked': {
                                      color: '#667eea',
                                    },
                                  }}
                                />
                              </ListItem>
                            )
                          ))}
                        </List>
                      </Box>
                    )}
                  </Paper>
                </Box>
              )}
              
              {/* Rechter Bereich: Tabs und Inhalte */}
              <Box sx={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', pr: 1, maxHeight: 'calc(100vh - 280px)' }}>
                <Tabs value={tabIndex} onChange={handleTabChange} variant="scrollable" scrollButtons="auto" sx={{ mb: 2, position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1, borderBottom: '1px solid #e0e0e0' }}>
                  <Tab label={t('cv.personal.info')} />
                  <Tab label={t('cv.work.experience')} />
                  <Tab label={t('cv.education')} />
                  <Tab label={getTranslatedCvLabel('Weitere Angaben')} />
                </Tabs>
          
          {tabIndex === 0 && (
            <Box sx={{ mt: 3 }}>
              {/* Persönliche Angaben + Profilbild */}
              <Box sx={{ display: 'flex', gap: 3, mb: 3 }}>
                {/* Linke Seite: Persönliche Angaben */}
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h6" gutterBottom>{t('cv.personal.info')}</Typography>
                  <TextField label={t('cv.personal.fullname')} value={fullName} onChange={e => handleFullNameChange(e.target.value)} fullWidth sx={{ mb: 2 }} />
                  <TextField label={t('cv.personal.company')} value={company} onChange={e => handleCvDataChange(setCompany, e.target.value)} fullWidth sx={{ mb: 2 }} />
                  <TextField label={t('cv.personal.address')} value={address} onChange={e => handleCvDataChange(setAddress, e.target.value)} fullWidth sx={{ mb: 2 }} />
                  <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                    <TextField label={t('cv.personal.postal.code')} value={postalCode} onChange={e => handleCvDataChange(setPostalCode, e.target.value)} sx={{ width: '40%' }} />
                    <TextField label={t('cv.personal.city')} value={city} onChange={e => handleCvDataChange(setCity, e.target.value)} sx={{ width: '60%' }} />
                  </Box>
                  <TextField label={getTranslatedCvLabel('Land:').replace(':', '')} value={country} onChange={e => handleCvDataChange(setCountry, e.target.value)} fullWidth sx={{ mb: 2 }} />
                  <TextField 
                    label={getTranslatedCvLabel('Verfügbar ab:').replace(':', '')} 
                    type="date"
                    value={availableFrom || ''} 
                    onChange={e => handleCvDataChange(setAvailableFrom, e.target.value)} 
                    fullWidth 
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{ mb: 2 }} 
                  />
                  <TextField label={t('cv.personal.phone')} value={phoneNumber} onChange={e => handleCvDataChange(setPhoneNumber, e.target.value)} fullWidth sx={{ mb: 2 }} />
                  <TextField label={t('cv.personal.email')} value={email} onChange={e => handleCvDataChange(setEmail, e.target.value)} fullWidth sx={{ mb: 2 }} />
                  <TextField label={t('cv.personal.birthyear')} value={birthYear} onChange={e => handleCvDataChange(setBirthYear, e.target.value)} fullWidth sx={{ mb: 2 }} />
                                  <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel>{t('cv.personal.nationality')}</InputLabel>
                  <Select 
                    value={nationality} 
                    label={t('cv.personal.nationality')} 
                    onChange={e => handleCvDataChange(setNationality, e.target.value)}
                  >
                    <MenuItem value="">{t('cv.personal.nationality.select')}</MenuItem>
                    <MenuItem value="CH">CH - Schweiz</MenuItem>
                    <MenuItem value="DE">DE - Deutschland</MenuItem>
                    <MenuItem value="AT">AT - Österreich</MenuItem>
                    <MenuItem value="FR">FR - Frankreich</MenuItem>
                    <MenuItem value="IT">IT - Italien</MenuItem>
                    <MenuItem value="other">{t('cv.personal.nationality.other')}</MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel>{t('cv.personal.permit')}</InputLabel>
                  <Select 
                    value={residencePermit} 
                    label={t('cv.personal.permit')} 
                    onChange={e => handleCvDataChange(setResidencePermit, e.target.value)}
                  >
                    <MenuItem value="">{t('cv.personal.permit.select')}</MenuItem>
                    <MenuItem value="B">B - Aufenthaltsbewilligung</MenuItem>
                    <MenuItem value="C">C - Niederlassungsbewilligung</MenuItem>
                    <MenuItem value="G">G - Grenzgängerbewilligung</MenuItem>
                    <MenuItem value="L">L - Kurzaufenthaltsbewilligung</MenuItem>
                    <MenuItem value="Ci">Ci - Vorläufig aufgenommen</MenuItem>
                    <MenuItem value="N">N - Asylsuchend</MenuItem>
                    <MenuItem value="S">S - Schutzbedürftige</MenuItem>
                    <MenuItem value="Schweizer">Schweizer</MenuItem>
                    <MenuItem value="EU/EFTA">EU/EFTA</MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel>{t('cv.personal.civilstatus')}</InputLabel>
                  <Select 
                    value={civilStatus} 
                    label={t('cv.personal.civilstatus')} 
                    onChange={e => handleCvDataChange(setCivilStatus, e.target.value)}
                  >
                    <MenuItem value="">{t('cv.personal.civilstatus.select')}</MenuItem>
                    <MenuItem value="ledig">{t('cv.personal.civilstatus.single')}</MenuItem>
                    <MenuItem value="verheiratet">{t('cv.personal.civilstatus.married')}</MenuItem>
                    <MenuItem value="geschieden">{t('cv.personal.civilstatus.divorced')}</MenuItem>
                    <MenuItem value="verwitwet">{t('cv.personal.civilstatus.widowed')}</MenuItem>
                    <MenuItem value="eingetragene-partnerschaft">{t('cv.personal.civilstatus.registered-partnership')}</MenuItem>
                  </Select>
                </FormControl>
                </Box>
                
                {/* Rechte Seite: Profilbild und Signatur */}
                <Box sx={{ 
                  width: '220px', 
                  display: 'flex', 
                  flexDirection: 'column', 
                  gap: 3
                }}>
                  {/* Profilbild */}
                  <Box>
                    <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600 }}>
                      {getTranslatedCvLabel('Profilbild:')}
                    </Typography>
                    {profileImage ? (
                      <Box sx={{ position: 'relative', width: '100%', aspectRatio: '3/4' }}>
                        <img 
                          src={profileImage} 
                          alt="Profilbild" 
                          style={{ 
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: '8px',
                            border: '2px solid #e0e0e0'
                          }} 
                        />
                        <IconButton
                          size="small"
                          onClick={handleRemoveProfileImage}
                          sx={{
                            position: 'absolute',
                            top: 5,
                            right: 5,
                            backgroundColor: 'rgba(255,255,255,0.8)',
                            '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' }
                          }}
                          aria-label="Foto entfernen"
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                        {userRole === 'Admin' && (
                          <IconButton
                            size="small"
                            onClick={handleOptimizeImage}
                            disabled={optimizingImage}
                            sx={{
                              position: 'absolute',
                              top: 5,
                              left: 5,
                              backgroundColor: optimizingImage ? 'rgba(255,255,255,0.9)' : 'rgba(255,255,255,0.8)',
                              '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' },
                              transition: 'all 0.2s ease'
                            }}
                            aria-label="Bild optimieren"
                          >
                            {optimizingImage ? <CircularProgress size={16} /> : <AutoFixHighIcon fontSize="small" />}
                          </IconButton>
                        )}
                      </Box>
                    ) : (
                      <Button
                        variant="outlined"
                        component="label"
                        fullWidth
                        sx={{ 
                          height: 200, 
                          border: '2px dashed #28a745', 
                          borderRadius: 2,
                          color: '#28a745',
                          backgroundColor: '#f8fff9',
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 1,
                          '&:hover': {
                            backgroundColor: '#e8f5e8',
                            borderColor: '#1e7e34'
                          }
                        }}
                      >
                        <CloudUploadIcon sx={{ fontSize: 40 }} />
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontSize: '0.8rem' }}>
                          <span>Foto hochladen</span>
                          <span>(Kamera/Galerie)</span>
                        </Box>
                        <input
                          type="file"
                          hidden
                          accept="image/*"
                          capture="environment"
                          onChange={handleProfileImageUpload}
                        />
                      </Button>
                    )}
                    
                    {/* QR-Code Button - nur für Admin sichtbar */}
                    {userRole === 'Admin' && !profileImage && (
                      <Button
                        variant="outlined"
                        onClick={generatePhotoQrCode}
                        disabled={isGeneratingQr}
                        fullWidth
                        sx={{ 
                          height: 80, 
                          border: '2px dashed #007bff', 
                          borderRadius: 2, 
                          color: '#007bff',
                          backgroundColor: '#f0f8ff',
                          mt: 1,
                          '&:hover': {
                            backgroundColor: '#e6f3ff',
                            borderColor: '#0056b3'
                          }
                        }}
                        startIcon={isGeneratingQr ? <CircularProgress size={16} /> : <QrCodeIcon sx={{ fontSize: 24 }} />}
                      >
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', fontSize: '0.75rem' }}>
                          <span>Foto von</span>
                          <span>Smartphone laden</span>
                        </Box>
                      </Button>
                    )}
                  </Box>

                  {/* Signatur */}
                  <Box>
                    <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600 }}>
                      {getTranslatedCvLabel('Signatur:')}
                    </Typography>
                    {signature ? (
                      <Box sx={{ position: 'relative', width: '100%', height: '80px' }}>
                        <img 
                          src={signature} 
                          alt="Signatur" 
                          style={{ 
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                            borderRadius: '8px',
                            border: '1px solid #e0e0e0',
                            backgroundColor: 'white'
                          }} 
                        />
                        <IconButton
                          size="small"
                          onClick={handleRemoveSignature}
                          sx={{
                            position: 'absolute',
                            top: 5,
                            right: 5,
                            backgroundColor: 'rgba(255,255,255,0.8)',
                            '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' }
                          }}
                          aria-label="Signatur entfernen"
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    ) : (
                      <Button
                        variant="outlined"
                        component="label"
                        fullWidth
                        sx={{ 
                          height: 100, 
                          border: '2px dashed #ccc', 
                          borderRadius: 2,
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 1
                        }}
                      >
                        <EditIcon sx={{ fontSize: 32, color: '#666' }} />
                        <span style={{ fontSize: '0.8rem' }}>Signatur hochladen</span>
                        <input
                          type="file"
                          hidden
                          accept="image/*"
                          onChange={handleSignatureUpload}
                        />
                      </Button>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
          )}
          
          {tabIndex === 1 && (
            <Box sx={{ mt: 3 }}>
              {/* Kurzprofil */}
              <TextField 
                label={getTranslatedCvLabel('Kurzprofil')} 
                value={shortProfile} 
                onChange={e => handleCvDataChange(setShortProfile, e.target.value)} 
                fullWidth 
                multiline 
                minRows={3}
                maxRows={6}
                sx={{ 
                  mb: 3,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 3
                  }
                }}
              />
              
              {/* Kernkompetenzen */}
              <Box 
                sx={{ 
                  border: 'none',
                  borderRadius: 3,
                  bgcolor: 'white',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  overflow: 'hidden',
                  mb: 3
                }}
              >
                <Box sx={{ 
                  p: 3, 
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white'
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <StarOutlineIcon sx={{ fontSize: 28 }} />
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                        {getTranslatedCvLabel('Kernkompetenzen')}
                      </Typography>
                      <IconButton 
                        onClick={() => setShowCoreCompetenciesCollapsed(!showCoreCompetenciesCollapsed)}
                        sx={{ 
                          color: 'white',
                          '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' }
                        }}
                      >
                        {showCoreCompetenciesCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                      </IconButton>
                    </Box>
                    <Button 
                      variant="contained" 
                      startIcon={<AddIcon />} 
                      onClick={handleAddCoreCompetency}
                      sx={{
                        bgcolor: 'rgba(255,255,255,0.2)',
                        border: '1px solid rgba(255,255,255,0.3)',
                        color: 'white',
                        textTransform: 'uppercase',
                        fontWeight: 600,
                        px: 3,
                        py: 1.5,
                        borderRadius: 2,
                        backdropFilter: 'blur(10px)',
                        '&:hover': {
                          bgcolor: 'rgba(255,255,255,0.3)',
                          borderColor: 'rgba(255,255,255,0.5)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        },
                        transition: 'all 0.2s ease'
                      }}
                    >
                      {t('button.add')}
                    </Button>
                  </Box>
                </Box>
                
                {!showCoreCompetenciesCollapsed && (
                  <>
                    <Table>
                      <TableHead>
                        <TableRow sx={{ 
                          background: 'linear-gradient(90deg, #f8fafc 0%, #e2e8f0 100%)',
                          borderBottom: '2px solid #e2e8f0'
                        }}>
                          <TableCell sx={{ 
                            fontWeight: 700, 
                            color: '#1e293b', 
                            fontSize: '0.875rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                            {getTranslatedCvLabel('Beschreibung')}
                          </TableCell>
                          <TableCell sx={{ 
                            fontWeight: 700, 
                            color: '#1e293b', 
                            fontSize: '0.875rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {coreCompetencies.length > 0 ? (
                          [...coreCompetencies].map((comp, idx) => (
                            <TableRow key={idx} sx={{ 
                              borderBottom: '1px solid #f1f5f9',
                              transition: 'all 0.2s ease',
                              '&:hover': {
                                bgcolor: '#f8fafc',
                                transform: 'scale(1.01)',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                              }
                            }}>
                              <TableCell sx={{ py: 2 }}>
                                <TextField 
                                  variant="standard" 
                                  value={comp.competency || ''} 
                                  onChange={(e) => handleCoreCompetencyChange(idx, e.target.value)}
                                  fullWidth 
                                  size="small"
                                  InputProps={{ 
                                    disableUnderline: false,
                                    style: { 
                                      color: '#1e293b', 
                                      fontWeight: 600,
                                      fontSize: '0.9rem'
                                    }
                                  }}
                                  sx={{
                                    '& .MuiInput-underline:before': {
                                      borderBottom: '1px dotted #e2e8f0'
                                    },
                                    '& .MuiInput-underline:hover:before': {
                                      borderBottom: '1px dotted #cbd5e1'
                                    },
                                    '& .MuiInput-underline:after': {
                                      borderBottom: '2px solid #3b82f6'
                                    }
                                  }}
                                />
                              </TableCell>
                              <TableCell sx={{ py: 2, textAlign: 'right', pr: 2 }}>
                                <IconButton 
                                  size="small" 
                                  onClick={() => handleDeleteCoreCompetency(idx)}
                                  sx={{ 
                                    color: '#94a3b8',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                      color: '#ef4444',
                                      bgcolor: '#fef2f2',
                                      transform: 'scale(1.1)'
                                    }
                                  }}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={2} align="center" sx={{ 
                              py: 4, 
                              color: '#94a3b8', 
                              fontStyle: 'italic',
                              fontSize: '0.9rem'
                            }}>
                              Keine Kernkompetenzen hinzugefügt
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </>
                )}
              </Box>
              
              {/* Branchenerfahrungen */}
              <Box 
                sx={{ 
                  border: 'none',
                  borderRadius: 3,
                  bgcolor: 'white',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  overflow: 'hidden',
                  mb: 3
                }}
              >
                <Box sx={{ 
                  p: 3, 
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white'
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <BusinessCenterOutlinedIcon sx={{ fontSize: 28 }} />
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                        {getTranslatedCvLabel('Branchenerfahrungen')}
                      </Typography>
                      <IconButton 
                        onClick={() => setShowIndustryExperiencesCollapsed(!showIndustryExperiencesCollapsed)}
                        sx={{ 
                          color: 'white',
                          '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' }
                        }}
                      >
                        {showIndustryExperiencesCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                      </IconButton>
                    </Box>
                    <Button 
                      variant="contained" 
                      startIcon={<AddIcon />} 
                      onClick={handleAddIndustryExperience}
                      sx={{
                        bgcolor: 'rgba(255,255,255,0.2)',
                        border: '1px solid rgba(255,255,255,0.3)',
                        color: 'white',
                        textTransform: 'uppercase',
                        fontWeight: 600,
                        px: 3,
                        py: 1.5,
                        borderRadius: 2,
                        backdropFilter: 'blur(10px)',
                        '&:hover': {
                          bgcolor: 'rgba(255,255,255,0.3)',
                          borderColor: 'rgba(255,255,255,0.5)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        },
                        transition: 'all 0.2s ease'
                      }}
                    >
                      {t('button.add')}
                    </Button>
                  </Box>
                </Box>
                
                {!showIndustryExperiencesCollapsed && (
                  <>
                {industryExperiences.length > 0 ? (
                  industryExperiences.map((exp, idx) => (
                    <Box key={idx} sx={{ 
                      border: '2px solid #e2e8f0',
                      borderRadius: 3,
                      mb: 2,
                      mt: idx === 0 ? 3 : 0,
                      mx: 2,
                      overflow: 'hidden',
                      bgcolor: 'white',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
                        transform: 'translateY(-2px)',
                        borderColor: '#cbd5e1'
                      }
                    }}>
                      <Table>
                        <TableHead>
                          <TableRow sx={{ 
                            background: 'linear-gradient(90deg, #f8fafc 0%, #e2e8f0 100%)',
                            borderBottom: '2px solid #e2e8f0'
                          }}>
                            <TableCell sx={{ 
                              fontWeight: 700, 
                              color: '#1e293b', 
                              fontSize: '0.875rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px'
                            }}>
                              {getTranslatedCvLabel('Branche')}
                            </TableCell>
                            <TableCell sx={{ 
                              fontWeight: 700, 
                              color: '#1e293b', 
                              fontSize: '0.875rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px'
                            }}>
                              {getTranslatedCvLabel('Jahre')}
                            </TableCell>
                            <TableCell sx={{ 
                              fontWeight: 700, 
                              color: '#1e293b', 
                              fontSize: '0.875rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px'
                            }}>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell sx={{ py: 2 }}>
                              <TextField 
                                variant="standard" 
                                value={exp.industry || ''} 
                                onChange={(e) => handleIndustryExperienceChange(idx, 'industry', e.target.value)}
                                fullWidth 
                                size="small" 
                                InputProps={{ 
                                  disableUnderline: false,
                                  style: { 
                                    color: '#1e293b', 
                                    fontWeight: 600,
                                    fontSize: '0.9rem'
                                  }
                                }}
                                sx={{
                                  '& .MuiInput-underline:before': {
                                    borderBottom: '1px dotted #e2e8f0'
                                  },
                                  '& .MuiInput-underline:hover:before': {
                                    borderBottom: '1px dotted #cbd5e1'
                                  },
                                  '& .MuiInput-underline:after': {
                                    borderBottom: '2px solid #3b82f6'
                                  }
                                }}
                              />
                            </TableCell>
                            <TableCell sx={{ py: 2 }}>
                              <TextField 
                                variant="standard" 
                                value={exp.years || ''} 
                                onChange={(e) => handleIndustryExperienceChange(idx, 'years', e.target.value)}
                                fullWidth 
                                size="small" 
                                InputProps={{ 
                                  disableUnderline: false,
                                  style: { 
                                    color: '#64748b', 
                                    fontWeight: 500,
                                    fontSize: '0.9rem'
                                  }
                                }}
                                sx={{
                                  '& .MuiInput-underline:before': {
                                    borderBottom: '1px dotted #e2e8f0'
                                  },
                                  '& .MuiInput-underline:hover:before': {
                                    borderBottom: '1px dotted #cbd5e1'
                                  },
                                  '& .MuiInput-underline:after': {
                                    borderBottom: '2px solid #3b82f6'
                                  }
                                }}
                              />
                            </TableCell>
                            <TableCell sx={{ py: 2, textAlign: 'right', pr: 2 }}>
                              <IconButton 
                                size="small" 
                                onClick={() => handleDeleteIndustryExperience(idx)}
                                sx={{ 
                                  color: '#94a3b8',
                                  transition: 'all 0.2s ease',
                                  '&:hover': {
                                    color: '#ef4444',
                                    bgcolor: '#fef2f2',
                                    transform: 'scale(1.1)'
                                  }
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </Box>
                  ))
                ) : (
                  <Box sx={{ 
                    textAlign: 'center', 
                    py: 4,
                    color: '#94a3b8', 
                    fontStyle: 'italic',
                    fontSize: '0.9rem'
                  }}>
                    Keine Branchenerfahrungen verfügbar
                  </Box>
                )}
                  </>
                )}
              </Box>
              
              {/* Berufserfahrungen */}
              <Box 
                sx={{ 
                  border: 'none',
                  borderRadius: 3,
                  bgcolor: 'white',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  overflow: 'hidden',
                  mb: 3
                }}
              >
                <Box sx={{ 
                  p: 3, 
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white'
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <WorkOutlineIcon sx={{ fontSize: 28 }} />
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                        {t('cv.work.experience')}
                      </Typography>
                      <IconButton 
                        onClick={() => setShowWorkExperiencesCollapsed(!showWorkExperiencesCollapsed)}
                        sx={{ 
                          color: 'white',
                          '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' }
                        }}
                      >
                        {showWorkExperiencesCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                      </IconButton>
                    </Box>
                    <Button 
                      variant="contained" 
                      startIcon={<AddIcon />} 
                      onClick={() => setShowNewWorkExperienceForm(true)}
                      sx={{
                        bgcolor: 'rgba(255,255,255,0.2)',
                        border: '1px solid rgba(255,255,255,0.3)',
                        color: 'white',
                        textTransform: 'uppercase',
                        fontWeight: 600,
                        px: 3,
                        py: 1.5,
                        borderRadius: 2,
                        backdropFilter: 'blur(10px)',
                        '&:hover': {
                          bgcolor: 'rgba(255,255,255,0.3)',
                          borderColor: 'rgba(255,255,255,0.5)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        },
                        transition: 'all 0.2s ease'
                      }}
                    >
                      {t('button.add')}
                    </Button>
                  </Box>
                </Box>
                
                {!showWorkExperiencesCollapsed && (
                  <>
                {showNewWorkExperienceForm && (
                  <Box 
                    sx={{ 
                      border: '2px solid #e2e8f0',
                      borderRadius: 3,
                      mb: 3,
                      mt: 3,
                      mx: 2,
                      overflow: 'hidden',
                      bgcolor: 'white',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                      transition: 'all 0.2s ease'
                    }}
                  >
                    <Table>
                      <TableHead>
                        <TableRow sx={{ 
                          background: 'linear-gradient(90deg, #f8fafc 0%, #e2e8f0 100%)',
                          borderBottom: '2px solid #e2e8f0'
                        }}>
                          <TableCell sx={{ 
                            fontWeight: 700, 
                            color: '#1e293b', 
                            fontSize: '0.875rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                            {getTranslatedCvLabel('Firma')}
                          </TableCell>
                          <TableCell sx={{ 
                            fontWeight: 700, 
                            color: '#1e293b', 
                            fontSize: '0.875rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                            {getTranslatedCvLabel('Position')}
                          </TableCell>
                          <TableCell sx={{ 
                            fontWeight: 700, 
                            color: '#1e293b', 
                            fontSize: '0.875rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                            {getTranslatedCvLabel('Start')}
                          </TableCell>
                          <TableCell sx={{ 
                            fontWeight: 700, 
                            color: '#1e293b', 
                            fontSize: '0.875rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                            {getTranslatedCvLabel('Ende')}
                          </TableCell>
                          <TableCell sx={{ 
                            fontWeight: 700, 
                            color: '#1e293b', 
                            fontSize: '0.875rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell sx={{ py: 2 }}>
                            <TextField 
                              variant="standard" 
                              value={newWorkExperience.company || ''} 
                              onChange={(e) => handleNewWorkExperienceChange('company', e.target.value)}
                              fullWidth 
                              size="small" 
                              InputProps={{ 
                                disableUnderline: true,
                                style: { 
                                  color: '#1e293b', 
                                  fontWeight: 600,
                                  fontSize: '0.9rem'
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ py: 2 }}>
                            <TextField 
                              variant="standard" 
                              value={newWorkExperience.position || ''} 
                              onChange={(e) => handleNewWorkExperienceChange('position', e.target.value)}
                              fullWidth 
                              size="small" 
                              InputProps={{ 
                                disableUnderline: true,
                                style: { 
                                  color: '#1e293b', 
                                  fontWeight: 600,
                                  fontSize: '0.9rem'
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ py: 2 }}>
                            <TextField 
                              variant="standard" 
                              value={newWorkExperience.startDate || ''} 
                              onChange={(e) => handleNewWorkExperienceChange('startDate', e.target.value)}
                              fullWidth 
                              size="small" 
                              InputProps={{ 
                                disableUnderline: true,
                                style: { 
                                  color: '#64748b', 
                                  fontWeight: 500,
                                  fontSize: '0.9rem'
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ py: 2 }}>
                            <TextField 
                              variant="standard" 
                              value={newWorkExperience.endDate || ''} 
                              onChange={(e) => handleNewWorkExperienceChange('endDate', e.target.value)}
                              fullWidth 
                              size="small" 
                              InputProps={{ 
                                disableUnderline: true,
                                style: { 
                                  color: '#64748b', 
                                  fontWeight: 500,
                                  fontSize: '0.9rem'
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ py: 2 }}>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                              <Button 
                                variant="contained" 
                                onClick={handleAddNewWorkExperience}
                                sx={{
                                  bgcolor: 'rgba(255,255,255,0.2)',
                                  border: '1px solid rgba(255,255,255,0.3)',
                                  color: 'white',
                                  textTransform: 'none',
                                  fontWeight: 600,
                                  px: 2,
                                  py: 0.5,
                                  fontSize: '0.875rem',
                                  backdropFilter: 'blur(10px)',
                                  '&:hover': {
                                    bgcolor: 'rgba(255,255,255,0.3)',
                                    borderColor: 'rgba(255,255,255,0.5)'
                                  }
                                }}
                              >
                                Hinzufügen
                              </Button>
                              <Button 
                                variant="outlined" 
                                onClick={() => setShowNewWorkExperienceForm(false)}
                                sx={{
                                  borderColor: '#e2e8f0',
                                  color: '#64748b',
                                  textTransform: 'none',
                                  fontWeight: 600,
                                  px: 2,
                                  py: 0.5,
                                  fontSize: '0.875rem',
                                  '&:hover': {
                                    borderColor: '#cbd5e1',
                                    bgcolor: '#f8fafc'
                                  }
                                }}
                              >
                                Abbrechen
                              </Button>
                            </Box>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                    <Box sx={{ p: 2, bgcolor: '#f8fafc', borderTop: '1px solid #e2e8f0' }}>
                      <Typography variant="subtitle2" sx={{ 
                        fontWeight: 600, 
                        color: '#1e293b', 
                        mb: 1,
                        fontSize: '0.875rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}>
                        {getTranslatedCvLabel('Beschreibung')}
                      </Typography>
                      <TextField 
                        variant="standard" 
                        value={newWorkExperience.description || ''} 
                        onChange={(e) => handleNewWorkExperienceChange('description', e.target.value)}
                        fullWidth 
                        multiline
                        InputProps={{ 
                          disableUnderline: true,
                          style: { 
                            color: '#475569', 
                            fontWeight: 500,
                            fontSize: '0.9rem'
                          }
                        }}
                      />
                    </Box>
                  </Box>
                )}
                
                {workExperiences.length > 0 ? (
                  workExperiences
                    .map((exp, originalIdx) => ({ ...exp, originalIdx }))
                    .sort((a, b) => {
                      const aEndDate = a.endDate === 'Heute' ? new Date() : new Date(a.endDate || '1900-01-01');
                      const bEndDate = b.endDate === 'Heute' ? new Date() : new Date(b.endDate || '1900-01-01');
                      return bEndDate.getTime() - aEndDate.getTime();
                    })
                    .map((exp, idx) => (
                      <Box key={idx} sx={{ 
                        border: '2px solid #e2e8f0',
                        borderRadius: 3,
                        mb: 2,
                        mt: idx === 0 ? 3 : 0,
                        mx: 2,
                        overflow: 'hidden',
                        bgcolor: 'white',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
                          transform: 'translateY(-2px)',
                          borderColor: '#cbd5e1'
                        }
                      }}>
                        <Box sx={{ p: 2, bgcolor: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                          <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                            <Box sx={{ flex: 1 }}>
                              <Typography variant="caption" sx={{ 
                                fontWeight: 700, 
                                color: '#1e293b', 
                                fontSize: '0.75rem',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                display: 'block',
                                mb: 0.5
                              }}>
                                {getTranslatedCvLabel('Start')}
                              </Typography>
                              <TextField 
                                variant="standard" 
                                value={exp.startDate || ''} 
                                onChange={(e) => handleCvWorkExperienceChange(exp.originalIdx, 'startDate', e.target.value)}
                                fullWidth 
                                size="small" 
                                InputProps={{ 
                                  disableUnderline: false,
                                  style: { 
                                    color: '#64748b', 
                                    fontWeight: 500,
                                    fontSize: '0.9rem'
                                  }
                                }}
                                sx={{
                                  '& .MuiInput-underline:before': {
                                    borderBottom: '1px dotted #e2e8f0'
                                  },
                                  '& .MuiInput-underline:hover:before': {
                                    borderBottom: '1px dotted #cbd5e1'
                                  },
                                  '& .MuiInput-underline:after': {
                                    borderBottom: '2px solid #3b82f6'
                                  }
                                }}
                              />
                            </Box>
                            <Box sx={{ flex: 1 }}>
                              <Typography variant="caption" sx={{ 
                                fontWeight: 700, 
                                color: '#1e293b', 
                                fontSize: '0.75rem',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                display: 'block',
                                mb: 0.5
                              }}>
                                {getTranslatedCvLabel('Ende')}
                              </Typography>
                              <TextField 
                                variant="standard" 
                                value={exp.endDate || ''} 
                                onChange={(e) => handleCvWorkExperienceChange(exp.originalIdx, 'endDate', e.target.value)}
                                fullWidth 
                                size="small" 
                                InputProps={{ 
                                  disableUnderline: false,
                                  style: { 
                                    color: '#64748b', 
                                    fontWeight: 500,
                                    fontSize: '0.9rem'
                                  }
                                }}
                                sx={{
                                  '& .MuiInput-underline:before': {
                                    borderBottom: '1px dotted #e2e8f0'
                                  },
                                  '& .MuiInput-underline:hover:before': {
                                    borderBottom: '1px dotted #cbd5e1'
                                  },
                                  '& .MuiInput-underline:after': {
                                    borderBottom: '2px solid #3b82f6'
                                  }
                                }}
                              />
                            </Box>
                          </Box>
                          <Box sx={{ display: 'flex', gap: 2 }}>
                            <Box sx={{ flex: 1 }}>
                              <Typography variant="caption" sx={{ 
                                fontWeight: 700, 
                                color: '#1e293b', 
                                fontSize: '0.75rem',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                display: 'block',
                                mb: 0.5
                              }}>
                                {getTranslatedCvLabel('Firma')}
                              </Typography>
                              <TextField 
                                variant="standard" 
                                value={exp.company || ''} 
                                onChange={(e) => handleCvWorkExperienceChange(exp.originalIdx, 'company', e.target.value)}
                                fullWidth 
                                size="small" 
                                InputProps={{ 
                                  disableUnderline: false,
                                  style: { 
                                    color: '#1e293b', 
                                    fontWeight: 600,
                                    fontSize: '0.9rem'
                                  }
                                }}
                                sx={{
                                  '& .MuiInput-underline:before': {
                                    borderBottom: '1px dotted #e2e8f0'
                                  },
                                  '& .MuiInput-underline:hover:before': {
                                    borderBottom: '1px dotted #cbd5e1'
                                  },
                                  '& .MuiInput-underline:after': {
                                    borderBottom: '2px solid #3b82f6'
                                  }
                                }}
                              />
                            </Box>
                            <Box sx={{ flex: 1 }}>
                              <Typography variant="caption" sx={{ 
                                fontWeight: 700, 
                                color: '#1e293b', 
                                fontSize: '0.75rem',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                display: 'block',
                                mb: 0.5
                              }}>
                                {getTranslatedCvLabel('Position')}
                              </Typography>
                              <TextField 
                                variant="standard" 
                                value={exp.position || ''} 
                                onChange={(e) => handleCvWorkExperienceChange(exp.originalIdx, 'position', e.target.value)}
                                fullWidth 
                                size="small"
                                multiline
                                InputProps={{ 
                                  disableUnderline: false,
                                  style: { 
                                    color: '#1e293b', 
                                    fontWeight: 600,
                                    fontSize: '0.9rem'
                                  }
                                }}
                                sx={{
                                  '& .MuiInput-underline:before': {
                                    borderBottom: '1px dotted #e2e8f0'
                                  },
                                  '& .MuiInput-underline:hover:before': {
                                    borderBottom: '1px dotted #cbd5e1'
                                  },
                                  '& .MuiInput-underline:after': {
                                    borderBottom: '2px solid #3b82f6'
                                  }
                                }}
                              />
                            </Box>
                          </Box>
                          <Box>
                            <Typography variant="caption" sx={{ 
                              fontWeight: 700, 
                              color: '#1e293b', 
                              fontSize: '0.75rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block',
                              mb: 0.5,
                              mt: 2
                            }}>
                              {getTranslatedCvLabel('Beschreibung')}
                            </Typography>
                            <TextField 
                              variant="standard" 
                              value={exp.description || ''} 
                              onChange={(e) => handleCvWorkExperienceChange(exp.originalIdx, 'description', e.target.value)}
                              fullWidth 
                              multiline
                              InputProps={{ 
                                disableUnderline: false,
                                style: { 
                                  color: '#475569', 
                                  fontWeight: 500,
                                  fontSize: '0.9rem'
                                }
                              }}
                              sx={{
                                '& .MuiInput-underline:before': {
                                  borderBottom: '1px dotted #e2e8f0'
                                },
                                '& .MuiInput-underline:hover:before': {
                                  borderBottom: '1px dotted #cbd5e1'
                                },
                                '& .MuiInput-underline:after': {
                                  borderBottom: '2px solid #3b82f6'
                                }
                              }}
                            />
                          </Box>
                        </Box>
                        <Box sx={{ p: 2, textAlign: 'right', borderTop: '1px solid #e2e8f0' }}>
                          <IconButton 
                            size="small" 
                            onClick={() => handleDeleteWorkExperience(exp.originalIdx)}
                            sx={{ 
                              color: '#94a3b8',
                              transition: 'all 0.2s ease',
                              '&:hover': {
                                color: '#ef4444',
                                bgcolor: '#fef2f2',
                                transform: 'scale(1.1)'
                              }
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </Box>
                    ))
                ) : (
                  <Box sx={{ 
                    textAlign: 'center', 
                    py: 4,
                    color: '#94a3b8', 
                    fontStyle: 'italic',
                    fontSize: '0.9rem'
                  }}>
                    Keine Berufserfahrung hinzugefügt
                  </Box>
                )}
                  </>
                )}
              </Box>
            </Box>
          )}
          
          {tabIndex === 2 && (
            <Box sx={{ mt: 3 }}>
              
              {/* Ausbildung */}
              <Box 
                sx={{ 
                  border: 'none',
                  borderRadius: 3,
                  bgcolor: 'white',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  overflow: 'hidden',
                  mb: 3
                }}
              >
                <Box sx={{ 
                  p: 3, 
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white'
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <SchoolOutlinedIcon sx={{ fontSize: 28 }} />
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                        {getTranslatedCvLabel('Ausbildung')}
                      </Typography>
                      <IconButton 
                        onClick={() => setShowEducationCollapsed(!showEducationCollapsed)}
                        sx={{ 
                          color: 'white',
                          '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' }
                        }}
                      >
                        {showEducationCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                      </IconButton>
                    </Box>
                    <Button 
                      variant="contained" 
                      startIcon={<AddIcon />} 
                      onClick={handleAddEducation}
                      sx={{
                        bgcolor: 'rgba(255,255,255,0.2)',
                        border: '1px solid rgba(255,255,255,0.3)',
                        color: 'white',
                        textTransform: 'uppercase',
                        fontWeight: 600,
                        px: 3,
                        py: 1.5,
                        borderRadius: 2,
                        backdropFilter: 'blur(10px)',
                        '&:hover': {
                          bgcolor: 'rgba(255,255,255,0.3)',
                          borderColor: 'rgba(255,255,255,0.5)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        },
                        transition: 'all 0.2s ease'
                      }}
                    >
                      {t('button.add')}
                    </Button>
                  </Box>
                </Box>
                
                {!showEducationCollapsed && (
                  <>
                {educations.length > 0 ? (
                  educations.map((edu, idx) => (
                    <Box key={idx} sx={{ 
                      border: '2px solid #e2e8f0',
                      borderRadius: 3,
                      mb: 2,
                      mt: idx === 0 ? 3 : 0,
                      mx: 2,
                      overflow: 'hidden',
                      bgcolor: 'white',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
                        transform: 'translateY(-2px)',
                        borderColor: '#cbd5e1'
                      }
                    }}>
                      <Box sx={{ p: 2, bgcolor: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="caption" sx={{ 
                              fontWeight: 700, 
                              color: '#1e293b', 
                              fontSize: '0.75rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block',
                              mb: 0.5
                            }}>
                              {getTranslatedCvLabel('Start')}
                            </Typography>
                            <TextField 
                              variant="standard" 
                              value={edu.startDate || ''} 
                              onChange={(e) => handleEducationChange(idx, 'startDate', e.target.value)}
                              fullWidth 
                              size="small" 
                              InputProps={{ 
                                disableUnderline: false,
                                style: { 
                                  color: '#64748b', 
                                  fontWeight: 500,
                                  fontSize: '0.9rem'
                                }
                              }}
                              sx={{
                                '& .MuiInput-underline:before': {
                                  borderBottom: '1px dotted #e2e8f0'
                                },
                                '& .MuiInput-underline:hover:before': {
                                  borderBottom: '1px dotted #cbd5e1'
                                },
                                '& .MuiInput-underline:after': {
                                  borderBottom: '2px solid #3b82f6'
                                }
                              }}
                            />
                          </Box>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="caption" sx={{ 
                              fontWeight: 700, 
                              color: '#1e293b', 
                              fontSize: '0.75rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block',
                              mb: 0.5
                            }}>
                              {getTranslatedCvLabel('Ende')}
                            </Typography>
                            <TextField 
                              variant="standard" 
                              value={edu.endDate || ''} 
                              onChange={(e) => handleEducationChange(idx, 'endDate', e.target.value)}
                              fullWidth 
                              size="small" 
                              InputProps={{ 
                                disableUnderline: false,
                                style: { 
                                  color: '#64748b', 
                                  fontWeight: 500,
                                  fontSize: '0.9rem'
                                }
                              }}
                              sx={{
                                '& .MuiInput-underline:before': {
                                  borderBottom: '1px dotted #e2e8f0'
                                },
                                '& .MuiInput-underline:hover:before': {
                                  borderBottom: '1px dotted #cbd5e1'
                                },
                                '& .MuiInput-underline:after': {
                                  borderBottom: '2px solid #3b82f6'
                                }
                              }}
                            />
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="caption" sx={{ 
                              fontWeight: 700, 
                              color: '#1e293b', 
                              fontSize: '0.75rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block',
                              mb: 0.5
                            }}>
                              {getTranslatedCvLabel('Abschluss')}
                            </Typography>
                            <TextField 
                              variant="standard" 
                              value={edu.degree || ''} 
                              onChange={(e) => handleEducationChange(idx, 'degree', e.target.value)}
                              fullWidth 
                              size="small" 
                              InputProps={{ 
                                disableUnderline: false,
                                style: { 
                                  color: '#1e293b', 
                                  fontWeight: 600,
                                  fontSize: '0.9rem'
                                }
                              }}
                              sx={{
                                '& .MuiInput-underline:before': {
                                  borderBottom: '1px dotted #e2e8f0'
                                },
                                '& .MuiInput-underline:hover:before': {
                                  borderBottom: '1px dotted #cbd5e1'
                                },
                                '& .MuiInput-underline:after': {
                                  borderBottom: '2px solid #3b82f6'
                                }
                              }}
                            />
                          </Box>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="caption" sx={{ 
                              fontWeight: 700, 
                              color: '#1e293b', 
                              fontSize: '0.75rem',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                              display: 'block',
                              mb: 0.5
                            }}>
                              {getTranslatedCvLabel('Institution')}
                            </Typography>
                            <TextField 
                              variant="standard" 
                              value={edu.institution || ''} 
                              onChange={(e) => handleEducationChange(idx, 'institution', e.target.value)}
                              fullWidth 
                              size="small" 
                              InputProps={{ 
                                disableUnderline: false,
                                style: { 
                                  color: '#475569', 
                                  fontWeight: 500,
                                  fontSize: '0.9rem'
                                }
                              }}
                              sx={{
                                '& .MuiInput-underline:before': {
                                  borderBottom: '1px dotted #e2e8f0'
                                },
                                '& .MuiInput-underline:hover:before': {
                                  borderBottom: '1px dotted #cbd5e1'
                                },
                                '& .MuiInput-underline:after': {
                                  borderBottom: '2px solid #3b82f6'
                                }
                              }}
                            />
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{ p: 2, textAlign: 'right', borderTop: '1px solid #e2e8f0' }}>
                        <IconButton 
                          size="small" 
                          onClick={() => handleDeleteEducation(idx)}
                          sx={{ 
                            color: '#94a3b8',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                              color: '#ef4444',
                              bgcolor: '#fef2f2',
                              transform: 'scale(1.1)'
                            }
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Box>
                    </Box>
                  ))
                ) : (
                  <Box sx={{ 
                    textAlign: 'center', 
                    py: 4,
                    color: '#94a3b8', 
                    fontStyle: 'italic',
                    fontSize: '0.9rem'
                  }}>
                    Keine Ausbildung hinzugefügt
                  </Box>
                )}
                  </>
                )}
              </Box>

              {/* Zertifikate */}
              <Box 
                sx={{ 
                  border: 'none',
                  borderRadius: 3,
                  bgcolor: 'white',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  overflow: 'hidden',
                  mb: 3
                }}
              >
                <Box sx={{ 
                  p: 3, 
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white'
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <WorkspacePremiumOutlinedIcon sx={{ fontSize: 28 }} />
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                        {getTranslatedCvLabel('Zertifikate')}
                      </Typography>
                      <IconButton 
                        onClick={() => setShowCertificationsCollapsed(!showCertificationsCollapsed)}
                        sx={{ 
                          color: 'white',
                          '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' }
                        }}
                      >
                        {showCertificationsCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                      </IconButton>
                    </Box>
                    <Button 
                      variant="contained" 
                      startIcon={<AddIcon />} 
                      onClick={handleAddCertification}
                      sx={{
                        bgcolor: 'rgba(255,255,255,0.2)',
                        border: '1px solid rgba(255,255,255,0.3)',
                        color: 'white',
                        textTransform: 'uppercase',
                        fontWeight: 600,
                        px: 3,
                        py: 1.5,
                        borderRadius: 2,
                        backdropFilter: 'blur(10px)',
                        '&:hover': {
                          bgcolor: 'rgba(255,255,255,0.3)',
                          borderColor: 'rgba(255,255,255,0.5)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        },
                        transition: 'all 0.2s ease'
                      }}
                    >
                      {t('button.add')}
                    </Button>
                  </Box>
                </Box>
                {!showCertificationsCollapsed && (
                  <>
                    {certifications.length > 0 ? (
                      certifications.map((cert, idx) => (
                        <Box key={idx} sx={{ 
                          border: '2px solid #e2e8f0',
                          borderRadius: 3,
                          mb: 2,
                          mt: idx === 0 ? 3 : 0,
                          mx: 2,
                          overflow: 'hidden',
                          bgcolor: 'white',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
                            transform: 'translateY(-2px)',
                            borderColor: '#cbd5e1'
                          }
                        }}>
                          <Box sx={{ p: 2, bgcolor: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                            <Box sx={{ mb: 2 }}>
                              <Typography variant="caption" sx={{ 
                                fontWeight: 700, 
                                color: '#1e293b', 
                                fontSize: '0.75rem',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                display: 'block',
                                mb: 0.5
                              }}>
                                {getTranslatedCvLabel('Datum')}
                              </Typography>
                              <TextField
                                variant="standard"
                                value={cert.date || ''}
                                onChange={(e) => handleCertificationChange(idx, 'date', e.target.value)}
                                fullWidth
                                size="small"
                                InputProps={{
                                  disableUnderline: false,
                                  style: {
                                    color: '#475569',
                                    fontWeight: 500,
                                    fontSize: '0.9rem'
                                  }
                                }}
                                sx={{
                                  '& .MuiInput-underline:before': {
                                    borderBottom: '1px dotted #e2e8f0'
                                  },
                                  '& .MuiInput-underline:hover:before': {
                                    borderBottom: '1px dotted #cbd5e1'
                                  },
                                  '& .MuiInput-underline:after': {
                                    borderBottom: '2px solid #3b82f6'
                                  }
                                }}
                              />
                            </Box>
                            <Box sx={{ display: 'flex', gap: 2 }}>
                              <Box sx={{ flex: 1 }}>
                                <Typography variant="caption" sx={{ 
                                  fontWeight: 700, 
                                  color: '#1e293b', 
                                  fontSize: '0.75rem',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.5px',
                                  display: 'block',
                                  mb: 0.5
                                }}>
                                  {getTranslatedCvLabel('Name')}
                                </Typography>
                                <TextField 
                                  variant="standard" 
                                  value={cert.name || ''} 
                                  onChange={(e) => handleCertificationChange(idx, 'name', e.target.value)}
                                  fullWidth
                                  size="small"
                                  InputProps={{
                                    disableUnderline: false,
                                    style: {
                                      color: '#1e293b',
                                      fontWeight: 600,
                                      fontSize: '0.9rem'
                                    }
                                  }}
                                  sx={{
                                    '& .MuiInput-underline:before': {
                                      borderBottom: '1px dotted #e2e8f0'
                                    },
                                    '& .MuiInput-underline:hover:before': {
                                      borderBottom: '1px dotted #cbd5e1'
                                    },
                                    '& .MuiInput-underline:after': {
                                      borderBottom: '2px solid #3b82f6'
                                    }
                                  }}
                                />
                              </Box>
                              <Box sx={{ flex: 1 }}>
                                <Typography variant="caption" sx={{ 
                                  fontWeight: 700, 
                                  color: '#1e293b', 
                                  fontSize: '0.75rem',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.5px',
                                  display: 'block',
                                  mb: 0.5
                                }}>
                                  {getTranslatedCvLabel('Aussteller')}
                                </Typography>
                                <TextField 
                                  variant="standard" 
                                  value={cert.issuer || ''} 
                                  onChange={(e) => handleCertificationChange(idx, 'issuer', e.target.value)}
                                  fullWidth 
                                  size="small" 
                                  InputProps={{ 
                                    disableUnderline: false,
                                    style: { 
                                      color: '#64748b', 
                                      fontWeight: 500,
                                      fontSize: '0.9rem'
                                    }
                                  }}
                                  sx={{
                                    '& .MuiInput-underline:before': {
                                      borderBottom: '1px dotted #e2e8f0'
                                    },
                                    '& .MuiInput-underline:hover:before': {
                                      borderBottom: '1px dotted #cbd5e1'
                                    },
                                    '& .MuiInput-underline:after': {
                                      borderBottom: '2px solid #3b82f6'
                                    }
                                  }}
                                />
                              </Box>
                            </Box>
                          </Box>
                          <Box sx={{ p: 2, textAlign: 'right', borderTop: '1px solid #e2e8f0' }}>
                            <IconButton 
                              size="small" 
                              onClick={() => handleDeleteCertification(idx)}
                              sx={{ 
                                color: '#94a3b8',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                  color: '#ef4444',
                                  bgcolor: '#fef2f2',
                                  transform: 'scale(1.1)'
                                }
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Box>
                        </Box>
                      ))
                    ) : (
                      <Box sx={{ 
                        textAlign: 'center', 
                        py: 4,
                        color: '#64748b', 
                        fontStyle: 'italic',
                        fontSize: '0.9rem'
                      }}>
                        Keine Zertifikate hinzugefügt
                      </Box>
                    )}
                  </>
                )}
              </Box>

              {/* Sprachen */}
              <Box 
                sx={{ 
                  border: 'none',
                  borderRadius: 3,
                  bgcolor: 'white',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  overflow: 'hidden',
                  mb: 3
                }}
              >
                <Box sx={{ 
                  p: 3, 
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white'
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <LanguageOutlinedIcon sx={{ fontSize: 28 }} />
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                        {getTranslatedCvLabel('Sprachkenntnisse')}
                      </Typography>
                      <IconButton 
                        onClick={() => setShowLanguagesCollapsed(!showLanguagesCollapsed)}
                        sx={{ 
                          color: 'white',
                          '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' }
                        }}
                      >
                        {showLanguagesCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                      </IconButton>
                    </Box>
                    <Button 
                      variant="contained" 
                      startIcon={<AddIcon />} 
                      onClick={handleAddLanguage}
                      sx={{
                        bgcolor: 'rgba(255,255,255,0.2)',
                        border: '1px solid rgba(255,255,255,0.3)',
                        color: 'white',
                        textTransform: 'uppercase',
                        fontWeight: 600,
                        px: 3,
                        py: 1.5,
                        borderRadius: 2,
                        backdropFilter: 'blur(10px)',
                        '&:hover': {
                          bgcolor: 'rgba(255,255,255,0.3)',
                          borderColor: 'rgba(255,255,255,0.5)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        },
                        transition: 'all 0.2s ease'
                      }}
                    >
                      {t('button.add')}
                    </Button>
                  </Box>
                </Box>
                {!showLanguagesCollapsed && (
                  <>
                    <Table>
                      <TableHead>
                        <TableRow sx={{ 
                          background: 'linear-gradient(90deg, #f8fafc 0%, #e2e8f0 100%)',
                          borderBottom: '2px solid #e2e8f0'
                        }}>
                          <TableCell sx={{ 
                            fontWeight: 700, 
                            color: '#1e293b', 
                            fontSize: '0.875rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                            {getTranslatedCvLabel('Sprache')}
                          </TableCell>
                      <TableCell sx={{ 
                        fontWeight: 700, 
                        color: '#1e293b', 
                        fontSize: '0.875rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}>
                        {getTranslatedCvLabel('Niveau')}
                      </TableCell>
                      <TableCell sx={{ 
                        fontWeight: 700, 
                        color: '#1e293b', 
                        fontSize: '0.875rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                          {languages.length > 0 ? (
        languages.map((lang, idx) => (
                        <TableRow key={idx} sx={{ 
                          borderBottom: '1px solid #f1f5f9',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            bgcolor: '#f8fafc',
                            transform: 'scale(1.01)',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                          }
                        }}>
                          <TableCell sx={{ py: 2 }}>
                            <TextField 
                              variant="standard" 
                              value={lang.language || ''} 
                              onChange={(e) => handleLanguageTableChange(idx, 'language', e.target.value)}
                              fullWidth 
                              size="small" 
                              InputProps={{ 
                                disableUnderline: false,
                                style: { 
                                  color: '#1e293b', 
                                  fontWeight: 600,
                                  fontSize: '0.9rem'
                                }
                              }}
                              sx={{
                                '& .MuiInput-underline:before': {
                                  borderBottom: '1px dotted #e2e8f0'
                                },
                                '& .MuiInput-underline:hover:before': {
                                  borderBottom: '1px dotted #cbd5e1'
                                },
                                '& .MuiInput-underline:after': {
                                  borderBottom: '2px solid #3b82f6'
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ py: 2 }}>
                            <TextField 
                              variant="standard" 
                              value={lang.level || ''} 
                              onChange={(e) => handleLanguageTableChange(idx, 'level', e.target.value)}
                              fullWidth 
                              size="small" 
                              InputProps={{ 
                                disableUnderline: false,
                                style: { 
                                  color: '#64748b', 
                                  fontWeight: 500,
                                  fontSize: '0.9rem'
                                }
                              }}
                              sx={{
                                '& .MuiInput-underline:before': {
                                  borderBottom: '1px dotted #e2e8f0'
                                },
                                '& .MuiInput-underline:hover:before': {
                                  borderBottom: '1px dotted #cbd5e1'
                                },
                                '& .MuiInput-underline:after': {
                                  borderBottom: '2px solid #3b82f6'
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ py: 2, textAlign: 'right' }}>
                            <IconButton 
                              onClick={() => handleDeleteLanguage(idx)} 
                              size="small"
                              sx={{ 
                                color: '#94a3b8',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                  color: '#ef4444',
                                  bgcolor: '#fef2f2',
                                  transform: 'scale(1.1)'
                                }
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} sx={{ textAlign: 'center', py: 4, color: '#64748b', fontStyle: 'italic' }}>
                          Keine Sprachen hinzugefügt
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                  </>
                )}
              </Box>

              {/* IT Skills */}
              <Box 
                sx={{ 
                  border: 'none',
                  borderRadius: 3,
                  bgcolor: 'white',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  overflow: 'hidden',
                  mb: 3
                }}
              >
                <Box sx={{ 
                  p: 3, 
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white'
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <ComputerOutlinedIcon sx={{ fontSize: 28 }} />
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                        {getTranslatedCvLabel('IT-Kenntnisse')}
                      </Typography>
                      <IconButton 
                        onClick={() => setShowItSkillsCollapsed(!showItSkillsCollapsed)}
                        sx={{ 
                          color: 'white',
                          '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' }
                        }}
                      >
                        {showItSkillsCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                      </IconButton>
                    </Box>
                    <Button 
                      variant="contained" 
                      startIcon={<AddIcon />} 
                      onClick={handleAddItSkill}
                      sx={{
                        bgcolor: 'rgba(255,255,255,0.2)',
                        border: '1px solid rgba(255,255,255,0.3)',
                        color: 'white',
                        textTransform: 'uppercase',
                        fontWeight: 600,
                        px: 3,
                        py: 1.5,
                        borderRadius: 2,
                        backdropFilter: 'blur(10px)',
                        '&:hover': {
                          bgcolor: 'rgba(255,255,255,0.3)',
                          borderColor: 'rgba(255,255,255,0.5)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        },
                        transition: 'all 0.2s ease'
                      }}
                    >
                      {t('button.add')}
                    </Button>
                  </Box>
                </Box>
                {!showItSkillsCollapsed && (
                  <>
                    <Table>
                      <TableHead>
                        <TableRow sx={{ 
                          background: 'linear-gradient(90deg, #f8fafc 0%, #e2e8f0 100%)',
                          borderBottom: '2px solid #e2e8f0'
                        }}>
                          <TableCell sx={{ 
                            fontWeight: 700, 
                            color: '#1e293b', 
                            fontSize: '0.875rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                            {getTranslatedCvLabel('Skill')}
                          </TableCell>
                      <TableCell sx={{ 
                        fontWeight: 700, 
                        color: '#1e293b', 
                        fontSize: '0.875rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}>
                        {getTranslatedCvLabel('Niveau')}
                      </TableCell>
                      <TableCell sx={{ 
                        fontWeight: 700, 
                        color: '#1e293b', 
                        fontSize: '0.875rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                          {itSkills.length > 0 ? (
        itSkills.map((skill, idx) => (
                        <TableRow key={idx} sx={{ 
                          borderBottom: '1px solid #f1f5f9',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            bgcolor: '#f8fafc',
                            transform: 'scale(1.01)',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                          }
                        }}>
                          <TableCell sx={{ py: 2 }}>
                            <TextField 
                              variant="standard" 
                              value={skill.skill || ''} 
                              onChange={(e) => handleItSkillsChange(idx, 'skill', e.target.value)}
                              fullWidth 
                              size="small" 
                              InputProps={{ 
                                disableUnderline: false,
                                style: { 
                                  color: '#1e293b', 
                                  fontWeight: 600,
                                  fontSize: '0.9rem'
                                }
                              }}
                              sx={{
                                '& .MuiInput-underline:before': {
                                  borderBottom: '1px dotted #e2e8f0'
                                },
                                '& .MuiInput-underline:hover:before': {
                                  borderBottom: '1px dotted #cbd5e1'
                                },
                                '& .MuiInput-underline:after': {
                                  borderBottom: '2px solid #3b82f6'
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ py: 2 }}>
                            <TextField 
                              variant="standard" 
                              value={skill.level || ''} 
                              onChange={(e) => handleItSkillsChange(idx, 'level', e.target.value)}
                              fullWidth 
                              size="small" 
                              InputProps={{ 
                                disableUnderline: false,
                                style: { 
                                  color: '#64748b', 
                                  fontWeight: 500,
                                  fontSize: '0.9rem'
                                }
                              }}
                              sx={{
                                '& .MuiInput-underline:before': {
                                  borderBottom: '1px dotted #e2e8f0'
                                },
                                '& .MuiInput-underline:hover:before': {
                                  borderBottom: '1px dotted #cbd5e1'
                                },
                                '& .MuiInput-underline:after': {
                                  borderBottom: '2px solid #3b82f6'
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ py: 2, textAlign: 'right', pr: 2 }}>
                            <IconButton 
                              size="small" 
                              onClick={() => handleDeleteItSkill(idx)}
                              sx={{ 
                                color: '#94a3b8',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                  color: '#ef4444',
                                  bgcolor: '#fef2f2',
                                  transform: 'scale(1.1)'
                                }
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} align="center" sx={{ 
                          color: '#94a3b8', 
                          fontStyle: 'italic', 
                          py: 4,
                          fontSize: '0.9rem'
                        }}>
                          Keine IT-Kenntnisse hinzugefügt
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                  </>
                )}
              </Box>
            </Box>
          )}
          
          {tabIndex === 3 && (
            <Box sx={{ mt: 3 }}>
              
              {/* Hobbys */}
              <Box 
                sx={{ 
                  border: 'none',
                  borderRadius: 3,
                  bgcolor: 'white',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  overflow: 'hidden',
                  mb: 3
                }}
              >
                <Box sx={{ 
                  p: 3, 
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white'
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <SportsOutlinedIcon sx={{ fontSize: 28 }} />
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                        {getTranslatedCvLabel('Hobbys')}
                      </Typography>
                      <IconButton 
                        onClick={() => setShowHobbiesCollapsed(!showHobbiesCollapsed)}
                        sx={{ 
                          color: 'white',
                          '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' }
                        }}
                      >
                        {showHobbiesCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                      </IconButton>
                    </Box>
                    <Button 
                      variant="contained" 
                      startIcon={<AddIcon />} 
                      onClick={handleAddHobby}
                      sx={{
                        bgcolor: 'rgba(255,255,255,0.2)',
                        border: '1px solid rgba(255,255,255,0.3)',
                        color: 'white',
                        textTransform: 'uppercase',
                        fontWeight: 600,
                        px: 3,
                        py: 1.5,
                        borderRadius: 2,
                        backdropFilter: 'blur(10px)',
                        '&:hover': {
                          bgcolor: 'rgba(255,255,255,0.3)',
                          borderColor: 'rgba(255,255,255,0.5)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        },
                        transition: 'all 0.2s ease'
                      }}
                    >
                      {t('button.add')}
                    </Button>
                  </Box>
                </Box>
                {!showHobbiesCollapsed && (
                  <>
                    <Table>
                      <TableHead>
                        <TableRow sx={{ 
                          background: 'linear-gradient(90deg, #f8fafc 0%, #e2e8f0 100%)',
                          borderBottom: '2px solid #e2e8f0'
                        }}>
                          <TableCell sx={{ 
                            fontWeight: 700, 
                            color: '#1e293b', 
                            fontSize: '0.875rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                            {getTranslatedCvLabel('Hobby')}
                          </TableCell>
                          <TableCell sx={{ 
                            fontWeight: 700, 
                            color: '#1e293b', 
                            fontSize: '0.875rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                            {getTranslatedCvLabel('Beschreibung')}
                          </TableCell>
                          <TableCell sx={{ 
                            fontWeight: 700, 
                            color: '#1e293b', 
                            fontSize: '0.875rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                              {hobbies.length > 0 ? (
        hobbies.map((hobby, idx) => (
                            <TableRow key={idx} sx={{ 
                              borderBottom: '1px solid #f1f5f9',
                              transition: 'all 0.2s ease',
                              '&:hover': {
                                bgcolor: '#f8fafc',
                                transform: 'scale(1.01)',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                              }
                            }}>
                              <TableCell sx={{ py: 2 }}>
                                <TextField 
                                  variant="standard" 
                                  value={hobby.hobby || ''} 
                                  onChange={(e) => handleHobbyChange(idx, 'hobby', e.target.value)}
                                  fullWidth 
                                  size="small" 
                                  InputProps={{ 
                                    disableUnderline: false,
                                    style: { 
                                      color: '#1e293b', 
                                      fontWeight: 600,
                                      fontSize: '0.9rem'
                                    }
                                  }}
                                  sx={{
                                    '& .MuiInput-underline:before': {
                                      borderBottom: '1px dotted #e2e8f0'
                                    },
                                    '& .MuiInput-underline:hover:before': {
                                      borderBottom: '1px dotted #cbd5e1'
                                    },
                                    '& .MuiInput-underline:after': {
                                      borderBottom: '2px solid #3b82f6'
                                    }
                                  }}
                                />
                              </TableCell>
                              <TableCell sx={{ py: 2 }}>
                                <TextField 
                                  variant="standard" 
                                  value={hobby.description || ''} 
                                  onChange={(e) => handleHobbyChange(idx, 'description', e.target.value)}
                                  fullWidth 
                                  multiline
                                  size="small" 
                                  InputProps={{ 
                                    disableUnderline: false,
                                    style: { 
                                      color: '#64748b', 
                                      fontWeight: 500,
                                      fontSize: '0.9rem'
                                    }
                                  }}
                                  sx={{
                                    '& .MuiInput-underline:before': {
                                      borderBottom: '1px dotted #e2e8f0'
                                    },
                                    '& .MuiInput-underline:hover:before': {
                                      borderBottom: '1px dotted #cbd5e1'
                                    },
                                    '& .MuiInput-underline:after': {
                                      borderBottom: '2px solid #3b82f6'
                                    }
                                  }}
                                />
                              </TableCell>
                              <TableCell sx={{ py: 2, textAlign: 'right', pr: 2 }}>
                                <IconButton 
                                  size="small" 
                                  onClick={() => handleRemoveHobby(idx)}
                                  sx={{ 
                                    color: '#94a3b8',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                      color: '#ef4444',
                                      bgcolor: '#fef2f2',
                                      transform: 'scale(1.1)'
                                    }
                                  }}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={3} align="center" sx={{ 
                              color: '#94a3b8', 
                              fontStyle: 'italic', 
                              py: 4,
                              fontSize: '0.9rem'
                            }}>
                              Keine Hobbys hinzugefügt
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </>
                )}
              </Box>

              {/* Zusätzliche Angaben */}
              <Box 
                sx={{ 
                  border: 'none',
                  borderRadius: 3,
                  bgcolor: 'white',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  overflow: 'hidden',
                  mb: 3
                }}
              >
                <Box sx={{ 
                  p: 3, 
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white'
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <InfoOutlinedIcon sx={{ fontSize: 28 }} />
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                        {getTranslatedCvLabel('Weitere Angaben')}
                      </Typography>
                      <IconButton 
                        onClick={() => setShowAdditionalInfoCollapsed(!showAdditionalInfoCollapsed)}
                        sx={{ 
                          color: 'white',
                          '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' }
                        }}
                      >
                        {showAdditionalInfoCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                      </IconButton>
                    </Box>
                    <Button 
                      variant="contained" 
                      startIcon={<AddIcon />} 
                      onClick={handleAddAdditionalInfo}
                      sx={{
                        bgcolor: 'rgba(255,255,255,0.2)',
                        border: '1px solid rgba(255,255,255,0.3)',
                        color: 'white',
                        textTransform: 'uppercase',
                        fontWeight: 600,
                        px: 3,
                        py: 1.5,
                        borderRadius: 2,
                        backdropFilter: 'blur(10px)',
                        '&:hover': {
                          bgcolor: 'rgba(255,255,255,0.3)',
                          borderColor: 'rgba(255,255,255,0.5)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        },
                        transition: 'all 0.2s ease'
                      }}
                    >
                      {t('button.add')}
                    </Button>
                  </Box>
                </Box>
                {!showAdditionalInfoCollapsed && (
                  <>
                    <Table>
                      <TableHead>
                        <TableRow sx={{ 
                          background: 'linear-gradient(90deg, #f8fafc 0%, #e2e8f0 100%)',
                          borderBottom: '2px solid #e2e8f0'
                        }}>
                          <TableCell sx={{ 
                            fontWeight: 700, 
                            color: '#1e293b', 
                            fontSize: '0.875rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                            {getTranslatedCvLabel('Angabe')}
                          </TableCell>
                      <TableCell sx={{ 
                        fontWeight: 700, 
                        color: '#1e293b', 
                        fontSize: '0.875rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}>
                        {getTranslatedCvLabel('Beschreibung')}
                      </TableCell>
                      <TableCell sx={{ 
                        fontWeight: 700, 
                        color: '#1e293b', 
                        fontSize: '0.875rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                          {additionalInfo.length > 0 ? (
        additionalInfo.map((info, idx) => (
                        <TableRow key={idx} sx={{ 
                          borderBottom: '1px solid #f1f5f9',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            bgcolor: '#f8fafc',
                            transform: 'scale(1.01)',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                          }
                        }}>
                          <TableCell sx={{ py: 2 }}>
                            <TextField 
                              variant="standard" 
                              value={info.info || ''} 
                              onChange={(e) => handleAdditionalInfoChange(idx, 'info', e.target.value)}
                              fullWidth 
                              size="small" 
                              InputProps={{ 
                                disableUnderline: false,
                                style: { 
                                  color: '#1e293b', 
                                  fontWeight: 600,
                                  fontSize: '0.9rem'
                                }
                              }}
                              sx={{
                                '& .MuiInput-underline:before': {
                                  borderBottom: '1px dotted #e2e8f0'
                                },
                                '& .MuiInput-underline:hover:before': {
                                  borderBottom: '1px dotted #cbd5e1'
                                },
                                '& .MuiInput-underline:after': {
                                  borderBottom: '2px solid #3b82f6'
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ py: 2 }}>
                            <TextField 
                              variant="standard" 
                              value={info.details || ''} 
                              onChange={(e) => handleAdditionalInfoChange(idx, 'details', e.target.value)}
                              fullWidth 
                              multiline
                              size="small" 
                              InputProps={{ 
                                disableUnderline: false,
                                style: { 
                                  color: '#64748b', 
                                  fontWeight: 500,
                                  fontSize: '0.9rem'
                                }
                              }}
                              sx={{
                                '& .MuiInput-underline:before': {
                                  borderBottom: '1px dotted #e2e8f0'
                                },
                                '& .MuiInput-underline:hover:before': {
                                  borderBottom: '1px dotted #cbd5e1'
                                },
                                '& .MuiInput-underline:after': {
                                  borderBottom: '2px solid #3b82f6'
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ py: 2, textAlign: 'right', pr: 2 }}>
                            <IconButton 
                              size="small" 
                              onClick={() => handleDeleteAdditionalInfo(idx)}
                              sx={{ 
                                color: '#94a3b8',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                  color: '#ef4444',
                                  bgcolor: '#fef2f2',
                                  transform: 'scale(1.1)'
                                }
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} align="center" sx={{ 
                          color: '#94a3b8', 
                          fontStyle: 'italic', 
                          py: 4,
                          fontSize: '0.9rem'
                        }}>
                          Keine weiteren Angaben hinzugefügt
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                  </>
                )}
              </Box>
            </Box>
          )}
              </Box>
            </Box>
          </DialogContent>
        </Dialog>

        {/* CV-Import Warnungs-Dialog */}
        <Dialog
          open={showCvImportWarningDialog}
          onClose={undefined}
          maxWidth="sm"
          fullWidth
          disableEscapeKeyDown
        >
          <DialogTitle sx={{ 
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}>
            <WarningIcon />
            {t('cv.import.warning.title')}
          </DialogTitle>
          <DialogContent sx={{ p: 3, pt: 5 }}>
            <Box sx={{ mb: 3 }}></Box>
            <Typography variant="body1" sx={{ mb: 2, fontWeight: 500 }}>
              ⚠️ {t('cv.import.warning.message')}
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, color: '#666' }}>
              {t('cv.import.warning.description')}
            </Typography>
            <Box component="ul" sx={{ pl: 2, mb: 2 }}>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#666' }}>
                {t('cv.import.warning.item1')}
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#666' }}>
                {t('cv.import.warning.item2')}
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#666' }}>
                {t('cv.import.warning.item3')}
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#666' }}>
                {t('cv.import.warning.item4')}
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ color: '#666', fontStyle: 'italic' }}>
              {t('cv.import.warning.footer')}
            </Typography>
          </DialogContent>
          <DialogActions sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={dontShowImportWarning}
                  onChange={(e) => setDontShowImportWarning(e.target.checked)}
                  disableRipple
                  disableFocusRipple
                  sx={{ color: '#667eea', '&:hover': { backgroundColor: 'transparent' }, '& .MuiTouchRipple-root': { display: 'none' } }}
                />
              }
              label={t('cv.import.warning.dontShowAgain')}
              sx={{ color: '#666', margin: 0 }}
            />
            <Button 
              onClick={async () => {
                setShowCvImportWarningDialog(false);
                // Speichere Präferenz wenn Checkbox aktiviert
                if (dontShowImportWarning) {
                  await saveUserWarningPreferences(true, dontShowTemplateWarning);
                }
              }}
              variant="outlined"
              sx={{
                px: 3,
                py: 1.5,
                borderRadius: 6,
                borderColor: '#667eea',
                color: '#757575',
                fontWeight: 600,
                transition: 'all 0.2s ease',
                '&:hover': {
                  borderColor: '#764ba2',
                  backgroundColor: '#f5f5f5',
                  transform: 'translateY(-1px)',
                },
              }}
            >
              {t('cv.import.warning.button')}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Bestätigungsdialog für CV-Löschung */}
        <Dialog
          open={showDeleteCvDialog}
          onClose={() => setShowDeleteCvDialog(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#f44336' }}>
            <DeleteIcon />
            CV löschen
          </DialogTitle>
          <DialogContent>
            <Typography>
              Möchten Sie den CV "{currentCvName || 'Unbenannt'}" wirklich löschen?
            </Typography>
            <Typography variant="body2" sx={{ mt: 2, color: '#666' }}>
              Diese Aktion kann nicht rückgängig gemacht werden.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowDeleteCvDialog(false)}>
              Abbrechen
            </Button>
            <Button 
              onClick={handleDeleteCv}
              variant="contained"
              color="error"
              startIcon={<DeleteIcon />}
            >
              Löschen
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal für CV hinzufügen */}
        <Dialog 
          open={showAddCvModal} 
          onClose={() => {
            setShowAddCvModal(false);
            setCvModalManuallyClosed(true);
          }}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              maxHeight: '90vh',
              margin: '20px'
            }
          }}
        >
          <DialogTitle>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="h6">
                {getTranslatedCvLabel('CV-Daten hinzufügen')}
              </Typography>
              <IconButton onClick={() => {
                setShowAddCvModal(false);
                setCvModalManuallyClosed(true);
              }}>
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          
          <DialogContent sx={{ p: 3, overflow: 'hidden' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
              {/* Eingabefeld für CV-Name */}
              <TextField
                fullWidth
                label={getTranslatedCvLabel('CV-Name (optional)')}
                value={newCvName}
                onChange={(e) => setNewCvName(e.target.value)}
                placeholder={`z.B. Bewerbung bei ${currentLanguage === 'de' ? 'Firma XYZ' : currentLanguage === 'en' ? 'Company XYZ' : currentLanguage === 'fr' ? 'Entreprise XYZ' : 'Azienda XYZ'}`}
                variant="outlined"
                sx={{ mb: 1 }}
                helperText={currentLanguage === 'de' ? 'Gib deinem CV einen aussagekräftigen Namen für bessere Übersicht' :
                           currentLanguage === 'en' ? 'Give your CV a meaningful name for better overview' :
                           currentLanguage === 'fr' ? 'Donnez à votre CV un nom significatif pour une meilleure vue d\'ensemble' :
                           'Dai al tuo CV un nome significativo per una migliore panoramica'}
              />
              
              {/* Button: CV hochladen */}
              <Button
                variant="contained"
                component="label"
                fullWidth
                disabled={extracting}
                startIcon={<CloudUploadIcon />}
                sx={{
                  py: 2,
                  borderRadius: 2,
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  fontWeight: 600,
                  fontSize: '0.95rem',
                  textTransform: 'none',
                  boxShadow: '0 2px 8px rgba(102, 126, 234, 0.25)',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)',
                    boxShadow: '0 4px 12px rgba(102, 126, 234, 0.35)',
                  },
                  '&:disabled': {
                    opacity: 0.6,
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                  },
                }}
              >
                {extracting ? t('extraction.processing') : t('upload.cv')}
                <input
                  type="file"
                  accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  hidden
                  onChange={(e) => {
                    handleFileChange(e);
                    setShowAddCvModal(false);
                    setCvModalManuallyClosed(true);
                    setNewCvName(''); // Reset CV-Name
                  }}
                />
              </Button>

              {/* Trennlinie mit "oder" */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, my: 1 }}>
                <Box sx={{ flex: 1, height: '1px', bgcolor: '#e0e0e0' }} />
                <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500, fontSize: '0.875rem' }}>
                  {getTranslatedCvLabel('oder')}
                </Typography>
                <Box sx={{ flex: 1, height: '1px', bgcolor: '#e0e0e0' }} />
              </Box>

              {/* Button: Daten manuell befüllen */}
              <Button
                variant="outlined"
                fullWidth
                disabled={extracting}
                startIcon={<EditIcon />}
                onClick={async () => {
                  // Schließe Add-Modal
                  setShowAddCvModal(false);
                  setCvModalManuallyClosed(true);
                  
                  // Verstecke Upload-Buttons nach Klick auf "Daten manuell befüllen"
                  setHideUploadButtons(true);
                  
                  // Erstelle einen neuen CV - lösche alle aktuellen Daten
                  clearAllCvData();
                  
                  // Öffne CV-Daten Modal mit "Persönliche Informationen" Tab
                  setShowCvDataModal(true);
                  setTabIndex(0); // Setze Modal auf Tab "Persönliche Informationen"
                  setCvDataEditMode(true);
                  setHasUnsavedChanges(false); // Beim Öffnen keine ungespeicherten Änderungen
                  
                  // Zeige "Passgenauigkeit prüfen" Button wieder an, verstecke andere Buttons
                  setShowPassgenauigkeitButton(true);
                  setShowCvOptimierenButton(false);
                  
                  // Erzwinge Anzeige der CV-Daten, auch wenn keine Daten vorhanden sind
                  setForceShowCvData(true);
                }}
                sx={{
                  py: 2,
                  borderRadius: 2,
                  borderColor: 'primary.main',
                  color: 'primary.main',
                  fontWeight: 600,
                  fontSize: '0.95rem',
                  textTransform: 'none',
                  '&:hover': {
                    borderColor: 'primary.dark',
                    backgroundColor: 'rgba(102, 126, 234, 0.04)',
                  },
                }}
              >
                {getTranslatedCvLabel('Daten manuell befüllen')}
              </Button>
            </Box>
          </DialogContent>
        </Dialog>

        {/* CV-Template Warnungs-Dialog */}
        <Dialog
          open={showCvTemplateWarningDialog}
          onClose={undefined}
          maxWidth="sm"
          fullWidth
          disableEscapeKeyDown
        >
          <DialogTitle sx={{ 
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}>
            <WarningIcon />
            {t('cv.template.warning.title')}
          </DialogTitle>
          <DialogContent sx={{ p: 3, pt: 5 }}>
            {/* Abstand zwischen Header und Text */}
            <Box sx={{ mb: 3 }}></Box>
            <Typography variant="body1" sx={{ mb: 2, fontWeight: 500 }}>
              ⚠️ {t('cv.template.warning.message')}
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, color: '#666' }}>
              {t('cv.template.warning.description')}
            </Typography>
            <Box component="ul" sx={{ pl: 2, mb: 2 }}>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#666' }}>
                {t('cv.template.warning.item1')}
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#666' }}>
                {t('cv.template.warning.item2')}
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#666' }}>
                {t('cv.template.warning.item3')}
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#666' }}>
                {t('cv.template.warning.item4')}
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ color: '#666', fontStyle: 'italic' }}>
              {t('cv.template.warning.footer')}
            </Typography>
          </DialogContent>
          <DialogActions sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={dontShowTemplateWarning}
                  onChange={(e) => setDontShowTemplateWarning(e.target.checked)}
                  disableRipple
                  disableFocusRipple
                  sx={{ color: '#667eea', '&:hover': { backgroundColor: 'transparent' }, '& .MuiTouchRipple-root': { display: 'none' } }}
                />
              }
              label={t('cv.template.warning.dontShowAgain')}
              sx={{ color: '#666', margin: 0 }}
            />
            <Button 
              onClick={async () => {
                setShowCvTemplateWarningDialog(false);
                
                // Verwende den gleichen Prozess wie beim Modal "Bewerbungen" (funktioniert korrekt)
                // 1. Lade CV-Design-Settings aus Firebase (gemeinsame Funktion)
                const loadedDesignSettings = await loadCvDesignSettingsForPreview();
                
                // Verwende die geladenen Settings direkt - sie sind bereits normalisiert von loadCvDesignSettingsForPreview
                // Normalisiere NUR wenn keine Settings geladen wurden (verwende dann aktuelle State-Werte)
                // WICHTIG: Verwende die geladenen Settings direkt, nicht normalizeDesignSettings, da dies die State-Werte verwenden könnte
                const normalizedDesignSettings = loadedDesignSettings || getCurrentCvDesignSettings();
                
                if (normalizedDesignSettings) {
                  console.log('✅ Design-Einstellungen geladen und normalisiert:', normalizedDesignSettings);
                  
                  // 2. Wende die Design-Einstellungen explizit an (wie beim Modal Bewerbungen)
                  // Dies stellt sicher, dass alle Felder (Farben, Sichtbarkeiten, Profilbild-Einstellungen, etc.) korrekt übernommen werden
                  applyCvDesignSettings(normalizedDesignSettings);
                  console.log('✅ CV-Design-Einstellungen explizit angewendet:', normalizedDesignSettings);
                }
                
                // Speichere Präferenz wenn Checkbox aktiviert
                if (dontShowTemplateWarning) {
                  await saveUserWarningPreferences(dontShowImportWarning, true);
                }
                
                try {
                  // 3. Erstelle automatisch eine Bewerbung BEVOR die Preview geöffnet wird
                  // selectedApplicationId wurde beim Start der Optimierung auf null gesetzt
                  // Übergebe die normalisierten Design-Einstellungen direkt
                  const applicationId = await createApplicationFromCvPreview(normalizedDesignSettings);
                  
                  if (!applicationId) {
                    throw new Error('Fehler beim Erstellen der Application');
                  }
                  
                  // 4. Lade Design-Settings aus der erstellten Application (wie beim Modal Bewerbungen)
                  // Dies stellt sicher, dass die Design-Einstellungen korrekt angewendet werden
                  if (!user) {
                    throw new Error('Benutzer nicht angemeldet');
                  }
                  
                  // Kurze Verzögerung, um sicherzustellen, dass die Application vollständig gespeichert wurde
                  await new Promise(resolve => setTimeout(resolve, 100));
                  
                  const token = await user.getIdToken();
                  const response = await fetch(`${config.backend.baseUrl}/api/get-application-cv-preview-data/${applicationId}`, {
                    method: 'GET',
                    headers: {
                      'Authorization': `Bearer ${token}`,
                      'Content-Type': 'application/json'
                    }
                  });

                  if (!response.ok) {
                    throw new Error('Fehler beim Laden der Application-Daten');
                  }

                  const data = await response.json();
                  const cvPreviewData = data.cvPreviewData;

                  if (!cvPreviewData || !cvPreviewData.designSettings) {
                    throw new Error('Keine Design-Settings in cvPreviewData gefunden');
                  }

                  // Debug: Zeige die Design-Settings, die aus der Application geladen wurden
                  console.log('📥 Design-Settings aus Application geladen (Warning Dialog):', cvPreviewData.designSettings);
                  console.log('📥 Design-Settings Keys:', Object.keys(cvPreviewData.designSettings));
                  console.log('📥 selectedTemplate:', cvPreviewData.designSettings.selectedTemplate);
                  console.log('📥 leftColumnColor:', cvPreviewData.designSettings.leftColumnColor);
                  console.log('📥 topBoxColor:', cvPreviewData.designSettings.topBoxColor);
                  console.log('📥 nameTextColor:', cvPreviewData.designSettings.nameTextColor);

                  // Wende die Design-Settings aus der Application an (überschreibt globale Settings)
                  // Dies stellt sicher, dass die Design-Settings, die beim Erstellen der Application verwendet wurden, übernommen werden
                  applyCvDesignSettings(cvPreviewData.designSettings);
                  console.log('✅ CV-Design-Einstellungen aus Application geladen und angewendet:', cvPreviewData.designSettings);
                  
                  // 5. Warte, bis alle State-Updates verarbeitet wurden, bevor die Preview geöffnet wird
                  // Verwende requestAnimationFrame, um sicherzustellen, dass React die State-Updates verarbeitet hat
                  await new Promise(resolve => {
                    requestAnimationFrame(() => {
                      requestAnimationFrame(() => {
                        setTimeout(resolve, 100);
                      });
                    });
                  });
                  
                  // 6. Öffne CV-Preview Modal NACH dem Laden der Design-Einstellungen (wie beim Modal Bewerbungen)
                  // Die Design-Einstellungen wurden bereits explizit angewendet und die State-Updates wurden verarbeitet
                  setShowTemplatePreviewDialog(true);
                  setShowCvOptimierenButton(false);
                  // NICHT hier setzen - wird erst beim Schließen der Preview gesetzt
                  // setCvTemplateHasBeenOpened(true);
                } catch (error) {
                  console.error('❌ Fehler beim Öffnen der CV-Preview:', error);
                  setError('Fehler beim Öffnen der CV-Preview: ' + (error instanceof Error ? error.message : 'Unbekannter Fehler'));
                }
              }}
              variant="outlined"
              sx={{
                px: 3,
                py: 1.5,
                borderRadius: 6,
                borderColor: '#667eea',
                color: '#757575',
                fontWeight: 600,
                transition: 'all 0.2s ease',
                '&:hover': {
                  borderColor: '#764ba2',
                  backgroundColor: '#f5f5f5',
                  transform: 'translateY(-1px)',
                },
              }}
            >
              {t('cv.template.warning.button')}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Motivationsschreiben Warnungs-Dialog */}
        <Dialog
          open={showMotivationWarningDialog}
          onClose={() => setShowMotivationWarningDialog(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: '12px',
              boxShadow: '0 8px 32px rgba(0,0,0,0.12)'
            }
          }}
        >
          <DialogTitle sx={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}>
            <WarningIcon />
            {t('cv.motivation.warning.title')}
          </DialogTitle>
          <DialogContent sx={{ p: 3, pt: 5 }}>
            {/* Abstand zwischen Header und Text */}
            <Box sx={{ mb: 3 }}></Box>
            <Typography variant="body1" sx={{ mb: 2, fontWeight: 500 }}>
              ⚠️ {t('cv.motivation.warning.message')}
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, color: '#666' }}>
              {t('cv.motivation.warning.description')}
            </Typography>
            <Box component="ul" sx={{ pl: 2, mb: 2 }}>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#666' }}>
                {t('cv.motivation.warning.item1')}
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#666' }}>
                {t('cv.motivation.warning.item2')}
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#666' }}>
                {t('cv.motivation.warning.item3')}
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#666' }}>
                {t('cv.motivation.warning.item4')}
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ color: '#666', fontStyle: 'italic' }}>
              {t('cv.motivation.warning.footer')}
            </Typography>
          </DialogContent>
          <DialogActions sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={dontShowMotivationWarning}
                  onChange={(e) => setDontShowMotivationWarning(e.target.checked)}
                  disableRipple
                  disableFocusRipple
                  sx={{ color: '#667eea', '&:hover': { backgroundColor: 'transparent' }, '& .MuiTouchRipple-root': { display: 'none' } }}
                />
              }
              label={t('cv.motivation.warning.dontShowAgain')}
              sx={{ color: '#666', margin: 0 }}
            />
            <Button 
              onClick={async () => {
                setShowMotivationWarningDialog(false);
                // Speichere Präferenz wenn Checkbox aktiviert
                if (dontShowMotivationWarning) {
                  await saveUserWarningPreferences(dontShowImportWarning, dontShowTemplateWarning, true);
                }
                // Öffne das Motivationsschreiben nach Schliessen des Pop-ups
                if (motivationLetter) {
                  handleOpenMotivationDialog();
                }
              }}
              variant="outlined"
              sx={{
                px: 3,
                py: 1.5,
                borderRadius: 6,
                borderColor: '#667eea',
                color: '#757575',
                fontWeight: 600,
                transition: 'all 0.2s ease',
                '&:hover': {
                  borderColor: '#764ba2',
                  backgroundColor: '#f5f5f5',
                  transform: 'translateY(-1px)',
                },
              }}
            >
              {t('cv.motivation.warning.button')}
            </Button>
          </DialogActions>
        </Dialog>
        
        {/* Label für optimierte CV-Daten (Administrator) */}
      {isAdmin() && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <Typography variant="body2">Optimierte CV-Daten (Administrator)</Typography>
            <IconButton 
              onClick={() => {
                const newHideState = !hideOptimizedCvData;
                setHideOptimizedCvData(newHideState);
              }}
              sx={{ 
                color: 'primary.main',
                '&:hover': { bgcolor: 'rgba(25, 118, 210, 0.1)' }
              }}
            >
              {hideOptimizedCvData ? <ExpandMoreIcon /> : <ExpandLessIcon />}
            </IconButton>
          </Box>
        )}




        {/* Alle Elemente - minimierbar */}
        {!hideOptimizedCvData && (
          <>
            {/* Alle Daten löschen Button - nur für Admin sichtbar */}
            {isAdmin() && (
              <Box sx={{ mb: 2 }}>
                <Button
                  variant="outlined"
                  color="error"
                  size="small"
                  onClick={handleClearAllData}
                  startIcon={<ClearIcon />}
                  sx={{ 
                    minWidth: 'auto', 
                    px: 2,
                    borderColor: 'error.main',
                    color: 'error.main',
                    '&:hover': {
                      bgcolor: 'rgba(244, 67, 54, 0.1)',
                      borderColor: 'error.dark'
                    }
                  }}
                >
                  {t('clear.all.data')}
                </Button>
              </Box>
            )}

            {/* Template Vorschau Button */}
            <Box sx={{ mb: 3, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
              <Button
                variant="outlined"
                onClick={handleOpenCvTemplate}
                startIcon={<VisibilityIcon />}
                sx={{ mb: 2 }}
              >
                Optimierten CV anzeigen
              </Button>
              
              {motivationLetter && (
                <Button
                  variant="outlined"
                  onClick={handleOpenMotivationDialog}
                  startIcon={<VisibilityIcon />}
                  sx={{ mb: 2 }}
                >
                  Motivationsschreiben anzeigen
                </Button>
              )}
            </Box>

            {/* Persönliche Angaben - immer sichtbar */}
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6">
                Persönliche Angaben
              </Typography>
              <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2, mb: 3 }}>
                <TextField
                  label={getTranslatedCvLabel('Name:').replace(':', '')}
                  value={fullName || ''}
                  onChange={(e) => handleFullNameChange(e.target.value)}
                  fullWidth
                  variant="outlined"
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: '#f8f9fa',
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset': {
                        borderColor: '#bdbdbd',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#1976d2',
                      },
                    },
                  }}
                />
                <TextField
                  label={getTranslatedCvLabel('Email:').replace(':', '')}
                  value={email || ''}
                  onChange={(e) => handleCvDataChange(setEmail, e.target.value)}
                  fullWidth
                  variant="outlined"
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: '#f8f9fa',
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset': {
                        borderColor: '#bdbdbd',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#1976d2',
                      },
                    },
                  }}
                />
                <TextField
                  label={getTranslatedCvLabel('Telefon:').replace(':', '')}
                  value={phoneNumber || ''}
                  onChange={(e) => handleCvDataChange(setPhoneNumber, e.target.value)}
                  fullWidth
                  variant="outlined"
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: '#f8f9fa',
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset': {
                        borderColor: '#bdbdbd',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#1976d2',
                      },
                    },
                  }}
                />
                <TextField
                  label={getTranslatedCvLabel('Adresse:').replace(':', '')}
                  value={address || ''}
                  onChange={(e) => handleCvDataChange(setAddress, e.target.value)}
                  fullWidth
                  variant="outlined"
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: '#f8f9fa',
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset': {
                        borderColor: '#bdbdbd',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#1976d2',
                      },
                    },
                  }}
                />
                <TextField
                  label={getTranslatedCvLabel('PLZ:').replace(':', '')}
                  value={postalCode || ''}
                  onChange={(e) => handleCvDataChange(setPostalCode, e.target.value)}
                  fullWidth
                  variant="outlined"
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: '#f8f9fa',
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset': {
                        borderColor: '#bdbdbd',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#1976d2',
                      },
                    },
                  }}
                />
                <TextField
                  label={getTranslatedCvLabel('Stadt:').replace(':', '')}
                  value={city || ''}
                  onChange={(e) => handleCvDataChange(setCity, e.target.value)}
                  fullWidth
                  variant="outlined"
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: '#f8f9fa',
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset': {
                        borderColor: '#bdbdbd',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#1976d2',
                      },
                    },
                  }}
                />
                <TextField
                  label={t('cv.personal.birthyear')} 
                  type="number"
                  value={birthYear}
                  onChange={(e) => handleCvDataChange(setBirthYear, e.target.value)} 
                  fullWidth 
                  inputProps={{ min: 1900, max: new Date().getFullYear(), step: 1 }}
                  placeholder="z.B. 1990"
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: '#f8f9fa',
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset': {
                        borderColor: '#bdbdbd',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#1976d2',
                      },
                    },
                  }}
                />
                <TextField
                  label={getTranslatedCvLabel('Verfügbar ab:').replace(':', '')}
                  type="date"
                  value={availableFrom || ''}
                  onChange={(e) => handleCvDataChange(setAvailableFrom, e.target.value)}
                  fullWidth
                  variant="outlined"
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: '#f8f9fa',
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset': {
                        borderColor: '#bdbdbd',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#1976d2',
                      },
                    },
                  }}
                />
                <FormControl fullWidth size="small" sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                    backgroundColor: '#f8f9fa',
                    '& fieldset': {
                      borderColor: '#e0e0e0',
                    },
                    '&:hover fieldset': {
                      borderColor: '#bdbdbd',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#1976d2',
                    },
                  },
                }}>
                  <InputLabel>Nationalität</InputLabel>
                  <Select 
                    value={nationality || ''} 
                    label="Nationalität" 
                    onChange={(e) => handleCvDataChange(setNationality, e.target.value)}
                  >
                    <MenuItem value="">Bitte wählen</MenuItem>
                    <MenuItem value="CH">CH - Schweiz</MenuItem>
                    <MenuItem value="DE">DE - Deutschland</MenuItem>
                    <MenuItem value="AT">AT - Österreich</MenuItem>
                    <MenuItem value="FR">FR - Frankreich</MenuItem>
                    <MenuItem value="IT">IT - Italien</MenuItem>
                    <MenuItem value="ES">ES - Spanien</MenuItem>
                    <MenuItem value="PT">PT - Portugal</MenuItem>
                    <MenuItem value="NL">NL - Niederlande</MenuItem>
                    <MenuItem value="BE">BE - Belgien</MenuItem>
                    <MenuItem value="LU">LU - Luxemburg</MenuItem>
                    <MenuItem value="DK">DK - Dänemark</MenuItem>
                    <MenuItem value="SE">SE - Schweden</MenuItem>
                    <MenuItem value="NO">NO - Norwegen</MenuItem>
                    <MenuItem value="FI">FI - Finnland</MenuItem>
                    <MenuItem value="IS">IS - Island</MenuItem>
                    <MenuItem value="GB">GB - Großbritannien</MenuItem>
                    <MenuItem value="IE">IE - Irland</MenuItem>
                    <MenuItem value="PL">PL - Polen</MenuItem>
                    <MenuItem value="CZ">CZ - Tschechien</MenuItem>
                    <MenuItem value="SK">SK - Slowakei</MenuItem>
                    <MenuItem value="HU">HU - Ungarn</MenuItem>
                    <MenuItem value="RO">RO - Rumänien</MenuItem>
                    <MenuItem value="BG">BG - Bulgarien</MenuItem>
                    <MenuItem value="HR">HR - Kroatien</MenuItem>
                    <MenuItem value="SI">SI - Slowenien</MenuItem>
                    <MenuItem value="RS">RS - Serbien</MenuItem>
                    <MenuItem value="BA">BA - Bosnien-Herzegowina</MenuItem>
                    <MenuItem value="ME">ME - Montenegro</MenuItem>
                    <MenuItem value="MK">MK - Nordmazedonien</MenuItem>
                    <MenuItem value="AL">AL - Albanien</MenuItem>
                    <MenuItem value="GR">GR - Griechenland</MenuItem>
                    <MenuItem value="CY">CY - Zypern</MenuItem>
                    <MenuItem value="MT">MT - Malta</MenuItem>
                    <MenuItem value="EE">EE - Estland</MenuItem>
                    <MenuItem value="LV">LV - Lettland</MenuItem>
                    <MenuItem value="LT">LT - Litauen</MenuItem>
                    <MenuItem value="US">US - USA</MenuItem>
                    <MenuItem value="CA">CA - Kanada</MenuItem>
                    <MenuItem value="AU">AU - Australien</MenuItem>
                    <MenuItem value="NZ">NZ - Neuseeland</MenuItem>
                    <MenuItem value="JP">JP - Japan</MenuItem>
                    <MenuItem value="KR">KR - Südkorea</MenuItem>
                    <MenuItem value="CN">CN - China</MenuItem>
                    <MenuItem value="IN">IN - Indien</MenuItem>
                    <MenuItem value="PK">PK - Pakistan</MenuItem>
                    <MenuItem value="BD">BD - Bangladesch</MenuItem>
                    <MenuItem value="LK">LK - Sri Lanka</MenuItem>
                    <MenuItem value="NP">NP - Nepal</MenuItem>
                    <MenuItem value="BT">BT - Bhutan</MenuItem>
                    <MenuItem value="MV">MV - Malediven</MenuItem>
                    <MenuItem value="AF">AF - Afghanistan</MenuItem>
                    <MenuItem value="IR">IR - Iran</MenuItem>
                    <MenuItem value="IQ">IQ - Irak</MenuItem>
                    <MenuItem value="KW">KW - Kuwait</MenuItem>
                    <MenuItem value="BH">BH - Bahrain</MenuItem>
                    <MenuItem value="QA">QA - Katar</MenuItem>
                    <MenuItem value="Vereinigte Arabische Emirate">Vereinigte Arabische Emirate</MenuItem>
                    <MenuItem value="Omaner">Omaner</MenuItem>
                    <MenuItem value="Jemenit">Jemenit</MenuItem>
                    <MenuItem value="Saudi-Araber">Saudi-Araber</MenuItem>
                    <MenuItem value="Jordanier">Jordanier</MenuItem>
                    <MenuItem value="Libanese">Libanese</MenuItem>
                    <MenuItem value="Syrier">Syrier</MenuItem>
                    <MenuItem value="Palästinenser">Palästinenser</MenuItem>
                    <MenuItem value="Israeli">Israeli</MenuItem>
                    <MenuItem value="Ägypter">Ägypter</MenuItem>
                    <MenuItem value="Sudanese">Sudanese</MenuItem>
                    <MenuItem value="Südsudanese">Südsudanese</MenuItem>
                    <MenuItem value="Libyer">Libyer</MenuItem>
                    <MenuItem value="Tunesier">Tunesier</MenuItem>
                    <MenuItem value="Algerier">Algerier</MenuItem>
                    <MenuItem value="Marokkaner">Marokkaner</MenuItem>
                    <MenuItem value="Mauretanier">Mauretanier</MenuItem>
                    <MenuItem value="Senegalese">Senegalese</MenuItem>
                    <MenuItem value="Gambier">Gambier</MenuItem>
                    <MenuItem value="Guinea-Bissauer">Guinea-Bissauer</MenuItem>
                    <MenuItem value="Guineer">Guineer</MenuItem>
                    <MenuItem value="Sierra Leoner">Sierra Leoner</MenuItem>
                    <MenuItem value="Liberianer">Liberianer</MenuItem>
                    <MenuItem value="Elfenbeinküstler">Elfenbeinküstler</MenuItem>
                    <MenuItem value="Ghanaer">Ghanaer</MenuItem>
                    <MenuItem value="Togoer">Togoer</MenuItem>
                    <MenuItem value="Beniner">Beniner</MenuItem>
                    <MenuItem value="Nigerianer">Nigerianer</MenuItem>
                    <MenuItem value="Kameruner">Kameruner</MenuItem>
                    <MenuItem value="Tschader">Tschader</MenuItem>
                    <MenuItem value="Zentralafrikaner">Zentralafrikaner</MenuItem>
                    <MenuItem value="Äquatorialguineer">Äquatorialguineer</MenuItem>
                    <MenuItem value="Gabuner">Gabuner</MenuItem>
                    <MenuItem value="Kongolese">Kongolese</MenuItem>
                    <MenuItem value="Kongolese (DRC)">Kongolese (DRC)</MenuItem>
                    <MenuItem value="Angolaner">Angolaner</MenuItem>
                    <MenuItem value="Sambier">Sambier</MenuItem>
                    <MenuItem value="Malawier">Malawier</MenuItem>
                    <MenuItem value="Mosambikaner">Mosambikaner</MenuItem>
                    <MenuItem value="Simbabweer">Simbabweer</MenuItem>
                    <MenuItem value="Botswaner">Botswaner</MenuItem>
                    <MenuItem value="Namibier">Namibier</MenuItem>
                    <MenuItem value="Südafrikaner">Südafrikaner</MenuItem>
                    <MenuItem value="Lesothoer">Lesothoer</MenuItem>
                    <MenuItem value="Eswatini">Eswatini</MenuItem>
                    <MenuItem value="Madagasse">Madagasse</MenuItem>
                    <MenuItem value="Mauritier">Mauritier</MenuItem>
                    <MenuItem value="Seycheller">Seycheller</MenuItem>
                    <MenuItem value="Komorer">Komorer</MenuItem>
                    <MenuItem value="Dschibutier">Dschibutier</MenuItem>
                    <MenuItem value="Somalier">Somalier</MenuItem>
                    <MenuItem value="Äthiopier">Äthiopier</MenuItem>
                    <MenuItem value="Eritreer">Eritreer</MenuItem>
                    <MenuItem value="Keniaer">Keniaer</MenuItem>
                    <MenuItem value="Ugander">Ugander</MenuItem>
                    <MenuItem value="Tansanier">Tansanier</MenuItem>
                    <MenuItem value="Ruander">Ruander</MenuItem>
                    <MenuItem value="Burunder">Burunder</MenuItem>
                    <MenuItem value="Kongolese (Republik)">Kongolese (Republik)</MenuItem>
                    <MenuItem value="Gabuner">Gabuner</MenuItem>
                    <MenuItem value="Äquatorialguineer">Äquatorialguineer</MenuItem>
                    <MenuItem value="São Toméer">São Toméer</MenuItem>
                    <MenuItem value="Kap Verdeaner">Kap Verdeaner</MenuItem>
                    <MenuItem value="Brasilianer">Brasilianer</MenuItem>
                    <MenuItem value="Argentinier">Argentinier</MenuItem>
                    <MenuItem value="Chilene">Chilene</MenuItem>
                    <MenuItem value="Peruaner">Peruaner</MenuItem>
                    <MenuItem value="Bolivianer">Bolivianer</MenuItem>
                    <MenuItem value="Paraguayer">Paraguayer</MenuItem>
                    <MenuItem value="Uruguayer">Uruguayer</MenuItem>
                    <MenuItem value="Ecuadorianer">Ecuadorianer</MenuItem>
                    <MenuItem value="Kolumbianer">Kolumbianer</MenuItem>
                    <MenuItem value="Venezolaner">Venezolaner</MenuItem>
                    <MenuItem value="Guyaner">Guyaner</MenuItem>
                    <MenuItem value="Surinamer">Surinamer</MenuItem>
                    <MenuItem value="Franzose (Guyana)">Franzose (Guyana)</MenuItem>
                    <MenuItem value="Mexikaner">Mexikaner</MenuItem>
                    <MenuItem value="Guatemalteke">Guatemalteke</MenuItem>
                    <MenuItem value="Belizer">Belizer</MenuItem>
                    <MenuItem value="Salvadorianer">Salvadorianer</MenuItem>
                    <MenuItem value="Honduraner">Honduraner</MenuItem>
                    <MenuItem value="Nicaraguaner">Nicaraguaner</MenuItem>
                    <MenuItem value="Costa Ricaner">Costa Ricaner</MenuItem>
                    <MenuItem value="Panamaer">Panamaer</MenuItem>
                    <MenuItem value="Kubaner">Kubaner</MenuItem>
                    <MenuItem value="Jamaikaner">Jamaikaner</MenuItem>
                    <MenuItem value="Haitianer">Haitianer</MenuItem>
                    <MenuItem value="Dominikaner">Dominikaner</MenuItem>
                    <MenuItem value="Puerto Ricaner">Puerto Ricaner</MenuItem>
                    <MenuItem value="Bahamaer">Bahamaer</MenuItem>
                    <MenuItem value="Barbadier">Barbadier</MenuItem>
                    <MenuItem value="Trinidad und Tobagoer">Trinidad und Tobagoer</MenuItem>
                    <MenuItem value="Grenadier">Grenadier</MenuItem>
                    <MenuItem value="St. Lucianer">St. Lucianer</MenuItem>
                    <MenuItem value="St. Vincentianer">St. Vincentianer</MenuItem>
                    <MenuItem value="Antiguaner">Antiguaner</MenuItem>
                    <MenuItem value="Dominikaner (Commonwealth)">Dominikaner (Commonwealth)</MenuItem>
                    <MenuItem value="St. Kitts und Neviser">St. Kitts und Neviser</MenuItem>
                    <MenuItem value="Andere">Andere</MenuItem>
                  </Select>
                </FormControl>
                {nationality !== 'CH' && (
                  <TextField label={t('cv.personal.permit')} value={residencePermit} onChange={e => handleCvDataChange(setResidencePermit, e.target.value)} fullWidth sx={{ mb: 2 }} />
                )}
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel>{t('cv.personal.civilstatus')}</InputLabel>
                  <Select 
                    value={civilStatus} 
                    label={t('cv.personal.civilstatus')} 
                    onChange={e => handleCvDataChange(setCivilStatus, e.target.value)}
                  >
                    <MenuItem value="">{t('cv.personal.civilstatus.select')}</MenuItem>
                    <MenuItem value="ledig">{t('cv.personal.civilstatus.single')}</MenuItem>
                    <MenuItem value="verheiratet">{t('cv.personal.civilstatus.married')}</MenuItem>
                    <MenuItem value="geschieden">{t('cv.personal.civilstatus.divorced')}</MenuItem>
                    <MenuItem value="verwitwet">{t('cv.personal.civilstatus.widowed')}</MenuItem>
                    <MenuItem value="eingetragene-partnerschaft">{t('cv.personal.civilstatus.registered-partnership')}</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Box>

            {/* Optimiertes Kurzprofil - immer sichtbar */}
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6">
                Optimiertes Kurzprofil
              </Typography>
              <TextField
                multiline
                rows={4}
                value={optimizedShortProfile || ''}
                onChange={(e) => {
                  setOptimizedShortProfile(e.target.value);
                  // Setze Checkbox auf false, da optimierte Daten manuell bearbeitet wurden
                }}
                fullWidth
                variant="outlined"
                placeholder="AI-optimiertes Kurzprofil wird hier angezeigt..."
                helperText={`Aktueller Wert: ${optimizedShortProfile ? optimizedShortProfile.substring(0, 50) + '...' : 'Leer'}`}
                sx={{
                  mb: 3,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                    backgroundColor: '#f8f9fa',
                    '& fieldset': {
                      borderColor: '#e0e0e0',
                    },
                    '&:hover fieldset': {
                      borderColor: '#bdbdbd',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#1976d2',
                    },
                  },
                }}
              />
            </Box>

            {/* Relevante Kernkompetenzen Tabelle - vereinfacht */}
            {relevantCoreCompetencies && (
              <Box sx={{ mt: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="h6">
                    {getTranslatedCvLabel('Relevante Kernkompetenzen')}
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowCoreCompetencySelector(true)}
                    startIcon={<AddIcon />}
                    sx={{
                      borderColor: '#10b981',
                      color: '#10b981',
                      '&:hover': {
                        borderColor: '#059669',
                        backgroundColor: '#f0fdf4'
                      }
                    }}
                  >
                    Kernkompetenz hinzufügen
                  </Button>
                </Box>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Kernkompetenz</TableCell>
                      <TableCell>Aktion</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {relevantCoreCompetencies.length > 0 ? (
                      relevantCoreCompetencies.map((comp, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <TextField
                              value={comp.competency || ''}
                              onChange={(e) => {
                                const updatedCompetencies = [...relevantCoreCompetencies];
                                updatedCompetencies[index] = {
                                  ...updatedCompetencies[index],
                                  competency: e.target.value
                                };
                                setRelevantCoreCompetencies(updatedCompetencies);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <IconButton
                              size="small"
                              onClick={() => handleDeleteRelevantCoreCompetency(index)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={2} sx={{ textAlign: 'center' }}>
                          Keine relevanten Kernkompetenzen für diese Stelle verfügbar
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Box>
            )}

            {/* Relevante Branchen Tabelle */}
            {relevantIndustries && relevantIndustries.length > 0 && (
              <Box sx={{ mt: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="h6">
                    Relevante Branchen
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowIndustrySelector(true)}
                    startIcon={<AddIcon />}
                    sx={{
                      borderColor: '#10b981',
                      color: '#10b981',
                      '&:hover': {
                        borderColor: '#059669',
                        backgroundColor: '#f0fdf4'
                      }
                    }}
                  >
                    Branche hinzufügen
                  </Button>
                </Box>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Branche</TableCell>
                      <TableCell>Jahre</TableCell>
                      <TableCell>Aktion</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {relevantIndustries.map((industry, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          <TextField
                            value={industry.industry || ''}
                            onChange={(e) => {
                              const updatedIndustries = [...relevantIndustries];
                              updatedIndustries[index] = {
                                ...updatedIndustries[index],
                                industry: e.target.value
                              };
                              setRelevantIndustries(updatedIndustries);
                            }}
                            variant="standard"
                            size="small"
                            fullWidth
                            sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            value={industry.years || ''}
                            onChange={(e) => {
                              const updatedIndustries = [...relevantIndustries];
                              updatedIndustries[index] = {
                                ...updatedIndustries[index],
                                years: e.target.value
                              };
                              setRelevantIndustries(updatedIndustries);
                            }}
                            variant="standard"
                            size="small"
                            fullWidth
                            sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                          />
                        </TableCell>
                        <TableCell>
                          <IconButton
                            size="small"
                            onClick={() => handleDeleteRelevantIndustry(index)}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            )}

            {/* Relevante Hobbys Tabelle */}
            <Box sx={{ mt: 4 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6">
                  Relevante Hobbys
                </Typography>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => setShowHobbySelector(true)}
                  startIcon={<AddIcon />}
                  sx={{
                    borderColor: '#10b981',
                    color: '#10b981',
                    '&:hover': {
                      borderColor: '#059669',
                      backgroundColor: '#f0fdf4'
                    }
                  }}
                >
                  Hobby hinzufügen
                </Button>
              </Box>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Hobby</TableCell>
                    <TableCell>Beschreibung</TableCell>
                    <TableCell>Aktion</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {relevantHobbies && relevantHobbies.length > 0 ? (
                    relevantHobbies.map((hobby, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          <TextField
                            value={hobby.hobby || ''}
                            onChange={(e) => {
                              const updatedHobbies = [...relevantHobbies];
                              updatedHobbies[index] = {
                                ...updatedHobbies[index],
                                hobby: e.target.value
                              };
                              setRelevantHobbies(updatedHobbies);
                            }}
                            variant="standard"
                            size="small"
                            fullWidth
                            sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            value={hobby.description || ''}
                            onChange={(e) => {
                              const updatedHobbies = [...relevantHobbies];
                              updatedHobbies[index] = {
                                ...updatedHobbies[index],
                                description: e.target.value
                              };
                              setRelevantHobbies(updatedHobbies);
                            }}
                            variant="standard"
                            size="small"
                            fullWidth
                            sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                          />
                        </TableCell>
                        <TableCell>
                          <IconButton
                            size="small"
                            onClick={() => handleDeleteRelevantHobby(index)}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={3} sx={{ textAlign: 'center' }}>
                        Keine relevanten Hobbys für diese Stelle verfügbar
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Box>

            {/* Optimierte Berufserfahrungen Tabelle - nur relevante */}
            {optimizedWorkExperiences && (
              <Box sx={{ mt: 4 }}>
                <Typography variant="h6">
                  Optimierte Berufserfahrungen
                </Typography>
                {optimizedWorkExperiences.filter(exp => exp.relevant === true || exp.relevant === 'true').length > 0 ? (
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Firma</TableCell>
                        <TableCell>Position</TableCell>
                        <TableCell>Start</TableCell>
                        <TableCell>Ende</TableCell>
                        <TableCell>Beschreibung</TableCell>
                        <TableCell>Aktion</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {optimizedWorkExperiences.filter(exp => exp.relevant === true || exp.relevant === 'true').map((exp, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <TextField
                              value={exp.company || ''}
                              onChange={(e) => {
                                const updatedExperiences = [...optimizedWorkExperiences];
                                const originalIndex = optimizedWorkExperiences.findIndex(originalExp => originalExp === exp);
                                updatedExperiences[originalIndex] = {
                                  ...updatedExperiences[originalIndex],
                                  company: e.target.value
                                };
                                setOptimizedWorkExperiences(updatedExperiences);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={exp.position || ''}
                              onChange={(e) => {
                                const updatedExperiences = [...optimizedWorkExperiences];
                                const originalIndex = optimizedWorkExperiences.findIndex(originalExp => originalExp === exp);
                                updatedExperiences[originalIndex] = {
                                  ...updatedExperiences[originalIndex],
                                  position: e.target.value
                                };
                                setOptimizedWorkExperiences(updatedExperiences);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={exp.startDate || ''}
                              onChange={(e) => {
                                const updatedExperiences = [...optimizedWorkExperiences];
                                const originalIndex = optimizedWorkExperiences.findIndex(originalExp => originalExp === exp);
                                updatedExperiences[originalIndex] = {
                                  ...updatedExperiences[originalIndex],
                                  startDate: e.target.value
                                };
                                setOptimizedWorkExperiences(updatedExperiences);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={exp.endDate || ''}
                              onChange={(e) => {
                                const updatedExperiences = [...optimizedWorkExperiences];
                                const originalIndex = optimizedWorkExperiences.findIndex(originalExp => originalExp === exp);
                                updatedExperiences[originalIndex] = {
                                  ...updatedExperiences[originalIndex],
                                  endDate: e.target.value
                                };
                                setOptimizedWorkExperiences(updatedExperiences);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={exp.description || ''}
                              onChange={(e) => {
                                const updatedExperiences = [...optimizedWorkExperiences];
                                const originalIndex = optimizedWorkExperiences.findIndex(originalExp => originalExp === exp);
                                updatedExperiences[originalIndex] = {
                                  ...updatedExperiences[originalIndex],
                                  description: e.target.value
                                };
                                setOptimizedWorkExperiences(updatedExperiences);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <IconButton
                              size="small"
                              onClick={() => {
                                const updatedExperiences = optimizedWorkExperiences.filter((_, i) => i !== optimizedWorkExperiences.findIndex(originalExp => originalExp === exp));
                                setOptimizedWorkExperiences(updatedExperiences);
                              }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  <Box sx={{ textAlign: 'center', py: 4 }}>
                    Keine relevanten Arbeitserfahrungen verfügbar
                  </Box>
                )}
              </Box>
            )}

            {/* Nicht relevante Berufserfahrungen Tabelle */}
            {optimizedWorkExperiences && (
              <Box sx={{ mt: 4 }}>
                <Typography variant="h6">
                  Nicht relevante Berufserfahrung
                </Typography>
                {optimizedWorkExperiences.filter(exp => exp.relevant === false || exp.relevant === 'false').length > 0 ? (
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Firma</TableCell>
                        <TableCell>Position</TableCell>
                        <TableCell>Start</TableCell>
                        <TableCell>Ende</TableCell>
                        <TableCell>Beschreibung</TableCell>
                        <TableCell>Aktion</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {optimizedWorkExperiences.filter(exp => exp.relevant === false || exp.relevant === 'false').map((exp, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <TextField
                              value={exp.company || ''}
                              onChange={(e) => {
                                const updatedExperiences = [...optimizedWorkExperiences];
                                const originalIndex = optimizedWorkExperiences.findIndex(originalExp => originalExp === exp);
                                updatedExperiences[originalIndex] = {
                                  ...updatedExperiences[originalIndex],
                                  company: e.target.value
                                };
                                setOptimizedWorkExperiences(updatedExperiences);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={exp.position || ''}
                              onChange={(e) => {
                                const updatedExperiences = [...optimizedWorkExperiences];
                                const originalIndex = optimizedWorkExperiences.findIndex(originalExp => originalExp === exp);
                                updatedExperiences[originalIndex] = {
                                  ...updatedExperiences[originalIndex],
                                  position: e.target.value
                                };
                                setOptimizedWorkExperiences(updatedExperiences);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={exp.startDate || ''}
                              onChange={(e) => {
                                const updatedExperiences = [...optimizedWorkExperiences];
                                const originalIndex = optimizedWorkExperiences.findIndex(originalExp => originalExp === exp);
                                updatedExperiences[originalIndex] = {
                                  ...updatedExperiences[originalIndex],
                                  startDate: e.target.value
                                };
                                setOptimizedWorkExperiences(updatedExperiences);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={exp.endDate || ''}
                              onChange={(e) => {
                                const updatedExperiences = [...optimizedWorkExperiences];
                                const originalIndex = optimizedWorkExperiences.findIndex(originalExp => originalExp === exp);
                                updatedExperiences[originalIndex] = {
                                  ...updatedExperiences[originalIndex],
                                  endDate: e.target.value
                                };
                                setOptimizedWorkExperiences(updatedExperiences);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={exp.description || ''}
                              onChange={(e) => {
                                const updatedExperiences = [...optimizedWorkExperiences];
                                const originalIndex = optimizedWorkExperiences.findIndex(originalExp => originalExp === exp);
                                updatedExperiences[originalIndex] = {
                                  ...updatedExperiences[originalIndex],
                                  description: e.target.value
                                };
                                setOptimizedWorkExperiences(updatedExperiences);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <IconButton
                              size="small"
                              onClick={() => {
                                const updatedExperiences = optimizedWorkExperiences.filter((_, i) => i !== optimizedWorkExperiences.findIndex(originalExp => originalExp === exp));
                                setOptimizedWorkExperiences(updatedExperiences);
                              }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  <Box sx={{ textAlign: 'center', py: 4 }}>
                    Keine nicht relevanten Arbeitserfahrungen verfügbar
                  </Box>
                )}
              </Box>
            )}

            {/* Relevante Zertifizierungen Tabelle - vereinfacht */}
            {relevantCertifications && (
              <Box sx={{ mt: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="h6">
                    Relevante Zertifizierungen
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowCertificationSelector(true)}
                    startIcon={<AddIcon />}
                    sx={{
                      borderColor: '#10b981',
                      color: '#10b981',
                      '&:hover': {
                        borderColor: '#059669',
                        backgroundColor: '#f0fdf4'
                      }
                    }}
                  >
                    Zertifizierung hinzufügen
                  </Button>
                </Box>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Zertifizierung</TableCell>
                      <TableCell>Aussteller</TableCell>
                      <TableCell>Datum</TableCell>
                      <TableCell>Aktion</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {relevantCertifications.length > 0 ? (
                      relevantCertifications.map((cert, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <TextField
                              value={cert.name || ''}
                              onChange={(e) => {
                                const updatedCertifications = [...relevantCertifications];
                                updatedCertifications[index] = {
                                  ...updatedCertifications[index],
                                  name: e.target.value
                                };
                                setRelevantCertifications(updatedCertifications);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={cert.issuer || ''}
                              onChange={(e) => {
                                const updatedCertifications = [...relevantCertifications];
                                updatedCertifications[index] = {
                                  ...updatedCertifications[index],
                                  issuer: e.target.value
                                };
                                setRelevantCertifications(updatedCertifications);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={cert.date || ''}
                              onChange={(e) => {
                                const updatedCertifications = [...relevantCertifications];
                                updatedCertifications[index] = {
                                  ...updatedCertifications[index],
                                  date: e.target.value
                                };
                                setRelevantCertifications(updatedCertifications);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <IconButton
                              size="small"
                              onClick={() => handleDeleteRelevantCertification(index)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={4} sx={{ textAlign: 'center' }}>
                          Keine relevanten Zertifizierungen für diese Stelle verfügbar
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Box>
            )}

            {/* IT-Kenntnisse Tabelle - vereinfacht */}
            {relevantItSkills && (
              <Box sx={{ mt: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="h6">
                    Relevante IT-Kenntnisse
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowItSkillSelector(true)}
                    startIcon={<AddIcon />}
                    sx={{
                      borderColor: '#10b981',
                      color: '#10b981',
                      '&:hover': {
                        borderColor: '#059669',
                        backgroundColor: '#f0fdf4'
                      }
                    }}
                  >
                    IT-Skill hinzufügen
                  </Button>
                </Box>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>IT-Skill</TableCell>
                      <TableCell>Niveau</TableCell>
                      <TableCell>Aktion</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {relevantItSkills.length > 0 ? (
                      relevantItSkills.map((skill, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <TextField
                              value={skill.skill || ''}
                              onChange={(e) => {
                                const updatedSkills = [...relevantItSkills];
                                updatedSkills[index] = {
                                  ...updatedSkills[index],
                                  skill: e.target.value
                                };
                                setRelevantItSkills(updatedSkills);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={skill.level || ''}
                              onChange={(e) => {
                                const updatedSkills = [...relevantItSkills];
                                updatedSkills[index] = {
                                  ...updatedSkills[index],
                                  level: e.target.value
                                };
                                setRelevantItSkills(updatedSkills);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <IconButton
                              size="small"
                              onClick={() => handleDeleteRelevantItSkill(index)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} sx={{ textAlign: 'center' }}>
                          Keine relevanten IT-Kenntnisse für diese Stelle verfügbar
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Box>
            )}

            {/* Relevante Ausbildungen Tabelle - vereinfacht */}
            {relevantEducations && (
              <Box sx={{ mt: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="h6">
                    Relevante Ausbildungen
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowEducationSelector(true)}
                    startIcon={<AddIcon />}
                    sx={{
                      borderColor: '#10b981',
                      color: '#10b981',
                      '&:hover': {
                        borderColor: '#059669',
                        backgroundColor: '#f0fdf4'
                      }
                    }}
                  >
                    Ausbildung hinzufügen
                  </Button>
                </Box>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Institution</TableCell>
                      <TableCell>Abschluss</TableCell>
                      <TableCell>Startdatum</TableCell>
                      <TableCell>Enddatum</TableCell>
                      <TableCell>Aktion</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {relevantEducations.length > 0 ? (
                      relevantEducations.map((education, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <TextField
                              value={education.institution || ''}
                              onChange={(e) => {
                                const updatedEducations = [...relevantEducations];
                                updatedEducations[index] = {
                                  ...updatedEducations[index],
                                  institution: e.target.value
                                };
                                setRelevantEducations(updatedEducations);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={education.degree || ''}
                              onChange={(e) => {
                                const updatedEducations = [...relevantEducations];
                                updatedEducations[index] = {
                                  ...updatedEducations[index],
                                  degree: e.target.value
                                };
                                setRelevantEducations(updatedEducations);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={education.startDate || ''}
                              onChange={(e) => {
                                const updatedEducations = [...relevantEducations];
                                updatedEducations[index] = {
                                  ...updatedEducations[index],
                                  startDate: e.target.value
                                };
                                setRelevantEducations(updatedEducations);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={education.endDate || ''}
                              onChange={(e) => {
                                const updatedEducations = [...relevantEducations];
                                updatedEducations[index] = {
                                  ...updatedEducations[index],
                                  endDate: e.target.value
                                };
                                setRelevantEducations(updatedEducations);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <IconButton
                              size="small"
                              onClick={() => handleDeleteRelevantEducation(index)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={5} sx={{ textAlign: 'center' }}>
                          Keine relevanten Ausbildungen für diese Stelle verfügbar
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Box>
            )}

            {/* Relevante Sprachen Tabelle - vereinfacht */}
            {relevantLanguages !== null && (
              <Box sx={{ mt: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="h6">
                    Relevante Sprachen
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowLanguageSelector(true)}
                    startIcon={<AddIcon />}
                    sx={{
                      borderColor: '#10b981',
                      color: '#10b981',
                      '&:hover': {
                        borderColor: '#059669',
                        backgroundColor: '#f0fdf4'
                      }
                    }}
                  >
                    Sprache hinzufügen
                  </Button>
                </Box>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Sprache</TableCell>
                      <TableCell>Niveau</TableCell>
                      <TableCell>Aktion</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {relevantLanguages.length > 0 ? (
                      relevantLanguages.map((language, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <TextField
                              value={language.language || ''}
                              onChange={(e) => {
                                const updatedLanguages = [...relevantLanguages];
                                updatedLanguages[index] = {
                                  ...updatedLanguages[index],
                                  language: e.target.value
                                };
                                setRelevantLanguages(updatedLanguages);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={language.level || ''}
                              onChange={(e) => {
                                const updatedLanguages = [...relevantLanguages];
                                updatedLanguages[index] = {
                                  ...updatedLanguages[index],
                                  level: e.target.value
                                };
                                setRelevantLanguages(updatedLanguages);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <IconButton
                              size="small"
                              onClick={() => handleDeleteRelevantLanguage(index)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} sx={{ textAlign: 'center' }}>
                          Keine relevanten Sprachen für diese Stelle verfügbar
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Box>
            )}

            {/* Relevante weitere Informationen Tabelle - vereinfacht */}
            {relevantAdditionalInfo && (
              <Box sx={{ mt: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="h6">
                    Relevante weitere Angaben
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowAdditionalInfoSelector(true)}
                    startIcon={<AddIcon />}
                    sx={{
                      borderColor: '#10b981',
                      color: '#10b981',
                      '&:hover': {
                        borderColor: '#059669',
                        backgroundColor: '#f0fdf4'
                      }
                    }}
                  >
                    Information hinzufügen
                  </Button>
                </Box>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Kategorie</TableCell>
                      <TableCell>Beschreibung</TableCell>
                      <TableCell>Aktion</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {relevantAdditionalInfo.length > 0 ? (
                      relevantAdditionalInfo.map((info, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <TextField
                              value={info.info || ''}
                              onChange={(e) => {
                                const updatedInfo = [...relevantAdditionalInfo];
                                updatedInfo[index] = {
                                  ...updatedInfo[index],
                                  info: e.target.value
                                };
                                setRelevantAdditionalInfo(updatedInfo);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={info.details || ''}
                              onChange={(e) => {
                                const updatedInfo = [...relevantAdditionalInfo];
                                updatedInfo[index] = {
                                  ...updatedInfo[index],
                                  details: e.target.value
                                };
                                setRelevantAdditionalInfo(updatedInfo);
                              }}
                              variant="standard"
                              size="small"
                              fullWidth
                              sx={{ '& .MuiInput-root': { fontSize: '0.875rem' } }}
                            />
                          </TableCell>
                          <TableCell>
                            <IconButton
                              size="small"
                              onClick={() => handleDeleteRelevantAdditionalInfo(index)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} sx={{ textAlign: 'center' }}>
                          Keine relevanten weiteren Informationen für diese Stelle verfügbar
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Box>
            )}
          </>
        )}

        {/* Label für Prompt (Administrator) - innerhalb des Paper Containers */}
        {isAdmin() && (
          <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2, mt: 4 }}>
        <Typography variant="body2">Prompt (Administrator)</Typography>
        <IconButton 
          onClick={() => {
            const newHideState = !hidePromptData;
            setHidePromptData(newHideState);
          }}
          sx={{ 
            color: 'primary.main',
            '&:hover': { bgcolor: 'rgba(25, 118, 210, 0.1)' }
          }}
        >
          {hidePromptData ? <ExpandMoreIcon /> : <ExpandLessIcon />}
        </IconButton>
      </Box>

            {/* Prompt-Tabelle - minimierbar, innerhalb des Paper Containers */}
      {!hidePromptData && (
        <Box sx={{ mb: 3 }}>
          <TableContainer component={Paper} sx={{ maxHeight: 1600, overflow: 'auto' }}>
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', width: '20%' }}>Prompt-Typ</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', width: '10%' }}>Verwendung</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', width: '15%' }}>ChatGPT-Version</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', width: '10%' }}>Temperatur</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', width: '10%' }}>Max Tokens</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', width: '8%' }}>Aktionen</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortPrompts([...prompts])
                  .map((prompt, index) => (
                  <React.Fragment key={index}>
                    <TableRow hover>
                      <TableCell sx={{ fontWeight: 'bold', verticalAlign: 'top' }}>
                        {prompt.type}
                      </TableCell>
                      <TableCell sx={{ verticalAlign: 'top', textAlign: 'center' }}>
                        <Chip 
                          label={prompt.usage || 'N/A'} 
                          color={
                            prompt.usage === 'Extraktion' ? 'primary' : 
                            prompt.usage === 'Foto' ? 'success' :
                            prompt.usage === 'Check' ? 'warning' :
                            'secondary'
                          }
                          size="small"
                          variant="outlined"
                        />
                      </TableCell>
                      <TableCell sx={{ verticalAlign: 'top', textAlign: 'center' }}>
                        {prompt.chatGptVersion || 'N/A'}
                      </TableCell>
                      <TableCell sx={{ verticalAlign: 'top', textAlign: 'center' }}>
                        {prompt.temperature || '0.0'}
                      </TableCell>
                      <TableCell sx={{ verticalAlign: 'top', textAlign: 'center' }}>
                        {prompt.maxTokens || '8000'}
                      </TableCell>
                      <TableCell sx={{ verticalAlign: 'top' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                          <IconButton
                            size="small"
                            color="primary"
                            onClick={() => {
                              // Verwende den Prompt-Namen direkt für Identifikation (nicht Index!)
                              const sortedPrompts = sortPrompts([...prompts]);
                              const updatedPrompt = sortedPrompts[index];
                              
                              if (!updatedPrompt) {
                                console.error('❌ Prompt nicht gefunden für Index:', index);
                                return;
                              }
                              
                              // Verwende den Prompt-Namen direkt, nicht den Index
                              setEditingPromptIndex(null); // Setze Index auf null, da wir den Namen verwenden
                              setEditingPromptText(updatedPrompt.text);
                              setEditingPromptVersion(updatedPrompt.chatGptVersion || 'gpt-4o');
                              setEditingPromptUsage(updatedPrompt.usage || 'Optimierung');
                              setEditingPromptTemperature(updatedPrompt.temperature || '0.0');
                              setEditingPromptMaxTokens(updatedPrompt.maxTokens || '8000');
                              setEditingPromptSystemRole(updatedPrompt.systemRole || 'Du bist ein Experte für CV-Optimierung.');
                              setEditingPromptName(updatedPrompt.type);
                              setOriginalPromptName(updatedPrompt.type); // Speichere den ursprünglichen Namen
                              setPromptEditorOpen(true);
                            }}
                            title="Bearbeiten"
                          >
                            <SettingsIcon />
                          </IconButton>

                        </Box>
                      </TableCell>
                    </TableRow>
                    

                  </React.Fragment>
            ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
          )}
        </>
      )}

      {/* Modal für Bildoptimierung */}
      <Modal
        open={showImageOptimizer}
        onClose={() => setShowImageOptimizer(false)}
        aria-labelledby="image-optimizer-modal"
        aria-describedby="image-optimizer-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: 800,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          maxHeight: '90vh',
          overflow: 'auto'
        }}>
          <Typography variant="h6" component="h2" gutterBottom>
            Optimierte Bildvarianten
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Hier sehen Sie Ihr Profilbild in verschiedenen optimierten Versionen:
          </Typography>
          
          <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: 3 }}>
            {optimizedImages.map((image) => (
              <Box key={image.id} sx={{ 
                border: '2px solid #e0e0e0', 
                borderRadius: 2, 
                p: 2,
                cursor: 'pointer',
                '&:hover': { borderColor: 'primary.main' }
              }} onClick={() => handleSelectOptimizedImage(image.image)}>
                <Box sx={{ position: 'relative' }}>
                  <img 
                    src={image.image} 
                    alt={image.name}
                    style={{ 
                      height: 200, 
                      objectFit: 'cover',
                      borderRadius: 8
                    }} 
                  />
                  {image.isOriginal && (
                    <Box sx={{
                      position: 'absolute',
                      top: 8,
                      right: 8,
                      backgroundColor: 'rgba(0,0,0,0.7)',
                      color: 'white',
                      px: 1,
                      py: 0.5,
                      borderRadius: 1,
                      fontSize: '0.75rem'
                    }}>
                      Ursprünglich
                    </Box>
                  )}
                  {image.isOptimized && (
                    <Box sx={{
                      position: 'absolute',
                      top: 8,
                      right: 8,
                      backgroundColor: 'rgba(76,175,80,0.9)',
                      color: 'white',
                      px: 1,
                      py: 0.5,
                      borderRadius: 1,
                      fontSize: '0.75rem'
                    }}>
                      Optimiert
                    </Box>
                  )}
                  {image.isMask && (
                    <Box sx={{
                      position: 'absolute',
                      top: 8,
                      right: 8,
                      backgroundColor: 'rgba(255,193,7,0.9)',
                      color: 'white',
                      px: 1,
                      py: 0.5,
                      borderRadius: 1,
                      fontSize: '0.75rem'
                    }}>
                      Maske
                    </Box>
                  )}
                </Box>
                <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
                  {image.name}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  {image.description}
                </Typography>
                {image.optimizationInstructions && (
                  <Box sx={{ 
                    backgroundColor: '#f5f5f5', 
                    p: 2, 
                    borderRadius: 1,
                    border: '1px solid #e0e0e0'
                  }}>
                    <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
                      Optimierungsanweisungen:
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {image.optimizationInstructions}
                    </Typography>
                  </Box>
                )}
              </Box>
            ))}
          </Box>
          
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
            <Button onClick={() => setShowImageOptimizer(false)}>
              Abbrechen
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Grafik-Upload-Modal */}
      <Dialog
        open={showImageUploadModal}
        onClose={() => {
          setShowImageUploadModal(false);
          setImageTypeToUpload(null);
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          p: 3
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <ImageIcon sx={{ fontSize: 32, color: 'white' }} />
            <Typography variant="h5" sx={{ fontWeight: 700, color: 'white', textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              {imageTypeToUpload === 'header' 
                ? t('cv.image.upload.title.header')
                : t('cv.image.upload.title.column')}
            </Typography>
          </Box>
        </DialogTitle>
        
        <DialogContent sx={{ p: 4 }}>
          <Box sx={{ height: 40 }} /> {/* Zusätzlicher Abstand */}
          <Box sx={{ mb: 4 }}>
            <Alert severity="info" sx={{ mb: 3 }}>
              <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                {t('cv.image.upload.maxSize')}
              </Typography>
              <Typography variant="body2">
                {imageTypeToUpload === 'header' 
                  ? t('cv.image.upload.maxSize.header')
                  : t('cv.image.upload.maxSize.column')}
              </Typography>
              <Typography variant="body2" sx={{ mt: 1, fontSize: '0.875rem', color: '#666' }}>
                {t('cv.image.upload.info')}
              </Typography>
              <Typography variant="body2" sx={{ mt: 2, fontSize: '0.875rem', color: '#666', fontStyle: 'italic' }}>
                {t('cv.image.upload.alignment')}
              </Typography>
            </Alert>
            
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center' }}>
              <input
                id="imageUploadFile"
                type="file"
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (file) {
                    const reader = new FileReader();
                    reader.onload = (event) => {
                      const img = new Image();
                      img.onload = () => {
                        const maxWidth = imageTypeToUpload === 'header' ? 794 : 318;
                        const maxHeight = imageTypeToUpload === 'header' ? 228 : 1123;
                        
                        if (img.width > maxWidth || img.height > maxHeight) {
                          alert(t('cv.image.upload.error.tooLarge', {
                            maxWidth,
                            maxHeight,
                            width: img.width,
                            height: img.height
                          }));
                          e.target.value = ''; // Reset file input
                          return;
                        }
                        
                        // Bild setzen
                        if (imageTypeToUpload === 'header') {
                          setTopBoxImage(event.target?.result as string);
                        } else {
                          setLeftColumnImage(event.target?.result as string);
                        }
                        
                        // Modal schließen
                        setShowImageUploadModal(false);
                        setImageTypeToUpload(null);
                      };
                      img.src = event.target?.result as string;
                    };
                    reader.readAsDataURL(file);
                  }
                }}
                style={{ display: 'none' }}
              />
              <label htmlFor="imageUploadFile">
                <Button
                  variant="contained"
                  component="span"
                  startIcon={<CloudUploadIcon />}
                  size="large"
                  sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    textTransform: 'none',
                    fontSize: '1.05rem',
                    fontWeight: 600,
                    px: 4,
                    py: 1.5,
                    borderRadius: 2,
                    boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #5568d3 0%, #6a4091 100%)',
                      boxShadow: '0 6px 16px rgba(102, 126, 234, 0.4)',
                    },
                  }}
                >
                  {t('cv.image.upload.select')}
                </Button>
              </label>
            </Box>
          </Box>
        </DialogContent>
        
        <DialogActions sx={{ 
          p: 3, 
          bgcolor: 'rgba(0,0,0,0.02)', 
          justifyContent: 'space-between',
          borderTop: '1px solid',
          borderColor: 'divider'
        }}>
          <Button
            onClick={() => {
              setShowImageUploadModal(false);
              setImageTypeToUpload(null);
            }}
            sx={{
              color: 'text.secondary',
              textTransform: 'none',
              fontSize: '1rem',
              '&:hover': {
                bgcolor: 'rgba(0,0,0,0.05)'
              }
            }}
          >
            {t('common.cancel')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Template Preview Dialog */}
      <Dialog
        open={showTemplatePreviewDialog}
        onClose={downloadingPdf ? undefined : (async () => {
          // Speichere CV-Settings in Firebase beim Schließen des Modals
          if (user?.uid) {
            try {
              const currentSettings = getCurrentCvSettings();
              await saveCvSettings(user.uid, currentSettings);
            } catch (error) {
              console.error('Fehler beim Speichern der CV-Settings:', error);
            }
          }
          
          // Speichere CV-Design-Settings (Header-Farbe, Grafiken, etc.)
          if (user) {
            try {
              await saveCvDesignSettings();
              console.log('✅ CV-Design-Settings beim Schließen gespeichert');
            } catch (error) {
              console.error('❌ Fehler beim Speichern der CV-Design-Settings:', error);
            }
          }
          
          // Speichere CV-Preview-Daten in applications Collection, wenn eine Application ausgewählt ist
          // Verwende selectedApplicationId wenn vorhanden, sonst selectedApplication.id
          const targetApplicationId = selectedApplicationId || selectedApplication?.id;
          if (targetApplicationId && user) {
            try {
              const token = await user.getIdToken();
              const cvPreviewData = getCvDataForTemplate();
              
              await fetch(`${config.backend.baseUrl}/api/save-application-cv-preview-data`, {
                method: 'POST',
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  applicationId: targetApplicationId,
                  cvPreviewData: cvPreviewData
                })
              });
              console.log('✅ CV-Preview-Daten beim Schließen gespeichert');
            } catch (error) {
              console.error('❌ Fehler beim Speichern der CV-Preview-Daten:', error);
            }
          }
          
          setShowTemplatePreviewDialog(false);
          // Zeige "CV optimieren" Button nach dem Schließen des CV-Templates
          setShowCvOptimierenButton(true);
          // Aktiviere Motivationsschreiben-Icon beim Schließen der Preview
          setCvTemplateHasBeenOpened(true);
          // Trigger Seitenberechnung im CV-Template
          window.dispatchEvent(new CustomEvent('modalClosed'));
        })}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            margin: '20px',
            '@media print': {
              boxShadow: 'none',
              margin: '0px',
              maxWidth: 'none',
              height: '100%'
            }
          }
        }}
        sx={{
          '@media print': {
            '& .MuiDialogTitle-root': {
              display: 'none'
            },
            '& .MuiDialogActions-root': {
              display: 'none'
            },
            '& button': {
              display: 'none !important'
            }
          }
        }}
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6">{getTranslatedCvLabel('CV-Vorschau')}</Typography>
            <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
              {/* Alle Rahmen Button - nur für Admin sichtbar */}
              {isAdmin() && (
                <Button
                  variant="outlined"
                  onClick={toggleAllBorders}
                  size="small"
                  sx={{ 
                    backgroundColor: (showCvBorder || showFrames) ? '#e0e0e0' : 'transparent',
                    fontSize: '0.65rem',
                    minWidth: 'auto',
                    px: 0.25,
                    py: 0.25,
                    whiteSpace: 'nowrap',
                    '&:hover': {
                      backgroundColor: (showCvBorder || showFrames) ? '#d0d0d0' : '#f5f5f5'
                    }
                  }}
                >
                  {(showCvBorder || showFrames) ? 'Rahmen aus' : 'Rahmen an'}
                </Button>
              )}

              {/* Refresh Button für Template-Rendering */}
              <IconButton 
                onClick={() => {
                  // Trigger Template-Rendering neu
                  window.dispatchEvent(new CustomEvent('refreshTemplate'));
                }}
                size="small"
                sx={{ 
                  backgroundColor: 'transparent',
                  '&:hover': {
                    backgroundColor: '#f5f5f5'
                  }
                }}
                title="Template neu rendern"
              >
                <RefreshIcon fontSize="small" />
              </IconButton>

              <IconButton
                onClick={handleDownloadCvPdf}
                disabled={downloadingPdf}
                size="small"
                sx={{ 
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  padding: '2px',
                  minWidth: 'auto',
                  width: '28px',
                  height: '28px'
                }}
                title="CV als PDF herunterladen / aktualisieren"
              >
                {downloadingPdf ? (
                  <CircularProgress 
                    size={20} 
                    sx={{ 
                      color: '#667eea' // Blau-violettes Farbschema wie CV Hochladen Button
                    }} 
                  />
                ) : (
                  <DownloadIcon />
                )}
              </IconButton>
                  <IconButton 
                    onClick={downloadingPdf ? undefined : async () => {
                      // Speichere CV-Settings in Firebase beim Schließen des Modals
                      if (user?.uid) {
                        try {
                          const currentSettings = getCurrentCvSettings();
                          await saveCvSettings(user.uid, currentSettings);
                        } catch (error) {
                          console.error('Fehler beim Speichern der CV-Settings:', error);
                        }
                      }
                      
                      // Speichere CV-Preview-Daten in applications Collection, wenn eine Application ausgewählt ist
                      if (selectedApplication?.id && user) {
                        try {
                          const token = await user.getIdToken();
                          const cvPreviewData = getCvDataForTemplate();
                          
                          await fetch(`${config.backend.baseUrl}/api/save-application-cv-preview-data`, {
                            method: 'POST',
                            headers: {
                              'Authorization': `Bearer ${token}`,
                              'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                              applicationId: selectedApplication.id,
                              cvPreviewData: cvPreviewData
                            })
                          });
                          console.log('✅ CV-Preview-Daten beim Schließen gespeichert');
                        } catch (error) {
                          console.error('❌ Fehler beim Speichern der CV-Preview-Daten:', error);
                        }
                      }
                      
                      // Speichere CV-Design-Settings (Header-Farbe, Grafiken, etc.)
                      if (user) {
                        try {
                          await saveCvDesignSettings();
                          console.log('✅ CV-Design-Settings beim Schließen gespeichert');
                        } catch (error) {
                          console.error('❌ Fehler beim Speichern der CV-Design-Settings:', error);
                        }
                      }
                      
                      setShowTemplatePreviewDialog(false);
                      // Zeige "CV optimieren" Button nach dem Schließen des CV-Templates
                      setShowCvOptimierenButton(true);
                      // Aktiviere Motivationsschreiben-Icon beim Schließen der Preview
                      setCvTemplateHasBeenOpened(true);
                      // Trigger Seitenberechnung im CV-Template
                      window.dispatchEvent(new CustomEvent('modalClosed'));
                    }} 
                    disabled={downloadingPdf}
                    size="small"
                    sx={{ 
                      color: 'error.main',
                      minWidth: 'auto',
                      padding: '2px',
                  width: '28px',
                  height: '28px',
                  '&:hover': { bgcolor: 'rgba(244, 67, 54, 0.1)' }
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        </DialogTitle>
        
        {/* Info-Textfeld oberhalb der CV Template Tabs */}
        <Box sx={{ px: 2, py: 1 }}>
          <Alert 
            severity="info" 
            sx={{ 
              borderRadius: 2,
              backgroundColor: '#f0f7ff',
              border: '1px solid #b3d9ff',
              '& .MuiAlert-icon': {
                color: '#1976d2'
              }
            }}
          >
            <Typography variant="body2" sx={{ color: '#1976d2', fontWeight: 500 }}>
              {getTranslatedCvLabel('Hier kannst du dir deinen CV in 3 verschiedenen Designs anzeigen lassen. Wähle ein Design aus und lies die Texte sorgfältig durch. Wenn du etwas ändern willst, klicke auf das entsprechende Element. Die Einstellungen findest du links neben der CV-Vorschau. Willst du den CV herunterladen, klicke auf das Download Icon oben rechts.')}
            </Typography>
          </Alert>
        </Box>
        
        {/* Template-Tabs */}
        <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
          <Tabs 
            value={selectedTemplateId} 
            onChange={(_, newValue) => handleTemplateChange(newValue)}
            variant="fullWidth"
            sx={{
              '& .MuiTab-root': {
                minHeight: 48,
                textTransform: 'none',
                fontWeight: 500
              }
            }}
          >
            <Tab 
              label={getTranslatedCvLabel('Modern')} 
              value="template1"
              sx={{ 
                color: selectedTemplateId === 'template1' ? '#667eea' : '#666',
                '&.Mui-selected': { color: '#667eea' }
              }}
            />
            <Tab 
              label={getTranslatedCvLabel('Professional')} 
              value="template2"
              sx={{ 
                color: selectedTemplateId === 'template2' ? '#667eea' : '#666',
                '&.Mui-selected': { color: '#667eea' }
              }}
            />
            <Tab 
              label={getTranslatedCvLabel('Classic')} 
              value="template3"
              sx={{ 
                color: selectedTemplateId === 'template3' ? '#667eea' : '#666',
                '&.Mui-selected': { color: '#667eea' }
              }}
            />
          </Tabs>
        </Box>
        
        <DialogContent sx={{ 
          padding: '20px',
          '@media print': {
            padding: '0px',
            '& .MuiDialogTitle-root': {
              display: 'none'
            },
            '& .MuiDialogActions-root': {
              display: 'none'
            },
            '& button': {
              display: 'none !important'
            }
          }
        }}>
          {/* Settings und CV Preview in zwei Spalten */}
          <Box sx={{ 
            display: 'flex', 
            gap: 2, 
            height: '70vh',
            '@media (max-width: 800px)': {
              flexDirection: 'column',
              height: 'auto'
            }
          }}>
            {/* Settings Panel links */}
            <Box sx={{ 
              width: '220px', 
              minWidth: '220px',
              borderRight: '1px solid #e0e0e0',
              pr: 2,
              overflowY: 'auto',
              maxHeight: '100%',
              '& .MuiFormControlLabel-root': { 
                mb: 0.125,
                '&:last-child': { mb: 0 }
              },
              '@media (max-width: 800px)': {
                width: '100%',
                minWidth: 'auto',
                borderRight: 'none',
                borderBottom: '1px solid #e0e0e0',
                pr: 0,
                pb: 2,
                maxHeight: '300px'
              }
            }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6" sx={{ color: '#333', fontWeight: 600 }}>
                  {getTranslatedCvLabel('CV-Einstellungen')}
                </Typography>
                <IconButton
                  onClick={handleResetDesign}
                  size="small"
                  sx={{ 
                    color: '#666',
                    '&:hover': {
                      backgroundColor: 'rgba(102, 102, 102, 0.1)',
                      color: '#333'
                    }
                  }}
                  title="Reset Design"
                >
                  <RestoreIcon />
                </IconButton>
              </Box>
              
              {/* Grafik-Einstellungen */}
              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle2" sx={{ mb: 1, color: '#666', fontWeight: 600 }}>
                  {getTranslatedCvLabel('Grafik')}
                </Typography>
                <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 1, p: 1, backgroundColor: '#fafafa', mt: 0.5 }}>
                {/* Header-Bild-Einstellungen */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                  <Typography variant="body2" sx={{ color: '#666', fontSize: '0.7rem', minWidth: '60px' }}>
                    {getTranslatedCvLabel('Header')}:
                  </Typography>
                  {!topBoxImage ? (
                    <button
                      onClick={() => {
                        setImageTypeToUpload('header');
                        setShowImageUploadModal(true);
                      }}
                      style={{
                        flex: 1,
                        padding: '4px 8px',
                        border: '1px solid #ccc',
                        borderRadius: '3px',
                        backgroundColor: '#f5f5f5',
                        cursor: 'pointer',
                        fontSize: '0.7rem',
                        textAlign: 'center'
                      }}
                    >
                      {getTranslatedCvLabel('Datei wählen')}
                    </button>
                  ) : (
                    <button
                      onClick={() => setTopBoxImage('')}
                      style={{
                        flex: 1,
                        padding: '4px 8px',
                        fontSize: '0.7rem',
                        border: '1px solid #ccc',
                        borderRadius: '3px',
                        backgroundColor: '#f5f5f5',
                        cursor: 'pointer',
                        color: '#d32f2f'
                      }}
                    >
                      {getTranslatedCvLabel('Entfernen')}
                    </button>
                  )}
                </Box>
                
                {/* Linke Spalte Bild-Einstellungen */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                  <Typography variant="body2" sx={{ color: '#666', fontSize: '0.7rem', minWidth: '60px' }}>
                    {getTranslatedCvLabel('Spalte:')}
                  </Typography>
                  {!leftColumnImage ? (
                    <button
                      onClick={() => {
                        setImageTypeToUpload('column');
                        setShowImageUploadModal(true);
                      }}
                      style={{
                        flex: 1,
                        padding: '4px 8px',
                        border: '1px solid #ccc',
                        borderRadius: '3px',
                        backgroundColor: '#f5f5f5',
                        cursor: 'pointer',
                        fontSize: '0.7rem',
                        textAlign: 'center'
                      }}
                    >
                      {getTranslatedCvLabel('Datei wählen')}
                    </button>
                  ) : (
                    <button
                      onClick={() => setLeftColumnImage('')}
                      style={{
                        flex: 1,
                        padding: '4px 8px',
                        fontSize: '0.7rem',
                        border: '1px solid #ccc',
                        borderRadius: '3px',
                        backgroundColor: '#f5f5f5',
                        cursor: 'pointer',
                        color: '#d32f2f'
                      }}
                    >
                      {getTranslatedCvLabel('Entfernen')}
                    </button>
                  )}
                </Box>
                </Box>
              </Box>
              
              {/* Design-Einstellungen */}
              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle2" sx={{ mb: 1, color: '#666', fontWeight: 600 }}>
                  {getTranslatedCvLabel('Design')}
                </Typography>
                
                {/* Wrapper für alle Farb-Picker */}
                <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 1, p: 1, backgroundColor: '#fafafa', mt: 0.5, mb: 1 }}>
                  <Box sx={{ mb: 1 }}>
                  <Typography variant="body2" sx={{ mb: 0.5, color: '#666', fontSize: '0.75rem' }}>
                    Farben
                  </Typography>
                  
                  {/* Header Farbe */}
                  <Box sx={{ mb: 0.5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                      <button
                        onClick={() => handleColorPickerClick('header')}
                        style={{
                          width: '20px',
                          height: '20px',
                          border: '1px solid #ccc',
                          borderRadius: '50%',
                          cursor: 'pointer',
                          backgroundColor: topBoxColor,
                          padding: 0
                        }}
                      />
                      <Typography variant="body2" sx={{ color: '#666', fontSize: '0.7rem' }}>
                        Header
                      </Typography>
                    </Box>
                  </Box>
                  
                  {/* Spaltenfarbe */}
                  <Box sx={{ mb: 0.5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                      <button
                        onClick={() => handleColorPickerClick('column')}
                        style={{
                          width: '20px',
                          height: '20px',
                          border: '1px solid #ccc',
                          borderRadius: '50%',
                          cursor: 'pointer',
                          backgroundColor: leftColumnColor,
                          padding: 0
                        }}
                      />
                      <Typography variant="body2" sx={{ color: '#666', fontSize: '0.7rem' }}>
                        Spalte
                      </Typography>
                    </Box>
                  </Box>
                  
                  {/* Name Text Color */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                    <button
                      onClick={() => handleColorPickerClick('name')}
                      style={{
                        width: '20px',
                        height: '20px',
                        border: '1px solid #ccc',
                        borderRadius: '50%',
                        cursor: 'pointer',
                        backgroundColor: nameTextColor,
                        padding: 0
                      }}
                    />
                    <Typography variant="body2" sx={{ color: '#666', fontSize: '0.7rem' }}>
                      Name
                    </Typography>
                  </Box>
                  
                  {/* Left Column Title Color */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                    <button
                      onClick={() => handleColorPickerClick('leftTitle')}
                      style={{
                        width: '20px',
                        height: '20px',
                        border: '1px solid #ccc',
                        borderRadius: '50%',
                        cursor: 'pointer',
                        backgroundColor: leftColumnTitleColor,
                        padding: 0
                      }}
                    />
                    <Typography variant="body2" sx={{ color: '#666', fontSize: '0.7rem' }}>
                      Titel links
                    </Typography>
                  </Box>
                  
                  {/* Left Column Text Color */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                    <button
                      onClick={() => handleColorPickerClick('leftText')}
                      style={{
                        width: '20px',
                        height: '20px',
                        border: '1px solid #ccc',
                        borderRadius: '50%',
                        cursor: 'pointer',
                        backgroundColor: leftColumnTextColor,
                        padding: 0
                      }}
                    />
                    <Typography variant="body2" sx={{ color: '#666', fontSize: '0.7rem' }}>
                      Text links
                    </Typography>
                  </Box>
                </Box>
                  
                  {/* Right Column Title Color */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                    <button
                      onClick={() => handleColorPickerClick('rightTitle')}
                      style={{
                        width: '20px',
                        height: '20px',
                        border: '1px solid #ccc',
                        borderRadius: '50%',
                        cursor: 'pointer',
                        backgroundColor: rightColumnTitleColor,
                        padding: 0
                      }}
                    />
                    <Typography variant="body2" sx={{ color: '#666', fontSize: '0.7rem' }}>
                      Titel rechts
                    </Typography>
                  </Box>
                  
                  {/* Right Column Text Color */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                    <button
                      onClick={() => handleColorPickerClick('rightText')}
                      style={{
                        width: '20px',
                        height: '20px',
                        border: '1px solid #ccc',
                        borderRadius: '50%',
                        cursor: 'pointer',
                        backgroundColor: rightColumnTextColor,
                        padding: 0
                      }}
                    />
                    <Typography variant="body2" sx={{ color: '#666', fontSize: '0.7rem' }}>
                      Text rechts
                    </Typography>
                  </Box>
                </Box>
                  
                  <Typography variant="subtitle2" sx={{ mb: 1, color: '#666', fontWeight: 600, mt: 2 }}>
                    {getTranslatedCvLabel('Sichtbarkeit')}
                  </Typography>
                
                <Box sx={{ pl: 3, border: '1px solid #e0e0e0', borderRadius: 1, p: 1, backgroundColor: '#fafafa' }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={showProfileImageInCv}
                      onChange={() => setShowProfileImageInCv(!showProfileImageInCv)}
                      size="small"
                      disableRipple
                      disableFocusRipple
                      sx={{
                        p: 1,
                        '&:hover': { backgroundColor: 'transparent' },
                        '& .MuiTouchRipple-root': { display: 'none' },
                        '& .MuiSvgIcon-root': { 
                          borderRadius: '50%',
                        },
                        color: '#667eea',
                        '&.Mui-checked': {
                          color: '#667eea',
                        }
                      }}
                    />
                  }
                  label={getTranslatedCvLabel('Profilbild')}
                  sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                />
                
                  <FormControlLabel
                  control={
                    <Checkbox
                      checked={showProfileInCv}
                      onChange={() => setShowProfileInCv(!showProfileInCv)}
                      size="small"
                      disableRipple
                      disableFocusRipple
                      sx={{
                        p: 1,
                        '&:hover': { backgroundColor: 'transparent' },
                        '& .MuiTouchRipple-root': { display: 'none' },
                        '& .MuiSvgIcon-root': { 
                          borderRadius: '50%',
                        },
                        color: '#667eea',
                        '&.Mui-checked': {
                          color: '#667eea',
                        }
                      }}
                    />
                  }
                  label={getTranslatedCvLabel('Kurzprofil')}
                  sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                />
                
                  <FormControlLabel
                  control={
                    <Checkbox
                      checked={showCoreCompetenciesInCv}
                      onChange={() => setShowCoreCompetenciesInCv(!showCoreCompetenciesInCv)}
                      size="small"
                      disableRipple
                      disableFocusRipple
                      sx={{
                        p: 1,
                        '&:hover': { backgroundColor: 'transparent' },
                        '& .MuiTouchRipple-root': { display: 'none' },
                        '& .MuiSvgIcon-root': { 
                          borderRadius: '50%',
                        },
                        color: '#667eea',
                        '&.Mui-checked': {
                          color: '#667eea',
                        }
                      }}
                    />
                  }
                  label={getTranslatedCvLabel('Kernkompetenzen')}
                  sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                />
                
                  <FormControlLabel
                  control={
                    <Checkbox
                      checked={showEducationInCv}
                      onChange={() => setShowEducationInCv(!showEducationInCv)}
                      size="small"
                      disableRipple
                      disableFocusRipple
                      sx={{
                        p: 1,
                        '&:hover': { backgroundColor: 'transparent' },
                        '& .MuiTouchRipple-root': { display: 'none' },
                        '& .MuiSvgIcon-root': { 
                          borderRadius: '50%',
                        },
                        color: '#667eea',
                        '&.Mui-checked': {
                          color: '#667eea',
                        }
                      }}
                    />
                  }
                  label={getTranslatedCvLabel('Ausbildung')}
                  sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                />
                
                  <FormControlLabel
                  control={
                    <Checkbox
                      checked={showCertificationsInCv}
                      onChange={() => setShowCertificationsInCv(!showCertificationsInCv)}
                      size="small"
                      disableRipple
                      disableFocusRipple
                      sx={{
                        p: 1,
                        '&:hover': { backgroundColor: 'transparent' },
                        '& .MuiTouchRipple-root': { display: 'none' },
                        '& .MuiSvgIcon-root': { 
                          borderRadius: '50%',
                        },
                        color: '#667eea',
                        '&.Mui-checked': {
                          color: '#667eea',
                        }
                      }}
                    />
                  }
                  label={getTranslatedCvLabel('Zertifizierungen')}
                  sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                />
                
                  <FormControlLabel
                  control={
                    <Checkbox
                      checked={showItSkillsInCv}
                      onChange={() => setShowItSkillsInCv(!showItSkillsInCv)}
                      size="small"
                      disableRipple
                      disableFocusRipple
                      sx={{
                        p: 1,
                        '&:hover': { backgroundColor: 'transparent' },
                        '& .MuiTouchRipple-root': { display: 'none' },
                        '& .MuiSvgIcon-root': { 
                          borderRadius: '50%',
                        },
                        color: '#667eea',
                        '&.Mui-checked': {
                          color: '#667eea',
                        }
                      }}
                    />
                  }
                  label={getTranslatedCvLabel('IT-Skills')}
                  sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                />
                
                  <FormControlLabel
                  control={
                    <Checkbox
                      checked={showIndustriesInCv}
                      onChange={() => setShowIndustriesInCv(!showIndustriesInCv)}
                      size="small"
                      disableRipple
                      disableFocusRipple
                      sx={{
                        p: 1,
                        '&:hover': { backgroundColor: 'transparent' },
                        '& .MuiTouchRipple-root': { display: 'none' },
                        '& .MuiSvgIcon-root': { 
                          borderRadius: '50%',
                        },
                        color: '#667eea',
                        '&.Mui-checked': {
                          color: '#667eea',
                        }
                      }}
                    />
                  }
                  label={getTranslatedCvLabel('Branchen')}
                  sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                />
                
                  <FormControlLabel
                  control={
                    <Checkbox
                      checked={showLanguagesInCv}
                      onChange={() => setShowLanguagesInCv(!showLanguagesInCv)}
                      size="small"
                      disableRipple
                      disableFocusRipple
                      sx={{
                        p: 1,
                        '&:hover': { backgroundColor: 'transparent' },
                        '& .MuiTouchRipple-root': { display: 'none' },
                        '& .MuiSvgIcon-root': { 
                          borderRadius: '50%',
                        },
                        color: '#667eea',
                        '&.Mui-checked': {
                          color: '#667eea',
                        }
                      }}
                    />
                  }
                  label={getTranslatedCvLabel('Sprachen')}
                  sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                />
                
                  <FormControlLabel
                  control={
                    <Checkbox
                      checked={showWorkExperienceInCv}
                      onChange={() => setShowWorkExperienceInCv(!showWorkExperienceInCv)}
                      size="small"
                      disableRipple
                      disableFocusRipple
                      sx={{
                        p: 1,
                        '&:hover': { backgroundColor: 'transparent' },
                        '& .MuiTouchRipple-root': { display: 'none' },
                        '& .MuiSvgIcon-root': { 
                          borderRadius: '50%',
                        },
                        color: '#667eea',
                        '&.Mui-checked': {
                          color: '#667eea',
                        }
                      }}
                    />
                  }
                  label={getTranslatedCvLabel('Berufserfahrung')}
                  sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                />
                
                  <FormControlLabel
                  control={
                    <Checkbox
                      checked={showAdditionalWorkExperienceInCv}
                      onChange={() => setShowAdditionalWorkExperienceInCv(!showAdditionalWorkExperienceInCv)}
                      size="small"
                      disableRipple
                      disableFocusRipple
                      sx={{
                        p: 1,
                        '&:hover': { backgroundColor: 'transparent' },
                        '& .MuiTouchRipple-root': { display: 'none' },
                        '& .MuiSvgIcon-root': { 
                          borderRadius: '50%',
                        },
                        color: '#667eea',
                        '&.Mui-checked': {
                          color: '#667eea',
                        }
                      }}
                    />
                  }
                  label={getTranslatedCvLabel('Weitere Berufserfahrungen')}
                  sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                />
                
                  <FormControlLabel
                  control={
                    <Checkbox
                      checked={showHobbiesInCv}
                      onChange={() => setShowHobbiesInCv(!showHobbiesInCv)}
                      size="small"
                      disableRipple
                      disableFocusRipple
                      sx={{
                        p: 1,
                        '&:hover': { backgroundColor: 'transparent' },
                        '& .MuiTouchRipple-root': { display: 'none' },
                        '& .MuiSvgIcon-root': { 
                          borderRadius: '50%',
                        },
                        color: '#667eea',
                        '&.Mui-checked': {
                          color: '#667eea',
                        }
                      }}
                    />
                  }
                  label={getTranslatedCvLabel('Hobbys')}
                  sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                />
                
                  <FormControlLabel
                  control={
                    <Checkbox
                      checked={showAdditionalInfoInCv}
                      onChange={() => setShowAdditionalInfoInCv(!showAdditionalInfoInCv)}
                      size="small"
                      disableRipple
                      disableFocusRipple
                      sx={{
                        p: 1,
                        '&:hover': { backgroundColor: 'transparent' },
                        '& .MuiTouchRipple-root': { display: 'none' },
                        '& .MuiSvgIcon-root': { 
                          borderRadius: '50%',
                        },
                        color: '#667eea',
                        '&.Mui-checked': {
                          color: '#667eea',
                        }
                      }}
                    />
                  }
                  label={getTranslatedCvLabel('Zusätzliche Infos')}
                  sx={{ display: 'block', mb: 1, '& .MuiFormControlLabel-label': { fontSize: '0.7rem' } }}
                />
                </Box>
              </Box>

              {/* Schließe linke Einstellungs-Spalte */}
            </Box>

            {/* CV Preview rechts */}
            <Box sx={{ 
              flex: 1, 
              overflow: 'auto',
              '@media (max-width: 800px)': {
                flex: 'none',
                height: '70vh'
              }
            }}>
              <CvTemplate
            cvData={getCvDataForTemplate()}
            profileImage={showPhotoInCv && profileImage ? profileImage : undefined}
            templateStyle={getTemplateStyle(selectedTemplateId)}
            nameTextColor={nameTextColor}
            leftColumnTextColor={leftColumnTextColor}
            rightColumnTextColor={rightColumnTextColor}
            leftColumnTitleColor={leftColumnTitleColor}
            rightColumnTitleColor={rightColumnTitleColor}
            showBorder={showCvBorder}
            showFrames={showFrames}
            onWorkExperienceChange={handleWorkExperienceChange}
            onCoreCompetenciesTitleChange={handleCoreCompetenciesTitleChange}
            onCertificationsTitleChange={handleCertificationsTitleChange}
            onItSkillsTitleChange={handleItSkillsTitleChange}
            onIndustriesTitleChange={handleIndustriesTitleChange}
            onLanguagesTitleChange={handleLanguagesTitleChange}
            onHobbiesTitleChange={handleHobbiesTitleChange}
            onEducationTitleChange={handleEducationTitleChange}
            onWorkExperienceTitleChange={handleWorkExperienceTitleChange}
            onProfileTitleChange={handleProfileTitleChange}
            targetLanguage={targetLanguage}
            translatedYears={translatedYears}
            leftColumnColor={hexToRgba(leftColumnColor, leftColumnAlpha)}
            topBoxColor={hexToRgba(topBoxColor, topBoxAlpha)}
            topBoxImage={topBoxImage}
            leftColumnImage={leftColumnImage}
            isEditMode={true}
            showCoreCompetenciesInCv={showCoreCompetenciesInCv}
            showCertificationsInCv={showCertificationsInCv}
            showItSkillsInCv={showItSkillsInCv}
            showIndustriesInCv={showIndustriesInCv}
            showLanguagesInCv={showLanguagesInCv}
            showHobbiesInCv={showHobbiesInCv}
            showEducationInCv={showEducationInCv}
            showWorkExperienceInCv={showWorkExperienceInCv}
            showAdditionalWorkExperienceInCv={showAdditionalWorkExperienceInCv}
            showProfileInCv={showProfileInCv}
            showAdditionalInfoInCv={showAdditionalInfoInCv}
            showProfileImageInCv={showProfileImageInCv}
            profileImageBorderRadius={profileImageBorderRadius}
            profileImageSize={profileImageSize}
            profileImageWidth={profileImageWidth}
            profileImagePosition={profileImagePosition}
            profileImageAlignment={profileImageAlignment}
            profileImageBorder={profileImageBorder}
            profileImageBorderColor={profileImageBorderColor}
            profileImageBorderThickness={profileImageBorderThickness}
            contactDisplayMode={contactDisplayMode}
            onContactDisplayModeChange={handleContactDisplayModeChange}
            nameFontSize={nameFontSize}
            onNameFontSizeChange={handleNameFontSizeChange}
            data-testid="cv-template"
          />
          </Box>
          </Box>
        </DialogContent>
      </Dialog>



      {/* Bestaetigungsdialog fuer ungespeicherte Aenderungen */}
      <Dialog
        open={showUnsavedChangesDialog}
        onClose={() => setShowUnsavedChangesDialog(false)}
        maxWidth="sm"
      >
        <DialogTitle>
          {getTranslatedCvLabel('Ungespeicherte Änderungen')}
        </DialogTitle>
        <DialogContent>
          <Typography>
            {getTranslatedCvLabel('Sie haben ungespeicherte Änderungen. Möchten Sie wirklich schließen ohne zu speichern?')}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => setShowUnsavedChangesDialog(false)}
            variant="outlined"
          >
            {getTranslatedCvLabel('Abbrechen')}
          </Button>
          <Button 
            onClick={confirmCloseCvDataModal}
            variant="contained"
            color="error"
          >
            {getTranslatedCvLabel('Ohne Speichern schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* QR-Code Dialog */}
      <Dialog
        open={showQrCodeDialog}
        onClose={() => {
          setShowQrCodeDialog(false);
          // Trigger Seitenberechnung im CV-Template
          window.dispatchEvent(new CustomEvent('modalClosed'));
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ width: '100%', maxWidth: '100%' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6">Foto über Smartphone hochladen</Typography>
            <Button onClick={() => setShowQrCodeDialog(false)} size="small">
              Schließen
            </Button>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, py: 2 }}>
            <Typography variant="body1" textAlign="center">
              Scannen Sie diesen QR-Code mit Ihrem Smartphone, um ein Foto hochzuladen:
            </Typography>
            
            {qrCodeData ? (
              <Box sx={{ border: '2px solid #e0e0e0', borderRadius: 2, p: 2, backgroundColor: 'white' }}>
                <img 
                  src={qrCodeData} 
                  alt="QR-Code für Foto-Upload" 
                  style={{ width: 300, height: 300, display: 'block' }}
                  onLoad={() => console.log('✅ QR-Code Bild geladen')}
                  onError={(e) => console.error('❌ QR-Code Bild Fehler:', e)}
                />
              </Box>
            ) : (
              <Box sx={{ border: '2px solid #e0e0e0', borderRadius: 2, p: 2, backgroundColor: 'white', width: 300, height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography color="text.secondary">
                  {getTranslatedCvLabel('QR-Code wird geladen...')}
                </Typography>
              </Box>
            )}
            
            <Typography variant="body2" color="text.secondary" textAlign="center">
              {getTranslatedCvLabel('Der QR-Code ist 10 Minuten gültig. Das Foto wird automatisch als Profilbild übernommen.')}
            </Typography>
            
            {qrExpiresAt && (
              <Typography variant="caption" color="text.secondary">
                Gültig bis: {new Date(qrExpiresAt).toLocaleString('de-DE')}
              </Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button 
            variant="outlined"
            onClick={() => setShowQrCodeDialog(false)}
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            Schließen
          </Button>
        </DialogActions>
      </Dialog>

      {/* Motivationsschreiben Dialog */}
      <Dialog
        open={showMotivationDialog}
        onClose={handleCloseMotivationDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            margin: '20px',
            overflowX: 'hidden',
            '@media print': {
              boxShadow: 'none',
              margin: '0px',
              maxWidth: 'none',
              height: '100%'
            }
          }
        }}
        sx={{
          '@media print': {
            '& .MuiDialogTitle-root': {
              display: 'none'
            },
            '& .MuiDialogActions-root': {
              display: 'none'
            },
            '& button': {
              display: 'none !important'
            }
          }
        }}
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6">{getTranslatedCvLabel('Motivationsschreiben-Vorschau')}</Typography>
            <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
              {isAdmin() && (
                <Button
                  variant="outlined"
                  onClick={() => setShowMotivationBorder(!showMotivationBorder)}
                  size="small"
                  sx={{ 
                    backgroundColor: showMotivationBorder ? '#e0e0e0' : 'transparent',
                    '&:hover': {
                      backgroundColor: showMotivationBorder ? '#d0d0d0' : '#f5f5f5'
                    }
                  }}
                >
                  {showMotivationBorder ? 'Rahmen entfernen' : 'Rahmen anzeigen'}
                </Button>
              )}
              <IconButton
                onClick={handleDownloadMotivationPdf}
                disabled={downloadingMotivationPdf}
                size="small"
                sx={{ 
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  padding: '2px',
                  minWidth: 'auto',
                  width: '28px',
                  height: '28px'
                }}
              >
                {downloadingMotivationPdf ? (
                  <CircularProgress 
                    size={20} 
                    sx={{ 
                      color: '#667eea'
                    }} 
                  />
                ) : (
                  <DownloadIcon />
                )}
              </IconButton>
              <IconButton 
                onClick={handleCloseMotivationDialog} 
                size="small"
                sx={{ 
                  color: 'error.main',
                  minWidth: 'auto',
                  padding: '2px',
                  width: '28px',
                  height: '28px',
                  '&:hover': { bgcolor: 'rgba(244, 67, 54, 0.1)' }
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        </DialogTitle>
        
        {/* Info-Textfeld oberhalb des Motivationsschreibens */}
        <Box sx={{ px: 2, py: 1 }}>
          <Alert 
            severity="info" 
            sx={{ 
              borderRadius: 2,
              backgroundColor: '#f0f7ff',
              border: '1px solid #b3d9ff',
              '& .MuiAlert-icon': {
                color: '#1976d2'
              }
            }}
          >
            <Typography variant="body2" sx={{ color: '#1976d2', fontWeight: 500 }}>
              {getTranslatedCvLabel('Bitte lies das Motivationsschreiben gut durch. Willst du etwas ändern, klicke auf den entsprechenden Text. Willst du es herunter laden, klicke auf das Download Icon oben rechts.')}
            </Typography>
          </Alert>
        </Box>
        
        <DialogContent sx={{
          p: 3,
          overflowX: 'hidden',
          '@media print': {
            padding: '0px',
            '& .MuiDialogTitle-root': {
              display: 'none'
            },
            '& .MuiDialogActions-root': {
              display: 'none'
            },
            '& button': {
              display: 'none !important'
            }
          }
        }}>
          <Box sx={{ mt: 2 }}>
            <MotivationTemplateComponent
              data-testid="motivation-template"
              data={{
                personalInfo: {
                  fullName: fullName || 'Max Mustermann',
                  address: address || 'Musterstraße 123',
                  postalCode: postalCode || '12345',
                  city: city || 'Musterstadt',
                  country: country || '',
                  availableFrom: availableFrom || '',
                  phoneNumber: phoneNumber || '+49 123 456789',
                  email: email || 'max.mustermann@email.com',
                  birthYear: '',
                  nationality: '',
                  residencePermit: '',
                  civilStatus: ''
                },
                recipientInfo: motivationRecipientInfo || {
                  company: 'Firma Mustermax GmbH',
                  contactPerson: 'Hans-Rudolf Graber',
                  address: 'Mustermaxstrasse 12',
                  postalCode: '9999',
                  city: 'Musterort'
                },
                title: tempMotivationTitle || 'Bewerbung als Softwareentwickler',
                greeting: tempMotivationGreeting || 'Sehr geehrte Damen und Herren,',
                motivationText: tempMotivationLetter || '',
                signature: signature || undefined,
                // Editierbare Felder
                senderName: tempMotivationSenderName,
                senderAddress: tempMotivationSenderAddress,
                senderPostalCode: tempMotivationSenderPostalCode,
                senderCity: tempMotivationSenderCity,
                recipientCompany: tempMotivationRecipientCompany,
                recipientContactPerson: tempMotivationRecipientContactPerson,
                recipientAddress: tempMotivationRecipientAddress,
                recipientPostalCode: tempMotivationRecipientPostalCode,
                recipientCity: tempMotivationRecipientCity,
                closingText: tempMotivationClosingText,
                dateLocation: tempMotivationDateLocation,
                signatureName: tempMotivationSignatureName
              }}
              onTitleChange={setTempMotivationTitle}
              onGreetingChange={setTempMotivationGreeting}
              onMotivationTextChange={setTempMotivationLetter}
              onSenderNameChange={setTempMotivationSenderName}
              onSenderAddressChange={setTempMotivationSenderAddress}
              onSenderPostalCodeChange={setTempMotivationSenderPostalCode}
              onSenderCityChange={setTempMotivationSenderCity}
              onRecipientCompanyChange={setTempMotivationRecipientCompany}
              onRecipientContactPersonChange={setTempMotivationRecipientContactPerson}
              onRecipientAddressChange={setTempMotivationRecipientAddress}
              onRecipientPostalCodeChange={setTempMotivationRecipientPostalCode}
              onRecipientCityChange={setTempMotivationRecipientCity}
              onClosingTextChange={setTempMotivationClosingText}
              onDateLocationChange={setTempMotivationDateLocation}
              onSignatureNameChange={setTempMotivationSignatureName}
              showBorder={showMotivationBorder}
            />
          </Box>
        </DialogContent>

      </Dialog>

      {/* Modal für Prompt-Editor */}
      <Dialog
        open={promptEditorOpen}
        onClose={handleClosePromptEditor}
        maxWidth={false}
        fullWidth
        PaperProps={{
          sx: {
            maxHeight: '90vh',
            minHeight: '70vh',
            width: '95vw',
            maxWidth: '1800px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ width: '100%', maxWidth: '100%', overflowX: 'hidden' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box>
              <Typography variant="h6">
                {originalPromptName ? `Prompt bearbeiten: ${originalPromptName}` : 'Prompt bearbeiten'}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {prompts.length} Prompts aus Firebase geladen
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 1, mr: 10 }}>
              <IconButton 
                onClick={handleRefreshPrompts}
                title="Prompts aus Firebase aktualisieren"
              >
                <RestoreIcon />
              </IconButton>
              <IconButton 
                color="error" 
                onClick={handleDeletePrompt}
                title="Prompt löschen"
                disabled={!originalPromptName}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton onClick={handleClosePromptEditor}>
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        </DialogTitle>
        
        <DialogContent sx={{ overflowX: 'hidden' }}>
          {/* Prompt-Name Bearbeitung */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              Prompt-Name
            </Typography>
            <TextField
              fullWidth
              label="Prompt-Name"
              value={editingPromptName}
              onChange={(e) => handlePromptNameChange(e.target.value)}
              disabled={editingPromptIndex === null}
              helperText="Der Name des Prompts (wird beim Speichern oder Testen übernommen)"
              sx={{ mb: 2 }}
            />
          </Box>

          {/* Verwendung und ChatGPT-Version Dropdowns */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              Prompt-Konfiguration
            </Typography>
            
            {/* Zeile 1: Verwendung und ChatGPT-Version nebeneinander */}
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              {/* Verwendung Dropdown */}
              <FormControl sx={{ flex: 1 }}>
                <InputLabel>Verwendung</InputLabel>
                <Select
                  value={editingPromptUsage}
                  onChange={(e) => setEditingPromptUsage(e.target.value)}
                  label="Verwendung"
                >
                  <MenuItem value="Extraktion">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Chip 
                        label="Extraktion" 
                        color="primary"
                        size="small"
                        variant="outlined"
                      />
                      <Typography variant="body2" color="text.secondary">
                        - Extrahiert Daten aus CV-Dokumenten
                      </Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem value="Optimierung">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Chip 
                        label="Optimierung" 
                        color="secondary"
                        size="small"
                        variant="outlined"
                      />
                      <Typography variant="body2" color="text.secondary">
                        - Optimiert Daten für Stellenausschreibungen
                      </Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem value="Foto">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Chip 
                        label="Foto" 
                        color="success"
                        size="small"
                        variant="outlined"
                      />
                      <Typography variant="body2" color="text.secondary">
                        - Optimiert und bearbeitet Profilbilder
                      </Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem value="Check">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Chip 
                        label="Check" 
                        color="warning"
                        size="small"
                        variant="outlined"
                      />
                      <Typography variant="body2" color="text.secondary">
                        - Überprüft und validiert Daten
                      </Typography>
                    </Box>
                  </MenuItem>
                </Select>
              </FormControl>
              
              {/* ChatGPT-Version Dropdown */}
              <FormControl sx={{ flex: 1 }}>
                <InputLabel>ChatGPT-Version</InputLabel>
                <Select
                  value={editingPromptVersion}
                  onChange={(e) => setEditingPromptVersion(e.target.value)}
                  label="ChatGPT-Version"
                >
                  {chatGptVersions.map((version) => (
                    <MenuItem key={version.value} value={version.value}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                          {version.label}
                        </Typography>
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            
            {/* Zeile 2: Temperatur und Max Tokens nebeneinander */}
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <FormControl fullWidth>
                <TextField
                  label="Temperatur"
                  type="number"
                  value={editingPromptTemperature}
                  onChange={(e) => setEditingPromptTemperature(e.target.value)}
                  inputProps={{ 
                    min: 0, 
                    max: 2, 
                    step: 0.1 
                  }}
                  helperText="0.0 = deterministisch, 2.0 = sehr kreativ"
                />
              </FormControl>
              
              <FormControl fullWidth>
                <TextField
                  label="Max Tokens"
                  type="number"
                  value={editingPromptMaxTokens}
                  onChange={(e) => setEditingPromptMaxTokens(e.target.value)}
                  inputProps={{ 
                    min: 1, 
                    max: 32000, 
                    step: 1 
                  }}
                  helperText="Maximale Anzahl der Tokens in der Antwort"
                />
              </FormControl>
            </Box>
            
            {/* System-Rolle */}
            <Box sx={{ mb: 2 }}>
              <TextField
                fullWidth
                label="System-Rolle (ChatGPT Identität)"
                value={editingPromptSystemRole}
                onChange={(e) => setEditingPromptSystemRole(e.target.value)}
                multiline
                minRows={2}
                helperText="Die Rolle definiert, wie sich ChatGPT verhält (z.B. 'Du bist ein Experte für...')"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    fontSize: '13px'
                  }
                }}
              />
            </Box>
            
            {/* Informationen zur ausgewählten Version */}
            {(() => {
              const selectedVersion = chatGptVersions.find(v => v.value === editingPromptVersion);
              if (!selectedVersion) return null;
              
              return (
                <Box sx={{ 
                  p: 2, 
                  border: '1px solid #e0e0e0', 
                  borderRadius: 1, 
                  backgroundColor: '#f8f8f8' 
                }}>
                  <Typography variant="h6" gutterBottom>
                    {selectedVersion.label} - {selectedVersion.description}
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 3, mb: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                        Geschwindigkeit:
                      </Typography>
                      <Chip 
                        label={selectedVersion.speed} 
                        size="small" 
                        sx={{ 
                          backgroundColor: selectedVersion.speedColor, 
                          color: 'white',
                          fontWeight: 'bold'
                        }} 
                      />
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                        Qualität:
                      </Typography>
                      <Chip 
                        label={selectedVersion.quality} 
                        size="small" 
                        sx={{ 
                          backgroundColor: selectedVersion.qualityColor, 
                          color: 'white',
                          fontWeight: 'bold'
                        }} 
                      />
                    </Box>
                  </Box>
                  <Typography variant="body2" color="text.secondary">
                    {selectedVersion.details}
                  </Typography>
                </Box>
              );
            })()}
          </Box>

          {/* Target Language Anzeige */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              Aktuelle Zielsprache
            </Typography>
            <Box sx={{ 
              p: 2, 
              border: '1px solid #e0e0e0', 
              borderRadius: 1, 
              backgroundColor: '#f8f8f8',
              display: 'flex',
              alignItems: 'center',
              gap: 2
            }}>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                targetLanguage:
              </Typography>
              <Chip 
                label={targetLanguage} 
                color="primary"
                size="small"
                sx={{ fontWeight: 'bold' }}
              />
              <Typography variant="body2" color="text.secondary">
                (Diese Variable wird in Prompts als {`{targetLanguage}`} ersetzt)
              </Typography>
            </Box>
          </Box>

          <TextField
            multiline
            minRows={10}
            value={editingPromptText}
            onChange={(e) => setEditingPromptText(e.target.value)}
            variant="outlined"
            fullWidth
            sx={{
              '& .MuiOutlinedInput-root': {
                fontSize: '12px',
                fontFamily: 'monospace'
              },
              '& .MuiInputBase-input': {
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word'
              }
            }}
          />
          
          {/* Test-Ergebnis - Immer sichtbar */}
          <Box sx={{ mt: 3 }}>
            <Typography variant="h6" gutterBottom>
              Test-Ergebnis:
            </Typography>
            <TextField
              multiline
              minRows={5}
              value={testResult || 'Klicke auf "Prompt testen" um ein Ergebnis zu erhalten...'}
              variant="outlined"
              fullWidth
              InputProps={{
                readOnly: true
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: '12px',
                  fontFamily: 'monospace',
                  backgroundColor: testResult ? '#f5f5f5' : '#fafafa'
                }
              }}
            />
          </Box>
          
          {/* Mitgelieferte Daten - Minimierbar */}
          <Box sx={{ mt: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
              <Typography variant="h6">
                Mitgelieferte Daten
              </Typography>
              <IconButton 
                onClick={() => setShowMitgelieferteDaten(!showMitgelieferteDaten)}
                size="small"
                sx={{ 
                  color: 'primary.main',
                  '&:hover': { bgcolor: 'rgba(25, 118, 210, 0.1)' }
                }}
              >
                {showMitgelieferteDaten ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            </Box>
            
            {showMitgelieferteDaten && (
              <TextField
                multiline
                minRows={3}
                value={getMitgelieferteDatenText()}
                variant="outlined"
                fullWidth
                InputProps={{
                  readOnly: true
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    fontSize: '11px',
                    fontFamily: 'monospace',
                    backgroundColor: '#f0f8ff'
                  }
                }}
                helperText="Nur die Daten, die mit dem Prompt mitgegeben werden (ohne Stellenbeschreibung oder andere Texte)"
              />
            )}
          </Box>
          
          {/* Datenset-Übersicht */}
          <Box sx={{ mt: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
              <Typography variant="h6">
                Verwendete Datensets
              </Typography>
              <IconButton 
                onClick={() => setShowVerwendeteDatensets(!showVerwendeteDatensets)}
                size="small"
                sx={{ 
                  color: 'primary.main',
                  '&:hover': { bgcolor: 'rgba(25, 118, 210, 0.1)' }
                }}
              >
                {showVerwendeteDatensets ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            </Box>
            
            {showVerwendeteDatensets && (
              <Box sx={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
                gap: 2 
              }}>
                  <Box sx={{ 
                    p: 2, 
                    border: '1px solid #e0e0e0', 
                    borderRadius: 1, 
                    backgroundColor: '#f8f8f8' 
                  }}>
                    <Typography variant="subtitle2" gutterBottom>
                      Persönliche Daten
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '11px', color: '#666', mb: 1 }}>
                      Platzhalter: {fullName ? '{fullName}' : '{cvText}'}
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '10px', color: '#888', mb: 1 }}>
                      Spezifische Datasets: {fullName ? '{fullName}, {shortProfile}' : 'Keine spezifischen Daten'}
                    </Typography>
                    <Typography variant="body2">
                      Name: {fullName || 'Nicht verfügbar'}
                    </Typography>
                    <Typography variant="body2">
                      Profil: {shortProfile ? `${shortProfile.substring(0, 50)}...` : 'Nicht verfügbar'}
                    </Typography>
                  </Box>
                  
                  <Box sx={{ 
                    p: 2, 
                    border: '1px solid #e0e0e0', 
                    borderRadius: 1, 
                    backgroundColor: '#f8f8f8' 
                  }}>
                    <Typography variant="subtitle2" gutterBottom>
                      Arbeitserfahrung
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '11px', color: '#666', mb: 1 }}>
                      Platzhalter: {jobDescription ? '{jobDescription}, {cvText}' : '{jobDescription}, {cvText}'}
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '10px', color: '#888', mb: 1 }}>
                      Spezifische Datasets: {workExperiences && workExperiences.length > 0 ? '{workExperienceData}' : 'Keine spezifischen Daten'}
                    </Typography>
                    <Typography variant="body2">
                      Anzahl: {workExperiences ? workExperiences.length : 0} Einträge
                    </Typography>
                    {workExperiences && workExperiences.length > 0 && (
                      <Typography variant="body2">
                        Letzte: {workExperiences[0].position} bei {workExperiences[0].company}
                      </Typography>
                    )}
                  </Box>
                  
                  <Box sx={{ 
                    p: 2, 
                    border: '1px solid #e0e0e0', 
                    borderRadius: 1, 
                    backgroundColor: '#f8f8f8' 
                  }}>
                    <Typography variant="subtitle2" gutterBottom>
                      Ausbildung
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '11px', color: '#666', mb: 1 }}>
                      Platzhalter: {jobDescription ? '{jobDescription}, {cvText}' : '{jobDescription}, {cvText}'}
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '10px', color: '#888', mb: 1 }}>
                      Spezifische Datasets: {educations && educations.length > 0 ? '{educationData}' : 'Keine spezifischen Daten'}
                    </Typography>
                    <Typography variant="body2">
                      Anzahl: {educations ? educations.length : 0} Einträge
                    </Typography>
                    {educations && educations.length > 0 && (
                      <Typography variant="body2">
                        Letzte: {educations[0].degree} an {educations[0].institution}
                      </Typography>
                    )}
                  </Box>
                  
                  <Box sx={{ 
                    p: 2, 
                    border: '1px solid #e0e0e0', 
                    borderRadius: 1, 
                    backgroundColor: '#f8f8f8' 
                  }}>
                    <Typography variant="subtitle2" gutterBottom>
                      IT-Skills
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '11px', color: '#666', mb: 1 }}>
                      Platzhalter: {jobDescription ? '{jobDescription}, {cvText}' : '{jobDescription}, {cvText}'}
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '10px', color: '#888', mb: 1 }}>
                      Spezifische Datasets: {itSkills && itSkills.length > 0 ? '{itSkillData}' : 'Keine spezifischen Daten'}
                    </Typography>
                    <Typography variant="body2">
                      Anzahl: {itSkills ? itSkills.length : 0} Skills
                    </Typography>
                    {itSkills && itSkills.length > 0 && (
                      <Typography variant="body2">
                        Beispiele: {itSkills.slice(0, 3).map(s => s.skill).join(', ')}
                      </Typography>
                    )}
                  </Box>
                  
                  <Box sx={{ 
                    p: 2, 
                    border: '1px solid #e0e0e0', 
                    borderRadius: 1, 
                    backgroundColor: '#f8f8f8' 
                  }}>
                    <Typography variant="subtitle2" gutterBottom>
                      Sprachen
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '11px', color: '#666', mb: 1 }}>
                      Platzhalter: {jobDescription ? '{jobDescription}, {cvText}' : '{jobDescription}, {cvText}'}
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '10px', color: '#888', mb: 1 }}>
                      Spezifische Datasets: {languages && languages.length > 0 ? '{languageData}' : 'Keine spezifischen Daten'}
                    </Typography>
                    <Typography variant="body2">
                      Anzahl: {languages ? languages.length : 0} Sprachen
                    </Typography>
                    {languages && languages.length > 0 && (
                      <Typography variant="body2">
                        Beispiele: {languages.slice(0, 3).map(l => `${l.language} (${l.level})`).join(', ')}
                      </Typography>
                    )}
                  </Box>
                  
                  <Box sx={{ 
                    p: 2, 
                    border: '1px solid #e0e0e0', 
                    borderRadius: 1, 
                    backgroundColor: '#f8f8f8' 
                  }}>
                    <Typography variant="subtitle2" gutterBottom>
                      Hobbys
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '11px', color: '#666', mb: 1 }}>
                      Platzhalter: {jobDescription ? '{jobDescription}, {cvText}' : '{jobDescription}, {cvText}'}
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '10px', color: '#888', mb: 1 }}>
                      Spezifische Datasets: {hobbies && hobbies.length > 0 ? '{hobbyData}' : 'Keine spezifischen Daten'}
                    </Typography>
                    <Typography variant="body2">
                      Anzahl: {hobbies ? hobbies.length : 0} Hobbys
                    </Typography>
                    {hobbies && hobbies.length > 0 && (
                      <Typography variant="body2">
                        Beispiele: {hobbies.slice(0, 3).map(h => h.hobby).join(', ')}
                      </Typography>
                    )}
                  </Box>
                  
                  <Box sx={{ 
                    p: 2, 
                    border: '1px solid #e0e0e0', 
                    borderRadius: 1, 
                    backgroundColor: '#f8f8f8' 
                  }}>
                    <Typography variant="subtitle2" gutterBottom>
                      Kernkompetenzen
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '11px', color: '#666', mb: 1 }}>
                      Platzhalter: {jobDescription ? '{jobDescription}, {cvText}' : '{jobDescription}, {cvText}'}
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '10px', color: '#888', mb: 1 }}>
                      Spezifische Datasets: {coreCompetencies && coreCompetencies.length > 0 ? '{coreCompetencyData}' : 'Keine spezifischen Daten'}
                    </Typography>
                    <Typography variant="body2">
                      Anzahl: {coreCompetencies ? coreCompetencies.length : 0} Kompetenzen
                    </Typography>
                    {coreCompetencies && coreCompetencies.length > 0 && (
                      <Typography variant="body2">
                        Beispiele: {coreCompetencies.slice(0, 3).map(c => c.competency).join(', ')}
                      </Typography>
                    )}
                  </Box>
                  
                  <Box sx={{ 
                    p: 2, 
                    border: '1px solid #e0e0e0', 
                    borderRadius: 1, 
                    backgroundColor: '#f8f8f8' 
                  }}>
                    <Typography variant="subtitle2" gutterBottom>
                      Zusätzliche Info
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '11px', color: '#666', mb: 1 }}>
                      Platzhalter: {jobDescription ? '{jobDescription}, {cvText}' : '{jobDescription}, {cvText}'}
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '10px', color: '#888', mb: 1 }}>
                      Spezifische Datasets: {additionalInfo && additionalInfo.length > 0 ? '{additionalInfoData}' : 'Keine spezifischen Daten'}
                    </Typography>
                    <Typography variant="body2">
                      Anzahl: {additionalInfo ? additionalInfo.length : 0} Einträge
                    </Typography>
                    {additionalInfo && additionalInfo.length > 0 && (
                      <Typography variant="body2">
                        Beispiele: {additionalInfo.slice(0, 3).map(a => a.info).join(', ')}
                      </Typography>
                    )}
                  </Box>
                  
                  <Box sx={{ 
                    p: 2, 
                    border: '1px solid #e0e0e0', 
                    borderRadius: 1, 
                    backgroundColor: '#f8f8f8' 
                  }}>
                    <Typography variant="subtitle2" gutterBottom>
                      Branchenerfahrung
                    </Typography>
                    <Typography variant="body2">
                      Anzahl: {industryExperiences ? industryExperiences.length : 0} Branchen
                    </Typography>
                    {industryExperiences && industryExperiences.length > 0 && (
                      <Typography variant="body2">
                        Beispiele: {industryExperiences.slice(0, 3).map(i => i.industry).join(', ')}
                      </Typography>
                    )}
                  </Box>
                  
                  <Box sx={{ 
                    p: 2, 
                    border: '1px solid #e0e0e0', 
                    borderRadius: 1, 
                    backgroundColor: '#f8f8f8' 
                  }}>
                    <Typography variant="subtitle2" gutterBottom>
                      Stellenausschreibung
                    </Typography>
                    <Typography variant="body2">
                      Länge: {jobDescription ? jobDescription.length : 0} Zeichen
                    </Typography>
                    {jobDescription && (
                      <Typography variant="body2">
                        Anfang: {jobDescription.substring(0, 50)}...
                      </Typography>
                    )}
                  </Box>
                </Box>
              )}
          </Box>
        </DialogContent>
        
        <DialogActions sx={{ p: 3, justifyContent: 'flex-end' }}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleResetPromptInModal}
            startIcon={<RestoreIcon />}
          >
            Zurücksetzen
          </Button>

          <Button
            variant="contained"
            onClick={handleSavePromptInModal}
            startIcon={<SaveIcon />}
          >
            Speichern
          </Button>
          
          <Button
            variant="outlined"
            color="primary"
            onClick={() => handleTestSinglePrompt(
              editingPromptText,
              originalPromptName || 'Unbekannt',
              editingPromptVersion,
              editingPromptTemperature,
              editingPromptMaxTokens
            )}
            disabled={isTesting}
            startIcon={isTesting ? <CircularProgress size={16} /> : <AutoFixHighIcon />}
          >
            {isTesting ? 'Teste...' : 'Prompt testen'}
          </Button>
          
          <Button
            variant="outlined"
            onClick={handleClosePromptEditor}
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            Schließen
          </Button>
        </DialogActions>
      </Dialog>

      {/* Versions-Info Modal */}
      <Dialog
        open={showVersionInfo}
        onClose={() => setShowVersionInfo(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
          color: 'white',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ color: 'white', fontWeight: 600 }}>
              Versionsinformationen
            </Typography>
            <IconButton onClick={() => setShowVersionInfo(false)} sx={{ color: 'white' }}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box sx={{ 
              p: 2, 
              border: '1px solid #e2e8f0', 
              borderRadius: 2, 
              backgroundColor: '#f8fafc' 
            }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b', mb: 1 }}>
                Frontend Information
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography variant="body1" sx={{ color: '#475569', fontWeight: 500 }}>
                  Version: {frontendVersion}
                </Typography>
                <Typography variant="body2" sx={{ color: '#64748b' }}>
                  Deployment: {new Date(buildTime).toLocaleString('de-DE')}
                </Typography>
              </Box>
            </Box>
            
            <Box sx={{ 
              p: 2, 
              border: '1px solid #e2e8f0', 
              borderRadius: 2, 
              backgroundColor: '#f8fafc' 
            }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b', mb: 1 }}>
                Backend Version
              </Typography>
              {loadingVersionInfo ? (
                <CircularProgress size={16} />
              ) : backendVersionInfo ? (
                <Box>
                  <Typography variant="body1" sx={{ color: '#475569', mb: 1 }}>
                    Version: {backendVersionInfo.backend.version}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#64748b' }}>
                    Deployment: {new Date(backendVersionInfo.backend.deploymentTime).toLocaleString('de-DE')}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#64748b' }}>
                    Function: {backendVersionInfo.backend.functionVersion}
                  </Typography>
                </Box>
              ) : (
                <Typography variant="body2" sx={{ color: '#64748b' }}>
                  Versionsinfo nicht verfügbar
                </Typography>
              )}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <Button
            variant="outlined"
            onClick={() => setShowVersionInfo(false)}
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            Schließen
          </Button>
        </DialogActions>
      </Dialog>

      {/* Kernkompetenzen Modal */}
      <Dialog
        open={showCoreCompetenciesModal}
        onClose={() => {
          setShowCoreCompetenciesModal(false);
          // Modal schließen ändert keine CV-Daten, daher Checkbox-Status nicht ändern
          // Trigger Seitenberechnung im CV-Template
          window.dispatchEvent(new CustomEvent('modalClosed'));
        }}
        maxWidth="sm"
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '600px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
            <TextField
              value={currentCoreCompetenciesTitle}
              onChange={(e) => setCurrentCoreCompetenciesTitle(e.target.value)}
              variant="standard"
                        sx={{
                          flex: 1,
                          mr: 4,
                          '& .MuiInput-root': {
                            fontSize: '1.25rem',
                            fontWeight: 700,
                            color: 'white',
                            textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                            '&:before': { borderBottom: 'none' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
                            '&:after': { borderBottom: '2px solid white' }
                          }
                        }}
            />
            <IconButton 
              onClick={() => setShowCoreCompetenciesModal(false)}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 5, overflowX: 'hidden' }}>
          {/* Sichtbarkeits-Schalter */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showCoreCompetenciesInCv}
                  onChange={(e) => setShowCoreCompetenciesInCv(e.target.checked)}
                  sx={{
                    color: '#667eea',
                    '&.Mui-checked': {
                      color: '#667eea',
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                  {getTranslatedCvLabel('Kernkompetenzen im CV-Template anzeigen')}
                </Typography>
              }
            />
          </Box>
          
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="body2" sx={{ color: '#64748b' }}>
              {getTranslatedCvLabel('Hier sind alle optimierten Kernkompetenzen aus Ihren CV-Daten:')}
            </Typography>
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddIcon />}
              onClick={() => {
                setShowAvailableCoreCompetenciesModal(true);
              }}
              sx={{ 
                borderColor: '#3b82f6',
                color: '#3b82f6',
                '&:hover': { 
                  borderColor: '#2563eb',
                  backgroundColor: 'rgba(59, 130, 246, 0.04)'
                }
              }}
            >
              {getTranslatedCvLabel('Hinzufügen')}
            </Button>
          </Box>
          
          <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                    {getTranslatedCvLabel('Kernkompetenz')}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                    {getTranslatedCvLabel('Aktionen')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(relevantCoreCompetencies || []).map((comp: any, index: number) => (
                  <TableRow key={index} hover>
                    <TableCell>
                      <TextField
                        value={comp.competency || comp}
                        onChange={(e) => {
                          setRelevantCoreCompetencies(prev => 
                            prev.map((item, i) => 
                              i === index ? { ...item, competency: e.target.value } : item
                            )
                          );
                        }}
                        variant="standard"
                        fullWidth
                        multiline
                        sx={{ 
                          '& .MuiInput-root': { 
                            fontSize: '0.875rem',
                            '&:before': { borderBottom: '1px solid #e0e0e0' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                            '&:after': { borderBottom: '2px solid #1976d2' }
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setRelevantCoreCompetencies(prev => 
                            prev.filter((_, i) => i !== index)
                          );
                        }}
                        sx={{ 
                          color: '#94a3b8',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            color: '#ef4444',
                            bgcolor: '#fef2f2',
                            transform: 'scale(1.1)'
                          }
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                {(!relevantCoreCompetencies || relevantCoreCompetencies.length === 0) && (
                  <TableRow>
                    <TableCell colSpan={2} sx={{ textAlign: 'center', color: '#64748b', fontStyle: 'italic' }}>
                      {getTranslatedCvLabel('Keine Kernkompetenzen verfügbar')}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => setShowCoreCompetenciesModal(false)}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal für verfügbare Kernkompetenzen */}
      <Dialog
        open={showAvailableCoreCompetenciesModal}
        onClose={() => setShowAvailableCoreCompetenciesModal(false)}
        maxWidth="md"
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '700px',
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          py: 3,
          position: 'relative'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6" sx={{ fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              {getTranslatedCvLabel('Verfügbare Kernkompetenzen aus CV-Daten')}
            </Typography>
            <IconButton 
              onClick={() => setShowAvailableCoreCompetenciesModal(false)}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 3 }}>
          <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
            {getTranslatedCvLabel('Wählen Sie Kernkompetenzen aus, die Sie zum CV-Template hinzufügen möchten:')}
          </Typography>
          
          {getAvailableCoreCompetencies().length > 0 ? (
            <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                      {getTranslatedCvLabel('Kernkompetenz')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                      {getTranslatedCvLabel('Aktionen')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getAvailableCoreCompetencies().map((comp: any, index: number) => (
                    <TableRow key={index} hover>
                      <TableCell>{comp.competency || '-'}</TableCell>
                      <TableCell>
                        <IconButton
                          size="small"
                          onClick={() => {
                            // Füge die Kernkompetenz zu relevantCoreCompetencies hinzu
                            setRelevantCoreCompetencies(prev => [...prev, comp]);
                          }}
                          sx={{ 
                            color: '#10b981',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                              color: '#059669',
                              bgcolor: '#f0fdf4',
                              transform: 'scale(1.1)'
                            }
                          }}
                        >
                          <AddIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <Typography variant="body2" sx={{ color: '#64748b', fontStyle: 'italic' }}>
                {getTranslatedCvLabel('Alle Kernkompetenzen sind bereits im CV-Template enthalten')}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => setShowAvailableCoreCompetenciesModal(false)}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Zertifizierungen Modal */}
      <Dialog
        open={showCertificationsModal}
        onClose={() => {
          setShowCertificationsModal(false);
          // Modal schließen ändert keine CV-Daten, daher Checkbox-Status nicht ändern
          // Trigger Seitenberechnung im CV-Template
          window.dispatchEvent(new CustomEvent('modalClosed'));
        }}
        maxWidth="sm"
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '600px',
            overflowX: 'hidden'
          }
        }}
      >
                  <DialogTitle sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    borderBottom: 'none',
                    width: '100%',
                    maxWidth: '100%'
                  }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
                      <TextField
                        value={currentCertificationsTitle}
                        onChange={(e) => setCurrentCertificationsTitle(e.target.value)}
                        variant="standard"
                        sx={{
                          flex: 1,
                          mr: 4,
                          '& .MuiInput-root': {
                            fontSize: '1.25rem',
                            fontWeight: 700,
                            color: 'white',
                            textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                            '&:before': { borderBottom: 'none' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
                            '&:after': { borderBottom: '2px solid white' }
                          }
                        }}
            />
            <IconButton 
              onClick={() => setShowCertificationsModal(false)}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 5, overflowX: 'hidden' }}>
          {/* Sichtbarkeits-Schalter */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showCertificationsInCv}
                  onChange={(e) => setShowCertificationsInCv(e.target.checked)}
                  sx={{
                    color: '#667eea',
                    '&.Mui-checked': {
                      color: '#667eea',
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                  {getTranslatedCvLabel('Zertifizierungen im CV-Template anzeigen')}
                </Typography>
              }
            />
          </Box>
          
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="body2" sx={{ color: '#64748b' }}>
              {getTranslatedCvLabel('Hier sind alle optimierten Zertifizierungen aus Ihren CV-Daten:')}
            </Typography>
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddIcon />}
              onClick={() => {
                setShowAvailableCertificationsModal(true);
              }}
              sx={{ 
                borderColor: '#3b82f6',
                color: '#3b82f6',
                '&:hover': { 
                  borderColor: '#2563eb',
                  backgroundColor: 'rgba(59, 130, 246, 0.04)'
                }
              }}
            >
              {getTranslatedCvLabel('Hinzufügen')}
            </Button>
          </Box>
          
          <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                    {getTranslatedCvLabel('Zertifizierung')}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                    {getTranslatedCvLabel('Aktionen')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(relevantCertifications || []).map((cert: any, index: number) => (
                  <TableRow key={index} hover>
                    <TableCell>
                      <TextField
                        value={cert.name || cert}
                        onChange={(e) => {
                          setRelevantCertifications(prev => 
                            prev.map((item, i) => 
                              i === index ? { ...item, name: e.target.value } : item
                            )
                          );
                        }}
                        variant="standard"
                        fullWidth
                        multiline
                        sx={{ 
                          '& .MuiInput-root': { 
                            fontSize: '0.875rem',
                            '&:before': { borderBottom: '1px solid #e0e0e0' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                            '&:after': { borderBottom: '2px solid #1976d2' }
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setRelevantCertifications(prev => 
                            prev.filter((_, i) => i !== index)
                          );
                        }}
                        sx={{ 
                          color: '#94a3b8',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            color: '#ef4444',
                            bgcolor: '#fef2f2',
                            transform: 'scale(1.1)'
                          }
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                {(!relevantCertifications || relevantCertifications.length === 0) && (
                  <TableRow>
                    <TableCell colSpan={2} sx={{ textAlign: 'center', color: '#64748b', fontStyle: 'italic' }}>
                      {getTranslatedCvLabel('Keine Zertifizierungen verfügbar')}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => setShowCertificationsModal(false)}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal für verfügbare Zertifizierungen */}
      <Dialog
        open={showAvailableCertificationsModal}
        onClose={() => setShowAvailableCertificationsModal(false)}
        maxWidth="md"
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '700px',
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          py: 3,
          position: 'relative'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6" sx={{ fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              {getTranslatedCvLabel('Verfügbare Zertifizierungen aus CV-Daten')}
            </Typography>
            <IconButton 
              onClick={() => setShowAvailableCertificationsModal(false)}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 3 }}>
          <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
            {getTranslatedCvLabel('Wählen Sie Zertifizierungen aus, die Sie zum CV-Template hinzufügen möchten:')}
          </Typography>
          
          {getAvailableCertifications().length > 0 ? (
            <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                      {getTranslatedCvLabel('Zertifizierung')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '150px' }}>
                      {getTranslatedCvLabel('Aussteller')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '100px' }}>
                      {getTranslatedCvLabel('Datum')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                      {getTranslatedCvLabel('Aktionen')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getAvailableCertifications().map((cert: any, index: number) => (
                    <TableRow key={index} hover>
                      <TableCell>{cert.name || '-'}</TableCell>
                      <TableCell>{cert.issuer || '-'}</TableCell>
                      <TableCell>{cert.date || '-'}</TableCell>
                      <TableCell>
                        <IconButton
                          size="small"
                          onClick={() => {
                            // Füge die Zertifizierung zu relevantCertifications hinzu
                            setRelevantCertifications(prev => [...prev, cert]);
                          }}
                          sx={{ 
                            color: '#10b981',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                              color: '#059669',
                              bgcolor: '#f0fdf4',
                              transform: 'scale(1.1)'
                            }
                          }}
                        >
                          <AddIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <Typography variant="body2" sx={{ color: '#64748b', fontStyle: 'italic' }}>
                {getTranslatedCvLabel('Alle Zertifizierungen sind bereits im CV-Template enthalten')}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => setShowAvailableCertificationsModal(false)}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* IT-Skills Modal */}
      <Dialog
        open={showItSkillsModal}
        onClose={() => {
          setShowItSkillsModal(false);
          // Modal schließen ändert keine CV-Daten, daher Checkbox-Status nicht ändern
          // Trigger Seitenberechnung im CV-Template
          window.dispatchEvent(new CustomEvent('modalClosed'));
        }}
        maxWidth="sm"
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '600px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
            <TextField
              value={currentItSkillsTitle}
              onChange={(e) => setCurrentItSkillsTitle(e.target.value)}
              variant="standard"
                        sx={{
                          flex: 1,
                          mr: 4,
                          '& .MuiInput-root': {
                            fontSize: '1.25rem',
                            fontWeight: 700,
                            color: 'white',
                            textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                            '&:before': { borderBottom: 'none' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
                            '&:after': { borderBottom: '2px solid white' }
                          }
                        }}
            />
            <IconButton 
              onClick={() => setShowItSkillsModal(false)}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 5, overflowX: 'hidden' }}>
          {/* Sichtbarkeits-Schalter */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showItSkillsInCv}
                  onChange={(e) => setShowItSkillsInCv(e.target.checked)}
                  sx={{
                    color: '#667eea',
                    '&.Mui-checked': {
                      color: '#667eea',
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                  {getTranslatedCvLabel('IT-Skills im CV-Template anzeigen')}
                </Typography>
              }
            />
          </Box>
          
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="body2" sx={{ color: '#64748b' }}>
              {getTranslatedCvLabel('Hier sind alle optimierten IT-Skills aus Ihren CV-Daten:')}
            </Typography>
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddIcon />}
              onClick={() => {
                setShowAvailableItSkillsModal(true);
              }}
              sx={{ 
                borderColor: '#3b82f6',
                color: '#3b82f6',
                '&:hover': { 
                  borderColor: '#2563eb',
                  backgroundColor: 'rgba(59, 130, 246, 0.04)'
                }
              }}
            >
              {getTranslatedCvLabel('Hinzufügen')}
            </Button>
          </Box>
          
          <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                    {getTranslatedCvLabel('IT-Skill')}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                    {getTranslatedCvLabel('Aktionen')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(relevantItSkills || []).map((skill: any, index: number) => (
                  <TableRow key={index} hover>
                    <TableCell>
                      <TextField
                        value={skill.skill || skill}
                        onChange={(e) => {
                          setRelevantItSkills(prev => 
                            prev.map((item, i) => 
                              i === index ? { ...item, skill: e.target.value } : item
                            )
                          );
                        }}
                        variant="standard"
                        fullWidth
                        multiline
                        sx={{ 
                          '& .MuiInput-root': { 
                            fontSize: '0.875rem',
                            '&:before': { borderBottom: '1px solid #e0e0e0' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                            '&:after': { borderBottom: '2px solid #1976d2' }
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setRelevantItSkills(prev => 
                            prev.filter((_, i) => i !== index)
                          );
                        }}
                        sx={{ 
                          color: '#94a3b8',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            color: '#ef4444',
                            bgcolor: '#fef2f2',
                            transform: 'scale(1.1)'
                          }
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                {(!relevantItSkills || relevantItSkills.length === 0) && (
                  <TableRow>
                    <TableCell colSpan={2} sx={{ textAlign: 'center', color: '#64748b', fontStyle: 'italic' }}>
                      {getTranslatedCvLabel('Keine IT-Skills verfügbar')}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => setShowItSkillsModal(false)}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal für verfügbare IT-Skills */}
      <Dialog
        open={showAvailableItSkillsModal}
        onClose={() => setShowAvailableItSkillsModal(false)}
        maxWidth="md"
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '700px',
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          py: 3,
          position: 'relative'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6" sx={{ fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              {getTranslatedCvLabel('Verfügbare IT-Skills aus CV-Daten')}
            </Typography>
            <IconButton 
              onClick={() => setShowAvailableItSkillsModal(false)}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 3 }}>
          <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
            {getTranslatedCvLabel('Wählen Sie IT-Skills aus, die Sie zum CV-Template hinzufügen möchten:')}
          </Typography>
          
          {getAvailableItSkills().length > 0 ? (
            <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                      {getTranslatedCvLabel('Skill')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '150px' }}>
                      {getTranslatedCvLabel('Level')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                      {getTranslatedCvLabel('Aktionen')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getAvailableItSkills().map((skill: any, index: number) => (
                    <TableRow key={index} hover>
                      <TableCell>{skill.skill || '-'}</TableCell>
                      <TableCell>{skill.level || '-'}</TableCell>
                      <TableCell>
                        <IconButton
                          size="small"
                          onClick={() => {
                            // Füge den IT-Skill zu relevantItSkills hinzu
                            setRelevantItSkills(prev => [...prev, skill]);
                          }}
                          sx={{ 
                            color: '#10b981',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                              color: '#059669',
                              bgcolor: '#f0fdf4',
                              transform: 'scale(1.1)'
                            }
                          }}
                        >
                          <AddIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <Typography variant="body2" sx={{ color: '#64748b', fontStyle: 'italic' }}>
                {getTranslatedCvLabel('Alle IT-Skills sind bereits im CV-Template enthalten')}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => setShowAvailableItSkillsModal(false)}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Branchen Modal */}
      <Dialog
        open={showIndustriesModal}
        onClose={() => {
          setShowIndustriesModal(false);
          // Modal schließen ändert keine CV-Daten, daher Checkbox-Status nicht ändern
          // Trigger Seitenberechnung im CV-Template
          window.dispatchEvent(new CustomEvent('modalClosed'));
        }}
        maxWidth="sm"
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '600px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
            <TextField
              value={currentIndustriesTitle}
              onChange={(e) => setCurrentIndustriesTitle(e.target.value)}
              variant="standard"
                        sx={{
                          flex: 1,
                          mr: 4,
                          '& .MuiInput-root': {
                            fontSize: '1.25rem',
                            fontWeight: 700,
                            color: 'white',
                            textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                            '&:before': { borderBottom: 'none' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
                            '&:after': { borderBottom: '2px solid white' }
                          }
                        }}
            />
            <IconButton 
              onClick={() => setShowIndustriesModal(false)}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 5, overflowX: 'hidden' }}>
          {/* Sichtbarkeits-Schalter */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showIndustriesInCv}
                  onChange={(e) => setShowIndustriesInCv(e.target.checked)}
                  sx={{
                    color: '#667eea',
                    '&.Mui-checked': {
                      color: '#667eea',
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                  {getTranslatedCvLabel('Branchen im CV-Template anzeigen')}
                </Typography>
              }
            />
          </Box>
          
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="body2" sx={{ color: '#64748b' }}>
              {getTranslatedCvLabel('Hier sind alle optimierten Branchen aus Ihren CV-Daten:')}
            </Typography>
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddIcon />}
              onClick={() => {
                setShowAvailableIndustriesModal(true);
              }}
              sx={{ 
                borderColor: '#3b82f6',
                color: '#3b82f6',
                '&:hover': { 
                  borderColor: '#2563eb',
                  backgroundColor: 'rgba(59, 130, 246, 0.04)'
                }
              }}
            >
              {getTranslatedCvLabel('Hinzufügen')}
            </Button>
          </Box>
          
          <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                    {getTranslatedCvLabel('Branche')}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '120px' }}>
                    {translatedYears}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                    {getTranslatedCvLabel('Aktionen')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(relevantIndustries || []).map((industry: any, index: number) => (
                  <TableRow key={index} hover>
                    <TableCell>
                      <TextField
                        value={industry.industry || industry}
                        onChange={(e) => {
                          setRelevantIndustries(prev => 
                            prev.map((item, i) => 
                              i === index ? { ...item, industry: e.target.value } : item
                            )
                          );
                        }}
                        variant="standard"
                        fullWidth
                        sx={{ 
                          '& .MuiInput-root': { 
                            fontSize: '0.875rem',
                            '&:before': { borderBottom: '1px solid #e0e0e0' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                            '&:after': { borderBottom: '2px solid #1976d2' }
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        value={industry.years || ''}
                        onChange={(e) => {
                          setRelevantIndustries(prev => 
                            prev.map((item, i) => 
                              i === index ? { ...item, years: e.target.value } : item
                            )
                          );
                        }}
                        variant="standard"
                        fullWidth
                        placeholder={translatedYears}
                        sx={{ 
                          '& .MuiInput-root': { 
                            fontSize: '0.875rem',
                            '&:before': { borderBottom: '1px solid #e0e0e0' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                            '&:after': { borderBottom: '2px solid #1976d2' }
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setRelevantIndustries(prev => 
                            prev.filter((_, i) => i !== index)
                          );
                        }}
                        sx={{ 
                          color: '#94a3b8',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            color: '#ef4444',
                            bgcolor: '#fef2f2',
                            transform: 'scale(1.1)'
                          }
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                {(!relevantIndustries || relevantIndustries.length === 0) && (
                  <TableRow>
                    <TableCell colSpan={3} sx={{ textAlign: 'center', color: '#64748b', fontStyle: 'italic' }}>
                      {getTranslatedCvLabel('Keine Branchen verfügbar')}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => setShowIndustriesModal(false)}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal für verfügbare Branchen */}
      <Dialog
        open={showAvailableIndustriesModal}
        onClose={() => setShowAvailableIndustriesModal(false)}
        maxWidth="md"
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '800px',
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          py: 3,
          position: 'relative'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6" sx={{ fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              {getTranslatedCvLabel('Verfügbare Branchen aus CV-Daten')}
            </Typography>
            <IconButton 
              onClick={() => setShowAvailableIndustriesModal(false)}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 3 }}>
          <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
            {getTranslatedCvLabel('Wählen Sie Branchen aus, die Sie zum CV-Template hinzufügen möchten:')}
          </Typography>
          
          {getAvailableIndustries().length > 0 ? (
            <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                      {getTranslatedCvLabel('Branche')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '100px' }}>
                      {getTranslatedCvLabel('Jahre')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                      {getTranslatedCvLabel('Aktionen')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getAvailableIndustries().map((industry: any, index: number) => (
                    <TableRow key={index} hover>
                      <TableCell>{industry.industry || '-'}</TableCell>
                      <TableCell>{industry.years || '-'}</TableCell>
                      <TableCell>
                        <IconButton
                          size="small"
                          onClick={() => {
                            // Füge die Branche zu relevantIndustries hinzu
                            setRelevantIndustries(prev => [...prev, industry]);
                          }}
                          sx={{ 
                            color: '#10b981',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                              color: '#059669',
                              bgcolor: '#f0fdf4',
                              transform: 'scale(1.1)'
                            }
                          }}
                        >
                          <AddIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <Typography variant="body2" sx={{ color: '#64748b', fontStyle: 'italic' }}>
                {getTranslatedCvLabel('Alle Branchen sind bereits im CV-Template enthalten')}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => setShowAvailableIndustriesModal(false)}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Sprachen Modal */}
      <Dialog
        open={showLanguagesModal}
        onClose={() => {
          setShowLanguagesModal(false);
          // Modal schließen ändert keine CV-Daten, daher Checkbox-Status nicht ändern
          // Trigger Seitenberechnung im CV-Template
          window.dispatchEvent(new CustomEvent('modalClosed'));
        }}
        maxWidth="sm"
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '600px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
            <TextField
              value={currentLanguagesTitle}
              onChange={(e) => setCurrentLanguagesTitle(e.target.value)}
              variant="standard"
                        sx={{
                          flex: 1,
                          mr: 4,
                          '& .MuiInput-root': {
                            fontSize: '1.25rem',
                            fontWeight: 700,
                            color: 'white',
                            textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                            '&:before': { borderBottom: 'none' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
                            '&:after': { borderBottom: '2px solid white' }
                          }
                        }}
            />
            <IconButton 
              onClick={() => setShowLanguagesModal(false)}
              size="small"
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 5, overflowX: 'hidden' }}>
          {/* Sichtbarkeits-Schalter */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showLanguagesInCv}
                  onChange={(e) => setShowLanguagesInCv(e.target.checked)}
                  sx={{
                    color: '#667eea',
                    '&.Mui-checked': {
                      color: '#667eea',
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                  {getTranslatedCvLabel('Sprachen im CV-Template anzeigen')}
                </Typography>
              }
            />
          </Box>
          
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="body2" sx={{ color: '#64748b' }}>
              {getTranslatedCvLabel('Hier sind alle optimierten Sprachen aus Ihren CV-Daten:')}
            </Typography>
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddIcon />}
              onClick={() => {
                setShowAvailableLanguagesModal(true);
              }}
              sx={{ 
                borderColor: '#3b82f6',
                color: '#3b82f6',
                '&:hover': { 
                  borderColor: '#2563eb',
                  backgroundColor: 'rgba(59, 130, 246, 0.04)'
                }
              }}
            >
              {getTranslatedCvLabel('Hinzufügen')}
            </Button>
          </Box>
          
          <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                    {getTranslatedCvLabel('Sprache')}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '120px' }}>
                    {getTranslatedCvLabel('Niveau')}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                    {getTranslatedCvLabel('Aktionen')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(relevantLanguages || []).map((language: any, index: number) => (
                  <TableRow key={index} hover>
                    <TableCell>
                      <TextField
                        value={language.language || language}
                        onChange={(e) => {
                          setRelevantLanguages(prev => 
                            prev.map((item, i) => 
                              i === index ? { ...item, language: e.target.value } : item
                            )
                          );
                        }}
                        variant="standard"
                        fullWidth
                        sx={{ 
                          '& .MuiInput-root': { 
                            fontSize: '0.875rem',
                            '&:before': { borderBottom: '1px solid #e0e0e0' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                            '&:after': { borderBottom: '2px solid #1976d2' }
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        value={language.level || ''}
                        onChange={(e) => {
                          setRelevantLanguages(prev => 
                            prev.map((item, i) => 
                              i === index ? { ...item, level: e.target.value } : item
                            )
                          );
                        }}
                        variant="standard"
                        fullWidth
                        placeholder="Niveau"
                        sx={{ 
                          '& .MuiInput-root': { 
                            fontSize: '0.875rem',
                            '&:before': { borderBottom: '1px solid #e0e0e0' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                            '&:after': { borderBottom: '2px solid #1976d2' }
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setRelevantLanguages(prev => 
                            prev.filter((_, i) => i !== index)
                          );
                        }}
                        sx={{ 
                          color: '#94a3b8',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            color: '#ef4444',
                            bgcolor: '#fef2f2',
                            transform: 'scale(1.1)'
                          }
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                {(!relevantLanguages || relevantLanguages.length === 0) && (
                  <TableRow>
                    <TableCell colSpan={3} sx={{ textAlign: 'center', color: '#64748b', fontStyle: 'italic' }}>
                      {getTranslatedCvLabel('Keine Sprachen verfügbar')}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => setShowLanguagesModal(false)}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal für verfügbare Sprachen */}
      <Dialog
        open={showAvailableLanguagesModal}
        onClose={() => setShowAvailableLanguagesModal(false)}
        maxWidth="md"
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '700px',
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          py: 3,
          position: 'relative'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6" sx={{ fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              {getTranslatedCvLabel('Verfügbare Sprachen aus CV-Daten')}
            </Typography>
            <IconButton 
              onClick={() => setShowAvailableLanguagesModal(false)}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 3 }}>
          <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
            {getTranslatedCvLabel('Wählen Sie Sprachen aus, die Sie zum CV-Template hinzufügen möchten:')}
          </Typography>
          
          {getAvailableLanguages().length > 0 ? (
            <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                      {getTranslatedCvLabel('Sprache')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '150px' }}>
                      {getTranslatedCvLabel('Level')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                      {getTranslatedCvLabel('Aktionen')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getAvailableLanguages().map((lang: any, index: number) => (
                    <TableRow key={index} hover>
                      <TableCell>{lang.language || '-'}</TableCell>
                      <TableCell>{lang.level || '-'}</TableCell>
                      <TableCell>
                        <IconButton
                          size="small"
                          onClick={() => {
                            // Füge die Sprache zu relevantLanguages hinzu
                            setRelevantLanguages(prev => [...prev, lang]);
                          }}
                          sx={{ 
                            color: '#10b981',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                              color: '#059669',
                              bgcolor: '#f0fdf4',
                              transform: 'scale(1.1)'
                            }
                          }}
                        >
                          <AddIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <Typography variant="body2" sx={{ color: '#64748b', fontStyle: 'italic' }}>
                {getTranslatedCvLabel('Alle Sprachen sind bereits im CV-Template enthalten')}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => setShowAvailableLanguagesModal(false)}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Hobbies Modal */}
      <Dialog
        open={showHobbiesModal}
        onClose={() => {
          setShowHobbiesModal(false);
          // Modal schließen ändert keine CV-Daten, daher Checkbox-Status nicht ändern
          // Trigger Seitenberechnung im CV-Template
          window.dispatchEvent(new CustomEvent('modalClosed'));
        }}
        maxWidth="sm"
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '600px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
            <TextField
              value={currentHobbiesTitle}
              onChange={(e) => setCurrentHobbiesTitle(e.target.value)}
              variant="standard"
                        sx={{
                          flex: 1,
                          mr: 4,
                          '& .MuiInput-root': {
                            fontSize: '1.25rem',
                            fontWeight: 700,
                            color: 'white',
                            textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                            '&:before': { borderBottom: 'none' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
                            '&:after': { borderBottom: '2px solid white' }
                          }
                        }}
            />
            <IconButton 
              onClick={() => setShowHobbiesModal(false)}
              size="small"
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 5, overflowX: 'hidden' }}>
          {/* Sichtbarkeits-Schalter */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showHobbiesInCv}
                  onChange={(e) => setShowHobbiesInCv(e.target.checked)}
                  sx={{
                    color: '#667eea',
                    '&.Mui-checked': {
                      color: '#667eea',
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                  {getTranslatedCvLabel('Hobbies im CV-Template anzeigen')}
                </Typography>
              }
            />
          </Box>
          
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="body2" sx={{ color: '#64748b' }}>
              {getTranslatedCvLabel('Hier sind alle optimierten Hobbies aus Ihren CV-Daten:')}
            </Typography>
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddIcon />}
              onClick={() => {
                setShowAvailableHobbiesModal(true);
              }}
              sx={{ 
                borderColor: '#3b82f6',
                color: '#3b82f6',
                '&:hover': { 
                  borderColor: '#2563eb',
                  backgroundColor: 'rgba(59, 130, 246, 0.04)'
                }
              }}
            >
              {getTranslatedCvLabel('Hinzufügen')}
            </Button>
          </Box>
          
          <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                    {getTranslatedCvLabel('Hobby')}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                    {getTranslatedCvLabel('Aktionen')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(Array.isArray(relevantHobbies) ? relevantHobbies : []).map((hobby: any, index: number) => (
                  <TableRow key={index} hover>
                    <TableCell>
                      <TextField
                        value={hobby.hobby || hobby}
                        onChange={(e) => {
                          setRelevantHobbies(prev => 
                            prev.map((item, i) => 
                              i === index ? { ...item, hobby: e.target.value } : item
                            )
                          );
                        }}
                        variant="standard"
                        fullWidth
                        multiline
                        sx={{ 
                          '& .MuiInput-root': { 
                            fontSize: '0.875rem',
                            '&:before': { borderBottom: '1px solid #e0e0e0' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                            '&:after': { borderBottom: '2px solid #1976d2' }
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setRelevantHobbies(prev => 
                            prev.filter((_, i) => i !== index)
                          );
                        }}
                        sx={{ 
                          color: '#94a3b8',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            color: '#ef4444',
                            bgcolor: '#fef2f2',
                            transform: 'scale(1.1)'
                          }
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                {(!relevantHobbies || relevantHobbies.length === 0) && (
                  <TableRow>
                    <TableCell colSpan={2} sx={{ textAlign: 'center', color: '#64748b', fontStyle: 'italic' }}>
                      {getTranslatedCvLabel('Keine Hobbies verfügbar')}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => setShowHobbiesModal(false)}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal für verfügbare Hobbys */}
      <Dialog
        open={showAvailableHobbiesModal}
        onClose={() => setShowAvailableHobbiesModal(false)}
        maxWidth="md"
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '700px',
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          py: 3,
          position: 'relative'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6" sx={{ fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              {getTranslatedCvLabel('Verfügbare Hobbys aus CV-Daten')}
            </Typography>
            <IconButton 
              onClick={() => setShowAvailableHobbiesModal(false)}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 3 }}>
          <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
            {getTranslatedCvLabel('Wählen Sie Hobbys aus, die Sie zum CV-Template hinzufügen möchten:')}
          </Typography>
          
          {getAvailableHobbies().length > 0 ? (
            <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                      {getTranslatedCvLabel('Hobby')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '250px' }}>
                      {getTranslatedCvLabel('Beschreibung')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                      {getTranslatedCvLabel('Aktionen')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getAvailableHobbies().map((hobby: any, index: number) => (
                    <TableRow key={index} hover>
                      <TableCell sx={{ fontWeight: 600 }}>{hobby.hobby || '-'}</TableCell>
                      <TableCell>{hobby.description || '-'}</TableCell>
                      <TableCell>
                        <IconButton
                          size="small"
                          onClick={() => {
                            // Füge das Hobby zu relevantHobbies hinzu
                            setRelevantHobbies(prev => [...prev, hobby]);
                          }}
                          sx={{ 
                            color: '#10b981',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                              color: '#059669',
                              bgcolor: '#f0fdf4',
                              transform: 'scale(1.1)'
                            }
                          }}
                        >
                          <AddIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <Typography variant="body2" sx={{ color: '#64748b', fontStyle: 'italic' }}>
                {getTranslatedCvLabel('Alle Hobbys sind bereits im CV-Template enthalten')}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => setShowAvailableHobbiesModal(false)}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Weitere Angaben Modal */}
      <Dialog
        open={showAdditionalInfoModal}
        onClose={() => {
          setShowAdditionalInfoModal(false);
          // Modal schließen ändert keine CV-Daten, daher Checkbox-Status nicht ändern
          // Trigger Seitenberechnung im CV-Template
          window.dispatchEvent(new CustomEvent('modalClosed'));
        }}
        maxWidth="sm"
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '600px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
            <TextField
              value={currentAdditionalInfoTitle}
              onChange={(e) => setCurrentAdditionalInfoTitle(e.target.value)}
              variant="standard"
                        sx={{
                          flex: 1,
                          mr: 4,
                          '& .MuiInput-root': {
                            fontSize: '1.25rem',
                            fontWeight: 700,
                            color: 'white',
                            textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                            '&:before': { borderBottom: 'none' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
                            '&:after': { borderBottom: '2px solid white' }
                          }
                        }}
            />
            <IconButton 
              onClick={() => setShowAdditionalInfoModal(false)}
              size="small"
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 5, overflowX: 'hidden' }}>
          {/* Sichtbarkeits-Schalter */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showAdditionalInfoInCv}
                  onChange={(e) => setShowAdditionalInfoInCv(e.target.checked)}
                  sx={{
                    color: '#667eea',
                    '&.Mui-checked': {
                      color: '#667eea',
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                  {getTranslatedCvLabel('Weitere Angaben im CV-Template anzeigen')}
                </Typography>
              }
            />
          </Box>
          
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="body2" sx={{ color: '#64748b' }}>
              {getTranslatedCvLabel('Hier sind alle optimierten Weitere Angaben aus Ihren CV-Daten:')}
            </Typography>
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddIcon />}
              onClick={() => {
                setShowAvailableAdditionalInfoModal(true);
              }}
              sx={{ 
                borderColor: '#3b82f6',
                color: '#3b82f6',
                '&:hover': { 
                  borderColor: '#2563eb',
                  backgroundColor: 'rgba(59, 130, 246, 0.04)'
                }
              }}
            >
              {getTranslatedCvLabel('Hinzufügen')}
            </Button>
          </Box>
          
          <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                    {getTranslatedCvLabel('Info')}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                    {getTranslatedCvLabel('Details')}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                    {getTranslatedCvLabel('Aktionen')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(Array.isArray(relevantAdditionalInfo) ? relevantAdditionalInfo : []).map((item: any, index: number) => (
                  <TableRow key={index} hover>
                    <TableCell>
                      <TextField
                        value={item.info || ''}
                        onChange={(e) => {
                          setRelevantAdditionalInfo(prev => 
                            prev.map((infoItem, i) => 
                              i === index ? { ...infoItem, info: e.target.value } : infoItem
                            )
                          );
                        }}
                        variant="standard"
                        fullWidth
                        multiline
                        sx={{ 
                          '& .MuiInput-root': { 
                            fontSize: '0.875rem',
                            '&:before': { borderBottom: '1px solid #e0e0e0' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                            '&:after': { borderBottom: '2px solid #1976d2' }
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        value={item.details || ''}
                        onChange={(e) => {
                          setRelevantAdditionalInfo(prev => 
                            prev.map((infoItem, i) => 
                              i === index ? { ...infoItem, details: e.target.value } : infoItem
                            )
                          );
                        }}
                        variant="standard"
                        fullWidth
                        multiline
                        sx={{ 
                          '& .MuiInput-root': { 
                            fontSize: '0.875rem',
                            '&:before': { borderBottom: '1px solid #e0e0e0' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                            '&:after': { borderBottom: '2px solid #1976d2' }
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setRelevantAdditionalInfo(prev => 
                            prev.filter((_, i) => i !== index)
                          );
                        }}
                        sx={{ 
                          color: '#94a3b8',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            color: '#ef4444',
                            bgcolor: '#fef2f2',
                            transform: 'scale(1.1)'
                          }
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                {(!relevantAdditionalInfo || relevantAdditionalInfo.length === 0) && (
                  <TableRow>
                    <TableCell colSpan={3} sx={{ textAlign: 'center', color: '#64748b', fontStyle: 'italic' }}>
                      {getTranslatedCvLabel('Keine Weitere Angaben verfügbar')}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => setShowAdditionalInfoModal(false)}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal für verfügbare Weitere Angaben */}
      <Dialog
        open={showAvailableAdditionalInfoModal}
        onClose={() => setShowAvailableAdditionalInfoModal(false)}
        maxWidth="md"
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '700px',
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          py: 3,
          position: 'relative'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6" sx={{ fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              {getTranslatedCvLabel('Verfügbare Weitere Angaben aus CV-Daten')}
            </Typography>
            <IconButton 
              onClick={() => setShowAvailableAdditionalInfoModal(false)}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 3 }}>
          <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
            {getTranslatedCvLabel('Wählen Sie Weitere Angaben aus, die Sie zum CV-Template hinzufügen möchten:')}
          </Typography>
          
          {getAvailableAdditionalInfo().length > 0 ? (
            <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc' }}>
                      {getTranslatedCvLabel('Info')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '250px' }}>
                      {getTranslatedCvLabel('Details')}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, backgroundColor: '#f8fafc', width: '80px' }}>
                      {getTranslatedCvLabel('Aktionen')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getAvailableAdditionalInfo().map((info: any, index: number) => (
                    <TableRow key={index} hover>
                      <TableCell>{info.info || '-'}</TableCell>
                      <TableCell>{info.details || '-'}</TableCell>
                      <TableCell>
                        <IconButton
                          size="small"
                          onClick={() => {
                            // Füge die Weitere Angabe zu relevantAdditionalInfo hinzu
                            setRelevantAdditionalInfo(prev => [...prev, info]);
                          }}
                          sx={{ 
                            color: '#10b981',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                              color: '#059669',
                              bgcolor: '#f0fdf4',
                              transform: 'scale(1.1)'
                            }
                          }}
                        >
                          <AddIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <Typography variant="body2" sx={{ color: '#64748b', fontStyle: 'italic' }}>
                {getTranslatedCvLabel('Alle Weiteren Angaben sind bereits im CV-Template enthalten')}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => setShowAvailableAdditionalInfoModal(false)}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Ausbildung Modal */}
      <Dialog
        open={showEducationModal}
        onClose={() => {
          setShowEducationModal(false);
          // Modal schließen ändert keine CV-Daten, daher Checkbox-Status nicht ändern
          // Trigger Seitenberechnung im CV-Template
          window.dispatchEvent(new CustomEvent('modalClosed'));
        }}
        maxWidth="sm"
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '600px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
            <TextField
              value={currentEducationTitle}
              onChange={(e) => setCurrentEducationTitle(e.target.value)}
              variant="standard"
                        sx={{
                          flex: 1,
                          mr: 4,
                          '& .MuiInput-root': {
                            fontSize: '1.25rem',
                            fontWeight: 700,
                            color: 'white',
                            textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                            '&:before': { borderBottom: 'none' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
                            '&:after': { borderBottom: '2px solid white' }
                          }
                        }}
            />
            <IconButton 
              onClick={() => setShowEducationModal(false)}
              size="small"
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 5, overflowX: 'hidden' }}>
          {/* Sichtbarkeits-Schalter */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showEducationInCv}
                  onChange={(e) => setShowEducationInCv(e.target.checked)}
                  sx={{
                    color: '#667eea',
                    '&.Mui-checked': {
                      color: '#667eea',
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                  {getTranslatedCvLabel('Ausbildungen im CV-Template anzeigen')}
                </Typography>
              }
            />
          </Box>
          
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="body2" sx={{ color: '#64748b' }}>
              {getTranslatedCvLabel('Hier sind alle optimierten Ausbildungen aus Ihren CV-Daten:')}
            </Typography>
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddIcon />}
              onClick={() => {
                setRelevantEducations(prev => [{ degree: '', institution: '', startDate: '', endDate: '' }, ...prev]);
              }}
              sx={{ 
                borderColor: '#3b82f6',
                color: '#3b82f6',
                '&:hover': { 
                  borderColor: '#2563eb',
                  backgroundColor: 'rgba(59, 130, 246, 0.04)'
                }
              }}
            >
              {getTranslatedCvLabel('Hinzufügen')}
            </Button>
          </Box>
          
          <Box sx={{ maxHeight: 400, overflowY: 'auto' }}>
            {(relevantEducations || []).map((edu: any, index: number) => (
              <Box key={index} sx={{ 
                p: 2, 
                border: '1px solid #e2e8f0', 
                borderRadius: 2, 
                backgroundColor: '#fafbfc',
                mb: 2,
                '&:hover': {
                  borderColor: '#3b82f6',
                  boxShadow: '0 2px 8px rgba(59, 130, 246, 0.1)'
                }
              }}>
                {/* Abschluss auf einer Zeile */}
                <Box sx={{ mb: 2 }}>
                  <TextField
                    label={getTranslatedCvLabel('Abschluss')}
                    value={edu.degree || ''}
                    onChange={(e) => {
                      setRelevantEducations(prev => 
                        prev.map((item, i) => 
                          i === index ? { ...item, degree: e.target.value } : item
                        )
                      );
                    }}
                    variant="outlined"
                    fullWidth
                    size="small"
                    sx={{ 
                      '& .MuiInputLabel-root': { 
                        fontSize: '0.875rem',
                        color: '#64748b'
                      },
                      '& .MuiOutlinedInput-root': { 
                        fontSize: '0.875rem',
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#3b82f6'
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#3b82f6'
                        }
                      }
                    }}
                  />
                </Box>
                
                {/* Institution auf einer Zeile */}
                <Box sx={{ mb: 2 }}>
                  <TextField
                    label={getTranslatedCvLabel('Institution')}
                    value={edu.institution || ''}
                    onChange={(e) => {
                      setRelevantEducations(prev => 
                        prev.map((item, i) => 
                          i === index ? { ...item, institution: e.target.value } : item
                        )
                      );
                    }}
                    variant="outlined"
                    fullWidth
                    size="small"
                    sx={{ 
                      '& .MuiInputLabel-root': { 
                        fontSize: '0.875rem',
                        color: '#64748b'
                      },
                      '& .MuiOutlinedInput-root': { 
                        fontSize: '0.875rem',
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#3b82f6'
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#3b82f6'
                        }
                      }
                    }}
                  />
                </Box>
                
                {/* Von und Bis auf der gleichen Zeile */}
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start', justifyContent: 'space-between' }}>
                  <TextField
                    label={getTranslatedCvLabel('Von')}
                    value={edu.startDate || ''}
                    onChange={(e) => {
                      setRelevantEducations(prev => 
                        prev.map((item, i) => 
                          i === index ? { ...item, startDate: e.target.value } : item
                        )
                      );
                    }}
                    variant="outlined"
                    placeholder="YYYY"
                    size="small"
                    sx={{ 
                      flex: 1,
                      '& .MuiInputLabel-root': { 
                        fontSize: '0.875rem',
                        color: '#64748b'
                      },
                      '& .MuiOutlinedInput-root': { 
                        fontSize: '0.875rem',
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#3b82f6'
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#3b82f6'
                        }
                      }
                    }}
                  />
                  <TextField
                    label={getTranslatedCvLabel('Bis')}
                    value={edu.endDate || ''}
                    onChange={(e) => {
                      setRelevantEducations(prev => 
                        prev.map((item, i) => 
                          i === index ? { ...item, endDate: e.target.value } : item
                        )
                      );
                    }}
                    variant="outlined"
                    placeholder="YYYY"
                    size="small"
                    sx={{ 
                      flex: 1,
                      '& .MuiInputLabel-root': { 
                        fontSize: '0.875rem',
                        color: '#64748b'
                      },
                      '& .MuiOutlinedInput-root': { 
                        fontSize: '0.875rem',
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#3b82f6'
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#3b82f6'
                        }
                      }
                    }}
                  />
                  <IconButton
                    onClick={() => {
                      setRelevantEducations(prev => prev.filter((_, i) => i !== index));
                    }}
                    size="small"
                    sx={{ 
                      color: '#94a3b8',
                      transition: 'all 0.2s ease',
                      ml: 1,
                      alignSelf: 'center',
                      '&:hover': {
                        color: '#ef4444',
                        bgcolor: '#fef2f2',
                        transform: 'scale(1.1)'
                      }
                    }}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Box>
              </Box>
            ))}
            {(!relevantEducations || relevantEducations.length === 0) && (
              <Box sx={{ 
                p: 3, 
                textAlign: 'center', 
                color: '#64748b', 
                fontStyle: 'italic',
                border: '1px dashed #e2e8f0',
                borderRadius: 2
              }}>
                {getTranslatedCvLabel('Keine Ausbildungen verfügbar')}
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => setShowEducationModal(false)}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Berufserfahrungen Modal */}
      <Dialog
        open={showWorkExperienceModal}
        onClose={() => {
          setShowWorkExperienceModal(false);
          // Modal schließen ändert keine CV-Daten, daher Checkbox-Status nicht ändern
          // Trigger Seitenberechnung im CV-Template
          window.dispatchEvent(new CustomEvent('modalClosed'));
        }}
        maxWidth="sm"
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '600px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
            <TextField
              value={currentWorkExperienceTitle}
              onChange={(e) => setCurrentWorkExperienceTitle(e.target.value)}
              variant="standard"
              fullWidth
                        sx={{
                          flex: 1,
                          mr: 4,
                          '& .MuiInput-root': {
                            fontSize: '1.25rem',
                            fontWeight: 700,
                            color: 'white',
                            textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                            '&:before': { borderBottom: 'none' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
                            '&:after': { borderBottom: '2px solid white' }
                          }
                        }}
            />
            <IconButton 
              onClick={() => {
                setShowWorkExperienceModal(false);
                // Trigger Seitenberechnung im CV-Template
                window.dispatchEvent(new CustomEvent('modalClosed'));
              }}
              size="small"
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 5, overflowX: 'hidden' }}>
          {/* Sichtbarkeits-Schalter */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isNonRelevantWorkExperience ? showAdditionalWorkExperienceInCv : showWorkExperienceInCv}
                  onChange={(e) => {
                    if (isNonRelevantWorkExperience) {
                      setShowAdditionalWorkExperienceInCv(e.target.checked);
                    } else {
                      setShowWorkExperienceInCv(e.target.checked);
                    }
                  }}
                  sx={{
                    color: '#667eea',
                    '&.Mui-checked': {
                      color: '#667eea',
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                  {isNonRelevantWorkExperience 
                    ? getTranslatedCvLabel('Weitere Berufserfahrungen im CV-Template anzeigen')
                    : getTranslatedCvLabel('Berufserfahrungen im CV-Template anzeigen')
                  }
                </Typography>
              }
            />
          </Box>
          
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="body2" sx={{ color: '#64748b' }}>
              {selectedWorkExperience ? getTranslatedCvLabel('Bearbeiten Sie diese Berufserfahrung:') : getTranslatedCvLabel('Hier sind alle optimierten Berufserfahrungen aus Ihren CV-Daten:')}
            </Typography>
            {!selectedWorkExperience && (
              <Button
                variant="outlined"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => {
                  syncWorkExperiences([...relevantWorkExperiences, { 
                    position: '', 
                    company: '', 
                    startDate: '', 
                    endDate: '', 
                    description: '',
                    responsibilities: [],
                    relevant: true
                  }]);
                }}
                sx={{ 
                  borderColor: '#3b82f6',
                  color: '#3b82f6',
                  '&:hover': { 
                    borderColor: '#2563eb',
                    backgroundColor: 'rgba(59, 130, 246, 0.04)'
                  }
                }}
              >
                {getTranslatedCvLabel('Hinzufügen')}
              </Button>
            )}
          </Box>
          
          {selectedWorkExperience ? (
            // Einzelne Berufserfahrung - Einzelne Felder
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <TextField
                  label={getTranslatedCvLabel('Position')}
                  value={selectedWorkExperience.position || ''}
                  onChange={(e) => {
                    setSelectedWorkExperience(prev => ({ ...prev, position: e.target.value }));
                  }}
                  variant="outlined"
                  fullWidth
                  sx={{ 
                    '& .MuiInputLabel-root': { 
                      fontSize: '0.875rem',
                      color: '#64748b'
                    },
                    '& .MuiOutlinedInput-root': { 
                      fontSize: '0.875rem',
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#3b82f6'
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#3b82f6'
                      }
                    }
                  }}
                />
                <TextField
                  label={getTranslatedCvLabel('Unternehmen')}
                  value={selectedWorkExperience.company || ''}
                  onChange={(e) => {
                    setSelectedWorkExperience(prev => ({ ...prev, company: e.target.value }));
                  }}
                  variant="outlined"
                  fullWidth
                  sx={{ 
                    '& .MuiInputLabel-root': { 
                      fontSize: '0.875rem',
                      color: '#64748b'
                    },
                    '& .MuiOutlinedInput-root': { 
                      fontSize: '0.875rem',
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#3b82f6'
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#3b82f6'
                      }
                    }
                  }}
                />
              </Box>
              
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField
                  label={getTranslatedCvLabel('Von')}
                  value={selectedWorkExperience.startDate || ''}
                  onChange={(e) => {
                    setSelectedWorkExperience(prev => ({ ...prev, startDate: e.target.value }));
                  }}
                  variant="outlined"
                  placeholder="MM/YYYY"
                  sx={{ 
                    width: '200px',
                    '& .MuiInputLabel-root': { 
                      fontSize: '0.875rem',
                      color: '#64748b'
                    },
                    '& .MuiOutlinedInput-root': { 
                      fontSize: '0.875rem',
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#3b82f6'
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#3b82f6'
                      }
                    }
                  }}
                />
                <TextField
                  label={getTranslatedCvLabel('Bis')}
                  value={selectedWorkExperience.endDate || ''}
                  onChange={(e) => {
                    setSelectedWorkExperience(prev => ({ ...prev, endDate: e.target.value }));
                  }}
                  variant="outlined"
                  placeholder="MM/YYYY"
                  sx={{ 
                    width: '200px',
                    '& .MuiInputLabel-root': { 
                      fontSize: '0.875rem',
                      color: '#64748b'
                    },
                    '& .MuiOutlinedInput-root': { 
                      fontSize: '0.875rem',
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#3b82f6'
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#3b82f6'
                      }
                    }
                  }}
                />
              </Box>
              
              {!isNonRelevantWorkExperience && (
                <TextField
                  label={getTranslatedCvLabel('Beschreibung')}
                  value={selectedWorkExperience.description || ''}
                  onChange={(e) => {
                    setSelectedWorkExperience(prev => ({ ...prev, description: e.target.value }));
                  }}
                  variant="outlined"
                  multiline
                  minRows={4}
                  maxRows={Infinity}
                  fullWidth
                  sx={{ 
                    '& .MuiInputLabel-root': { 
                      fontSize: '0.875rem',
                      color: '#64748b'
                    },
                    '& .MuiOutlinedInput-root': { 
                      fontSize: '0.875rem',
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#3b82f6'
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#3b82f6'
                      }
                    }
                  }}
                />
              )}
              
              <FormControl variant="outlined" fullWidth>
                <InputLabel sx={{ 
                  fontSize: '0.875rem',
                  color: '#64748b'
                }}>
                  {getTranslatedCvLabel('Relevant')}
                </InputLabel>
                <Select
                  value={selectedWorkExperience.relevant === true || selectedWorkExperience.relevant === 'true' ? 'true' : 'false'}
                  onChange={(e) => {
                    setSelectedWorkExperience(prev => ({ ...prev, relevant: e.target.value === 'true' }));
                  }}
                  label={getTranslatedCvLabel('Relevant')}
                  sx={{ 
                    fontSize: '0.875rem',
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#3b82f6'
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#3b82f6'
                    }
                  }}
                >
                  <MenuItem value="true">{getTranslatedCvLabel('Relevant')}</MenuItem>
                  <MenuItem value="false">{getTranslatedCvLabel('Nicht relevant')}</MenuItem>
                </Select>
              </FormControl>
              
              {/* Info-Textfeld für Relevanz */}
              <Box sx={{ mt: 2 }}>
                <Alert 
                  severity="info" 
                  sx={{ 
                    borderRadius: 2,
                    backgroundColor: '#f0f7ff',
                    border: '1px solid #b3d9ff',
                    '& .MuiAlert-icon': {
                      color: '#1976d2'
                    }
                  }}
                >
                  <Typography variant="body2" sx={{ color: '#1976d2', fontWeight: 500 }}>
                    {getTranslatedCvLabel('Mit Relevanz kannst du angeben, ob eine Berufserfahrung mit Beschreibung unter BERUFLICHER WERDEGANG oder mit minimalen Informationen unter WEITERE BERUFSERFAHRUNGEN aufgeführt werden soll.')}
                  </Typography>
                </Alert>
              </Box>
            </Box>
          ) : (
            // Übersicht - Tabelle
            <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ backgroundColor: '#f8fafc', width: '150px' }}>
                      {getTranslatedCvLabel('Position')}
                    </TableCell>
                    <TableCell sx={{ backgroundColor: '#f8fafc', width: '150px' }}>
                      {getTranslatedCvLabel('Unternehmen')}
                    </TableCell>
                    <TableCell sx={{ backgroundColor: '#f8fafc', width: '100px' }}>
                      {getTranslatedCvLabel('Von')}
                    </TableCell>
                    <TableCell sx={{ backgroundColor: '#f8fafc', width: '100px' }}>
                      {getTranslatedCvLabel('Bis')}
                    </TableCell>
                    <TableCell sx={{ backgroundColor: '#f8fafc' }}>
                      {getTranslatedCvLabel('Beschreibung')}
                    </TableCell>
                    <TableCell sx={{ backgroundColor: '#f8fafc', width: '120px' }}>
                      {getTranslatedCvLabel('Relevant')}
                    </TableCell>
                    <TableCell sx={{ backgroundColor: '#f8fafc', width: '80px' }}>
                      {getTranslatedCvLabel('Aktionen')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(relevantWorkExperiences || []).map((work: any, index: number) => (
                    <TableRow key={index} hover>
                      <TableCell>
                        <TextField
                          value={work.position || ''}
                          onChange={(e) => {
                            const updated = relevantWorkExperiences.map((item, i) => 
                              i === index ? { ...item, position: e.target.value } : item
                            );
                            syncWorkExperiences(updated);
                          }}
                          variant="standard"
                          fullWidth
                          sx={{ 
                            '& .MuiInput-root': { 
                              fontSize: '0.875rem',
                              fontWeight: 'normal',
                              '&:before': { borderBottom: '1px solid #e0e0e0' },
                              '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                              '&:after': { borderBottom: '2px solid #1976d2' }
                            },
                            '& .MuiInputBase-input': {
                              fontWeight: 'normal'
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          value={work.company || ''}
                          onChange={(e) => {
                            const updated = relevantWorkExperiences.map((item, i) => 
                              i === index ? { ...item, company: e.target.value } : item
                            );
                            syncWorkExperiences(updated);
                          }}
                          variant="standard"
                          fullWidth
                          sx={{ 
                            '& .MuiInput-root': { 
                              fontSize: '0.875rem',
                              fontWeight: 'normal',
                              '&:before': { borderBottom: '1px solid #e0e0e0' },
                              '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                              '&:after': { borderBottom: '2px solid #1976d2' }
                            },
                            '& .MuiInputBase-input': {
                              fontWeight: 'normal'
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          value={work.startDate || ''}
                          onChange={(e) => {
                            const updated = relevantWorkExperiences.map((item, i) => 
                              i === index ? { ...item, startDate: e.target.value } : item
                            );
                            syncWorkExperiences(updated);
                          }}
                          variant="standard"
                          fullWidth
                          placeholder="MM/YYYY"
                          sx={{ 
                            '& .MuiInput-root': { 
                              fontSize: '0.875rem',
                              '&:before': { borderBottom: '1px solid #e0e0e0' },
                              '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                              '&:after': { borderBottom: '2px solid #1976d2' }
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          value={work.endDate || ''}
                          onChange={(e) => {
                            const updated = relevantWorkExperiences.map((item, i) => 
                              i === index ? { ...item, endDate: e.target.value } : item
                            );
                            syncWorkExperiences(updated);
                          }}
                          variant="standard"
                          fullWidth
                          placeholder="MM/YYYY"
                          sx={{ 
                            '& .MuiInput-root': { 
                              fontSize: '0.875rem',
                              '&:before': { borderBottom: '1px solid #e0e0e0' },
                              '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                              '&:after': { borderBottom: '2px solid #1976d2' }
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          value={work.description || ''}
                          onChange={(e) => {
                            const updated = relevantWorkExperiences.map((item, i) => 
                              i === index ? { ...item, description: e.target.value } : item
                            );
                            syncWorkExperiences(updated);
                          }}
                          variant="standard"
                          fullWidth
                          multiline
                          rows={2}
                          sx={{ 
                            '& .MuiInput-root': { 
                              fontSize: '0.875rem',
                              '&:before': { borderBottom: '1px solid #e0e0e0' },
                              '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                              '&:after': { borderBottom: '2px solid #1976d2' }
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <FormControl variant="standard" fullWidth>
                          <Select
                            value={work.relevant === true || work.relevant === 'true' ? 'true' : 'false'}
                            onChange={(e) => {
                              const updated = relevantWorkExperiences.map((item, i) => 
                                i === index ? { ...item, relevant: e.target.value === 'true' } : item
                              );
                              syncWorkExperiences(updated);
                            }}
                            sx={{ 
                              fontSize: '0.875rem',
                              '&:before': { borderBottom: '1px solid #e0e0e0' },
                              '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #1976d2' },
                              '&:after': { borderBottom: '2px solid #1976d2' }
                            }}
                          >
                            <MenuItem value="true">Relevant</MenuItem>
                            <MenuItem value="false">Nicht relevant</MenuItem>
                          </Select>
                        </FormControl>
                      </TableCell>
                      <TableCell>
                        <IconButton
                          size="small"
                          onClick={() => {
                            const updated = relevantWorkExperiences.filter((_, i) => i !== index);
                            syncWorkExperiences(updated);
                          }}
                          sx={{ 
                            color: '#ef4444',
                            '&:hover': { 
                              backgroundColor: 'rgba(239, 68, 68, 0.1)' 
                            }
                          }}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                  {(!relevantWorkExperiences || relevantWorkExperiences.length === 0) && (
                    <TableRow>
                      <TableCell colSpan={7} sx={{ textAlign: 'center', color: '#64748b', fontStyle: 'italic' }}>
                        {getTranslatedCvLabel('Keine Berufserfahrungen verfügbar')}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => {
              // Speichere automatisch beim Schließen
              if (selectedWorkExperience && originalWorkExperience) {
                // Konvertiere selectedWorkExperience zu dem erwarteten Typ
                const updatedWorkExperience = {
                  company: selectedWorkExperience.company || '',
                  position: selectedWorkExperience.position || '',
                  startDate: selectedWorkExperience.startDate || '',
                  endDate: selectedWorkExperience.endDate || '',
                  description: selectedWorkExperience.description || '',
                  relevant: selectedWorkExperience.relevant
                };
                
                // Finde die Arbeitserfahrung anhand der ursprünglichen Eigenschaften
                setOptimizedWorkExperiences(prev => 
                  prev.map(exp => {
                    // Vergleiche anhand der ursprünglichen Eigenschaften
                    if (exp.position === originalWorkExperience.position && 
                        exp.company === originalWorkExperience.company &&
                        exp.startDate === originalWorkExperience.startDate &&
                        exp.endDate === originalWorkExperience.endDate) {
                      return updatedWorkExperience;
                    }
                    return exp;
                  })
                );
                setRelevantWorkExperiences(prev => 
                  prev.map(exp => {
                    // Vergleiche anhand der ursprünglichen Eigenschaften
                    if (exp.position === originalWorkExperience.position && 
                        exp.company === originalWorkExperience.company &&
                        exp.startDate === originalWorkExperience.startDate &&
                        exp.endDate === originalWorkExperience.endDate) {
                      return updatedWorkExperience;
                    }
                    return exp;
                  })
                );
              }
                  setShowWorkExperienceModal(false);
                  setSelectedWorkExperience(null);
                  setOriginalWorkExperience(null);
                  setIsNonRelevantWorkExperience(false);
                  
                  // Trigger Seitenberechnung im CV-Template
                  window.dispatchEvent(new CustomEvent('modalClosed'));
            }}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Profil Modal */}
      <Dialog
        open={showProfileModal}
        onClose={() => {
          // ESC oder X-Button: Änderungen verwerfen und Modal schließen
          discardProfileChanges();
          setShowProfileModal(false);
        }}
        maxWidth="sm"
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '600px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
            <TextField
              value={currentProfileTitle}
              onChange={(e) => setCurrentProfileTitle(e.target.value)}
              variant="standard"
              fullWidth
                        sx={{
                          flex: 1,
                          mr: 4,
                          '& .MuiInput-root': {
                            fontSize: '1.25rem',
                            fontWeight: 700,
                            color: 'white',
                            textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                            '&:before': { borderBottom: 'none' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
                            '&:after': { borderBottom: '2px solid white' }
                          }
                        }}
            />
            <IconButton 
              onClick={() => {
                // X-Button: Änderungen verwerfen und Modal schließen
                discardProfileChanges();
                setShowProfileModal(false);
              }}
              size="small"
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 5, overflowX: 'hidden' }}>
          {/* Sichtbarkeits-Schalter */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showProfileInCv}
                  onChange={(e) => setShowProfileInCv(e.target.checked)}
                  sx={{
                    color: '#667eea',
                    '&.Mui-checked': {
                      color: '#667eea',
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                  {getTranslatedCvLabel('Profil im CV-Template anzeigen')}
                </Typography>
              }
            />
          </Box>
          
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="body2" sx={{ color: '#64748b' }}>
              {getTranslatedCvLabel('Bearbeiten Sie Ihr Profil:')}
            </Typography>
          </Box>
          
          <TextField
            label={getTranslatedCvLabel('Profil-Text')}
            value={tempOptimizedShortProfile || ''}
            onChange={handleProfileTextChange}
            variant="outlined"
            multiline
            rows={8}
            fullWidth
            placeholder={getTranslatedCvLabel('Beschreiben Sie sich selbst, Ihre Ziele und Ihre Stärken...')}
            sx={{ 
              '& .MuiInputLabel-root': { 
                fontSize: '0.875rem',
                color: '#64748b'
              },
              '& .MuiOutlinedInput-root': { 
                fontSize: '0.875rem',
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#3b82f6'
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#3b82f6'
                }
              }
            }}
          />
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={() => {
              // Übernehme die Änderungen beim Schließen
              applyProfileChanges();
              setShowProfileModal(false);
              // Trigger Seitenberechnung im CV-Template
              window.dispatchEvent(new CustomEvent('modalClosed'));
            }}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Profilbild Modal */}
      <Dialog
        open={showProfileImageModal}
        onClose={() => setShowProfileImageModal(false)}
        maxWidth="md"
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '600px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              {getTranslatedCvLabel('Profilbild:')}
            </Typography>
            <IconButton 
              onClick={handleCloseProfileImageModal}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 5, overflowX: 'hidden' }}>
          {/* Sichtbarkeits-Schalter */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showProfileImageInCv}
                  onChange={(e) => setShowProfileImageInCv(e.target.checked)}
                  sx={{
                    color: '#667eea',
                    '&.Mui-checked': {
                      color: '#667eea',
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                  {getTranslatedCvLabel('Profilbild im CV-Template anzeigen')}
                </Typography>
              }
            />
          </Box>
          
          {/* Profilbild-Vorschau */}
          {showProfileImageInCv && profileImage && (
            <Box sx={{ 
              mb: 3, 
              p: 2, 
              backgroundColor: '#f8fafc', 
              borderRadius: 2, 
              border: '1px solid #e2e8f0'
            }}>
              <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151', mb: 2, textAlign: 'left' }}>
                {getTranslatedCvLabel('Vorschau')}
              </Typography>
              <Box sx={{ 
                textAlign: profileImageAlignment === 'left' ? 'left' : 
                         profileImageAlignment === 'right' ? 'right' : 'center'
              }}>
                <Box
                  sx={{
                    width: '100%',
                    aspectRatio: '1 / 1', // Quadratischer Container wie im CV-Template
                    margin: profileImageAlignment === 'left' ? '0 0 5px 0' :
                            profileImageAlignment === 'right' ? '0 0 5px auto' :
                            '0 auto 5px auto',
                    overflow: 'hidden',
                    borderRadius: `${profileImageBorderRadius}%`,
                    display: 'block',
                    border: tempProfileImageBorder ? `${tempProfileImageBorderThickness}px solid ${tempProfileImageBorderColor}` : 'none'
                  }}
                >
                  <img
                    src={profileImage}
                    alt="Profilbild"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      objectPosition: 'center top', // Wie im CV-Template
                      userSelect: 'none'
                    }}
                  />
                </Box>
              </Box>
            </Box>
          )}
          
          {/* Rundungs-Slider */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151', mb: 2 }}>
              {getTranslatedCvLabel('Rundung:')} {profileImageBorderRadius === 0 ? getTranslatedCvLabel('Eckig') : profileImageBorderRadius === 50 ? getTranslatedCvLabel('Rund') : `${profileImageBorderRadius}%`}
            </Typography>
            <Slider
              value={profileImageBorderRadius}
              onChange={(_, value: number | number[]) => setProfileImageBorderRadius(value as number)}
              min={0}
              max={50}
              step={5}
              marks={[
                { value: 0, label: getTranslatedCvLabel('Eckig') },
                { value: 25, label: '25%' },
                { value: 50, label: getTranslatedCvLabel('Rund') },
              ]}
              valueLabelDisplay="auto"
              sx={{
                color: '#667eea',
                '& .MuiSlider-thumb': {
                  backgroundColor: '#667eea',
                },
                '& .MuiSlider-track': {
                  backgroundColor: '#667eea',
                },
                '& .MuiSlider-rail': {
                  backgroundColor: '#e2e8f0',
                },
              }}
            />
          </Box>

          {/* Rahmen-Einstellungen */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151', mb: 2 }}>
              {getTranslatedCvLabel('Rahmen')}
            </Typography>
            <FormControlLabel
              control={
                <Checkbox
                  checked={tempProfileImageBorder}
                  onChange={(e) => setTempProfileImageBorder(e.target.checked)}
                  sx={{
                    color: '#667eea',
                    '&.Mui-checked': {
                      color: '#667eea',
                    }
                  }}
                />
              }
              label={getTranslatedCvLabel('Rahmen um das Profilbild anzeigen')}
              sx={{ mb: 2 }}
            />
            {tempProfileImageBorder && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151', mb: 1 }}>
                  {getTranslatedCvLabel('Rahmenfarbe')}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                  <input
                    type="color"
                    value={tempProfileImageBorderColor}
                    onChange={(e) => setTempProfileImageBorderColor(e.target.value)}
                    style={{
                      width: '40px',
                      height: '40px',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}
                  />
                  <TextField
                    value={tempProfileImageBorderColor}
                    onChange={(e) => setTempProfileImageBorderColor(e.target.value)}
                    size="small"
                    sx={{
                      width: '100px',
                      '& .MuiOutlinedInput-root': {
                        fontSize: '12px'
                      }
                    }}
                  />
                </Box>
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151', mb: 1 }}>
                  {getTranslatedCvLabel('Rahmendicke:')} {tempProfileImageBorderThickness}px
                </Typography>
                <Slider
                  value={tempProfileImageBorderThickness}
                  onChange={(_, value: number | number[]) => setTempProfileImageBorderThickness(value as number)}
                  min={1}
                  max={20}
                  step={1}
                  marks={[
                    { value: 1, label: '1px' },
                    { value: 5, label: '5px' },
                    { value: 10, label: '10px' },
                    { value: 15, label: '15px' },
                    { value: 20, label: '20px' },
                  ]}
                  valueLabelDisplay="auto"
                  sx={{
                    color: '#667eea',
                    '& .MuiSlider-thumb': {
                      backgroundColor: '#667eea',
                    },
                    '& .MuiSlider-track': {
                      backgroundColor: '#667eea',
                    },
                    '& .MuiSlider-rail': {
                      backgroundColor: '#e2e8f0',
                    }
                  }}
                />
              </Box>
            )}
          </Box>
          
          {/* Breiten-Anpassung */}
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
            <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151', mb: 2 }}>
              {getTranslatedCvLabel('Breite:')} {profileImageWidth}%
            </Typography>
            <Slider
              value={profileImageWidth}
              onChange={(_, value: number | number[]) => setProfileImageWidth(value as number)}
              min={50}
              max={100}
              step={10}
              marks={[
                { value: 50, label: '50%' },
                { value: 75, label: '75%' },
                { value: 100, label: '100%' },
              ]}
              valueLabelDisplay="auto"
              sx={{
                color: '#667eea',
                '& .MuiSlider-thumb': {
                  backgroundColor: '#667eea',
                },
                '& .MuiSlider-track': {
                  backgroundColor: '#667eea',
                },
                '& .MuiSlider-rail': {
                  backgroundColor: '#e2e8f0',
                },
              }}
            />
          </Box>
          
          {/* Größen-Auswahl - nur für Admin sichtbar */}
          {isAdmin() && (
            <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
              <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151', mb: 2 }}>
                {getTranslatedCvLabel('Profilbild-Größe')}
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
                {['S', 'M', 'L'].map((size) => (
                  <FormControlLabel
                    key={size}
                    control={
                      <Checkbox
                        checked={profileImageSize === size}
                        onChange={() => setProfileImageSize(size)}
                        sx={{
                          color: '#667eea',
                          '&.Mui-checked': {
                            color: '#667eea',
                          },
                        }}
                      />
                    }
                    label={
                      <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                        {size}
                      </Typography>
                    }
                  />
                ))}
              </Box>
            </Box>
          )}
          
          {/* Ausrichtungs-Auswahl - nur für Admin sichtbar */}
          {isAdmin() && (
            <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
              <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151', mb: 2 }}>
                {getTranslatedCvLabel('Profilbild-Ausrichtung')}
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
                {[
                  { value: 'left', label: 'Links' },
                  { value: 'center', label: 'Mittig' },
                  { value: 'right', label: 'Rechts' }
                ].map((alignment) => (
                  <FormControlLabel
                    key={alignment.value}
                    control={
                      <Checkbox
                        checked={profileImageAlignment === alignment.value}
                        onChange={() => setProfileImageAlignment(alignment.value)}
                        sx={{
                          color: '#667eea',
                          '&.Mui-checked': {
                            color: '#667eea',
                          },
                        }}
                      />
                    }
                    label={
                      <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                        {getTranslatedCvLabel(alignment.label)}
                      </Typography>
                    }
                  />
                ))}
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 0 }}>
          <Button 
            variant="contained" 
            onClick={handleCloseProfileImageModal}
            sx={{
              bgcolor: '#667eea',
              color: 'white',
              textTransform: 'none',
              fontWeight: 600,
              '&:hover': {
                bgcolor: '#5a6fd8'
              }
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Textfarben-Modal */}
      <Dialog
        open={showTextColorPalette}
        onClose={handleCloseTextColorPalette}
        maxWidth="lg"
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '800px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
            <Typography variant="h5" sx={{ fontWeight: 700, color: 'white', textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              Textfarben anpassen
            </Typography>
            <IconButton 
              onClick={handleCloseTextColorPalette}
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.1)'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        
        <DialogContent sx={{ p: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            {renderTextColorPalette('name', tempNameTextColor)}
            {renderTextColorPalette('left', tempLeftColumnTextColor)}
            {renderTextColorPalette('right', tempRightColumnTextColor)}
            {renderTextColorPalette('leftTitle', tempLeftColumnTitleColor)}
            {renderTextColorPalette('rightTitle', tempRightColumnTitleColor)}
          </Box>
        </DialogContent>
        
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc' }}>
          <Button 
            onClick={handleCloseTextColorPalette}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            Schließen
          </Button>
        </DialogActions>
      </Dialog>

      {/* Bewerbungsdetails Modal */}
      <Dialog
        open={showApplicationDetailsModal}
        onClose={async () => {
          await saveApplicationData();
          // Lösche Passgenauigkeiten, optimierte CV-Daten und Motivationsschreiben
          clearOptimizedAndMatchData();
          setShowApplicationDetailsModal(false);
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              {getTranslatedCvLabel('Bewerbungsdetails')}
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <IconButton 
                onClick={async () => {
                  await saveApplicationData();
                  // Lösche Passgenauigkeiten, optimierte CV-Daten und Motivationsschreiben
                  clearOptimizedAndMatchData();
                  setShowApplicationDetailsModal(false);
                }}
                sx={{ color: 'white' }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        </DialogTitle>
        
        <DialogContent sx={{ p: 3, pt: 4 }}>
          {selectedApplication && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              {/* Rollentitel und Status nebeneinander */}
              <Box sx={{ display: 'flex', gap: 3, alignItems: 'flex-start' }}>
                {/* Rollentitel - Editierbar */}
                <Box sx={{ flex: 1 }}>
                  <Typography variant="caption" sx={{ 
                    fontWeight: 700, 
                    color: '#64748b', 
                    fontSize: '0.75rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    display: 'block',
                    mb: 1
                  }}>
                    {getTranslatedCvLabel('Rollentitel')}
                  </Typography>
                  <TextField
                    fullWidth
                    value={editableRoleTitle}
                    onChange={(e) => setEditableRoleTitle(e.target.value)}
                    placeholder={getTranslatedCvLabel('Rollentitel eingeben...')}
                    variant="outlined"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#667eea',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#667eea',
                        },
                      }
                    }}
                  />
                </Box>
                
                {/* Status rechts */}
                <Box sx={{ minWidth: '250px' }}>
                  <Typography variant="caption" sx={{ 
                    fontWeight: 700, 
                    color: '#64748b', 
                    fontSize: '0.75rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    display: 'block',
                    mb: 1
                  }}>
                    {getTranslatedCvLabel('Status')}
                  </Typography>
                  <FormControl fullWidth>
                    <Select
                      value={selectedApplication.status || 'Offen'}
                      onChange={async (e) => {
                        const newStatus = e.target.value;
                        
                        // Update local state
                        setSelectedApplication((prev: any) => ({ ...prev, status: newStatus }));
                        
                        // Update in applications list
                        setApplications((prev: any[]) => 
                          prev.map(app => 
                            app.id === selectedApplication.id 
                              ? { ...app, status: newStatus }
                              : app
                          )
                        );
                        
                        // Update in backend
                        try {
                          const token = await user?.getIdToken();
                          await fetch(`${config.backend.baseUrl}/api/update-application-status`, {
                            method: 'POST',
                            headers: {
                              'Authorization': `Bearer ${token}`,
                              'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                              applicationId: selectedApplication.id,
                              status: newStatus
                            })
                          });
                          console.log('✅ Status aktualisiert:', newStatus);
                        } catch (error) {
                          console.error('❌ Fehler beim Aktualisieren des Status:', error);
                        }
                      }}
                      sx={{
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#e2e8f0',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#667eea',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#667eea',
                        }
                      }}
                    >
                      <MenuItem value="Offen">
                        <Chip 
                          label={getTranslatedCvLabel('Offen')} 
                          size="small" 
                          sx={{ bgcolor: '#3b82f6', color: 'white', fontWeight: 600 }}
                        />
                      </MenuItem>
                      <MenuItem value="Vorstellungsgespräch">
                        <Chip 
                          label={getTranslatedCvLabel('Vorstellungsgespräch')} 
                          size="small" 
                          sx={{ bgcolor: '#f59e0b', color: 'white', fontWeight: 600 }}
                        />
                      </MenuItem>
                      <MenuItem value="Geschlossen">
                        <Chip 
                          label={getTranslatedCvLabel('Geschlossen')} 
                          size="small" 
                          sx={{ bgcolor: '#6b7280', color: 'white', fontWeight: 600 }}
                        />
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </Box>
              
              {/* Name und Passgenauigkeit */}
              <Box sx={{ display: 'flex', gap: 3, alignItems: 'flex-start' }}>
                {/* Name */}
                {selectedApplication.fullName && (
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="caption" sx={{ 
                      fontWeight: 700, 
                      color: '#64748b', 
                      fontSize: '0.75rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      display: 'block',
                      mb: 1
                    }}>
                      {getTranslatedCvLabel('Name')}
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#1e293b', fontWeight: 600 }}>
                      {selectedApplication.fullName}
                    </Typography>
                  </Box>
                )}
                
                {/* Passgenauigkeit */}
                {selectedApplication.matchScore !== null && selectedApplication.matchScore !== undefined && (
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="caption" sx={{ 
                      fontWeight: 700, 
                      color: '#64748b', 
                      fontSize: '0.75rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      display: 'block',
                      mb: 1
                    }}>
                      {getTranslatedCvLabel('Passgenauigkeit:')}
                    </Typography>
                    <Typography variant="body1" sx={{ 
                      color: selectedApplication.matchScore >= 75 ? '#10b981' : selectedApplication.matchScore >= 50 ? '#f59e0b' : '#ef4444', 
                      fontWeight: 700,
                      fontSize: '1.1rem'
                    }}>
                      {selectedApplication.matchScore}%
                    </Typography>
                  </Box>
                )}
              </Box>
              
              {/* Firma und Branche - Editierbar */}
              <Box sx={{ display: 'flex', gap: 3, alignItems: 'flex-start' }}>
                {/* Firma */}
                <Box sx={{ flex: 1 }}>
                  <Typography variant="caption" sx={{ 
                    fontWeight: 700, 
                    color: '#64748b', 
                    fontSize: '0.75rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    display: 'block',
                    mb: 1
                  }}>
                    {getTranslatedCvLabel('Firma')}
                  </Typography>
                  <TextField
                    fullWidth
                    value={editableCompany}
                    onChange={(e) => setEditableCompany(e.target.value)}
                    placeholder={getTranslatedCvLabel('Firmenname eingeben...')}
                    variant="outlined"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#667eea',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#667eea',
                        },
                      }
                    }}
                  />
                </Box>
                
                {/* Branche */}
                <Box sx={{ flex: 1 }}>
                  <Typography variant="caption" sx={{ 
                    fontWeight: 700, 
                    color: '#64748b', 
                    fontSize: '0.75rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    display: 'block',
                    mb: 1
                  }}>
                    {getTranslatedCvLabel('Branche')}
                  </Typography>
                  <TextField
                    fullWidth
                    value={editableIndustry}
                    onChange={(e) => setEditableIndustry(e.target.value)}
                    placeholder={getTranslatedCvLabel('Branche eingeben...')}
                    variant="outlined"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#667eea',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#667eea',
                        },
                      }
                    }}
                  />
                </Box>
              </Box>
              
              {/* PDF-Info (oberhalb von Notizen) mit Kontaktdaten links */}
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'stretch', 
                gap: 2
              }}>
                {/* Kontaktdaten links */}
                {selectedApplication.contactInfo && (
                  <Box sx={{ 
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column'
                  }}>
                    <Typography variant="caption" sx={{ 
                      fontWeight: 700, 
                      color: '#64748b', 
                      fontSize: '0.75rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      display: 'block',
                      mb: 1
                    }}>
                      {getTranslatedCvLabel('Kontaktdaten')}
                    </Typography>
                    <Box sx={{ 
                      p: 2,
                      border: '1px solid #e2e8f0',
                      borderRadius: 2,
                      bgcolor: '#f8fafc',
                      flex: 1
                    }}>
                      <Typography variant="body2" sx={{ color: '#1e293b', fontWeight: 500 }}>
                        {selectedApplication.contactInfo}
                      </Typography>
                    </Box>
                  </Box>
                )}
                {/* PDF rechts */}
                <Box sx={{ 
                  flex: selectedApplication.contactInfo ? '0 0 80px' : '1',
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                  <Typography variant="caption" sx={{ 
                    fontWeight: 700, 
                    color: '#64748b', 
                    fontSize: '0.75rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    display: 'block',
                    mb: 1
                  }}>
                    {getTranslatedCvLabel('CV')}
                  </Typography>
                  <Box sx={{ 
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 1,
                    p: 2,
                    border: '1px solid #e2e8f0',
                    borderRadius: 2,
                    bgcolor: '#f8fafc',
                    flex: 1
                  }}>
                    {/* CV-Icon - nur anzeigen wenn cvPreviewData vorhanden */}
                    {selectedApplication && selectedApplication.cvPreviewData && selectedApplication.cvPreviewData.encrypted && (
                      <Tooltip title={getTranslatedCvLabel('CV-Vorschau öffnen')}>
                        <IconButton
                          onClick={async () => {
                            await handleOpenCvPreviewFromApplication(selectedApplication.id);
                          }}
                          sx={{
                            color: '#667eea',
                            transition: 'all 0.2s ease',
                            padding: '8px',
                            '&:hover': {
                              bgcolor: '#f0f4ff',
                              color: '#5a6fd8',
                              transform: 'scale(1.1)',
                            },
                            '& .MuiSvgIcon-root': {
                              fontSize: '32px'
                            }
                          }}
                        >
                          <DescriptionOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                    {selectedApplication.pdfFileName && (
                      <Tooltip title={getTranslatedCvLabel('PDF verfügbar zum Download')}>
                        <IconButton
                          onClick={async () => {
                            try {
                              const token = await user?.getIdToken();
                              const response = await fetch(`${config.backend.baseUrl}/api/get-application-pdf/${selectedApplication.id}`, {
                                method: 'GET',
                                headers: {
                                  'Authorization': `Bearer ${token}`,
                                  'Content-Type': 'application/json'
                                }
                              });
                              
                              if (response.ok) {
                                const blob = await response.blob();
                                const url = window.URL.createObjectURL(blob);
                                const link = document.createElement('a');
                                link.href = url;
                                link.download = 'bewerbung.pdf';
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                window.URL.revokeObjectURL(url);
                              } else {
                                console.error('Fehler beim Laden des PDFs:', response.statusText);
                              }
                            } catch (error) {
                              console.error('Fehler beim Laden des PDFs:', error);
                            }
                          }}
                          sx={{
                            transition: 'all 0.2s ease',
                            borderRadius: '50%',
                            color: '#1e293b',
                            '&:hover': {
                              color: '#667eea',
                              bgcolor: '#f0f4ff',
                              transform: 'scale(1.1)',
                              borderRadius: '50%'
                            }
                          }}
                        >
                          <DownloadIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Box>
                </Box>
              </Box>

              {/* Notizen - Editierbar */}
              <Box>
                <Typography variant="caption" sx={{ 
                  fontWeight: 700, 
                  color: '#64748b', 
                  fontSize: '0.75rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  display: 'block',
                  mb: 1
                }}>
                  {getTranslatedCvLabel('Notizen')}
                </Typography>
                <TextField
                  multiline
                  rows={3}
                  fullWidth
                  value={editableNotes}
                  onChange={(e) => setEditableNotes(e.target.value)}
                  placeholder={getTranslatedCvLabel('Notizen zur Bewerbung hinzufügen...')}
                  variant="outlined"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      '&:hover fieldset': {
                        borderColor: '#667eea',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#667eea',
                      },
                    }
                  }}
                />
              </Box>
              
              {/* Share-Link Sektion - nur anzeigen wenn cvPreviewData vorhanden */}
              {selectedApplication && selectedApplication.cvPreviewData && selectedApplication.cvPreviewData.encrypted && (
                <Box sx={{ mt: 2, p: 2, bgcolor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
                  <Typography variant="caption" sx={{ 
                    fontWeight: 700, 
                    color: '#64748b', 
                    fontSize: '0.75rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    display: 'block',
                    mb: 2
                  }}>
                    CV-Informationen teilen
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Generieren Sie einen Link, um externen Personen zu ermöglichen, die CV-Informationen zu überprüfen und anzupassen.
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                    <TextField
                      size="small"
                      placeholder="E-Mail-Adresse (optional)"
                      value={shareLinkEmail}
                      onChange={(e) => setShareLinkEmail(e.target.value)}
                      variant="outlined"
                      type="email"
                      sx={{ flex: 1 }}
                    />
                    <Button
                      variant="contained"
                      startIcon={generatingShareLink ? <CircularProgress size={20} /> : <ShareIcon />}
                      onClick={() => generateShareLink(selectedApplication.id, shareLinkEmail || undefined)}
                      disabled={generatingShareLink}
                      sx={{
                        bgcolor: '#667eea',
                        '&:hover': {
                          bgcolor: '#5a6fd8'
                        }
                      }}
                    >
                      {generatingShareLink ? 'Generiere...' : 'Link generieren'}
                    </Button>
                  </Box>
                </Box>
              )}
              
              {/* Aufgaben und Anforderungen aus Job-Informationen */}
              {(selectedApplication.aufgaben || selectedApplication.anforderungen) ? (
                <>
                  {/* Aufgaben */}
                  {selectedApplication.aufgaben && (
                    <Box sx={{ mb: 3 }}>
                      <Typography variant="caption" sx={{ 
                        fontWeight: 700, 
                        color: '#64748b', 
                        fontSize: '0.75rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        display: 'block',
                        mb: 1
                      }}>
                        {getTranslatedCvLabel('Aufgaben')}
                      </Typography>
                      <Paper sx={{ 
                        p: 2, 
                        bgcolor: '#f8fafc', 
                        borderRadius: 2,
                        maxHeight: 300,
                        overflow: 'auto'
                      }}>
                        <Typography variant="body2" sx={{ 
                          color: '#1e293b', 
                          whiteSpace: 'pre-wrap',
                          fontSize: '0.9rem',
                          lineHeight: 1.6
                        }}>
                          {Array.isArray(selectedApplication.aufgaben) 
                            ? selectedApplication.aufgaben.map((aufgabe: string, idx: number) => (
                                <Box key={idx} sx={{ mb: 1 }}>
                                  • {aufgabe}
                                </Box>
                              ))
                            : selectedApplication.aufgaben}
                        </Typography>
                      </Paper>
                    </Box>
                  )}
                  
                  {/* Anforderungen */}
                  {selectedApplication.anforderungen && (
                    <Box sx={{ mb: 0 }}>
                      <Typography variant="caption" sx={{ 
                        fontWeight: 700, 
                        color: '#64748b', 
                        fontSize: '0.75rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        display: 'block',
                        mb: 1
                      }}>
                        {getTranslatedCvLabel('Anforderungen')}
                      </Typography>
                      <Paper sx={{ 
                        p: 2, 
                        bgcolor: '#f8fafc', 
                        borderRadius: 2,
                        maxHeight: 300,
                        overflow: 'auto'
                      }}>
                        <Typography variant="body2" sx={{ 
                          color: '#1e293b', 
                          whiteSpace: 'pre-wrap',
                          fontSize: '0.9rem',
                          lineHeight: 1.6
                        }}>
                          {Array.isArray(selectedApplication.anforderungen) 
                            ? selectedApplication.anforderungen.map((anforderung: string, idx: number) => (
                                <Box key={idx} sx={{ mb: 1 }}>
                                  • {anforderung}
                                </Box>
                              ))
                            : selectedApplication.anforderungen}
                        </Typography>
                      </Paper>
                    </Box>
                  )}
                </>
              ) : (
                // Fallback: Zeige Stellenbeschreibung falls keine Aufgaben/Anforderungen vorhanden
                <Box>
                  <Typography variant="caption" sx={{ 
                    fontWeight: 700, 
                    color: '#64748b', 
                    fontSize: '0.75rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    display: 'block',
                    mb: 1
                  }}>
                    {getTranslatedCvLabel('Stellenbeschreibung')}
                  </Typography>
                  <Paper sx={{ 
                    p: 2, 
                    bgcolor: '#f8fafc', 
                    borderRadius: 2,
                    maxHeight: 300,
                    overflow: 'auto'
                  }}>
                    <Typography variant="body2" sx={{ 
                      color: '#1e293b', 
                      whiteSpace: 'pre-wrap',
                      fontSize: '0.9rem',
                      lineHeight: 1.6
                    }}>
                      {selectedApplication.jobDescription || getTranslatedCvLabel('Keine Informationen verfügbar')}
                    </Typography>
                  </Paper>
                </Box>
              )}
              
              {/* Firma und Branche (unten entfernt, bleibt nur oben editierbar) */}

              {/* Erste Zeile: Auslastung (Firma wird oben angezeigt und hier nicht erneut) */}
              <Box sx={{ display: 'flex', gap: 3 }}>
                {selectedApplication.workload && (
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="caption" sx={{ 
                      fontWeight: 700, 
                      color: '#64748b', 
                      fontSize: '0.75rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      display: 'block',
                      mb: 1
                    }}>
                      {getTranslatedCvLabel('Auslastung')}
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#1e293b', fontWeight: 500 }}>
                      {selectedApplication.workload}
                    </Typography>
                  </Box>
                )}
              </Box>
              
              {/* Zweite Zeile: Ausschreibedatum, Kontaktdaten */}
              <Box sx={{ display: 'flex', gap: 3 }}>
                {selectedApplication.publishDate && (
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="caption" sx={{ 
                      fontWeight: 700, 
                      color: '#64748b', 
                      fontSize: '0.75rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      display: 'block',
                      mb: 1
                    }}>
                      {getTranslatedCvLabel('Ausschreibedatum')}
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#1e293b', fontWeight: 500 }}>
                      {selectedApplication.publishDate}
                    </Typography>
                  </Box>
                )}
                
                {/* Kontaktdaten werden im PDF-Bereich links angezeigt */}
              </Box>
              
              {/* Schlüsselstichworte */}
              {selectedApplication.keywords && selectedApplication.keywords.length > 0 && (
                <Box>
                  <Typography variant="caption" sx={{ 
                    fontWeight: 700, 
                    color: '#64748b', 
                    fontSize: '0.75rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    display: 'block',
                    mb: 1
                  }}>
                    {getTranslatedCvLabel('Schlüsselstichworte')}
                  </Typography>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    {selectedApplication.keywords.map((keyword: string, idx: number) => (
                      <Chip 
                        key={idx}
                        label={keyword}
                        sx={{ 
                          bgcolor: '#667eea',
                          color: 'white',
                          fontWeight: 600
                        }}
                      />
                    ))}
                  </Box>
                </Box>
              )}
              
            </Box>
          )}
        </DialogContent>
        
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc', justifyContent: 'space-between' }}>
          <Button 
            onClick={async () => {
              try {
                const idToken = await user?.getIdToken();
                await fetch(`${config.backend.baseUrl}/api/delete-job-description/${selectedApplication.id}`, {
                  method: 'DELETE',
                  headers: {
                    'Authorization': `Bearer ${idToken}`
                  }
                });
                // Reload applications
                setApplications(prev => prev.filter(a => a.id !== selectedApplication.id));
                console.log('✅ Application gelöscht');
                setShowApplicationDetailsModal(false);
              } catch (error) {
                console.error('❌ Fehler beim Löschen:', error);
              }
            }}
            variant="outlined"
            startIcon={<DeleteIcon />}
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#ef4444',
              color: '#ef4444',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#dc2626',
                backgroundColor: '#fef2f2',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Löschen')}
          </Button>
          
          <Button 
            onClick={async () => {
              await saveApplicationData();
              // Lösche Passgenauigkeiten, optimierte CV-Daten und Motivationsschreiben
              clearOptimizedAndMatchData();
              setShowApplicationDetailsModal(false);
            }}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Color Picker Modal */}
      <Dialog
        open={openColorPickerModal}
        onClose={handleCancelColor}
        maxWidth="sm"
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '600px',
            overflowX: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderBottom: 'none',
          width: '100%',
          maxWidth: '100%'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
            <Typography sx={{ 
              fontSize: '1.25rem',
              fontWeight: 700,
              color: 'white',
              textShadow: '0 1px 2px rgba(0,0,0,0.1)',
              textTransform: 'uppercase'
            }}>
              {currentColorPicker === 'header' && getTranslatedCvLabel('Header Farbe')}
              {currentColorPicker === 'column' && getTranslatedCvLabel('Spaltenfarbe')}
              {currentColorPicker === 'name' && 'Name Farbe'}
              {currentColorPicker === 'leftTitle' && 'Titel links Farbe'}
              {currentColorPicker === 'leftText' && 'Text links Farbe'}
              {currentColorPicker === 'rightTitle' && 'Titel rechts Farbe'}
              {currentColorPicker === 'rightText' && 'Text rechts Farbe'}
            </Typography>
            <IconButton 
              onClick={handleCancelColor}
              size="small"
              sx={{ 
                color: 'white',
                padding: '8px',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 5, overflowX: 'hidden' }}>
          <Box sx={{ mb: 2 }} />
          {/* Farbpicker */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#374151' }}>
              {getTranslatedCvLabel('Farbe:')}
            </Typography>
            <input
              type="color"
              value={tempColor}
              onChange={(e) => handleColorChange(e.target.value, tempAlpha)}
              style={{
                width: '100%',
                height: '60px',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                cursor: 'pointer'
              }}
            />
          </Box>

          {/* Sichtbarkeit Eingabefeld - nur für Header und Spalte */}
          {(currentColorPicker === 'header' || currentColorPicker === 'column') && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#374151' }}>
                {getTranslatedCvLabel('Sichtbarkeit (0-100%):')}
              </Typography>
              <TextField
                type="number"
                inputProps={{ min: 0, max: 100 }}
                value={Math.round(tempAlpha * 100)}
                onChange={(e) => {
                  const value = parseInt(e.target.value) || 0;
                  const clampedValue = Math.max(0, Math.min(100, value));
                  handleColorChange(tempColor, clampedValue / 100);
                }}
                fullWidth
                variant="outlined"
                sx={{ 
                  '& .MuiInputLabel-root': { 
                    fontSize: '0.875rem',
                    color: '#64748b'
                  },
                  '& .MuiOutlinedInput-root': { 
                    fontSize: '0.875rem',
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#667eea'
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#667eea'
                    }
                  }
                }}
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f8fafc', justifyContent: 'flex-end' }}>
          <Button
            onClick={handleApplyColor}
            variant="outlined"
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 3,
              borderColor: '#667eea',
              color: '#757575',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: '#764ba2',
                backgroundColor: '#f5f5f5',
                transform: 'translateY(-1px)',
              },
            }}
          >
            {getTranslatedCvLabel('Schließen')}
          </Button>
        </DialogActions>
      </Dialog>
      
      {/* Share-Link Dialog */}
      <Dialog
        open={showShareLinkDialog}
        onClose={() => setShowShareLinkDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Share-Link generiert
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Der Link wurde erfolgreich generiert. Sie können ihn kopieren und manuell versenden, oder er wurde bereits per E-Mail versendet.
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <TextField
              fullWidth
              value={shareLinkUrl || ''}
              variant="outlined"
              InputProps={{
                readOnly: true
              }}
              sx={{ flex: 1 }}
            />
            <Button
              variant="outlined"
              startIcon={<ContentCopyIcon />}
              onClick={copyShareLinkToClipboard}
            >
              Kopieren
            </Button>
          </Box>
          <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
            Dieser Link ist 7 Tage gültig.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowShareLinkDialog(false)}>
            Schließen
          </Button>
        </DialogActions>
      </Dialog>

            </Paper>
          </Container>
        </>
      )}
    </Box>
  );
}

function App() {
  const { user } = useAuth();
  
  // Prüfe, ob wir auf der Share-Seite sind
  const pathname = window.location.pathname;
  console.log('📍 Aktueller Pfad:', pathname);
  const shareMatch = pathname.match(/^\/share\/([a-f0-9]+)$/);
  
  if (shareMatch) {
    const token = shareMatch[1];
    console.log('🔗 Share-Seite erkannt, Token:', token);
    // Share-Seite rendern (keine Authentifizierung erforderlich)
    return <CvSharePage token={token} />;
  }
  
  // Normale App (erfordert Login)
  return user ? <ProtectedApp /> : <Login />;
}

export default function Root() {
  return (
    <AuthProvider>
      <App />
      </AuthProvider>
    );
  }